import { gql } from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  JSON: any;
  MongoID: any;
  RegExpAsString: any;
  SequelizeJSON: any;
};

export type AchLossTimeline = {
  __typename?: 'ACHLossTimeline';
  achLossStatus?: Maybe<Status>;
};

export type ArCustomer = {
  __typename?: 'ARCustomer';
  companyName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isMissingDetails?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  type?: Maybe<ArCustomerType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum ArCustomerType {
  Business = 'Business',
  Consumer = 'Consumer',
  Customer = 'Customer',
  Lead = 'Lead',
  Vendor = 'Vendor'
}

export enum AccountCurrency {
  AED = 'AED',
  AUD = 'AUD',
  BGN = 'BGN',
  BRL = 'BRL',
  CAD = 'CAD',
  CNY = 'CNY',
  CZK = 'CZK',
  DKK = 'DKK',
  EGP = 'EGP',
  EUR = 'EUR',
  GBP = 'GBP',
  GEL = 'GEL',
  HKD = 'HKD',
  HUF = 'HUF',
  ILS = 'ILS',
  INR = 'INR',
  KES = 'KES',
  KRW = 'KRW',
  MXN = 'MXN',
  NOK = 'NOK',
  NZD = 'NZD',
  PHP = 'PHP',
  PLN = 'PLN',
  RON = 'RON',
  SEK = 'SEK',
  SGD = 'SGD',
  THB = 'THB',
  USD = 'USD',
  VND = 'VND',
  ZAR = 'ZAR'
}

export enum AccountEntityEnum {
  deliveryMethod = 'deliveryMethod',
  fundingSource = 'fundingSource',
  ip = 'ip',
  payor = 'payor',
  user = 'user',
  vendor = 'vendor'
}

export enum AccountFlow {
  DELIVERY = 'DELIVERY',
  FUNDING = 'FUNDING'
}

export enum AccountType {
  Dda = 'Dda',
  Fbo = 'Fbo',
  Msb = 'Msb',
  MsbDda = 'MsbDda'
}

export type AccountingFirm = {
  __typename?: 'AccountingFirm';
  accountants?: Maybe<Array<Maybe<User>>>;
  organization?: Maybe<Organization>;
};

/** Defines the structure for an accounting firm's tier and client information. */
export type AccountingFirmTier = {
  __typename?: 'AccountingFirmTier';
  /** The number of clients associated with the firm. */
  clientCount: Scalars['Int'];
  /** A list of client IDs associated with the firm. */
  clientIds?: Maybe<Array<Scalars['Int']>>;
  /** A list of client IDs for whom the firm is billed. */
  firmBilledClientIds?: Maybe<Array<Scalars['Int']>>;
  /** The ID of the firm. */
  firmId: Scalars['Int'];
  /** The tier associated with the firm. */
  tier?: Maybe<Scalars['String']>;
  /** The details of the firm's tier. */
  tierDetails: AccountingFirmTierDetails;
};

/** Details of the accounting firm tier, including name and discount. */
export type AccountingFirmTierDetails = {
  __typename?: 'AccountingFirmTierDetails';
  /** Discount percentage associated with the tier. */
  discount?: Maybe<Scalars['Int']>;
  /** Name of the tier. */
  name?: Maybe<Scalars['String']>;
};

export type AccountingSoftwareData = {
  __typename?: 'AccountingSoftwareData';
  data?: Maybe<CompositeBill>;
};

export type AccountsBankAccountDetails = {
  __typename?: 'AccountsBankAccountDetails';
  accountNumber?: Maybe<Scalars['String']>;
  accountType?: Maybe<AccountsBankAccountType>;
  routingNumber?: Maybe<Scalars['String']>;
};

export enum AccountsBankAccountType {
  CHECKING = 'CHECKING',
  SAVINGS = 'SAVINGS'
}

export type AccountsBillerDirectoryAccountDetails = {
  __typename?: 'AccountsBillerDirectoryAccountDetails';
  isPreferred?: Maybe<Scalars['Boolean']>;
  paymentMethodType?: Maybe<BillerDirectoryPaymentMethodType>;
  provider?: Maybe<BillerDirectoryProvider>;
};

export type AccountsCardAccountDetails = {
  __typename?: 'AccountsCardAccountDetails';
  accountId?: Maybe<Scalars['String']>;
  addressLine?: Maybe<Scalars['String']>;
  bin?: Maybe<Scalars['String']>;
  cardCountry?: Maybe<Scalars['String']>;
  cardCurrency?: Maybe<Scalars['String']>;
  cardProgram?: Maybe<AccountsCardProgram>;
  cardType?: Maybe<AccountsCardType>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  last4Digits?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  network?: Maybe<Scalars['String']>;
  rawAVSQuery?: Maybe<Scalars['String']>;
  referenceId?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type AccountsCardProgram = {
  __typename?: 'AccountsCardProgram';
  code?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
};

export enum AccountsCardType {
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT'
}

export type AccountsCheckAccountDetails = {
  __typename?: 'AccountsCheckAccountDetails';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  payToTheOrderOf?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type AccountsContact = {
  __typename?: 'AccountsContact';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  aptNumber?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  mcc?: Maybe<Scalars['String']>;
  parentExternalId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  streetName?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type AccountsInternationalAccountAddress = {
  __typename?: 'AccountsInternationalAccountAddress';
  addressLine1?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type AccountsInternationalAccountDetails = {
  __typename?: 'AccountsInternationalAccountDetails';
  accountHolderName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  accountType?: Maybe<Scalars['String']>;
  address?: Maybe<AccountsInternationalAccountAddress>;
  bankCode?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  bicSwift?: Maybe<Scalars['String']>;
  branchCode?: Maybe<Scalars['String']>;
  bsbCode?: Maybe<Scalars['String']>;
  clabe?: Maybe<Scalars['String']>;
  cnpj?: Maybe<Scalars['String']>;
  currency?: Maybe<AccountCurrency>;
  email?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  ifscCode?: Maybe<Scalars['String']>;
  institutionNumber?: Maybe<Scalars['String']>;
  payeeAccountType?: Maybe<PayeeAccountType>;
  payeeBankName?: Maybe<Scalars['String']>;
  sortCode?: Maybe<Scalars['String']>;
  transitNumber?: Maybe<Scalars['String']>;
};

export type AccountsServiceAccountInfo = {
  __typename?: 'AccountsServiceAccountInfo';
  accountDetailsId?: Maybe<Scalars['String']>;
  accountEmail?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['String']>;
  accountType?: Maybe<DeliveryAccountType>;
  accountVersionId?: Maybe<Scalars['String']>;
  bankAccountDetails?: Maybe<AccountsBankAccountDetails>;
  billerDirectoryAccountDetails?: Maybe<AccountsBillerDirectoryAccountDetails>;
  cardAccountDetails?: Maybe<AccountsCardAccountDetails>;
  checkAccountDetails?: Maybe<AccountsCheckAccountDetails>;
  contact?: Maybe<AccountsContact>;
  createdAt?: Maybe<Scalars['String']>;
  flow?: Maybe<AccountFlow>;
  internationalAccountDetails?: Maybe<AccountsInternationalAccountDetails>;
  updatedAt?: Maybe<Scalars['String']>;
  wireAccountDetails?: Maybe<AccountsWireAccountDetails>;
};

export type AccountsWireAccountDetails = {
  __typename?: 'AccountsWireAccountDetails';
  accountNumber?: Maybe<Scalars['String']>;
  accountType?: Maybe<Scalars['String']>;
  financialInstitutionName?: Maybe<Scalars['String']>;
  routingNumber?: Maybe<Scalars['String']>;
};

export enum AchDetailsRecipientType {
  Melio = 'Melio',
  QBDT = 'QBDT',
  QBO = 'QBO'
}

export type Action = {
  __typename?: 'Action';
  _id: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  module: Scalars['String'];
  name: Scalars['String'];
  roles?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  updatedAt?: Maybe<Scalars['Date']>;
};

/** A connection to a list of items. */
export type ActionConnection = {
  __typename?: 'ActionConnection';
  /** Total object count. */
  count: Scalars['Int'];
  /** Information to aid in pagination. */
  edges: Array<ActionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ActionEdge = {
  __typename?: 'ActionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Action;
};

export type ActionLog = {
  __typename?: 'ActionLog';
  _id: Scalars['MongoID'];
  actionEndpoint: Scalars['String'];
  actionName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  details?: Maybe<ActionLogDetails>;
  entity: EnumActionLogEntity;
  entityId: Scalars['String'];
  failureMessage?: Maybe<Scalars['String']>;
  isTrainingMode?: Maybe<Scalars['Boolean']>;
  module?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  result: EnumActionLogResult;
  updatedAt?: Maybe<Scalars['Date']>;
  user?: Maybe<SherlockUser>;
  userEmail?: Maybe<Scalars['String']>;
  userId: Scalars['MongoID'];
};

/** A connection to a list of items. */
export type ActionLogConnection = {
  __typename?: 'ActionLogConnection';
  /** Total object count. */
  count: Scalars['Int'];
  /** Information to aid in pagination. */
  edges: Array<ActionLogEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ActionLogDetails = {
  __typename?: 'ActionLogDetails';
  actionValues?: Maybe<Scalars['JSON']>;
  checkSerialNumber?: Maybe<Scalars['String']>;
  companyType?: Maybe<Scalars['String']>;
  createdManualPaymentId?: Maybe<Scalars['Float']>;
  deliveryMethodId?: Maybe<Scalars['Float']>;
  fundingSourceId?: Maybe<Scalars['Float']>;
  isSubscribed?: Maybe<Scalars['Boolean']>;
  isVip?: Maybe<Scalars['Boolean']>;
  metaData?: Maybe<Scalars['JSON']>;
  planCyclePeriod?: Maybe<Scalars['String']>;
  seats?: Maybe<Scalars['Float']>;
  sessionId?: Maybe<Scalars['String']>;
  subscriptionPlanId?: Maybe<Scalars['String']>;
  subscriptionPromoCode?: Maybe<Scalars['String']>;
  transferId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Float']>;
  zendeskTicketId?: Maybe<Scalars['Float']>;
};

/** An edge in a connection. */
export type ActionLogEdge = {
  __typename?: 'ActionLogEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: ActionLog;
};

/** List of items with pagination. */
export type ActionLogPagination = {
  __typename?: 'ActionLogPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<ActionLog>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ActionLogTimeline = {
  __typename?: 'ActionLogTimeline';
  actionType?: Maybe<Scalars['String']>;
  agentEmail?: Maybe<Scalars['String']>;
  outcome?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
};

/** List of items with pagination. */
export type ActionPagination = {
  __typename?: 'ActionPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Action>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ActiveLimitation = {
  __typename?: 'ActiveLimitation';
  limitationName: LimitationName;
  scopes: Array<RestrictedScope>;
};

export enum ActivityStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PROCESSING = 'PROCESSING'
}

export type ActivityStatusResponse = {
  __typename?: 'ActivityStatusResponse';
  createdAt: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  response?: Maybe<Scalars['String']>;
  status?: Maybe<ActivityStatus>;
  updatedAt: Scalars['String'];
};

export type AddressObjectTc = {
  __typename?: 'AddressObjectTC';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  aptNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clusterAppearances?: Maybe<Scalars['Int']>;
  countryCode?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<BusinessPropertyTag>>>;
  zipCode?: Maybe<Scalars['String']>;
};

export type AddressType = {
  __typename?: 'AddressType';
  addressLine1?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<BusinessPropertyTag>>>;
  updatedAt?: Maybe<Scalars['Date']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type AddressVerification = {
  __typename?: 'AddressVerification';
  addressMatch?: Maybe<Scalars['Boolean']>;
  provider?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactionRecordId?: Maybe<Scalars['String']>;
};

export type Agent = {
  __typename?: 'Agent';
  actionGroups?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  agentArn?: Maybe<Scalars['String']>;
  agentId?: Maybe<Scalars['String']>;
  /** Actual instructions from the agent version */
  agentInstructions?: Maybe<Scalars['String']>;
  agentName?: Maybe<Scalars['String']>;
  agentResourceRoleArn?: Maybe<Scalars['String']>;
  agentStatus?: Maybe<Scalars['String']>;
  agentVersion?: Maybe<Scalars['String']>;
  aliasId?: Maybe<Scalars['String']>;
  aliasName?: Maybe<Scalars['String']>;
  /** Available aliases for this agent */
  aliases?: Maybe<Array<Maybe<AgentAlias>>>;
  capabilities?: Maybe<Array<Maybe<Scalars['String']>>>;
  clientToken?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  customerEncryptionKeyArn?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  failureReasons?: Maybe<Array<Maybe<Scalars['String']>>>;
  foundationModel?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  idleSessionTTLInSeconds?: Maybe<Scalars['Int']>;
  knowledgeBases?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  modelId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** Prompt override configuration */
  promptOverrideConfiguration?: Maybe<Scalars['JSON']>;
  sessionTimeout?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  /** Detailed version information including instructions and configuration */
  versionDetails?: Maybe<Scalars['JSON']>;
};

export type AgentAlias = {
  __typename?: 'AgentAlias';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  status?: Maybe<Scalars['String']>;
};

export enum AgentExecutionType {
  ORCHESTRATION = 'ORCHESTRATION',
  POST_DECISION = 'POST_DECISION'
}

export type AgentFeedbackInput = {
  agentName: Scalars['String'];
  agentResult: Scalars['JSON'];
  entityId: Scalars['String'];
  entityType: Scalars['String'];
  feedbackDecision: FeedbackDecisionEnum;
  message?: InputMaybe<Scalars['String']>;
};

export type AgentFeedbackResponse = {
  __typename?: 'AgentFeedbackResponse';
  feedbackId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type AgentJobResult = {
  __typename?: 'AgentJobResult';
  content?: Maybe<Scalars['String']>;
  errorReason?: Maybe<Scalars['String']>;
  resolvedAlias?: Maybe<Scalars['String']>;
  resolvedVersion?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type AgentJobSubmission = {
  __typename?: 'AgentJobSubmission';
  aliasName: Scalars['String'];
  aliasVersion: Scalars['String'];
  jobId: Scalars['String'];
};

/** Response from the risk AI agent. */
export type AgentResultResponse = {
  __typename?: 'AgentResultResponse';
  /** The name of the agent. */
  agentName: Scalars['String'];
  /** The creation timestamp of the agent result. */
  createdAt: Scalars['String'];
  /** The result from the agent. */
  result?: Maybe<Scalars['String']>;
  /** The execution status of the agent result. */
  status: Scalars['String'];
};

export type AliasDetails = {
  __typename?: 'AliasDetails';
  agentInstructions?: Maybe<Scalars['String']>;
  agentVersion?: Maybe<Scalars['String']>;
  aliasId: Scalars['String'];
  aliasName: Scalars['String'];
  createdAt?: Maybe<Scalars['String']>;
  foundationModel?: Maybe<Scalars['String']>;
  guardrailConfiguration?: Maybe<GuardrailConfiguration>;
  updatedAt?: Maybe<Scalars['String']>;
};

export enum AllCasesCreatorOrigin {
  JusttApi = 'JusttApi',
  Manual = 'Manual',
  System = 'System'
}

export type AllCasesEntity = {
  __typename?: 'AllCasesEntity';
  amount: Scalars['Float'];
  caseId?: Maybe<Scalars['String']>;
  chargeReferenceNumber?: Maybe<Scalars['String']>;
  chargebackAccount?: Maybe<ChargebackAccount>;
  chargebackBankDate?: Maybe<Scalars['String']>;
  claim?: Maybe<Scalars['String']>;
  createOrigin?: Maybe<AllCasesCreatorOrigin>;
  createdAt?: Maybe<Scalars['String']>;
  creatorOrigin?: Maybe<ChargebackCreatorOrigin>;
  disputed?: Maybe<Scalars['Boolean']>;
  disputedInternally?: Maybe<Scalars['Boolean']>;
  dueDate?: Maybe<Scalars['String']>;
  entity?: Maybe<AllCasesEntityResponseEntityEnum>;
  externalNotes?: Maybe<Scalars['String']>;
  highLevelClaim?: Maybe<HighLevelClaim>;
  id: Scalars['String'];
  installmentNumber?: Maybe<Scalars['Int']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  noDisputeReason?: Maybe<NoDisputeReason>;
  noDisputeReasonOther?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  originalFailureCode?: Maybe<Scalars['String']>;
  originalLossCreatedAt: Scalars['String'];
  partner?: Maybe<Scalars['String']>;
  /** original payment details */
  payment?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['Int']>;
  reason?: Maybe<AllCasesReason>;
  reasonOther?: Maybe<Scalars['String']>;
  recoveredByJustt?: Maybe<Scalars['Boolean']>;
  recoveryAccount?: Maybe<ChargebackAccount>;
  recoveryBankDate?: Maybe<Scalars['String']>;
  recoveryDate?: Maybe<Scalars['String']>;
  recoveryMethod?: Maybe<AllCasesRecoveryMethod>;
  recoveryMethodOther?: Maybe<Scalars['String']>;
  scenario?: Maybe<AllCasesScenario>;
  scenarioOther?: Maybe<Scalars['String']>;
  source?: Maybe<UfSource>;
  status?: Maybe<Status>;
  subStatus?: Maybe<AllCasesSubStatus>;
  subStatusOther?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

/** Get all cases and count */
export type AllCasesEntityRecord = {
  __typename?: 'AllCasesEntityRecord';
  cases?: Maybe<Array<Maybe<AllCasesEntity>>>;
  count: Scalars['Int'];
};

export enum AllCasesEntityResponseEntityEnum {
  Chargeback = 'Chargeback',
  Meliodbcase = 'Meliodbcase'
}

export enum AllCasesReason {
  Abuse = 'Abuse',
  Ato = 'Ato',
  CheckDmPolicyIssue = 'CheckDmPolicyIssue',
  DelinquentRefund = 'DelinquentRefund',
  ExpeditedPayment = 'ExpeditedPayment',
  ExternalServiceIssue = 'ExternalServiceIssue',
  FeeForFailedPayment = 'FeeForFailedPayment',
  FriendlyFraud = 'FriendlyFraud',
  GoodUserInexplainable = 'GoodUserInexplainable',
  GoodsServiceNotRendered = 'GoodsServiceNotRendered',
  InternalIssue = 'InternalIssue',
  NotAsDescribedDefective = 'NotAsDescribedDefective',
  Other = 'Other',
  P2dFraud = 'P2dFraud',
  RealFraud = 'RealFraud',
  ReversePhishing = 'ReversePhishing',
  Sf = 'Sf',
  UnilateralFraud = 'UnilateralFraud',
  VendorSideFraud = 'VendorSideFraud'
}

export enum AllCasesRecoveryMethod {
  AchReversal = 'AchReversal',
  Affidavit = 'Affidavit',
  AffidavitPendingBankResponse = 'AffidavitPendingBankResponse',
  AffidavitPendingPayee = 'AffidavitPendingPayee',
  AffidavitPreparedPendingNotarization = 'AffidavitPreparedPendingNotarization',
  CbDispute = 'CbDispute',
  Dispute = 'Dispute',
  DisputingNotViaJustt = 'DisputingNotViaJustt',
  HandoffToCk = 'HandoffToCk',
  InternationalRecall = 'InternationalRecall',
  LegalAction = 'LegalAction',
  Loi = 'Loi',
  Other = 'Other',
  Recollect = 'Recollect',
  RecoveredFromTheVendor = 'RecoveredFromTheVendor',
  RemovalRequest = 'RemovalRequest',
  SecondCbDispute = 'SecondCbDispute',
  TabapayReversal = 'TabapayReversal'
}

export enum AllCasesScenario {
  Arbitration = 'Arbitration',
  Cb = 'Cb',
  ExternalLoss = 'ExternalLoss',
  Inquiry = 'Inquiry',
  Other = 'Other',
  PartnerLoss = 'PartnerLoss',
  Poa = 'Poa',
  PotentialLoss = 'PotentialLoss',
  PreArbitration = 'PreArbitration',
  Reimbursement = 'Reimbursement',
  SecondChargeback = 'SecondChargeback',
  UncollectedFees = 'UncollectedFees',
  UncollectedFunds = 'UncollectedFunds'
}

export enum AllCasesSubStatus {
  AttemptingRecovery = 'AttemptingRecovery',
  FalsePositive = 'FalsePositive',
  Final = 'Final',
  InquiryLost = 'InquiryLost',
  InquiryResponded = 'InquiryResponded',
  InquiryWon = 'InquiryWon',
  LossReviewed = 'LossReviewed',
  MelioHasFunds = 'MelioHasFunds',
  NotFighting = 'NotFighting',
  NotFinal = 'NotFinal',
  Other = 'Other',
  PoaAnswered = 'PoaAnswered',
  RecoveryFailed = 'RecoveryFailed',
  RecoverySuccessful = 'RecoverySuccessful',
  RemovedByPayor = 'RemovedByPayor',
  Tbd = 'Tbd'
}

export type AllTags = {
  __typename?: 'AllTags';
  count?: Maybe<Scalars['Int']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
};

export type Analyst = {
  __typename?: 'Analyst';
  name: Scalars['String'];
  picture?: Maybe<Scalars['String']>;
  status?: Maybe<ParticipantStatusEnum>;
  userId: Scalars['String'];
};

export enum AppliedLimitationEntity {
  organization = 'organization',
  payment = 'payment'
}

export type Assets = {
  __typename?: 'Assets';
  features?: Maybe<Array<Maybe<StrategyFeatureTc>>>;
};

export type AssignedCard = {
  __typename?: 'AssignedCard';
  brand: Scalars['String'];
  cardId: Scalars['String'];
  last4: Scalars['String'];
  nickname: Scalars['String'];
};

export type AssignedUser = {
  __typename?: 'AssignedUser';
  _id?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
};

export enum AtoAutomationEntityType {
  DeliveryMethod = 'DeliveryMethod',
  Ip = 'Ip',
  Organization = 'Organization',
  Payment = 'Payment',
  User = 'User'
}

export enum AtoAutomationName {
  changeOde = 'changeOde',
  createCallTicket = 'createCallTicket',
  declineInProgressPayments = 'declineInProgressPayments',
  declineScheduledPayments = 'declineScheduledPayments',
  emailCommunication = 'emailCommunication',
  escalateToPOps = 'escalateToPOps',
  limitUser = 'limitUser',
  noteOnAccount = 'noteOnAccount',
  setKyb = 'setKyb',
  tagDm = 'tagDm',
  tagOrg = 'tagOrg',
  tagPayment = 'tagPayment',
  tagPaymentIp = 'tagPaymentIp',
  tagUser = 'tagUser'
}

export enum AtoAutomationStatus {
  failed = 'failed',
  success = 'success'
}

export type AtoCase = {
  __typename?: 'AtoCase';
  affectedPaymentIds: Array<Scalars['Int']>;
  automations: Array<AtoCaseAutomation>;
  callTicketUrl?: Maybe<Scalars['String']>;
  closedDate?: Maybe<Scalars['String']>;
  compromisedUserEmail: Scalars['String'];
  createdAt?: Maybe<Scalars['String']>;
  createdByUser?: Maybe<AtoCaseUser>;
  id: Scalars['String'];
  organizationId: Scalars['Int'];
  status: AtoCaseStatus;
  triggerPayments: Array<Scalars['Int']>;
  trustedUserCommunicationTicketUrl?: Maybe<Scalars['String']>;
  trustedUserEmail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type AtoCaseAutomation = {
  __typename?: 'AtoCaseAutomation';
  automationName: AtoAutomationName;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<AtoAutomationEntityType>;
  failedMessage?: Maybe<Scalars['String']>;
  ranAt: Scalars['String'];
  status: AtoAutomationStatus;
  value?: Maybe<Scalars['String']>;
};

export enum AtoCaseStatus {
  automationFailed = 'automationFailed',
  automationSuccess = 'automationSuccess',
  done = 'done',
  manuallyApproved = 'manuallyApproved',
  open = 'open',
  running = 'running'
}

export type AtoCaseUser = {
  __typename?: 'AtoCaseUser';
  name: Scalars['String'];
  picture?: Maybe<Scalars['String']>;
};

export type AttachedFile = {
  __typename?: 'AttachedFile';
  associatedPaymentIds: Array<Maybe<Scalars['String']>>;
  associatedTicketUrl?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  ocrJson?: Maybe<OcrJson>;
  originalFileName?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  requestId: Scalars['String'];
  source?: Maybe<Scalars['String']>;
  uploadedBy?: Maybe<Scalars['String']>;
  uploadedOn?: Maybe<Scalars['Date']>;
};

export type AttachedFileIndication = {
  __typename?: 'AttachedFileIndication';
  hasFiles: Scalars['Boolean'];
  hasOcrError: Scalars['Boolean'];
  hasProhibited: Scalars['Boolean'];
  hasSanctioned: Scalars['Boolean'];
};

export type AttachedPaymentFile = {
  __typename?: 'AttachedPaymentFile';
  agreements?: Maybe<Array<Maybe<Agreement>>>;
  attachedToInvoices?: Maybe<Array<Maybe<Invoice>>>;
  billSubscriptions?: Maybe<Array<Maybe<BillSubscription>>>;
  bills?: Maybe<Array<Maybe<Bill>>>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  fileName?: Maybe<Scalars['String']>;
  hash?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  invoice?: Maybe<Invoice>;
  mimeType?: Maybe<Scalars['String']>;
  ocrJson?: Maybe<OcrJson>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  owningOrganizationId?: Maybe<Scalars['Int']>;
  partnerName?: Maybe<Scalars['String']>;
  paymentRequests?: Maybe<Array<Maybe<PaymentRequest>>>;
  previewRef?: Maybe<Scalars['String']>;
  receivablePaymentDetails?: Maybe<Array<Maybe<ReceivablePaymentDetails>>>;
  size?: Maybe<Scalars['Int']>;
  storageRef?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  users?: Maybe<Array<Maybe<User>>>;
};

export type AuditTrailActor = {
  __typename?: 'AuditTrailActor';
  accountId?: Maybe<Scalars['String']>;
  clientIp?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  partnerName?: Maybe<Scalars['String']>;
  service?: Maybe<Scalars['String']>;
  sourceService?: Maybe<Scalars['String']>;
  userAgent?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};

export type AuditTrailCsvExportResponse = {
  __typename?: 'AuditTrailCsvExportResponse';
  signedUrl?: Maybe<Scalars['String']>;
};

export type AuditTrailEvent = {
  __typename?: 'AuditTrailEvent';
  actionId?: Maybe<Scalars['String']>;
  actionType: Scalars['String'];
  actor?: Maybe<AuditTrailActor>;
  data?: Maybe<Scalars['String']>;
  eventData?: Maybe<Scalars['JSON']>;
  text?: Maybe<Scalars['String']>;
  timestamp: Scalars['String'];
  traceId?: Maybe<Scalars['String']>;
};

export type AuditTrailQueryResponse = {
  __typename?: 'AuditTrailQueryResponse';
  events?: Maybe<Array<Maybe<AuditTrailEvent>>>;
  next?: Maybe<Scalars['String']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type BadAsset = {
  __typename?: 'BadAsset';
  badAssets: Array<Maybe<Scalars['String']>>;
  organization: BadAssetLinkingOrganization;
};

export type BadAssetLinkingOrganization = {
  __typename?: 'BadAssetLinkingOrganization';
  id: Scalars['Int'];
  moneyIn?: Maybe<BadAssetLinkingOrganizationMoneyIn>;
  moneyOut?: Maybe<BadAssetLinkingOrganizationMoneyOut>;
  name: Scalars['String'];
};

export type BadAssetLinkingOrganizationMoneyIn = {
  __typename?: 'BadAssetLinkingOrganizationMoneyIn';
  decision?: Maybe<DecisionsTypes>;
  labels?: Maybe<Array<Maybe<OrganizationLabel>>>;
};

export type BadAssetLinkingOrganizationMoneyOut = {
  __typename?: 'BadAssetLinkingOrganizationMoneyOut';
  decision?: Maybe<DecisionsTypes>;
  labels?: Maybe<Array<Maybe<OrganizationLabel>>>;
};

export type BadAssetsLinkingResponse = {
  __typename?: 'BadAssetsLinkingResponse';
  payee: Array<BadAsset>;
  payor: Array<BadAsset>;
};

export type BankAccountType = {
  __typename?: 'BankAccountType';
  accountNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['String']>;
  routingNumber?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<BusinessPropertyTag>>>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type BankRecordTypeSummaryGraphQlType = {
  __typename?: 'BankRecordTypeSummaryGraphQlType';
  breakdown?: Maybe<BankType>;
  credit?: Maybe<DirectionSummaryGraphQlType>;
  debit?: Maybe<DirectionSummaryGraphQlType>;
  totalReconciledRecords?: Maybe<Scalars['Float']>;
  totalReconciledSumOfMoney?: Maybe<Scalars['Float']>;
  totalRecords?: Maybe<Scalars['Float']>;
  totalSumOfMoney?: Maybe<Scalars['Float']>;
  totalUnreconciledRecords?: Maybe<Scalars['Float']>;
  totalUnreconciledSumOfMoney?: Maybe<Scalars['Float']>;
};

export type BasicRule = {
  __typename?: 'BasicRule';
  _id?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['JSON']>;
  decision?: Maybe<Scalars['String']>;
  entityType?: Maybe<Scalars['String']>;
  labelIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  limitations?: Maybe<Scalars['JSON']>;
  mos?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  riskDecisionCodeId?: Maybe<Scalars['Int']>;
  ruleId?: Maybe<Scalars['Int']>;
  subcategory?: Maybe<Scalars['String']>;
};

export type BillAttachment = {
  __typename?: 'BillAttachment';
  fileName: Scalars['String'];
  ocrJson?: Maybe<OcrJson>;
  url?: Maybe<Scalars['String']>;
};

export type BillProhibitedIndustriesData = {
  __typename?: 'BillProhibitedIndustriesData';
  invoiceNumberSuspectedWords: Array<Scalars['String']>;
  noteSuspectedWords: Array<Scalars['String']>;
};

export enum BillerDirectoryPaymentMethodType {
  ACH = 'ACH',
  CHECK = 'CHECK'
}

export enum BillerDirectoryProvider {
  FISERV = 'FISERV'
}

export type BillingInformationType = {
  __typename?: 'BillingInformationType';
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  fundingSourceId?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type BlockRule = {
  __typename?: 'BlockRule';
  id?: Maybe<Scalars['Int']>;
  mos?: Maybe<Array<Maybe<Scalars['String']>>>;
  muted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type Browser = {
  __typename?: 'Browser';
  isConsistent?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type BulkCommentsResponse = {
  __typename?: 'BulkCommentsResponse';
  collectionName?: Maybe<CollectionName>;
  comments?: Maybe<Array<Maybe<Comment>>>;
  entityId: Scalars['String'];
};

export type BulkEntitiesTags = {
  __typename?: 'BulkEntitiesTags';
  entity?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<EntityTag>>>;
};

export enum BusinessEntityEnum {
  Other = 'Other',
  Payee = 'Payee',
  Payor = 'Payor'
}

export type BusinessNameObjectTc = {
  __typename?: 'BusinessNameObjectTC';
  clusterAppearances?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<BusinessPropertyTag>>>;
  type?: Maybe<BusinessNameTypes>;
};

export type BusinessNameType = {
  __typename?: 'BusinessNameType';
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<BusinessPropertyTag>>>;
  type?: Maybe<BusinessNameTypes>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export enum BusinessNameTypes {
  Alias = 'Alias',
  Legal = 'Legal',
  Public = 'Public'
}

export enum BusinessPropertyTag {
  Enrichment = 'Enrichment',
  SelfProclaimed = 'SelfProclaimed',
  StrategicSegment = 'StrategicSegment'
}

export enum BusinessRelationshipType {
  Branch = 'Branch',
  Conglomerate = 'Conglomerate',
  Franchisee = 'Franchisee',
  Franchisor = 'Franchisor',
  PayableCohort = 'PayableCohort',
  Subsidiary = 'Subsidiary'
}

export type BusinessType = {
  __typename?: 'BusinessType';
  addresses?: Maybe<Array<Maybe<AddressType>>>;
  bankAccounts?: Maybe<Array<Maybe<BankAccountType>>>;
  businessNames?: Maybe<Array<Maybe<BusinessNameType>>>;
  businessRelationshipTypes?: Maybe<Array<Maybe<BusinessRelationshipType>>>;
  contacts?: Maybe<Array<Maybe<ContactType>>>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  emails?: Maybe<Array<Maybe<EmailType>>>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  virtualCard?: Maybe<VirtualCardType>;
};

export type BusyEntityCachedData = {
  __typename?: 'BusyEntityCachedData';
  accountNumber?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  aptNumber?: Maybe<Scalars['String']>;
  businessId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  contactFirstName?: Maybe<Scalars['String']>;
  contactFullName?: Maybe<Scalars['String']>;
  contactLastName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  escalationDescription?: Maybe<Scalars['String']>;
  escalationReason?: Maybe<Scalars['String']>;
  fcbStatus?: Maybe<EnumBusyEntityCachedDataFcbStatus>;
  groupId?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  notes?: Maybe<Scalars['String']>;
  origin?: Maybe<EnumBusyEntityCachedDataOrigin>;
  phone?: Maybe<Scalars['String']>;
  rejectionReason?: Maybe<EnumBusyEntityCachedDataRejectionReason>;
  relatedTasks?: Maybe<Scalars['Float']>;
  routingNumber?: Maybe<Scalars['String']>;
  sourceId: Scalars['String'];
  sourceType: EnumBusyEntityCachedDataSourceType;
  state?: Maybe<Scalars['String']>;
  taskReviewStartTime?: Maybe<Scalars['Date']>;
  taskType: EnumBusyEntityCachedDataTaskType;
  taxId?: Maybe<Scalars['String']>;
  taxIdType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  virtualCardEmail?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type BusyTaskSourceType = {
  __typename?: 'BusyTaskSourceType';
  sourceType?: Maybe<BusyTaskSourceTypes>;
  totalTasks?: Maybe<Scalars['Int']>;
};

export enum BusyTaskSourceTypes {
  IntuitVcBusinessSubmissionForm = 'IntuitVcBusinessSubmissionForm',
  JpmVcBusinessFileUpload = 'JpmVcBusinessFileUpload',
  Msn = 'Msn',
  MsnGetPaidOrganizationFileUpload = 'MsnGetPaidOrganizationFileUpload',
  StrategicSegmentsFile = 'StrategicSegmentsFile',
  UnlinkBusinessMatch = 'UnlinkBusinessMatch',
  VcBusinessSubmissionForm = 'VcBusinessSubmissionForm'
}

export type BusyUnmatchTaskEntityCachedData = {
  __typename?: 'BusyUnmatchTaskEntityCachedData';
  businessId: Scalars['String'];
  businessMatchResult?: Maybe<BusyUnmatchTaskEntityCachedDataBusinessMatchResult>;
  businessName: Scalars['String'];
  createdAt: Scalars['Date'];
  decision?: Maybe<EnumBusyUnmatchTaskEntityCachedDataDecision>;
  escalationDescription?: Maybe<Scalars['String']>;
  escalationReason?: Maybe<Scalars['String']>;
  hasScheduledPayments?: Maybe<Scalars['Boolean']>;
  id: Scalars['Float'];
  isPaidVendor?: Maybe<Scalars['Boolean']>;
  matchCreationDate: Scalars['Date'];
  matchCreationReason?: Maybe<Scalars['String']>;
  matchCreationSource: EnumBusyUnmatchTaskEntityCachedDataMatchCreationSource;
  next30DaysTpv?: Maybe<Scalars['Float']>;
  notes?: Maybe<Scalars['String']>;
  relatedTasks?: Maybe<Scalars['Float']>;
  sourceId: Scalars['String'];
  sourceType: EnumBusyUnmatchTaskEntityCachedDataSourceType;
  unmatchReason?: Maybe<EnumBusyUnmatchTaskEntityCachedDataUnmatchReason>;
  updatedAt: Scalars['Date'];
  vendorId: Scalars['String'];
  vendorName: Scalars['String'];
};

export type BusyUnmatchTaskEntityCachedDataBusinessMatchResult = {
  __typename?: 'BusyUnmatchTaskEntityCachedDataBusinessMatchResult';
  breakdown?: Maybe<BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdown>;
  matchScore?: Maybe<Scalars['Float']>;
  matched?: Maybe<Scalars['Boolean']>;
  version?: Maybe<Scalars['Float']>;
};

export type BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdown = {
  __typename?: 'BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdown';
  address?: Maybe<BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddress>;
  bankAccount?: Maybe<BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccount>;
  email?: Maybe<BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownEmail>;
  legalName?: Maybe<BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownLegalName>;
  phone?: Maybe<BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownPhone>;
  publicName?: Maybe<BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownPublicName>;
  taxDetails?: Maybe<BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetails>;
};

export type BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddress = {
  __typename?: 'BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddress';
  breakdown?: Maybe<BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdown>;
  matchScore?: Maybe<Scalars['Float']>;
  matched?: Maybe<Scalars['Boolean']>;
};

export type BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdown = {
  __typename?: 'BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdown';
  addressLine1?: Maybe<BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAddressLine1>;
  addressLine2?: Maybe<BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAddressLine2>;
  aptNumber?: Maybe<BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAptNumber>;
  city?: Maybe<BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownCity>;
  countryCode?: Maybe<BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownCountryCode>;
  googlePlaceId?: Maybe<BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownGooglePlaceId>;
  state?: Maybe<BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownState>;
  zipCode?: Maybe<BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownZipCode>;
};

export type BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAddressLine1 = {
  __typename?: 'BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAddressLine1';
  matchScore?: Maybe<Scalars['Float']>;
  matched?: Maybe<Scalars['Boolean']>;
};

export type BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAddressLine2 = {
  __typename?: 'BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAddressLine2';
  matchScore?: Maybe<Scalars['Float']>;
  matched?: Maybe<Scalars['Boolean']>;
};

export type BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAptNumber = {
  __typename?: 'BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAptNumber';
  matchScore?: Maybe<Scalars['Float']>;
  matched?: Maybe<Scalars['Boolean']>;
};

export type BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownCity = {
  __typename?: 'BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownCity';
  matchScore?: Maybe<Scalars['Float']>;
  matched?: Maybe<Scalars['Boolean']>;
};

export type BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownCountryCode = {
  __typename?: 'BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownCountryCode';
  matchScore?: Maybe<Scalars['Float']>;
  matched?: Maybe<Scalars['Boolean']>;
};

export type BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownGooglePlaceId = {
  __typename?: 'BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownGooglePlaceId';
  matchScore?: Maybe<Scalars['Float']>;
  matched?: Maybe<Scalars['Boolean']>;
};

export type BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownState = {
  __typename?: 'BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownState';
  matchScore?: Maybe<Scalars['Float']>;
  matched?: Maybe<Scalars['Boolean']>;
};

export type BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownZipCode = {
  __typename?: 'BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownZipCode';
  matchScore?: Maybe<Scalars['Float']>;
  matched?: Maybe<Scalars['Boolean']>;
};

export type BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccount = {
  __typename?: 'BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccount';
  breakdown?: Maybe<BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountBreakdown>;
  matchScore?: Maybe<Scalars['Float']>;
  matched?: Maybe<Scalars['Boolean']>;
};

export type BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountBreakdown = {
  __typename?: 'BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountBreakdown';
  accountNumber?: Maybe<BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountBreakdownAccountNumber>;
  routingNumber?: Maybe<BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountBreakdownRoutingNumber>;
};

export type BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountBreakdownAccountNumber = {
  __typename?: 'BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountBreakdownAccountNumber';
  matchScore?: Maybe<Scalars['Float']>;
  matched?: Maybe<Scalars['Boolean']>;
};

export type BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountBreakdownRoutingNumber = {
  __typename?: 'BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountBreakdownRoutingNumber';
  matchScore?: Maybe<Scalars['Float']>;
  matched?: Maybe<Scalars['Boolean']>;
};

export type BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownEmail = {
  __typename?: 'BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownEmail';
  matchScore?: Maybe<Scalars['Float']>;
  matched?: Maybe<Scalars['Boolean']>;
};

export type BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownLegalName = {
  __typename?: 'BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownLegalName';
  matchScore?: Maybe<Scalars['Float']>;
  matched?: Maybe<Scalars['Boolean']>;
};

export type BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownPhone = {
  __typename?: 'BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownPhone';
  matchScore?: Maybe<Scalars['Float']>;
  matched?: Maybe<Scalars['Boolean']>;
};

export type BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownPublicName = {
  __typename?: 'BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownPublicName';
  matchScore?: Maybe<Scalars['Float']>;
  matched?: Maybe<Scalars['Boolean']>;
};

export type BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetails = {
  __typename?: 'BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetails';
  breakdown?: Maybe<BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsBreakdown>;
  matchScore?: Maybe<Scalars['Float']>;
  matched?: Maybe<Scalars['Boolean']>;
};

export type BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsBreakdown = {
  __typename?: 'BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsBreakdown';
  taxId?: Maybe<BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsBreakdownTaxId>;
  taxIdType?: Maybe<BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsBreakdownTaxIdType>;
};

export type BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsBreakdownTaxId = {
  __typename?: 'BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsBreakdownTaxId';
  matchScore?: Maybe<Scalars['Float']>;
  matched?: Maybe<Scalars['Boolean']>;
};

export type BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsBreakdownTaxIdType = {
  __typename?: 'BusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsBreakdownTaxIdType';
  matchScore?: Maybe<Scalars['Float']>;
  matched?: Maybe<Scalars['Boolean']>;
};

export type CardRecord = {
  __typename?: 'CardRecord';
  _id: Scalars['MongoID'];
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deliveryMethod: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
  recordId: Scalars['String'];
  updatedAt?: Maybe<Scalars['Date']>;
};

/** A connection to a list of items. */
export type CardRecordConnection = {
  __typename?: 'CardRecordConnection';
  /** Total object count. */
  count: Scalars['Int'];
  /** Information to aid in pagination. */
  edges: Array<CardRecordEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CardRecordEdge = {
  __typename?: 'CardRecordEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: CardRecord;
};

/** List of items with pagination. */
export type CardRecordPagination = {
  __typename?: 'CardRecordPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<CardRecord>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type Cardholder = {
  __typename?: 'Cardholder';
  addedDate?: Maybe<Scalars['DateTime']>;
  assignedCards?: Maybe<Array<AssignedCard>>;
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['String'];
  isArchived: Scalars['Boolean'];
  lastName: Scalars['String'];
  optedInAt?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  status: CardholderStatus;
};

export enum CardholderStatus {
  active = 'active',
  archived = 'archived',
  pending = 'pending'
}

export type CardholdersResponse = {
  __typename?: 'CardholdersResponse';
  data: Array<Cardholder>;
  pagination: ExpenseManagementPaginationMeta;
};

export type Chargeback = {
  __typename?: 'Chargeback';
  amount: Scalars['Float'];
  caseId: Scalars['String'];
  chargeReferenceNumber?: Maybe<Scalars['String']>;
  chargebackAccount?: Maybe<ChargebackAccount>;
  chargebackBankDate?: Maybe<Scalars['String']>;
  claim: Scalars['String'];
  createdAt?: Maybe<Scalars['String']>;
  creatorOrigin?: Maybe<ChargebackCreatorOrigin>;
  disputed?: Maybe<Scalars['Boolean']>;
  disputedInternally?: Maybe<Scalars['Boolean']>;
  dueDate?: Maybe<Scalars['String']>;
  externalNotes?: Maybe<Scalars['String']>;
  highLevelClaim?: Maybe<HighLevelClaim>;
  id: Scalars['String'];
  installmentNumber?: Maybe<Scalars['Int']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  noDisputeReason?: Maybe<NoDisputeReason>;
  noDisputeReasonOther?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  originalFailureCode?: Maybe<Scalars['String']>;
  originalLossCreatedAt: Scalars['String'];
  partner?: Maybe<Scalars['String']>;
  /** original payment details */
  payment?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['Int']>;
  reason?: Maybe<ChargebackReason>;
  reasonOther?: Maybe<Scalars['String']>;
  recoveredByJustt?: Maybe<Scalars['Boolean']>;
  recoveryAccount?: Maybe<ChargebackAccount>;
  recoveryBankDate?: Maybe<Scalars['String']>;
  recoveryDate?: Maybe<Scalars['String']>;
  recoveryMethod?: Maybe<ChargebackRecoveryMethod>;
  recoveryMethodOther?: Maybe<Scalars['String']>;
  scenario?: Maybe<ChargebackScenario>;
  scenarioOther?: Maybe<Scalars['String']>;
  source?: Maybe<UfSource>;
  status?: Maybe<Status>;
  subStatus?: Maybe<ChargebackSubStatus>;
  subStatusOther?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export enum ChargebackAccount {
  Evolve2586Dda = 'Evolve2586Dda',
  Evolve2587Fbo = 'Evolve2587Fbo',
  Svb3639Fbo = 'Svb3639Fbo',
  Svb3643Fbo = 'Svb3643Fbo',
  Svb8361Dda = 'Svb8361Dda'
}

export enum ChargebackCreatorOrigin {
  JusttApi = 'JusttApi',
  Manual = 'Manual',
  System = 'System'
}

export enum ChargebackReason {
  Abuse = 'Abuse',
  Ato = 'Ato',
  CheckDmPolicyIssue = 'CheckDmPolicyIssue',
  DelinquentRefund = 'DelinquentRefund',
  ExpeditedPayment = 'ExpeditedPayment',
  ExternalServiceIssue = 'ExternalServiceIssue',
  FeeForFailedPayment = 'FeeForFailedPayment',
  FriendlyFraud = 'FriendlyFraud',
  GoodUserInexplainable = 'GoodUserInexplainable',
  GoodsServiceNotRendered = 'GoodsServiceNotRendered',
  InternalIssue = 'InternalIssue',
  NotAsDescribedDefective = 'NotAsDescribedDefective',
  Other = 'Other',
  P2dFraud = 'P2dFraud',
  RealFraud = 'RealFraud',
  ReversePhishing = 'ReversePhishing',
  Sf = 'Sf',
  UnilateralFraud = 'UnilateralFraud',
  VendorSideFraud = 'VendorSideFraud'
}

/** Get all Chargeback cases and count */
export type ChargebackRecord = {
  __typename?: 'ChargebackRecord';
  cases?: Maybe<Array<Maybe<Chargeback>>>;
  count: Scalars['Int'];
};

export enum ChargebackRecoveryMethod {
  AchReversal = 'AchReversal',
  AffidavitPendingBankResponse = 'AffidavitPendingBankResponse',
  AffidavitPendingPayee = 'AffidavitPendingPayee',
  AffidavitPreparedPendingNotarization = 'AffidavitPreparedPendingNotarization',
  CbDispute = 'CbDispute',
  Dispute = 'Dispute',
  DisputingNotViaJustt = 'DisputingNotViaJustt',
  LegalAction = 'LegalAction',
  Loi = 'Loi',
  Other = 'Other',
  RecoveredFromTheVendor = 'RecoveredFromTheVendor',
  RemovalRequest = 'RemovalRequest',
  SecondCbDispute = 'SecondCbDispute',
  TabapayReversal = 'TabapayReversal'
}

export enum ChargebackScenario {
  Arbitration = 'Arbitration',
  Cb = 'Cb',
  Inquiry = 'Inquiry',
  Other = 'Other',
  PotentialLoss = 'PotentialLoss',
  PreArbitration = 'PreArbitration',
  SecondChargeback = 'SecondChargeback'
}

export enum ChargebackSubStatus {
  AttemptingRecovery = 'AttemptingRecovery',
  FalsePositive = 'FalsePositive',
  Final = 'Final',
  InquiryLost = 'InquiryLost',
  InquiryResponded = 'InquiryResponded',
  InquiryWon = 'InquiryWon',
  LossReviewed = 'LossReviewed',
  MelioHasFunds = 'MelioHasFunds',
  NotFighting = 'NotFighting',
  NotFinal = 'NotFinal',
  Other = 'Other',
  RecoveryFailed = 'RecoveryFailed',
  RecoverySuccessful = 'RecoverySuccessful',
  RemovedByPayor = 'RemovedByPayor',
  Tbd = 'Tbd'
}

export type ChargebackTimeline = {
  __typename?: 'ChargebackTimeline';
  chargebackStatus?: Maybe<Status>;
};

export type ClusterTpv = {
  __typename?: 'ClusterTpv';
  tpv?: Maybe<Scalars['Float']>;
};

export enum CollectionName {
  organization = 'organization',
  payment = 'payment',
  thread = 'thread',
  user = 'user'
}

export enum ColumnDisplayType {
  Amount = 'Amount',
  Boolean = 'Boolean',
  Date = 'Date',
  Link = 'Link',
  Number = 'Number',
  Tag = 'Tag',
  Text = 'Text'
}

export type Comment = {
  __typename?: 'Comment';
  collectionName: CollectionName;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['Date']>;
  entityId: Scalars['String'];
  id: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  sherlockUser?: Maybe<SherlockUser>;
  updatedAt?: Maybe<Scalars['Date']>;
  visibleTo?: Maybe<VisibilityTeam>;
};

export type CommunicationDisplayType = {
  __typename?: 'CommunicationDisplayType';
  partners?: Maybe<Array<Maybe<Scalars['String']>>>;
  recipientTypes?: Maybe<Array<Maybe<CommunicationRecipientTypes>>>;
  sampleModels?: Maybe<Scalars['JSON']>;
};

export enum CommunicationMediumTypes {
  email = 'email',
  push_notification = 'push_notification',
  sms = 'sms'
}

export enum CommunicationRecipientTypes {
  actor = 'actor',
  admins = 'admins',
  invitation = 'invitation',
  joinOrganizationRequest = 'joinOrganizationRequest',
  owner = 'owner',
  payee = 'payee',
  payload = 'payload',
  paymentApprovalDecisionActor = 'paymentApprovalDecisionActor',
  users = 'users'
}

export type CommunicationRenderedTemplateType = {
  __typename?: 'CommunicationRenderedTemplateType';
  html?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
};

export type CommunicationRowType = {
  __typename?: 'CommunicationRowType';
  communicationType: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  eventNames: Array<Scalars['String']>;
  mediums?: Maybe<Array<Maybe<CommunicationMediumTypes>>>;
  owner?: Maybe<Scalars['String']>;
  recipientTypes?: Maybe<Array<Maybe<CommunicationRecipientTypes>>>;
};

export type CompletedTasks = {
  __typename?: 'CompletedTasks';
  approved: Scalars['Int'];
  declined: Scalars['Int'];
  total: Scalars['Int'];
};

export type ComplianceGoodStandingVerification = {
  __typename?: 'ComplianceGoodStandingVerification';
  lastVerified?: Maybe<Scalars['DateTime']>;
  provider?: Maybe<TaxVerificationProviderEnum>;
  status?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactionRecordId?: Maybe<Scalars['String']>;
};

export type CompositeBill = {
  __typename?: 'CompositeBill';
  account: PartialAccount;
  balance?: Maybe<Scalars['Float']>;
  billPaymentIds: Array<Scalars['String']>;
  currency: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  invoiceDate?: Maybe<Scalars['Date']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  isDeleted: Scalars['Boolean'];
  note?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  status: Scalars['String'];
  totalAmount: Scalars['Float'];
  updatedAt?: Maybe<Scalars['Date']>;
  vendor: PartialVendor;
};

export enum ConcernAreaDecision {
  approved = 'approved',
  declined = 'declined',
  escalated = 'escalated',
  pending = 'pending'
}

export type ConcernAreaSchema = {
  __typename?: 'ConcernAreaSchema';
  _id: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  createdBy: Scalars['MongoID'];
  deletedAt?: Maybe<Scalars['Date']>;
  isMandatory?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  rules: Array<Maybe<Scalars['String']>>;
  squad?: Maybe<Squad>;
  squadId: Scalars['MongoID'];
  status: EnumConcernAreaSchemaStatus;
  team?: Maybe<Team>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export enum ConcernAreaStatus {
  closed = 'closed',
  completed = 'completed',
  deleted = 'deleted',
  open = 'open'
}

export type ConnectedCard = {
  __typename?: 'ConnectedCard';
  accountingPlatformAccountId?: Maybe<Scalars['String']>;
  addedDate?: Maybe<Scalars['DateTime']>;
  brand: Scalars['String'];
  cardId?: Maybe<Scalars['String']>;
  cardholderId?: Maybe<Scalars['String']>;
  cardholderName: Scalars['String'];
  expenses?: Maybe<Array<Expense>>;
  expiryDate?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  last4: Scalars['String'];
  nickname: Scalars['String'];
  state: Scalars['String'];
};


export type ConnectedCardExpensesArgs = {
  fromDate?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
  stage?: InputMaybe<ExpenseStage>;
  toDate?: InputMaybe<Scalars['Date']>;
};

export type ConnectedCardsResponse = {
  __typename?: 'ConnectedCardsResponse';
  data: Array<ConnectedCard>;
  pagination: ExpenseManagementPaginationMeta;
};

export type ContactNameObjectTc = {
  __typename?: 'ContactNameObjectTC';
  clusterAppearances?: Maybe<Scalars['Int']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<BusinessPropertyTag>>>;
};

export type ContactPhoneObjectTc = {
  __typename?: 'ContactPhoneObjectTC';
  clusterAppearances?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  phoneExt?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<BusinessPropertyTag>>>;
};

export type ContactType = {
  __typename?: 'ContactType';
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<BusinessPropertyTag>>>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type Conversation = {
  __typename?: 'Conversation';
  agentName?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  id: Scalars['String'];
  lastMessageAt: Scalars['String'];
  modelId?: Maybe<Scalars['String']>;
  partner: Scalars['String'];
};

export type CreateOneConcernAreaSchemaInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy: Scalars['MongoID'];
  deletedAt?: InputMaybe<Scalars['Date']>;
  isMandatory?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  rules: Array<InputMaybe<Scalars['String']>>;
  squadId: Scalars['MongoID'];
  status: EnumConcernAreaSchemaStatus;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type CreateOneConcernAreaSchemaPayload = {
  __typename?: 'CreateOneConcernAreaSchemaPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ConcernAreaSchema>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneGayaFormInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  formType?: InputMaybe<EnumGayaFormFormType>;
  name: Scalars['String'];
  published?: InputMaybe<Scalars['Boolean']>;
  schema: Scalars['JSON'];
  theme?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
  version?: InputMaybe<Scalars['Float']>;
};

export type CreateOneGayaFormPayload = {
  __typename?: 'CreateOneGayaFormPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<GayaForm>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneGayaThemeInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  name: Scalars['String'];
  published?: InputMaybe<Scalars['Boolean']>;
  theme: Scalars['JSON'];
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type CreateOneGayaThemePayload = {
  __typename?: 'CreateOneGayaThemePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<GayaTheme>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneIncidentGroupInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  flowId?: InputMaybe<Scalars['MongoID']>;
  incidentId?: InputMaybe<Scalars['MongoID']>;
  isTemplate?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<IncidentGroupMetadataInput>;
  name: Scalars['String'];
  order: Scalars['Float'];
  rules?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type CreateOneIncidentInput = {
  batchIds?: InputMaybe<Array<InputMaybe<IncidentBatchIdsInput>>>;
  calculationSize?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  entity?: InputMaybe<EnumIncidentEntity>;
  entityIds?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  fireHydrantUrl?: InputMaybe<Scalars['String']>;
  isCalculating?: InputMaybe<Scalars['Boolean']>;
  isCalculationFailed?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  status?: InputMaybe<EnumIncidentStatus>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type CreateOneIncidentPayload = {
  __typename?: 'CreateOneIncidentPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Incident>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneModuleRoutesInput = {
  module?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type CreateOneModuleRoutesPayload = {
  __typename?: 'CreateOneModuleRoutesPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ModuleRoutes>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneRubricInput = {
  createdBy?: InputMaybe<Scalars['MongoID']>;
  entity?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<Array<InputMaybe<RubricFieldsInput>>>;
  name?: InputMaybe<Scalars['String']>;
  tableCollection?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<EnumRubricType>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type CreateOneRubricPayload = {
  __typename?: 'CreateOneRubricPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Rubric>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneUiFlowInput = {
  blocks: Array<InputMaybe<UiFlowBlocksInput>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  disabledMessage?: InputMaybe<Scalars['String']>;
  lastUpdatedBy?: InputMaybe<Scalars['String']>;
  readingDeletedEntities?: InputMaybe<UiFlowReadingDeletedEntitiesInput>;
  rejectHandler?: InputMaybe<UiFlowRejectHandlerInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  triggers?: InputMaybe<UiFlowTriggersInput>;
  type: Scalars['String'];
  updateComment?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  version?: InputMaybe<Scalars['Float']>;
};

export type CreateOneUiFlowPayload = {
  __typename?: 'CreateOneUIFlowPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<UiFlow>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneWatsonViewInput = {
  createdBy?: InputMaybe<Scalars['MongoID']>;
  entity?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<Array<InputMaybe<WatsonViewFieldsInput>>>;
};

export type CreateOneWatsonViewPayload = {
  __typename?: 'CreateOneWatsonViewPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<WatsonView>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOnerulesInput = {
  conditions?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  decision?: InputMaybe<Scalars['JSON']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  editedVia?: InputMaybe<Scalars['String']>;
  entityType?: InputMaybe<Scalars['String']>;
  labelIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lastEditedBy?: InputMaybe<Scalars['String']>;
  limitations?: InputMaybe<Scalars['JSON']>;
  mos?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  name?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  riskDecisionCodeId?: InputMaybe<Scalars['Int']>;
  ruleId?: InputMaybe<Scalars['Float']>;
  ruleVersion?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  version?: InputMaybe<Scalars['Float']>;
};

export type CreateOnerulesPayload = {
  __typename?: 'CreateOnerulesPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Rules>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOrganizationInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type CreatePartnerInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type CreatePromoCodeInput = {
  campaignId: Scalars['Int'];
  code: Scalars['String'];
  discountPercentage: Scalars['Float'];
  effectiveFrom?: InputMaybe<Scalars['String']>;
  effectiveTo?: InputMaybe<Scalars['String']>;
  externalProductRatePlanChargeId: Scalars['String'];
  externalProductRatePlanId: Scalars['String'];
  initialQuantity?: InputMaybe<Scalars['Int']>;
};

export type CreatePromoCodeResponse = {
  __typename?: 'CreatePromoCodeResponse';
  message?: Maybe<Scalars['String']>;
  promoCode?: Maybe<CreatedPromoCode>;
};

export type CreatedPromoCode = {
  __typename?: 'CreatedPromoCode';
  code?: Maybe<Scalars['String']>;
  discountPercentage?: Maybe<Scalars['Float']>;
  externalProductRatePlanChargeId?: Maybe<Scalars['String']>;
  externalProductRatePlanId?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  zuoraPromoId?: Maybe<Scalars['Int']>;
};

export type Crr = {
  __typename?: 'Crr';
  createdAt?: Maybe<Scalars['String']>;
  crrNumericScore?: Maybe<Scalars['Int']>;
  crrRank?: Maybe<CrrRankEnum>;
  source?: Maybe<CrrSourceEnum>;
};

export type CrrHistory = {
  __typename?: 'CrrHistory';
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  crrNumericScore?: Maybe<Scalars['Int']>;
  crrRank?: Maybe<CrrRankEnum>;
  crrScoreId?: Maybe<Scalars['String']>;
  features?: Maybe<Scalars['JSON']>;
  reason?: Maybe<Scalars['String']>;
  source?: Maybe<CrrSourceEnum>;
};

export enum CrrRankEnum {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

export enum CrrSourceEnum {
  Manual = 'Manual',
  System = 'System'
}

export type CustomerApprovalEvent = {
  __typename?: 'CustomerApprovalEvent';
  actor: Scalars['String'];
  eventDate: Scalars['String'];
  eventDescription: Scalars['String'];
  eventName: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
  result: Scalars['String'];
  shouldHighlight: Scalars['Boolean'];
};

export type CustomerApprovalQueryResponse = {
  __typename?: 'CustomerApprovalQueryResponse';
  events: Array<CustomerApprovalEvent>;
  totalCount: Scalars['Int'];
};

export type DmChange = {
  __typename?: 'DMChange';
  from?: Maybe<DeliveryMethod>;
  to?: Maybe<DeliveryMethod>;
};

export type DmTimeline = {
  __typename?: 'DMTimeline';
  dmChanged?: Maybe<DmChange>;
};

export type Data = {
  __typename?: 'Data';
  isExcluded: Scalars['Boolean'];
};

export type DecisionCodeTc = {
  __typename?: 'DecisionCodeTC';
  decision?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  subcategory?: Maybe<Scalars['String']>;
};

export type DecisionReport = {
  __typename?: 'DecisionReport';
  _id: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  mode: EnumDecisionReportMode;
  ruleDecisions: Array<Maybe<Scalars['JSON']>>;
  selectedStrategy?: Maybe<Strategy>;
  status: EnumDecisionReportStatus;
  strategy: Scalars['MongoID'];
  strategyVersion: Scalars['Float'];
  success: Scalars['Boolean'];
  updatedAt?: Maybe<Scalars['Date']>;
};

/** A connection to a list of items. */
export type DecisionReportConnection = {
  __typename?: 'DecisionReportConnection';
  /** Total object count. */
  count: Scalars['Int'];
  /** Information to aid in pagination. */
  edges: Array<DecisionReportEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type DecisionReportEdge = {
  __typename?: 'DecisionReportEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: DecisionReport;
};

/** List of items with pagination. */
export type DecisionReportPagination = {
  __typename?: 'DecisionReportPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<DecisionReport>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export enum DecisionsTypes {
  Accept = 'Accept',
  Block = 'Block',
  BlockCompliance = 'BlockCompliance',
  BlockRisk = 'BlockRisk',
  Reject = 'Reject',
  Undecided = 'Undecided'
}

export type DeleteResponse = {
  __typename?: 'DeleteResponse';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export enum DeliveryAccountType {
  bank_account = 'bank_account',
  biller_directory = 'biller_directory',
  card = 'card',
  check = 'check',
  international = 'international',
  virtual_card = 'virtual_card',
  wire = 'wire'
}

export type DeliveryMethodDetail = {
  __typename?: 'DeliveryMethodDetail';
  formattedMethod?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDeliverStatusFailed?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
};

export type DeliveryMethodObjectTc = {
  __typename?: 'DeliveryMethodObjectTC';
  accountNumber?: Maybe<Scalars['String']>;
  clusterAppearances?: Maybe<Scalars['Int']>;
  completedPayments?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mcc?: Maybe<Scalars['String']>;
  routingNumber?: Maybe<Scalars['String']>;
  status?: Maybe<VirtualCardStatus>;
  tags?: Maybe<Array<Maybe<BusinessPropertyTag>>>;
  type?: Maybe<DeliveryMethodType>;
};

export enum DeliveryMethodType {
  ACH = 'ACH',
  CARD = 'CARD',
  CHECK = 'CHECK',
  CRYPTO_USD = 'CRYPTO_USD',
  DOMESTIC_WIRE = 'DOMESTIC_WIRE',
  INTERNATIONAL = 'INTERNATIONAL',
  INTERNATIONAL_WIRE = 'INTERNATIONAL_WIRE',
  MANAGED = 'MANAGED',
  PAYPAL_BALANCE = 'PAYPAL_BALANCE',
  RPPS = 'RPPS',
  VIRTUAL = 'VIRTUAL',
  VIRTUAL_CARD = 'VIRTUAL_CARD'
}

export type DeliveryMethodsResponse = {
  __typename?: 'DeliveryMethodsResponse';
  data?: Maybe<Array<Maybe<DeliveryMethod>>>;
  deliveryMethodDetails?: Maybe<Array<Maybe<DeliveryMethodDetail>>>;
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum DescribeEntity {
  CustomField = 'CustomField',
  Ticket = 'Ticket'
}

export enum DescribeOperation {
  CreateOne = 'CreateOne',
  Read = 'Read',
  UpdateOne = 'UpdateOne'
}

export type DeviceConsistencyData = {
  __typename?: 'DeviceConsistencyData';
  agentId?: Maybe<Scalars['String']>;
  browser?: Maybe<Browser>;
  locale?: Maybe<Locale>;
  operatingSystem?: Maybe<OperatingSystem>;
  resolutionSize?: Maybe<ResolutionSize>;
  screenSize?: Maybe<ScreenSize>;
};

export type DeviceConsistencyResponse = {
  __typename?: 'DeviceConsistencyResponse';
  data?: Maybe<DeviceConsistencyData>;
};

export type DirectionSummaryGraphQlType = {
  __typename?: 'DirectionSummaryGraphQlType';
  totalReconciledRecords?: Maybe<Scalars['Float']>;
  totalReconciledSumOfMoney?: Maybe<Scalars['Float']>;
  totalRecords?: Maybe<Scalars['Float']>;
  totalSumOfMoney?: Maybe<Scalars['Float']>;
  totalUnreconciledRecords?: Maybe<Scalars['Float']>;
  totalUnreconciledSumOfMoney?: Maybe<Scalars['Float']>;
};

export type DmLinkingDetails = {
  __typename?: 'DmLinkingDetails';
  /** Whether this delivery method has linking to other DMs */
  hasLinking?: Maybe<Scalars['Boolean']>;
  /** Risk status of the DM linking based on chalk service data */
  linkingStatus?: Maybe<DmLinkingStatus>;
};

export enum DmLinkingStatus {
  BAD = 'BAD',
  GOOD = 'GOOD',
  NO_INDICATION = 'NO_INDICATION'
}

export type DocumentRequest = {
  __typename?: 'DocumentRequest';
  createdBy?: Maybe<Scalars['String']>;
  requiredDocs: Array<Maybe<Scalars['String']>>;
};

export type Edge = {
  __typename?: 'Edge';
  from: Scalars['String'];
  to: Scalars['String'];
};

export type EmailObjectTc = {
  __typename?: 'EmailObjectTC';
  address?: Maybe<Scalars['String']>;
  clusterAppearances?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<BusinessPropertyTag>>>;
};

export type EmailProhibitedIndustriesData = {
  __typename?: 'EmailProhibitedIndustriesData';
  domainSuspectedWords: Array<Scalars['String']>;
  nameSuspectedWords: Array<Scalars['String']>;
};

export type EmailType = {
  __typename?: 'EmailType';
  address?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<BusinessPropertyTag>>>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export enum EngineEntities {
  Organization = 'Organization'
}

export type EngineExecution = {
  __typename?: 'EngineExecution';
  decision?: Maybe<DecisionsTypes>;
  engineType: EnginesType;
  entityId: Scalars['Int'];
  entityType: EngineEntities;
  executionUuid: Scalars['String'];
  featuresResult: Scalars['SequelizeJSON'];
  gitRevision: Scalars['String'];
  id: Scalars['Int'];
  modelVersion: Scalars['String'];
  rulesResult: Scalars['SequelizeJSON'];
  trigger: Scalars['String'];
};

export enum EnginesType {
  Organization = 'Organization'
}

export enum Entity {
  Bill = 'Bill',
  DeliveryMethod = 'DeliveryMethod',
  FundingSource = 'FundingSource',
  Ip = 'Ip',
  Oki = 'Oki',
  Organization = 'Organization',
  Payment = 'Payment',
  User = 'User',
  Vendor = 'Vendor'
}

export type EntityActionConfig = {
  __typename?: 'EntityActionConfig';
  actionKey: Scalars['String'];
  actionType: Scalars['String'];
  eligible: Scalars['Boolean'];
  nonEligibleReason?: Maybe<Scalars['String']>;
};

export type EntityFilterInput = {
  entity?: InputMaybe<Entity>;
  entityId: Scalars['String'];
};

export type EntityTag = {
  __typename?: 'EntityTag';
  entity: Scalars['String'];
  entityId: Scalars['String'];
  id: Scalars['String'];
  propertyName?: Maybe<Scalars['String']>;
  tag?: Maybe<PartialTag>;
};

export type EntityTags = {
  __typename?: 'EntityTags';
  entity?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Tags>>>;
};

export enum EntityType {
  organization = 'organization',
  payment = 'payment'
}

export enum EnumActionLogEntity {
  ach = 'ach',
  adjustment = 'adjustment',
  atoAutomationCase = 'atoAutomationCase',
  businessVerificationTask = 'businessVerificationTask',
  card = 'card',
  chargeback = 'chargeback',
  check = 'check',
  deliveryMethod = 'deliveryMethod',
  escalation = 'escalation',
  featureStrategy = 'featureStrategy',
  fraudReferralCase = 'fraudReferralCase',
  fundingSource = 'fundingSource',
  ip = 'ip',
  melioDbCase = 'melioDbCase',
  oki = 'oki',
  organization = 'organization',
  partner = 'partner',
  payeeIp = 'payeeIp',
  payment = 'payment',
  paymentIp = 'paymentIp',
  payorIp = 'payorIp',
  project = 'project',
  promoCode = 'promoCode',
  rejectCheck = 'rejectCheck',
  strategyRule = 'strategyRule',
  tagDefinition = 'tagDefinition',
  task = 'task',
  ubo = 'ubo',
  unclassified = 'unclassified',
  updateIp = 'updateIp',
  user = 'user',
  vendor = 'vendor',
  virtualCardAccount = 'virtualCardAccount'
}

export enum EnumActionLogResult {
  failure = 'failure',
  success = 'success'
}

export enum EnumBusyEntityCachedDataFcbStatus {
  NotSure = 'NotSure',
  PartOfLargerOrganization = 'PartOfLargerOrganization',
  StandaloneBusiness = 'StandaloneBusiness'
}

export enum EnumBusyEntityCachedDataOrigin {
  ar_erp_form = 'ar_erp_form',
  existing_get_paid_vendor = 'existing_get_paid_vendor',
  public_form = 'public_form',
  sales_form = 'sales_form',
  sales_get_paid_wizard = 'sales_get_paid_wizard',
  unilateral_and_enrollment = 'unilateral_and_enrollment'
}

export enum EnumBusyEntityCachedDataRejectionReason {
  Branch = 'Branch',
  Conglomerate = 'Conglomerate',
  DoubleMsnSubmission = 'DoubleMsnSubmission',
  Franchise = 'Franchise',
  Fraud = 'Fraud',
  InsufficientData = 'InsufficientData',
  Not_a_business = 'Not_a_business',
  ProhibitedIndustry = 'ProhibitedIndustry',
  RejectedByAutomation = 'RejectedByAutomation',
  TechnicalIssue = 'TechnicalIssue',
  UnauthorizedOperator = 'UnauthorizedOperator',
  UserRequest = 'UserRequest'
}

export enum EnumBusyEntityCachedDataSourceType {
  IntuitVcBusinessSubmissionForm = 'IntuitVcBusinessSubmissionForm',
  JpmVcBusinessFileUpload = 'JpmVcBusinessFileUpload',
  MSN = 'MSN',
  MSNGetPaidOrganizationFileUpload = 'MSNGetPaidOrganizationFileUpload',
  StrategicSegmentsFile = 'StrategicSegmentsFile',
  UnlinkBusinessMatch = 'UnlinkBusinessMatch',
  VcBusinessSubmissionForm = 'VcBusinessSubmissionForm'
}

export enum EnumBusyEntityCachedDataTaskType {
  OptIn = 'OptIn'
}

export enum EnumBusyUnmatchTaskEntityCachedDataDecision {
  Match = 'Match',
  PermanentUnmatch = 'PermanentUnmatch',
  Unmatch = 'Unmatch'
}

export enum EnumBusyUnmatchTaskEntityCachedDataMatchCreationSource {
  Manual = 'Manual',
  Matcher = 'Matcher',
  Payor = 'Payor',
  SelfProclaimed = 'SelfProclaimed'
}

export enum EnumBusyUnmatchTaskEntityCachedDataSourceType {
  IntuitVcBusinessSubmissionForm = 'IntuitVcBusinessSubmissionForm',
  JpmVcBusinessFileUpload = 'JpmVcBusinessFileUpload',
  MSN = 'MSN',
  MSNGetPaidOrganizationFileUpload = 'MSNGetPaidOrganizationFileUpload',
  StrategicSegmentsFile = 'StrategicSegmentsFile',
  UnlinkBusinessMatch = 'UnlinkBusinessMatch',
  VcBusinessSubmissionForm = 'VcBusinessSubmissionForm'
}

export enum EnumBusyUnmatchTaskEntityCachedDataUnmatchReason {
  DifferentDM = 'DifferentDM',
  DifferentFinancialEntity = 'DifferentFinancialEntity',
  DifferentSupplier = 'DifferentSupplier',
  FraudulentVendor = 'FraudulentVendor',
  InsufficientData = 'InsufficientData'
}

export enum EnumConcernAreaSchemaStatus {
  deprecated = 'deprecated',
  live = 'live'
}

export enum EnumDecisionReportMode {
  live = 'live',
  shadow = 'shadow'
}

export enum EnumDecisionReportStatus {
  failed = 'failed',
  succeeded = 'succeeded'
}

export enum EnumFlowExecutionCurrentStepStatus {
  failed = 'failed',
  rejected = 'rejected',
  succeeded = 'succeeded',
  waiting = 'waiting'
}

export enum EnumFlowExecutionMode {
  live = 'live',
  shadow = 'shadow'
}

export enum EnumFlowExecutionPassedStepsStatus {
  failed = 'failed',
  rejected = 'rejected',
  succeeded = 'succeeded',
  waiting = 'waiting'
}

export enum EnumFlowExecutionState {
  exited = 'exited',
  initial = 'initial',
  running = 'running',
  waiting = 'waiting'
}

export enum EnumFlowExecutionStatus {
  failed = 'failed',
  rejected = 'rejected',
  succeeded = 'succeeded'
}

export enum EnumGayaFormFormType {
  external = 'external',
  internal = 'internal'
}

export enum EnumGayaFormResponseFormType {
  external = 'external',
  internal = 'internal'
}

export enum EnumGenericTaskStatus {
  approved = 'approved',
  canceled = 'canceled',
  completed = 'completed',
  escalated = 'escalated',
  inProgress = 'inProgress',
  isNotLive = 'isNotLive',
  open = 'open',
  pending = 'pending',
  read = 'read',
  rejected = 'rejected',
  unread = 'unread'
}

export enum EnumGenericTaskType {
  busy = 'busy',
  busyUnmatchTask = 'busyUnmatchTask',
  luci = 'luci',
  recoAch = 'recoAch',
  recoCard = 'recoCard',
  recoCheck = 'recoCheck',
  sherlockDecisionTagging = 'sherlockDecisionTagging',
  sherlockEscalation = 'sherlockEscalation',
  sherlockOrganization = 'sherlockOrganization',
  sherlockOrganizationEscalation = 'sherlockOrganizationEscalation'
}

export enum EnumGroupEntityField {
  accountNumber = 'accountNumber',
  note = 'note',
  taxId = 'taxId'
}

export enum EnumGroupEntityType {
  Note = 'Note',
  PII = 'PII',
  TaxId = 'TaxId'
}

export enum EnumIncidentBatchIdsMode {
  live = 'live',
  shadow = 'shadow'
}

export enum EnumIncidentEntity {
  organization = 'organization',
  payment = 'payment',
  user = 'user'
}

export enum EnumIncidentExecutionLogEntity {
  organization = 'organization',
  payment = 'payment',
  user = 'user'
}

export enum EnumIncidentStatus {
  close = 'close',
  open = 'open',
  processing = 'processing'
}

export enum EnumLabelType {
  organization = 'organization',
  payment = 'payment'
}

export enum EnumLogActionType {
  actionExecuted = 'actionExecuted',
  concernAreaAssigned = 'concernAreaAssigned',
  concernAreaClaimed = 'concernAreaClaimed',
  concernAreaDecisionMade = 'concernAreaDecisionMade',
  concernAreaOverturned = 'concernAreaOverturned',
  concernAreaRerun = 'concernAreaRerun',
  concernAreaUnassigned = 'concernAreaUnassigned',
  escalatedExternally = 'escalatedExternally',
  singleViewInFocus = 'singleViewInFocus',
  singleViewUnfocused = 'singleViewUnfocused',
  statusChanged = 'statusChanged',
  taskAssigned = 'taskAssigned',
  taskCompleted = 'taskCompleted',
  taskCreated = 'taskCreated',
  taskUnassigned = 'taskUnassigned',
  taskUpdated = 'taskUpdated',
  userAFK = 'userAFK'
}

export enum EnumLogSource {
  forest = 'forest',
  ruleEngine = 'ruleEngine',
  sherlock = 'sherlock',
  taskEngine = 'taskEngine'
}

export enum EnumLuciEntityCachedDataChargebackAccount {
  Evolve_2586_DDA = 'Evolve_2586_DDA',
  Evolve_2587_FBO = 'Evolve_2587_FBO',
  SVB_3639_FBO = 'SVB_3639_FBO',
  SVB_3643_FBO = 'SVB_3643_FBO',
  SVB_8361_DDA = 'SVB_8361_DDA'
}

export enum EnumLuciEntityCachedDataCreatorOrigin {
  justt_api = 'justt_api',
  manual = 'manual',
  system = 'system'
}

export enum EnumLuciEntityCachedDataEntity {
  chargeback = 'chargeback',
  meliodbcase = 'meliodbcase'
}

export enum EnumLuciEntityCachedDataHighLevelClaim {
  fraud = 'fraud',
  processing = 'processing',
  service = 'service'
}

export enum EnumLuciEntityCachedDataNoDisputeReason {
  hold_funds = 'hold_funds',
  other = 'other',
  real_fraud = 'real_fraud',
  refund_promised = 'refund_promised',
  removed = 'removed'
}

export enum EnumLuciEntityCachedDataReason {
  abuse = 'abuse',
  ato = 'ato',
  check_dm_policy_issue = 'check_dm_policy_issue',
  delinquent_refund = 'delinquent_refund',
  expedited_payment = 'expedited_payment',
  external_service_issue = 'external_service_issue',
  fee_for_failed_payment = 'fee_for_failed_payment',
  friendly_fraud = 'friendly_fraud',
  good_user___inexplainable = 'good_user___inexplainable',
  goods_service_not_rendered = 'goods_service_not_rendered',
  internal_issue = 'internal_issue',
  not_as_described_defective = 'not_as_described_defective',
  other = 'other',
  p2d_fraud = 'p2d_fraud',
  real_fraud = 'real_fraud',
  reverse_phishing = 'reverse_phishing',
  sf = 'sf',
  unilateral_fraud = 'unilateral_fraud',
  vendor_side_fraud = 'vendor_side_fraud'
}

export enum EnumLuciEntityCachedDataRecoveryAccount {
  Evolve_2586_DDA = 'Evolve_2586_DDA',
  Evolve_2587_FBO = 'Evolve_2587_FBO',
  SVB_3639_FBO = 'SVB_3639_FBO',
  SVB_3643_FBO = 'SVB_3643_FBO',
  SVB_8361_DDA = 'SVB_8361_DDA'
}

export enum EnumLuciEntityCachedDataRecoveryMethod {
  ach_reversal = 'ach_reversal',
  affidavit = 'affidavit',
  affidavit_pending_bank_response = 'affidavit_pending_bank_response',
  affidavit_pending_payee = 'affidavit_pending_payee',
  affidavit_prepared___pending_notarization = 'affidavit_prepared___pending_notarization',
  cb_dispute = 'cb_dispute',
  dispute = 'dispute',
  disputing_not_via_justt = 'disputing_not_via_justt',
  handoff_to_ck = 'handoff_to_ck',
  international_recall = 'international_recall',
  legal_action = 'legal_action',
  loi = 'loi',
  other = 'other',
  recollect = 'recollect',
  recovered_from_the_vendor = 'recovered_from_the_vendor',
  removal_request = 'removal_request',
  second_cb_dispute = 'second_cb_dispute',
  tabapay_reversal = 'tabapay_reversal'
}

export enum EnumLuciEntityCachedDataScenario {
  arbitration = 'arbitration',
  cb = 'cb',
  external_loss = 'external_loss',
  inquiry = 'inquiry',
  other = 'other',
  partner_loss = 'partner_loss',
  poa = 'poa',
  potential_loss = 'potential_loss',
  pre_arbitration = 'pre_arbitration',
  reimbursement = 'reimbursement',
  second_chargeback = 'second_chargeback',
  uncollected_fees = 'uncollected_fees',
  uncollected_funds = 'uncollected_funds'
}

export enum EnumLuciEntityCachedDataSource {
  fee = 'fee',
  payment = 'payment',
  subscription_fee = 'subscription_fee'
}

export enum EnumLuciEntityCachedDataStatus {
  lost = 'lost',
  partner_loss = 'partner_loss',
  potential_loss = 'potential_loss',
  recovered = 'recovered',
  resolved_potential_loss = 'resolved_potential_loss'
}

export enum EnumLuciEntityCachedDataSubStatus {
  attempting_recovery = 'attempting_recovery',
  false_positive = 'false_positive',
  final = 'final',
  inquiry_lost = 'inquiry_lost',
  inquiry_responded = 'inquiry_responded',
  inquiry_won = 'inquiry_won',
  loss_reviewed = 'loss_reviewed',
  melio_has_funds = 'melio_has_funds',
  not_fighting = 'not_fighting',
  not_final = 'not_final',
  other = 'other',
  poa_answered = 'poa_answered',
  recovery_failed = 'recovery_failed',
  recovery_successful = 'recovery_successful',
  removed_by_payor = 'removed_by_payor',
  tbd = 'tbd'
}

export enum EnumProjectFieldsToHide {
  PaymentRiskStatus = 'PaymentRiskStatus'
}

export enum EnumProjectStatus {
  Archived = 'Archived',
  Open = 'Open'
}

export enum EnumRubricFieldsDisplayType {
  amount = 'amount',
  boolean = 'boolean',
  date = 'date',
  link = 'link',
  number = 'number',
  tag = 'tag',
  text = 'text'
}

export enum EnumRubricType {
  regular = 'regular',
  table = 'table'
}

export enum EnumSherlockDecisionTaggingEntityCachedDataDeliveryMethodDeliveryType {
  ach = 'ach',
  card = 'card',
  check = 'check',
  crypto_usd = 'crypto_usd',
  domestic_wire = 'domestic_wire',
  international = 'international',
  international_wire = 'international_wire',
  managed = 'managed',
  paypal_balance = 'paypal_balance',
  rpps = 'rpps',
  virtual = 'virtual',
  virtual_card = 'virtual_card'
}

export enum EnumSherlockDecisionTaggingEntityCachedDataDeliveryMethodVerifiedStatus {
  micro_deposit_verified = 'micro_deposit_verified',
  not_verified = 'not_verified',
  plaid_verified = 'plaid_verified',
  soft_verified = 'soft_verified'
}

export enum EnumSherlockDecisionTaggingEntityCachedDataFundingSourceOrigin {
  carat = 'carat',
  card = 'card',
  manual = 'manual',
  micro = 'micro',
  partner = 'partner',
  plaid = 'plaid',
  qbcash = 'qbcash',
  taba_pay = 'taba_pay'
}

export enum EnumSherlockDecisionTaggingEntityCachedDataOrganizationDecision {
  NULL = 'NULL',
  accept = 'accept',
  block = 'block',
  blockCompliance = 'blockCompliance',
  blockRisk = 'blockRisk',
  reject = 'reject',
  undecided = 'undecided'
}

export enum EnumSherlockDecisionTaggingEntityCachedDataOrganizationKybMoneyIn {
  NULL = 'NULL',
  accept = 'accept',
  approveAll = 'approveAll',
  policy = 'policy',
  reject = 'reject',
  undecided = 'undecided'
}

export enum EnumSherlockDecisionTaggingEntityCachedDataOrganizationKybMoneyInSubType {
  NULL = 'NULL',
  abuse = 'abuse',
  became_abusive = 'became_abusive',
  compromised = 'compromised',
  consumer = 'consumer',
  duplicate = 'duplicate',
  finalised_money_loss = 'finalised_money_loss',
  fraud = 'fraud',
  inaccurate_legal_info = 'inaccurate_legal_info',
  loss_risk = 'loss_risk',
  other = 'other',
  prohibited_LOB = 'prohibited_LOB',
  reinstated = 'reinstated',
  sensitive = 'sensitive',
  standard = 'standard',
  tentative = 'tentative',
  unresponsive_user = 'unresponsive_user'
}

export enum EnumSherlockDecisionTaggingEntityCachedDataOrganizationTaxIdType {
  EIN = 'EIN',
  ITIN = 'ITIN',
  NULL = 'NULL',
  SSN = 'SSN'
}

export enum EnumSherlockDecisionTaggingEntityCachedDataPaymentCreateOrigin {
  accounts_payable_platform = 'accounts_payable_platform',
  ar_invoice = 'ar_invoice',
  ar_link = 'ar_link',
  built_partnership = 'built_partnership',
  merchant_checkout = 'merchant_checkout',
  native_android = 'native_android',
  native_ios = 'native_ios',
  native_sdk_android = 'native_sdk_android',
  native_sdk_ios = 'native_sdk_ios',
  pay = 'pay',
  qbdt_integration = 'qbdt_integration',
  qbdt_mac = 'qbdt_mac',
  qbdt_windows = 'qbdt_windows',
  qbm_android = 'qbm_android',
  qbm_integration = 'qbm_integration',
  qbm_ios = 'qbm_ios',
  qbo_integration = 'qbo_integration',
  qbr_android = 'qbr_android',
  qbr_integration = 'qbr_integration',
  qbr_ios = 'qbr_ios',
  request = 'request'
}

export enum EnumSherlockDecisionTaggingEntityCachedDataPaymentDirection {
  AP = 'AP',
  AR = 'AR'
}

export enum EnumSherlockDecisionTaggingEntityCachedDataPaymentRiskStatus {
  approved = 'approved',
  declined = 'declined',
  pending = 'pending'
}

export enum EnumSherlockEscalationEntityCachedDataEscalatedToType {
  Group = 'Group',
  Single = 'Single'
}

export enum EnumSherlockEscalationEntityCachedDataOrganizationDecision {
  NULL = 'NULL',
  accept = 'accept',
  block = 'block',
  blockCompliance = 'blockCompliance',
  blockRisk = 'blockRisk',
  reject = 'reject',
  undecided = 'undecided'
}

export enum EnumSherlockEscalationEntityCachedDataRelatedTaskInboxType {
  busy = 'busy',
  busyUnmatchTask = 'busyUnmatchTask',
  luci = 'luci',
  recoAch = 'recoAch',
  recoCard = 'recoCard',
  recoCheck = 'recoCheck',
  sherlockDecisionTagging = 'sherlockDecisionTagging',
  sherlockEscalation = 'sherlockEscalation',
  sherlockOrganization = 'sherlockOrganization',
  sherlockOrganizationEscalation = 'sherlockOrganizationEscalation'
}

export enum EnumSherlockOrganizationEntityCachedDataCrrRank {
  high = 'high',
  low = 'low',
  medium = 'medium'
}

export enum EnumSherlockOrganizationEntityCachedDataOdeMoneyInDecision {
  accept = 'accept',
  block = 'block',
  blockCompliance = 'blockCompliance',
  blockRisk = 'blockRisk',
  reject = 'reject',
  undecided = 'undecided'
}

export enum EnumSherlockOrganizationEntityCachedDataOdeMoneyOutDecision {
  accept = 'accept',
  block = 'block',
  blockCompliance = 'blockCompliance',
  blockRisk = 'blockRisk',
  reject = 'reject',
  undecided = 'undecided'
}

export enum EnumSherlockOrganizationEntityCachedDataOrigin {
  accounts_payable_platform = 'accounts_payable_platform',
  add_company = 'add_company',
  built_partnership = 'built_partnership',
  erp_vendor_onboarding = 'erp_vendor_onboarding',
  guest = 'guest',
  merchant_checkout = 'merchant_checkout',
  msn_portal = 'msn_portal',
  native_android = 'native_android',
  native_ios = 'native_ios',
  native_sdk_android = 'native_sdk_android',
  native_sdk_ios = 'native_sdk_ios',
  push_to_debit = 'push_to_debit',
  qbdt_integration = 'qbdt_integration',
  qbdt_mac = 'qbdt_mac',
  qbdt_windows = 'qbdt_windows',
  qbm_android = 'qbm_android',
  qbm_integration = 'qbm_integration',
  qbm_ios = 'qbm_ios',
  qbo_integration = 'qbo_integration',
  qbr_android = 'qbr_android',
  qbr_integration = 'qbr_integration',
  qbr_ios = 'qbr_ios',
  syngency_integration = 'syngency_integration',
  unilateral_request = 'unilateral_request',
  user_signup = 'user_signup'
}

export enum EnumSherlockOrganizationEntityCachedDataTaxIdType {
  EIN = 'EIN',
  ITIN = 'ITIN',
  NULL = 'NULL',
  SSN = 'SSN'
}

export enum EnumSherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentPriority {
  high = 'high',
  low = 'low',
  normal = 'normal',
  urgent = 'urgent'
}

export enum EnumSherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentStatus {
  closed = 'closed',
  hold = 'hold',
  new = 'new',
  open = 'open',
  pending = 'pending',
  solved = 'solved'
}

export enum EnumSherlockOrganizationTaskEntityCachedDataCrrRank {
  high = 'high',
  low = 'low',
  medium = 'medium'
}

export enum EnumSherlockOrganizationTaskEntityCachedDataOdeMoneyInDecision {
  accept = 'accept',
  block = 'block',
  blockCompliance = 'blockCompliance',
  blockRisk = 'blockRisk',
  reject = 'reject',
  undecided = 'undecided'
}

export enum EnumSherlockOrganizationTaskEntityCachedDataOdeMoneyOutDecision {
  accept = 'accept',
  block = 'block',
  blockCompliance = 'blockCompliance',
  blockRisk = 'blockRisk',
  reject = 'reject',
  undecided = 'undecided'
}

export enum EnumSherlockOrganizationTaskEntityCachedDataOrigin {
  accounts_payable_platform = 'accounts_payable_platform',
  add_company = 'add_company',
  built_partnership = 'built_partnership',
  erp_vendor_onboarding = 'erp_vendor_onboarding',
  guest = 'guest',
  merchant_checkout = 'merchant_checkout',
  msn_portal = 'msn_portal',
  native_android = 'native_android',
  native_ios = 'native_ios',
  native_sdk_android = 'native_sdk_android',
  native_sdk_ios = 'native_sdk_ios',
  push_to_debit = 'push_to_debit',
  qbdt_integration = 'qbdt_integration',
  qbdt_mac = 'qbdt_mac',
  qbdt_windows = 'qbdt_windows',
  qbm_android = 'qbm_android',
  qbm_integration = 'qbm_integration',
  qbm_ios = 'qbm_ios',
  qbo_integration = 'qbo_integration',
  qbr_android = 'qbr_android',
  qbr_integration = 'qbr_integration',
  qbr_ios = 'qbr_ios',
  syngency_integration = 'syngency_integration',
  unilateral_request = 'unilateral_request',
  user_signup = 'user_signup'
}

export enum EnumSherlockOrganizationTaskEntityCachedDataTaxIdType {
  EIN = 'EIN',
  ITIN = 'ITIN',
  NULL = 'NULL',
  SSN = 'SSN'
}

export enum EnumSherlockOrganizationTaskEntityCachedDataZendeskTicketsLatestCommentPriority {
  high = 'high',
  low = 'low',
  normal = 'normal',
  urgent = 'urgent'
}

export enum EnumSherlockOrganizationTaskEntityCachedDataZendeskTicketsLatestCommentStatus {
  closed = 'closed',
  hold = 'hold',
  new = 'new',
  open = 'open',
  pending = 'pending',
  solved = 'solved'
}

export enum EnumSherlockOrganizationTaskStatus {
  approved = 'approved',
  canceled = 'canceled',
  completed = 'completed',
  escalated = 'escalated',
  inProgress = 'inProgress',
  isNotLive = 'isNotLive',
  open = 'open',
  pending = 'pending',
  read = 'read',
  rejected = 'rejected',
  unread = 'unread'
}

export enum EnumSherlockOrganizationTaskType {
  busy = 'busy',
  busyUnmatchTask = 'busyUnmatchTask',
  luci = 'luci',
  recoAch = 'recoAch',
  recoCard = 'recoCard',
  recoCheck = 'recoCheck',
  sherlockDecisionTagging = 'sherlockDecisionTagging',
  sherlockEscalation = 'sherlockEscalation',
  sherlockOrganization = 'sherlockOrganization',
  sherlockOrganizationEscalation = 'sherlockOrganizationEscalation'
}

export enum EnumTaskConcernAreasDecision {
  approved = 'approved',
  declined = 'declined',
  escalated = 'escalated',
  pending = 'pending'
}

export enum EnumTaskConcernAreasLastDecisionDetailsType {
  system = 'system',
  user = 'user'
}

export enum EnumTaskConcernAreasPrevDecision {
  approved = 'approved',
  declined = 'declined',
  escalated = 'escalated',
  pending = 'pending'
}

export enum EnumTaskConcernAreasStatus {
  closed = 'closed',
  completed = 'completed',
  deleted = 'deleted',
  open = 'open'
}

export enum EnumTaskEntityCachedDataOrganizationDecision {
  NULL = 'NULL',
  accept = 'accept',
  block = 'block',
  blockCompliance = 'blockCompliance',
  blockRisk = 'blockRisk',
  reject = 'reject',
  undecided = 'undecided'
}

export enum EnumTaskEntityCachedDataOrganizationKybMoneyIn {
  NULL = 'NULL',
  accept = 'accept',
  approveAll = 'approveAll',
  policy = 'policy',
  reject = 'reject',
  undecided = 'undecided'
}

export enum EnumTaskEntityCachedDataOrganizationKybMoneyInSubType {
  NULL = 'NULL',
  abuse = 'abuse',
  became_abusive = 'became_abusive',
  compromised = 'compromised',
  consumer = 'consumer',
  duplicate = 'duplicate',
  finalised_money_loss = 'finalised_money_loss',
  fraud = 'fraud',
  inaccurate_legal_info = 'inaccurate_legal_info',
  loss_risk = 'loss_risk',
  other = 'other',
  prohibited_LOB = 'prohibited_LOB',
  reinstated = 'reinstated',
  sensitive = 'sensitive',
  standard = 'standard',
  tentative = 'tentative',
  unresponsive_user = 'unresponsive_user'
}

export enum EnumTaskEntityCachedDataOrganizationTaxIdType {
  EIN = 'EIN',
  ITIN = 'ITIN',
  NULL = 'NULL',
  SSN = 'SSN'
}

export enum EnumTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentPriority {
  high = 'high',
  low = 'low',
  normal = 'normal',
  urgent = 'urgent'
}

export enum EnumTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentStatus {
  closed = 'closed',
  hold = 'hold',
  new = 'new',
  open = 'open',
  pending = 'pending',
  solved = 'solved'
}

export enum EnumTaskEntityCachedDataPaymentCreateOrigin {
  accounts = 'accounts',
  ar = 'ar',
  built = 'built',
  merchant = 'merchant',
  native = 'native',
  pay = 'pay',
  qbdt = 'qbdt',
  qbm = 'qbm',
  qbo = 'qbo',
  qbr = 'qbr',
  request = 'request'
}

export enum EnumTaskEntityCachedDataPaymentDeliveryPreference {
  NULL = 'NULL',
  draft_check = 'draft_check',
  expedited_ach = 'expedited_ach',
  express_card = 'express_card',
  express_check = 'express_check',
  express_domestic_wire = 'express_domestic_wire',
  fast_international = 'fast_international',
  fast_vc = 'fast_vc',
  internal_express_check = 'internal_express_check',
  overnight_ach = 'overnight_ach',
  overnight_check = 'overnight_check',
  rtp = 'rtp'
}

export enum EnumTaskEntityCachedDataPaymentDirection {
  AP = 'AP',
  AR = 'AR'
}

export enum EnumTaskEntityCachedDataPaymentRiskStatus {
  approved = 'approved',
  declined = 'declined',
  pending = 'pending'
}

export enum EnumTaskStatus {
  approved = 'approved',
  canceled = 'canceled',
  completed = 'completed',
  escalated = 'escalated',
  inProgress = 'inProgress',
  isNotLive = 'isNotLive',
  open = 'open',
  pending = 'pending',
  read = 'read',
  rejected = 'rejected',
  unread = 'unread'
}

export enum EnumTeamIntegrationType {
  escalate_busy_task = 'escalate_busy_task',
  escalated = 'escalated'
}

export enum EnumUiFlowBlocksFlowStatus {
  NULL = 'NULL',
  failed = 'failed',
  succeeded = 'succeeded'
}

export enum EnumUiFlowBlocksPortsAlignment {
  bottom = 'bottom',
  left = 'left',
  right = 'right',
  top = 'top'
}

export enum EnumUiFlowBlocksType {
  action = 'action',
  entry = 'entry',
  exit = 'exit',
  flow = 'flow',
  logic = 'logic',
  pass = 'pass',
  wait = 'wait'
}

export enum EnumUiFlowBlocksWaitInterval {
  business_day = 'business_day',
  day = 'day',
  hour = 'hour'
}

export enum EnumWatsonViewFieldsDisplayType {
  amount = 'amount',
  boolean = 'boolean',
  date = 'date',
  link = 'link',
  number = 'number',
  tag = 'tag',
  text = 'text'
}

export enum EnumsherlockUserStatus {
  approved = 'approved',
  declined = 'declined',
  invited = 'invited',
  requested = 'requested'
}

export type ErrorInterface = {
  /** Generic error message */
  message?: Maybe<Scalars['String']>;
};

export type EscalatedTo = {
  __typename?: 'EscalatedTo';
  id: Scalars['String'];
  type?: Maybe<EscalationEntityTypeEnum>;
};

export type EscalationComment = {
  __typename?: 'EscalationComment';
  createdAt: Scalars['Date'];
  name: Scalars['String'];
  note: Scalars['String'];
  picture?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type EscalationDecision = {
  __typename?: 'EscalationDecision';
  escalationId: Scalars['String'];
  organizationName?: Maybe<Scalars['String']>;
};

export type EscalationDescription = {
  __typename?: 'EscalationDescription';
  createdAt: Scalars['Date'];
  note: Scalars['String'];
};

export enum EscalationEntityTypeEnum {
  Group = 'Group',
  Single = 'Single'
}

export type EventExtraDataInput = {
  category?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export enum EventType {
  DrawerOpenEvent = 'DrawerOpenEvent',
  PageLoadEvent = 'PageLoadEvent',
  UserLoginEvent = 'UserLoginEvent'
}

export type Expense = {
  __typename?: 'Expense';
  amount: Scalars['Float'];
  cardBrand: Scalars['String'];
  cardId: Scalars['String'];
  cardLast4: Scalars['String'];
  cardholderName?: Maybe<Scalars['String']>;
  currency: Scalars['String'];
  date?: Maybe<Scalars['DateTime']>;
  fileId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  memo?: Maybe<Scalars['String']>;
  merchant: Scalars['String'];
  receiptStatus: ExpenseReceiptStatus;
  receiptUrl?: Maybe<Scalars['String']>;
  stage: ExpenseStage;
  syncStatus: ExpenseSyncStatus;
  transactionAmount: Scalars['Float'];
  transactionCurrency: Scalars['String'];
  transactionId: Scalars['String'];
  updatedBy?: Maybe<Scalars['String']>;
  uploadStatus?: Maybe<ExpenseManagementUploadRequestStatus>;
};

export type ExpenseManagementOnboardingStatus = {
  __typename?: 'ExpenseManagementOnboardingStatus';
  isOnboarded: Scalars['Boolean'];
  subaccountId?: Maybe<Scalars['String']>;
};

export type ExpenseManagementPaginationMeta = {
  __typename?: 'ExpenseManagementPaginationMeta';
  limit: Scalars['Int'];
  page: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type ExpenseManagementUploadRequestStatus = {
  __typename?: 'ExpenseManagementUploadRequestStatus';
  fileId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  uploadStatus: ExpenseManagementUploadRequestStatusEnum;
};

export enum ExpenseManagementUploadRequestStatusEnum {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING'
}

export enum ExpenseReceiptStatus {
  attached = 'attached',
  missing = 'missing',
  pending = 'pending',
  waived = 'waived'
}

export enum ExpenseStage {
  needs_review = 'needs_review',
  ready_to_sync = 'ready_to_sync',
  synced = 'synced',
  waiting = 'waiting'
}

export enum ExpenseSyncStatus {
  error = 'error',
  not_synced = 'not_synced',
  pending = 'pending',
  synced = 'synced'
}

export type ExpensesResponse = {
  __typename?: 'ExpensesResponse';
  data: Array<Expense>;
  pagination: ExpenseManagementPaginationMeta;
};

export type FsChange = {
  __typename?: 'FSChange';
  from?: Maybe<FundingSource>;
  to?: Maybe<FundingSource>;
};

export type FsTimeline = {
  __typename?: 'FSTimeline';
  fsChanged?: Maybe<FsChange>;
};

export enum FailFlowEnum {
  Collect = 'Collect',
  Deliver = 'Deliver'
}

export type FailureData = {
  __typename?: 'FailureData';
  failureCode?: Maybe<Scalars['String']>;
  failureReason?: Maybe<FailureReasonTc>;
  failureType?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['JSON']>;
};

export type FailureReasonTc = {
  __typename?: 'FailureReasonTc';
  errorReason?: Maybe<Scalars['String']>;
};

export type FeatureStrategy = {
  __typename?: 'FeatureStrategy';
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['String']>;
  deployedBy?: Maybe<Scalars['String']>;
  entityType?: Maybe<Scalars['String']>;
  fallthroughDecision?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  rules?: Maybe<Array<Maybe<RuleProperties>>>;
  version?: Maybe<Scalars['String']>;
};

export type Fee = {
  __typename?: 'Fee';
  amount?: Maybe<Scalars['Float']>;
  cap?: Maybe<Scalars['Int']>;
  catalogId?: Maybe<Scalars['Int']>;
  feeCatalogId?: Maybe<Scalars['Int']>;
  feeType?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isPercentage?: Maybe<Scalars['Boolean']>;
  min?: Maybe<Scalars['Int']>;
};

export enum FeeActor {
  Payee = 'Payee',
  Payor = 'Payor'
}

export type FeeInput = {
  amount?: InputMaybe<Scalars['Float']>;
  cap?: InputMaybe<Scalars['Int']>;
  catalogId?: InputMaybe<Scalars['Int']>;
  feeType?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isPercentage?: InputMaybe<Scalars['Boolean']>;
  min?: InputMaybe<Scalars['Int']>;
};

export enum FeeLabelKey {
  DmAch = 'DmAch',
  DmBillerDirectory = 'DmBillerDirectory',
  DmCard = 'DmCard',
  DmCheck = 'DmCheck',
  DmCrypto = 'DmCrypto',
  DmDomesticWire = 'DmDomesticWire',
  DmFastAch = 'DmFastAch',
  DmFastCheck = 'DmFastCheck',
  DmFastDomesticWire = 'DmFastDomesticWire',
  DmFastInternational = 'DmFastInternational',
  DmFastInternationalFx = 'DmFastInternationalFx',
  DmInternational = 'DmInternational',
  DmInternationalFx = 'DmInternationalFx',
  DmInternationalWire = 'DmInternationalWire',
  DmOvernightCheck = 'DmOvernightCheck',
  DmRtp = 'DmRtp',
  DmUnilateral = 'DmUnilateral',
  DmUnilateralInternational = 'DmUnilateralInternational',
  DmUnilateralInternationalFx = 'DmUnilateralInternationalFx',
  FsCard = 'FsCard',
  Refund = 'Refund'
}

export enum FeeRefundReason {
  BugPreventingSubscriptionManagementRefund = 'BugPreventingSubscriptionManagementRefund',
  CustomerSatisfactionReimbursement = 'CustomerSatisfactionReimbursement',
  DelayedPaymentReimbursement = 'DelayedPaymentReimbursement',
  ExternalFeeReimbursement = 'ExternalFeeReimbursement',
  OrgRejectedBlockedReimbursement = 'OrgRejectedBlockedReimbursement',
  PaymentNotDeliveredDueToMelioErrorRefund = 'PaymentNotDeliveredDueToMelioErrorRefund',
  SubscriptionMelioBillingErrorRefund = 'SubscriptionMelioBillingErrorRefund',
  SubscriptionOther = 'SubscriptionOther',
  SubscriptionUserErrorReimbursement = 'SubscriptionUserErrorReimbursement',
  TransactionalMelioBillingErrorRefund = 'TransactionalMelioBillingErrorRefund',
  TransactionalOther = 'TransactionalOther',
  UserErrorOrMisunderstandingReimbursement = 'UserErrorOrMisunderstandingReimbursement'
}

export enum FeeRefundType {
  SubscriptionFee = 'SubscriptionFee',
  TransactionalFee = 'TransactionalFee'
}

export enum FeedbackDecisionEnum {
  approved = 'approved',
  declined = 'declined'
}

export type FieldSettings = {
  __typename?: 'FieldSettings';
  listValues?: Maybe<Array<Maybe<FilterListValue>>>;
};

export enum FieldToHide {
  PaymentRiskStatus = 'PaymentRiskStatus'
}

export type FileData = {
  __typename?: 'FileData';
  content: Scalars['String'];
  contentType: Scalars['String'];
  fileName: Scalars['String'];
};

export type FilterCountActionInput = {
  AND?: InputMaybe<Array<FilterCountActionInput>>;
  OR?: InputMaybe<Array<FilterCountActionInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountActionOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  module?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountActionOperatorsInput = {
  _id?: InputMaybe<FilterCountAction_IdOperatorsInput>;
};

export type FilterCountAction_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountCardRecordInput = {
  AND?: InputMaybe<Array<FilterCountCardRecordInput>>;
  OR?: InputMaybe<Array<FilterCountCardRecordInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCardRecordOperatorsInput>;
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deliveryMethod?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  recordId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCardRecordOperatorsInput = {
  _id?: InputMaybe<FilterCountCardRecord_IdOperatorsInput>;
};

export type FilterCountCardRecord_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountDecisionReportInput = {
  AND?: InputMaybe<Array<FilterCountDecisionReportInput>>;
  OR?: InputMaybe<Array<FilterCountDecisionReportInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDecisionReportOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  mode?: InputMaybe<EnumDecisionReportMode>;
  ruleDecisions?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  status?: InputMaybe<EnumDecisionReportStatus>;
  strategy?: InputMaybe<Scalars['MongoID']>;
  strategyVersion?: InputMaybe<Scalars['Float']>;
  success?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountDecisionReportOperatorsInput = {
  _id?: InputMaybe<FilterCountDecisionReport_IdOperatorsInput>;
};

export type FilterCountDecisionReport_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountFlowExecutionCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountFlowExecutionCurrentStepCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountFlowExecutionCurrentStepExpiresAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountFlowExecutionCurrentStepFlowExecutionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountFlowExecutionCurrentStepFlowResultOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterCountFlowExecutionCurrentStepIndexOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountFlowExecutionCurrentStepInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  expiresAt?: InputMaybe<Scalars['Date']>;
  flowExecutionId?: InputMaybe<Scalars['MongoID']>;
  flowResult?: InputMaybe<Scalars['JSON']>;
  index?: InputMaybe<Scalars['String']>;
  output?: InputMaybe<FilterCountFlowExecutionCurrentStepOutputInput>;
  status?: InputMaybe<EnumFlowExecutionCurrentStepStatus>;
  strategyDecisionReport?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterCountFlowExecutionCurrentStepOperatorsInput = {
  createdAt?: InputMaybe<FilterCountFlowExecutionCurrentStepCreatedAtOperatorsInput>;
  expiresAt?: InputMaybe<FilterCountFlowExecutionCurrentStepExpiresAtOperatorsInput>;
  flowExecutionId?: InputMaybe<FilterCountFlowExecutionCurrentStepFlowExecutionIdOperatorsInput>;
  flowResult?: InputMaybe<FilterCountFlowExecutionCurrentStepFlowResultOperatorsInput>;
  index?: InputMaybe<FilterCountFlowExecutionCurrentStepIndexOperatorsInput>;
  output?: InputMaybe<FilterCountFlowExecutionCurrentStepOutputOperatorsInput>;
  status?: InputMaybe<FilterCountFlowExecutionCurrentStepStatusOperatorsInput>;
  strategyDecisionReport?: InputMaybe<FilterCountFlowExecutionCurrentStepStrategyDecisionReportOperatorsInput>;
  updatedAt?: InputMaybe<FilterCountFlowExecutionCurrentStepUpdatedAtOperatorsInput>;
};

export type FilterCountFlowExecutionCurrentStepOutputErrorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountFlowExecutionCurrentStepOutputFeeIdsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountFlowExecutionCurrentStepOutputFundingSourceIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountFlowExecutionCurrentStepOutputInput = {
  error?: InputMaybe<Scalars['String']>;
  feeIds?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  fundingSourceId?: InputMaybe<Scalars['Float']>;
  isEligible?: InputMaybe<Scalars['Boolean']>;
  setNumber?: InputMaybe<Scalars['Float']>;
  setString?: InputMaybe<Scalars['String']>;
  zendeskTicketId?: InputMaybe<Scalars['Float']>;
};

export type FilterCountFlowExecutionCurrentStepOutputIsEligibleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountFlowExecutionCurrentStepOutputOperatorsInput = {
  error?: InputMaybe<FilterCountFlowExecutionCurrentStepOutputErrorOperatorsInput>;
  feeIds?: InputMaybe<FilterCountFlowExecutionCurrentStepOutputFeeIdsOperatorsInput>;
  fundingSourceId?: InputMaybe<FilterCountFlowExecutionCurrentStepOutputFundingSourceIdOperatorsInput>;
  isEligible?: InputMaybe<FilterCountFlowExecutionCurrentStepOutputIsEligibleOperatorsInput>;
  setNumber?: InputMaybe<FilterCountFlowExecutionCurrentStepOutputSetNumberOperatorsInput>;
  setString?: InputMaybe<FilterCountFlowExecutionCurrentStepOutputSetStringOperatorsInput>;
  zendeskTicketId?: InputMaybe<FilterCountFlowExecutionCurrentStepOutputZendeskTicketIdOperatorsInput>;
};

export type FilterCountFlowExecutionCurrentStepOutputSetNumberOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountFlowExecutionCurrentStepOutputSetStringOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountFlowExecutionCurrentStepOutputZendeskTicketIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountFlowExecutionCurrentStepStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumFlowExecutionCurrentStepStatus>;
  gte?: InputMaybe<EnumFlowExecutionCurrentStepStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumFlowExecutionCurrentStepStatus>>>;
  lt?: InputMaybe<EnumFlowExecutionCurrentStepStatus>;
  lte?: InputMaybe<EnumFlowExecutionCurrentStepStatus>;
  ne?: InputMaybe<EnumFlowExecutionCurrentStepStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumFlowExecutionCurrentStepStatus>>>;
};

export type FilterCountFlowExecutionCurrentStepStrategyDecisionReportOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountFlowExecutionCurrentStepUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountFlowExecutionDeletedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountFlowExecutionDynamicVariablesFeeIdsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountFlowExecutionDynamicVariablesFundingSourceIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountFlowExecutionDynamicVariablesInput = {
  feeIds?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  fundingSourceId?: InputMaybe<Scalars['Float']>;
  isEligible?: InputMaybe<Scalars['Boolean']>;
  setNumber?: InputMaybe<Scalars['Float']>;
  setString?: InputMaybe<Scalars['String']>;
  zendeskTicketId?: InputMaybe<Scalars['Float']>;
};

export type FilterCountFlowExecutionDynamicVariablesIsEligibleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountFlowExecutionDynamicVariablesOperatorsInput = {
  feeIds?: InputMaybe<FilterCountFlowExecutionDynamicVariablesFeeIdsOperatorsInput>;
  fundingSourceId?: InputMaybe<FilterCountFlowExecutionDynamicVariablesFundingSourceIdOperatorsInput>;
  isEligible?: InputMaybe<FilterCountFlowExecutionDynamicVariablesIsEligibleOperatorsInput>;
  setNumber?: InputMaybe<FilterCountFlowExecutionDynamicVariablesSetNumberOperatorsInput>;
  setString?: InputMaybe<FilterCountFlowExecutionDynamicVariablesSetStringOperatorsInput>;
  zendeskTicketId?: InputMaybe<FilterCountFlowExecutionDynamicVariablesZendeskTicketIdOperatorsInput>;
};

export type FilterCountFlowExecutionDynamicVariablesSetNumberOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountFlowExecutionDynamicVariablesSetStringOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountFlowExecutionDynamicVariablesZendeskTicketIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountFlowExecutionInput = {
  AND?: InputMaybe<Array<FilterCountFlowExecutionInput>>;
  OR?: InputMaybe<Array<FilterCountFlowExecutionInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountFlowExecutionOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  currentStep?: InputMaybe<FilterCountFlowExecutionCurrentStepInput>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  dynamicVariables?: InputMaybe<FilterCountFlowExecutionDynamicVariablesInput>;
  input?: InputMaybe<Scalars['JSON']>;
  mode?: InputMaybe<EnumFlowExecutionMode>;
  output?: InputMaybe<Scalars['String']>;
  parentExecution?: InputMaybe<Scalars['MongoID']>;
  partnerName?: InputMaybe<Scalars['String']>;
  passedSteps?: InputMaybe<Array<InputMaybe<FilterCountFlowExecutionPassedStepsInput>>>;
  result?: InputMaybe<Scalars['JSON']>;
  startedAt?: InputMaybe<Scalars['Date']>;
  state?: InputMaybe<EnumFlowExecutionState>;
  status?: InputMaybe<EnumFlowExecutionStatus>;
  uiFlow?: InputMaybe<Scalars['MongoID']>;
  uiFlowVersion?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterCountFlowExecutionInputOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterCountFlowExecutionModeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumFlowExecutionMode>;
  gte?: InputMaybe<EnumFlowExecutionMode>;
  in?: InputMaybe<Array<InputMaybe<EnumFlowExecutionMode>>>;
  lt?: InputMaybe<EnumFlowExecutionMode>;
  lte?: InputMaybe<EnumFlowExecutionMode>;
  ne?: InputMaybe<EnumFlowExecutionMode>;
  nin?: InputMaybe<Array<InputMaybe<EnumFlowExecutionMode>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountFlowExecutionOperatorsInput = {
  _id?: InputMaybe<FilterCountFlowExecution_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterCountFlowExecutionCreatedAtOperatorsInput>;
  currentStep?: InputMaybe<FilterCountFlowExecutionCurrentStepOperatorsInput>;
  deletedAt?: InputMaybe<FilterCountFlowExecutionDeletedAtOperatorsInput>;
  dynamicVariables?: InputMaybe<FilterCountFlowExecutionDynamicVariablesOperatorsInput>;
  input?: InputMaybe<FilterCountFlowExecutionInputOperatorsInput>;
  mode?: InputMaybe<FilterCountFlowExecutionModeOperatorsInput>;
  output?: InputMaybe<FilterCountFlowExecutionOutputOperatorsInput>;
  parentExecution?: InputMaybe<FilterCountFlowExecutionParentExecutionOperatorsInput>;
  partnerName?: InputMaybe<FilterCountFlowExecutionPartnerNameOperatorsInput>;
  passedSteps?: InputMaybe<FilterCountFlowExecutionPassedStepsOperatorsInput>;
  result?: InputMaybe<FilterCountFlowExecutionResultOperatorsInput>;
  startedAt?: InputMaybe<FilterCountFlowExecutionStartedAtOperatorsInput>;
  state?: InputMaybe<FilterCountFlowExecutionStateOperatorsInput>;
  status?: InputMaybe<FilterCountFlowExecutionStatusOperatorsInput>;
  uiFlow?: InputMaybe<FilterCountFlowExecutionUiFlowOperatorsInput>;
  uiFlowVersion?: InputMaybe<FilterCountFlowExecutionUiFlowVersionOperatorsInput>;
  updatedAt?: InputMaybe<FilterCountFlowExecutionUpdatedAtOperatorsInput>;
};

export type FilterCountFlowExecutionOutputOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountFlowExecutionParentExecutionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountFlowExecutionPartnerNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountFlowExecutionPassedStepsCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountFlowExecutionPassedStepsExpiresAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountFlowExecutionPassedStepsFlowExecutionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountFlowExecutionPassedStepsFlowResultOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterCountFlowExecutionPassedStepsIndexOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountFlowExecutionPassedStepsInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  expiresAt?: InputMaybe<Scalars['Date']>;
  flowExecutionId?: InputMaybe<Scalars['MongoID']>;
  flowResult?: InputMaybe<Scalars['JSON']>;
  index?: InputMaybe<Scalars['String']>;
  output?: InputMaybe<FilterCountFlowExecutionPassedStepsOutputInput>;
  status?: InputMaybe<EnumFlowExecutionPassedStepsStatus>;
  strategyDecisionReport?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterCountFlowExecutionPassedStepsOperatorsInput = {
  createdAt?: InputMaybe<FilterCountFlowExecutionPassedStepsCreatedAtOperatorsInput>;
  expiresAt?: InputMaybe<FilterCountFlowExecutionPassedStepsExpiresAtOperatorsInput>;
  flowExecutionId?: InputMaybe<FilterCountFlowExecutionPassedStepsFlowExecutionIdOperatorsInput>;
  flowResult?: InputMaybe<FilterCountFlowExecutionPassedStepsFlowResultOperatorsInput>;
  index?: InputMaybe<FilterCountFlowExecutionPassedStepsIndexOperatorsInput>;
  output?: InputMaybe<FilterCountFlowExecutionPassedStepsOutputOperatorsInput>;
  status?: InputMaybe<FilterCountFlowExecutionPassedStepsStatusOperatorsInput>;
  strategyDecisionReport?: InputMaybe<FilterCountFlowExecutionPassedStepsStrategyDecisionReportOperatorsInput>;
  updatedAt?: InputMaybe<FilterCountFlowExecutionPassedStepsUpdatedAtOperatorsInput>;
};

export type FilterCountFlowExecutionPassedStepsOutputErrorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountFlowExecutionPassedStepsOutputFeeIdsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountFlowExecutionPassedStepsOutputFundingSourceIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountFlowExecutionPassedStepsOutputInput = {
  error?: InputMaybe<Scalars['String']>;
  feeIds?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  fundingSourceId?: InputMaybe<Scalars['Float']>;
  isEligible?: InputMaybe<Scalars['Boolean']>;
  setNumber?: InputMaybe<Scalars['Float']>;
  setString?: InputMaybe<Scalars['String']>;
  zendeskTicketId?: InputMaybe<Scalars['Float']>;
};

export type FilterCountFlowExecutionPassedStepsOutputIsEligibleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountFlowExecutionPassedStepsOutputOperatorsInput = {
  error?: InputMaybe<FilterCountFlowExecutionPassedStepsOutputErrorOperatorsInput>;
  feeIds?: InputMaybe<FilterCountFlowExecutionPassedStepsOutputFeeIdsOperatorsInput>;
  fundingSourceId?: InputMaybe<FilterCountFlowExecutionPassedStepsOutputFundingSourceIdOperatorsInput>;
  isEligible?: InputMaybe<FilterCountFlowExecutionPassedStepsOutputIsEligibleOperatorsInput>;
  setNumber?: InputMaybe<FilterCountFlowExecutionPassedStepsOutputSetNumberOperatorsInput>;
  setString?: InputMaybe<FilterCountFlowExecutionPassedStepsOutputSetStringOperatorsInput>;
  zendeskTicketId?: InputMaybe<FilterCountFlowExecutionPassedStepsOutputZendeskTicketIdOperatorsInput>;
};

export type FilterCountFlowExecutionPassedStepsOutputSetNumberOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountFlowExecutionPassedStepsOutputSetStringOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountFlowExecutionPassedStepsOutputZendeskTicketIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountFlowExecutionPassedStepsStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumFlowExecutionPassedStepsStatus>;
  gte?: InputMaybe<EnumFlowExecutionPassedStepsStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumFlowExecutionPassedStepsStatus>>>;
  lt?: InputMaybe<EnumFlowExecutionPassedStepsStatus>;
  lte?: InputMaybe<EnumFlowExecutionPassedStepsStatus>;
  ne?: InputMaybe<EnumFlowExecutionPassedStepsStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumFlowExecutionPassedStepsStatus>>>;
};

export type FilterCountFlowExecutionPassedStepsStrategyDecisionReportOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountFlowExecutionPassedStepsUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountFlowExecutionResultOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterCountFlowExecutionStartedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountFlowExecutionStateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumFlowExecutionState>;
  gte?: InputMaybe<EnumFlowExecutionState>;
  in?: InputMaybe<Array<InputMaybe<EnumFlowExecutionState>>>;
  lt?: InputMaybe<EnumFlowExecutionState>;
  lte?: InputMaybe<EnumFlowExecutionState>;
  ne?: InputMaybe<EnumFlowExecutionState>;
  nin?: InputMaybe<Array<InputMaybe<EnumFlowExecutionState>>>;
};

export type FilterCountFlowExecutionStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumFlowExecutionStatus>;
  gte?: InputMaybe<EnumFlowExecutionStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumFlowExecutionStatus>>>;
  lt?: InputMaybe<EnumFlowExecutionStatus>;
  lte?: InputMaybe<EnumFlowExecutionStatus>;
  ne?: InputMaybe<EnumFlowExecutionStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumFlowExecutionStatus>>>;
};

export type FilterCountFlowExecutionUiFlowOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountFlowExecutionUiFlowVersionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountFlowExecutionUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountFlowExecution_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountGayaFormCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountGayaFormCreatedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountGayaFormDeletedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountGayaFormDescriptionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountGayaFormFormTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumGayaFormFormType>;
  gte?: InputMaybe<EnumGayaFormFormType>;
  in?: InputMaybe<Array<InputMaybe<EnumGayaFormFormType>>>;
  lt?: InputMaybe<EnumGayaFormFormType>;
  lte?: InputMaybe<EnumGayaFormFormType>;
  ne?: InputMaybe<EnumGayaFormFormType>;
  nin?: InputMaybe<Array<InputMaybe<EnumGayaFormFormType>>>;
};

export type FilterCountGayaFormInput = {
  AND?: InputMaybe<Array<FilterCountGayaFormInput>>;
  OR?: InputMaybe<Array<FilterCountGayaFormInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountGayaFormOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  formType?: InputMaybe<EnumGayaFormFormType>;
  name?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  schema?: InputMaybe<Scalars['JSON']>;
  theme?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
  version?: InputMaybe<Scalars['Float']>;
};

export type FilterCountGayaFormNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountGayaFormOperatorsInput = {
  _id?: InputMaybe<FilterCountGayaForm_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterCountGayaFormCreatedAtOperatorsInput>;
  createdBy?: InputMaybe<FilterCountGayaFormCreatedByOperatorsInput>;
  deletedAt?: InputMaybe<FilterCountGayaFormDeletedAtOperatorsInput>;
  description?: InputMaybe<FilterCountGayaFormDescriptionOperatorsInput>;
  formType?: InputMaybe<FilterCountGayaFormFormTypeOperatorsInput>;
  name?: InputMaybe<FilterCountGayaFormNameOperatorsInput>;
  published?: InputMaybe<FilterCountGayaFormPublishedOperatorsInput>;
  schema?: InputMaybe<FilterCountGayaFormSchemaOperatorsInput>;
  theme?: InputMaybe<FilterCountGayaFormThemeOperatorsInput>;
  updatedAt?: InputMaybe<FilterCountGayaFormUpdatedAtOperatorsInput>;
  updatedBy?: InputMaybe<FilterCountGayaFormUpdatedByOperatorsInput>;
  version?: InputMaybe<FilterCountGayaFormVersionOperatorsInput>;
};

export type FilterCountGayaFormPublishedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountGayaFormResponseContentOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterCountGayaFormResponseCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountGayaFormResponseCreatedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountGayaFormResponseDeletedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountGayaFormResponseFormIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountGayaFormResponseFormTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumGayaFormResponseFormType>;
  gte?: InputMaybe<EnumGayaFormResponseFormType>;
  in?: InputMaybe<Array<InputMaybe<EnumGayaFormResponseFormType>>>;
  lt?: InputMaybe<EnumGayaFormResponseFormType>;
  lte?: InputMaybe<EnumGayaFormResponseFormType>;
  ne?: InputMaybe<EnumGayaFormResponseFormType>;
  nin?: InputMaybe<Array<InputMaybe<EnumGayaFormResponseFormType>>>;
};

export type FilterCountGayaFormResponseFormVersionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountGayaFormResponseInput = {
  AND?: InputMaybe<Array<FilterCountGayaFormResponseInput>>;
  OR?: InputMaybe<Array<FilterCountGayaFormResponseInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountGayaFormResponseOperatorsInput>;
  content?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  formId?: InputMaybe<Scalars['MongoID']>;
  formType?: InputMaybe<EnumGayaFormResponseFormType>;
  formVersion?: InputMaybe<Scalars['Float']>;
  partnerName?: InputMaybe<Scalars['String']>;
  userEmail?: InputMaybe<Scalars['String']>;
  zendeskTicketId?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountGayaFormResponseOperatorsInput = {
  _id?: InputMaybe<FilterCountGayaFormResponse_IdOperatorsInput>;
  content?: InputMaybe<FilterCountGayaFormResponseContentOperatorsInput>;
  createdAt?: InputMaybe<FilterCountGayaFormResponseCreatedAtOperatorsInput>;
  createdBy?: InputMaybe<FilterCountGayaFormResponseCreatedByOperatorsInput>;
  deletedAt?: InputMaybe<FilterCountGayaFormResponseDeletedAtOperatorsInput>;
  formId?: InputMaybe<FilterCountGayaFormResponseFormIdOperatorsInput>;
  formType?: InputMaybe<FilterCountGayaFormResponseFormTypeOperatorsInput>;
  formVersion?: InputMaybe<FilterCountGayaFormResponseFormVersionOperatorsInput>;
  partnerName?: InputMaybe<FilterCountGayaFormResponsePartnerNameOperatorsInput>;
  userEmail?: InputMaybe<FilterCountGayaFormResponseUserEmailOperatorsInput>;
  zendeskTicketId?: InputMaybe<FilterCountGayaFormResponseZendeskTicketIdOperatorsInput>;
};

export type FilterCountGayaFormResponsePartnerNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountGayaFormResponseUserEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountGayaFormResponseZendeskTicketIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountGayaFormResponse_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountGayaFormSchemaOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterCountGayaFormThemeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountGayaFormUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountGayaFormUpdatedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountGayaFormVersionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountGayaForm_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountIncidentBatchIdsBatchIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountIncidentBatchIdsExecutedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountIncidentBatchIdsFailedEntitiesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountIncidentBatchIdsGroupsIdsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountIncidentBatchIdsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  batchId?: InputMaybe<Scalars['MongoID']>;
  executedBy?: InputMaybe<Scalars['MongoID']>;
  failedEntities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  groupsIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  isRunning?: InputMaybe<Scalars['Boolean']>;
  mode?: InputMaybe<EnumIncidentBatchIdsMode>;
  runAt?: InputMaybe<Scalars['Date']>;
};

export type FilterCountIncidentBatchIdsIsRunningOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountIncidentBatchIdsModeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumIncidentBatchIdsMode>;
  gte?: InputMaybe<EnumIncidentBatchIdsMode>;
  in?: InputMaybe<Array<InputMaybe<EnumIncidentBatchIdsMode>>>;
  lt?: InputMaybe<EnumIncidentBatchIdsMode>;
  lte?: InputMaybe<EnumIncidentBatchIdsMode>;
  ne?: InputMaybe<EnumIncidentBatchIdsMode>;
  nin?: InputMaybe<Array<InputMaybe<EnumIncidentBatchIdsMode>>>;
};

export type FilterCountIncidentBatchIdsOperatorsInput = {
  _id?: InputMaybe<FilterCountIncidentBatchIds_IdOperatorsInput>;
  batchId?: InputMaybe<FilterCountIncidentBatchIdsBatchIdOperatorsInput>;
  executedBy?: InputMaybe<FilterCountIncidentBatchIdsExecutedByOperatorsInput>;
  failedEntities?: InputMaybe<FilterCountIncidentBatchIdsFailedEntitiesOperatorsInput>;
  groupsIds?: InputMaybe<FilterCountIncidentBatchIdsGroupsIdsOperatorsInput>;
  isRunning?: InputMaybe<FilterCountIncidentBatchIdsIsRunningOperatorsInput>;
  mode?: InputMaybe<FilterCountIncidentBatchIdsModeOperatorsInput>;
  runAt?: InputMaybe<FilterCountIncidentBatchIdsRunAtOperatorsInput>;
};

export type FilterCountIncidentBatchIdsRunAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountIncidentBatchIds_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountIncidentCalculationSizeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountIncidentCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountIncidentCreatedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountIncidentDeletedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountIncidentDescriptionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountIncidentEntityIdsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountIncidentEntityOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumIncidentEntity>;
  gte?: InputMaybe<EnumIncidentEntity>;
  in?: InputMaybe<Array<InputMaybe<EnumIncidentEntity>>>;
  lt?: InputMaybe<EnumIncidentEntity>;
  lte?: InputMaybe<EnumIncidentEntity>;
  ne?: InputMaybe<EnumIncidentEntity>;
  nin?: InputMaybe<Array<InputMaybe<EnumIncidentEntity>>>;
};

export type FilterCountIncidentFireHydrantUrlOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountIncidentInput = {
  AND?: InputMaybe<Array<FilterCountIncidentInput>>;
  OR?: InputMaybe<Array<FilterCountIncidentInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountIncidentOperatorsInput>;
  batchIds?: InputMaybe<Array<InputMaybe<FilterCountIncidentBatchIdsInput>>>;
  calculationSize?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  /** Search by email in regExp */
  email?: InputMaybe<Scalars['String']>;
  entity?: InputMaybe<EnumIncidentEntity>;
  entityIds?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  fireHydrantUrl?: InputMaybe<Scalars['String']>;
  isCalculating?: InputMaybe<Scalars['Boolean']>;
  isCalculationFailed?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<EnumIncidentStatus>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterCountIncidentIsCalculatingOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountIncidentIsCalculationFailedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountIncidentNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountIncidentOperatorsInput = {
  _id?: InputMaybe<FilterCountIncident_IdOperatorsInput>;
  batchIds?: InputMaybe<FilterCountIncidentBatchIdsOperatorsInput>;
  calculationSize?: InputMaybe<FilterCountIncidentCalculationSizeOperatorsInput>;
  createdAt?: InputMaybe<FilterCountIncidentCreatedAtOperatorsInput>;
  createdBy?: InputMaybe<FilterCountIncidentCreatedByOperatorsInput>;
  deletedAt?: InputMaybe<FilterCountIncidentDeletedAtOperatorsInput>;
  description?: InputMaybe<FilterCountIncidentDescriptionOperatorsInput>;
  entity?: InputMaybe<FilterCountIncidentEntityOperatorsInput>;
  entityIds?: InputMaybe<FilterCountIncidentEntityIdsOperatorsInput>;
  fireHydrantUrl?: InputMaybe<FilterCountIncidentFireHydrantUrlOperatorsInput>;
  isCalculating?: InputMaybe<FilterCountIncidentIsCalculatingOperatorsInput>;
  isCalculationFailed?: InputMaybe<FilterCountIncidentIsCalculationFailedOperatorsInput>;
  name?: InputMaybe<FilterCountIncidentNameOperatorsInput>;
  status?: InputMaybe<FilterCountIncidentStatusOperatorsInput>;
  updatedAt?: InputMaybe<FilterCountIncidentUpdatedAtOperatorsInput>;
};

export type FilterCountIncidentStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumIncidentStatus>;
  gte?: InputMaybe<EnumIncidentStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumIncidentStatus>>>;
  lt?: InputMaybe<EnumIncidentStatus>;
  lte?: InputMaybe<EnumIncidentStatus>;
  ne?: InputMaybe<EnumIncidentStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumIncidentStatus>>>;
};

export type FilterCountIncidentUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountIncident_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountProjectInput = {
  AND?: InputMaybe<Array<FilterCountProjectInput>>;
  OR?: InputMaybe<Array<FilterCountProjectInput>>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  status?: InputMaybe<EnumProjectStatus>;
};

export type FilterCountRoleInput = {
  AND?: InputMaybe<Array<FilterCountRoleInput>>;
  OR?: InputMaybe<Array<FilterCountRoleInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountRoleOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  forbiddenGroupEntityIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  name?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountRoleOperatorsInput = {
  _id?: InputMaybe<FilterCountRole_IdOperatorsInput>;
};

export type FilterCountRole_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountRuleInput = {
  AND?: InputMaybe<Array<FilterCountRuleInput>>;
  OR?: InputMaybe<Array<FilterCountRuleInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountRuleOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  logic?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  tree?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  version?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountRuleOperatorsInput = {
  _id?: InputMaybe<FilterCountRule_IdOperatorsInput>;
};

export type FilterCountRule_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountSquadInput = {
  AND?: InputMaybe<Array<FilterCountSquadInput>>;
  OR?: InputMaybe<Array<FilterCountSquadInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountSquadOperatorsInput>;
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountSquadOperatorsInput = {
  _id?: InputMaybe<FilterCountSquad_IdOperatorsInput>;
};

export type FilterCountSquad_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountStrategyInput = {
  AND?: InputMaybe<Array<FilterCountStrategyInput>>;
  OR?: InputMaybe<Array<FilterCountStrategyInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountStrategyOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  logic?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  rules?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  tree?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  version?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountStrategyOperatorsInput = {
  _id?: InputMaybe<FilterCountStrategy_IdOperatorsInput>;
};

export type FilterCountStrategy_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountTeamInput = {
  AND?: InputMaybe<Array<FilterCountTeamInput>>;
  OR?: InputMaybe<Array<FilterCountTeamInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountTeamOperatorsInput>;
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterCountTeamIntegrationDeletedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountTeamIntegrationEntityTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountTeamIntegrationInput = {
  AND?: InputMaybe<Array<FilterCountTeamIntegrationInput>>;
  OR?: InputMaybe<Array<FilterCountTeamIntegrationInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountTeamIntegrationOperatorsInput>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  entityType?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  settings?: InputMaybe<FilterCountTeamIntegrationSettingsInput>;
  type?: InputMaybe<EnumTeamIntegrationType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountTeamIntegrationOperatorsInput = {
  _id?: InputMaybe<FilterCountTeamIntegration_IdOperatorsInput>;
  deletedAt?: InputMaybe<FilterCountTeamIntegrationDeletedAtOperatorsInput>;
  entityType?: InputMaybe<FilterCountTeamIntegrationEntityTypeOperatorsInput>;
  reason?: InputMaybe<FilterCountTeamIntegrationReasonOperatorsInput>;
  roleIds?: InputMaybe<FilterCountTeamIntegrationRoleIdsOperatorsInput>;
  settings?: InputMaybe<FilterCountTeamIntegrationSettingsOperatorsInput>;
  type?: InputMaybe<FilterCountTeamIntegrationTypeOperatorsInput>;
};

export type FilterCountTeamIntegrationReasonOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountTeamIntegrationRoleIdsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountTeamIntegrationSettingsInput = {
  showAmount?: InputMaybe<Scalars['Boolean']>;
  slackChannelId?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['String']>;
};

export type FilterCountTeamIntegrationSettingsOperatorsInput = {
  showAmount?: InputMaybe<FilterCountTeamIntegrationSettingsShowAmountOperatorsInput>;
  slackChannelId?: InputMaybe<FilterCountTeamIntegrationSettingsSlackChannelIdOperatorsInput>;
  tag?: InputMaybe<FilterCountTeamIntegrationSettingsTagOperatorsInput>;
};

export type FilterCountTeamIntegrationSettingsShowAmountOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountTeamIntegrationSettingsSlackChannelIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountTeamIntegrationSettingsTagOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountTeamIntegrationTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTeamIntegrationType>;
  gte?: InputMaybe<EnumTeamIntegrationType>;
  in?: InputMaybe<Array<InputMaybe<EnumTeamIntegrationType>>>;
  lt?: InputMaybe<EnumTeamIntegrationType>;
  lte?: InputMaybe<EnumTeamIntegrationType>;
  ne?: InputMaybe<EnumTeamIntegrationType>;
  nin?: InputMaybe<Array<InputMaybe<EnumTeamIntegrationType>>>;
};

export type FilterCountTeamIntegration_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountTeamOperatorsInput = {
  _id?: InputMaybe<FilterCountTeam_IdOperatorsInput>;
};

export type FilterCountTeam_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountUiFlowBlocksActionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowBlocksColorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowBlocksDisplayNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowBlocksDynamicVariablesInput = {
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterCountUiFlowBlocksDynamicVariablesNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowBlocksDynamicVariablesOperatorsInput = {
  name?: InputMaybe<FilterCountUiFlowBlocksDynamicVariablesNameOperatorsInput>;
  value?: InputMaybe<FilterCountUiFlowBlocksDynamicVariablesValueOperatorsInput>;
};

export type FilterCountUiFlowBlocksDynamicVariablesValueOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowBlocksExtrasOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterCountUiFlowBlocksFlowIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountUiFlowBlocksFlowResultOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowBlocksFlowStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumUiFlowBlocksFlowStatus>;
  gte?: InputMaybe<EnumUiFlowBlocksFlowStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumUiFlowBlocksFlowStatus>>>;
  lt?: InputMaybe<EnumUiFlowBlocksFlowStatus>;
  lte?: InputMaybe<EnumUiFlowBlocksFlowStatus>;
  ne?: InputMaybe<EnumUiFlowBlocksFlowStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumUiFlowBlocksFlowStatus>>>;
};

export type FilterCountUiFlowBlocksIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowBlocksInput = {
  actionId?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  dynamicVariables?: InputMaybe<Array<InputMaybe<FilterCountUiFlowBlocksDynamicVariablesInput>>>;
  extras?: InputMaybe<Scalars['JSON']>;
  flowId?: InputMaybe<Scalars['MongoID']>;
  flowResult?: InputMaybe<Scalars['String']>;
  flowStatus?: InputMaybe<EnumUiFlowBlocksFlowStatus>;
  id?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  parameters?: InputMaybe<Array<InputMaybe<FilterCountUiFlowBlocksParametersInput>>>;
  ports?: InputMaybe<Array<InputMaybe<FilterCountUiFlowBlocksPortsInput>>>;
  readOnly?: InputMaybe<Scalars['Boolean']>;
  selected?: InputMaybe<Scalars['Boolean']>;
  strategyId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<EnumUiFlowBlocksType>;
  wait?: InputMaybe<FilterCountUiFlowBlocksWaitInput>;
  x?: InputMaybe<Scalars['Float']>;
  y?: InputMaybe<Scalars['Float']>;
};

export type FilterCountUiFlowBlocksLabelOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowBlocksLockedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountUiFlowBlocksOperatorsInput = {
  actionId?: InputMaybe<FilterCountUiFlowBlocksActionIdOperatorsInput>;
  color?: InputMaybe<FilterCountUiFlowBlocksColorOperatorsInput>;
  displayName?: InputMaybe<FilterCountUiFlowBlocksDisplayNameOperatorsInput>;
  dynamicVariables?: InputMaybe<FilterCountUiFlowBlocksDynamicVariablesOperatorsInput>;
  extras?: InputMaybe<FilterCountUiFlowBlocksExtrasOperatorsInput>;
  flowId?: InputMaybe<FilterCountUiFlowBlocksFlowIdOperatorsInput>;
  flowResult?: InputMaybe<FilterCountUiFlowBlocksFlowResultOperatorsInput>;
  flowStatus?: InputMaybe<FilterCountUiFlowBlocksFlowStatusOperatorsInput>;
  id?: InputMaybe<FilterCountUiFlowBlocksIdOperatorsInput>;
  label?: InputMaybe<FilterCountUiFlowBlocksLabelOperatorsInput>;
  locked?: InputMaybe<FilterCountUiFlowBlocksLockedOperatorsInput>;
  parameters?: InputMaybe<FilterCountUiFlowBlocksParametersOperatorsInput>;
  ports?: InputMaybe<FilterCountUiFlowBlocksPortsOperatorsInput>;
  readOnly?: InputMaybe<FilterCountUiFlowBlocksReadOnlyOperatorsInput>;
  selected?: InputMaybe<FilterCountUiFlowBlocksSelectedOperatorsInput>;
  strategyId?: InputMaybe<FilterCountUiFlowBlocksStrategyIdOperatorsInput>;
  type?: InputMaybe<FilterCountUiFlowBlocksTypeOperatorsInput>;
  wait?: InputMaybe<FilterCountUiFlowBlocksWaitOperatorsInput>;
  x?: InputMaybe<FilterCountUiFlowBlocksXOperatorsInput>;
  y?: InputMaybe<FilterCountUiFlowBlocksYOperatorsInput>;
};

export type FilterCountUiFlowBlocksParametersInput = {
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterCountUiFlowBlocksParametersNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowBlocksParametersOperatorsInput = {
  name?: InputMaybe<FilterCountUiFlowBlocksParametersNameOperatorsInput>;
  value?: InputMaybe<FilterCountUiFlowBlocksParametersValueOperatorsInput>;
};

export type FilterCountUiFlowBlocksParametersValueOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterCountUiFlowBlocksPortsAlignmentOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumUiFlowBlocksPortsAlignment>;
  gte?: InputMaybe<EnumUiFlowBlocksPortsAlignment>;
  in?: InputMaybe<Array<InputMaybe<EnumUiFlowBlocksPortsAlignment>>>;
  lt?: InputMaybe<EnumUiFlowBlocksPortsAlignment>;
  lte?: InputMaybe<EnumUiFlowBlocksPortsAlignment>;
  ne?: InputMaybe<EnumUiFlowBlocksPortsAlignment>;
  nin?: InputMaybe<Array<InputMaybe<EnumUiFlowBlocksPortsAlignment>>>;
};

export type FilterCountUiFlowBlocksPortsExtrasOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterCountUiFlowBlocksPortsIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowBlocksPortsInOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountUiFlowBlocksPortsInput = {
  alignment?: InputMaybe<EnumUiFlowBlocksPortsAlignment>;
  extras?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<FilterCountUiFlowBlocksPortsLinkInput>;
  links?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  locked?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentNode?: InputMaybe<Scalars['String']>;
  selected?: InputMaybe<Scalars['Boolean']>;
  target?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  x?: InputMaybe<Scalars['Float']>;
  y?: InputMaybe<Scalars['Float']>;
};

export type FilterCountUiFlowBlocksPortsLabelOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowBlocksPortsLinkColorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowBlocksPortsLinkCurvynessOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountUiFlowBlocksPortsLinkExtrasOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterCountUiFlowBlocksPortsLinkIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowBlocksPortsLinkInput = {
  color?: InputMaybe<Scalars['String']>;
  curvyness?: InputMaybe<Scalars['Float']>;
  extras?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Array<InputMaybe<FilterCountUiFlowBlocksPortsLinkLabelsInput>>>;
  locked?: InputMaybe<Scalars['Boolean']>;
  points?: InputMaybe<Array<InputMaybe<FilterCountUiFlowBlocksPortsLinkPointsInput>>>;
  selected?: InputMaybe<Scalars['Boolean']>;
  selectedColor?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  sourcePort?: InputMaybe<Scalars['String']>;
  target?: InputMaybe<Scalars['String']>;
  targetPort?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type FilterCountUiFlowBlocksPortsLinkLabelsExtrasOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterCountUiFlowBlocksPortsLinkLabelsIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowBlocksPortsLinkLabelsInput = {
  extras?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  offsetX?: InputMaybe<Scalars['Float']>;
  offsetY?: InputMaybe<Scalars['Float']>;
  selected?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
};

export type FilterCountUiFlowBlocksPortsLinkLabelsLockedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountUiFlowBlocksPortsLinkLabelsOffsetXOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountUiFlowBlocksPortsLinkLabelsOffsetYOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountUiFlowBlocksPortsLinkLabelsOperatorsInput = {
  extras?: InputMaybe<FilterCountUiFlowBlocksPortsLinkLabelsExtrasOperatorsInput>;
  id?: InputMaybe<FilterCountUiFlowBlocksPortsLinkLabelsIdOperatorsInput>;
  locked?: InputMaybe<FilterCountUiFlowBlocksPortsLinkLabelsLockedOperatorsInput>;
  offsetX?: InputMaybe<FilterCountUiFlowBlocksPortsLinkLabelsOffsetXOperatorsInput>;
  offsetY?: InputMaybe<FilterCountUiFlowBlocksPortsLinkLabelsOffsetYOperatorsInput>;
  selected?: InputMaybe<FilterCountUiFlowBlocksPortsLinkLabelsSelectedOperatorsInput>;
  type?: InputMaybe<FilterCountUiFlowBlocksPortsLinkLabelsTypeOperatorsInput>;
};

export type FilterCountUiFlowBlocksPortsLinkLabelsSelectedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountUiFlowBlocksPortsLinkLabelsTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowBlocksPortsLinkLockedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountUiFlowBlocksPortsLinkOperatorsInput = {
  color?: InputMaybe<FilterCountUiFlowBlocksPortsLinkColorOperatorsInput>;
  curvyness?: InputMaybe<FilterCountUiFlowBlocksPortsLinkCurvynessOperatorsInput>;
  extras?: InputMaybe<FilterCountUiFlowBlocksPortsLinkExtrasOperatorsInput>;
  id?: InputMaybe<FilterCountUiFlowBlocksPortsLinkIdOperatorsInput>;
  labels?: InputMaybe<FilterCountUiFlowBlocksPortsLinkLabelsOperatorsInput>;
  locked?: InputMaybe<FilterCountUiFlowBlocksPortsLinkLockedOperatorsInput>;
  points?: InputMaybe<FilterCountUiFlowBlocksPortsLinkPointsOperatorsInput>;
  selected?: InputMaybe<FilterCountUiFlowBlocksPortsLinkSelectedOperatorsInput>;
  selectedColor?: InputMaybe<FilterCountUiFlowBlocksPortsLinkSelectedColorOperatorsInput>;
  source?: InputMaybe<FilterCountUiFlowBlocksPortsLinkSourceOperatorsInput>;
  sourcePort?: InputMaybe<FilterCountUiFlowBlocksPortsLinkSourcePortOperatorsInput>;
  target?: InputMaybe<FilterCountUiFlowBlocksPortsLinkTargetOperatorsInput>;
  targetPort?: InputMaybe<FilterCountUiFlowBlocksPortsLinkTargetPortOperatorsInput>;
  type?: InputMaybe<FilterCountUiFlowBlocksPortsLinkTypeOperatorsInput>;
  width?: InputMaybe<FilterCountUiFlowBlocksPortsLinkWidthOperatorsInput>;
};

export type FilterCountUiFlowBlocksPortsLinkPointsExtrasOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterCountUiFlowBlocksPortsLinkPointsIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowBlocksPortsLinkPointsInput = {
  extras?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  selected?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  x?: InputMaybe<Scalars['Float']>;
  y?: InputMaybe<Scalars['Float']>;
};

export type FilterCountUiFlowBlocksPortsLinkPointsLockedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountUiFlowBlocksPortsLinkPointsOperatorsInput = {
  extras?: InputMaybe<FilterCountUiFlowBlocksPortsLinkPointsExtrasOperatorsInput>;
  id?: InputMaybe<FilterCountUiFlowBlocksPortsLinkPointsIdOperatorsInput>;
  locked?: InputMaybe<FilterCountUiFlowBlocksPortsLinkPointsLockedOperatorsInput>;
  selected?: InputMaybe<FilterCountUiFlowBlocksPortsLinkPointsSelectedOperatorsInput>;
  type?: InputMaybe<FilterCountUiFlowBlocksPortsLinkPointsTypeOperatorsInput>;
  x?: InputMaybe<FilterCountUiFlowBlocksPortsLinkPointsXOperatorsInput>;
  y?: InputMaybe<FilterCountUiFlowBlocksPortsLinkPointsYOperatorsInput>;
};

export type FilterCountUiFlowBlocksPortsLinkPointsSelectedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountUiFlowBlocksPortsLinkPointsTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowBlocksPortsLinkPointsXOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountUiFlowBlocksPortsLinkPointsYOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountUiFlowBlocksPortsLinkSelectedColorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowBlocksPortsLinkSelectedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountUiFlowBlocksPortsLinkSourceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowBlocksPortsLinkSourcePortOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowBlocksPortsLinkTargetOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowBlocksPortsLinkTargetPortOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowBlocksPortsLinkTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowBlocksPortsLinkWidthOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountUiFlowBlocksPortsLinksOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterCountUiFlowBlocksPortsLockedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountUiFlowBlocksPortsNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowBlocksPortsOperatorsInput = {
  alignment?: InputMaybe<FilterCountUiFlowBlocksPortsAlignmentOperatorsInput>;
  extras?: InputMaybe<FilterCountUiFlowBlocksPortsExtrasOperatorsInput>;
  id?: InputMaybe<FilterCountUiFlowBlocksPortsIdOperatorsInput>;
  in?: InputMaybe<FilterCountUiFlowBlocksPortsInOperatorsInput>;
  label?: InputMaybe<FilterCountUiFlowBlocksPortsLabelOperatorsInput>;
  link?: InputMaybe<FilterCountUiFlowBlocksPortsLinkOperatorsInput>;
  links?: InputMaybe<FilterCountUiFlowBlocksPortsLinksOperatorsInput>;
  locked?: InputMaybe<FilterCountUiFlowBlocksPortsLockedOperatorsInput>;
  name?: InputMaybe<FilterCountUiFlowBlocksPortsNameOperatorsInput>;
  parentNode?: InputMaybe<FilterCountUiFlowBlocksPortsParentNodeOperatorsInput>;
  selected?: InputMaybe<FilterCountUiFlowBlocksPortsSelectedOperatorsInput>;
  target?: InputMaybe<FilterCountUiFlowBlocksPortsTargetOperatorsInput>;
  type?: InputMaybe<FilterCountUiFlowBlocksPortsTypeOperatorsInput>;
  x?: InputMaybe<FilterCountUiFlowBlocksPortsXOperatorsInput>;
  y?: InputMaybe<FilterCountUiFlowBlocksPortsYOperatorsInput>;
};

export type FilterCountUiFlowBlocksPortsParentNodeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowBlocksPortsSelectedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountUiFlowBlocksPortsTargetOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowBlocksPortsTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowBlocksPortsXOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountUiFlowBlocksPortsYOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountUiFlowBlocksReadOnlyOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountUiFlowBlocksSelectedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountUiFlowBlocksStrategyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowBlocksTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumUiFlowBlocksType>;
  gte?: InputMaybe<EnumUiFlowBlocksType>;
  in?: InputMaybe<Array<InputMaybe<EnumUiFlowBlocksType>>>;
  lt?: InputMaybe<EnumUiFlowBlocksType>;
  lte?: InputMaybe<EnumUiFlowBlocksType>;
  ne?: InputMaybe<EnumUiFlowBlocksType>;
  nin?: InputMaybe<Array<InputMaybe<EnumUiFlowBlocksType>>>;
};

export type FilterCountUiFlowBlocksWaitAmountOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountUiFlowBlocksWaitInput = {
  amount?: InputMaybe<Scalars['Float']>;
  interval?: InputMaybe<EnumUiFlowBlocksWaitInterval>;
  startFrom?: InputMaybe<Scalars['String']>;
};

export type FilterCountUiFlowBlocksWaitIntervalOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumUiFlowBlocksWaitInterval>;
  gte?: InputMaybe<EnumUiFlowBlocksWaitInterval>;
  in?: InputMaybe<Array<InputMaybe<EnumUiFlowBlocksWaitInterval>>>;
  lt?: InputMaybe<EnumUiFlowBlocksWaitInterval>;
  lte?: InputMaybe<EnumUiFlowBlocksWaitInterval>;
  ne?: InputMaybe<EnumUiFlowBlocksWaitInterval>;
  nin?: InputMaybe<Array<InputMaybe<EnumUiFlowBlocksWaitInterval>>>;
};

export type FilterCountUiFlowBlocksWaitOperatorsInput = {
  amount?: InputMaybe<FilterCountUiFlowBlocksWaitAmountOperatorsInput>;
  interval?: InputMaybe<FilterCountUiFlowBlocksWaitIntervalOperatorsInput>;
  startFrom?: InputMaybe<FilterCountUiFlowBlocksWaitStartFromOperatorsInput>;
};

export type FilterCountUiFlowBlocksWaitStartFromOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowBlocksXOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountUiFlowBlocksYOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountUiFlowCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountUiFlowDeletedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountUiFlowDisabledMessageOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowDisabledOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountUiFlowInput = {
  AND?: InputMaybe<Array<FilterCountUiFlowInput>>;
  OR?: InputMaybe<Array<FilterCountUiFlowInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountUiFlowOperatorsInput>;
  blocks?: InputMaybe<Array<InputMaybe<FilterCountUiFlowBlocksInput>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  disabledMessage?: InputMaybe<Scalars['String']>;
  lastUpdatedBy?: InputMaybe<Scalars['String']>;
  readingDeletedEntities?: InputMaybe<FilterCountUiFlowReadingDeletedEntitiesInput>;
  rejectHandler?: InputMaybe<FilterCountUiFlowRejectHandlerInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  triggers?: InputMaybe<FilterCountUiFlowTriggersInput>;
  type?: InputMaybe<Scalars['String']>;
  updateComment?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  version?: InputMaybe<Scalars['Float']>;
};

export type FilterCountUiFlowLastUpdatedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountUiFlowOperatorsInput = {
  _id?: InputMaybe<FilterCountUiFlow_IdOperatorsInput>;
  blocks?: InputMaybe<FilterCountUiFlowBlocksOperatorsInput>;
  createdAt?: InputMaybe<FilterCountUiFlowCreatedAtOperatorsInput>;
  deletedAt?: InputMaybe<FilterCountUiFlowDeletedAtOperatorsInput>;
  disabled?: InputMaybe<FilterCountUiFlowDisabledOperatorsInput>;
  disabledMessage?: InputMaybe<FilterCountUiFlowDisabledMessageOperatorsInput>;
  lastUpdatedBy?: InputMaybe<FilterCountUiFlowLastUpdatedByOperatorsInput>;
  readingDeletedEntities?: InputMaybe<FilterCountUiFlowReadingDeletedEntitiesOperatorsInput>;
  rejectHandler?: InputMaybe<FilterCountUiFlowRejectHandlerOperatorsInput>;
  tags?: InputMaybe<FilterCountUiFlowTagsOperatorsInput>;
  triggers?: InputMaybe<FilterCountUiFlowTriggersOperatorsInput>;
  type?: InputMaybe<FilterCountUiFlowTypeOperatorsInput>;
  updateComment?: InputMaybe<FilterCountUiFlowUpdateCommentOperatorsInput>;
  updatedAt?: InputMaybe<FilterCountUiFlowUpdatedAtOperatorsInput>;
  version?: InputMaybe<FilterCountUiFlowVersionOperatorsInput>;
};

export type FilterCountUiFlowReadingDeletedEntitiesDefaultPolicyOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountUiFlowReadingDeletedEntitiesDeliveryMethodOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountUiFlowReadingDeletedEntitiesFundingSourceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountUiFlowReadingDeletedEntitiesInput = {
  defaultPolicy?: InputMaybe<Scalars['Boolean']>;
  deliveryMethod?: InputMaybe<Scalars['Boolean']>;
  fundingSource?: InputMaybe<Scalars['Boolean']>;
  payment?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountUiFlowReadingDeletedEntitiesOperatorsInput = {
  defaultPolicy?: InputMaybe<FilterCountUiFlowReadingDeletedEntitiesDefaultPolicyOperatorsInput>;
  deliveryMethod?: InputMaybe<FilterCountUiFlowReadingDeletedEntitiesDeliveryMethodOperatorsInput>;
  fundingSource?: InputMaybe<FilterCountUiFlowReadingDeletedEntitiesFundingSourceOperatorsInput>;
  payment?: InputMaybe<FilterCountUiFlowReadingDeletedEntitiesPaymentOperatorsInput>;
};

export type FilterCountUiFlowReadingDeletedEntitiesPaymentOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountUiFlowRejectHandlerActionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowRejectHandlerInput = {
  actionId?: InputMaybe<Scalars['String']>;
  parameters?: InputMaybe<Array<InputMaybe<FilterCountUiFlowRejectHandlerParametersInput>>>;
};

export type FilterCountUiFlowRejectHandlerOperatorsInput = {
  actionId?: InputMaybe<FilterCountUiFlowRejectHandlerActionIdOperatorsInput>;
  parameters?: InputMaybe<FilterCountUiFlowRejectHandlerParametersOperatorsInput>;
};

export type FilterCountUiFlowRejectHandlerParametersInput = {
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterCountUiFlowRejectHandlerParametersNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowRejectHandlerParametersOperatorsInput = {
  name?: InputMaybe<FilterCountUiFlowRejectHandlerParametersNameOperatorsInput>;
  value?: InputMaybe<FilterCountUiFlowRejectHandlerParametersValueOperatorsInput>;
};

export type FilterCountUiFlowRejectHandlerParametersValueOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterCountUiFlowTagsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowTriggersEventsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterCountUiFlowTriggersInput = {
  events?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterCountUiFlowTriggersOperatorsInput = {
  events?: InputMaybe<FilterCountUiFlowTriggersEventsOperatorsInput>;
};

export type FilterCountUiFlowTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowUpdateCommentOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUiFlowUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountUiFlowVersionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountUiFlow_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterEnum = {
  __typename?: 'FilterEnum';
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type FilterFindManyActionInput = {
  AND?: InputMaybe<Array<FilterFindManyActionInput>>;
  OR?: InputMaybe<Array<FilterFindManyActionInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyActionOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  module?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyActionLogActionEndpointOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyActionLogActionNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyActionLogCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyActionLogDetailsActionValuesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindManyActionLogDetailsCheckSerialNumberOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyActionLogDetailsCompanyTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyActionLogDetailsCreatedManualPaymentIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyActionLogDetailsDeliveryMethodIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyActionLogDetailsFundingSourceIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyActionLogDetailsInput = {
  actionValues?: InputMaybe<Scalars['JSON']>;
  checkSerialNumber?: InputMaybe<Scalars['String']>;
  companyType?: InputMaybe<Scalars['String']>;
  createdManualPaymentId?: InputMaybe<Scalars['Float']>;
  deliveryMethodId?: InputMaybe<Scalars['Float']>;
  fundingSourceId?: InputMaybe<Scalars['Float']>;
  isSubscribed?: InputMaybe<Scalars['Boolean']>;
  isVip?: InputMaybe<Scalars['Boolean']>;
  metaData?: InputMaybe<Scalars['JSON']>;
  planCyclePeriod?: InputMaybe<Scalars['String']>;
  seats?: InputMaybe<Scalars['Float']>;
  sessionId?: InputMaybe<Scalars['String']>;
  subscriptionPlanId?: InputMaybe<Scalars['String']>;
  subscriptionPromoCode?: InputMaybe<Scalars['String']>;
  transferId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Float']>;
  zendeskTicketId?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyActionLogDetailsIsSubscribedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyActionLogDetailsIsVipOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyActionLogDetailsMetaDataOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindManyActionLogDetailsOperatorsInput = {
  actionValues?: InputMaybe<FilterFindManyActionLogDetailsActionValuesOperatorsInput>;
  checkSerialNumber?: InputMaybe<FilterFindManyActionLogDetailsCheckSerialNumberOperatorsInput>;
  companyType?: InputMaybe<FilterFindManyActionLogDetailsCompanyTypeOperatorsInput>;
  createdManualPaymentId?: InputMaybe<FilterFindManyActionLogDetailsCreatedManualPaymentIdOperatorsInput>;
  deliveryMethodId?: InputMaybe<FilterFindManyActionLogDetailsDeliveryMethodIdOperatorsInput>;
  fundingSourceId?: InputMaybe<FilterFindManyActionLogDetailsFundingSourceIdOperatorsInput>;
  isSubscribed?: InputMaybe<FilterFindManyActionLogDetailsIsSubscribedOperatorsInput>;
  isVip?: InputMaybe<FilterFindManyActionLogDetailsIsVipOperatorsInput>;
  metaData?: InputMaybe<FilterFindManyActionLogDetailsMetaDataOperatorsInput>;
  planCyclePeriod?: InputMaybe<FilterFindManyActionLogDetailsPlanCyclePeriodOperatorsInput>;
  seats?: InputMaybe<FilterFindManyActionLogDetailsSeatsOperatorsInput>;
  sessionId?: InputMaybe<FilterFindManyActionLogDetailsSessionIdOperatorsInput>;
  subscriptionPlanId?: InputMaybe<FilterFindManyActionLogDetailsSubscriptionPlanIdOperatorsInput>;
  subscriptionPromoCode?: InputMaybe<FilterFindManyActionLogDetailsSubscriptionPromoCodeOperatorsInput>;
  transferId?: InputMaybe<FilterFindManyActionLogDetailsTransferIdOperatorsInput>;
  userId?: InputMaybe<FilterFindManyActionLogDetailsUserIdOperatorsInput>;
  zendeskTicketId?: InputMaybe<FilterFindManyActionLogDetailsZendeskTicketIdOperatorsInput>;
};

export type FilterFindManyActionLogDetailsPlanCyclePeriodOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyActionLogDetailsSeatsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyActionLogDetailsSessionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyActionLogDetailsSubscriptionPlanIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyActionLogDetailsSubscriptionPromoCodeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyActionLogDetailsTransferIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyActionLogDetailsUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyActionLogDetailsZendeskTicketIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyActionLogEntityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyActionLogEntityOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumActionLogEntity>;
  gte?: InputMaybe<EnumActionLogEntity>;
  in?: InputMaybe<Array<InputMaybe<EnumActionLogEntity>>>;
  lt?: InputMaybe<EnumActionLogEntity>;
  lte?: InputMaybe<EnumActionLogEntity>;
  ne?: InputMaybe<EnumActionLogEntity>;
  nin?: InputMaybe<Array<InputMaybe<EnumActionLogEntity>>>;
};

export type FilterFindManyActionLogFailureMessageOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyActionLogInput = {
  AND?: InputMaybe<Array<FilterFindManyActionLogInput>>;
  OR?: InputMaybe<Array<FilterFindManyActionLogInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyActionLogOperatorsInput>;
  actionEndpoint?: InputMaybe<Scalars['String']>;
  actionName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  details?: InputMaybe<FilterFindManyActionLogDetailsInput>;
  entity?: InputMaybe<EnumActionLogEntity>;
  entityId?: InputMaybe<Scalars['String']>;
  failureMessage?: InputMaybe<Scalars['String']>;
  isTrainingMode?: InputMaybe<Scalars['Boolean']>;
  /** Filter by module names extracted from actionName or actionEndpoint */
  module?: InputMaybe<Scalars['String']>;
  partnerName?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<EnumActionLogResult>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  /** Filter by email in RegExp */
  userEmailRegExp?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyActionLogIsTrainingModeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyActionLogOperatorsInput = {
  _id?: InputMaybe<FilterFindManyActionLog_IdOperatorsInput>;
  actionEndpoint?: InputMaybe<FilterFindManyActionLogActionEndpointOperatorsInput>;
  actionName?: InputMaybe<FilterFindManyActionLogActionNameOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyActionLogCreatedAtOperatorsInput>;
  details?: InputMaybe<FilterFindManyActionLogDetailsOperatorsInput>;
  entity?: InputMaybe<FilterFindManyActionLogEntityOperatorsInput>;
  entityId?: InputMaybe<FilterFindManyActionLogEntityIdOperatorsInput>;
  failureMessage?: InputMaybe<FilterFindManyActionLogFailureMessageOperatorsInput>;
  isTrainingMode?: InputMaybe<FilterFindManyActionLogIsTrainingModeOperatorsInput>;
  partnerName?: InputMaybe<FilterFindManyActionLogPartnerNameOperatorsInput>;
  result?: InputMaybe<FilterFindManyActionLogResultOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyActionLogUpdatedAtOperatorsInput>;
  userId?: InputMaybe<FilterFindManyActionLogUserIdOperatorsInput>;
};

export type FilterFindManyActionLogPartnerNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyActionLogResultOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumActionLogResult>;
  gte?: InputMaybe<EnumActionLogResult>;
  in?: InputMaybe<Array<InputMaybe<EnumActionLogResult>>>;
  lt?: InputMaybe<EnumActionLogResult>;
  lte?: InputMaybe<EnumActionLogResult>;
  ne?: InputMaybe<EnumActionLogResult>;
  nin?: InputMaybe<Array<InputMaybe<EnumActionLogResult>>>;
};

export type FilterFindManyActionLogUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyActionLogUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyActionLog_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyActionOperatorsInput = {
  _id?: InputMaybe<FilterFindManyAction_IdOperatorsInput>;
};

export type FilterFindManyAction_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyBusyEntityCachedDataAccountNumberOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyEntityCachedDataAddressLine1OperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyEntityCachedDataAddressLine2OperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyEntityCachedDataAddressOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyEntityCachedDataAptNumberOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyEntityCachedDataBusinessIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyEntityCachedDataCityOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyEntityCachedDataCompanyNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyEntityCachedDataContactFirstNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyEntityCachedDataContactFullNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyEntityCachedDataContactLastNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyEntityCachedDataCountryCodeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyEntityCachedDataCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyBusyEntityCachedDataDeletedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyBusyEntityCachedDataEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyEntityCachedDataEscalationDescriptionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyEntityCachedDataEscalationReasonOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyEntityCachedDataFcbStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumBusyEntityCachedDataFcbStatus>;
  gte?: InputMaybe<EnumBusyEntityCachedDataFcbStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumBusyEntityCachedDataFcbStatus>>>;
  lt?: InputMaybe<EnumBusyEntityCachedDataFcbStatus>;
  lte?: InputMaybe<EnumBusyEntityCachedDataFcbStatus>;
  ne?: InputMaybe<EnumBusyEntityCachedDataFcbStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumBusyEntityCachedDataFcbStatus>>>;
};

export type FilterFindManyBusyEntityCachedDataGroupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyEntityCachedDataIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBusyEntityCachedDataInput = {
  AND?: InputMaybe<Array<FilterFindManyBusyEntityCachedDataInput>>;
  OR?: InputMaybe<Array<FilterFindManyBusyEntityCachedDataInput>>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBusyEntityCachedDataOperatorsInput>;
  accountNumber?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  aptNumber?: InputMaybe<Scalars['String']>;
  businessId?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  contactFirstName?: InputMaybe<Scalars['String']>;
  contactFullName?: InputMaybe<Scalars['String']>;
  contactLastName?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  escalationDescription?: InputMaybe<Scalars['String']>;
  escalationReason?: InputMaybe<Scalars['String']>;
  fcbStatus?: InputMaybe<EnumBusyEntityCachedDataFcbStatus>;
  groupId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  notes?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<EnumBusyEntityCachedDataOrigin>;
  phone?: InputMaybe<Scalars['String']>;
  rejectionReason?: InputMaybe<EnumBusyEntityCachedDataRejectionReason>;
  relatedTasks?: InputMaybe<Scalars['Float']>;
  routingNumber?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceType?: InputMaybe<EnumBusyEntityCachedDataSourceType>;
  state?: InputMaybe<Scalars['String']>;
  taskReviewStartTime?: InputMaybe<Scalars['Date']>;
  taskType?: InputMaybe<EnumBusyEntityCachedDataTaskType>;
  taxId?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  virtualCardEmail?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyBusyEntityCachedDataNotesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBusyEntityCachedDataOperatorsInput = {
  accountNumber?: InputMaybe<FilterFindManyBusyEntityCachedDataAccountNumberOperatorsInput>;
  address?: InputMaybe<FilterFindManyBusyEntityCachedDataAddressOperatorsInput>;
  addressLine1?: InputMaybe<FilterFindManyBusyEntityCachedDataAddressLine1OperatorsInput>;
  addressLine2?: InputMaybe<FilterFindManyBusyEntityCachedDataAddressLine2OperatorsInput>;
  aptNumber?: InputMaybe<FilterFindManyBusyEntityCachedDataAptNumberOperatorsInput>;
  businessId?: InputMaybe<FilterFindManyBusyEntityCachedDataBusinessIdOperatorsInput>;
  city?: InputMaybe<FilterFindManyBusyEntityCachedDataCityOperatorsInput>;
  companyName?: InputMaybe<FilterFindManyBusyEntityCachedDataCompanyNameOperatorsInput>;
  contactFirstName?: InputMaybe<FilterFindManyBusyEntityCachedDataContactFirstNameOperatorsInput>;
  contactFullName?: InputMaybe<FilterFindManyBusyEntityCachedDataContactFullNameOperatorsInput>;
  contactLastName?: InputMaybe<FilterFindManyBusyEntityCachedDataContactLastNameOperatorsInput>;
  countryCode?: InputMaybe<FilterFindManyBusyEntityCachedDataCountryCodeOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyBusyEntityCachedDataCreatedAtOperatorsInput>;
  deletedAt?: InputMaybe<FilterFindManyBusyEntityCachedDataDeletedAtOperatorsInput>;
  email?: InputMaybe<FilterFindManyBusyEntityCachedDataEmailOperatorsInput>;
  escalationDescription?: InputMaybe<FilterFindManyBusyEntityCachedDataEscalationDescriptionOperatorsInput>;
  escalationReason?: InputMaybe<FilterFindManyBusyEntityCachedDataEscalationReasonOperatorsInput>;
  fcbStatus?: InputMaybe<FilterFindManyBusyEntityCachedDataFcbStatusOperatorsInput>;
  groupId?: InputMaybe<FilterFindManyBusyEntityCachedDataGroupIdOperatorsInput>;
  id?: InputMaybe<FilterFindManyBusyEntityCachedDataIdOperatorsInput>;
  notes?: InputMaybe<FilterFindManyBusyEntityCachedDataNotesOperatorsInput>;
  origin?: InputMaybe<FilterFindManyBusyEntityCachedDataOriginOperatorsInput>;
  phone?: InputMaybe<FilterFindManyBusyEntityCachedDataPhoneOperatorsInput>;
  rejectionReason?: InputMaybe<FilterFindManyBusyEntityCachedDataRejectionReasonOperatorsInput>;
  relatedTasks?: InputMaybe<FilterFindManyBusyEntityCachedDataRelatedTasksOperatorsInput>;
  routingNumber?: InputMaybe<FilterFindManyBusyEntityCachedDataRoutingNumberOperatorsInput>;
  sourceId?: InputMaybe<FilterFindManyBusyEntityCachedDataSourceIdOperatorsInput>;
  sourceType?: InputMaybe<FilterFindManyBusyEntityCachedDataSourceTypeOperatorsInput>;
  state?: InputMaybe<FilterFindManyBusyEntityCachedDataStateOperatorsInput>;
  taskReviewStartTime?: InputMaybe<FilterFindManyBusyEntityCachedDataTaskReviewStartTimeOperatorsInput>;
  taskType?: InputMaybe<FilterFindManyBusyEntityCachedDataTaskTypeOperatorsInput>;
  taxId?: InputMaybe<FilterFindManyBusyEntityCachedDataTaxIdOperatorsInput>;
  taxIdType?: InputMaybe<FilterFindManyBusyEntityCachedDataTaxIdTypeOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyBusyEntityCachedDataUpdatedAtOperatorsInput>;
  virtualCardEmail?: InputMaybe<FilterFindManyBusyEntityCachedDataVirtualCardEmailOperatorsInput>;
  zipCode?: InputMaybe<FilterFindManyBusyEntityCachedDataZipCodeOperatorsInput>;
};

export type FilterFindManyBusyEntityCachedDataOriginOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumBusyEntityCachedDataOrigin>;
  gte?: InputMaybe<EnumBusyEntityCachedDataOrigin>;
  in?: InputMaybe<Array<InputMaybe<EnumBusyEntityCachedDataOrigin>>>;
  lt?: InputMaybe<EnumBusyEntityCachedDataOrigin>;
  lte?: InputMaybe<EnumBusyEntityCachedDataOrigin>;
  ne?: InputMaybe<EnumBusyEntityCachedDataOrigin>;
  nin?: InputMaybe<Array<InputMaybe<EnumBusyEntityCachedDataOrigin>>>;
};

export type FilterFindManyBusyEntityCachedDataPhoneOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyEntityCachedDataRejectionReasonOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumBusyEntityCachedDataRejectionReason>;
  gte?: InputMaybe<EnumBusyEntityCachedDataRejectionReason>;
  in?: InputMaybe<Array<InputMaybe<EnumBusyEntityCachedDataRejectionReason>>>;
  lt?: InputMaybe<EnumBusyEntityCachedDataRejectionReason>;
  lte?: InputMaybe<EnumBusyEntityCachedDataRejectionReason>;
  ne?: InputMaybe<EnumBusyEntityCachedDataRejectionReason>;
  nin?: InputMaybe<Array<InputMaybe<EnumBusyEntityCachedDataRejectionReason>>>;
};

export type FilterFindManyBusyEntityCachedDataRelatedTasksOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBusyEntityCachedDataRoutingNumberOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyEntityCachedDataSourceIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyEntityCachedDataSourceTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumBusyEntityCachedDataSourceType>;
  gte?: InputMaybe<EnumBusyEntityCachedDataSourceType>;
  in?: InputMaybe<Array<InputMaybe<EnumBusyEntityCachedDataSourceType>>>;
  lt?: InputMaybe<EnumBusyEntityCachedDataSourceType>;
  lte?: InputMaybe<EnumBusyEntityCachedDataSourceType>;
  ne?: InputMaybe<EnumBusyEntityCachedDataSourceType>;
  nin?: InputMaybe<Array<InputMaybe<EnumBusyEntityCachedDataSourceType>>>;
};

export type FilterFindManyBusyEntityCachedDataStateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyEntityCachedDataTaskReviewStartTimeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyBusyEntityCachedDataTaskTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumBusyEntityCachedDataTaskType>;
  gte?: InputMaybe<EnumBusyEntityCachedDataTaskType>;
  in?: InputMaybe<Array<InputMaybe<EnumBusyEntityCachedDataTaskType>>>;
  lt?: InputMaybe<EnumBusyEntityCachedDataTaskType>;
  lte?: InputMaybe<EnumBusyEntityCachedDataTaskType>;
  ne?: InputMaybe<EnumBusyEntityCachedDataTaskType>;
  nin?: InputMaybe<Array<InputMaybe<EnumBusyEntityCachedDataTaskType>>>;
};

export type FilterFindManyBusyEntityCachedDataTaxIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyEntityCachedDataTaxIdTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyEntityCachedDataUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyBusyEntityCachedDataVirtualCardEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyEntityCachedDataZipCodeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAddressLine1Input = {
  matchScore?: InputMaybe<Scalars['Float']>;
  matched?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAddressLine1MatchScoreOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAddressLine1MatchedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAddressLine1OperatorsInput = {
  matchScore?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAddressLine1MatchScoreOperatorsInput>;
  matched?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAddressLine1MatchedOperatorsInput>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAddressLine2Input = {
  matchScore?: InputMaybe<Scalars['Float']>;
  matched?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAddressLine2MatchScoreOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAddressLine2MatchedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAddressLine2OperatorsInput = {
  matchScore?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAddressLine2MatchScoreOperatorsInput>;
  matched?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAddressLine2MatchedOperatorsInput>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAptNumberInput = {
  matchScore?: InputMaybe<Scalars['Float']>;
  matched?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAptNumberMatchScoreOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAptNumberMatchedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAptNumberOperatorsInput = {
  matchScore?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAptNumberMatchScoreOperatorsInput>;
  matched?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAptNumberMatchedOperatorsInput>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownCityInput = {
  matchScore?: InputMaybe<Scalars['Float']>;
  matched?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownCityMatchScoreOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownCityMatchedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownCityOperatorsInput = {
  matchScore?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownCityMatchScoreOperatorsInput>;
  matched?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownCityMatchedOperatorsInput>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownCountryCodeInput = {
  matchScore?: InputMaybe<Scalars['Float']>;
  matched?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownCountryCodeMatchScoreOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownCountryCodeMatchedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownCountryCodeOperatorsInput = {
  matchScore?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownCountryCodeMatchScoreOperatorsInput>;
  matched?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownCountryCodeMatchedOperatorsInput>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownGooglePlaceIdInput = {
  matchScore?: InputMaybe<Scalars['Float']>;
  matched?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownGooglePlaceIdMatchScoreOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownGooglePlaceIdMatchedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownGooglePlaceIdOperatorsInput = {
  matchScore?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownGooglePlaceIdMatchScoreOperatorsInput>;
  matched?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownGooglePlaceIdMatchedOperatorsInput>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownInput = {
  addressLine1?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAddressLine1Input>;
  addressLine2?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAddressLine2Input>;
  aptNumber?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAptNumberInput>;
  city?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownCityInput>;
  countryCode?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownCountryCodeInput>;
  googlePlaceId?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownGooglePlaceIdInput>;
  state?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownStateInput>;
  zipCode?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownZipCodeInput>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownOperatorsInput = {
  addressLine1?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAddressLine1OperatorsInput>;
  addressLine2?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAddressLine2OperatorsInput>;
  aptNumber?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownAptNumberOperatorsInput>;
  city?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownCityOperatorsInput>;
  countryCode?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownCountryCodeOperatorsInput>;
  googlePlaceId?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownGooglePlaceIdOperatorsInput>;
  state?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownStateOperatorsInput>;
  zipCode?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownZipCodeOperatorsInput>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownStateInput = {
  matchScore?: InputMaybe<Scalars['Float']>;
  matched?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownStateMatchScoreOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownStateMatchedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownStateOperatorsInput = {
  matchScore?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownStateMatchScoreOperatorsInput>;
  matched?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownStateMatchedOperatorsInput>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownZipCodeInput = {
  matchScore?: InputMaybe<Scalars['Float']>;
  matched?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownZipCodeMatchScoreOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownZipCodeMatchedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownZipCodeOperatorsInput = {
  matchScore?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownZipCodeMatchScoreOperatorsInput>;
  matched?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownZipCodeMatchedOperatorsInput>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressInput = {
  breakdown?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownInput>;
  matchScore?: InputMaybe<Scalars['Float']>;
  matched?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressMatchScoreOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressMatchedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressOperatorsInput = {
  breakdown?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressBreakdownOperatorsInput>;
  matchScore?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressMatchScoreOperatorsInput>;
  matched?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressMatchedOperatorsInput>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountBreakdownAccountNumberInput = {
  matchScore?: InputMaybe<Scalars['Float']>;
  matched?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountBreakdownAccountNumberMatchScoreOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountBreakdownAccountNumberMatchedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountBreakdownAccountNumberOperatorsInput = {
  matchScore?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountBreakdownAccountNumberMatchScoreOperatorsInput>;
  matched?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountBreakdownAccountNumberMatchedOperatorsInput>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountBreakdownInput = {
  accountNumber?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountBreakdownAccountNumberInput>;
  routingNumber?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountBreakdownRoutingNumberInput>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountBreakdownOperatorsInput = {
  accountNumber?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountBreakdownAccountNumberOperatorsInput>;
  routingNumber?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountBreakdownRoutingNumberOperatorsInput>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountBreakdownRoutingNumberInput = {
  matchScore?: InputMaybe<Scalars['Float']>;
  matched?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountBreakdownRoutingNumberMatchScoreOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountBreakdownRoutingNumberMatchedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountBreakdownRoutingNumberOperatorsInput = {
  matchScore?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountBreakdownRoutingNumberMatchScoreOperatorsInput>;
  matched?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountBreakdownRoutingNumberMatchedOperatorsInput>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountInput = {
  breakdown?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountBreakdownInput>;
  matchScore?: InputMaybe<Scalars['Float']>;
  matched?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountMatchScoreOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountMatchedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountOperatorsInput = {
  breakdown?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountBreakdownOperatorsInput>;
  matchScore?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountMatchScoreOperatorsInput>;
  matched?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountMatchedOperatorsInput>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownEmailInput = {
  matchScore?: InputMaybe<Scalars['Float']>;
  matched?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownEmailMatchScoreOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownEmailMatchedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownEmailOperatorsInput = {
  matchScore?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownEmailMatchScoreOperatorsInput>;
  matched?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownEmailMatchedOperatorsInput>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownInput = {
  address?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressInput>;
  bankAccount?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountInput>;
  email?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownEmailInput>;
  legalName?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownLegalNameInput>;
  phone?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownPhoneInput>;
  publicName?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownPublicNameInput>;
  taxDetails?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsInput>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownLegalNameInput = {
  matchScore?: InputMaybe<Scalars['Float']>;
  matched?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownLegalNameMatchScoreOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownLegalNameMatchedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownLegalNameOperatorsInput = {
  matchScore?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownLegalNameMatchScoreOperatorsInput>;
  matched?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownLegalNameMatchedOperatorsInput>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownOperatorsInput = {
  address?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownAddressOperatorsInput>;
  bankAccount?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownBankAccountOperatorsInput>;
  email?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownEmailOperatorsInput>;
  legalName?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownLegalNameOperatorsInput>;
  phone?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownPhoneOperatorsInput>;
  publicName?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownPublicNameOperatorsInput>;
  taxDetails?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsOperatorsInput>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownPhoneInput = {
  matchScore?: InputMaybe<Scalars['Float']>;
  matched?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownPhoneMatchScoreOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownPhoneMatchedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownPhoneOperatorsInput = {
  matchScore?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownPhoneMatchScoreOperatorsInput>;
  matched?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownPhoneMatchedOperatorsInput>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownPublicNameInput = {
  matchScore?: InputMaybe<Scalars['Float']>;
  matched?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownPublicNameMatchScoreOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownPublicNameMatchedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownPublicNameOperatorsInput = {
  matchScore?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownPublicNameMatchScoreOperatorsInput>;
  matched?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownPublicNameMatchedOperatorsInput>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsBreakdownInput = {
  taxId?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsBreakdownTaxIdInput>;
  taxIdType?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsBreakdownTaxIdTypeInput>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsBreakdownOperatorsInput = {
  taxId?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsBreakdownTaxIdOperatorsInput>;
  taxIdType?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsBreakdownTaxIdTypeOperatorsInput>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsBreakdownTaxIdInput = {
  matchScore?: InputMaybe<Scalars['Float']>;
  matched?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsBreakdownTaxIdMatchScoreOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsBreakdownTaxIdMatchedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsBreakdownTaxIdOperatorsInput = {
  matchScore?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsBreakdownTaxIdMatchScoreOperatorsInput>;
  matched?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsBreakdownTaxIdMatchedOperatorsInput>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsBreakdownTaxIdTypeInput = {
  matchScore?: InputMaybe<Scalars['Float']>;
  matched?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsBreakdownTaxIdTypeMatchScoreOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsBreakdownTaxIdTypeMatchedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsBreakdownTaxIdTypeOperatorsInput = {
  matchScore?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsBreakdownTaxIdTypeMatchScoreOperatorsInput>;
  matched?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsBreakdownTaxIdTypeMatchedOperatorsInput>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsInput = {
  breakdown?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsBreakdownInput>;
  matchScore?: InputMaybe<Scalars['Float']>;
  matched?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsMatchScoreOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsMatchedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsOperatorsInput = {
  breakdown?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsBreakdownOperatorsInput>;
  matchScore?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsMatchScoreOperatorsInput>;
  matched?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownTaxDetailsMatchedOperatorsInput>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultInput = {
  breakdown?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownInput>;
  matchScore?: InputMaybe<Scalars['Float']>;
  matched?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultMatchScoreOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultMatchedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultOperatorsInput = {
  breakdown?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultBreakdownOperatorsInput>;
  matchScore?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultMatchScoreOperatorsInput>;
  matched?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultMatchedOperatorsInput>;
  version?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultVersionOperatorsInput>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultVersionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataDecisionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumBusyUnmatchTaskEntityCachedDataDecision>;
  gte?: InputMaybe<EnumBusyUnmatchTaskEntityCachedDataDecision>;
  in?: InputMaybe<Array<InputMaybe<EnumBusyUnmatchTaskEntityCachedDataDecision>>>;
  lt?: InputMaybe<EnumBusyUnmatchTaskEntityCachedDataDecision>;
  lte?: InputMaybe<EnumBusyUnmatchTaskEntityCachedDataDecision>;
  ne?: InputMaybe<EnumBusyUnmatchTaskEntityCachedDataDecision>;
  nin?: InputMaybe<Array<InputMaybe<EnumBusyUnmatchTaskEntityCachedDataDecision>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataEscalationDescriptionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataEscalationReasonOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataHasScheduledPaymentsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataInput = {
  AND?: InputMaybe<Array<FilterFindManyBusyUnmatchTaskEntityCachedDataInput>>;
  OR?: InputMaybe<Array<FilterFindManyBusyUnmatchTaskEntityCachedDataInput>>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataOperatorsInput>;
  businessId?: InputMaybe<Scalars['String']>;
  businessMatchResult?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultInput>;
  businessName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  decision?: InputMaybe<EnumBusyUnmatchTaskEntityCachedDataDecision>;
  escalationDescription?: InputMaybe<Scalars['String']>;
  escalationReason?: InputMaybe<Scalars['String']>;
  hasScheduledPayments?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Float']>;
  isPaidVendor?: InputMaybe<Scalars['Boolean']>;
  matchCreationDate?: InputMaybe<Scalars['Date']>;
  matchCreationReason?: InputMaybe<Scalars['String']>;
  matchCreationSource?: InputMaybe<EnumBusyUnmatchTaskEntityCachedDataMatchCreationSource>;
  next30DaysTpv?: InputMaybe<Scalars['Float']>;
  notes?: InputMaybe<Scalars['String']>;
  relatedTasks?: InputMaybe<Scalars['Float']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceType?: InputMaybe<EnumBusyUnmatchTaskEntityCachedDataSourceType>;
  unmatchReason?: InputMaybe<EnumBusyUnmatchTaskEntityCachedDataUnmatchReason>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  vendorId?: InputMaybe<Scalars['String']>;
  vendorName?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataIsPaidVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataMatchCreationDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataMatchCreationReasonOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataMatchCreationSourceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumBusyUnmatchTaskEntityCachedDataMatchCreationSource>;
  gte?: InputMaybe<EnumBusyUnmatchTaskEntityCachedDataMatchCreationSource>;
  in?: InputMaybe<Array<InputMaybe<EnumBusyUnmatchTaskEntityCachedDataMatchCreationSource>>>;
  lt?: InputMaybe<EnumBusyUnmatchTaskEntityCachedDataMatchCreationSource>;
  lte?: InputMaybe<EnumBusyUnmatchTaskEntityCachedDataMatchCreationSource>;
  ne?: InputMaybe<EnumBusyUnmatchTaskEntityCachedDataMatchCreationSource>;
  nin?: InputMaybe<Array<InputMaybe<EnumBusyUnmatchTaskEntityCachedDataMatchCreationSource>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataNext30DaysTpvOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataNotesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBusyUnmatchTaskEntityCachedDataOperatorsInput = {
  businessId?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessIdOperatorsInput>;
  businessMatchResult?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessMatchResultOperatorsInput>;
  businessName?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataBusinessNameOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataCreatedAtOperatorsInput>;
  decision?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataDecisionOperatorsInput>;
  escalationDescription?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataEscalationDescriptionOperatorsInput>;
  escalationReason?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataEscalationReasonOperatorsInput>;
  hasScheduledPayments?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataHasScheduledPaymentsOperatorsInput>;
  id?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataIdOperatorsInput>;
  isPaidVendor?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataIsPaidVendorOperatorsInput>;
  matchCreationDate?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataMatchCreationDateOperatorsInput>;
  matchCreationReason?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataMatchCreationReasonOperatorsInput>;
  matchCreationSource?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataMatchCreationSourceOperatorsInput>;
  next30DaysTpv?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataNext30DaysTpvOperatorsInput>;
  notes?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataNotesOperatorsInput>;
  relatedTasks?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataRelatedTasksOperatorsInput>;
  sourceId?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataSourceIdOperatorsInput>;
  sourceType?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataSourceTypeOperatorsInput>;
  unmatchReason?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataUnmatchReasonOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataUpdatedAtOperatorsInput>;
  vendorId?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataVendorIdOperatorsInput>;
  vendorName?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataVendorNameOperatorsInput>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataRelatedTasksOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataSourceIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataSourceTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumBusyUnmatchTaskEntityCachedDataSourceType>;
  gte?: InputMaybe<EnumBusyUnmatchTaskEntityCachedDataSourceType>;
  in?: InputMaybe<Array<InputMaybe<EnumBusyUnmatchTaskEntityCachedDataSourceType>>>;
  lt?: InputMaybe<EnumBusyUnmatchTaskEntityCachedDataSourceType>;
  lte?: InputMaybe<EnumBusyUnmatchTaskEntityCachedDataSourceType>;
  ne?: InputMaybe<EnumBusyUnmatchTaskEntityCachedDataSourceType>;
  nin?: InputMaybe<Array<InputMaybe<EnumBusyUnmatchTaskEntityCachedDataSourceType>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataUnmatchReasonOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumBusyUnmatchTaskEntityCachedDataUnmatchReason>;
  gte?: InputMaybe<EnumBusyUnmatchTaskEntityCachedDataUnmatchReason>;
  in?: InputMaybe<Array<InputMaybe<EnumBusyUnmatchTaskEntityCachedDataUnmatchReason>>>;
  lt?: InputMaybe<EnumBusyUnmatchTaskEntityCachedDataUnmatchReason>;
  lte?: InputMaybe<EnumBusyUnmatchTaskEntityCachedDataUnmatchReason>;
  ne?: InputMaybe<EnumBusyUnmatchTaskEntityCachedDataUnmatchReason>;
  nin?: InputMaybe<Array<InputMaybe<EnumBusyUnmatchTaskEntityCachedDataUnmatchReason>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBusyUnmatchTaskEntityCachedDataVendorNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyCardRecordInput = {
  AND?: InputMaybe<Array<FilterFindManyCardRecordInput>>;
  OR?: InputMaybe<Array<FilterFindManyCardRecordInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCardRecordOperatorsInput>;
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deliveryMethod?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  recordId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCardRecordOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCardRecord_IdOperatorsInput>;
};

export type FilterFindManyCardRecord_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyConcernAreaSchemaInput = {
  AND?: InputMaybe<Array<FilterFindManyConcernAreaSchemaInput>>;
  OR?: InputMaybe<Array<FilterFindManyConcernAreaSchemaInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyConcernAreaSchemaOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  isMandatory?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  rules?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  squadId?: InputMaybe<Scalars['MongoID']>;
  status?: InputMaybe<EnumConcernAreaSchemaStatus>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyConcernAreaSchemaOperatorsInput = {
  _id?: InputMaybe<FilterFindManyConcernAreaSchema_IdOperatorsInput>;
};

export type FilterFindManyConcernAreaSchema_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyDecisionReportCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyDecisionReportInput = {
  AND?: InputMaybe<Array<FilterFindManyDecisionReportInput>>;
  OR?: InputMaybe<Array<FilterFindManyDecisionReportInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDecisionReportOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  mode?: InputMaybe<EnumDecisionReportMode>;
  ruleDecisions?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  status?: InputMaybe<EnumDecisionReportStatus>;
  strategy?: InputMaybe<Scalars['MongoID']>;
  strategyVersion?: InputMaybe<Scalars['Float']>;
  success?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyDecisionReportModeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumDecisionReportMode>;
  gte?: InputMaybe<EnumDecisionReportMode>;
  in?: InputMaybe<Array<InputMaybe<EnumDecisionReportMode>>>;
  lt?: InputMaybe<EnumDecisionReportMode>;
  lte?: InputMaybe<EnumDecisionReportMode>;
  ne?: InputMaybe<EnumDecisionReportMode>;
  nin?: InputMaybe<Array<InputMaybe<EnumDecisionReportMode>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyDecisionReportOperatorsInput = {
  _id?: InputMaybe<FilterFindManyDecisionReport_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyDecisionReportCreatedAtOperatorsInput>;
  mode?: InputMaybe<FilterFindManyDecisionReportModeOperatorsInput>;
  ruleDecisions?: InputMaybe<FilterFindManyDecisionReportRuleDecisionsOperatorsInput>;
  status?: InputMaybe<FilterFindManyDecisionReportStatusOperatorsInput>;
  strategy?: InputMaybe<FilterFindManyDecisionReportStrategyOperatorsInput>;
  strategyVersion?: InputMaybe<FilterFindManyDecisionReportStrategyVersionOperatorsInput>;
  success?: InputMaybe<FilterFindManyDecisionReportSuccessOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyDecisionReportUpdatedAtOperatorsInput>;
};

export type FilterFindManyDecisionReportRuleDecisionsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindManyDecisionReportStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumDecisionReportStatus>;
  gte?: InputMaybe<EnumDecisionReportStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumDecisionReportStatus>>>;
  lt?: InputMaybe<EnumDecisionReportStatus>;
  lte?: InputMaybe<EnumDecisionReportStatus>;
  ne?: InputMaybe<EnumDecisionReportStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumDecisionReportStatus>>>;
};

export type FilterFindManyDecisionReportStrategyOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyDecisionReportStrategyVersionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyDecisionReportSuccessOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyDecisionReportUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyDecisionReport_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyFlowExecutionCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyFlowExecutionCurrentStepCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyFlowExecutionCurrentStepExpiresAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyFlowExecutionCurrentStepFlowExecutionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyFlowExecutionCurrentStepFlowResultOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindManyFlowExecutionCurrentStepIndexOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyFlowExecutionCurrentStepInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  expiresAt?: InputMaybe<Scalars['Date']>;
  flowExecutionId?: InputMaybe<Scalars['MongoID']>;
  flowResult?: InputMaybe<Scalars['JSON']>;
  index?: InputMaybe<Scalars['String']>;
  output?: InputMaybe<FilterFindManyFlowExecutionCurrentStepOutputInput>;
  status?: InputMaybe<EnumFlowExecutionCurrentStepStatus>;
  strategyDecisionReport?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyFlowExecutionCurrentStepOperatorsInput = {
  createdAt?: InputMaybe<FilterFindManyFlowExecutionCurrentStepCreatedAtOperatorsInput>;
  expiresAt?: InputMaybe<FilterFindManyFlowExecutionCurrentStepExpiresAtOperatorsInput>;
  flowExecutionId?: InputMaybe<FilterFindManyFlowExecutionCurrentStepFlowExecutionIdOperatorsInput>;
  flowResult?: InputMaybe<FilterFindManyFlowExecutionCurrentStepFlowResultOperatorsInput>;
  index?: InputMaybe<FilterFindManyFlowExecutionCurrentStepIndexOperatorsInput>;
  output?: InputMaybe<FilterFindManyFlowExecutionCurrentStepOutputOperatorsInput>;
  status?: InputMaybe<FilterFindManyFlowExecutionCurrentStepStatusOperatorsInput>;
  strategyDecisionReport?: InputMaybe<FilterFindManyFlowExecutionCurrentStepStrategyDecisionReportOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyFlowExecutionCurrentStepUpdatedAtOperatorsInput>;
};

export type FilterFindManyFlowExecutionCurrentStepOutputErrorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyFlowExecutionCurrentStepOutputFeeIdsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyFlowExecutionCurrentStepOutputFundingSourceIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyFlowExecutionCurrentStepOutputInput = {
  error?: InputMaybe<Scalars['String']>;
  feeIds?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  fundingSourceId?: InputMaybe<Scalars['Float']>;
  isEligible?: InputMaybe<Scalars['Boolean']>;
  setNumber?: InputMaybe<Scalars['Float']>;
  setString?: InputMaybe<Scalars['String']>;
  zendeskTicketId?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyFlowExecutionCurrentStepOutputIsEligibleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyFlowExecutionCurrentStepOutputOperatorsInput = {
  error?: InputMaybe<FilterFindManyFlowExecutionCurrentStepOutputErrorOperatorsInput>;
  feeIds?: InputMaybe<FilterFindManyFlowExecutionCurrentStepOutputFeeIdsOperatorsInput>;
  fundingSourceId?: InputMaybe<FilterFindManyFlowExecutionCurrentStepOutputFundingSourceIdOperatorsInput>;
  isEligible?: InputMaybe<FilterFindManyFlowExecutionCurrentStepOutputIsEligibleOperatorsInput>;
  setNumber?: InputMaybe<FilterFindManyFlowExecutionCurrentStepOutputSetNumberOperatorsInput>;
  setString?: InputMaybe<FilterFindManyFlowExecutionCurrentStepOutputSetStringOperatorsInput>;
  zendeskTicketId?: InputMaybe<FilterFindManyFlowExecutionCurrentStepOutputZendeskTicketIdOperatorsInput>;
};

export type FilterFindManyFlowExecutionCurrentStepOutputSetNumberOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyFlowExecutionCurrentStepOutputSetStringOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyFlowExecutionCurrentStepOutputZendeskTicketIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyFlowExecutionCurrentStepStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumFlowExecutionCurrentStepStatus>;
  gte?: InputMaybe<EnumFlowExecutionCurrentStepStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumFlowExecutionCurrentStepStatus>>>;
  lt?: InputMaybe<EnumFlowExecutionCurrentStepStatus>;
  lte?: InputMaybe<EnumFlowExecutionCurrentStepStatus>;
  ne?: InputMaybe<EnumFlowExecutionCurrentStepStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumFlowExecutionCurrentStepStatus>>>;
};

export type FilterFindManyFlowExecutionCurrentStepStrategyDecisionReportOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyFlowExecutionCurrentStepUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyFlowExecutionDeletedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyFlowExecutionDynamicVariablesFeeIdsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyFlowExecutionDynamicVariablesFundingSourceIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyFlowExecutionDynamicVariablesInput = {
  feeIds?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  fundingSourceId?: InputMaybe<Scalars['Float']>;
  isEligible?: InputMaybe<Scalars['Boolean']>;
  setNumber?: InputMaybe<Scalars['Float']>;
  setString?: InputMaybe<Scalars['String']>;
  zendeskTicketId?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyFlowExecutionDynamicVariablesIsEligibleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyFlowExecutionDynamicVariablesOperatorsInput = {
  feeIds?: InputMaybe<FilterFindManyFlowExecutionDynamicVariablesFeeIdsOperatorsInput>;
  fundingSourceId?: InputMaybe<FilterFindManyFlowExecutionDynamicVariablesFundingSourceIdOperatorsInput>;
  isEligible?: InputMaybe<FilterFindManyFlowExecutionDynamicVariablesIsEligibleOperatorsInput>;
  setNumber?: InputMaybe<FilterFindManyFlowExecutionDynamicVariablesSetNumberOperatorsInput>;
  setString?: InputMaybe<FilterFindManyFlowExecutionDynamicVariablesSetStringOperatorsInput>;
  zendeskTicketId?: InputMaybe<FilterFindManyFlowExecutionDynamicVariablesZendeskTicketIdOperatorsInput>;
};

export type FilterFindManyFlowExecutionDynamicVariablesSetNumberOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyFlowExecutionDynamicVariablesSetStringOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyFlowExecutionDynamicVariablesZendeskTicketIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyFlowExecutionInput = {
  AND?: InputMaybe<Array<FilterFindManyFlowExecutionInput>>;
  OR?: InputMaybe<Array<FilterFindManyFlowExecutionInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyFlowExecutionOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  currentStep?: InputMaybe<FilterFindManyFlowExecutionCurrentStepInput>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  dynamicVariables?: InputMaybe<FilterFindManyFlowExecutionDynamicVariablesInput>;
  input?: InputMaybe<Scalars['JSON']>;
  mode?: InputMaybe<EnumFlowExecutionMode>;
  output?: InputMaybe<Scalars['String']>;
  parentExecution?: InputMaybe<Scalars['MongoID']>;
  partnerName?: InputMaybe<Scalars['String']>;
  passedSteps?: InputMaybe<Array<InputMaybe<FilterFindManyFlowExecutionPassedStepsInput>>>;
  result?: InputMaybe<Scalars['JSON']>;
  startedAt?: InputMaybe<Scalars['Date']>;
  state?: InputMaybe<EnumFlowExecutionState>;
  status?: InputMaybe<EnumFlowExecutionStatus>;
  uiFlow?: InputMaybe<Scalars['MongoID']>;
  uiFlowVersion?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyFlowExecutionInputOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindManyFlowExecutionModeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumFlowExecutionMode>;
  gte?: InputMaybe<EnumFlowExecutionMode>;
  in?: InputMaybe<Array<InputMaybe<EnumFlowExecutionMode>>>;
  lt?: InputMaybe<EnumFlowExecutionMode>;
  lte?: InputMaybe<EnumFlowExecutionMode>;
  ne?: InputMaybe<EnumFlowExecutionMode>;
  nin?: InputMaybe<Array<InputMaybe<EnumFlowExecutionMode>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyFlowExecutionOperatorsInput = {
  _id?: InputMaybe<FilterFindManyFlowExecution_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyFlowExecutionCreatedAtOperatorsInput>;
  currentStep?: InputMaybe<FilterFindManyFlowExecutionCurrentStepOperatorsInput>;
  deletedAt?: InputMaybe<FilterFindManyFlowExecutionDeletedAtOperatorsInput>;
  dynamicVariables?: InputMaybe<FilterFindManyFlowExecutionDynamicVariablesOperatorsInput>;
  input?: InputMaybe<FilterFindManyFlowExecutionInputOperatorsInput>;
  mode?: InputMaybe<FilterFindManyFlowExecutionModeOperatorsInput>;
  output?: InputMaybe<FilterFindManyFlowExecutionOutputOperatorsInput>;
  parentExecution?: InputMaybe<FilterFindManyFlowExecutionParentExecutionOperatorsInput>;
  partnerName?: InputMaybe<FilterFindManyFlowExecutionPartnerNameOperatorsInput>;
  passedSteps?: InputMaybe<FilterFindManyFlowExecutionPassedStepsOperatorsInput>;
  result?: InputMaybe<FilterFindManyFlowExecutionResultOperatorsInput>;
  startedAt?: InputMaybe<FilterFindManyFlowExecutionStartedAtOperatorsInput>;
  state?: InputMaybe<FilterFindManyFlowExecutionStateOperatorsInput>;
  status?: InputMaybe<FilterFindManyFlowExecutionStatusOperatorsInput>;
  uiFlow?: InputMaybe<FilterFindManyFlowExecutionUiFlowOperatorsInput>;
  uiFlowVersion?: InputMaybe<FilterFindManyFlowExecutionUiFlowVersionOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyFlowExecutionUpdatedAtOperatorsInput>;
};

export type FilterFindManyFlowExecutionOutputOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyFlowExecutionParentExecutionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyFlowExecutionPartnerNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyFlowExecutionPassedStepsCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyFlowExecutionPassedStepsExpiresAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyFlowExecutionPassedStepsFlowExecutionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyFlowExecutionPassedStepsFlowResultOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindManyFlowExecutionPassedStepsIndexOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyFlowExecutionPassedStepsInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  expiresAt?: InputMaybe<Scalars['Date']>;
  flowExecutionId?: InputMaybe<Scalars['MongoID']>;
  flowResult?: InputMaybe<Scalars['JSON']>;
  index?: InputMaybe<Scalars['String']>;
  output?: InputMaybe<FilterFindManyFlowExecutionPassedStepsOutputInput>;
  status?: InputMaybe<EnumFlowExecutionPassedStepsStatus>;
  strategyDecisionReport?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyFlowExecutionPassedStepsOperatorsInput = {
  createdAt?: InputMaybe<FilterFindManyFlowExecutionPassedStepsCreatedAtOperatorsInput>;
  expiresAt?: InputMaybe<FilterFindManyFlowExecutionPassedStepsExpiresAtOperatorsInput>;
  flowExecutionId?: InputMaybe<FilterFindManyFlowExecutionPassedStepsFlowExecutionIdOperatorsInput>;
  flowResult?: InputMaybe<FilterFindManyFlowExecutionPassedStepsFlowResultOperatorsInput>;
  index?: InputMaybe<FilterFindManyFlowExecutionPassedStepsIndexOperatorsInput>;
  output?: InputMaybe<FilterFindManyFlowExecutionPassedStepsOutputOperatorsInput>;
  status?: InputMaybe<FilterFindManyFlowExecutionPassedStepsStatusOperatorsInput>;
  strategyDecisionReport?: InputMaybe<FilterFindManyFlowExecutionPassedStepsStrategyDecisionReportOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyFlowExecutionPassedStepsUpdatedAtOperatorsInput>;
};

export type FilterFindManyFlowExecutionPassedStepsOutputErrorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyFlowExecutionPassedStepsOutputFeeIdsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyFlowExecutionPassedStepsOutputFundingSourceIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyFlowExecutionPassedStepsOutputInput = {
  error?: InputMaybe<Scalars['String']>;
  feeIds?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  fundingSourceId?: InputMaybe<Scalars['Float']>;
  isEligible?: InputMaybe<Scalars['Boolean']>;
  setNumber?: InputMaybe<Scalars['Float']>;
  setString?: InputMaybe<Scalars['String']>;
  zendeskTicketId?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyFlowExecutionPassedStepsOutputIsEligibleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyFlowExecutionPassedStepsOutputOperatorsInput = {
  error?: InputMaybe<FilterFindManyFlowExecutionPassedStepsOutputErrorOperatorsInput>;
  feeIds?: InputMaybe<FilterFindManyFlowExecutionPassedStepsOutputFeeIdsOperatorsInput>;
  fundingSourceId?: InputMaybe<FilterFindManyFlowExecutionPassedStepsOutputFundingSourceIdOperatorsInput>;
  isEligible?: InputMaybe<FilterFindManyFlowExecutionPassedStepsOutputIsEligibleOperatorsInput>;
  setNumber?: InputMaybe<FilterFindManyFlowExecutionPassedStepsOutputSetNumberOperatorsInput>;
  setString?: InputMaybe<FilterFindManyFlowExecutionPassedStepsOutputSetStringOperatorsInput>;
  zendeskTicketId?: InputMaybe<FilterFindManyFlowExecutionPassedStepsOutputZendeskTicketIdOperatorsInput>;
};

export type FilterFindManyFlowExecutionPassedStepsOutputSetNumberOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyFlowExecutionPassedStepsOutputSetStringOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyFlowExecutionPassedStepsOutputZendeskTicketIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyFlowExecutionPassedStepsStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumFlowExecutionPassedStepsStatus>;
  gte?: InputMaybe<EnumFlowExecutionPassedStepsStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumFlowExecutionPassedStepsStatus>>>;
  lt?: InputMaybe<EnumFlowExecutionPassedStepsStatus>;
  lte?: InputMaybe<EnumFlowExecutionPassedStepsStatus>;
  ne?: InputMaybe<EnumFlowExecutionPassedStepsStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumFlowExecutionPassedStepsStatus>>>;
};

export type FilterFindManyFlowExecutionPassedStepsStrategyDecisionReportOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyFlowExecutionPassedStepsUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyFlowExecutionResultOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindManyFlowExecutionStartedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyFlowExecutionStateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumFlowExecutionState>;
  gte?: InputMaybe<EnumFlowExecutionState>;
  in?: InputMaybe<Array<InputMaybe<EnumFlowExecutionState>>>;
  lt?: InputMaybe<EnumFlowExecutionState>;
  lte?: InputMaybe<EnumFlowExecutionState>;
  ne?: InputMaybe<EnumFlowExecutionState>;
  nin?: InputMaybe<Array<InputMaybe<EnumFlowExecutionState>>>;
};

export type FilterFindManyFlowExecutionStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumFlowExecutionStatus>;
  gte?: InputMaybe<EnumFlowExecutionStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumFlowExecutionStatus>>>;
  lt?: InputMaybe<EnumFlowExecutionStatus>;
  lte?: InputMaybe<EnumFlowExecutionStatus>;
  ne?: InputMaybe<EnumFlowExecutionStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumFlowExecutionStatus>>>;
};

export type FilterFindManyFlowExecutionUiFlowOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyFlowExecutionUiFlowVersionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyFlowExecutionUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyFlowExecution_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyFlowPermissionCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyFlowPermissionInput = {
  AND?: InputMaybe<Array<FilterFindManyFlowPermissionInput>>;
  OR?: InputMaybe<Array<FilterFindManyFlowPermissionInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyFlowPermissionOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  uiFlowId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  viewRoleIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyFlowPermissionOperatorsInput = {
  _id?: InputMaybe<FilterFindManyFlowPermission_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyFlowPermissionCreatedAtOperatorsInput>;
  uiFlowId?: InputMaybe<FilterFindManyFlowPermissionUiFlowIdOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyFlowPermissionUpdatedAtOperatorsInput>;
  viewRoleIds?: InputMaybe<FilterFindManyFlowPermissionViewRoleIdsOperatorsInput>;
};

export type FilterFindManyFlowPermissionUiFlowIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyFlowPermissionUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyFlowPermissionViewRoleIdsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyFlowPermission_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyGayaFormCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyGayaFormCreatedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyGayaFormDeletedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyGayaFormDescriptionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyGayaFormFormTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumGayaFormFormType>;
  gte?: InputMaybe<EnumGayaFormFormType>;
  in?: InputMaybe<Array<InputMaybe<EnumGayaFormFormType>>>;
  lt?: InputMaybe<EnumGayaFormFormType>;
  lte?: InputMaybe<EnumGayaFormFormType>;
  ne?: InputMaybe<EnumGayaFormFormType>;
  nin?: InputMaybe<Array<InputMaybe<EnumGayaFormFormType>>>;
};

export type FilterFindManyGayaFormInput = {
  AND?: InputMaybe<Array<FilterFindManyGayaFormInput>>;
  OR?: InputMaybe<Array<FilterFindManyGayaFormInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyGayaFormOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  formType?: InputMaybe<EnumGayaFormFormType>;
  name?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  schema?: InputMaybe<Scalars['JSON']>;
  theme?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
  version?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyGayaFormNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyGayaFormOperatorsInput = {
  _id?: InputMaybe<FilterFindManyGayaForm_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyGayaFormCreatedAtOperatorsInput>;
  createdBy?: InputMaybe<FilterFindManyGayaFormCreatedByOperatorsInput>;
  deletedAt?: InputMaybe<FilterFindManyGayaFormDeletedAtOperatorsInput>;
  description?: InputMaybe<FilterFindManyGayaFormDescriptionOperatorsInput>;
  formType?: InputMaybe<FilterFindManyGayaFormFormTypeOperatorsInput>;
  name?: InputMaybe<FilterFindManyGayaFormNameOperatorsInput>;
  published?: InputMaybe<FilterFindManyGayaFormPublishedOperatorsInput>;
  schema?: InputMaybe<FilterFindManyGayaFormSchemaOperatorsInput>;
  theme?: InputMaybe<FilterFindManyGayaFormThemeOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyGayaFormUpdatedAtOperatorsInput>;
  updatedBy?: InputMaybe<FilterFindManyGayaFormUpdatedByOperatorsInput>;
  version?: InputMaybe<FilterFindManyGayaFormVersionOperatorsInput>;
};

export type FilterFindManyGayaFormPublishedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyGayaFormResponseContentOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindManyGayaFormResponseCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyGayaFormResponseCreatedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyGayaFormResponseDeletedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyGayaFormResponseFormIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyGayaFormResponseFormTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumGayaFormResponseFormType>;
  gte?: InputMaybe<EnumGayaFormResponseFormType>;
  in?: InputMaybe<Array<InputMaybe<EnumGayaFormResponseFormType>>>;
  lt?: InputMaybe<EnumGayaFormResponseFormType>;
  lte?: InputMaybe<EnumGayaFormResponseFormType>;
  ne?: InputMaybe<EnumGayaFormResponseFormType>;
  nin?: InputMaybe<Array<InputMaybe<EnumGayaFormResponseFormType>>>;
};

export type FilterFindManyGayaFormResponseFormVersionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyGayaFormResponseInput = {
  AND?: InputMaybe<Array<FilterFindManyGayaFormResponseInput>>;
  OR?: InputMaybe<Array<FilterFindManyGayaFormResponseInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyGayaFormResponseOperatorsInput>;
  content?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  formId?: InputMaybe<Scalars['MongoID']>;
  formType?: InputMaybe<EnumGayaFormResponseFormType>;
  formVersion?: InputMaybe<Scalars['Float']>;
  partnerName?: InputMaybe<Scalars['String']>;
  userEmail?: InputMaybe<Scalars['String']>;
  zendeskTicketId?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyGayaFormResponseOperatorsInput = {
  _id?: InputMaybe<FilterFindManyGayaFormResponse_IdOperatorsInput>;
  content?: InputMaybe<FilterFindManyGayaFormResponseContentOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyGayaFormResponseCreatedAtOperatorsInput>;
  createdBy?: InputMaybe<FilterFindManyGayaFormResponseCreatedByOperatorsInput>;
  deletedAt?: InputMaybe<FilterFindManyGayaFormResponseDeletedAtOperatorsInput>;
  formId?: InputMaybe<FilterFindManyGayaFormResponseFormIdOperatorsInput>;
  formType?: InputMaybe<FilterFindManyGayaFormResponseFormTypeOperatorsInput>;
  formVersion?: InputMaybe<FilterFindManyGayaFormResponseFormVersionOperatorsInput>;
  partnerName?: InputMaybe<FilterFindManyGayaFormResponsePartnerNameOperatorsInput>;
  userEmail?: InputMaybe<FilterFindManyGayaFormResponseUserEmailOperatorsInput>;
  zendeskTicketId?: InputMaybe<FilterFindManyGayaFormResponseZendeskTicketIdOperatorsInput>;
};

export type FilterFindManyGayaFormResponsePartnerNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyGayaFormResponseUserEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyGayaFormResponseZendeskTicketIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyGayaFormResponse_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyGayaFormSchemaOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindManyGayaFormThemeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyGayaFormUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyGayaFormUpdatedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyGayaFormVersionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyGayaForm_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyGayaThemeCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyGayaThemeCreatedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyGayaThemeInput = {
  AND?: InputMaybe<Array<FilterFindManyGayaThemeInput>>;
  OR?: InputMaybe<Array<FilterFindManyGayaThemeInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyGayaThemeOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  theme?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyGayaThemeNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyGayaThemeOperatorsInput = {
  _id?: InputMaybe<FilterFindManyGayaTheme_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyGayaThemeCreatedAtOperatorsInput>;
  createdBy?: InputMaybe<FilterFindManyGayaThemeCreatedByOperatorsInput>;
  name?: InputMaybe<FilterFindManyGayaThemeNameOperatorsInput>;
  published?: InputMaybe<FilterFindManyGayaThemePublishedOperatorsInput>;
  theme?: InputMaybe<FilterFindManyGayaThemeThemeOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyGayaThemeUpdatedAtOperatorsInput>;
  updatedBy?: InputMaybe<FilterFindManyGayaThemeUpdatedByOperatorsInput>;
};

export type FilterFindManyGayaThemePublishedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyGayaThemeThemeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindManyGayaThemeUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyGayaThemeUpdatedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyGayaTheme_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyGenericTaskAssignedToOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyGenericTaskCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyGenericTaskDeletedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyGenericTaskEntityCachedDataOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindManyGenericTaskEntityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyGenericTaskInput = {
  AND?: InputMaybe<Array<FilterFindManyGenericTaskInput>>;
  OR?: InputMaybe<Array<FilterFindManyGenericTaskInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyGenericTaskOperatorsInput>;
  assignedTo?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  busyFilter?: InputMaybe<FilterFindManyBusyEntityCachedDataInput>;
  busyUnmatchTaskFilter?: InputMaybe<FilterFindManyBusyUnmatchTaskEntityCachedDataInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  entityCachedData?: InputMaybe<Scalars['JSON']>;
  entityId?: InputMaybe<Scalars['String']>;
  filterQueryObject?: InputMaybe<Scalars['JSON']>;
  labelIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  luciFilter?: InputMaybe<FilterFindManyLuciEntityCachedDataInput>;
  parentTaskId?: InputMaybe<Scalars['MongoID']>;
  partnerName?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['MongoID']>;
  sherlockDecisionTaggingFilter?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataInput>;
  sherlockEscalationFilter?: InputMaybe<FilterFindManySherlockEscalationEntityCachedDataInput>;
  sherlockOrganizationFilter?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataInput>;
  status?: InputMaybe<EnumGenericTaskStatus>;
  type?: InputMaybe<EnumGenericTaskType>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyGenericTaskLabelIdsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyGenericTaskOperatorsInput = {
  _id?: InputMaybe<FilterFindManyGenericTask_IdOperatorsInput>;
  assignedTo?: InputMaybe<FilterFindManyGenericTaskAssignedToOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyGenericTaskCreatedAtOperatorsInput>;
  deletedAt?: InputMaybe<FilterFindManyGenericTaskDeletedAtOperatorsInput>;
  entityCachedData?: InputMaybe<FilterFindManyGenericTaskEntityCachedDataOperatorsInput>;
  entityId?: InputMaybe<FilterFindManyGenericTaskEntityIdOperatorsInput>;
  labelIds?: InputMaybe<FilterFindManyGenericTaskLabelIdsOperatorsInput>;
  parentTaskId?: InputMaybe<FilterFindManyGenericTaskParentTaskIdOperatorsInput>;
  partnerName?: InputMaybe<FilterFindManyGenericTaskPartnerNameOperatorsInput>;
  projectId?: InputMaybe<FilterFindManyGenericTaskProjectIdOperatorsInput>;
  status?: InputMaybe<FilterFindManyGenericTaskStatusOperatorsInput>;
  type?: InputMaybe<FilterFindManyGenericTaskTypeOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyGenericTaskUpdatedAtOperatorsInput>;
};

export type FilterFindManyGenericTaskParentTaskIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyGenericTaskPartnerNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyGenericTaskProjectIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyGenericTaskStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumGenericTaskStatus>;
  gte?: InputMaybe<EnumGenericTaskStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumGenericTaskStatus>>>;
  lt?: InputMaybe<EnumGenericTaskStatus>;
  lte?: InputMaybe<EnumGenericTaskStatus>;
  ne?: InputMaybe<EnumGenericTaskStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumGenericTaskStatus>>>;
};

export type FilterFindManyGenericTaskTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumGenericTaskType>;
  gte?: InputMaybe<EnumGenericTaskType>;
  in?: InputMaybe<Array<InputMaybe<EnumGenericTaskType>>>;
  lt?: InputMaybe<EnumGenericTaskType>;
  lte?: InputMaybe<EnumGenericTaskType>;
  ne?: InputMaybe<EnumGenericTaskType>;
  nin?: InputMaybe<Array<InputMaybe<EnumGenericTaskType>>>;
};

export type FilterFindManyGenericTaskUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyGenericTask_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyGroupEntityCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyGroupEntityDeletedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyGroupEntityEntityOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyGroupEntityFieldOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumGroupEntityField>;
  gte?: InputMaybe<EnumGroupEntityField>;
  in?: InputMaybe<Array<InputMaybe<EnumGroupEntityField>>>;
  lt?: InputMaybe<EnumGroupEntityField>;
  lte?: InputMaybe<EnumGroupEntityField>;
  ne?: InputMaybe<EnumGroupEntityField>;
  nin?: InputMaybe<Array<InputMaybe<EnumGroupEntityField>>>;
};

export type FilterFindManyGroupEntityInput = {
  AND?: InputMaybe<Array<FilterFindManyGroupEntityInput>>;
  OR?: InputMaybe<Array<FilterFindManyGroupEntityInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyGroupEntityOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  entity?: InputMaybe<Scalars['String']>;
  field?: InputMaybe<EnumGroupEntityField>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<EnumGroupEntityType>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyGroupEntityNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyGroupEntityOperatorsInput = {
  _id?: InputMaybe<FilterFindManyGroupEntity_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyGroupEntityCreatedAtOperatorsInput>;
  deletedAt?: InputMaybe<FilterFindManyGroupEntityDeletedAtOperatorsInput>;
  entity?: InputMaybe<FilterFindManyGroupEntityEntityOperatorsInput>;
  field?: InputMaybe<FilterFindManyGroupEntityFieldOperatorsInput>;
  name?: InputMaybe<FilterFindManyGroupEntityNameOperatorsInput>;
  type?: InputMaybe<FilterFindManyGroupEntityTypeOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyGroupEntityUpdatedAtOperatorsInput>;
};

export type FilterFindManyGroupEntityTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumGroupEntityType>;
  gte?: InputMaybe<EnumGroupEntityType>;
  in?: InputMaybe<Array<InputMaybe<EnumGroupEntityType>>>;
  lt?: InputMaybe<EnumGroupEntityType>;
  lte?: InputMaybe<EnumGroupEntityType>;
  ne?: InputMaybe<EnumGroupEntityType>;
  nin?: InputMaybe<Array<InputMaybe<EnumGroupEntityType>>>;
};

export type FilterFindManyGroupEntityUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyGroupEntity_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyIncidentBatchIdsBatchIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyIncidentBatchIdsExecutedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyIncidentBatchIdsFailedEntitiesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyIncidentBatchIdsGroupsIdsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyIncidentBatchIdsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  batchId?: InputMaybe<Scalars['MongoID']>;
  executedBy?: InputMaybe<Scalars['MongoID']>;
  failedEntities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  groupsIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  isRunning?: InputMaybe<Scalars['Boolean']>;
  mode?: InputMaybe<EnumIncidentBatchIdsMode>;
  runAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyIncidentBatchIdsIsRunningOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyIncidentBatchIdsModeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumIncidentBatchIdsMode>;
  gte?: InputMaybe<EnumIncidentBatchIdsMode>;
  in?: InputMaybe<Array<InputMaybe<EnumIncidentBatchIdsMode>>>;
  lt?: InputMaybe<EnumIncidentBatchIdsMode>;
  lte?: InputMaybe<EnumIncidentBatchIdsMode>;
  ne?: InputMaybe<EnumIncidentBatchIdsMode>;
  nin?: InputMaybe<Array<InputMaybe<EnumIncidentBatchIdsMode>>>;
};

export type FilterFindManyIncidentBatchIdsOperatorsInput = {
  _id?: InputMaybe<FilterFindManyIncidentBatchIds_IdOperatorsInput>;
  batchId?: InputMaybe<FilterFindManyIncidentBatchIdsBatchIdOperatorsInput>;
  executedBy?: InputMaybe<FilterFindManyIncidentBatchIdsExecutedByOperatorsInput>;
  failedEntities?: InputMaybe<FilterFindManyIncidentBatchIdsFailedEntitiesOperatorsInput>;
  groupsIds?: InputMaybe<FilterFindManyIncidentBatchIdsGroupsIdsOperatorsInput>;
  isRunning?: InputMaybe<FilterFindManyIncidentBatchIdsIsRunningOperatorsInput>;
  mode?: InputMaybe<FilterFindManyIncidentBatchIdsModeOperatorsInput>;
  runAt?: InputMaybe<FilterFindManyIncidentBatchIdsRunAtOperatorsInput>;
};

export type FilterFindManyIncidentBatchIdsRunAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyIncidentBatchIds_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyIncidentCalculationSizeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyIncidentCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyIncidentCreatedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyIncidentDeletedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyIncidentDescriptionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyIncidentEntityIdsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyIncidentEntityOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumIncidentEntity>;
  gte?: InputMaybe<EnumIncidentEntity>;
  in?: InputMaybe<Array<InputMaybe<EnumIncidentEntity>>>;
  lt?: InputMaybe<EnumIncidentEntity>;
  lte?: InputMaybe<EnumIncidentEntity>;
  ne?: InputMaybe<EnumIncidentEntity>;
  nin?: InputMaybe<Array<InputMaybe<EnumIncidentEntity>>>;
};

export type FilterFindManyIncidentExecutionLogBatchIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyIncidentExecutionLogCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyIncidentExecutionLogEntityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyIncidentExecutionLogEntityOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumIncidentExecutionLogEntity>;
  gte?: InputMaybe<EnumIncidentExecutionLogEntity>;
  in?: InputMaybe<Array<InputMaybe<EnumIncidentExecutionLogEntity>>>;
  lt?: InputMaybe<EnumIncidentExecutionLogEntity>;
  lte?: InputMaybe<EnumIncidentExecutionLogEntity>;
  ne?: InputMaybe<EnumIncidentExecutionLogEntity>;
  nin?: InputMaybe<Array<InputMaybe<EnumIncidentExecutionLogEntity>>>;
};

export type FilterFindManyIncidentExecutionLogFlowExecutionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyIncidentExecutionLogIncidentGroupOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyIncidentExecutionLogIncidentOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyIncidentExecutionLogInput = {
  AND?: InputMaybe<Array<FilterFindManyIncidentExecutionLogInput>>;
  OR?: InputMaybe<Array<FilterFindManyIncidentExecutionLogInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyIncidentExecutionLogOperatorsInput>;
  batchId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  entity?: InputMaybe<EnumIncidentExecutionLogEntity>;
  entityId?: InputMaybe<Scalars['Float']>;
  flowExecutionId?: InputMaybe<Scalars['MongoID']>;
  incident?: InputMaybe<Scalars['MongoID']>;
  incidentGroup?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyIncidentExecutionLogOperatorsInput = {
  _id?: InputMaybe<FilterFindManyIncidentExecutionLog_IdOperatorsInput>;
  batchId?: InputMaybe<FilterFindManyIncidentExecutionLogBatchIdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyIncidentExecutionLogCreatedAtOperatorsInput>;
  entity?: InputMaybe<FilterFindManyIncidentExecutionLogEntityOperatorsInput>;
  entityId?: InputMaybe<FilterFindManyIncidentExecutionLogEntityIdOperatorsInput>;
  flowExecutionId?: InputMaybe<FilterFindManyIncidentExecutionLogFlowExecutionIdOperatorsInput>;
  incident?: InputMaybe<FilterFindManyIncidentExecutionLogIncidentOperatorsInput>;
  incidentGroup?: InputMaybe<FilterFindManyIncidentExecutionLogIncidentGroupOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyIncidentExecutionLogUpdatedAtOperatorsInput>;
};

export type FilterFindManyIncidentExecutionLogUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyIncidentExecutionLog_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyIncidentFireHydrantUrlOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyIncidentGroupCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyIncidentGroupDeletedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyIncidentGroupFlowIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyIncidentGroupIncidentIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyIncidentGroupInput = {
  AND?: InputMaybe<Array<FilterFindManyIncidentGroupInput>>;
  OR?: InputMaybe<Array<FilterFindManyIncidentGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyIncidentGroupOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  flowId?: InputMaybe<Scalars['MongoID']>;
  incidentId?: InputMaybe<Scalars['MongoID']>;
  isTemplate?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<FilterFindManyIncidentGroupMetadataInput>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Float']>;
  rules?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyIncidentGroupIsTemplateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyIncidentGroupMetadataCalculatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyIncidentGroupMetadataEntityIdsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyIncidentGroupMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  calculatedAt?: InputMaybe<Scalars['Date']>;
  entityIds?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  totalEntities?: InputMaybe<Scalars['Float']>;
  totalEntitiesPercentage?: InputMaybe<Scalars['Float']>;
  totalTPV?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyIncidentGroupMetadataOperatorsInput = {
  _id?: InputMaybe<FilterFindManyIncidentGroupMetadata_IdOperatorsInput>;
  calculatedAt?: InputMaybe<FilterFindManyIncidentGroupMetadataCalculatedAtOperatorsInput>;
  entityIds?: InputMaybe<FilterFindManyIncidentGroupMetadataEntityIdsOperatorsInput>;
  totalEntities?: InputMaybe<FilterFindManyIncidentGroupMetadataTotalEntitiesOperatorsInput>;
  totalEntitiesPercentage?: InputMaybe<FilterFindManyIncidentGroupMetadataTotalEntitiesPercentageOperatorsInput>;
  totalTPV?: InputMaybe<FilterFindManyIncidentGroupMetadataTotalTpvOperatorsInput>;
};

export type FilterFindManyIncidentGroupMetadataTotalEntitiesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyIncidentGroupMetadataTotalEntitiesPercentageOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyIncidentGroupMetadataTotalTpvOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyIncidentGroupMetadata_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyIncidentGroupNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyIncidentGroupOperatorsInput = {
  _id?: InputMaybe<FilterFindManyIncidentGroup_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyIncidentGroupCreatedAtOperatorsInput>;
  deletedAt?: InputMaybe<FilterFindManyIncidentGroupDeletedAtOperatorsInput>;
  flowId?: InputMaybe<FilterFindManyIncidentGroupFlowIdOperatorsInput>;
  incidentId?: InputMaybe<FilterFindManyIncidentGroupIncidentIdOperatorsInput>;
  isTemplate?: InputMaybe<FilterFindManyIncidentGroupIsTemplateOperatorsInput>;
  metadata?: InputMaybe<FilterFindManyIncidentGroupMetadataOperatorsInput>;
  name?: InputMaybe<FilterFindManyIncidentGroupNameOperatorsInput>;
  order?: InputMaybe<FilterFindManyIncidentGroupOrderOperatorsInput>;
  rules?: InputMaybe<FilterFindManyIncidentGroupRulesOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyIncidentGroupUpdatedAtOperatorsInput>;
};

export type FilterFindManyIncidentGroupOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyIncidentGroupRulesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindManyIncidentGroupUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyIncidentGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyIncidentInput = {
  AND?: InputMaybe<Array<FilterFindManyIncidentInput>>;
  OR?: InputMaybe<Array<FilterFindManyIncidentInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyIncidentOperatorsInput>;
  batchIds?: InputMaybe<Array<InputMaybe<FilterFindManyIncidentBatchIdsInput>>>;
  calculationSize?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  /** Search by email in regExp */
  email?: InputMaybe<Scalars['String']>;
  entity?: InputMaybe<EnumIncidentEntity>;
  entityIds?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  fireHydrantUrl?: InputMaybe<Scalars['String']>;
  isCalculating?: InputMaybe<Scalars['Boolean']>;
  isCalculationFailed?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<EnumIncidentStatus>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyIncidentIsCalculatingOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyIncidentIsCalculationFailedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyIncidentNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyIncidentOperatorsInput = {
  _id?: InputMaybe<FilterFindManyIncident_IdOperatorsInput>;
  batchIds?: InputMaybe<FilterFindManyIncidentBatchIdsOperatorsInput>;
  calculationSize?: InputMaybe<FilterFindManyIncidentCalculationSizeOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyIncidentCreatedAtOperatorsInput>;
  createdBy?: InputMaybe<FilterFindManyIncidentCreatedByOperatorsInput>;
  deletedAt?: InputMaybe<FilterFindManyIncidentDeletedAtOperatorsInput>;
  description?: InputMaybe<FilterFindManyIncidentDescriptionOperatorsInput>;
  entity?: InputMaybe<FilterFindManyIncidentEntityOperatorsInput>;
  entityIds?: InputMaybe<FilterFindManyIncidentEntityIdsOperatorsInput>;
  fireHydrantUrl?: InputMaybe<FilterFindManyIncidentFireHydrantUrlOperatorsInput>;
  isCalculating?: InputMaybe<FilterFindManyIncidentIsCalculatingOperatorsInput>;
  isCalculationFailed?: InputMaybe<FilterFindManyIncidentIsCalculationFailedOperatorsInput>;
  name?: InputMaybe<FilterFindManyIncidentNameOperatorsInput>;
  status?: InputMaybe<FilterFindManyIncidentStatusOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyIncidentUpdatedAtOperatorsInput>;
};

export type FilterFindManyIncidentStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumIncidentStatus>;
  gte?: InputMaybe<EnumIncidentStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumIncidentStatus>>>;
  lt?: InputMaybe<EnumIncidentStatus>;
  lte?: InputMaybe<EnumIncidentStatus>;
  ne?: InputMaybe<EnumIncidentStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumIncidentStatus>>>;
};

export type FilterFindManyIncidentUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyIncident_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyLabelColorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyLabelCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyLabelCreatedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyLabelDeletedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyLabelDescriptionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyLabelInput = {
  AND?: InputMaybe<Array<FilterFindManyLabelInput>>;
  OR?: InputMaybe<Array<FilterFindManyLabelInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyLabelOperatorsInput>;
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Float']>;
  rules?: InputMaybe<Array<InputMaybe<FilterFindManyLabelRulesInput>>>;
  type?: InputMaybe<EnumLabelType>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyLabelNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyLabelOperatorsInput = {
  _id?: InputMaybe<FilterFindManyLabel_IdOperatorsInput>;
  color?: InputMaybe<FilterFindManyLabelColorOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyLabelCreatedAtOperatorsInput>;
  createdBy?: InputMaybe<FilterFindManyLabelCreatedByOperatorsInput>;
  deletedAt?: InputMaybe<FilterFindManyLabelDeletedAtOperatorsInput>;
  description?: InputMaybe<FilterFindManyLabelDescriptionOperatorsInput>;
  name?: InputMaybe<FilterFindManyLabelNameOperatorsInput>;
  priority?: InputMaybe<FilterFindManyLabelPriorityOperatorsInput>;
  rules?: InputMaybe<FilterFindManyLabelRulesOperatorsInput>;
  type?: InputMaybe<FilterFindManyLabelTypeOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyLabelUpdatedAtOperatorsInput>;
};

export type FilterFindManyLabelPriorityOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyLabelRulesInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  logic?: InputMaybe<Scalars['String']>;
  tree?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyLabelRulesLogicOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyLabelRulesOperatorsInput = {
  _id?: InputMaybe<FilterFindManyLabelRules_IdOperatorsInput>;
  logic?: InputMaybe<FilterFindManyLabelRulesLogicOperatorsInput>;
  tree?: InputMaybe<FilterFindManyLabelRulesTreeOperatorsInput>;
};

export type FilterFindManyLabelRulesTreeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyLabelRules_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyLabelTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumLabelType>;
  gte?: InputMaybe<EnumLabelType>;
  in?: InputMaybe<Array<InputMaybe<EnumLabelType>>>;
  lt?: InputMaybe<EnumLabelType>;
  lte?: InputMaybe<EnumLabelType>;
  ne?: InputMaybe<EnumLabelType>;
  nin?: InputMaybe<Array<InputMaybe<EnumLabelType>>>;
};

export type FilterFindManyLabelUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyLabel_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyLogActionResultOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindManyLogActionTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumLogActionType>;
  gte?: InputMaybe<EnumLogActionType>;
  in?: InputMaybe<Array<InputMaybe<EnumLogActionType>>>;
  lt?: InputMaybe<EnumLogActionType>;
  lte?: InputMaybe<EnumLogActionType>;
  ne?: InputMaybe<EnumLogActionType>;
  nin?: InputMaybe<Array<InputMaybe<EnumLogActionType>>>;
};

export type FilterFindManyLogCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyLogDeletedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyLogInput = {
  AND?: InputMaybe<Array<FilterFindManyLogInput>>;
  OR?: InputMaybe<Array<FilterFindManyLogInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyLogOperatorsInput>;
  actionResult?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  actionType?: InputMaybe<EnumLogActionType>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  payload?: InputMaybe<Scalars['JSON']>;
  route?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<EnumLogSource>;
  taskId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  userId?: InputMaybe<Scalars['MongoID']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyLogOperatorsInput = {
  _id?: InputMaybe<FilterFindManyLog_IdOperatorsInput>;
  actionResult?: InputMaybe<FilterFindManyLogActionResultOperatorsInput>;
  actionType?: InputMaybe<FilterFindManyLogActionTypeOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyLogCreatedAtOperatorsInput>;
  deletedAt?: InputMaybe<FilterFindManyLogDeletedAtOperatorsInput>;
  payload?: InputMaybe<FilterFindManyLogPayloadOperatorsInput>;
  route?: InputMaybe<FilterFindManyLogRouteOperatorsInput>;
  source?: InputMaybe<FilterFindManyLogSourceOperatorsInput>;
  taskId?: InputMaybe<FilterFindManyLogTaskIdOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyLogUpdatedAtOperatorsInput>;
  userId?: InputMaybe<FilterFindManyLogUserIdOperatorsInput>;
};

export type FilterFindManyLogPayloadOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindManyLogRouteOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyLogSourceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumLogSource>;
  gte?: InputMaybe<EnumLogSource>;
  in?: InputMaybe<Array<InputMaybe<EnumLogSource>>>;
  lt?: InputMaybe<EnumLogSource>;
  lte?: InputMaybe<EnumLogSource>;
  ne?: InputMaybe<EnumLogSource>;
  nin?: InputMaybe<Array<InputMaybe<EnumLogSource>>>;
};

export type FilterFindManyLogTaskIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyLogUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyLogUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyLog_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyLuciEntityCachedDataAmountOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyLuciEntityCachedDataCaseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyLuciEntityCachedDataChargeReferenceNumberOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyLuciEntityCachedDataChargebackAccountOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumLuciEntityCachedDataChargebackAccount>;
  gte?: InputMaybe<EnumLuciEntityCachedDataChargebackAccount>;
  in?: InputMaybe<Array<InputMaybe<EnumLuciEntityCachedDataChargebackAccount>>>;
  lt?: InputMaybe<EnumLuciEntityCachedDataChargebackAccount>;
  lte?: InputMaybe<EnumLuciEntityCachedDataChargebackAccount>;
  ne?: InputMaybe<EnumLuciEntityCachedDataChargebackAccount>;
  nin?: InputMaybe<Array<InputMaybe<EnumLuciEntityCachedDataChargebackAccount>>>;
};

export type FilterFindManyLuciEntityCachedDataChargebackBankDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyLuciEntityCachedDataClaimOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyLuciEntityCachedDataCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyLuciEntityCachedDataCreatorOriginOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumLuciEntityCachedDataCreatorOrigin>;
  gte?: InputMaybe<EnumLuciEntityCachedDataCreatorOrigin>;
  in?: InputMaybe<Array<InputMaybe<EnumLuciEntityCachedDataCreatorOrigin>>>;
  lt?: InputMaybe<EnumLuciEntityCachedDataCreatorOrigin>;
  lte?: InputMaybe<EnumLuciEntityCachedDataCreatorOrigin>;
  ne?: InputMaybe<EnumLuciEntityCachedDataCreatorOrigin>;
  nin?: InputMaybe<Array<InputMaybe<EnumLuciEntityCachedDataCreatorOrigin>>>;
};

export type FilterFindManyLuciEntityCachedDataCurrentVersionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyLuciEntityCachedDataDisputedInternallyOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyLuciEntityCachedDataDisputedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyLuciEntityCachedDataDueDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyLuciEntityCachedDataEntityOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumLuciEntityCachedDataEntity>;
  gte?: InputMaybe<EnumLuciEntityCachedDataEntity>;
  in?: InputMaybe<Array<InputMaybe<EnumLuciEntityCachedDataEntity>>>;
  lt?: InputMaybe<EnumLuciEntityCachedDataEntity>;
  lte?: InputMaybe<EnumLuciEntityCachedDataEntity>;
  ne?: InputMaybe<EnumLuciEntityCachedDataEntity>;
  nin?: InputMaybe<Array<InputMaybe<EnumLuciEntityCachedDataEntity>>>;
};

export type FilterFindManyLuciEntityCachedDataExternalNotesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyLuciEntityCachedDataFinancingProviderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyLuciEntityCachedDataHighLevelClaimOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumLuciEntityCachedDataHighLevelClaim>;
  gte?: InputMaybe<EnumLuciEntityCachedDataHighLevelClaim>;
  in?: InputMaybe<Array<InputMaybe<EnumLuciEntityCachedDataHighLevelClaim>>>;
  lt?: InputMaybe<EnumLuciEntityCachedDataHighLevelClaim>;
  lte?: InputMaybe<EnumLuciEntityCachedDataHighLevelClaim>;
  ne?: InputMaybe<EnumLuciEntityCachedDataHighLevelClaim>;
  nin?: InputMaybe<Array<InputMaybe<EnumLuciEntityCachedDataHighLevelClaim>>>;
};

export type FilterFindManyLuciEntityCachedDataIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyLuciEntityCachedDataInput = {
  AND?: InputMaybe<Array<FilterFindManyLuciEntityCachedDataInput>>;
  OR?: InputMaybe<Array<FilterFindManyLuciEntityCachedDataInput>>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyLuciEntityCachedDataOperatorsInput>;
  amount?: InputMaybe<Scalars['Float']>;
  caseId?: InputMaybe<Scalars['String']>;
  chargeReferenceNumber?: InputMaybe<Scalars['String']>;
  chargebackAccount?: InputMaybe<EnumLuciEntityCachedDataChargebackAccount>;
  chargebackBankDate?: InputMaybe<Scalars['Date']>;
  claim?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  creatorOrigin?: InputMaybe<EnumLuciEntityCachedDataCreatorOrigin>;
  currentVersionId?: InputMaybe<Scalars['MongoID']>;
  disputed?: InputMaybe<Scalars['Boolean']>;
  disputedInternally?: InputMaybe<Scalars['Boolean']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  entity?: InputMaybe<EnumLuciEntityCachedDataEntity>;
  externalNotes?: InputMaybe<Scalars['String']>;
  financingProvider?: InputMaybe<Scalars['String']>;
  highLevelClaim?: InputMaybe<EnumLuciEntityCachedDataHighLevelClaim>;
  id?: InputMaybe<Scalars['String']>;
  installmentNumber?: InputMaybe<Scalars['Float']>;
  lastUpdatedBy?: InputMaybe<Scalars['String']>;
  noDisputeReason?: InputMaybe<EnumLuciEntityCachedDataNoDisputeReason>;
  noDisputeReasonOther?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Float']>;
  originalFailureCode?: InputMaybe<Scalars['String']>;
  originalLossCreatedAt?: InputMaybe<Scalars['Date']>;
  partner?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<FilterFindManyLuciEntityCachedDataPaymentInput>;
  paymentId?: InputMaybe<Scalars['Float']>;
  reason?: InputMaybe<EnumLuciEntityCachedDataReason>;
  reasonOther?: InputMaybe<Scalars['String']>;
  recoveredByJustt?: InputMaybe<Scalars['Boolean']>;
  recoveryAccount?: InputMaybe<EnumLuciEntityCachedDataRecoveryAccount>;
  recoveryBankDate?: InputMaybe<Scalars['Date']>;
  recoveryDate?: InputMaybe<Scalars['Date']>;
  recoveryMethod?: InputMaybe<EnumLuciEntityCachedDataRecoveryMethod>;
  recoveryMethodOther?: InputMaybe<Scalars['String']>;
  scenario?: InputMaybe<EnumLuciEntityCachedDataScenario>;
  scenarioOther?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<EnumLuciEntityCachedDataSource>;
  status?: InputMaybe<EnumLuciEntityCachedDataStatus>;
  subStatus?: InputMaybe<EnumLuciEntityCachedDataSubStatus>;
  subStatusOther?: InputMaybe<Scalars['String']>;
  transferId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyLuciEntityCachedDataInstallmentNumberOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyLuciEntityCachedDataLastUpdatedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyLuciEntityCachedDataNoDisputeReasonOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumLuciEntityCachedDataNoDisputeReason>;
  gte?: InputMaybe<EnumLuciEntityCachedDataNoDisputeReason>;
  in?: InputMaybe<Array<InputMaybe<EnumLuciEntityCachedDataNoDisputeReason>>>;
  lt?: InputMaybe<EnumLuciEntityCachedDataNoDisputeReason>;
  lte?: InputMaybe<EnumLuciEntityCachedDataNoDisputeReason>;
  ne?: InputMaybe<EnumLuciEntityCachedDataNoDisputeReason>;
  nin?: InputMaybe<Array<InputMaybe<EnumLuciEntityCachedDataNoDisputeReason>>>;
};

export type FilterFindManyLuciEntityCachedDataNoDisputeReasonOtherOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyLuciEntityCachedDataNotesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyLuciEntityCachedDataOperatorsInput = {
  amount?: InputMaybe<FilterFindManyLuciEntityCachedDataAmountOperatorsInput>;
  caseId?: InputMaybe<FilterFindManyLuciEntityCachedDataCaseIdOperatorsInput>;
  chargeReferenceNumber?: InputMaybe<FilterFindManyLuciEntityCachedDataChargeReferenceNumberOperatorsInput>;
  chargebackAccount?: InputMaybe<FilterFindManyLuciEntityCachedDataChargebackAccountOperatorsInput>;
  chargebackBankDate?: InputMaybe<FilterFindManyLuciEntityCachedDataChargebackBankDateOperatorsInput>;
  claim?: InputMaybe<FilterFindManyLuciEntityCachedDataClaimOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyLuciEntityCachedDataCreatedAtOperatorsInput>;
  creatorOrigin?: InputMaybe<FilterFindManyLuciEntityCachedDataCreatorOriginOperatorsInput>;
  currentVersionId?: InputMaybe<FilterFindManyLuciEntityCachedDataCurrentVersionIdOperatorsInput>;
  disputed?: InputMaybe<FilterFindManyLuciEntityCachedDataDisputedOperatorsInput>;
  disputedInternally?: InputMaybe<FilterFindManyLuciEntityCachedDataDisputedInternallyOperatorsInput>;
  dueDate?: InputMaybe<FilterFindManyLuciEntityCachedDataDueDateOperatorsInput>;
  entity?: InputMaybe<FilterFindManyLuciEntityCachedDataEntityOperatorsInput>;
  externalNotes?: InputMaybe<FilterFindManyLuciEntityCachedDataExternalNotesOperatorsInput>;
  financingProvider?: InputMaybe<FilterFindManyLuciEntityCachedDataFinancingProviderOperatorsInput>;
  highLevelClaim?: InputMaybe<FilterFindManyLuciEntityCachedDataHighLevelClaimOperatorsInput>;
  id?: InputMaybe<FilterFindManyLuciEntityCachedDataIdOperatorsInput>;
  installmentNumber?: InputMaybe<FilterFindManyLuciEntityCachedDataInstallmentNumberOperatorsInput>;
  lastUpdatedBy?: InputMaybe<FilterFindManyLuciEntityCachedDataLastUpdatedByOperatorsInput>;
  noDisputeReason?: InputMaybe<FilterFindManyLuciEntityCachedDataNoDisputeReasonOperatorsInput>;
  noDisputeReasonOther?: InputMaybe<FilterFindManyLuciEntityCachedDataNoDisputeReasonOtherOperatorsInput>;
  notes?: InputMaybe<FilterFindManyLuciEntityCachedDataNotesOperatorsInput>;
  organizationId?: InputMaybe<FilterFindManyLuciEntityCachedDataOrganizationIdOperatorsInput>;
  originalFailureCode?: InputMaybe<FilterFindManyLuciEntityCachedDataOriginalFailureCodeOperatorsInput>;
  originalLossCreatedAt?: InputMaybe<FilterFindManyLuciEntityCachedDataOriginalLossCreatedAtOperatorsInput>;
  partner?: InputMaybe<FilterFindManyLuciEntityCachedDataPartnerOperatorsInput>;
  payment?: InputMaybe<FilterFindManyLuciEntityCachedDataPaymentOperatorsInput>;
  paymentId?: InputMaybe<FilterFindManyLuciEntityCachedDataPaymentIdOperatorsInput>;
  reason?: InputMaybe<FilterFindManyLuciEntityCachedDataReasonOperatorsInput>;
  reasonOther?: InputMaybe<FilterFindManyLuciEntityCachedDataReasonOtherOperatorsInput>;
  recoveredByJustt?: InputMaybe<FilterFindManyLuciEntityCachedDataRecoveredByJusttOperatorsInput>;
  recoveryAccount?: InputMaybe<FilterFindManyLuciEntityCachedDataRecoveryAccountOperatorsInput>;
  recoveryBankDate?: InputMaybe<FilterFindManyLuciEntityCachedDataRecoveryBankDateOperatorsInput>;
  recoveryDate?: InputMaybe<FilterFindManyLuciEntityCachedDataRecoveryDateOperatorsInput>;
  recoveryMethod?: InputMaybe<FilterFindManyLuciEntityCachedDataRecoveryMethodOperatorsInput>;
  recoveryMethodOther?: InputMaybe<FilterFindManyLuciEntityCachedDataRecoveryMethodOtherOperatorsInput>;
  scenario?: InputMaybe<FilterFindManyLuciEntityCachedDataScenarioOperatorsInput>;
  scenarioOther?: InputMaybe<FilterFindManyLuciEntityCachedDataScenarioOtherOperatorsInput>;
  source?: InputMaybe<FilterFindManyLuciEntityCachedDataSourceOperatorsInput>;
  status?: InputMaybe<FilterFindManyLuciEntityCachedDataStatusOperatorsInput>;
  subStatus?: InputMaybe<FilterFindManyLuciEntityCachedDataSubStatusOperatorsInput>;
  subStatusOther?: InputMaybe<FilterFindManyLuciEntityCachedDataSubStatusOtherOperatorsInput>;
  transferId?: InputMaybe<FilterFindManyLuciEntityCachedDataTransferIdOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyLuciEntityCachedDataUpdatedAtOperatorsInput>;
};

export type FilterFindManyLuciEntityCachedDataOrganizationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyLuciEntityCachedDataOriginalFailureCodeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyLuciEntityCachedDataOriginalLossCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyLuciEntityCachedDataPartnerOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyLuciEntityCachedDataPaymentAmountOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyLuciEntityCachedDataPaymentIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyLuciEntityCachedDataPaymentInput = {
  amount?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['Float']>;
  organization?: InputMaybe<FilterFindManyLuciEntityCachedDataPaymentOrganizationInput>;
};

export type FilterFindManyLuciEntityCachedDataPaymentOperatorsInput = {
  amount?: InputMaybe<FilterFindManyLuciEntityCachedDataPaymentAmountOperatorsInput>;
  id?: InputMaybe<FilterFindManyLuciEntityCachedDataPaymentIdOperatorsInput>;
  organization?: InputMaybe<FilterFindManyLuciEntityCachedDataPaymentOrganizationOperatorsInput>;
};

export type FilterFindManyLuciEntityCachedDataPaymentOrganizationCompanyNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyLuciEntityCachedDataPaymentOrganizationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyLuciEntityCachedDataPaymentOrganizationInput = {
  companyName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyLuciEntityCachedDataPaymentOrganizationOperatorsInput = {
  companyName?: InputMaybe<FilterFindManyLuciEntityCachedDataPaymentOrganizationCompanyNameOperatorsInput>;
  id?: InputMaybe<FilterFindManyLuciEntityCachedDataPaymentOrganizationIdOperatorsInput>;
};

export type FilterFindManyLuciEntityCachedDataReasonOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumLuciEntityCachedDataReason>;
  gte?: InputMaybe<EnumLuciEntityCachedDataReason>;
  in?: InputMaybe<Array<InputMaybe<EnumLuciEntityCachedDataReason>>>;
  lt?: InputMaybe<EnumLuciEntityCachedDataReason>;
  lte?: InputMaybe<EnumLuciEntityCachedDataReason>;
  ne?: InputMaybe<EnumLuciEntityCachedDataReason>;
  nin?: InputMaybe<Array<InputMaybe<EnumLuciEntityCachedDataReason>>>;
};

export type FilterFindManyLuciEntityCachedDataReasonOtherOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyLuciEntityCachedDataRecoveredByJusttOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyLuciEntityCachedDataRecoveryAccountOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumLuciEntityCachedDataRecoveryAccount>;
  gte?: InputMaybe<EnumLuciEntityCachedDataRecoveryAccount>;
  in?: InputMaybe<Array<InputMaybe<EnumLuciEntityCachedDataRecoveryAccount>>>;
  lt?: InputMaybe<EnumLuciEntityCachedDataRecoveryAccount>;
  lte?: InputMaybe<EnumLuciEntityCachedDataRecoveryAccount>;
  ne?: InputMaybe<EnumLuciEntityCachedDataRecoveryAccount>;
  nin?: InputMaybe<Array<InputMaybe<EnumLuciEntityCachedDataRecoveryAccount>>>;
};

export type FilterFindManyLuciEntityCachedDataRecoveryBankDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyLuciEntityCachedDataRecoveryDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyLuciEntityCachedDataRecoveryMethodOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumLuciEntityCachedDataRecoveryMethod>;
  gte?: InputMaybe<EnumLuciEntityCachedDataRecoveryMethod>;
  in?: InputMaybe<Array<InputMaybe<EnumLuciEntityCachedDataRecoveryMethod>>>;
  lt?: InputMaybe<EnumLuciEntityCachedDataRecoveryMethod>;
  lte?: InputMaybe<EnumLuciEntityCachedDataRecoveryMethod>;
  ne?: InputMaybe<EnumLuciEntityCachedDataRecoveryMethod>;
  nin?: InputMaybe<Array<InputMaybe<EnumLuciEntityCachedDataRecoveryMethod>>>;
};

export type FilterFindManyLuciEntityCachedDataRecoveryMethodOtherOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyLuciEntityCachedDataScenarioOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumLuciEntityCachedDataScenario>;
  gte?: InputMaybe<EnumLuciEntityCachedDataScenario>;
  in?: InputMaybe<Array<InputMaybe<EnumLuciEntityCachedDataScenario>>>;
  lt?: InputMaybe<EnumLuciEntityCachedDataScenario>;
  lte?: InputMaybe<EnumLuciEntityCachedDataScenario>;
  ne?: InputMaybe<EnumLuciEntityCachedDataScenario>;
  nin?: InputMaybe<Array<InputMaybe<EnumLuciEntityCachedDataScenario>>>;
};

export type FilterFindManyLuciEntityCachedDataScenarioOtherOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyLuciEntityCachedDataSourceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumLuciEntityCachedDataSource>;
  gte?: InputMaybe<EnumLuciEntityCachedDataSource>;
  in?: InputMaybe<Array<InputMaybe<EnumLuciEntityCachedDataSource>>>;
  lt?: InputMaybe<EnumLuciEntityCachedDataSource>;
  lte?: InputMaybe<EnumLuciEntityCachedDataSource>;
  ne?: InputMaybe<EnumLuciEntityCachedDataSource>;
  nin?: InputMaybe<Array<InputMaybe<EnumLuciEntityCachedDataSource>>>;
};

export type FilterFindManyLuciEntityCachedDataStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumLuciEntityCachedDataStatus>;
  gte?: InputMaybe<EnumLuciEntityCachedDataStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumLuciEntityCachedDataStatus>>>;
  lt?: InputMaybe<EnumLuciEntityCachedDataStatus>;
  lte?: InputMaybe<EnumLuciEntityCachedDataStatus>;
  ne?: InputMaybe<EnumLuciEntityCachedDataStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumLuciEntityCachedDataStatus>>>;
};

export type FilterFindManyLuciEntityCachedDataSubStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumLuciEntityCachedDataSubStatus>;
  gte?: InputMaybe<EnumLuciEntityCachedDataSubStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumLuciEntityCachedDataSubStatus>>>;
  lt?: InputMaybe<EnumLuciEntityCachedDataSubStatus>;
  lte?: InputMaybe<EnumLuciEntityCachedDataSubStatus>;
  ne?: InputMaybe<EnumLuciEntityCachedDataSubStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumLuciEntityCachedDataSubStatus>>>;
};

export type FilterFindManyLuciEntityCachedDataSubStatusOtherOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyLuciEntityCachedDataTransferIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyLuciEntityCachedDataUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyModuleInput = {
  AND?: InputMaybe<Array<FilterFindManyModuleInput>>;
  OR?: InputMaybe<Array<FilterFindManyModuleInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyModuleOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyModuleOperatorsInput = {
  _id?: InputMaybe<FilterFindManyModule_IdOperatorsInput>;
};

export type FilterFindManyModuleRoutesInput = {
  AND?: InputMaybe<Array<FilterFindManyModuleRoutesInput>>;
  OR?: InputMaybe<Array<FilterFindManyModuleRoutesInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyModuleRoutesOperatorsInput>;
  module?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyModuleRoutesOperatorsInput = {
  _id?: InputMaybe<FilterFindManyModuleRoutes_IdOperatorsInput>;
  path?: InputMaybe<FilterFindManyModuleRoutesPathOperatorsInput>;
};

export type FilterFindManyModuleRoutesPathOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyModuleRoutes_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyModule_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyProjectCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyProjectCreatedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyProjectDescriptionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyProjectDueDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyProjectInput = {
  AND?: InputMaybe<Array<FilterFindManyProjectInput>>;
  OR?: InputMaybe<Array<FilterFindManyProjectInput>>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyProjectOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  startDate?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<EnumProjectStatus>;
  totalTasks?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyProjectNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyProjectOperatorsInput = {
  createdAt?: InputMaybe<FilterFindManyProjectCreatedAtOperatorsInput>;
  createdBy?: InputMaybe<FilterFindManyProjectCreatedByOperatorsInput>;
  description?: InputMaybe<FilterFindManyProjectDescriptionOperatorsInput>;
  dueDate?: InputMaybe<FilterFindManyProjectDueDateOperatorsInput>;
  name?: InputMaybe<FilterFindManyProjectNameOperatorsInput>;
  participants?: InputMaybe<FilterFindManyProjectParticipantsOperatorsInput>;
  startDate?: InputMaybe<FilterFindManyProjectStartDateOperatorsInput>;
  status?: InputMaybe<FilterFindManyProjectStatusOperatorsInput>;
  totalTasks?: InputMaybe<FilterFindManyProjectTotalTasksOperatorsInput>;
};

export type FilterFindManyProjectParticipantsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyProjectStartDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyProjectStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumProjectStatus>;
  gte?: InputMaybe<EnumProjectStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumProjectStatus>>>;
  lt?: InputMaybe<EnumProjectStatus>;
  lte?: InputMaybe<EnumProjectStatus>;
  ne?: InputMaybe<EnumProjectStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumProjectStatus>>>;
};

export type FilterFindManyProjectTotalTasksOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyRoleInput = {
  AND?: InputMaybe<Array<FilterFindManyRoleInput>>;
  OR?: InputMaybe<Array<FilterFindManyRoleInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyRoleOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  forbiddenGroupEntityIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  name?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyRoleOperatorsInput = {
  _id?: InputMaybe<FilterFindManyRole_IdOperatorsInput>;
};

export type FilterFindManyRole_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyRubricFieldsInput = {
  displayName?: InputMaybe<Scalars['String']>;
  displayText?: InputMaybe<Scalars['String']>;
  displayType?: InputMaybe<EnumRubricFieldsDisplayType>;
  key?: InputMaybe<Scalars['String']>;
  linkFormat?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyRubricInput = {
  AND?: InputMaybe<Array<FilterFindManyRubricInput>>;
  OR?: InputMaybe<Array<FilterFindManyRubricInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyRubricOperatorsInput>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  entity?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<Array<InputMaybe<FilterFindManyRubricFieldsInput>>>;
  name?: InputMaybe<Scalars['String']>;
  tableCollection?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<EnumRubricType>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyRubricOperatorsInput = {
  _id?: InputMaybe<FilterFindManyRubric_IdOperatorsInput>;
};

export type FilterFindManyRubric_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyRuleInput = {
  AND?: InputMaybe<Array<FilterFindManyRuleInput>>;
  OR?: InputMaybe<Array<FilterFindManyRuleInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyRuleOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  logic?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  tree?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  version?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyRuleOperatorsInput = {
  _id?: InputMaybe<FilterFindManyRule_IdOperatorsInput>;
};

export type FilterFindManyRule_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataBillCurrencyOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataBillInput = {
  currency?: InputMaybe<Scalars['String']>;
  recurringBillIndex?: InputMaybe<Scalars['Float']>;
  totalAmount?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataBillOperatorsInput = {
  currency?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataBillCurrencyOperatorsInput>;
  recurringBillIndex?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataBillRecurringBillIndexOperatorsInput>;
  totalAmount?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataBillTotalAmountOperatorsInput>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataBillRecurringBillIndexOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataBillTotalAmountOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataDeliveryMethodCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataDeliveryMethodDeliveryTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataDeliveryMethodDeliveryType>;
  gte?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataDeliveryMethodDeliveryType>;
  in?: InputMaybe<Array<InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataDeliveryMethodDeliveryType>>>;
  lt?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataDeliveryMethodDeliveryType>;
  lte?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataDeliveryMethodDeliveryType>;
  ne?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataDeliveryMethodDeliveryType>;
  nin?: InputMaybe<Array<InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataDeliveryMethodDeliveryType>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataDeliveryMethodIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataDeliveryMethodInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  deliveryType?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataDeliveryMethodDeliveryType>;
  id?: InputMaybe<Scalars['Float']>;
  verifiedStatus?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataDeliveryMethodVerifiedStatus>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataDeliveryMethodOperatorsInput = {
  createdAt?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataDeliveryMethodCreatedAtOperatorsInput>;
  deliveryType?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataDeliveryMethodDeliveryTypeOperatorsInput>;
  id?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataDeliveryMethodIdOperatorsInput>;
  verifiedStatus?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataDeliveryMethodVerifiedStatusOperatorsInput>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataDeliveryMethodVerifiedStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataDeliveryMethodVerifiedStatus>;
  gte?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataDeliveryMethodVerifiedStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataDeliveryMethodVerifiedStatus>>>;
  lt?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataDeliveryMethodVerifiedStatus>;
  lte?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataDeliveryMethodVerifiedStatus>;
  ne?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataDeliveryMethodVerifiedStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataDeliveryMethodVerifiedStatus>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataEnrichmentDataOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesClientIpAgeForOrganizationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesClientIpAgeForUserOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesDoesOrgOweMoneyOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesHasFileRequestsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesInput = {
  clientIpAgeForOrganization?: InputMaybe<Scalars['Float']>;
  clientIpAgeForUser?: InputMaybe<Scalars['Float']>;
  doesOrgOweMoney?: InputMaybe<Scalars['Boolean']>;
  hasFileRequests?: InputMaybe<Scalars['Boolean']>;
  invoiceOrNoteHasSanctionedWord?: InputMaybe<Scalars['Boolean']>;
  invoiceOrNoteHasSanctionedWordError?: InputMaybe<Scalars['Boolean']>;
  isApFinancingPayment?: InputMaybe<Scalars['Boolean']>;
  isCardWithSimilarDataApproved?: InputMaybe<Scalars['Boolean']>;
  isEmailVerified?: InputMaybe<Scalars['Boolean']>;
  isFRR?: InputMaybe<Scalars['Boolean']>;
  isGoodsReceived?: InputMaybe<Scalars['Boolean']>;
  isHighAmountForFS?: InputMaybe<Scalars['Boolean']>;
  isPaymentExpedited?: InputMaybe<Scalars['Boolean']>;
  numManuallyApprovedPayments?: InputMaybe<Scalars['Float']>;
  numOrganizationVendorCompletedPayments?: InputMaybe<Scalars['Float']>;
  payeeIdmScreeningNumHits?: InputMaybe<Scalars['Float']>;
  payorCreateOrigin?: InputMaybe<Scalars['String']>;
  payorIdmScreeningNumHits?: InputMaybe<Scalars['Float']>;
  vendorHasHandle?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesInvoiceOrNoteHasSanctionedWordErrorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesInvoiceOrNoteHasSanctionedWordOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesIsApFinancingPaymentOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesIsCardWithSimilarDataApprovedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesIsEmailVerifiedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesIsFrrOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesIsGoodsReceivedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesIsHighAmountForFsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesIsPaymentExpeditedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesNumManuallyApprovedPaymentsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesNumOrganizationVendorCompletedPaymentsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesOperatorsInput = {
  clientIpAgeForOrganization?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesClientIpAgeForOrganizationOperatorsInput>;
  clientIpAgeForUser?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesClientIpAgeForUserOperatorsInput>;
  doesOrgOweMoney?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesDoesOrgOweMoneyOperatorsInput>;
  hasFileRequests?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesHasFileRequestsOperatorsInput>;
  invoiceOrNoteHasSanctionedWord?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesInvoiceOrNoteHasSanctionedWordOperatorsInput>;
  invoiceOrNoteHasSanctionedWordError?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesInvoiceOrNoteHasSanctionedWordErrorOperatorsInput>;
  isApFinancingPayment?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesIsApFinancingPaymentOperatorsInput>;
  isCardWithSimilarDataApproved?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesIsCardWithSimilarDataApprovedOperatorsInput>;
  isEmailVerified?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesIsEmailVerifiedOperatorsInput>;
  isFRR?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesIsFrrOperatorsInput>;
  isGoodsReceived?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesIsGoodsReceivedOperatorsInput>;
  isHighAmountForFS?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesIsHighAmountForFsOperatorsInput>;
  isPaymentExpedited?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesIsPaymentExpeditedOperatorsInput>;
  numManuallyApprovedPayments?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesNumManuallyApprovedPaymentsOperatorsInput>;
  numOrganizationVendorCompletedPayments?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesNumOrganizationVendorCompletedPaymentsOperatorsInput>;
  payeeIdmScreeningNumHits?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesPayeeIdmScreeningNumHitsOperatorsInput>;
  payorCreateOrigin?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesPayorCreateOriginOperatorsInput>;
  payorIdmScreeningNumHits?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesPayorIdmScreeningNumHitsOperatorsInput>;
  vendorHasHandle?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesVendorHasHandleOperatorsInput>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesPayeeIdmScreeningNumHitsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesPayorCreateOriginOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesPayorIdmScreeningNumHitsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesVendorHasHandleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFirstBlockingRiskEngineDecisionDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFundingSourceBankAccountIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFundingSourceCardAccountCardTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFundingSourceCardAccountInput = {
  cardType?: InputMaybe<Scalars['String']>;
  network?: InputMaybe<Scalars['String']>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFundingSourceCardAccountNetworkOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFundingSourceCardAccountOperatorsInput = {
  cardType?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFundingSourceCardAccountCardTypeOperatorsInput>;
  network?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFundingSourceCardAccountNetworkOperatorsInput>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFundingSourceInput = {
  bankAccountId?: InputMaybe<Scalars['Float']>;
  cardAccount?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFundingSourceCardAccountInput>;
  intuitAccountId?: InputMaybe<Scalars['String']>;
  isVerified?: InputMaybe<Scalars['Boolean']>;
  origin?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataFundingSourceOrigin>;
  plaidAccountId?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFundingSourceIntuitAccountIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFundingSourceIsVerifiedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFundingSourceOperatorsInput = {
  bankAccountId?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFundingSourceBankAccountIdOperatorsInput>;
  cardAccount?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFundingSourceCardAccountOperatorsInput>;
  intuitAccountId?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFundingSourceIntuitAccountIdOperatorsInput>;
  isVerified?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFundingSourceIsVerifiedOperatorsInput>;
  origin?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFundingSourceOriginOperatorsInput>;
  plaidAccountId?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFundingSourcePlaidAccountIdOperatorsInput>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFundingSourceOriginOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataFundingSourceOrigin>;
  gte?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataFundingSourceOrigin>;
  in?: InputMaybe<Array<InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataFundingSourceOrigin>>>;
  lt?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataFundingSourceOrigin>;
  lte?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataFundingSourceOrigin>;
  ne?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataFundingSourceOrigin>;
  nin?: InputMaybe<Array<InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataFundingSourceOrigin>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataFundingSourcePlaidAccountIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataInput = {
  AND?: InputMaybe<Array<FilterFindManySherlockDecisionTaggingEntityCachedDataInput>>;
  OR?: InputMaybe<Array<FilterFindManySherlockDecisionTaggingEntityCachedDataInput>>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataOperatorsInput>;
  bill?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataBillInput>;
  deliveryMethod?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataDeliveryMethodInput>;
  enrichmentData?: InputMaybe<Scalars['JSON']>;
  features?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesInput>;
  firstBlockingRiskEngineDecisionDate?: InputMaybe<Scalars['Date']>;
  fundingSource?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFundingSourceInput>;
  organization?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataOrganizationInput>;
  payment?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentInput>;
  recurringBill?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataRecurringBillInput>;
  riskEngineDecision?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataRiskEngineDecisionInput>;
  tagNames?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataTagNamesInput>;
  vendor?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataVendorInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySherlockDecisionTaggingEntityCachedDataOperatorsInput = {
  bill?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataBillOperatorsInput>;
  deliveryMethod?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataDeliveryMethodOperatorsInput>;
  enrichmentData?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataEnrichmentDataOperatorsInput>;
  features?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFeaturesOperatorsInput>;
  firstBlockingRiskEngineDecisionDate?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFirstBlockingRiskEngineDecisionDateOperatorsInput>;
  fundingSource?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataFundingSourceOperatorsInput>;
  organization?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataOrganizationOperatorsInput>;
  payment?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentOperatorsInput>;
  recurringBill?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataRecurringBillOperatorsInput>;
  riskEngineDecision?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataRiskEngineDecisionOperatorsInput>;
  tagNames?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataTagNamesOperatorsInput>;
  vendor?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataVendorOperatorsInput>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataOrganizationCompanyNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataOrganizationDecisionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationDecision>;
  gte?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationDecision>;
  in?: InputMaybe<Array<InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationDecision>>>;
  lt?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationDecision>;
  lte?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationDecision>;
  ne?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationDecision>;
  nin?: InputMaybe<Array<InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationDecision>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataOrganizationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataOrganizationInput = {
  companyName?: InputMaybe<Scalars['String']>;
  decision?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationDecision>;
  id?: InputMaybe<Scalars['Float']>;
  kybMoneyIn?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationKybMoneyIn>;
  kybMoneyInSubType?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationKybMoneyInSubType>;
  kybStatus?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  taxIdType?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationTaxIdType>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataOrganizationKybMoneyInOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationKybMoneyIn>;
  gte?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationKybMoneyIn>;
  in?: InputMaybe<Array<InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationKybMoneyIn>>>;
  lt?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationKybMoneyIn>;
  lte?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationKybMoneyIn>;
  ne?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationKybMoneyIn>;
  nin?: InputMaybe<Array<InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationKybMoneyIn>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataOrganizationKybMoneyInSubTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationKybMoneyInSubType>;
  gte?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationKybMoneyInSubType>;
  in?: InputMaybe<Array<InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationKybMoneyInSubType>>>;
  lt?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationKybMoneyInSubType>;
  lte?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationKybMoneyInSubType>;
  ne?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationKybMoneyInSubType>;
  nin?: InputMaybe<Array<InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationKybMoneyInSubType>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataOrganizationKybStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataOrganizationLabelsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataOrganizationOperatorsInput = {
  companyName?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataOrganizationCompanyNameOperatorsInput>;
  decision?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataOrganizationDecisionOperatorsInput>;
  id?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataOrganizationIdOperatorsInput>;
  kybMoneyIn?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataOrganizationKybMoneyInOperatorsInput>;
  kybMoneyInSubType?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataOrganizationKybMoneyInSubTypeOperatorsInput>;
  kybStatus?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataOrganizationKybStatusOperatorsInput>;
  labels?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataOrganizationLabelsOperatorsInput>;
  taxIdType?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataOrganizationTaxIdTypeOperatorsInput>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataOrganizationTaxIdTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationTaxIdType>;
  gte?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationTaxIdType>;
  in?: InputMaybe<Array<InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationTaxIdType>>>;
  lt?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationTaxIdType>;
  lte?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationTaxIdType>;
  ne?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationTaxIdType>;
  nin?: InputMaybe<Array<InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationTaxIdType>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentAmountOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentCreateOriginOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataPaymentCreateOrigin>;
  gte?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataPaymentCreateOrigin>;
  in?: InputMaybe<Array<InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataPaymentCreateOrigin>>>;
  lt?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataPaymentCreateOrigin>;
  lte?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataPaymentCreateOrigin>;
  ne?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataPaymentCreateOrigin>;
  nin?: InputMaybe<Array<InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataPaymentCreateOrigin>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentCreatedByEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentCreatedByPartnerCompanyNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentCreatedByPartnerInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  companyName?: InputMaybe<Scalars['String']>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentCreatedByPartnerOperatorsInput = {
  _id?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentCreatedByPartner_IdOperatorsInput>;
  companyName?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentCreatedByPartnerCompanyNameOperatorsInput>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentCreatedByPartner_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentCurrencyOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentDirectionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataPaymentDirection>;
  gte?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataPaymentDirection>;
  in?: InputMaybe<Array<InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataPaymentDirection>>>;
  lt?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataPaymentDirection>;
  lte?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataPaymentDirection>;
  ne?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataPaymentDirection>;
  nin?: InputMaybe<Array<InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataPaymentDirection>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentForeignAmountOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentForeignCurrencyOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentInput = {
  amount?: InputMaybe<Scalars['Float']>;
  createOrigin?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataPaymentCreateOrigin>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdByEmail?: InputMaybe<Scalars['String']>;
  createdByPartner?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentCreatedByPartnerInput>;
  currency?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataPaymentDirection>;
  foreignAmount?: InputMaybe<Scalars['Float']>;
  foreignCurrency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  isPartial?: InputMaybe<Scalars['Boolean']>;
  paymentApprovalActionReason?: InputMaybe<Scalars['String']>;
  riskStatus?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataPaymentRiskStatus>;
  scheduledDate?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentIsPartialOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentOperatorsInput = {
  amount?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentAmountOperatorsInput>;
  createOrigin?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentCreateOriginOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentCreatedAtOperatorsInput>;
  createdByEmail?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentCreatedByEmailOperatorsInput>;
  createdByPartner?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentCreatedByPartnerOperatorsInput>;
  currency?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentCurrencyOperatorsInput>;
  direction?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentDirectionOperatorsInput>;
  foreignAmount?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentForeignAmountOperatorsInput>;
  foreignCurrency?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentForeignCurrencyOperatorsInput>;
  id?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentIdOperatorsInput>;
  isPartial?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentIsPartialOperatorsInput>;
  paymentApprovalActionReason?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentPaymentApprovalActionReasonOperatorsInput>;
  riskStatus?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentRiskStatusOperatorsInput>;
  scheduledDate?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentScheduledDateOperatorsInput>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentPaymentApprovalActionReasonOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentRiskStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataPaymentRiskStatus>;
  gte?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataPaymentRiskStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataPaymentRiskStatus>>>;
  lt?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataPaymentRiskStatus>;
  lte?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataPaymentRiskStatus>;
  ne?: InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataPaymentRiskStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumSherlockDecisionTaggingEntityCachedDataPaymentRiskStatus>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataPaymentScheduledDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataRecurringBillInput = {
  occurrences?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataRecurringBillOccurrencesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataRecurringBillOperatorsInput = {
  occurrences?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataRecurringBillOccurrencesOperatorsInput>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataRiskEngineDecisionInput = {
  reason?: InputMaybe<Scalars['String']>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataRiskEngineDecisionOperatorsInput = {
  reason?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataRiskEngineDecisionReasonOperatorsInput>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataRiskEngineDecisionReasonOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataTagNamesInput = {
  organizationDecision?: InputMaybe<Scalars['String']>;
  organizationLabels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  paymentRiskStatus?: InputMaybe<Scalars['String']>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataTagNamesOperatorsInput = {
  organizationDecision?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataTagNamesOrganizationDecisionOperatorsInput>;
  organizationLabels?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataTagNamesOrganizationLabelsOperatorsInput>;
  paymentRiskStatus?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataTagNamesPaymentRiskStatusOperatorsInput>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataTagNamesOrganizationDecisionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataTagNamesOrganizationLabelsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataTagNamesPaymentRiskStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataVendorCompanyNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataVendorInput = {
  companyName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManySherlockDecisionTaggingEntityCachedDataVendorOperatorsInput = {
  companyName?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataVendorCompanyNameOperatorsInput>;
  id?: InputMaybe<FilterFindManySherlockDecisionTaggingEntityCachedDataVendorIdOperatorsInput>;
};

export type FilterFindManySherlockEscalationEntityCachedDataConcernAreaIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManySherlockEscalationEntityCachedDataCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManySherlockEscalationEntityCachedDataCreatedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManySherlockEscalationEntityCachedDataEscalatedToIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockEscalationEntityCachedDataEscalatedToInput = {
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<EnumSherlockEscalationEntityCachedDataEscalatedToType>;
};

export type FilterFindManySherlockEscalationEntityCachedDataEscalatedToOperatorsInput = {
  id?: InputMaybe<FilterFindManySherlockEscalationEntityCachedDataEscalatedToIdOperatorsInput>;
  type?: InputMaybe<FilterFindManySherlockEscalationEntityCachedDataEscalatedToTypeOperatorsInput>;
};

export type FilterFindManySherlockEscalationEntityCachedDataEscalatedToTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumSherlockEscalationEntityCachedDataEscalatedToType>;
  gte?: InputMaybe<EnumSherlockEscalationEntityCachedDataEscalatedToType>;
  in?: InputMaybe<Array<InputMaybe<EnumSherlockEscalationEntityCachedDataEscalatedToType>>>;
  lt?: InputMaybe<EnumSherlockEscalationEntityCachedDataEscalatedToType>;
  lte?: InputMaybe<EnumSherlockEscalationEntityCachedDataEscalatedToType>;
  ne?: InputMaybe<EnumSherlockEscalationEntityCachedDataEscalatedToType>;
  nin?: InputMaybe<Array<InputMaybe<EnumSherlockEscalationEntityCachedDataEscalatedToType>>>;
};

export type FilterFindManySherlockEscalationEntityCachedDataInput = {
  AND?: InputMaybe<Array<FilterFindManySherlockEscalationEntityCachedDataInput>>;
  OR?: InputMaybe<Array<FilterFindManySherlockEscalationEntityCachedDataInput>>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySherlockEscalationEntityCachedDataOperatorsInput>;
  concernAreaId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  escalatedTo?: InputMaybe<Array<InputMaybe<FilterFindManySherlockEscalationEntityCachedDataEscalatedToInput>>>;
  organization?: InputMaybe<FilterFindManySherlockEscalationEntityCachedDataOrganizationInput>;
  partner?: InputMaybe<FilterFindManySherlockEscalationEntityCachedDataPartnerInput>;
  reason?: InputMaybe<Scalars['String']>;
  relatedTaskIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  relatedTaskInboxType?: InputMaybe<EnumSherlockEscalationEntityCachedDataRelatedTaskInboxType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySherlockEscalationEntityCachedDataOperatorsInput = {
  concernAreaId?: InputMaybe<FilterFindManySherlockEscalationEntityCachedDataConcernAreaIdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManySherlockEscalationEntityCachedDataCreatedAtOperatorsInput>;
  createdBy?: InputMaybe<FilterFindManySherlockEscalationEntityCachedDataCreatedByOperatorsInput>;
  escalatedTo?: InputMaybe<FilterFindManySherlockEscalationEntityCachedDataEscalatedToOperatorsInput>;
  organization?: InputMaybe<FilterFindManySherlockEscalationEntityCachedDataOrganizationOperatorsInput>;
  partner?: InputMaybe<FilterFindManySherlockEscalationEntityCachedDataPartnerOperatorsInput>;
  reason?: InputMaybe<FilterFindManySherlockEscalationEntityCachedDataReasonOperatorsInput>;
  relatedTaskIds?: InputMaybe<FilterFindManySherlockEscalationEntityCachedDataRelatedTaskIdsOperatorsInput>;
  relatedTaskInboxType?: InputMaybe<FilterFindManySherlockEscalationEntityCachedDataRelatedTaskInboxTypeOperatorsInput>;
};

export type FilterFindManySherlockEscalationEntityCachedDataOrganizationCompanyNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockEscalationEntityCachedDataOrganizationDecisionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumSherlockEscalationEntityCachedDataOrganizationDecision>;
  gte?: InputMaybe<EnumSherlockEscalationEntityCachedDataOrganizationDecision>;
  in?: InputMaybe<Array<InputMaybe<EnumSherlockEscalationEntityCachedDataOrganizationDecision>>>;
  lt?: InputMaybe<EnumSherlockEscalationEntityCachedDataOrganizationDecision>;
  lte?: InputMaybe<EnumSherlockEscalationEntityCachedDataOrganizationDecision>;
  ne?: InputMaybe<EnumSherlockEscalationEntityCachedDataOrganizationDecision>;
  nin?: InputMaybe<Array<InputMaybe<EnumSherlockEscalationEntityCachedDataOrganizationDecision>>>;
};

export type FilterFindManySherlockEscalationEntityCachedDataOrganizationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManySherlockEscalationEntityCachedDataOrganizationInput = {
  companyName?: InputMaybe<Scalars['String']>;
  decision?: InputMaybe<EnumSherlockEscalationEntityCachedDataOrganizationDecision>;
  id?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManySherlockEscalationEntityCachedDataOrganizationOperatorsInput = {
  companyName?: InputMaybe<FilterFindManySherlockEscalationEntityCachedDataOrganizationCompanyNameOperatorsInput>;
  decision?: InputMaybe<FilterFindManySherlockEscalationEntityCachedDataOrganizationDecisionOperatorsInput>;
  id?: InputMaybe<FilterFindManySherlockEscalationEntityCachedDataOrganizationIdOperatorsInput>;
};

export type FilterFindManySherlockEscalationEntityCachedDataPartnerCompanyNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockEscalationEntityCachedDataPartnerInput = {
  companyName?: InputMaybe<Scalars['String']>;
  partnerName?: InputMaybe<Scalars['String']>;
};

export type FilterFindManySherlockEscalationEntityCachedDataPartnerOperatorsInput = {
  companyName?: InputMaybe<FilterFindManySherlockEscalationEntityCachedDataPartnerCompanyNameOperatorsInput>;
  partnerName?: InputMaybe<FilterFindManySherlockEscalationEntityCachedDataPartnerPartnerNameOperatorsInput>;
};

export type FilterFindManySherlockEscalationEntityCachedDataPartnerPartnerNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockEscalationEntityCachedDataReasonOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockEscalationEntityCachedDataRelatedTaskIdsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManySherlockEscalationEntityCachedDataRelatedTaskInboxTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumSherlockEscalationEntityCachedDataRelatedTaskInboxType>;
  gte?: InputMaybe<EnumSherlockEscalationEntityCachedDataRelatedTaskInboxType>;
  in?: InputMaybe<Array<InputMaybe<EnumSherlockEscalationEntityCachedDataRelatedTaskInboxType>>>;
  lt?: InputMaybe<EnumSherlockEscalationEntityCachedDataRelatedTaskInboxType>;
  lte?: InputMaybe<EnumSherlockEscalationEntityCachedDataRelatedTaskInboxType>;
  ne?: InputMaybe<EnumSherlockEscalationEntityCachedDataRelatedTaskInboxType>;
  nin?: InputMaybe<Array<InputMaybe<EnumSherlockEscalationEntityCachedDataRelatedTaskInboxType>>>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataCrrRankOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumSherlockOrganizationEntityCachedDataCrrRank>;
  gte?: InputMaybe<EnumSherlockOrganizationEntityCachedDataCrrRank>;
  in?: InputMaybe<Array<InputMaybe<EnumSherlockOrganizationEntityCachedDataCrrRank>>>;
  lt?: InputMaybe<EnumSherlockOrganizationEntityCachedDataCrrRank>;
  lte?: InputMaybe<EnumSherlockOrganizationEntityCachedDataCrrRank>;
  ne?: InputMaybe<EnumSherlockOrganizationEntityCachedDataCrrRank>;
  nin?: InputMaybe<Array<InputMaybe<EnumSherlockOrganizationEntityCachedDataCrrRank>>>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataDetectionDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataInput = {
  AND?: InputMaybe<Array<FilterFindManySherlockOrganizationEntityCachedDataInput>>;
  OR?: InputMaybe<Array<FilterFindManySherlockOrganizationEntityCachedDataInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  crrRank?: InputMaybe<EnumSherlockOrganizationEntityCachedDataCrrRank>;
  detectionDate?: InputMaybe<Scalars['Date']>;
  lastDecisionDetails?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataLastDecisionDetailsInput>;
  lastEscalatedDetails?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataLastEscalatedDetailsInput>;
  name?: InputMaybe<Scalars['String']>;
  odeMoneyInDecision?: InputMaybe<EnumSherlockOrganizationEntityCachedDataOdeMoneyInDecision>;
  odeMoneyOutDecision?: InputMaybe<EnumSherlockOrganizationEntityCachedDataOdeMoneyOutDecision>;
  organizationId?: InputMaybe<Scalars['Float']>;
  origin?: InputMaybe<EnumSherlockOrganizationEntityCachedDataOrigin>;
  partner?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataPartnerInput>;
  state?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<EnumSherlockOrganizationEntityCachedDataTaxIdType>;
  tpv?: InputMaybe<Scalars['Float']>;
  zendeskTickets?: InputMaybe<Array<InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataZendeskTicketsInput>>>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataLastDecisionDetailsDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataLastDecisionDetailsInput = {
  date?: InputMaybe<Scalars['Date']>;
  reason?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataLastDecisionDetailsOperatorsInput = {
  date?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataLastDecisionDetailsDateOperatorsInput>;
  reason?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataLastDecisionDetailsReasonOperatorsInput>;
  userId?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataLastDecisionDetailsUserIdOperatorsInput>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataLastDecisionDetailsReasonOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataLastDecisionDetailsUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataLastEscalatedDetailsCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataLastEscalatedDetailsDescriptionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataLastEscalatedDetailsInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  teamIntegrationId?: InputMaybe<Scalars['MongoID']>;
  userId?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataLastEscalatedDetailsOperatorsInput = {
  createdAt?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataLastEscalatedDetailsCreatedAtOperatorsInput>;
  description?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataLastEscalatedDetailsDescriptionOperatorsInput>;
  teamIntegrationId?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataLastEscalatedDetailsTeamIntegrationIdOperatorsInput>;
  userId?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataLastEscalatedDetailsUserIdOperatorsInput>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataLastEscalatedDetailsTeamIntegrationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataLastEscalatedDetailsUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataOdeMoneyInDecisionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumSherlockOrganizationEntityCachedDataOdeMoneyInDecision>;
  gte?: InputMaybe<EnumSherlockOrganizationEntityCachedDataOdeMoneyInDecision>;
  in?: InputMaybe<Array<InputMaybe<EnumSherlockOrganizationEntityCachedDataOdeMoneyInDecision>>>;
  lt?: InputMaybe<EnumSherlockOrganizationEntityCachedDataOdeMoneyInDecision>;
  lte?: InputMaybe<EnumSherlockOrganizationEntityCachedDataOdeMoneyInDecision>;
  ne?: InputMaybe<EnumSherlockOrganizationEntityCachedDataOdeMoneyInDecision>;
  nin?: InputMaybe<Array<InputMaybe<EnumSherlockOrganizationEntityCachedDataOdeMoneyInDecision>>>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataOdeMoneyOutDecisionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumSherlockOrganizationEntityCachedDataOdeMoneyOutDecision>;
  gte?: InputMaybe<EnumSherlockOrganizationEntityCachedDataOdeMoneyOutDecision>;
  in?: InputMaybe<Array<InputMaybe<EnumSherlockOrganizationEntityCachedDataOdeMoneyOutDecision>>>;
  lt?: InputMaybe<EnumSherlockOrganizationEntityCachedDataOdeMoneyOutDecision>;
  lte?: InputMaybe<EnumSherlockOrganizationEntityCachedDataOdeMoneyOutDecision>;
  ne?: InputMaybe<EnumSherlockOrganizationEntityCachedDataOdeMoneyOutDecision>;
  nin?: InputMaybe<Array<InputMaybe<EnumSherlockOrganizationEntityCachedDataOdeMoneyOutDecision>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySherlockOrganizationEntityCachedDataOperatorsInput = {
  _id?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedData_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataCreatedAtOperatorsInput>;
  crrRank?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataCrrRankOperatorsInput>;
  detectionDate?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataDetectionDateOperatorsInput>;
  lastDecisionDetails?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataLastDecisionDetailsOperatorsInput>;
  lastEscalatedDetails?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataLastEscalatedDetailsOperatorsInput>;
  name?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataNameOperatorsInput>;
  odeMoneyInDecision?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataOdeMoneyInDecisionOperatorsInput>;
  odeMoneyOutDecision?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataOdeMoneyOutDecisionOperatorsInput>;
  organizationId?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataOrganizationIdOperatorsInput>;
  origin?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataOriginOperatorsInput>;
  partner?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataPartnerOperatorsInput>;
  state?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataStateOperatorsInput>;
  taxIdType?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataTaxIdTypeOperatorsInput>;
  tpv?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataTpvOperatorsInput>;
  zendeskTickets?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataZendeskTicketsOperatorsInput>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataOrganizationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataOriginOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumSherlockOrganizationEntityCachedDataOrigin>;
  gte?: InputMaybe<EnumSherlockOrganizationEntityCachedDataOrigin>;
  in?: InputMaybe<Array<InputMaybe<EnumSherlockOrganizationEntityCachedDataOrigin>>>;
  lt?: InputMaybe<EnumSherlockOrganizationEntityCachedDataOrigin>;
  lte?: InputMaybe<EnumSherlockOrganizationEntityCachedDataOrigin>;
  ne?: InputMaybe<EnumSherlockOrganizationEntityCachedDataOrigin>;
  nin?: InputMaybe<Array<InputMaybe<EnumSherlockOrganizationEntityCachedDataOrigin>>>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataPartnerCompanyNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataPartnerIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataPartnerInput = {
  companyName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  partnerName?: InputMaybe<Scalars['String']>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataPartnerOperatorsInput = {
  companyName?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataPartnerCompanyNameOperatorsInput>;
  id?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataPartnerIdOperatorsInput>;
  partnerName?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataPartnerPartnerNameOperatorsInput>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataPartnerPartnerNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataStateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataTaxIdTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumSherlockOrganizationEntityCachedDataTaxIdType>;
  gte?: InputMaybe<EnumSherlockOrganizationEntityCachedDataTaxIdType>;
  in?: InputMaybe<Array<InputMaybe<EnumSherlockOrganizationEntityCachedDataTaxIdType>>>;
  lt?: InputMaybe<EnumSherlockOrganizationEntityCachedDataTaxIdType>;
  lte?: InputMaybe<EnumSherlockOrganizationEntityCachedDataTaxIdType>;
  ne?: InputMaybe<EnumSherlockOrganizationEntityCachedDataTaxIdType>;
  nin?: InputMaybe<Array<InputMaybe<EnumSherlockOrganizationEntityCachedDataTaxIdType>>>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataTpvOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataZendeskTicketsIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataZendeskTicketsInput = {
  id?: InputMaybe<Scalars['Float']>;
  latestComment?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentInput>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentCommenterInput = {
  isAnalyst?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentCommenterIsAnalystOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentCommenterNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentCommenterOperatorsInput = {
  isAnalyst?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentCommenterIsAnalystOperatorsInput>;
  name?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentCommenterNameOperatorsInput>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentInput = {
  commenter?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentCommenterInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  priority?: InputMaybe<EnumSherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentPriority>;
  status?: InputMaybe<EnumSherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentStatus>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentOperatorsInput = {
  commenter?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentCommenterOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentCreatedAtOperatorsInput>;
  priority?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentPriorityOperatorsInput>;
  status?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentStatusOperatorsInput>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentPriorityOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumSherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentPriority>;
  gte?: InputMaybe<EnumSherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentPriority>;
  in?: InputMaybe<Array<InputMaybe<EnumSherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentPriority>>>;
  lt?: InputMaybe<EnumSherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentPriority>;
  lte?: InputMaybe<EnumSherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentPriority>;
  ne?: InputMaybe<EnumSherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentPriority>;
  nin?: InputMaybe<Array<InputMaybe<EnumSherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentPriority>>>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumSherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentStatus>;
  gte?: InputMaybe<EnumSherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumSherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentStatus>>>;
  lt?: InputMaybe<EnumSherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentStatus>;
  lte?: InputMaybe<EnumSherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentStatus>;
  ne?: InputMaybe<EnumSherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumSherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentStatus>>>;
};

export type FilterFindManySherlockOrganizationEntityCachedDataZendeskTicketsOperatorsInput = {
  id?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataZendeskTicketsIdOperatorsInput>;
  latestComment?: InputMaybe<FilterFindManySherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentOperatorsInput>;
};

export type FilterFindManySherlockOrganizationEntityCachedData_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManySlotAssignedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManySlotAssignedDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManySlotConcernAreaSchemaIdsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManySlotCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManySlotDeletedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManySlotEndDateTimeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManySlotExternalSystemIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManySlotInput = {
  AND?: InputMaybe<Array<FilterFindManySlotInput>>;
  OR?: InputMaybe<Array<FilterFindManySlotInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySlotOperatorsInput>;
  assignedBy?: InputMaybe<Scalars['MongoID']>;
  assignedDate?: InputMaybe<Scalars['Date']>;
  concernAreaSchemaIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  endDateTime?: InputMaybe<Scalars['Date']>;
  externalSystemId?: InputMaybe<Scalars['Float']>;
  labelIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  role?: InputMaybe<Scalars['String']>;
  shiftId?: InputMaybe<Scalars['MongoID']>;
  slotType?: InputMaybe<Scalars['String']>;
  startDateTime?: InputMaybe<Scalars['Date']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  userId?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManySlotLabelIdsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySlotOperatorsInput = {
  _id?: InputMaybe<FilterFindManySlot_IdOperatorsInput>;
  assignedBy?: InputMaybe<FilterFindManySlotAssignedByOperatorsInput>;
  assignedDate?: InputMaybe<FilterFindManySlotAssignedDateOperatorsInput>;
  concernAreaSchemaIds?: InputMaybe<FilterFindManySlotConcernAreaSchemaIdsOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManySlotCreatedAtOperatorsInput>;
  deletedAt?: InputMaybe<FilterFindManySlotDeletedAtOperatorsInput>;
  endDateTime?: InputMaybe<FilterFindManySlotEndDateTimeOperatorsInput>;
  externalSystemId?: InputMaybe<FilterFindManySlotExternalSystemIdOperatorsInput>;
  labelIds?: InputMaybe<FilterFindManySlotLabelIdsOperatorsInput>;
  role?: InputMaybe<FilterFindManySlotRoleOperatorsInput>;
  shiftId?: InputMaybe<FilterFindManySlotShiftIdOperatorsInput>;
  slotType?: InputMaybe<FilterFindManySlotSlotTypeOperatorsInput>;
  startDateTime?: InputMaybe<FilterFindManySlotStartDateTimeOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManySlotUpdatedAtOperatorsInput>;
  userId?: InputMaybe<FilterFindManySlotUserIdOperatorsInput>;
};

export type FilterFindManySlotRoleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySlotShiftIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManySlotSlotTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySlotStartDateTimeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManySlotUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManySlotUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManySlot_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManySquadInput = {
  AND?: InputMaybe<Array<FilterFindManySquadInput>>;
  OR?: InputMaybe<Array<FilterFindManySquadInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySquadOperatorsInput>;
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySquadOperatorsInput = {
  _id?: InputMaybe<FilterFindManySquad_IdOperatorsInput>;
};

export type FilterFindManySquad_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyStrategyInput = {
  AND?: InputMaybe<Array<FilterFindManyStrategyInput>>;
  OR?: InputMaybe<Array<FilterFindManyStrategyInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyStrategyOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  logic?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  rules?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  tree?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  version?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyStrategyOperatorsInput = {
  _id?: InputMaybe<FilterFindManyStrategy_IdOperatorsInput>;
};

export type FilterFindManyStrategy_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyTaskAssignedToOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyTaskConcernAreasAssignedToOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyTaskConcernAreasBlockedRulesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskConcernAreasConcernAreaSchemaIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyTaskConcernAreasCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyTaskConcernAreasDecisionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTaskConcernAreasDecision>;
  gte?: InputMaybe<EnumTaskConcernAreasDecision>;
  in?: InputMaybe<Array<InputMaybe<EnumTaskConcernAreasDecision>>>;
  lt?: InputMaybe<EnumTaskConcernAreasDecision>;
  lte?: InputMaybe<EnumTaskConcernAreasDecision>;
  ne?: InputMaybe<EnumTaskConcernAreasDecision>;
  nin?: InputMaybe<Array<InputMaybe<EnumTaskConcernAreasDecision>>>;
};

export type FilterFindManyTaskConcernAreasInput = {
  assignedTo?: InputMaybe<Scalars['MongoID']>;
  blockedRules?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  concernAreaSchemaId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  decision?: InputMaybe<EnumTaskConcernAreasDecision>;
  lastDecisionDetails?: InputMaybe<FilterFindManyTaskConcernAreasLastDecisionDetailsInput>;
  prevDecision?: InputMaybe<EnumTaskConcernAreasPrevDecision>;
  status?: InputMaybe<EnumTaskConcernAreasStatus>;
};

export type FilterFindManyTaskConcernAreasLastDecisionDetailsApproveAutomatedActionsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTaskConcernAreasLastDecisionDetailsFreeTextReasonOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskConcernAreasLastDecisionDetailsIncludeRecurringOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTaskConcernAreasLastDecisionDetailsInput = {
  approveAutomatedActions?: InputMaybe<Scalars['Boolean']>;
  freeTextReason?: InputMaybe<Scalars['String']>;
  includeRecurring?: InputMaybe<Scalars['Boolean']>;
  lastDecisionDate: Scalars['Date'];
  lastDecisionMakerId?: InputMaybe<Scalars['MongoID']>;
  reason?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<EnumTaskConcernAreasLastDecisionDetailsType>;
};

export type FilterFindManyTaskConcernAreasLastDecisionDetailsLastDecisionDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyTaskConcernAreasLastDecisionDetailsLastDecisionMakerIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyTaskConcernAreasLastDecisionDetailsOperatorsInput = {
  approveAutomatedActions?: InputMaybe<FilterFindManyTaskConcernAreasLastDecisionDetailsApproveAutomatedActionsOperatorsInput>;
  freeTextReason?: InputMaybe<FilterFindManyTaskConcernAreasLastDecisionDetailsFreeTextReasonOperatorsInput>;
  includeRecurring?: InputMaybe<FilterFindManyTaskConcernAreasLastDecisionDetailsIncludeRecurringOperatorsInput>;
  lastDecisionDate?: InputMaybe<FilterFindManyTaskConcernAreasLastDecisionDetailsLastDecisionDateOperatorsInput>;
  lastDecisionMakerId?: InputMaybe<FilterFindManyTaskConcernAreasLastDecisionDetailsLastDecisionMakerIdOperatorsInput>;
  reason?: InputMaybe<FilterFindManyTaskConcernAreasLastDecisionDetailsReasonOperatorsInput>;
  type?: InputMaybe<FilterFindManyTaskConcernAreasLastDecisionDetailsTypeOperatorsInput>;
};

export type FilterFindManyTaskConcernAreasLastDecisionDetailsReasonOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskConcernAreasLastDecisionDetailsTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTaskConcernAreasLastDecisionDetailsType>;
  gte?: InputMaybe<EnumTaskConcernAreasLastDecisionDetailsType>;
  in?: InputMaybe<Array<InputMaybe<EnumTaskConcernAreasLastDecisionDetailsType>>>;
  lt?: InputMaybe<EnumTaskConcernAreasLastDecisionDetailsType>;
  lte?: InputMaybe<EnumTaskConcernAreasLastDecisionDetailsType>;
  ne?: InputMaybe<EnumTaskConcernAreasLastDecisionDetailsType>;
  nin?: InputMaybe<Array<InputMaybe<EnumTaskConcernAreasLastDecisionDetailsType>>>;
};

export type FilterFindManyTaskConcernAreasOperatorsInput = {
  assignedTo?: InputMaybe<FilterFindManyTaskConcernAreasAssignedToOperatorsInput>;
  blockedRules?: InputMaybe<FilterFindManyTaskConcernAreasBlockedRulesOperatorsInput>;
  concernAreaSchemaId?: InputMaybe<FilterFindManyTaskConcernAreasConcernAreaSchemaIdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyTaskConcernAreasCreatedAtOperatorsInput>;
  decision?: InputMaybe<FilterFindManyTaskConcernAreasDecisionOperatorsInput>;
  lastDecisionDetails?: InputMaybe<FilterFindManyTaskConcernAreasLastDecisionDetailsOperatorsInput>;
  prevDecision?: InputMaybe<FilterFindManyTaskConcernAreasPrevDecisionOperatorsInput>;
  status?: InputMaybe<FilterFindManyTaskConcernAreasStatusOperatorsInput>;
};

export type FilterFindManyTaskConcernAreasPrevDecisionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTaskConcernAreasPrevDecision>;
  gte?: InputMaybe<EnumTaskConcernAreasPrevDecision>;
  in?: InputMaybe<Array<InputMaybe<EnumTaskConcernAreasPrevDecision>>>;
  lt?: InputMaybe<EnumTaskConcernAreasPrevDecision>;
  lte?: InputMaybe<EnumTaskConcernAreasPrevDecision>;
  ne?: InputMaybe<EnumTaskConcernAreasPrevDecision>;
  nin?: InputMaybe<Array<InputMaybe<EnumTaskConcernAreasPrevDecision>>>;
};

export type FilterFindManyTaskConcernAreasStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTaskConcernAreasStatus>;
  gte?: InputMaybe<EnumTaskConcernAreasStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumTaskConcernAreasStatus>>>;
  lt?: InputMaybe<EnumTaskConcernAreasStatus>;
  lte?: InputMaybe<EnumTaskConcernAreasStatus>;
  ne?: InputMaybe<EnumTaskConcernAreasStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumTaskConcernAreasStatus>>>;
};

export type FilterFindManyTaskCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyTaskDeletedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyTaskEntityCachedDataBillCurrencyOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataBillIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTaskEntityCachedDataBillInput = {
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  isTest?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  recurringBillIndex?: InputMaybe<Scalars['Float']>;
  totalAmount?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyTaskEntityCachedDataBillIsTestOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTaskEntityCachedDataBillNoteOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataBillOperatorsInput = {
  currency?: InputMaybe<FilterFindManyTaskEntityCachedDataBillCurrencyOperatorsInput>;
  id?: InputMaybe<FilterFindManyTaskEntityCachedDataBillIdOperatorsInput>;
  isTest?: InputMaybe<FilterFindManyTaskEntityCachedDataBillIsTestOperatorsInput>;
  note?: InputMaybe<FilterFindManyTaskEntityCachedDataBillNoteOperatorsInput>;
  recurringBillIndex?: InputMaybe<FilterFindManyTaskEntityCachedDataBillRecurringBillIndexOperatorsInput>;
  totalAmount?: InputMaybe<FilterFindManyTaskEntityCachedDataBillTotalAmountOperatorsInput>;
};

export type FilterFindManyTaskEntityCachedDataBillRecurringBillIndexOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTaskEntityCachedDataBillTotalAmountOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTaskEntityCachedDataDeliveryMethodBankAccountIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTaskEntityCachedDataDeliveryMethodCardAccountCardTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataDeliveryMethodCardAccountInput = {
  cardType?: InputMaybe<Scalars['String']>;
  network?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyTaskEntityCachedDataDeliveryMethodCardAccountNetworkOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataDeliveryMethodCardAccountOperatorsInput = {
  cardType?: InputMaybe<FilterFindManyTaskEntityCachedDataDeliveryMethodCardAccountCardTypeOperatorsInput>;
  network?: InputMaybe<FilterFindManyTaskEntityCachedDataDeliveryMethodCardAccountNetworkOperatorsInput>;
};

export type FilterFindManyTaskEntityCachedDataDeliveryMethodCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyTaskEntityCachedDataDeliveryMethodDeliveryTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataDeliveryMethodIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTaskEntityCachedDataDeliveryMethodInput = {
  bankAccountId?: InputMaybe<Scalars['Float']>;
  cardAccount?: InputMaybe<FilterFindManyTaskEntityCachedDataDeliveryMethodCardAccountInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deliveryType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  intuitAccountId?: InputMaybe<Scalars['String']>;
  isVerified?: InputMaybe<Scalars['Boolean']>;
  paperCheckId?: InputMaybe<Scalars['Float']>;
  plaidAccountId?: InputMaybe<Scalars['Float']>;
  rppsAccountId?: InputMaybe<Scalars['Float']>;
  verifiedStatus?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyTaskEntityCachedDataDeliveryMethodIntuitAccountIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataDeliveryMethodIsVerifiedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTaskEntityCachedDataDeliveryMethodOperatorsInput = {
  bankAccountId?: InputMaybe<FilterFindManyTaskEntityCachedDataDeliveryMethodBankAccountIdOperatorsInput>;
  cardAccount?: InputMaybe<FilterFindManyTaskEntityCachedDataDeliveryMethodCardAccountOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyTaskEntityCachedDataDeliveryMethodCreatedAtOperatorsInput>;
  deliveryType?: InputMaybe<FilterFindManyTaskEntityCachedDataDeliveryMethodDeliveryTypeOperatorsInput>;
  id?: InputMaybe<FilterFindManyTaskEntityCachedDataDeliveryMethodIdOperatorsInput>;
  intuitAccountId?: InputMaybe<FilterFindManyTaskEntityCachedDataDeliveryMethodIntuitAccountIdOperatorsInput>;
  isVerified?: InputMaybe<FilterFindManyTaskEntityCachedDataDeliveryMethodIsVerifiedOperatorsInput>;
  paperCheckId?: InputMaybe<FilterFindManyTaskEntityCachedDataDeliveryMethodPaperCheckIdOperatorsInput>;
  plaidAccountId?: InputMaybe<FilterFindManyTaskEntityCachedDataDeliveryMethodPlaidAccountIdOperatorsInput>;
  rppsAccountId?: InputMaybe<FilterFindManyTaskEntityCachedDataDeliveryMethodRppsAccountIdOperatorsInput>;
  verifiedStatus?: InputMaybe<FilterFindManyTaskEntityCachedDataDeliveryMethodVerifiedStatusOperatorsInput>;
};

export type FilterFindManyTaskEntityCachedDataDeliveryMethodPaperCheckIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTaskEntityCachedDataDeliveryMethodPlaidAccountIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTaskEntityCachedDataDeliveryMethodRppsAccountIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTaskEntityCachedDataDeliveryMethodVerifiedStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataFeaturesClientIpAgeForOrganizationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTaskEntityCachedDataFeaturesClientIpAgeForUserOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTaskEntityCachedDataFeaturesDeliveryMethodTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataFeaturesDoesOrgOweMoneyOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTaskEntityCachedDataFeaturesFundingSourceTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataFeaturesHasFileRequestsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTaskEntityCachedDataFeaturesInput = {
  clientIpAgeForOrganization?: InputMaybe<Scalars['Float']>;
  clientIpAgeForUser?: InputMaybe<Scalars['Float']>;
  deliveryMethodType?: InputMaybe<Scalars['String']>;
  doesOrgOweMoney?: InputMaybe<Scalars['Boolean']>;
  fundingSourceType?: InputMaybe<Scalars['String']>;
  hasFileRequests?: InputMaybe<Scalars['Boolean']>;
  invoiceOrNoteHasSanctionedWord?: InputMaybe<Scalars['Boolean']>;
  invoiceOrNoteHasSanctionedWordError?: InputMaybe<Scalars['Boolean']>;
  isApFinancingPayment?: InputMaybe<Scalars['Boolean']>;
  isCardWithSimilarDataApproved?: InputMaybe<Scalars['Boolean']>;
  isEmailVerified?: InputMaybe<Scalars['Boolean']>;
  isFRR?: InputMaybe<Scalars['Boolean']>;
  isGoodsReceived?: InputMaybe<Scalars['Boolean']>;
  isHighAmountForFS?: InputMaybe<Scalars['Boolean']>;
  isMicroDeposit?: InputMaybe<Scalars['Boolean']>;
  isOriginalDmEqualToCurrentDM?: InputMaybe<Scalars['Boolean']>;
  isPaymentExpedited?: InputMaybe<Scalars['Boolean']>;
  isPaymentOriginSafe?: InputMaybe<Scalars['Boolean']>;
  isSuspectedOfProhibitedIndustries?: InputMaybe<Scalars['Boolean']>;
  numOrganizationVendorCompletedPayments?: InputMaybe<Scalars['Float']>;
  payeeIdmScreeningNumHits?: InputMaybe<Scalars['Float']>;
  payorCreateOrigin?: InputMaybe<Scalars['String']>;
  payorIdmScreeningNumHits?: InputMaybe<Scalars['Float']>;
  vendorHasHandle?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyTaskEntityCachedDataFeaturesInvoiceOrNoteHasSanctionedWordErrorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTaskEntityCachedDataFeaturesInvoiceOrNoteHasSanctionedWordOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTaskEntityCachedDataFeaturesIsApFinancingPaymentOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTaskEntityCachedDataFeaturesIsCardWithSimilarDataApprovedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTaskEntityCachedDataFeaturesIsEmailVerifiedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTaskEntityCachedDataFeaturesIsFrrOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTaskEntityCachedDataFeaturesIsGoodsReceivedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTaskEntityCachedDataFeaturesIsHighAmountForFsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTaskEntityCachedDataFeaturesIsMicroDepositOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTaskEntityCachedDataFeaturesIsOriginalDmEqualToCurrentDmOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTaskEntityCachedDataFeaturesIsPaymentExpeditedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTaskEntityCachedDataFeaturesIsPaymentOriginSafeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTaskEntityCachedDataFeaturesIsSuspectedOfProhibitedIndustriesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTaskEntityCachedDataFeaturesNumOrganizationVendorCompletedPaymentsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTaskEntityCachedDataFeaturesOperatorsInput = {
  clientIpAgeForOrganization?: InputMaybe<FilterFindManyTaskEntityCachedDataFeaturesClientIpAgeForOrganizationOperatorsInput>;
  clientIpAgeForUser?: InputMaybe<FilterFindManyTaskEntityCachedDataFeaturesClientIpAgeForUserOperatorsInput>;
  deliveryMethodType?: InputMaybe<FilterFindManyTaskEntityCachedDataFeaturesDeliveryMethodTypeOperatorsInput>;
  doesOrgOweMoney?: InputMaybe<FilterFindManyTaskEntityCachedDataFeaturesDoesOrgOweMoneyOperatorsInput>;
  fundingSourceType?: InputMaybe<FilterFindManyTaskEntityCachedDataFeaturesFundingSourceTypeOperatorsInput>;
  hasFileRequests?: InputMaybe<FilterFindManyTaskEntityCachedDataFeaturesHasFileRequestsOperatorsInput>;
  invoiceOrNoteHasSanctionedWord?: InputMaybe<FilterFindManyTaskEntityCachedDataFeaturesInvoiceOrNoteHasSanctionedWordOperatorsInput>;
  invoiceOrNoteHasSanctionedWordError?: InputMaybe<FilterFindManyTaskEntityCachedDataFeaturesInvoiceOrNoteHasSanctionedWordErrorOperatorsInput>;
  isApFinancingPayment?: InputMaybe<FilterFindManyTaskEntityCachedDataFeaturesIsApFinancingPaymentOperatorsInput>;
  isCardWithSimilarDataApproved?: InputMaybe<FilterFindManyTaskEntityCachedDataFeaturesIsCardWithSimilarDataApprovedOperatorsInput>;
  isEmailVerified?: InputMaybe<FilterFindManyTaskEntityCachedDataFeaturesIsEmailVerifiedOperatorsInput>;
  isFRR?: InputMaybe<FilterFindManyTaskEntityCachedDataFeaturesIsFrrOperatorsInput>;
  isGoodsReceived?: InputMaybe<FilterFindManyTaskEntityCachedDataFeaturesIsGoodsReceivedOperatorsInput>;
  isHighAmountForFS?: InputMaybe<FilterFindManyTaskEntityCachedDataFeaturesIsHighAmountForFsOperatorsInput>;
  isMicroDeposit?: InputMaybe<FilterFindManyTaskEntityCachedDataFeaturesIsMicroDepositOperatorsInput>;
  isOriginalDmEqualToCurrentDM?: InputMaybe<FilterFindManyTaskEntityCachedDataFeaturesIsOriginalDmEqualToCurrentDmOperatorsInput>;
  isPaymentExpedited?: InputMaybe<FilterFindManyTaskEntityCachedDataFeaturesIsPaymentExpeditedOperatorsInput>;
  isPaymentOriginSafe?: InputMaybe<FilterFindManyTaskEntityCachedDataFeaturesIsPaymentOriginSafeOperatorsInput>;
  isSuspectedOfProhibitedIndustries?: InputMaybe<FilterFindManyTaskEntityCachedDataFeaturesIsSuspectedOfProhibitedIndustriesOperatorsInput>;
  numOrganizationVendorCompletedPayments?: InputMaybe<FilterFindManyTaskEntityCachedDataFeaturesNumOrganizationVendorCompletedPaymentsOperatorsInput>;
  payeeIdmScreeningNumHits?: InputMaybe<FilterFindManyTaskEntityCachedDataFeaturesPayeeIdmScreeningNumHitsOperatorsInput>;
  payorCreateOrigin?: InputMaybe<FilterFindManyTaskEntityCachedDataFeaturesPayorCreateOriginOperatorsInput>;
  payorIdmScreeningNumHits?: InputMaybe<FilterFindManyTaskEntityCachedDataFeaturesPayorIdmScreeningNumHitsOperatorsInput>;
  vendorHasHandle?: InputMaybe<FilterFindManyTaskEntityCachedDataFeaturesVendorHasHandleOperatorsInput>;
};

export type FilterFindManyTaskEntityCachedDataFeaturesPayeeIdmScreeningNumHitsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTaskEntityCachedDataFeaturesPayorCreateOriginOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataFeaturesPayorIdmScreeningNumHitsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTaskEntityCachedDataFeaturesVendorHasHandleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTaskEntityCachedDataFundingSourceBankAccountIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTaskEntityCachedDataFundingSourceCardAccountCardTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataFundingSourceCardAccountInput = {
  cardType?: InputMaybe<Scalars['String']>;
  network?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyTaskEntityCachedDataFundingSourceCardAccountNetworkOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataFundingSourceCardAccountOperatorsInput = {
  cardType?: InputMaybe<FilterFindManyTaskEntityCachedDataFundingSourceCardAccountCardTypeOperatorsInput>;
  network?: InputMaybe<FilterFindManyTaskEntityCachedDataFundingSourceCardAccountNetworkOperatorsInput>;
};

export type FilterFindManyTaskEntityCachedDataFundingSourceFlexAccountIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTaskEntityCachedDataFundingSourceIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTaskEntityCachedDataFundingSourceInput = {
  bankAccountId?: InputMaybe<Scalars['Float']>;
  cardAccount?: InputMaybe<FilterFindManyTaskEntityCachedDataFundingSourceCardAccountInput>;
  flexAccountId?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['Float']>;
  intuitAccountId?: InputMaybe<Scalars['String']>;
  isVerified?: InputMaybe<Scalars['Boolean']>;
  origin?: InputMaybe<Scalars['String']>;
  plaidAccountId?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyTaskEntityCachedDataFundingSourceIntuitAccountIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataFundingSourceIsVerifiedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTaskEntityCachedDataFundingSourceOperatorsInput = {
  bankAccountId?: InputMaybe<FilterFindManyTaskEntityCachedDataFundingSourceBankAccountIdOperatorsInput>;
  cardAccount?: InputMaybe<FilterFindManyTaskEntityCachedDataFundingSourceCardAccountOperatorsInput>;
  flexAccountId?: InputMaybe<FilterFindManyTaskEntityCachedDataFundingSourceFlexAccountIdOperatorsInput>;
  id?: InputMaybe<FilterFindManyTaskEntityCachedDataFundingSourceIdOperatorsInput>;
  intuitAccountId?: InputMaybe<FilterFindManyTaskEntityCachedDataFundingSourceIntuitAccountIdOperatorsInput>;
  isVerified?: InputMaybe<FilterFindManyTaskEntityCachedDataFundingSourceIsVerifiedOperatorsInput>;
  origin?: InputMaybe<FilterFindManyTaskEntityCachedDataFundingSourceOriginOperatorsInput>;
  plaidAccountId?: InputMaybe<FilterFindManyTaskEntityCachedDataFundingSourcePlaidAccountIdOperatorsInput>;
};

export type FilterFindManyTaskEntityCachedDataFundingSourceOriginOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataFundingSourcePlaidAccountIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTaskEntityCachedDataInput = {
  bill?: InputMaybe<FilterFindManyTaskEntityCachedDataBillInput>;
  deliveryMethod?: InputMaybe<FilterFindManyTaskEntityCachedDataDeliveryMethodInput>;
  features?: InputMaybe<FilterFindManyTaskEntityCachedDataFeaturesInput>;
  fundingSource?: InputMaybe<FilterFindManyTaskEntityCachedDataFundingSourceInput>;
  organization?: InputMaybe<FilterFindManyTaskEntityCachedDataOrganizationInput>;
  payment?: InputMaybe<FilterFindManyTaskEntityCachedDataPaymentInput>;
  paymentApprovalAction?: InputMaybe<FilterFindManyTaskEntityCachedDataPaymentApprovalActionInput>;
  recurringBill?: InputMaybe<FilterFindManyTaskEntityCachedDataRecurringBillInput>;
  riskEngineDecision?: InputMaybe<FilterFindManyTaskEntityCachedDataRiskEngineDecisionInput>;
  vendor?: InputMaybe<FilterFindManyTaskEntityCachedDataVendorInput>;
};

export type FilterFindManyTaskEntityCachedDataOperatorsInput = {
  bill?: InputMaybe<FilterFindManyTaskEntityCachedDataBillOperatorsInput>;
  deliveryMethod?: InputMaybe<FilterFindManyTaskEntityCachedDataDeliveryMethodOperatorsInput>;
  features?: InputMaybe<FilterFindManyTaskEntityCachedDataFeaturesOperatorsInput>;
  fundingSource?: InputMaybe<FilterFindManyTaskEntityCachedDataFundingSourceOperatorsInput>;
  organization?: InputMaybe<FilterFindManyTaskEntityCachedDataOrganizationOperatorsInput>;
  payment?: InputMaybe<FilterFindManyTaskEntityCachedDataPaymentOperatorsInput>;
  paymentApprovalAction?: InputMaybe<FilterFindManyTaskEntityCachedDataPaymentApprovalActionOperatorsInput>;
  recurringBill?: InputMaybe<FilterFindManyTaskEntityCachedDataRecurringBillOperatorsInput>;
  riskEngineDecision?: InputMaybe<FilterFindManyTaskEntityCachedDataRiskEngineDecisionOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyTaskEntityCachedDataVendorOperatorsInput>;
};

export type FilterFindManyTaskEntityCachedDataOrganizationCompanyNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataOrganizationDecisionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTaskEntityCachedDataOrganizationDecision>;
  gte?: InputMaybe<EnumTaskEntityCachedDataOrganizationDecision>;
  in?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataOrganizationDecision>>>;
  lt?: InputMaybe<EnumTaskEntityCachedDataOrganizationDecision>;
  lte?: InputMaybe<EnumTaskEntityCachedDataOrganizationDecision>;
  ne?: InputMaybe<EnumTaskEntityCachedDataOrganizationDecision>;
  nin?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataOrganizationDecision>>>;
};

export type FilterFindManyTaskEntityCachedDataOrganizationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTaskEntityCachedDataOrganizationInput = {
  companyName?: InputMaybe<Scalars['String']>;
  decision?: InputMaybe<EnumTaskEntityCachedDataOrganizationDecision>;
  id?: InputMaybe<Scalars['Float']>;
  isApiPartner?: InputMaybe<Scalars['Boolean']>;
  isSuspectedOfProhibitedIndustries?: InputMaybe<Scalars['Boolean']>;
  kybMoneyIn?: InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyIn>;
  kybMoneyInSubType?: InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyInSubType>;
  kybStatus?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  partner?: InputMaybe<FilterFindManyTaskEntityCachedDataOrganizationPartnerInput>;
  taxIdType?: InputMaybe<EnumTaskEntityCachedDataOrganizationTaxIdType>;
  zendeskTickets?: InputMaybe<Array<InputMaybe<FilterFindManyTaskEntityCachedDataOrganizationZendeskTicketsInput>>>;
};

export type FilterFindManyTaskEntityCachedDataOrganizationIsApiPartnerOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTaskEntityCachedDataOrganizationIsSuspectedOfProhibitedIndustriesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTaskEntityCachedDataOrganizationKybMoneyInOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyIn>;
  gte?: InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyIn>;
  in?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyIn>>>;
  lt?: InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyIn>;
  lte?: InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyIn>;
  ne?: InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyIn>;
  nin?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyIn>>>;
};

export type FilterFindManyTaskEntityCachedDataOrganizationKybMoneyInSubTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyInSubType>;
  gte?: InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyInSubType>;
  in?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyInSubType>>>;
  lt?: InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyInSubType>;
  lte?: InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyInSubType>;
  ne?: InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyInSubType>;
  nin?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyInSubType>>>;
};

export type FilterFindManyTaskEntityCachedDataOrganizationKybStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataOrganizationLabelsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataOrganizationOperatorsInput = {
  companyName?: InputMaybe<FilterFindManyTaskEntityCachedDataOrganizationCompanyNameOperatorsInput>;
  decision?: InputMaybe<FilterFindManyTaskEntityCachedDataOrganizationDecisionOperatorsInput>;
  id?: InputMaybe<FilterFindManyTaskEntityCachedDataOrganizationIdOperatorsInput>;
  isApiPartner?: InputMaybe<FilterFindManyTaskEntityCachedDataOrganizationIsApiPartnerOperatorsInput>;
  isSuspectedOfProhibitedIndustries?: InputMaybe<FilterFindManyTaskEntityCachedDataOrganizationIsSuspectedOfProhibitedIndustriesOperatorsInput>;
  kybMoneyIn?: InputMaybe<FilterFindManyTaskEntityCachedDataOrganizationKybMoneyInOperatorsInput>;
  kybMoneyInSubType?: InputMaybe<FilterFindManyTaskEntityCachedDataOrganizationKybMoneyInSubTypeOperatorsInput>;
  kybStatus?: InputMaybe<FilterFindManyTaskEntityCachedDataOrganizationKybStatusOperatorsInput>;
  labels?: InputMaybe<FilterFindManyTaskEntityCachedDataOrganizationLabelsOperatorsInput>;
  partner?: InputMaybe<FilterFindManyTaskEntityCachedDataOrganizationPartnerOperatorsInput>;
  taxIdType?: InputMaybe<FilterFindManyTaskEntityCachedDataOrganizationTaxIdTypeOperatorsInput>;
  zendeskTickets?: InputMaybe<FilterFindManyTaskEntityCachedDataOrganizationZendeskTicketsOperatorsInput>;
};

export type FilterFindManyTaskEntityCachedDataOrganizationPartnerCompanyNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataOrganizationPartnerInput = {
  companyName?: InputMaybe<Scalars['String']>;
  partnerName?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyTaskEntityCachedDataOrganizationPartnerOperatorsInput = {
  companyName?: InputMaybe<FilterFindManyTaskEntityCachedDataOrganizationPartnerCompanyNameOperatorsInput>;
  partnerName?: InputMaybe<FilterFindManyTaskEntityCachedDataOrganizationPartnerPartnerNameOperatorsInput>;
};

export type FilterFindManyTaskEntityCachedDataOrganizationPartnerPartnerNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataOrganizationTaxIdTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTaskEntityCachedDataOrganizationTaxIdType>;
  gte?: InputMaybe<EnumTaskEntityCachedDataOrganizationTaxIdType>;
  in?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataOrganizationTaxIdType>>>;
  lt?: InputMaybe<EnumTaskEntityCachedDataOrganizationTaxIdType>;
  lte?: InputMaybe<EnumTaskEntityCachedDataOrganizationTaxIdType>;
  ne?: InputMaybe<EnumTaskEntityCachedDataOrganizationTaxIdType>;
  nin?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataOrganizationTaxIdType>>>;
};

export type FilterFindManyTaskEntityCachedDataOrganizationZendeskTicketsIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTaskEntityCachedDataOrganizationZendeskTicketsInput = {
  id?: InputMaybe<Scalars['Float']>;
  latestComment?: InputMaybe<FilterFindManyTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentInput>;
};

export type FilterFindManyTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentCommenterInput = {
  isAnalyst?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentCommenterIsAnalystOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentCommenterNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentCommenterOperatorsInput = {
  isAnalyst?: InputMaybe<FilterFindManyTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentCommenterIsAnalystOperatorsInput>;
  name?: InputMaybe<FilterFindManyTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentCommenterNameOperatorsInput>;
};

export type FilterFindManyTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentInput = {
  commenter?: InputMaybe<FilterFindManyTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentCommenterInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  priority?: InputMaybe<EnumTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentPriority>;
  status?: InputMaybe<EnumTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentStatus>;
};

export type FilterFindManyTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentOperatorsInput = {
  commenter?: InputMaybe<FilterFindManyTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentCommenterOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentCreatedAtOperatorsInput>;
  priority?: InputMaybe<FilterFindManyTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentPriorityOperatorsInput>;
  status?: InputMaybe<FilterFindManyTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentStatusOperatorsInput>;
};

export type FilterFindManyTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentPriorityOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentPriority>;
  gte?: InputMaybe<EnumTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentPriority>;
  in?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentPriority>>>;
  lt?: InputMaybe<EnumTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentPriority>;
  lte?: InputMaybe<EnumTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentPriority>;
  ne?: InputMaybe<EnumTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentPriority>;
  nin?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentPriority>>>;
};

export type FilterFindManyTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentStatus>;
  gte?: InputMaybe<EnumTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentStatus>>>;
  lt?: InputMaybe<EnumTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentStatus>;
  lte?: InputMaybe<EnumTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentStatus>;
  ne?: InputMaybe<EnumTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentStatus>>>;
};

export type FilterFindManyTaskEntityCachedDataOrganizationZendeskTicketsOperatorsInput = {
  id?: InputMaybe<FilterFindManyTaskEntityCachedDataOrganizationZendeskTicketsIdOperatorsInput>;
  latestComment?: InputMaybe<FilterFindManyTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentOperatorsInput>;
};

export type FilterFindManyTaskEntityCachedDataPaymentAmountOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTaskEntityCachedDataPaymentApprovalActionInput = {
  reason?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyTaskEntityCachedDataPaymentApprovalActionOperatorsInput = {
  reason?: InputMaybe<FilterFindManyTaskEntityCachedDataPaymentApprovalActionReasonOperatorsInput>;
};

export type FilterFindManyTaskEntityCachedDataPaymentApprovalActionReasonOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataPaymentCreateOriginOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTaskEntityCachedDataPaymentCreateOrigin>;
  gte?: InputMaybe<EnumTaskEntityCachedDataPaymentCreateOrigin>;
  in?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataPaymentCreateOrigin>>>;
  lt?: InputMaybe<EnumTaskEntityCachedDataPaymentCreateOrigin>;
  lte?: InputMaybe<EnumTaskEntityCachedDataPaymentCreateOrigin>;
  ne?: InputMaybe<EnumTaskEntityCachedDataPaymentCreateOrigin>;
  nin?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataPaymentCreateOrigin>>>;
};

export type FilterFindManyTaskEntityCachedDataPaymentCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyTaskEntityCachedDataPaymentCreatedByEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataPaymentCreatedByPartnerCompanyNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataPaymentCreatedByPartnerIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTaskEntityCachedDataPaymentCreatedByPartnerInput = {
  companyName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyTaskEntityCachedDataPaymentCreatedByPartnerOperatorsInput = {
  companyName?: InputMaybe<FilterFindManyTaskEntityCachedDataPaymentCreatedByPartnerCompanyNameOperatorsInput>;
  id?: InputMaybe<FilterFindManyTaskEntityCachedDataPaymentCreatedByPartnerIdOperatorsInput>;
};

export type FilterFindManyTaskEntityCachedDataPaymentCurrencyOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataPaymentDeliveryPreferenceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTaskEntityCachedDataPaymentDeliveryPreference>;
  gte?: InputMaybe<EnumTaskEntityCachedDataPaymentDeliveryPreference>;
  in?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataPaymentDeliveryPreference>>>;
  lt?: InputMaybe<EnumTaskEntityCachedDataPaymentDeliveryPreference>;
  lte?: InputMaybe<EnumTaskEntityCachedDataPaymentDeliveryPreference>;
  ne?: InputMaybe<EnumTaskEntityCachedDataPaymentDeliveryPreference>;
  nin?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataPaymentDeliveryPreference>>>;
};

export type FilterFindManyTaskEntityCachedDataPaymentDirectionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTaskEntityCachedDataPaymentDirection>;
  gte?: InputMaybe<EnumTaskEntityCachedDataPaymentDirection>;
  in?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataPaymentDirection>>>;
  lt?: InputMaybe<EnumTaskEntityCachedDataPaymentDirection>;
  lte?: InputMaybe<EnumTaskEntityCachedDataPaymentDirection>;
  ne?: InputMaybe<EnumTaskEntityCachedDataPaymentDirection>;
  nin?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataPaymentDirection>>>;
};

export type FilterFindManyTaskEntityCachedDataPaymentForeignAmountOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTaskEntityCachedDataPaymentForeignCurrencyOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataPaymentIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTaskEntityCachedDataPaymentInput = {
  amount?: InputMaybe<Scalars['Float']>;
  createOrigin?: InputMaybe<EnumTaskEntityCachedDataPaymentCreateOrigin>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdByEmail?: InputMaybe<Scalars['String']>;
  createdByPartner?: InputMaybe<FilterFindManyTaskEntityCachedDataPaymentCreatedByPartnerInput>;
  currency?: InputMaybe<Scalars['String']>;
  deliveryPreference?: InputMaybe<EnumTaskEntityCachedDataPaymentDeliveryPreference>;
  direction?: InputMaybe<EnumTaskEntityCachedDataPaymentDirection>;
  foreignAmount?: InputMaybe<Scalars['Float']>;
  foreignCurrency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  isPartial?: InputMaybe<Scalars['Boolean']>;
  isSuspectedOfProhibitedIndustries?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  pendingReason?: InputMaybe<Scalars['String']>;
  productUseCase?: InputMaybe<Scalars['String']>;
  riskStatus?: InputMaybe<EnumTaskEntityCachedDataPaymentRiskStatus>;
  scheduledDate?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyTaskEntityCachedDataPaymentIsPartialOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTaskEntityCachedDataPaymentIsSuspectedOfProhibitedIndustriesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTaskEntityCachedDataPaymentNoteOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataPaymentOperatorsInput = {
  amount?: InputMaybe<FilterFindManyTaskEntityCachedDataPaymentAmountOperatorsInput>;
  createOrigin?: InputMaybe<FilterFindManyTaskEntityCachedDataPaymentCreateOriginOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyTaskEntityCachedDataPaymentCreatedAtOperatorsInput>;
  createdByEmail?: InputMaybe<FilterFindManyTaskEntityCachedDataPaymentCreatedByEmailOperatorsInput>;
  createdByPartner?: InputMaybe<FilterFindManyTaskEntityCachedDataPaymentCreatedByPartnerOperatorsInput>;
  currency?: InputMaybe<FilterFindManyTaskEntityCachedDataPaymentCurrencyOperatorsInput>;
  deliveryPreference?: InputMaybe<FilterFindManyTaskEntityCachedDataPaymentDeliveryPreferenceOperatorsInput>;
  direction?: InputMaybe<FilterFindManyTaskEntityCachedDataPaymentDirectionOperatorsInput>;
  foreignAmount?: InputMaybe<FilterFindManyTaskEntityCachedDataPaymentForeignAmountOperatorsInput>;
  foreignCurrency?: InputMaybe<FilterFindManyTaskEntityCachedDataPaymentForeignCurrencyOperatorsInput>;
  id?: InputMaybe<FilterFindManyTaskEntityCachedDataPaymentIdOperatorsInput>;
  isPartial?: InputMaybe<FilterFindManyTaskEntityCachedDataPaymentIsPartialOperatorsInput>;
  isSuspectedOfProhibitedIndustries?: InputMaybe<FilterFindManyTaskEntityCachedDataPaymentIsSuspectedOfProhibitedIndustriesOperatorsInput>;
  note?: InputMaybe<FilterFindManyTaskEntityCachedDataPaymentNoteOperatorsInput>;
  pendingReason?: InputMaybe<FilterFindManyTaskEntityCachedDataPaymentPendingReasonOperatorsInput>;
  productUseCase?: InputMaybe<FilterFindManyTaskEntityCachedDataPaymentProductUseCaseOperatorsInput>;
  riskStatus?: InputMaybe<FilterFindManyTaskEntityCachedDataPaymentRiskStatusOperatorsInput>;
  scheduledDate?: InputMaybe<FilterFindManyTaskEntityCachedDataPaymentScheduledDateOperatorsInput>;
};

export type FilterFindManyTaskEntityCachedDataPaymentPendingReasonOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataPaymentProductUseCaseOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataPaymentRiskStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTaskEntityCachedDataPaymentRiskStatus>;
  gte?: InputMaybe<EnumTaskEntityCachedDataPaymentRiskStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataPaymentRiskStatus>>>;
  lt?: InputMaybe<EnumTaskEntityCachedDataPaymentRiskStatus>;
  lte?: InputMaybe<EnumTaskEntityCachedDataPaymentRiskStatus>;
  ne?: InputMaybe<EnumTaskEntityCachedDataPaymentRiskStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataPaymentRiskStatus>>>;
};

export type FilterFindManyTaskEntityCachedDataPaymentScheduledDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyTaskEntityCachedDataRecurringBillIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTaskEntityCachedDataRecurringBillInput = {
  id?: InputMaybe<Scalars['Float']>;
  occurrences?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyTaskEntityCachedDataRecurringBillOccurrencesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTaskEntityCachedDataRecurringBillOperatorsInput = {
  id?: InputMaybe<FilterFindManyTaskEntityCachedDataRecurringBillIdOperatorsInput>;
  occurrences?: InputMaybe<FilterFindManyTaskEntityCachedDataRecurringBillOccurrencesOperatorsInput>;
};

export type FilterFindManyTaskEntityCachedDataRiskEngineDecisionFeaturesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindManyTaskEntityCachedDataRiskEngineDecisionInput = {
  features?: InputMaybe<Scalars['JSON']>;
  reason?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyTaskEntityCachedDataRiskEngineDecisionOperatorsInput = {
  features?: InputMaybe<FilterFindManyTaskEntityCachedDataRiskEngineDecisionFeaturesOperatorsInput>;
  reason?: InputMaybe<FilterFindManyTaskEntityCachedDataRiskEngineDecisionReasonOperatorsInput>;
};

export type FilterFindManyTaskEntityCachedDataRiskEngineDecisionReasonOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataVendorCompanyNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskEntityCachedDataVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTaskEntityCachedDataVendorInput = {
  companyName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  isSuspectedOfProhibitedIndustries?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyTaskEntityCachedDataVendorIsSuspectedOfProhibitedIndustriesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTaskEntityCachedDataVendorOperatorsInput = {
  companyName?: InputMaybe<FilterFindManyTaskEntityCachedDataVendorCompanyNameOperatorsInput>;
  id?: InputMaybe<FilterFindManyTaskEntityCachedDataVendorIdOperatorsInput>;
  isSuspectedOfProhibitedIndustries?: InputMaybe<FilterFindManyTaskEntityCachedDataVendorIsSuspectedOfProhibitedIndustriesOperatorsInput>;
};

export type FilterFindManyTaskEntityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskInput = {
  AND?: InputMaybe<Array<FilterFindManyTaskInput>>;
  OR?: InputMaybe<Array<FilterFindManyTaskInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTaskOperatorsInput>;
  assignedTo?: InputMaybe<Scalars['MongoID']>;
  concernAreas?: InputMaybe<Array<InputMaybe<FilterFindManyTaskConcernAreasInput>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  entityCachedData?: InputMaybe<FilterFindManyTaskEntityCachedDataInput>;
  entityId?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['MongoID']>;
  lastDecisionDetails?: InputMaybe<FilterFindManyTaskConcernAreasLastDecisionDetailsInput>;
  lastEscalatedDetails?: InputMaybe<FilterFindManyTaskLastEscalatedDetailsInput>;
  parentTaskId?: InputMaybe<Scalars['MongoID']>;
  partnerName?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['JSON']>;
  prioritization?: InputMaybe<Scalars['Float']>;
  recurringBillId?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<EnumTaskStatus>;
  taskVersion?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedInSherlock?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyTaskLabelOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyTaskLastDecisionDetailsApproveAutomatedActionsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTaskLastDecisionDetailsFreeTextReasonOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskLastDecisionDetailsIncludeRecurringOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTaskLastDecisionDetailsLastDecisionDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyTaskLastDecisionDetailsLastDecisionMakerIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyTaskLastDecisionDetailsOperatorsInput = {
  approveAutomatedActions?: InputMaybe<FilterFindManyTaskLastDecisionDetailsApproveAutomatedActionsOperatorsInput>;
  freeTextReason?: InputMaybe<FilterFindManyTaskLastDecisionDetailsFreeTextReasonOperatorsInput>;
  includeRecurring?: InputMaybe<FilterFindManyTaskLastDecisionDetailsIncludeRecurringOperatorsInput>;
  lastDecisionDate?: InputMaybe<FilterFindManyTaskLastDecisionDetailsLastDecisionDateOperatorsInput>;
  lastDecisionMakerId?: InputMaybe<FilterFindManyTaskLastDecisionDetailsLastDecisionMakerIdOperatorsInput>;
  reason?: InputMaybe<FilterFindManyTaskLastDecisionDetailsReasonOperatorsInput>;
  type?: InputMaybe<FilterFindManyTaskLastDecisionDetailsTypeOperatorsInput>;
};

export type FilterFindManyTaskLastDecisionDetailsReasonOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskLastDecisionDetailsTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTaskConcernAreasLastDecisionDetailsType>;
  gte?: InputMaybe<EnumTaskConcernAreasLastDecisionDetailsType>;
  in?: InputMaybe<Array<InputMaybe<EnumTaskConcernAreasLastDecisionDetailsType>>>;
  lt?: InputMaybe<EnumTaskConcernAreasLastDecisionDetailsType>;
  lte?: InputMaybe<EnumTaskConcernAreasLastDecisionDetailsType>;
  ne?: InputMaybe<EnumTaskConcernAreasLastDecisionDetailsType>;
  nin?: InputMaybe<Array<InputMaybe<EnumTaskConcernAreasLastDecisionDetailsType>>>;
};

export type FilterFindManyTaskLastEscalatedDetailsCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyTaskLastEscalatedDetailsDescriptionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskLastEscalatedDetailsInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  teamIntegrationId?: InputMaybe<Scalars['MongoID']>;
  userId?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyTaskLastEscalatedDetailsOperatorsInput = {
  createdAt?: InputMaybe<FilterFindManyTaskLastEscalatedDetailsCreatedAtOperatorsInput>;
  description?: InputMaybe<FilterFindManyTaskLastEscalatedDetailsDescriptionOperatorsInput>;
  teamIntegrationId?: InputMaybe<FilterFindManyTaskLastEscalatedDetailsTeamIntegrationIdOperatorsInput>;
  userId?: InputMaybe<FilterFindManyTaskLastEscalatedDetailsUserIdOperatorsInput>;
};

export type FilterFindManyTaskLastEscalatedDetailsTeamIntegrationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyTaskLastEscalatedDetailsUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTaskOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTask_IdOperatorsInput>;
  assignedTo?: InputMaybe<FilterFindManyTaskAssignedToOperatorsInput>;
  concernAreas?: InputMaybe<FilterFindManyTaskConcernAreasOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyTaskCreatedAtOperatorsInput>;
  deletedAt?: InputMaybe<FilterFindManyTaskDeletedAtOperatorsInput>;
  entityCachedData?: InputMaybe<FilterFindManyTaskEntityCachedDataOperatorsInput>;
  entityId?: InputMaybe<FilterFindManyTaskEntityIdOperatorsInput>;
  extraFilters?: InputMaybe<Scalars['JSON']>;
  label?: InputMaybe<FilterFindManyTaskLabelOperatorsInput>;
  lastDecisionDetails?: InputMaybe<FilterFindManyTaskLastDecisionDetailsOperatorsInput>;
  lastEscalatedDetails?: InputMaybe<FilterFindManyTaskLastEscalatedDetailsOperatorsInput>;
  parentTaskId?: InputMaybe<FilterFindManyTaskParentTaskIdOperatorsInput>;
  partnerName?: InputMaybe<FilterFindManyTaskPartnerNameOperatorsInput>;
  payload?: InputMaybe<FilterFindManyTaskPayloadOperatorsInput>;
  prioritization?: InputMaybe<FilterFindManyTaskPrioritizationOperatorsInput>;
  recurringBillId?: InputMaybe<FilterFindManyTaskRecurringBillIdOperatorsInput>;
  status?: InputMaybe<FilterFindManyTaskStatusOperatorsInput>;
  taskVersion?: InputMaybe<FilterFindManyTaskTaskVersionOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyTaskUpdatedAtOperatorsInput>;
  updatedInSherlock?: InputMaybe<FilterFindManyTaskUpdatedInSherlockOperatorsInput>;
};

export type FilterFindManyTaskParentTaskIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyTaskPartnerNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTaskPayloadOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindManyTaskPrioritizationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTaskRecurringBillIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTaskStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTaskStatus>;
  gte?: InputMaybe<EnumTaskStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumTaskStatus>>>;
  lt?: InputMaybe<EnumTaskStatus>;
  lte?: InputMaybe<EnumTaskStatus>;
  ne?: InputMaybe<EnumTaskStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumTaskStatus>>>;
};

export type FilterFindManyTaskTaskVersionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTaskUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyTaskUpdatedInSherlockOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTask_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyTeamInput = {
  AND?: InputMaybe<Array<FilterFindManyTeamInput>>;
  OR?: InputMaybe<Array<FilterFindManyTeamInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTeamOperatorsInput>;
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyTeamIntegrationDeletedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyTeamIntegrationEntityTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTeamIntegrationInput = {
  AND?: InputMaybe<Array<FilterFindManyTeamIntegrationInput>>;
  OR?: InputMaybe<Array<FilterFindManyTeamIntegrationInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTeamIntegrationOperatorsInput>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  entityType?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  settings?: InputMaybe<FilterFindManyTeamIntegrationSettingsInput>;
  type?: InputMaybe<EnumTeamIntegrationType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTeamIntegrationOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTeamIntegration_IdOperatorsInput>;
  deletedAt?: InputMaybe<FilterFindManyTeamIntegrationDeletedAtOperatorsInput>;
  entityType?: InputMaybe<FilterFindManyTeamIntegrationEntityTypeOperatorsInput>;
  reason?: InputMaybe<FilterFindManyTeamIntegrationReasonOperatorsInput>;
  roleIds?: InputMaybe<FilterFindManyTeamIntegrationRoleIdsOperatorsInput>;
  settings?: InputMaybe<FilterFindManyTeamIntegrationSettingsOperatorsInput>;
  type?: InputMaybe<FilterFindManyTeamIntegrationTypeOperatorsInput>;
};

export type FilterFindManyTeamIntegrationReasonOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTeamIntegrationRoleIdsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyTeamIntegrationSettingsInput = {
  showAmount?: InputMaybe<Scalars['Boolean']>;
  slackChannelId?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyTeamIntegrationSettingsOperatorsInput = {
  showAmount?: InputMaybe<FilterFindManyTeamIntegrationSettingsShowAmountOperatorsInput>;
  slackChannelId?: InputMaybe<FilterFindManyTeamIntegrationSettingsSlackChannelIdOperatorsInput>;
  tag?: InputMaybe<FilterFindManyTeamIntegrationSettingsTagOperatorsInput>;
};

export type FilterFindManyTeamIntegrationSettingsShowAmountOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTeamIntegrationSettingsSlackChannelIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTeamIntegrationSettingsTagOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyTeamIntegrationTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTeamIntegrationType>;
  gte?: InputMaybe<EnumTeamIntegrationType>;
  in?: InputMaybe<Array<InputMaybe<EnumTeamIntegrationType>>>;
  lt?: InputMaybe<EnumTeamIntegrationType>;
  lte?: InputMaybe<EnumTeamIntegrationType>;
  ne?: InputMaybe<EnumTeamIntegrationType>;
  nin?: InputMaybe<Array<InputMaybe<EnumTeamIntegrationType>>>;
};

export type FilterFindManyTeamIntegration_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTeamOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTeam_IdOperatorsInput>;
};

export type FilterFindManyTeam_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyUiFlowBlocksActionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowBlocksColorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowBlocksDisplayNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowBlocksDynamicVariablesInput = {
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyUiFlowBlocksDynamicVariablesNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowBlocksDynamicVariablesOperatorsInput = {
  name?: InputMaybe<FilterFindManyUiFlowBlocksDynamicVariablesNameOperatorsInput>;
  value?: InputMaybe<FilterFindManyUiFlowBlocksDynamicVariablesValueOperatorsInput>;
};

export type FilterFindManyUiFlowBlocksDynamicVariablesValueOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowBlocksExtrasOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindManyUiFlowBlocksFlowIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyUiFlowBlocksFlowResultOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowBlocksFlowStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumUiFlowBlocksFlowStatus>;
  gte?: InputMaybe<EnumUiFlowBlocksFlowStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumUiFlowBlocksFlowStatus>>>;
  lt?: InputMaybe<EnumUiFlowBlocksFlowStatus>;
  lte?: InputMaybe<EnumUiFlowBlocksFlowStatus>;
  ne?: InputMaybe<EnumUiFlowBlocksFlowStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumUiFlowBlocksFlowStatus>>>;
};

export type FilterFindManyUiFlowBlocksIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowBlocksInput = {
  actionId?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  dynamicVariables?: InputMaybe<Array<InputMaybe<FilterFindManyUiFlowBlocksDynamicVariablesInput>>>;
  extras?: InputMaybe<Scalars['JSON']>;
  flowId?: InputMaybe<Scalars['MongoID']>;
  flowResult?: InputMaybe<Scalars['String']>;
  flowStatus?: InputMaybe<EnumUiFlowBlocksFlowStatus>;
  id?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  parameters?: InputMaybe<Array<InputMaybe<FilterFindManyUiFlowBlocksParametersInput>>>;
  ports?: InputMaybe<Array<InputMaybe<FilterFindManyUiFlowBlocksPortsInput>>>;
  readOnly?: InputMaybe<Scalars['Boolean']>;
  selected?: InputMaybe<Scalars['Boolean']>;
  strategyId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<EnumUiFlowBlocksType>;
  wait?: InputMaybe<FilterFindManyUiFlowBlocksWaitInput>;
  x?: InputMaybe<Scalars['Float']>;
  y?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyUiFlowBlocksLabelOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowBlocksLockedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyUiFlowBlocksOperatorsInput = {
  actionId?: InputMaybe<FilterFindManyUiFlowBlocksActionIdOperatorsInput>;
  color?: InputMaybe<FilterFindManyUiFlowBlocksColorOperatorsInput>;
  displayName?: InputMaybe<FilterFindManyUiFlowBlocksDisplayNameOperatorsInput>;
  dynamicVariables?: InputMaybe<FilterFindManyUiFlowBlocksDynamicVariablesOperatorsInput>;
  extras?: InputMaybe<FilterFindManyUiFlowBlocksExtrasOperatorsInput>;
  flowId?: InputMaybe<FilterFindManyUiFlowBlocksFlowIdOperatorsInput>;
  flowResult?: InputMaybe<FilterFindManyUiFlowBlocksFlowResultOperatorsInput>;
  flowStatus?: InputMaybe<FilterFindManyUiFlowBlocksFlowStatusOperatorsInput>;
  id?: InputMaybe<FilterFindManyUiFlowBlocksIdOperatorsInput>;
  label?: InputMaybe<FilterFindManyUiFlowBlocksLabelOperatorsInput>;
  locked?: InputMaybe<FilterFindManyUiFlowBlocksLockedOperatorsInput>;
  parameters?: InputMaybe<FilterFindManyUiFlowBlocksParametersOperatorsInput>;
  ports?: InputMaybe<FilterFindManyUiFlowBlocksPortsOperatorsInput>;
  readOnly?: InputMaybe<FilterFindManyUiFlowBlocksReadOnlyOperatorsInput>;
  selected?: InputMaybe<FilterFindManyUiFlowBlocksSelectedOperatorsInput>;
  strategyId?: InputMaybe<FilterFindManyUiFlowBlocksStrategyIdOperatorsInput>;
  type?: InputMaybe<FilterFindManyUiFlowBlocksTypeOperatorsInput>;
  wait?: InputMaybe<FilterFindManyUiFlowBlocksWaitOperatorsInput>;
  x?: InputMaybe<FilterFindManyUiFlowBlocksXOperatorsInput>;
  y?: InputMaybe<FilterFindManyUiFlowBlocksYOperatorsInput>;
};

export type FilterFindManyUiFlowBlocksParametersInput = {
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterFindManyUiFlowBlocksParametersNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowBlocksParametersOperatorsInput = {
  name?: InputMaybe<FilterFindManyUiFlowBlocksParametersNameOperatorsInput>;
  value?: InputMaybe<FilterFindManyUiFlowBlocksParametersValueOperatorsInput>;
};

export type FilterFindManyUiFlowBlocksParametersValueOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindManyUiFlowBlocksPortsAlignmentOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumUiFlowBlocksPortsAlignment>;
  gte?: InputMaybe<EnumUiFlowBlocksPortsAlignment>;
  in?: InputMaybe<Array<InputMaybe<EnumUiFlowBlocksPortsAlignment>>>;
  lt?: InputMaybe<EnumUiFlowBlocksPortsAlignment>;
  lte?: InputMaybe<EnumUiFlowBlocksPortsAlignment>;
  ne?: InputMaybe<EnumUiFlowBlocksPortsAlignment>;
  nin?: InputMaybe<Array<InputMaybe<EnumUiFlowBlocksPortsAlignment>>>;
};

export type FilterFindManyUiFlowBlocksPortsExtrasOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindManyUiFlowBlocksPortsIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowBlocksPortsInOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyUiFlowBlocksPortsInput = {
  alignment?: InputMaybe<EnumUiFlowBlocksPortsAlignment>;
  extras?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkInput>;
  links?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  locked?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentNode?: InputMaybe<Scalars['String']>;
  selected?: InputMaybe<Scalars['Boolean']>;
  target?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  x?: InputMaybe<Scalars['Float']>;
  y?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyUiFlowBlocksPortsLabelOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowBlocksPortsLinkColorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowBlocksPortsLinkCurvynessOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyUiFlowBlocksPortsLinkExtrasOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindManyUiFlowBlocksPortsLinkIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowBlocksPortsLinkInput = {
  color?: InputMaybe<Scalars['String']>;
  curvyness?: InputMaybe<Scalars['Float']>;
  extras?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Array<InputMaybe<FilterFindManyUiFlowBlocksPortsLinkLabelsInput>>>;
  locked?: InputMaybe<Scalars['Boolean']>;
  points?: InputMaybe<Array<InputMaybe<FilterFindManyUiFlowBlocksPortsLinkPointsInput>>>;
  selected?: InputMaybe<Scalars['Boolean']>;
  selectedColor?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  sourcePort?: InputMaybe<Scalars['String']>;
  target?: InputMaybe<Scalars['String']>;
  targetPort?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyUiFlowBlocksPortsLinkLabelsExtrasOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindManyUiFlowBlocksPortsLinkLabelsIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowBlocksPortsLinkLabelsInput = {
  extras?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  offsetX?: InputMaybe<Scalars['Float']>;
  offsetY?: InputMaybe<Scalars['Float']>;
  selected?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyUiFlowBlocksPortsLinkLabelsLockedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyUiFlowBlocksPortsLinkLabelsOffsetXOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyUiFlowBlocksPortsLinkLabelsOffsetYOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyUiFlowBlocksPortsLinkLabelsOperatorsInput = {
  extras?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkLabelsExtrasOperatorsInput>;
  id?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkLabelsIdOperatorsInput>;
  locked?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkLabelsLockedOperatorsInput>;
  offsetX?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkLabelsOffsetXOperatorsInput>;
  offsetY?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkLabelsOffsetYOperatorsInput>;
  selected?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkLabelsSelectedOperatorsInput>;
  type?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkLabelsTypeOperatorsInput>;
};

export type FilterFindManyUiFlowBlocksPortsLinkLabelsSelectedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyUiFlowBlocksPortsLinkLabelsTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowBlocksPortsLinkLockedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyUiFlowBlocksPortsLinkOperatorsInput = {
  color?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkColorOperatorsInput>;
  curvyness?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkCurvynessOperatorsInput>;
  extras?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkExtrasOperatorsInput>;
  id?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkIdOperatorsInput>;
  labels?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkLabelsOperatorsInput>;
  locked?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkLockedOperatorsInput>;
  points?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkPointsOperatorsInput>;
  selected?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkSelectedOperatorsInput>;
  selectedColor?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkSelectedColorOperatorsInput>;
  source?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkSourceOperatorsInput>;
  sourcePort?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkSourcePortOperatorsInput>;
  target?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkTargetOperatorsInput>;
  targetPort?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkTargetPortOperatorsInput>;
  type?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkTypeOperatorsInput>;
  width?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkWidthOperatorsInput>;
};

export type FilterFindManyUiFlowBlocksPortsLinkPointsExtrasOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindManyUiFlowBlocksPortsLinkPointsIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowBlocksPortsLinkPointsInput = {
  extras?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  selected?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  x?: InputMaybe<Scalars['Float']>;
  y?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyUiFlowBlocksPortsLinkPointsLockedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyUiFlowBlocksPortsLinkPointsOperatorsInput = {
  extras?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkPointsExtrasOperatorsInput>;
  id?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkPointsIdOperatorsInput>;
  locked?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkPointsLockedOperatorsInput>;
  selected?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkPointsSelectedOperatorsInput>;
  type?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkPointsTypeOperatorsInput>;
  x?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkPointsXOperatorsInput>;
  y?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkPointsYOperatorsInput>;
};

export type FilterFindManyUiFlowBlocksPortsLinkPointsSelectedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyUiFlowBlocksPortsLinkPointsTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowBlocksPortsLinkPointsXOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyUiFlowBlocksPortsLinkPointsYOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyUiFlowBlocksPortsLinkSelectedColorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowBlocksPortsLinkSelectedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyUiFlowBlocksPortsLinkSourceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowBlocksPortsLinkSourcePortOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowBlocksPortsLinkTargetOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowBlocksPortsLinkTargetPortOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowBlocksPortsLinkTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowBlocksPortsLinkWidthOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyUiFlowBlocksPortsLinksOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindManyUiFlowBlocksPortsLockedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyUiFlowBlocksPortsNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowBlocksPortsOperatorsInput = {
  alignment?: InputMaybe<FilterFindManyUiFlowBlocksPortsAlignmentOperatorsInput>;
  extras?: InputMaybe<FilterFindManyUiFlowBlocksPortsExtrasOperatorsInput>;
  id?: InputMaybe<FilterFindManyUiFlowBlocksPortsIdOperatorsInput>;
  in?: InputMaybe<FilterFindManyUiFlowBlocksPortsInOperatorsInput>;
  label?: InputMaybe<FilterFindManyUiFlowBlocksPortsLabelOperatorsInput>;
  link?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinkOperatorsInput>;
  links?: InputMaybe<FilterFindManyUiFlowBlocksPortsLinksOperatorsInput>;
  locked?: InputMaybe<FilterFindManyUiFlowBlocksPortsLockedOperatorsInput>;
  name?: InputMaybe<FilterFindManyUiFlowBlocksPortsNameOperatorsInput>;
  parentNode?: InputMaybe<FilterFindManyUiFlowBlocksPortsParentNodeOperatorsInput>;
  selected?: InputMaybe<FilterFindManyUiFlowBlocksPortsSelectedOperatorsInput>;
  target?: InputMaybe<FilterFindManyUiFlowBlocksPortsTargetOperatorsInput>;
  type?: InputMaybe<FilterFindManyUiFlowBlocksPortsTypeOperatorsInput>;
  x?: InputMaybe<FilterFindManyUiFlowBlocksPortsXOperatorsInput>;
  y?: InputMaybe<FilterFindManyUiFlowBlocksPortsYOperatorsInput>;
};

export type FilterFindManyUiFlowBlocksPortsParentNodeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowBlocksPortsSelectedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyUiFlowBlocksPortsTargetOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowBlocksPortsTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowBlocksPortsXOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyUiFlowBlocksPortsYOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyUiFlowBlocksReadOnlyOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyUiFlowBlocksSelectedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyUiFlowBlocksStrategyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowBlocksTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumUiFlowBlocksType>;
  gte?: InputMaybe<EnumUiFlowBlocksType>;
  in?: InputMaybe<Array<InputMaybe<EnumUiFlowBlocksType>>>;
  lt?: InputMaybe<EnumUiFlowBlocksType>;
  lte?: InputMaybe<EnumUiFlowBlocksType>;
  ne?: InputMaybe<EnumUiFlowBlocksType>;
  nin?: InputMaybe<Array<InputMaybe<EnumUiFlowBlocksType>>>;
};

export type FilterFindManyUiFlowBlocksWaitAmountOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyUiFlowBlocksWaitInput = {
  amount?: InputMaybe<Scalars['Float']>;
  interval?: InputMaybe<EnumUiFlowBlocksWaitInterval>;
  startFrom?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyUiFlowBlocksWaitIntervalOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumUiFlowBlocksWaitInterval>;
  gte?: InputMaybe<EnumUiFlowBlocksWaitInterval>;
  in?: InputMaybe<Array<InputMaybe<EnumUiFlowBlocksWaitInterval>>>;
  lt?: InputMaybe<EnumUiFlowBlocksWaitInterval>;
  lte?: InputMaybe<EnumUiFlowBlocksWaitInterval>;
  ne?: InputMaybe<EnumUiFlowBlocksWaitInterval>;
  nin?: InputMaybe<Array<InputMaybe<EnumUiFlowBlocksWaitInterval>>>;
};

export type FilterFindManyUiFlowBlocksWaitOperatorsInput = {
  amount?: InputMaybe<FilterFindManyUiFlowBlocksWaitAmountOperatorsInput>;
  interval?: InputMaybe<FilterFindManyUiFlowBlocksWaitIntervalOperatorsInput>;
  startFrom?: InputMaybe<FilterFindManyUiFlowBlocksWaitStartFromOperatorsInput>;
};

export type FilterFindManyUiFlowBlocksWaitStartFromOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowBlocksXOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyUiFlowBlocksYOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyUiFlowCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyUiFlowDeletedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyUiFlowDisabledMessageOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowDisabledOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyUiFlowInput = {
  AND?: InputMaybe<Array<FilterFindManyUiFlowInput>>;
  OR?: InputMaybe<Array<FilterFindManyUiFlowInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyUiFlowOperatorsInput>;
  blocks?: InputMaybe<Array<InputMaybe<FilterFindManyUiFlowBlocksInput>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  disabledMessage?: InputMaybe<Scalars['String']>;
  lastUpdatedBy?: InputMaybe<Scalars['String']>;
  readingDeletedEntities?: InputMaybe<FilterFindManyUiFlowReadingDeletedEntitiesInput>;
  rejectHandler?: InputMaybe<FilterFindManyUiFlowRejectHandlerInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  triggers?: InputMaybe<FilterFindManyUiFlowTriggersInput>;
  type?: InputMaybe<Scalars['String']>;
  updateComment?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  version?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyUiFlowLastUpdatedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyUiFlowOperatorsInput = {
  _id?: InputMaybe<FilterFindManyUiFlow_IdOperatorsInput>;
  blocks?: InputMaybe<FilterFindManyUiFlowBlocksOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyUiFlowCreatedAtOperatorsInput>;
  deletedAt?: InputMaybe<FilterFindManyUiFlowDeletedAtOperatorsInput>;
  disabled?: InputMaybe<FilterFindManyUiFlowDisabledOperatorsInput>;
  disabledMessage?: InputMaybe<FilterFindManyUiFlowDisabledMessageOperatorsInput>;
  lastUpdatedBy?: InputMaybe<FilterFindManyUiFlowLastUpdatedByOperatorsInput>;
  readingDeletedEntities?: InputMaybe<FilterFindManyUiFlowReadingDeletedEntitiesOperatorsInput>;
  rejectHandler?: InputMaybe<FilterFindManyUiFlowRejectHandlerOperatorsInput>;
  tags?: InputMaybe<FilterFindManyUiFlowTagsOperatorsInput>;
  triggers?: InputMaybe<FilterFindManyUiFlowTriggersOperatorsInput>;
  type?: InputMaybe<FilterFindManyUiFlowTypeOperatorsInput>;
  updateComment?: InputMaybe<FilterFindManyUiFlowUpdateCommentOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyUiFlowUpdatedAtOperatorsInput>;
  version?: InputMaybe<FilterFindManyUiFlowVersionOperatorsInput>;
};

export type FilterFindManyUiFlowReadingDeletedEntitiesDefaultPolicyOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyUiFlowReadingDeletedEntitiesDeliveryMethodOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyUiFlowReadingDeletedEntitiesFundingSourceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyUiFlowReadingDeletedEntitiesInput = {
  defaultPolicy?: InputMaybe<Scalars['Boolean']>;
  deliveryMethod?: InputMaybe<Scalars['Boolean']>;
  fundingSource?: InputMaybe<Scalars['Boolean']>;
  payment?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyUiFlowReadingDeletedEntitiesOperatorsInput = {
  defaultPolicy?: InputMaybe<FilterFindManyUiFlowReadingDeletedEntitiesDefaultPolicyOperatorsInput>;
  deliveryMethod?: InputMaybe<FilterFindManyUiFlowReadingDeletedEntitiesDeliveryMethodOperatorsInput>;
  fundingSource?: InputMaybe<FilterFindManyUiFlowReadingDeletedEntitiesFundingSourceOperatorsInput>;
  payment?: InputMaybe<FilterFindManyUiFlowReadingDeletedEntitiesPaymentOperatorsInput>;
};

export type FilterFindManyUiFlowReadingDeletedEntitiesPaymentOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyUiFlowRejectHandlerActionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowRejectHandlerInput = {
  actionId?: InputMaybe<Scalars['String']>;
  parameters?: InputMaybe<Array<InputMaybe<FilterFindManyUiFlowRejectHandlerParametersInput>>>;
};

export type FilterFindManyUiFlowRejectHandlerOperatorsInput = {
  actionId?: InputMaybe<FilterFindManyUiFlowRejectHandlerActionIdOperatorsInput>;
  parameters?: InputMaybe<FilterFindManyUiFlowRejectHandlerParametersOperatorsInput>;
};

export type FilterFindManyUiFlowRejectHandlerParametersInput = {
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterFindManyUiFlowRejectHandlerParametersNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowRejectHandlerParametersOperatorsInput = {
  name?: InputMaybe<FilterFindManyUiFlowRejectHandlerParametersNameOperatorsInput>;
  value?: InputMaybe<FilterFindManyUiFlowRejectHandlerParametersValueOperatorsInput>;
};

export type FilterFindManyUiFlowRejectHandlerParametersValueOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindManyUiFlowTagsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowTriggersEventsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindManyUiFlowTriggersInput = {
  events?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindManyUiFlowTriggersOperatorsInput = {
  events?: InputMaybe<FilterFindManyUiFlowTriggersEventsOperatorsInput>;
};

export type FilterFindManyUiFlowTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowUpdateCommentOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUiFlowUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyUiFlowVersionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyUiFlow_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManysherlockUserEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManysherlockUserInput = {
  AND?: InputMaybe<Array<FilterFindManysherlockUserInput>>;
  OR?: InputMaybe<Array<FilterFindManysherlockUserInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManysherlockUserOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  /** Search by email in regExp */
  emailRegexp?: InputMaybe<Scalars['String']>;
  favoriteModules?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lastLoginAt?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  picture?: InputMaybe<Scalars['String']>;
  /** Search by role names */
  roleName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  squads?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  status?: InputMaybe<EnumsherlockUserStatus>;
  /** Search by team Ids */
  teamId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Search by team names */
  teamName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  xeroEmail?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManysherlockUserOperatorsInput = {
  _id?: InputMaybe<FilterFindManysherlockUser_IdOperatorsInput>;
  email?: InputMaybe<FilterFindManysherlockUserEmailOperatorsInput>;
  xeroEmail?: InputMaybe<FilterFindManysherlockUserXeroEmailOperatorsInput>;
};

export type FilterFindManysherlockUserXeroEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManysherlockUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneActionInput = {
  AND?: InputMaybe<Array<FilterFindOneActionInput>>;
  OR?: InputMaybe<Array<FilterFindOneActionInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneActionOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  module?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindOneActionLogCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindOneActionLogDetailsInput = {
  actionValues?: InputMaybe<Scalars['JSON']>;
  checkSerialNumber?: InputMaybe<Scalars['String']>;
  companyType?: InputMaybe<Scalars['String']>;
  createdManualPaymentId?: InputMaybe<Scalars['Float']>;
  deliveryMethodId?: InputMaybe<Scalars['Float']>;
  fundingSourceId?: InputMaybe<Scalars['Float']>;
  isSubscribed?: InputMaybe<Scalars['Boolean']>;
  isVip?: InputMaybe<Scalars['Boolean']>;
  metaData?: InputMaybe<Scalars['JSON']>;
  planCyclePeriod?: InputMaybe<Scalars['String']>;
  seats?: InputMaybe<Scalars['Float']>;
  sessionId?: InputMaybe<Scalars['String']>;
  subscriptionPlanId?: InputMaybe<Scalars['String']>;
  subscriptionPromoCode?: InputMaybe<Scalars['String']>;
  transferId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Float']>;
  zendeskTicketId?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneActionLogEntityOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumActionLogEntity>;
  gte?: InputMaybe<EnumActionLogEntity>;
  in?: InputMaybe<Array<InputMaybe<EnumActionLogEntity>>>;
  lt?: InputMaybe<EnumActionLogEntity>;
  lte?: InputMaybe<EnumActionLogEntity>;
  ne?: InputMaybe<EnumActionLogEntity>;
  nin?: InputMaybe<Array<InputMaybe<EnumActionLogEntity>>>;
};

export type FilterFindOneActionLogInput = {
  AND?: InputMaybe<Array<FilterFindOneActionLogInput>>;
  OR?: InputMaybe<Array<FilterFindOneActionLogInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneActionLogOperatorsInput>;
  actionEndpoint?: InputMaybe<Scalars['String']>;
  actionName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  details?: InputMaybe<FilterFindOneActionLogDetailsInput>;
  entity?: InputMaybe<EnumActionLogEntity>;
  entityId?: InputMaybe<Scalars['String']>;
  failureMessage?: InputMaybe<Scalars['String']>;
  isTrainingMode?: InputMaybe<Scalars['Boolean']>;
  partnerName?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<EnumActionLogResult>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  userId?: InputMaybe<Scalars['MongoID']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneActionLogOperatorsInput = {
  _id?: InputMaybe<FilterFindOneActionLog_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindOneActionLogCreatedAtOperatorsInput>;
  entity?: InputMaybe<FilterFindOneActionLogEntityOperatorsInput>;
};

export type FilterFindOneActionLog_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneActionOperatorsInput = {
  _id?: InputMaybe<FilterFindOneAction_IdOperatorsInput>;
};

export type FilterFindOneAction_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneCardRecordInput = {
  AND?: InputMaybe<Array<FilterFindOneCardRecordInput>>;
  OR?: InputMaybe<Array<FilterFindOneCardRecordInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCardRecordOperatorsInput>;
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deliveryMethod?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  recordId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCardRecordOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCardRecord_IdOperatorsInput>;
};

export type FilterFindOneCardRecord_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneConcernAreaSchemaInput = {
  AND?: InputMaybe<Array<FilterFindOneConcernAreaSchemaInput>>;
  OR?: InputMaybe<Array<FilterFindOneConcernAreaSchemaInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneConcernAreaSchemaOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  isMandatory?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  rules?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  squadId?: InputMaybe<Scalars['MongoID']>;
  status?: InputMaybe<EnumConcernAreaSchemaStatus>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneConcernAreaSchemaOperatorsInput = {
  _id?: InputMaybe<FilterFindOneConcernAreaSchema_IdOperatorsInput>;
};

export type FilterFindOneConcernAreaSchema_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneDecisionReportInput = {
  AND?: InputMaybe<Array<FilterFindOneDecisionReportInput>>;
  OR?: InputMaybe<Array<FilterFindOneDecisionReportInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDecisionReportOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  mode?: InputMaybe<EnumDecisionReportMode>;
  ruleDecisions?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  status?: InputMaybe<EnumDecisionReportStatus>;
  strategy?: InputMaybe<Scalars['MongoID']>;
  strategyVersion?: InputMaybe<Scalars['Float']>;
  success?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneDecisionReportOperatorsInput = {
  _id?: InputMaybe<FilterFindOneDecisionReport_IdOperatorsInput>;
};

export type FilterFindOneDecisionReport_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneFlowExecutionCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindOneFlowExecutionCurrentStepInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  expiresAt?: InputMaybe<Scalars['Date']>;
  flowExecutionId?: InputMaybe<Scalars['MongoID']>;
  flowResult?: InputMaybe<Scalars['JSON']>;
  index?: InputMaybe<Scalars['String']>;
  output?: InputMaybe<FilterFindOneFlowExecutionCurrentStepOutputInput>;
  status?: InputMaybe<EnumFlowExecutionCurrentStepStatus>;
  strategyDecisionReport?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindOneFlowExecutionCurrentStepOutputInput = {
  error?: InputMaybe<Scalars['String']>;
  feeIds?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  fundingSourceId?: InputMaybe<Scalars['Float']>;
  isEligible?: InputMaybe<Scalars['Boolean']>;
  setNumber?: InputMaybe<Scalars['Float']>;
  setString?: InputMaybe<Scalars['String']>;
  zendeskTicketId?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneFlowExecutionDynamicVariablesInput = {
  feeIds?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  fundingSourceId?: InputMaybe<Scalars['Float']>;
  isEligible?: InputMaybe<Scalars['Boolean']>;
  setNumber?: InputMaybe<Scalars['Float']>;
  setString?: InputMaybe<Scalars['String']>;
  zendeskTicketId?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneFlowExecutionInput = {
  AND?: InputMaybe<Array<FilterFindOneFlowExecutionInput>>;
  OR?: InputMaybe<Array<FilterFindOneFlowExecutionInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneFlowExecutionOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  currentStep?: InputMaybe<FilterFindOneFlowExecutionCurrentStepInput>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  dynamicVariables?: InputMaybe<FilterFindOneFlowExecutionDynamicVariablesInput>;
  input?: InputMaybe<Scalars['JSON']>;
  mode?: InputMaybe<EnumFlowExecutionMode>;
  output?: InputMaybe<Scalars['String']>;
  parentExecution?: InputMaybe<Scalars['MongoID']>;
  partnerName?: InputMaybe<Scalars['String']>;
  passedSteps?: InputMaybe<Array<InputMaybe<FilterFindOneFlowExecutionPassedStepsInput>>>;
  result?: InputMaybe<Scalars['JSON']>;
  startedAt?: InputMaybe<Scalars['Date']>;
  state?: InputMaybe<EnumFlowExecutionState>;
  status?: InputMaybe<EnumFlowExecutionStatus>;
  uiFlow?: InputMaybe<Scalars['MongoID']>;
  uiFlowVersion?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneFlowExecutionOperatorsInput = {
  _id?: InputMaybe<FilterFindOneFlowExecution_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindOneFlowExecutionCreatedAtOperatorsInput>;
};

export type FilterFindOneFlowExecutionPassedStepsInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  expiresAt?: InputMaybe<Scalars['Date']>;
  flowExecutionId?: InputMaybe<Scalars['MongoID']>;
  flowResult?: InputMaybe<Scalars['JSON']>;
  index?: InputMaybe<Scalars['String']>;
  output?: InputMaybe<FilterFindOneFlowExecutionPassedStepsOutputInput>;
  status?: InputMaybe<EnumFlowExecutionPassedStepsStatus>;
  strategyDecisionReport?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindOneFlowExecutionPassedStepsOutputInput = {
  error?: InputMaybe<Scalars['String']>;
  feeIds?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  fundingSourceId?: InputMaybe<Scalars['Float']>;
  isEligible?: InputMaybe<Scalars['Boolean']>;
  setNumber?: InputMaybe<Scalars['Float']>;
  setString?: InputMaybe<Scalars['String']>;
  zendeskTicketId?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneFlowExecution_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneGayaFormInput = {
  AND?: InputMaybe<Array<FilterFindOneGayaFormInput>>;
  OR?: InputMaybe<Array<FilterFindOneGayaFormInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneGayaFormOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  formType?: InputMaybe<EnumGayaFormFormType>;
  name?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  schema?: InputMaybe<Scalars['JSON']>;
  theme?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
  version?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneGayaFormNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneGayaFormOperatorsInput = {
  _id?: InputMaybe<FilterFindOneGayaForm_IdOperatorsInput>;
  name?: InputMaybe<FilterFindOneGayaFormNameOperatorsInput>;
};

export type FilterFindOneGayaFormResponseCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindOneGayaFormResponseCreatedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneGayaFormResponseInput = {
  AND?: InputMaybe<Array<FilterFindOneGayaFormResponseInput>>;
  OR?: InputMaybe<Array<FilterFindOneGayaFormResponseInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneGayaFormResponseOperatorsInput>;
  content?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  formId?: InputMaybe<Scalars['MongoID']>;
  formType?: InputMaybe<EnumGayaFormResponseFormType>;
  formVersion?: InputMaybe<Scalars['Float']>;
  partnerName?: InputMaybe<Scalars['String']>;
  userEmail?: InputMaybe<Scalars['String']>;
  zendeskTicketId?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneGayaFormResponseOperatorsInput = {
  _id?: InputMaybe<FilterFindOneGayaFormResponse_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindOneGayaFormResponseCreatedAtOperatorsInput>;
  createdBy?: InputMaybe<FilterFindOneGayaFormResponseCreatedByOperatorsInput>;
};

export type FilterFindOneGayaFormResponse_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneGayaForm_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneGayaThemeInput = {
  AND?: InputMaybe<Array<FilterFindOneGayaThemeInput>>;
  OR?: InputMaybe<Array<FilterFindOneGayaThemeInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneGayaThemeOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  theme?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindOneGayaThemeNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneGayaThemeOperatorsInput = {
  _id?: InputMaybe<FilterFindOneGayaTheme_IdOperatorsInput>;
  name?: InputMaybe<FilterFindOneGayaThemeNameOperatorsInput>;
};

export type FilterFindOneGayaTheme_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneGenericTaskAssignedToOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneGenericTaskCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindOneGenericTaskDeletedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindOneGenericTaskEntityCachedDataOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindOneGenericTaskEntityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneGenericTaskInput = {
  AND?: InputMaybe<Array<FilterFindOneGenericTaskInput>>;
  OR?: InputMaybe<Array<FilterFindOneGenericTaskInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneGenericTaskOperatorsInput>;
  assignedTo?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  entityCachedData?: InputMaybe<Scalars['JSON']>;
  entityId?: InputMaybe<Scalars['String']>;
  labelIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  parentTaskId?: InputMaybe<Scalars['MongoID']>;
  partnerName?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['MongoID']>;
  status?: InputMaybe<EnumGenericTaskStatus>;
  type?: InputMaybe<EnumGenericTaskType>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindOneGenericTaskLabelIdsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneGenericTaskOperatorsInput = {
  _id?: InputMaybe<FilterFindOneGenericTask_IdOperatorsInput>;
  assignedTo?: InputMaybe<FilterFindOneGenericTaskAssignedToOperatorsInput>;
  createdAt?: InputMaybe<FilterFindOneGenericTaskCreatedAtOperatorsInput>;
  deletedAt?: InputMaybe<FilterFindOneGenericTaskDeletedAtOperatorsInput>;
  entityCachedData?: InputMaybe<FilterFindOneGenericTaskEntityCachedDataOperatorsInput>;
  entityId?: InputMaybe<FilterFindOneGenericTaskEntityIdOperatorsInput>;
  labelIds?: InputMaybe<FilterFindOneGenericTaskLabelIdsOperatorsInput>;
  parentTaskId?: InputMaybe<FilterFindOneGenericTaskParentTaskIdOperatorsInput>;
  partnerName?: InputMaybe<FilterFindOneGenericTaskPartnerNameOperatorsInput>;
  projectId?: InputMaybe<FilterFindOneGenericTaskProjectIdOperatorsInput>;
  status?: InputMaybe<FilterFindOneGenericTaskStatusOperatorsInput>;
  type?: InputMaybe<FilterFindOneGenericTaskTypeOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindOneGenericTaskUpdatedAtOperatorsInput>;
};

export type FilterFindOneGenericTaskParentTaskIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneGenericTaskPartnerNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneGenericTaskProjectIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneGenericTaskStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumGenericTaskStatus>;
  gte?: InputMaybe<EnumGenericTaskStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumGenericTaskStatus>>>;
  lt?: InputMaybe<EnumGenericTaskStatus>;
  lte?: InputMaybe<EnumGenericTaskStatus>;
  ne?: InputMaybe<EnumGenericTaskStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumGenericTaskStatus>>>;
};

export type FilterFindOneGenericTaskTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumGenericTaskType>;
  gte?: InputMaybe<EnumGenericTaskType>;
  in?: InputMaybe<Array<InputMaybe<EnumGenericTaskType>>>;
  lt?: InputMaybe<EnumGenericTaskType>;
  lte?: InputMaybe<EnumGenericTaskType>;
  ne?: InputMaybe<EnumGenericTaskType>;
  nin?: InputMaybe<Array<InputMaybe<EnumGenericTaskType>>>;
};

export type FilterFindOneGenericTaskUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindOneGenericTask_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneIncidentBatchIdsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  batchId?: InputMaybe<Scalars['MongoID']>;
  executedBy?: InputMaybe<Scalars['MongoID']>;
  failedEntities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  groupsIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  isRunning?: InputMaybe<Scalars['Boolean']>;
  mode?: InputMaybe<EnumIncidentBatchIdsMode>;
  runAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindOneIncidentCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindOneIncidentExecutionLogBatchIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneIncidentExecutionLogIncidentGroupOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneIncidentExecutionLogInput = {
  AND?: InputMaybe<Array<FilterFindOneIncidentExecutionLogInput>>;
  OR?: InputMaybe<Array<FilterFindOneIncidentExecutionLogInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneIncidentExecutionLogOperatorsInput>;
  batchId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  entity?: InputMaybe<EnumIncidentExecutionLogEntity>;
  entityId?: InputMaybe<Scalars['Float']>;
  flowExecutionId?: InputMaybe<Scalars['MongoID']>;
  incident?: InputMaybe<Scalars['MongoID']>;
  incidentGroup?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneIncidentExecutionLogOperatorsInput = {
  _id?: InputMaybe<FilterFindOneIncidentExecutionLog_IdOperatorsInput>;
  batchId?: InputMaybe<FilterFindOneIncidentExecutionLogBatchIdOperatorsInput>;
  incidentGroup?: InputMaybe<FilterFindOneIncidentExecutionLogIncidentGroupOperatorsInput>;
};

export type FilterFindOneIncidentExecutionLog_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneIncidentGroupIncidentIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneIncidentGroupInput = {
  AND?: InputMaybe<Array<FilterFindOneIncidentGroupInput>>;
  OR?: InputMaybe<Array<FilterFindOneIncidentGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneIncidentGroupOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  flowId?: InputMaybe<Scalars['MongoID']>;
  incidentId?: InputMaybe<Scalars['MongoID']>;
  isTemplate?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<FilterFindOneIncidentGroupMetadataInput>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Float']>;
  rules?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindOneIncidentGroupIsTemplateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindOneIncidentGroupMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  calculatedAt?: InputMaybe<Scalars['Date']>;
  entityIds?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  totalEntities?: InputMaybe<Scalars['Float']>;
  totalEntitiesPercentage?: InputMaybe<Scalars['Float']>;
  totalTPV?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneIncidentGroupOperatorsInput = {
  _id?: InputMaybe<FilterFindOneIncidentGroup_IdOperatorsInput>;
  incidentId?: InputMaybe<FilterFindOneIncidentGroupIncidentIdOperatorsInput>;
  isTemplate?: InputMaybe<FilterFindOneIncidentGroupIsTemplateOperatorsInput>;
};

export type FilterFindOneIncidentGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneIncidentInput = {
  AND?: InputMaybe<Array<FilterFindOneIncidentInput>>;
  OR?: InputMaybe<Array<FilterFindOneIncidentInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneIncidentOperatorsInput>;
  batchIds?: InputMaybe<Array<InputMaybe<FilterFindOneIncidentBatchIdsInput>>>;
  calculationSize?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  entity?: InputMaybe<EnumIncidentEntity>;
  entityIds?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  fireHydrantUrl?: InputMaybe<Scalars['String']>;
  isCalculating?: InputMaybe<Scalars['Boolean']>;
  isCalculationFailed?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<EnumIncidentStatus>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindOneIncidentNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneIncidentOperatorsInput = {
  _id?: InputMaybe<FilterFindOneIncident_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindOneIncidentCreatedAtOperatorsInput>;
  name?: InputMaybe<FilterFindOneIncidentNameOperatorsInput>;
};

export type FilterFindOneIncident_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneLabelInput = {
  AND?: InputMaybe<Array<FilterFindOneLabelInput>>;
  OR?: InputMaybe<Array<FilterFindOneLabelInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneLabelOperatorsInput>;
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Float']>;
  rules?: InputMaybe<Array<InputMaybe<FilterFindOneLabelRulesInput>>>;
  type?: InputMaybe<EnumLabelType>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneLabelOperatorsInput = {
  _id?: InputMaybe<FilterFindOneLabel_IdOperatorsInput>;
};

export type FilterFindOneLabelRulesInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  logic?: InputMaybe<Scalars['String']>;
  tree?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneLabel_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneModuleRoutesInput = {
  AND?: InputMaybe<Array<FilterFindOneModuleRoutesInput>>;
  OR?: InputMaybe<Array<FilterFindOneModuleRoutesInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneModuleRoutesOperatorsInput>;
  module?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneModuleRoutesOperatorsInput = {
  _id?: InputMaybe<FilterFindOneModuleRoutes_IdOperatorsInput>;
  path?: InputMaybe<FilterFindOneModuleRoutesPathOperatorsInput>;
};

export type FilterFindOneModuleRoutesPathOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneModuleRoutes_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneRoleInput = {
  AND?: InputMaybe<Array<FilterFindOneRoleInput>>;
  OR?: InputMaybe<Array<FilterFindOneRoleInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneRoleOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  forbiddenGroupEntityIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  name?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneRoleOperatorsInput = {
  _id?: InputMaybe<FilterFindOneRole_IdOperatorsInput>;
};

export type FilterFindOneRole_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneRuleInput = {
  AND?: InputMaybe<Array<FilterFindOneRuleInput>>;
  OR?: InputMaybe<Array<FilterFindOneRuleInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneRuleOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  logic?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  tree?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  version?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneRuleOperatorsInput = {
  _id?: InputMaybe<FilterFindOneRule_IdOperatorsInput>;
};

export type FilterFindOneRule_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneSlotAssignedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneSlotAssignedDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindOneSlotConcernAreaSchemaIdsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneSlotCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindOneSlotDeletedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindOneSlotEndDateTimeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindOneSlotExternalSystemIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindOneSlotInput = {
  AND?: InputMaybe<Array<FilterFindOneSlotInput>>;
  OR?: InputMaybe<Array<FilterFindOneSlotInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneSlotOperatorsInput>;
  assignedBy?: InputMaybe<Scalars['MongoID']>;
  assignedDate?: InputMaybe<Scalars['Date']>;
  concernAreaSchemaIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  endDateTime?: InputMaybe<Scalars['Date']>;
  externalSystemId?: InputMaybe<Scalars['Float']>;
  labelIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  role?: InputMaybe<Scalars['String']>;
  shiftId?: InputMaybe<Scalars['MongoID']>;
  slotType?: InputMaybe<Scalars['String']>;
  startDateTime?: InputMaybe<Scalars['Date']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  userId?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindOneSlotLabelIdsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneSlotOperatorsInput = {
  _id?: InputMaybe<FilterFindOneSlot_IdOperatorsInput>;
  assignedBy?: InputMaybe<FilterFindOneSlotAssignedByOperatorsInput>;
  assignedDate?: InputMaybe<FilterFindOneSlotAssignedDateOperatorsInput>;
  concernAreaSchemaIds?: InputMaybe<FilterFindOneSlotConcernAreaSchemaIdsOperatorsInput>;
  createdAt?: InputMaybe<FilterFindOneSlotCreatedAtOperatorsInput>;
  deletedAt?: InputMaybe<FilterFindOneSlotDeletedAtOperatorsInput>;
  endDateTime?: InputMaybe<FilterFindOneSlotEndDateTimeOperatorsInput>;
  externalSystemId?: InputMaybe<FilterFindOneSlotExternalSystemIdOperatorsInput>;
  labelIds?: InputMaybe<FilterFindOneSlotLabelIdsOperatorsInput>;
  role?: InputMaybe<FilterFindOneSlotRoleOperatorsInput>;
  shiftId?: InputMaybe<FilterFindOneSlotShiftIdOperatorsInput>;
  slotType?: InputMaybe<FilterFindOneSlotSlotTypeOperatorsInput>;
  startDateTime?: InputMaybe<FilterFindOneSlotStartDateTimeOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindOneSlotUpdatedAtOperatorsInput>;
  userId?: InputMaybe<FilterFindOneSlotUserIdOperatorsInput>;
};

export type FilterFindOneSlotRoleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneSlotShiftIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneSlotSlotTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneSlotStartDateTimeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindOneSlotUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindOneSlotUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneSlot_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneSquadInput = {
  AND?: InputMaybe<Array<FilterFindOneSquadInput>>;
  OR?: InputMaybe<Array<FilterFindOneSquadInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneSquadOperatorsInput>;
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneSquadOperatorsInput = {
  _id?: InputMaybe<FilterFindOneSquad_IdOperatorsInput>;
};

export type FilterFindOneSquad_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneStrategyInput = {
  AND?: InputMaybe<Array<FilterFindOneStrategyInput>>;
  OR?: InputMaybe<Array<FilterFindOneStrategyInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneStrategyOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  logic?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  rules?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  tree?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  version?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneStrategyOperatorsInput = {
  _id?: InputMaybe<FilterFindOneStrategy_IdOperatorsInput>;
};

export type FilterFindOneStrategy_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneTaskConcernAreasConcernAreaSchemaIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneTaskConcernAreasDecisionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTaskConcernAreasDecision>;
  gte?: InputMaybe<EnumTaskConcernAreasDecision>;
  in?: InputMaybe<Array<InputMaybe<EnumTaskConcernAreasDecision>>>;
  lt?: InputMaybe<EnumTaskConcernAreasDecision>;
  lte?: InputMaybe<EnumTaskConcernAreasDecision>;
  ne?: InputMaybe<EnumTaskConcernAreasDecision>;
  nin?: InputMaybe<Array<InputMaybe<EnumTaskConcernAreasDecision>>>;
};

export type FilterFindOneTaskConcernAreasInput = {
  assignedTo?: InputMaybe<Scalars['MongoID']>;
  blockedRules?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  concernAreaSchemaId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  decision?: InputMaybe<EnumTaskConcernAreasDecision>;
  lastDecisionDetails?: InputMaybe<FilterFindOneTaskConcernAreasLastDecisionDetailsInput>;
  prevDecision?: InputMaybe<EnumTaskConcernAreasPrevDecision>;
  status?: InputMaybe<EnumTaskConcernAreasStatus>;
};

export type FilterFindOneTaskConcernAreasLastDecisionDetailsInput = {
  approveAutomatedActions?: InputMaybe<Scalars['Boolean']>;
  freeTextReason?: InputMaybe<Scalars['String']>;
  includeRecurring?: InputMaybe<Scalars['Boolean']>;
  lastDecisionDate: Scalars['Date'];
  lastDecisionMakerId?: InputMaybe<Scalars['MongoID']>;
  reason?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<EnumTaskConcernAreasLastDecisionDetailsType>;
};

export type FilterFindOneTaskConcernAreasLastDecisionDetailsLastDecisionDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindOneTaskConcernAreasLastDecisionDetailsLastDecisionMakerIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneTaskConcernAreasLastDecisionDetailsOperatorsInput = {
  lastDecisionDate?: InputMaybe<FilterFindOneTaskConcernAreasLastDecisionDetailsLastDecisionDateOperatorsInput>;
  lastDecisionMakerId?: InputMaybe<FilterFindOneTaskConcernAreasLastDecisionDetailsLastDecisionMakerIdOperatorsInput>;
};

export type FilterFindOneTaskConcernAreasOperatorsInput = {
  concernAreaSchemaId?: InputMaybe<FilterFindOneTaskConcernAreasConcernAreaSchemaIdOperatorsInput>;
  decision?: InputMaybe<FilterFindOneTaskConcernAreasDecisionOperatorsInput>;
  lastDecisionDetails?: InputMaybe<FilterFindOneTaskConcernAreasLastDecisionDetailsOperatorsInput>;
  status?: InputMaybe<FilterFindOneTaskConcernAreasStatusOperatorsInput>;
};

export type FilterFindOneTaskConcernAreasStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTaskConcernAreasStatus>;
  gte?: InputMaybe<EnumTaskConcernAreasStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumTaskConcernAreasStatus>>>;
  lt?: InputMaybe<EnumTaskConcernAreasStatus>;
  lte?: InputMaybe<EnumTaskConcernAreasStatus>;
  ne?: InputMaybe<EnumTaskConcernAreasStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumTaskConcernAreasStatus>>>;
};

export type FilterFindOneTaskDeletedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindOneTaskEntityCachedDataBillIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindOneTaskEntityCachedDataBillInput = {
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  isTest?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  recurringBillIndex?: InputMaybe<Scalars['Float']>;
  totalAmount?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneTaskEntityCachedDataBillOperatorsInput = {
  id?: InputMaybe<FilterFindOneTaskEntityCachedDataBillIdOperatorsInput>;
};

export type FilterFindOneTaskEntityCachedDataDeliveryMethodCardAccountInput = {
  cardType?: InputMaybe<Scalars['String']>;
  network?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneTaskEntityCachedDataDeliveryMethodCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindOneTaskEntityCachedDataDeliveryMethodInput = {
  bankAccountId?: InputMaybe<Scalars['Float']>;
  cardAccount?: InputMaybe<FilterFindOneTaskEntityCachedDataDeliveryMethodCardAccountInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deliveryType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  intuitAccountId?: InputMaybe<Scalars['String']>;
  isVerified?: InputMaybe<Scalars['Boolean']>;
  paperCheckId?: InputMaybe<Scalars['Float']>;
  plaidAccountId?: InputMaybe<Scalars['Float']>;
  rppsAccountId?: InputMaybe<Scalars['Float']>;
  verifiedStatus?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneTaskEntityCachedDataDeliveryMethodOperatorsInput = {
  createdAt?: InputMaybe<FilterFindOneTaskEntityCachedDataDeliveryMethodCreatedAtOperatorsInput>;
};

export type FilterFindOneTaskEntityCachedDataFeaturesClientIpAgeForOrganizationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindOneTaskEntityCachedDataFeaturesClientIpAgeForUserOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindOneTaskEntityCachedDataFeaturesHasFileRequestsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindOneTaskEntityCachedDataFeaturesInput = {
  clientIpAgeForOrganization?: InputMaybe<Scalars['Float']>;
  clientIpAgeForUser?: InputMaybe<Scalars['Float']>;
  deliveryMethodType?: InputMaybe<Scalars['String']>;
  doesOrgOweMoney?: InputMaybe<Scalars['Boolean']>;
  fundingSourceType?: InputMaybe<Scalars['String']>;
  hasFileRequests?: InputMaybe<Scalars['Boolean']>;
  invoiceOrNoteHasSanctionedWord?: InputMaybe<Scalars['Boolean']>;
  invoiceOrNoteHasSanctionedWordError?: InputMaybe<Scalars['Boolean']>;
  isApFinancingPayment?: InputMaybe<Scalars['Boolean']>;
  isCardWithSimilarDataApproved?: InputMaybe<Scalars['Boolean']>;
  isEmailVerified?: InputMaybe<Scalars['Boolean']>;
  isFRR?: InputMaybe<Scalars['Boolean']>;
  isGoodsReceived?: InputMaybe<Scalars['Boolean']>;
  isHighAmountForFS?: InputMaybe<Scalars['Boolean']>;
  isMicroDeposit?: InputMaybe<Scalars['Boolean']>;
  isOriginalDmEqualToCurrentDM?: InputMaybe<Scalars['Boolean']>;
  isPaymentExpedited?: InputMaybe<Scalars['Boolean']>;
  isPaymentOriginSafe?: InputMaybe<Scalars['Boolean']>;
  isSuspectedOfProhibitedIndustries?: InputMaybe<Scalars['Boolean']>;
  numOrganizationVendorCompletedPayments?: InputMaybe<Scalars['Float']>;
  payeeIdmScreeningNumHits?: InputMaybe<Scalars['Float']>;
  payorCreateOrigin?: InputMaybe<Scalars['String']>;
  payorIdmScreeningNumHits?: InputMaybe<Scalars['Float']>;
  vendorHasHandle?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneTaskEntityCachedDataFeaturesOperatorsInput = {
  clientIpAgeForOrganization?: InputMaybe<FilterFindOneTaskEntityCachedDataFeaturesClientIpAgeForOrganizationOperatorsInput>;
  clientIpAgeForUser?: InputMaybe<FilterFindOneTaskEntityCachedDataFeaturesClientIpAgeForUserOperatorsInput>;
  hasFileRequests?: InputMaybe<FilterFindOneTaskEntityCachedDataFeaturesHasFileRequestsOperatorsInput>;
};

export type FilterFindOneTaskEntityCachedDataFundingSourceCardAccountInput = {
  cardType?: InputMaybe<Scalars['String']>;
  network?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneTaskEntityCachedDataFundingSourceIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindOneTaskEntityCachedDataFundingSourceInput = {
  bankAccountId?: InputMaybe<Scalars['Float']>;
  cardAccount?: InputMaybe<FilterFindOneTaskEntityCachedDataFundingSourceCardAccountInput>;
  flexAccountId?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['Float']>;
  intuitAccountId?: InputMaybe<Scalars['String']>;
  isVerified?: InputMaybe<Scalars['Boolean']>;
  origin?: InputMaybe<Scalars['String']>;
  plaidAccountId?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneTaskEntityCachedDataFundingSourceOperatorsInput = {
  id?: InputMaybe<FilterFindOneTaskEntityCachedDataFundingSourceIdOperatorsInput>;
};

export type FilterFindOneTaskEntityCachedDataInput = {
  bill?: InputMaybe<FilterFindOneTaskEntityCachedDataBillInput>;
  deliveryMethod?: InputMaybe<FilterFindOneTaskEntityCachedDataDeliveryMethodInput>;
  features?: InputMaybe<FilterFindOneTaskEntityCachedDataFeaturesInput>;
  fundingSource?: InputMaybe<FilterFindOneTaskEntityCachedDataFundingSourceInput>;
  organization?: InputMaybe<FilterFindOneTaskEntityCachedDataOrganizationInput>;
  payment?: InputMaybe<FilterFindOneTaskEntityCachedDataPaymentInput>;
  paymentApprovalAction?: InputMaybe<FilterFindOneTaskEntityCachedDataPaymentApprovalActionInput>;
  recurringBill?: InputMaybe<FilterFindOneTaskEntityCachedDataRecurringBillInput>;
  riskEngineDecision?: InputMaybe<FilterFindOneTaskEntityCachedDataRiskEngineDecisionInput>;
  vendor?: InputMaybe<FilterFindOneTaskEntityCachedDataVendorInput>;
};

export type FilterFindOneTaskEntityCachedDataOperatorsInput = {
  bill?: InputMaybe<FilterFindOneTaskEntityCachedDataBillOperatorsInput>;
  deliveryMethod?: InputMaybe<FilterFindOneTaskEntityCachedDataDeliveryMethodOperatorsInput>;
  features?: InputMaybe<FilterFindOneTaskEntityCachedDataFeaturesOperatorsInput>;
  fundingSource?: InputMaybe<FilterFindOneTaskEntityCachedDataFundingSourceOperatorsInput>;
  organization?: InputMaybe<FilterFindOneTaskEntityCachedDataOrganizationOperatorsInput>;
  payment?: InputMaybe<FilterFindOneTaskEntityCachedDataPaymentOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneTaskEntityCachedDataVendorOperatorsInput>;
};

export type FilterFindOneTaskEntityCachedDataOrganizationCompanyNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneTaskEntityCachedDataOrganizationDecisionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTaskEntityCachedDataOrganizationDecision>;
  gte?: InputMaybe<EnumTaskEntityCachedDataOrganizationDecision>;
  in?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataOrganizationDecision>>>;
  lt?: InputMaybe<EnumTaskEntityCachedDataOrganizationDecision>;
  lte?: InputMaybe<EnumTaskEntityCachedDataOrganizationDecision>;
  ne?: InputMaybe<EnumTaskEntityCachedDataOrganizationDecision>;
  nin?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataOrganizationDecision>>>;
};

export type FilterFindOneTaskEntityCachedDataOrganizationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindOneTaskEntityCachedDataOrganizationInput = {
  companyName?: InputMaybe<Scalars['String']>;
  decision?: InputMaybe<EnumTaskEntityCachedDataOrganizationDecision>;
  id?: InputMaybe<Scalars['Float']>;
  isApiPartner?: InputMaybe<Scalars['Boolean']>;
  isSuspectedOfProhibitedIndustries?: InputMaybe<Scalars['Boolean']>;
  kybMoneyIn?: InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyIn>;
  kybMoneyInSubType?: InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyInSubType>;
  kybStatus?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  partner?: InputMaybe<FilterFindOneTaskEntityCachedDataOrganizationPartnerInput>;
  taxIdType?: InputMaybe<EnumTaskEntityCachedDataOrganizationTaxIdType>;
  zendeskTickets?: InputMaybe<Array<InputMaybe<FilterFindOneTaskEntityCachedDataOrganizationZendeskTicketsInput>>>;
};

export type FilterFindOneTaskEntityCachedDataOrganizationKybMoneyInOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyIn>;
  gte?: InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyIn>;
  in?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyIn>>>;
  lt?: InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyIn>;
  lte?: InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyIn>;
  ne?: InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyIn>;
  nin?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyIn>>>;
};

export type FilterFindOneTaskEntityCachedDataOrganizationKybMoneyInSubTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyInSubType>;
  gte?: InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyInSubType>;
  in?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyInSubType>>>;
  lt?: InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyInSubType>;
  lte?: InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyInSubType>;
  ne?: InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyInSubType>;
  nin?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataOrganizationKybMoneyInSubType>>>;
};

export type FilterFindOneTaskEntityCachedDataOrganizationKybStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneTaskEntityCachedDataOrganizationOperatorsInput = {
  companyName?: InputMaybe<FilterFindOneTaskEntityCachedDataOrganizationCompanyNameOperatorsInput>;
  decision?: InputMaybe<FilterFindOneTaskEntityCachedDataOrganizationDecisionOperatorsInput>;
  id?: InputMaybe<FilterFindOneTaskEntityCachedDataOrganizationIdOperatorsInput>;
  kybMoneyIn?: InputMaybe<FilterFindOneTaskEntityCachedDataOrganizationKybMoneyInOperatorsInput>;
  kybMoneyInSubType?: InputMaybe<FilterFindOneTaskEntityCachedDataOrganizationKybMoneyInSubTypeOperatorsInput>;
  kybStatus?: InputMaybe<FilterFindOneTaskEntityCachedDataOrganizationKybStatusOperatorsInput>;
  partner?: InputMaybe<FilterFindOneTaskEntityCachedDataOrganizationPartnerOperatorsInput>;
  taxIdType?: InputMaybe<FilterFindOneTaskEntityCachedDataOrganizationTaxIdTypeOperatorsInput>;
  zendeskTickets?: InputMaybe<FilterFindOneTaskEntityCachedDataOrganizationZendeskTicketsOperatorsInput>;
};

export type FilterFindOneTaskEntityCachedDataOrganizationPartnerInput = {
  companyName?: InputMaybe<Scalars['String']>;
  partnerName?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneTaskEntityCachedDataOrganizationPartnerOperatorsInput = {
  partnerName?: InputMaybe<FilterFindOneTaskEntityCachedDataOrganizationPartnerPartnerNameOperatorsInput>;
};

export type FilterFindOneTaskEntityCachedDataOrganizationPartnerPartnerNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneTaskEntityCachedDataOrganizationTaxIdTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTaskEntityCachedDataOrganizationTaxIdType>;
  gte?: InputMaybe<EnumTaskEntityCachedDataOrganizationTaxIdType>;
  in?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataOrganizationTaxIdType>>>;
  lt?: InputMaybe<EnumTaskEntityCachedDataOrganizationTaxIdType>;
  lte?: InputMaybe<EnumTaskEntityCachedDataOrganizationTaxIdType>;
  ne?: InputMaybe<EnumTaskEntityCachedDataOrganizationTaxIdType>;
  nin?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataOrganizationTaxIdType>>>;
};

export type FilterFindOneTaskEntityCachedDataOrganizationZendeskTicketsIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindOneTaskEntityCachedDataOrganizationZendeskTicketsInput = {
  id?: InputMaybe<Scalars['Float']>;
  latestComment?: InputMaybe<FilterFindOneTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentInput>;
};

export type FilterFindOneTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentCommenterInput = {
  isAnalyst?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentInput = {
  commenter?: InputMaybe<FilterFindOneTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentCommenterInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  priority?: InputMaybe<EnumTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentPriority>;
  status?: InputMaybe<EnumTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentStatus>;
};

export type FilterFindOneTaskEntityCachedDataOrganizationZendeskTicketsOperatorsInput = {
  id?: InputMaybe<FilterFindOneTaskEntityCachedDataOrganizationZendeskTicketsIdOperatorsInput>;
};

export type FilterFindOneTaskEntityCachedDataPaymentAmountOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindOneTaskEntityCachedDataPaymentApprovalActionInput = {
  reason?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneTaskEntityCachedDataPaymentCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindOneTaskEntityCachedDataPaymentCreatedByEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneTaskEntityCachedDataPaymentCreatedByPartnerCompanyNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneTaskEntityCachedDataPaymentCreatedByPartnerInput = {
  companyName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneTaskEntityCachedDataPaymentCreatedByPartnerOperatorsInput = {
  companyName?: InputMaybe<FilterFindOneTaskEntityCachedDataPaymentCreatedByPartnerCompanyNameOperatorsInput>;
};

export type FilterFindOneTaskEntityCachedDataPaymentDirectionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTaskEntityCachedDataPaymentDirection>;
  gte?: InputMaybe<EnumTaskEntityCachedDataPaymentDirection>;
  in?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataPaymentDirection>>>;
  lt?: InputMaybe<EnumTaskEntityCachedDataPaymentDirection>;
  lte?: InputMaybe<EnumTaskEntityCachedDataPaymentDirection>;
  ne?: InputMaybe<EnumTaskEntityCachedDataPaymentDirection>;
  nin?: InputMaybe<Array<InputMaybe<EnumTaskEntityCachedDataPaymentDirection>>>;
};

export type FilterFindOneTaskEntityCachedDataPaymentIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindOneTaskEntityCachedDataPaymentInput = {
  amount?: InputMaybe<Scalars['Float']>;
  createOrigin?: InputMaybe<EnumTaskEntityCachedDataPaymentCreateOrigin>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdByEmail?: InputMaybe<Scalars['String']>;
  createdByPartner?: InputMaybe<FilterFindOneTaskEntityCachedDataPaymentCreatedByPartnerInput>;
  currency?: InputMaybe<Scalars['String']>;
  deliveryPreference?: InputMaybe<EnumTaskEntityCachedDataPaymentDeliveryPreference>;
  direction?: InputMaybe<EnumTaskEntityCachedDataPaymentDirection>;
  foreignAmount?: InputMaybe<Scalars['Float']>;
  foreignCurrency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  isPartial?: InputMaybe<Scalars['Boolean']>;
  isSuspectedOfProhibitedIndustries?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  pendingReason?: InputMaybe<Scalars['String']>;
  productUseCase?: InputMaybe<Scalars['String']>;
  riskStatus?: InputMaybe<EnumTaskEntityCachedDataPaymentRiskStatus>;
  scheduledDate?: InputMaybe<Scalars['Date']>;
};

export type FilterFindOneTaskEntityCachedDataPaymentOperatorsInput = {
  amount?: InputMaybe<FilterFindOneTaskEntityCachedDataPaymentAmountOperatorsInput>;
  createdAt?: InputMaybe<FilterFindOneTaskEntityCachedDataPaymentCreatedAtOperatorsInput>;
  createdByEmail?: InputMaybe<FilterFindOneTaskEntityCachedDataPaymentCreatedByEmailOperatorsInput>;
  createdByPartner?: InputMaybe<FilterFindOneTaskEntityCachedDataPaymentCreatedByPartnerOperatorsInput>;
  direction?: InputMaybe<FilterFindOneTaskEntityCachedDataPaymentDirectionOperatorsInput>;
  id?: InputMaybe<FilterFindOneTaskEntityCachedDataPaymentIdOperatorsInput>;
  scheduledDate?: InputMaybe<FilterFindOneTaskEntityCachedDataPaymentScheduledDateOperatorsInput>;
};

export type FilterFindOneTaskEntityCachedDataPaymentScheduledDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindOneTaskEntityCachedDataRecurringBillInput = {
  id?: InputMaybe<Scalars['Float']>;
  occurrences?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneTaskEntityCachedDataRiskEngineDecisionInput = {
  features?: InputMaybe<Scalars['JSON']>;
  reason?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneTaskEntityCachedDataVendorCompanyNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneTaskEntityCachedDataVendorInput = {
  companyName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  isSuspectedOfProhibitedIndustries?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneTaskEntityCachedDataVendorOperatorsInput = {
  companyName?: InputMaybe<FilterFindOneTaskEntityCachedDataVendorCompanyNameOperatorsInput>;
};

export type FilterFindOneTaskEntityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneTaskInput = {
  AND?: InputMaybe<Array<FilterFindOneTaskInput>>;
  OR?: InputMaybe<Array<FilterFindOneTaskInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneTaskOperatorsInput>;
  assignedTo?: InputMaybe<Scalars['MongoID']>;
  concernAreas?: InputMaybe<Array<InputMaybe<FilterFindOneTaskConcernAreasInput>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  entityCachedData?: InputMaybe<FilterFindOneTaskEntityCachedDataInput>;
  entityId?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['MongoID']>;
  lastDecisionDetails?: InputMaybe<FilterFindOneTaskConcernAreasLastDecisionDetailsInput>;
  lastEscalatedDetails?: InputMaybe<FilterFindOneTaskLastEscalatedDetailsInput>;
  parentTaskId?: InputMaybe<Scalars['MongoID']>;
  partnerName?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['JSON']>;
  prioritization?: InputMaybe<Scalars['Float']>;
  recurringBillId?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<EnumTaskStatus>;
  taskVersion?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedInSherlock?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneTaskLabelOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneTaskLastDecisionDetailsLastDecisionDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindOneTaskLastDecisionDetailsLastDecisionMakerIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneTaskLastDecisionDetailsOperatorsInput = {
  lastDecisionDate?: InputMaybe<FilterFindOneTaskLastDecisionDetailsLastDecisionDateOperatorsInput>;
  lastDecisionMakerId?: InputMaybe<FilterFindOneTaskLastDecisionDetailsLastDecisionMakerIdOperatorsInput>;
};

export type FilterFindOneTaskLastEscalatedDetailsInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  teamIntegrationId?: InputMaybe<Scalars['MongoID']>;
  userId?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindOneTaskLastEscalatedDetailsOperatorsInput = {
  teamIntegrationId?: InputMaybe<FilterFindOneTaskLastEscalatedDetailsTeamIntegrationIdOperatorsInput>;
};

export type FilterFindOneTaskLastEscalatedDetailsTeamIntegrationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneTaskOperatorsInput = {
  _id?: InputMaybe<FilterFindOneTask_IdOperatorsInput>;
  concernAreas?: InputMaybe<FilterFindOneTaskConcernAreasOperatorsInput>;
  deletedAt?: InputMaybe<FilterFindOneTaskDeletedAtOperatorsInput>;
  entityCachedData?: InputMaybe<FilterFindOneTaskEntityCachedDataOperatorsInput>;
  entityId?: InputMaybe<FilterFindOneTaskEntityIdOperatorsInput>;
  label?: InputMaybe<FilterFindOneTaskLabelOperatorsInput>;
  lastDecisionDetails?: InputMaybe<FilterFindOneTaskLastDecisionDetailsOperatorsInput>;
  lastEscalatedDetails?: InputMaybe<FilterFindOneTaskLastEscalatedDetailsOperatorsInput>;
  prioritization?: InputMaybe<FilterFindOneTaskPrioritizationOperatorsInput>;
  recurringBillId?: InputMaybe<FilterFindOneTaskRecurringBillIdOperatorsInput>;
  status?: InputMaybe<FilterFindOneTaskStatusOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindOneTaskUpdatedAtOperatorsInput>;
};

export type FilterFindOneTaskPrioritizationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindOneTaskRecurringBillIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindOneTaskStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTaskStatus>;
  gte?: InputMaybe<EnumTaskStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumTaskStatus>>>;
  lt?: InputMaybe<EnumTaskStatus>;
  lte?: InputMaybe<EnumTaskStatus>;
  ne?: InputMaybe<EnumTaskStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumTaskStatus>>>;
};

export type FilterFindOneTaskUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindOneTask_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneTeamInput = {
  AND?: InputMaybe<Array<FilterFindOneTeamInput>>;
  OR?: InputMaybe<Array<FilterFindOneTeamInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneTeamOperatorsInput>;
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindOneTeamIntegrationInput = {
  AND?: InputMaybe<Array<FilterFindOneTeamIntegrationInput>>;
  OR?: InputMaybe<Array<FilterFindOneTeamIntegrationInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneTeamIntegrationOperatorsInput>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  entityType?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  settings?: InputMaybe<FilterFindOneTeamIntegrationSettingsInput>;
  type?: InputMaybe<EnumTeamIntegrationType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneTeamIntegrationOperatorsInput = {
  _id?: InputMaybe<FilterFindOneTeamIntegration_IdOperatorsInput>;
  reason?: InputMaybe<FilterFindOneTeamIntegrationReasonOperatorsInput>;
  roleIds?: InputMaybe<FilterFindOneTeamIntegrationRoleIdsOperatorsInput>;
};

export type FilterFindOneTeamIntegrationReasonOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneTeamIntegrationRoleIdsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneTeamIntegrationSettingsInput = {
  showAmount?: InputMaybe<Scalars['Boolean']>;
  slackChannelId?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneTeamIntegration_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneTeamOperatorsInput = {
  _id?: InputMaybe<FilterFindOneTeam_IdOperatorsInput>;
};

export type FilterFindOneTeam_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneUiFlowBlocksDynamicVariablesInput = {
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneUiFlowBlocksInput = {
  actionId?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  dynamicVariables?: InputMaybe<Array<InputMaybe<FilterFindOneUiFlowBlocksDynamicVariablesInput>>>;
  extras?: InputMaybe<Scalars['JSON']>;
  flowId?: InputMaybe<Scalars['MongoID']>;
  flowResult?: InputMaybe<Scalars['String']>;
  flowStatus?: InputMaybe<EnumUiFlowBlocksFlowStatus>;
  id?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  parameters?: InputMaybe<Array<InputMaybe<FilterFindOneUiFlowBlocksParametersInput>>>;
  ports?: InputMaybe<Array<InputMaybe<FilterFindOneUiFlowBlocksPortsInput>>>;
  readOnly?: InputMaybe<Scalars['Boolean']>;
  selected?: InputMaybe<Scalars['Boolean']>;
  strategyId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<EnumUiFlowBlocksType>;
  wait?: InputMaybe<FilterFindOneUiFlowBlocksWaitInput>;
  x?: InputMaybe<Scalars['Float']>;
  y?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneUiFlowBlocksParametersInput = {
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterFindOneUiFlowBlocksPortsInput = {
  alignment?: InputMaybe<EnumUiFlowBlocksPortsAlignment>;
  extras?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<FilterFindOneUiFlowBlocksPortsLinkInput>;
  links?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  locked?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentNode?: InputMaybe<Scalars['String']>;
  selected?: InputMaybe<Scalars['Boolean']>;
  target?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  x?: InputMaybe<Scalars['Float']>;
  y?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneUiFlowBlocksPortsLinkInput = {
  color?: InputMaybe<Scalars['String']>;
  curvyness?: InputMaybe<Scalars['Float']>;
  extras?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Array<InputMaybe<FilterFindOneUiFlowBlocksPortsLinkLabelsInput>>>;
  locked?: InputMaybe<Scalars['Boolean']>;
  points?: InputMaybe<Array<InputMaybe<FilterFindOneUiFlowBlocksPortsLinkPointsInput>>>;
  selected?: InputMaybe<Scalars['Boolean']>;
  selectedColor?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  sourcePort?: InputMaybe<Scalars['String']>;
  target?: InputMaybe<Scalars['String']>;
  targetPort?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneUiFlowBlocksPortsLinkLabelsInput = {
  extras?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  offsetX?: InputMaybe<Scalars['Float']>;
  offsetY?: InputMaybe<Scalars['Float']>;
  selected?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneUiFlowBlocksPortsLinkPointsInput = {
  extras?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  selected?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  x?: InputMaybe<Scalars['Float']>;
  y?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneUiFlowBlocksWaitInput = {
  amount?: InputMaybe<Scalars['Float']>;
  interval?: InputMaybe<EnumUiFlowBlocksWaitInterval>;
  startFrom?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneUiFlowInput = {
  AND?: InputMaybe<Array<FilterFindOneUiFlowInput>>;
  OR?: InputMaybe<Array<FilterFindOneUiFlowInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneUiFlowOperatorsInput>;
  blocks?: InputMaybe<Array<InputMaybe<FilterFindOneUiFlowBlocksInput>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  disabledMessage?: InputMaybe<Scalars['String']>;
  lastUpdatedBy?: InputMaybe<Scalars['String']>;
  readingDeletedEntities?: InputMaybe<FilterFindOneUiFlowReadingDeletedEntitiesInput>;
  rejectHandler?: InputMaybe<FilterFindOneUiFlowRejectHandlerInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  triggers?: InputMaybe<FilterFindOneUiFlowTriggersInput>;
  type?: InputMaybe<Scalars['String']>;
  updateComment?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  version?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneUiFlowOperatorsInput = {
  _id?: InputMaybe<FilterFindOneUiFlow_IdOperatorsInput>;
  type?: InputMaybe<FilterFindOneUiFlowTypeOperatorsInput>;
};

export type FilterFindOneUiFlowReadingDeletedEntitiesInput = {
  defaultPolicy?: InputMaybe<Scalars['Boolean']>;
  deliveryMethod?: InputMaybe<Scalars['Boolean']>;
  fundingSource?: InputMaybe<Scalars['Boolean']>;
  payment?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneUiFlowRejectHandlerInput = {
  actionId?: InputMaybe<Scalars['String']>;
  parameters?: InputMaybe<Array<InputMaybe<FilterFindOneUiFlowRejectHandlerParametersInput>>>;
};

export type FilterFindOneUiFlowRejectHandlerParametersInput = {
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterFindOneUiFlowTriggersInput = {
  events?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterFindOneUiFlowTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneUiFlow_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneWatsonViewEntityOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneWatsonViewFieldsInput = {
  displayName?: InputMaybe<Scalars['String']>;
  displayText?: InputMaybe<Scalars['String']>;
  displayType?: InputMaybe<EnumWatsonViewFieldsDisplayType>;
  key?: InputMaybe<Scalars['String']>;
  linkFormat?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneWatsonViewInput = {
  AND?: InputMaybe<Array<FilterFindOneWatsonViewInput>>;
  OR?: InputMaybe<Array<FilterFindOneWatsonViewInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneWatsonViewOperatorsInput>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  entity?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<Array<InputMaybe<FilterFindOneWatsonViewFieldsInput>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneWatsonViewOperatorsInput = {
  _id?: InputMaybe<FilterFindOneWatsonView_IdOperatorsInput>;
  entity?: InputMaybe<FilterFindOneWatsonViewEntityOperatorsInput>;
};

export type FilterFindOneWatsonView_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOnesherlockUserEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnesherlockUserInput = {
  AND?: InputMaybe<Array<FilterFindOnesherlockUserInput>>;
  OR?: InputMaybe<Array<FilterFindOnesherlockUserInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnesherlockUserOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  favoriteModules?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lastLoginAt?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  picture?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  squads?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  status?: InputMaybe<EnumsherlockUserStatus>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  xeroEmail?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnesherlockUserOperatorsInput = {
  _id?: InputMaybe<FilterFindOnesherlockUser_IdOperatorsInput>;
  email?: InputMaybe<FilterFindOnesherlockUserEmailOperatorsInput>;
  xeroEmail?: InputMaybe<FilterFindOnesherlockUserXeroEmailOperatorsInput>;
};

export type FilterFindOnesherlockUserXeroEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnesherlockUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterListValue = {
  __typename?: 'FilterListValue';
  title?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type FilterQueryField = {
  __typename?: 'FilterQueryField';
  fieldSettings?: Maybe<FieldSettings>;
  initialEmptyWhere?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
  subfields?: Maybe<Scalars['SequelizeJSON']>;
  type?: Maybe<Scalars['String']>;
  valueSources?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type FilterUpdateManyGayaThemeInput = {
  AND?: InputMaybe<Array<FilterUpdateManyGayaThemeInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyGayaThemeInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyGayaThemeOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  theme?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterUpdateManyGayaThemeNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyGayaThemeOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyGayaTheme_IdOperatorsInput>;
  name?: InputMaybe<FilterUpdateManyGayaThemeNameOperatorsInput>;
};

export type FilterUpdateManyGayaTheme_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterUpdateOneGayaFormInput = {
  AND?: InputMaybe<Array<FilterUpdateOneGayaFormInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneGayaFormInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneGayaFormOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  formType?: InputMaybe<EnumGayaFormFormType>;
  name?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  schema?: InputMaybe<Scalars['JSON']>;
  theme?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
  version?: InputMaybe<Scalars['Float']>;
};

export type FilterUpdateOneGayaFormNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneGayaFormOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneGayaForm_IdOperatorsInput>;
  name?: InputMaybe<FilterUpdateOneGayaFormNameOperatorsInput>;
};

export type FilterUpdateOneGayaForm_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterUpdateOneGayaThemeInput = {
  AND?: InputMaybe<Array<FilterUpdateOneGayaThemeInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneGayaThemeInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneGayaThemeOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  theme?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type FilterUpdateOneGayaThemeNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneGayaThemeOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneGayaTheme_IdOperatorsInput>;
  name?: InputMaybe<FilterUpdateOneGayaThemeNameOperatorsInput>;
};

export type FilterUpdateOneGayaTheme_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterUpdateOneUiFlowBlocksDynamicVariablesInput = {
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterUpdateOneUiFlowBlocksInput = {
  actionId?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  dynamicVariables?: InputMaybe<Array<InputMaybe<FilterUpdateOneUiFlowBlocksDynamicVariablesInput>>>;
  extras?: InputMaybe<Scalars['JSON']>;
  flowId?: InputMaybe<Scalars['MongoID']>;
  flowResult?: InputMaybe<Scalars['String']>;
  flowStatus?: InputMaybe<EnumUiFlowBlocksFlowStatus>;
  id?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  parameters?: InputMaybe<Array<InputMaybe<FilterUpdateOneUiFlowBlocksParametersInput>>>;
  ports?: InputMaybe<Array<InputMaybe<FilterUpdateOneUiFlowBlocksPortsInput>>>;
  readOnly?: InputMaybe<Scalars['Boolean']>;
  selected?: InputMaybe<Scalars['Boolean']>;
  strategyId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<EnumUiFlowBlocksType>;
  wait?: InputMaybe<FilterUpdateOneUiFlowBlocksWaitInput>;
  x?: InputMaybe<Scalars['Float']>;
  y?: InputMaybe<Scalars['Float']>;
};

export type FilterUpdateOneUiFlowBlocksParametersInput = {
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterUpdateOneUiFlowBlocksPortsInput = {
  alignment?: InputMaybe<EnumUiFlowBlocksPortsAlignment>;
  extras?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<FilterUpdateOneUiFlowBlocksPortsLinkInput>;
  links?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  locked?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentNode?: InputMaybe<Scalars['String']>;
  selected?: InputMaybe<Scalars['Boolean']>;
  target?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  x?: InputMaybe<Scalars['Float']>;
  y?: InputMaybe<Scalars['Float']>;
};

export type FilterUpdateOneUiFlowBlocksPortsLinkInput = {
  color?: InputMaybe<Scalars['String']>;
  curvyness?: InputMaybe<Scalars['Float']>;
  extras?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Array<InputMaybe<FilterUpdateOneUiFlowBlocksPortsLinkLabelsInput>>>;
  locked?: InputMaybe<Scalars['Boolean']>;
  points?: InputMaybe<Array<InputMaybe<FilterUpdateOneUiFlowBlocksPortsLinkPointsInput>>>;
  selected?: InputMaybe<Scalars['Boolean']>;
  selectedColor?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  sourcePort?: InputMaybe<Scalars['String']>;
  target?: InputMaybe<Scalars['String']>;
  targetPort?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type FilterUpdateOneUiFlowBlocksPortsLinkLabelsInput = {
  extras?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  offsetX?: InputMaybe<Scalars['Float']>;
  offsetY?: InputMaybe<Scalars['Float']>;
  selected?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
};

export type FilterUpdateOneUiFlowBlocksPortsLinkPointsInput = {
  extras?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  selected?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  x?: InputMaybe<Scalars['Float']>;
  y?: InputMaybe<Scalars['Float']>;
};

export type FilterUpdateOneUiFlowBlocksWaitInput = {
  amount?: InputMaybe<Scalars['Float']>;
  interval?: InputMaybe<EnumUiFlowBlocksWaitInterval>;
  startFrom?: InputMaybe<Scalars['String']>;
};

export type FilterUpdateOneUiFlowInput = {
  AND?: InputMaybe<Array<FilterUpdateOneUiFlowInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneUiFlowInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneUiFlowOperatorsInput>;
  blocks?: InputMaybe<Array<InputMaybe<FilterUpdateOneUiFlowBlocksInput>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  disabledMessage?: InputMaybe<Scalars['String']>;
  lastUpdatedBy?: InputMaybe<Scalars['String']>;
  readingDeletedEntities?: InputMaybe<FilterUpdateOneUiFlowReadingDeletedEntitiesInput>;
  rejectHandler?: InputMaybe<FilterUpdateOneUiFlowRejectHandlerInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  triggers?: InputMaybe<FilterUpdateOneUiFlowTriggersInput>;
  type?: InputMaybe<Scalars['String']>;
  updateComment?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  version?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneUiFlowOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneUiFlow_IdOperatorsInput>;
  type?: InputMaybe<FilterUpdateOneUiFlowTypeOperatorsInput>;
};

export type FilterUpdateOneUiFlowReadingDeletedEntitiesInput = {
  defaultPolicy?: InputMaybe<Scalars['Boolean']>;
  deliveryMethod?: InputMaybe<Scalars['Boolean']>;
  fundingSource?: InputMaybe<Scalars['Boolean']>;
  payment?: InputMaybe<Scalars['Boolean']>;
};

export type FilterUpdateOneUiFlowRejectHandlerInput = {
  actionId?: InputMaybe<Scalars['String']>;
  parameters?: InputMaybe<Array<InputMaybe<FilterUpdateOneUiFlowRejectHandlerParametersInput>>>;
};

export type FilterUpdateOneUiFlowRejectHandlerParametersInput = {
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterUpdateOneUiFlowTriggersInput = {
  events?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FilterUpdateOneUiFlowTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterUpdateOneUiFlow_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FinancialInstitutionSummaryGraphQlType = {
  __typename?: 'FinancialInstitutionSummaryGraphQlType';
  breakdown?: Maybe<FinancialInstitution>;
  credit?: Maybe<DirectionSummaryGraphQlType>;
  debit?: Maybe<DirectionSummaryGraphQlType>;
  totalReconciledRecords?: Maybe<Scalars['Float']>;
  totalReconciledSumOfMoney?: Maybe<Scalars['Float']>;
  totalRecords?: Maybe<Scalars['Float']>;
  totalSumOfMoney?: Maybe<Scalars['Float']>;
  totalUnreconciledRecords?: Maybe<Scalars['Float']>;
  totalUnreconciledSumOfMoney?: Maybe<Scalars['Float']>;
};

export type FinancingPaymentData = {
  __typename?: 'FinancingPaymentData';
  numberOfAllTransfers?: Maybe<Scalars['Int']>;
  numberOfSuccessfulTransfers?: Maybe<Scalars['Int']>;
  totalAmount?: Maybe<Scalars['Float']>;
};

export type FinancingPaymentDataResponse = {
  __typename?: 'FinancingPaymentDataResponse';
  data?: Maybe<FinancingPaymentData>;
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type FlowExecution = {
  __typename?: 'FlowExecution';
  _id: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  currentStep?: Maybe<FlowExecutionCurrentStep>;
  deletedAt?: Maybe<Scalars['Date']>;
  dynamicVariables?: Maybe<FlowExecutionDynamicVariables>;
  flow?: Maybe<UiFlow>;
  flowVersion?: Maybe<UiFlow>;
  input?: Maybe<Scalars['JSON']>;
  isPopsDecisionSame?: Maybe<Scalars['Boolean']>;
  mode: EnumFlowExecutionMode;
  output?: Maybe<Scalars['String']>;
  parentExecution?: Maybe<Scalars['MongoID']>;
  parentExecutionDetails?: Maybe<FlowExecution>;
  partnerName?: Maybe<Scalars['String']>;
  passedSteps?: Maybe<Array<Maybe<FlowExecutionPassedSteps>>>;
  paymentLog?: Maybe<Scalars['JSON']>;
  result?: Maybe<Scalars['JSON']>;
  startedAt?: Maybe<Scalars['Date']>;
  state: EnumFlowExecutionState;
  status?: Maybe<EnumFlowExecutionStatus>;
  strategyDecisionReport?: Maybe<DecisionReport>;
  uiFlow?: Maybe<Scalars['MongoID']>;
  uiFlowVersion: Scalars['Float'];
  updatedAt?: Maybe<Scalars['Date']>;
};

export type FlowExecutionCurrentStep = {
  __typename?: 'FlowExecutionCurrentStep';
  createdAt?: Maybe<Scalars['Date']>;
  expiresAt?: Maybe<Scalars['Date']>;
  flowExecutionDetails?: Maybe<FlowExecution>;
  flowExecutionId?: Maybe<Scalars['MongoID']>;
  flowResult?: Maybe<Scalars['JSON']>;
  index: Scalars['String'];
  output?: Maybe<FlowExecutionCurrentStepOutput>;
  status?: Maybe<EnumFlowExecutionCurrentStepStatus>;
  strategyDecisionReport?: Maybe<Scalars['MongoID']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type FlowExecutionCurrentStepOutput = {
  __typename?: 'FlowExecutionCurrentStepOutput';
  error?: Maybe<Scalars['String']>;
  feeIds?: Maybe<Array<Maybe<Scalars['Float']>>>;
  fundingSourceId?: Maybe<Scalars['Float']>;
  isEligible?: Maybe<Scalars['Boolean']>;
  setNumber?: Maybe<Scalars['Float']>;
  setString?: Maybe<Scalars['String']>;
  zendeskTicketId?: Maybe<Scalars['Float']>;
};

export type FlowExecutionDynamicVariables = {
  __typename?: 'FlowExecutionDynamicVariables';
  feeIds?: Maybe<Array<Maybe<Scalars['Float']>>>;
  fundingSourceId?: Maybe<Scalars['Float']>;
  isEligible?: Maybe<Scalars['Boolean']>;
  setNumber?: Maybe<Scalars['Float']>;
  setString?: Maybe<Scalars['String']>;
  zendeskTicketId?: Maybe<Scalars['Float']>;
};

/** List of items with pagination. */
export type FlowExecutionPagination = {
  __typename?: 'FlowExecutionPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<FlowExecution>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type FlowExecutionPassedSteps = {
  __typename?: 'FlowExecutionPassedSteps';
  createdAt?: Maybe<Scalars['Date']>;
  expiresAt?: Maybe<Scalars['Date']>;
  flowExecutionDetails?: Maybe<FlowExecution>;
  flowExecutionId?: Maybe<Scalars['MongoID']>;
  flowResult?: Maybe<Scalars['JSON']>;
  index: Scalars['String'];
  output?: Maybe<FlowExecutionPassedStepsOutput>;
  status?: Maybe<EnumFlowExecutionPassedStepsStatus>;
  strategyDecisionReport?: Maybe<Scalars['MongoID']>;
  strategyDecisionReportDetails?: Maybe<DecisionReport>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type FlowExecutionPassedStepsOutput = {
  __typename?: 'FlowExecutionPassedStepsOutput';
  error?: Maybe<Scalars['String']>;
  feeIds?: Maybe<Array<Maybe<Scalars['Float']>>>;
  fundingSourceId?: Maybe<Scalars['Float']>;
  isEligible?: Maybe<Scalars['Boolean']>;
  setNumber?: Maybe<Scalars['Float']>;
  setString?: Maybe<Scalars['String']>;
  zendeskTicketId?: Maybe<Scalars['Float']>;
};

export type FlowPermission = {
  __typename?: 'FlowPermission';
  _id: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  flow?: Maybe<UiFlow>;
  uiFlowId: Scalars['MongoID'];
  updatedAt?: Maybe<Scalars['Date']>;
  viewRoleIds?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
};

export type FraudReferralCase = {
  __typename?: 'FraudReferralCase';
  closedDate?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  detectionDate: Scalars['String'];
  driveLink?: Maybe<Scalars['String']>;
  evaluationId: Scalars['String'];
  id: Scalars['String'];
  mergedCases: Array<MergedCaseRef>;
  orgTaskId: Scalars['String'];
  organizationId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  payments: Array<FraudReferralPayment>;
  previouslyDetectedPayments: Array<PreviouslyDetectedPayment>;
  resolvedByUserName?: Maybe<Scalars['String']>;
  status: FraudReferralCaseStatus;
  updatedAt?: Maybe<Scalars['String']>;
};

export enum FraudReferralCaseStatus {
  completed = 'completed',
  failed = 'failed',
  underReview = 'underReview'
}

export enum FraudReferralDecision {
  noReferralRequired = 'noReferralRequired',
  referralRequired = 'referralRequired'
}

export enum FraudReferralFraudType {
  ato = 'ato',
  invoiceCompromised = 'invoiceCompromised',
  invoiceFraud = 'invoiceFraud',
  stolenData = 'stolenData'
}

export type FraudReferralPayment = {
  __typename?: 'FraudReferralPayment';
  amount: Scalars['Float'];
  currency: Scalars['String'];
  decisionDetails?: Maybe<FraudReferralPaymentDecision>;
  id: Scalars['Int'];
  moneyFlow: MoneyFlow;
  status: FraudReferralPaymentStatus;
  tags: Array<Scalars['String']>;
};

export type FraudReferralPaymentDecision = {
  __typename?: 'FraudReferralPaymentDecision';
  alertDate?: Maybe<Scalars['String']>;
  alertType?: Maybe<Scalars['String']>;
  decision: FraudReferralDecision;
  fraudType?: Maybe<FraudReferralFraudType>;
  otherReason?: Maybe<Scalars['String']>;
  reason?: Maybe<NoReferralSubReason>;
  resolvedAt?: Maybe<Scalars['String']>;
  resolvedByUserName?: Maybe<Scalars['String']>;
};

export enum FraudReferralPaymentStatus {
  completed = 'completed',
  underReview = 'underReview'
}

export type FreeAchUsage = {
  __typename?: 'FreeAchUsage';
  available?: Maybe<Scalars['Int']>;
  resetDate?: Maybe<Scalars['String']>;
};

export type FundingSourceDetail = {
  __typename?: 'FundingSourceDetail';
  formattedSource?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isCollectStatusFailed?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
};

export type FundingSourcesResponse = {
  __typename?: 'FundingSourcesResponse';
  data?: Maybe<Array<Maybe<FundingSource>>>;
  error?: Maybe<Scalars['String']>;
  fundingSourceDetails?: Maybe<Array<Maybe<FundingSourceDetail>>>;
  success: Scalars['Boolean'];
};

export enum FundingTypeEnum {
  Ach = 'Ach',
  Card = 'Card',
  Flex = 'Flex',
  PaypalBalance = 'PaypalBalance'
}

export type GayaForm = {
  __typename?: 'GayaForm';
  _id: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<SherlockUser>;
  deletedAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  formType?: Maybe<EnumGayaFormFormType>;
  name: Scalars['String'];
  published?: Maybe<Scalars['Boolean']>;
  schema: Scalars['JSON'];
  theme?: Maybe<GayaTheme>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<SherlockUser>;
  version?: Maybe<Scalars['Float']>;
};

export type GayaFormResponse = {
  __typename?: 'GayaFormResponse';
  _id: Scalars['MongoID'];
  content: Scalars['JSON'];
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  createdByDetails?: Maybe<SherlockUser>;
  deletedAt?: Maybe<Scalars['Date']>;
  formId: Scalars['MongoID'];
  formInfo?: Maybe<GayaForm>;
  formType?: Maybe<EnumGayaFormResponseFormType>;
  formVersion?: Maybe<Scalars['Float']>;
  partnerName?: Maybe<Scalars['String']>;
  userEmail?: Maybe<Scalars['String']>;
  zendeskTicketId?: Maybe<Scalars['Float']>;
  zendeskTicketUrl?: Maybe<Scalars['String']>;
};

/** List of items with pagination. */
export type GayaFormResponsePagination = {
  __typename?: 'GayaFormResponsePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<GayaFormResponse>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type GayaTheme = {
  __typename?: 'GayaTheme';
  _id: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  name: Scalars['String'];
  published?: Maybe<Scalars['Boolean']>;
  theme: Scalars['JSON'];
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['MongoID']>;
};

export type GenericTask = {
  __typename?: 'GenericTask';
  _id: Scalars['MongoID'];
  assignedTo?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  entityCachedData?: Maybe<EntityCachedData>;
  entityId?: Maybe<Scalars['String']>;
  labelDetails?: Maybe<Label>;
  labelIds?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  parentTaskId?: Maybe<Scalars['MongoID']>;
  partnerName?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['MongoID']>;
  status: EnumGenericTaskStatus;
  type?: Maybe<EnumGenericTaskType>;
  updatedAt?: Maybe<Scalars['Date']>;
  userDetails?: Maybe<SherlockUser>;
};

/** List of items with pagination. */
export type GenericTaskPagination = {
  __typename?: 'GenericTaskPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<GenericTask>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export enum GenericTaskStatusEnum {
  approved = 'approved',
  canceled = 'canceled',
  completed = 'completed',
  escalated = 'escalated',
  inProgress = 'inProgress',
  isNotLive = 'isNotLive',
  open = 'open',
  pending = 'pending',
  read = 'read',
  rejected = 'rejected',
  unread = 'unread'
}

export type Graph = {
  __typename?: 'Graph';
  edges?: Maybe<Array<Maybe<Edge>>>;
  metadata?: Maybe<Metadata>;
  nodes?: Maybe<Array<Maybe<Node>>>;
};

export type GroupEntity = {
  __typename?: 'GroupEntity';
  _id: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  entity: Scalars['String'];
  field?: Maybe<EnumGroupEntityField>;
  name: Scalars['String'];
  type: EnumGroupEntityType;
  updatedAt?: Maybe<Scalars['Date']>;
};

export enum GroupNamesEnum {
  compliance = 'compliance',
  risk = 'risk'
}

export type GuardrailConfiguration = {
  __typename?: 'GuardrailConfiguration';
  guardrailIdentifier?: Maybe<Scalars['String']>;
  guardrailVersion?: Maybe<Scalars['String']>;
};

export enum HighLevelClaim {
  Fraud = 'Fraud',
  Processing = 'Processing',
  Service = 'Service'
}

export type HintsQuery = {
  __typename?: 'HintsQuery';
  deliveryMethodCount?: Maybe<Scalars['Int']>;
  escalationCount?: Maybe<Scalars['Int']>;
  fundingSourceCount?: Maybe<Scalars['Int']>;
  paymentCount?: Maybe<Scalars['Int']>;
  paymentIps?: Maybe<Array<Maybe<Scalars['String']>>>;
  userCount?: Maybe<Scalars['Int']>;
};

export type Ip = {
  __typename?: 'IP';
  features?: Maybe<IpFeatures>;
  ip: Scalars['String'];
  lastUsedAt: Scalars['DateTime'];
  paymentId: Scalars['Int'];
  syncActivityMigrationStatus?: Maybe<RailsDateTypeEnum>;
  tags?: Maybe<Array<Maybe<EntityTag>>>;
  usersIpAge?: Maybe<Array<Maybe<UserIpAge>>>;
};


export type IpFeaturesArgs = {
  paymentId?: InputMaybe<Scalars['Int']>;
};


export type IpUsersIpAgeArgs = {
  organizationId?: InputMaybe<Scalars['Int']>;
};

export enum IdentityDocumentTypeEnum {
  Driver_s_License = 'Driver_s_License',
  ITIN = 'ITIN',
  National_ID = 'National_ID',
  Passport = 'Passport',
  SSN_Card = 'SSN_Card'
}

export type IdmData = {
  __typename?: 'IdmData';
  applicationID?: Maybe<Scalars['String']>;
  recordID?: Maybe<Scalars['String']>;
  requestID?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  transactionID?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedByUser?: Maybe<UpdatedByUser>;
};

export type Incident = {
  __typename?: 'Incident';
  _id: Scalars['MongoID'];
  allCalculatedEntitiesAmount?: Maybe<Scalars['Int']>;
  batchIds?: Maybe<Array<Maybe<IncidentBatchIds>>>;
  calculatedAt?: Maybe<Scalars['Date']>;
  calculationSize?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<SherlockUser>;
  deletedAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  entity?: Maybe<EnumIncidentEntity>;
  entityIds?: Maybe<Array<Maybe<Scalars['Float']>>>;
  fireHydrantUrl?: Maybe<Scalars['String']>;
  incidentGroups: Array<IncidentGroup>;
  isCalculating?: Maybe<Scalars['Boolean']>;
  isCalculationFailed?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  status?: Maybe<EnumIncidentStatus>;
  updatedAt?: Maybe<Scalars['Date']>;
};


export type IncidentIncidentGroupsArgs = {
  filter?: InputMaybe<FilterFindManyIncidentGroupInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyIncidentGroupInput>;
};

export type IncidentBatchIds = {
  __typename?: 'IncidentBatchIds';
  _id?: Maybe<Scalars['MongoID']>;
  batchId: Scalars['MongoID'];
  executedBy?: Maybe<Scalars['MongoID']>;
  failedEntities?: Maybe<Array<Maybe<Scalars['Float']>>>;
  groupsIds?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  isRunning?: Maybe<Scalars['Boolean']>;
  mode?: Maybe<EnumIncidentBatchIdsMode>;
  runAt?: Maybe<Scalars['Date']>;
};

export type IncidentBatchIdsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  batchId: Scalars['MongoID'];
  executedBy?: InputMaybe<Scalars['MongoID']>;
  failedEntities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  groupsIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  isRunning?: InputMaybe<Scalars['Boolean']>;
  mode?: InputMaybe<EnumIncidentBatchIdsMode>;
  runAt?: InputMaybe<Scalars['Date']>;
};

export type IncidentExecutionLog = {
  __typename?: 'IncidentExecutionLog';
  _id: Scalars['MongoID'];
  batchId?: Maybe<Scalars['MongoID']>;
  createdAt?: Maybe<Scalars['Date']>;
  entity?: Maybe<EnumIncidentExecutionLogEntity>;
  entityId: Scalars['Float'];
  flowExecution?: Maybe<FlowExecution>;
  flowExecutionId: Scalars['MongoID'];
  incident: Scalars['MongoID'];
  incidentGroup: Scalars['MongoID'];
  updatedAt?: Maybe<Scalars['Date']>;
};

export type IncidentGroup = {
  __typename?: 'IncidentGroup';
  _id: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  flowId?: Maybe<Scalars['MongoID']>;
  flowUI?: Maybe<UiFlow>;
  incidentId?: Maybe<Scalars['MongoID']>;
  isTemplate?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<IncidentGroupMetadata>;
  name: Scalars['String'];
  order: Scalars['Float'];
  rules?: Maybe<Scalars['JSON']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type IncidentGroupMetadata = {
  __typename?: 'IncidentGroupMetadata';
  _id?: Maybe<Scalars['MongoID']>;
  calculatedAt?: Maybe<Scalars['Date']>;
  entityIds?: Maybe<Array<Maybe<Scalars['Float']>>>;
  totalEntities?: Maybe<Scalars['Float']>;
  totalEntitiesPercentage?: Maybe<Scalars['Float']>;
  totalTPV?: Maybe<Scalars['Float']>;
};

export type IncidentGroupMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  calculatedAt?: InputMaybe<Scalars['Date']>;
  entityIds?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  totalEntities?: InputMaybe<Scalars['Float']>;
  totalEntitiesPercentage?: InputMaybe<Scalars['Float']>;
  totalTPV?: InputMaybe<Scalars['Float']>;
};

export enum InterventionStatus {
  LossRecoveryInitiated = 'LossRecoveryInitiated',
  Refund = 'Refund',
  Retry = 'Retry'
}

export type InterventionTimeline = {
  __typename?: 'InterventionTimeline';
  agentEmail?: Maybe<Scalars['String']>;
  interventionStatus?: Maybe<InterventionStatus>;
  source?: Maybe<SourceOfIntervention>;
};

export type Label = {
  __typename?: 'Label';
  _id: Scalars['MongoID'];
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy: Scalars['MongoID'];
  deletedAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  priority: Scalars['Float'];
  rules?: Maybe<Array<Maybe<LabelRules>>>;
  type?: Maybe<EnumLabelType>;
  updatedAt?: Maybe<Scalars['Date']>;
  userDetails?: Maybe<SherlockUser>;
};

/** A connection to a list of items. */
export type LabelConnection = {
  __typename?: 'LabelConnection';
  /** Total object count. */
  count: Scalars['Int'];
  /** Information to aid in pagination. */
  edges: Array<LabelEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type LabelEdge = {
  __typename?: 'LabelEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Label;
};

/** List of items with pagination. */
export type LabelPagination = {
  __typename?: 'LabelPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Label>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type LabelRules = {
  __typename?: 'LabelRules';
  _id?: Maybe<Scalars['MongoID']>;
  logic?: Maybe<Scalars['String']>;
  tree?: Maybe<Scalars['String']>;
};

export type LastDecisionDetails = {
  __typename?: 'LastDecisionDetails';
  lastDecisionDate: Scalars['Date'];
  lastDecisionMakerId?: Maybe<Scalars['ID']>;
  reason?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type LastEscalatedUser = {
  __typename?: 'LastEscalatedUser';
  sherlockUser?: Maybe<SherlockUser>;
};

export type LegalInfoBasicData = {
  __typename?: 'LegalInfoBasicData';
  extraData?: Maybe<Array<LegalInfoBasicData>>;
  initialInput?: Maybe<Scalars['String']>;
  reference?: Maybe<ReferenceType>;
  spiiData?: Maybe<SpiiData>;
  type: LegalInfoTypeEnum;
};

export type LegalInfoData = {
  __typename?: 'LegalInfoData';
  data: Array<LegalInfoBasicData>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedById?: Maybe<Scalars['String']>;
};

export enum LegalInfoTypeEnum {
  DBA = 'DBA',
  DOB = 'DOB',
  businessAddress = 'businessAddress',
  businessAddress2 = 'businessAddress2',
  businessCity = 'businessCity',
  businessCountry = 'businessCountry',
  businessFullAddress = 'businessFullAddress',
  businessState = 'businessState',
  businessType = 'businessType',
  businessZipCode = 'businessZipCode',
  companyDescription = 'companyDescription',
  companyWebsite = 'companyWebsite',
  legalAddress = 'legalAddress',
  legalCity = 'legalCity',
  legalCountry = 'legalCountry',
  legalFullAddress = 'legalFullAddress',
  legalName = 'legalName',
  legalState = 'legalState',
  legalZipCode = 'legalZipCode',
  phone = 'phone',
  subIndustry = 'subIndustry',
  taxId = 'taxId',
  taxIdType = 'taxIdType'
}

export enum LimitationAction {
  lift = 'lift',
  place = 'place',
  update = 'update'
}

export type LimitationActionLog = {
  __typename?: 'LimitationActionLog';
  action?: Maybe<LimitationAction>;
  analystName?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<LimitationEntityType>;
  limitationName?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  scopes: Array<Scalars['String']>;
  source?: Maybe<LimitationSource>;
  timestamp?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type LimitationActionLogResponse = {
  __typename?: 'LimitationActionLogResponse';
  logs: Array<LimitationActionLog>;
  total: Scalars['Int'];
};

export type LimitationEntities = {
  __typename?: 'LimitationEntities';
  creator?: Maybe<LimitationEntity>;
  organization: LimitationEntity;
  users: Array<LimitationEntity>;
};

export type LimitationEntity = {
  __typename?: 'LimitationEntity';
  activeLimitations: Array<ActiveLimitation>;
  name: Scalars['String'];
  recentPastLimitationsLiftedAt?: Maybe<Scalars['String']>;
};

export enum LimitationEntityType {
  organization = 'organization',
  user = 'user'
}

export type LimitationInfo = {
  __typename?: 'LimitationInfo';
  gracePeriodEndDate?: Maybe<Scalars['String']>;
  liftOperations?: Maybe<Array<Maybe<Scalars['String']>>>;
  missingInfo?: Maybe<Scalars['JSON']>;
  name: Scalars['String'];
  numberOfPaymentsLeftInGracePeriod?: Maybe<Scalars['Int']>;
  restrictedScopes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum LimitationName {
  ATORejectOrg = 'ATORejectOrg',
  ATORejectUser = 'ATORejectUser',
  AbuseRejectOrg = 'AbuseRejectOrg',
  ComplianceReject = 'ComplianceReject',
  ComplianceUnresponsive = 'ComplianceUnresponsive',
  EDDBlock = 'EDDBlock',
  EDDFullAccess = 'EDDFullAccess',
  EDDRejectRiskDecision = 'EDDRejectRiskDecision',
  EDDRejectUnresponsive = 'EDDRejectUnresponsive',
  FraudUnresponsive = 'FraudUnresponsive',
  IdentityFraud = 'IdentityFraud',
  KYCGracePeriodEndedMissingInfo = 'KYCGracePeriodEndedMissingInfo',
  KYCMissingInfo = 'KYCMissingInfo',
  KYCTaxIdNotVerified = 'KYCTaxIdNotVerified',
  LocationNotSupported = 'LocationNotSupported',
  MDFraud = 'MDFraud',
  MRRFraud = 'MRRFraud',
  MRRPolicy = 'MRRPolicy',
  OrgOwesUsMoney = 'OrgOwesUsMoney',
  OutstandingBalanceCantResolve = 'OutstandingBalanceCantResolve',
  SFRejectRiskDecision = 'SFRejectRiskDecision',
  SFSuspectedOrg = 'SFSuspectedOrg',
  SuspectedPhishing = 'SuspectedPhishing'
}

export enum LimitationSource {
  manual = 'manual',
  system = 'system'
}

export enum LimitationStatus {
  Limited = 'Limited',
  NoLimitation = 'NoLimitation',
  PastLimitation = 'PastLimitation',
  WarningLimited = 'WarningLimited'
}

export type LimitationsResponse = {
  __typename?: 'LimitationsResponse';
  payee?: Maybe<LimitationEntities>;
  payor?: Maybe<LimitationEntities>;
  status: LimitationStatus;
};

export type Locale = {
  __typename?: 'Locale';
  isConsistent?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type Log = {
  __typename?: 'Log';
  _id: Scalars['MongoID'];
  actionResult?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  actionType: EnumLogActionType;
  assignedToUserDetails?: Maybe<SherlockUser>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  payload?: Maybe<Scalars['JSON']>;
  route?: Maybe<Scalars['String']>;
  source: EnumLogSource;
  taskId: Scalars['MongoID'];
  updatedAt?: Maybe<Scalars['Date']>;
  userDetails?: Maybe<SherlockUser>;
  userId?: Maybe<Scalars['MongoID']>;
};

export type LuciEntityCachedData = {
  __typename?: 'LuciEntityCachedData';
  amount: Scalars['Float'];
  caseId?: Maybe<Scalars['String']>;
  chargeReferenceNumber?: Maybe<Scalars['String']>;
  chargebackAccount?: Maybe<EnumLuciEntityCachedDataChargebackAccount>;
  chargebackBankDate?: Maybe<Scalars['Date']>;
  claim?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  creatorOrigin: EnumLuciEntityCachedDataCreatorOrigin;
  currentVersionId?: Maybe<Scalars['MongoID']>;
  disputed?: Maybe<Scalars['Boolean']>;
  disputedInternally?: Maybe<Scalars['Boolean']>;
  dueDate?: Maybe<Scalars['Date']>;
  entity: EnumLuciEntityCachedDataEntity;
  externalNotes?: Maybe<Scalars['String']>;
  financingProvider?: Maybe<Scalars['String']>;
  highLevelClaim?: Maybe<EnumLuciEntityCachedDataHighLevelClaim>;
  id: Scalars['String'];
  installmentNumber?: Maybe<Scalars['Float']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  noDisputeReason?: Maybe<EnumLuciEntityCachedDataNoDisputeReason>;
  noDisputeReasonOther?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Float']>;
  originalFailureCode?: Maybe<Scalars['String']>;
  originalLossCreatedAt?: Maybe<Scalars['Date']>;
  partner?: Maybe<Scalars['String']>;
  payment?: Maybe<LuciEntityCachedDataPayment>;
  paymentId?: Maybe<Scalars['Float']>;
  reason?: Maybe<EnumLuciEntityCachedDataReason>;
  reasonOther?: Maybe<Scalars['String']>;
  recoveredByJustt?: Maybe<Scalars['Boolean']>;
  recoveryAccount?: Maybe<EnumLuciEntityCachedDataRecoveryAccount>;
  recoveryBankDate?: Maybe<Scalars['Date']>;
  recoveryDate?: Maybe<Scalars['Date']>;
  recoveryMethod?: Maybe<EnumLuciEntityCachedDataRecoveryMethod>;
  recoveryMethodOther?: Maybe<Scalars['String']>;
  scenario?: Maybe<EnumLuciEntityCachedDataScenario>;
  scenarioOther?: Maybe<Scalars['String']>;
  source?: Maybe<EnumLuciEntityCachedDataSource>;
  status: EnumLuciEntityCachedDataStatus;
  subStatus: EnumLuciEntityCachedDataSubStatus;
  subStatusOther?: Maybe<Scalars['String']>;
  transferId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type LuciEntityCachedDataPayment = {
  __typename?: 'LuciEntityCachedDataPayment';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organization?: Maybe<LuciEntityCachedDataPaymentOrganization>;
};

export type LuciEntityCachedDataPaymentOrganization = {
  __typename?: 'LuciEntityCachedDataPaymentOrganization';
  companyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Float']>;
};

export enum ManualPaymentTypeEnum {
  ManualRefund = 'ManualRefund',
  PaymentLinkRecovery = 'PaymentLinkRecovery',
  Reimbursement = 'Reimbursement'
}

export type MeasurementInfo = {
  __typename?: 'MeasurementInfo';
  measurementUnit?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
};

export type MelioDbCase = {
  __typename?: 'MelioDbCase';
  amount: Scalars['Float'];
  chargebackAccount?: Maybe<ChargebackAccount>;
  chargebackBankDate?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  creatorOrigin?: Maybe<MelioDbCaseCreatorOrigin>;
  highLevelClaim?: Maybe<HighLevelClaim>;
  id: Scalars['String'];
  installmentNumber?: Maybe<Scalars['Int']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  noDisputeReason?: Maybe<NoDisputeReason>;
  noDisputeReasonOther?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  originalFailureCode?: Maybe<Scalars['String']>;
  originalLossCreatedAt: Scalars['String'];
  partner?: Maybe<Scalars['String']>;
  /** original payment details */
  payment?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['Int']>;
  reason?: Maybe<MelioDbCaseReason>;
  reasonOther?: Maybe<Scalars['String']>;
  recoveryAccount?: Maybe<ChargebackAccount>;
  recoveryBankDate?: Maybe<Scalars['String']>;
  recoveryDate?: Maybe<Scalars['String']>;
  recoveryMethod?: Maybe<MelioDbCaseRecoveryMethod>;
  recoveryMethodOther?: Maybe<Scalars['String']>;
  scenario?: Maybe<MelioDbCaseScenario>;
  source?: Maybe<UfSource>;
  status?: Maybe<Status>;
  subStatus?: Maybe<MelioDbCaseSubStatus>;
  subStatusOther?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export enum MelioDbCaseCreatorOrigin {
  Manual = 'Manual',
  System = 'System'
}

export enum MelioDbCaseReason {
  Abuse = 'Abuse',
  Ato = 'Ato',
  CheckDmPolicyIssue = 'CheckDmPolicyIssue',
  DelinquentRefund = 'DelinquentRefund',
  ExpeditedPayment = 'ExpeditedPayment',
  ExternalServiceIssue = 'ExternalServiceIssue',
  FriendlyFraud = 'FriendlyFraud',
  GoodUserInexplainable = 'GoodUserInexplainable',
  InternalIssue = 'InternalIssue',
  Other = 'Other',
  P2dFraud = 'P2dFraud',
  RealFraud = 'RealFraud',
  ReversePhishing = 'ReversePhishing',
  Sf = 'Sf',
  UnilateralFraud = 'UnilateralFraud',
  VendorSideFraud = 'VendorSideFraud'
}

/** Get all MelioDbCases and count */
export type MelioDbCaseRecord = {
  __typename?: 'MelioDbCaseRecord';
  cases?: Maybe<Array<Maybe<MelioDbCase>>>;
  count: Scalars['Int'];
};

export enum MelioDbCaseRecoveryMethod {
  AchReversal = 'AchReversal',
  Affidavit = 'Affidavit',
  AffidavitPendingBankResponse = 'AffidavitPendingBankResponse',
  AffidavitPendingPayee = 'AffidavitPendingPayee',
  AffidavitPreparedPendingNotarization = 'AffidavitPreparedPendingNotarization',
  HandoffToCk = 'HandoffToCk',
  InternationalRecall = 'InternationalRecall',
  LegalAction = 'LegalAction',
  Loi = 'Loi',
  Other = 'Other',
  Recollect = 'Recollect',
  TabapayReversal = 'TabapayReversal'
}

export enum MelioDbCaseScenario {
  ExternalLoss = 'ExternalLoss',
  PartnerLoss = 'PartnerLoss',
  Poa = 'Poa',
  Reimbursement = 'Reimbursement',
  UncollectedFees = 'UncollectedFees',
  UncollectedFunds = 'UncollectedFunds'
}

export enum MelioDbCaseSubStatus {
  AttemptingRecovery = 'AttemptingRecovery',
  FalsePositive = 'FalsePositive',
  Final = 'Final',
  LossReviewed = 'LossReviewed',
  MelioHasFunds = 'MelioHasFunds',
  NotFighting = 'NotFighting',
  Other = 'Other',
  PoaAnswered = 'PoaAnswered',
  RecoveryFailed = 'RecoveryFailed',
  RecoverySuccessful = 'RecoverySuccessful',
  Tbd = 'Tbd'
}

export type MentionUser = {
  __typename?: 'MentionUser';
  display: Scalars['String'];
  id: Scalars['String'];
  picture?: Maybe<Scalars['String']>;
  type?: Maybe<EscalationUserTypeEnum>;
};

export type MergedCaseRef = {
  __typename?: 'MergedCaseRef';
  evaluationId: Scalars['String'];
  id: Scalars['String'];
};

export type MessageInput = {
  content: Scalars['String'];
  role: Scalars['String'];
};

export type MessageResponse = {
  __typename?: 'MessageResponse';
  content: Scalars['String'];
  role: Scalars['String'];
};

export type Metadata = {
  __typename?: 'Metadata';
  builtAt: Scalars['String'];
  rootNodeKey: Scalars['String'];
  version: Scalars['String'];
};

export type Model = {
  __typename?: 'Model';
  capabilities?: Maybe<Array<Maybe<Scalars['String']>>>;
  customizationsSupported?: Maybe<Array<Maybe<Scalars['String']>>>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  inferenceType?: Maybe<Scalars['String']>;
  inferenceTypesSupported?: Maybe<Array<Maybe<Scalars['String']>>>;
  inputModalities?: Maybe<Array<Maybe<Scalars['String']>>>;
  modelArn?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  outputModalities?: Maybe<Array<Maybe<Scalars['String']>>>;
  provider: Scalars['String'];
  responseStreamingSupported?: Maybe<Scalars['Boolean']>;
};

export type Module = {
  __typename?: 'Module';
  _id: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  name: Scalars['String'];
  roles?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  rolesList?: Maybe<Array<Maybe<Role>>>;
  routes: Array<ModuleRoutes>;
  updatedAt?: Maybe<Scalars['Date']>;
};


export type ModuleRoutesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyModuleRoutesInput>;
};

export type ModuleRoutes = {
  __typename?: 'ModuleRoutes';
  _id: Scalars['MongoID'];
  module?: Maybe<Scalars['MongoID']>;
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  rolesList?: Maybe<Array<Maybe<Role>>>;
};

export enum MoneyFlow {
  ap = 'ap',
  ar = 'ar'
}

export type MongoError = ErrorInterface & {
  __typename?: 'MongoError';
  /** MongoDB error code */
  code?: Maybe<Scalars['Int']>;
  /** MongoDB error message */
  message?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Update Fs On Ck Payment */
  UpdateFSonCKpayment?: Maybe<PathFinderActionsResponse>;
  /** Account Closure */
  accountClosure?: Maybe<PathFinderActionsResponse>;
  /** Add Comment */
  addComment?: Maybe<PathFinderActionsResponse>;
  addNewComment?: Maybe<NewComment>;
  /** Add Tag To Organization */
  addTagToOrganization?: Maybe<PathFinderActionsResponse>;
  /** Add Tag To Payment */
  addTagToPayment?: Maybe<PathFinderActionsResponse>;
  /** Add Tag To User */
  addTagToUser?: Maybe<PathFinderActionsResponse>;
  /** Add User To Organization */
  addUserToOrganization?: Maybe<PathFinderActionsResponse>;
  /** Allow Micro Deposit Eligible */
  allowMicroDepositEligible?: Maybe<PathFinderActionsResponse>;
  archiveEscalation?: Maybe<Scalars['Boolean']>;
  assignUser?: Maybe<Scalars['Boolean']>;
  /** Assign VIP plan */
  assignVipPlan?: Maybe<UpdateOrgTypeType>;
  /** Bulk Update Bank Accounts */
  bulkUpdateBankAccounts?: Maybe<PathFinderActionsResponse>;
  /** Cancel organization subscription */
  cancelOrganizationSubscription?: Maybe<UpdateSubscriptionType>;
  /** Cancel VIP plan */
  cancelVipPlan?: Maybe<UpdateOrgTypeType>;
  /** Change Email */
  changeEmail?: Maybe<PathFinderActionsResponse>;
  /** Change Payment Status */
  changePaymentStatus?: Maybe<PathFinderActionsResponse>;
  /** Compare */
  compareStrategy?: Maybe<FeatureStrategy>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  concernAreaCreate?: Maybe<CreateOneConcernAreaSchemaPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  concernAreaRemoveById?: Maybe<RemoveByIdConcernAreaSchemaPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  concernAreaUpdateById?: Maybe<UpdateByIdConcernAreaSchemaPayload>;
  createAgentConversation?: Maybe<Conversation>;
  /** Create flow */
  createFlow?: Maybe<CreateOneUiFlowPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  createGayaForm?: Maybe<CreateOneGayaFormPayload>;
  createGayaFormResponse?: Maybe<Scalars['JSON']>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  createGayaTheme?: Maybe<CreateOneGayaThemePayload>;
  createGraph?: Maybe<Graph>;
  createModelConversation?: Maybe<Conversation>;
  /** Create organization with fee configuration */
  createOrganization?: Maybe<OrganizationFee>;
  /** Create partner with fee configuration */
  createPartner?: Maybe<PartnerFee>;
  createProject?: Maybe<Project>;
  /** Create promo code */
  createPromoCode?: Maybe<CreatePromoCodeResponse>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  createRubric?: Maybe<CreateOneRubricPayload>;
  createTaskHistory?: Maybe<Scalars['MongoID']>;
  createUploadRequest?: Maybe<UploadRequestStatus>;
  decipher?: Maybe<Scalars['String']>;
  /** Delete Comment */
  deleteComment?: Maybe<PathFinderActionsResponse>;
  /** Delete a conversation by ID */
  deleteConversation: Scalars['Boolean'];
  /** Delete Delivery Method */
  deleteDeliveryMethod?: Maybe<PathFinderActionsResponse>;
  /** Delete flow */
  deleteFlow?: Maybe<Scalars['MongoID']>;
  deleteGayaForm?: Maybe<Scalars['JSON']>;
  /** Delete organization fee */
  deleteOrganizationFee?: Maybe<OrganizationFee>;
  /** Delete partner fee */
  deletePartnerFee?: Maybe<PartnerFee>;
  deleteProject?: Maybe<Project>;
  /** Downgrade organization subscription */
  downgradeOrganizationSubscription?: Maybe<UpdateSubscriptionType>;
  /** Download Invoice */
  downloadInvoice?: Maybe<PathFinderFileResponse>;
  /** Download Loi */
  downloadLoi?: Maybe<PathFinderFileResponse>;
  /** Download Poa Document */
  downloadPoaDocument?: Maybe<PathFinderFileResponse>;
  /** Edit User Role */
  editUserRole?: Maybe<PathFinderActionsResponse>;
  escalationDecision?: Maybe<EscalationDecision>;
  /** Export audit trail events as CSV using the /internal/query endpoint with format=csv and max limit. */
  exportAuditTrailCsv?: Maybe<AuditTrailCsvExportResponse>;
  /** Export customer approval events as CSV */
  exportCustomerApprovalCsv?: Maybe<Scalars['String']>;
  /** Export Payments List */
  exportPaymentsList?: Maybe<PathFinderExportFileResponse>;
  /** General Request Escalation */
  generalRequestEscalation?: Maybe<PathFinderActionsResponse>;
  genericTaskAssignLabel?: Maybe<Scalars['Boolean']>;
  genericTaskUnassign?: Maybe<Scalars['Boolean']>;
  /** Get detailed information for a specific agent alias */
  getAliasDetails?: Maybe<AliasDetails>;
  /** Get Fx Payout Info */
  getFxPayoutInfo?: Maybe<PathFinderPayoutInfoResponse>;
  /** Global Opt Out Persistent Fast Payment */
  globalOptOutPersistentFastPayment?: Maybe<PathFinderActionsResponse>;
  /** Save strategy */
  handleStrategyChange?: Maybe<Scalars['String']>;
  /** Handoff To Ck */
  handoffToCk?: Maybe<PathFinderActionsResponse>;
  /** Finish incident */
  incidentClose?: Maybe<UpdateOneIncidentPayload>;
  /** Create incident */
  incidentCreate?: Maybe<CreateOneIncidentPayload>;
  /** Calculate incident groups */
  incidentGroupSegmentation?: Maybe<Scalars['JSON']>;
  /** Update incident */
  incidentUpdate?: Maybe<UpdateOneIncidentPayload>;
  /** Local Opt Out Persistent Fast Payment */
  localOptOutPersistentFastPayment?: Maybe<PathFinderActionsResponse>;
  logCreateOne?: Maybe<Log>;
  /** Migrate strategies and rules */
  migrateLiveStrategiesAndRules?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  moduleRoutesCreate?: Maybe<CreateOneModuleRoutesPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  moduleRoutesDelete?: Maybe<RemoveByIdModuleRoutesPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  moduleRoutesUpdate?: Maybe<UpdateByIdModuleRoutesPayload>;
  muteUnmuteUser?: Maybe<MuteUnmuteUser>;
  /** Opt Out Of Sunlight */
  optOutOfSunlight?: Maybe<PathFinderActionsResponse>;
  pollAgentJobResult?: Maybe<AgentJobResult>;
  /** Proof Of Payment Escalation */
  proofOfPaymentEscalation?: Maybe<PathFinderActionsResponseWithFile>;
  /** Push to live */
  pushToLive?: Maybe<FeatureStrategy>;
  /** Push to shadow */
  pushToShadow?: Maybe<FeatureStrategy>;
  /** Recalculate Payment State */
  recalculatePaymentState?: Maybe<PathFinderActionsResponse>;
  /** Recollect On Fee Escalation */
  recollectOnFeeEscalation?: Maybe<PathFinderActionsResponse>;
  /** Record Manual Payment */
  recordManualPayment?: Maybe<PathFinderActionsResponse>;
  /** Refund */
  refund?: Maybe<PathFinderActionsResponse>;
  /** Refund Fee Escalation */
  refundFeeEscalation?: Maybe<PathFinderActionsResponse>;
  /** Refund Fee Payment */
  refundFeePayment?: Maybe<PathFinderActionsResponse>;
  /** Refund Payment Escalation */
  refundPaymentEscalation?: Maybe<PathFinderActionsResponse>;
  /** Reimbursement Escalation */
  reimbursementEscalation?: Maybe<PathFinderActionsResponse>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeGayaThemeById?: Maybe<RemoveByIdGayaThemePayload>;
  removeTag?: Maybe<RemoveTag>;
  /** Remove Tag From Organization */
  removeTagFromOrganization?: Maybe<PathFinderActionsResponse>;
  /** Remove Tag From User */
  removeTagFromUser?: Maybe<PathFinderActionsResponse>;
  /** Remove User From Organization */
  removeUserFromOrganization?: Maybe<PathFinderActionsResponse>;
  /** Request Refund Approval */
  requestRefundApproval?: Maybe<PathFinderActionsResponse>;
  /** Resend 2 Fa Code */
  resend2faCode?: Maybe<PathFinderActionsResponse>;
  /** Reset Mfa Attempts */
  resetMfaAttempts?: Maybe<PathFinderActionsResponse>;
  /** Retry Collect */
  retryCollect?: Maybe<PathFinderActionsResponse>;
  /** Retry Delivery */
  retryDelivery?: Maybe<PathFinderActionsResponse>;
  /** Retry Delivery Escalation */
  retryDeliveryEscalation?: Maybe<PathFinderActionsResponse>;
  /** Retry Installment Escalation */
  retryInstallmentEscalation?: Maybe<PathFinderActionsResponse>;
  runFlow?: Maybe<Scalars['JSON']>;
  /** [Ruby] Run flow by type/name */
  runFlowByType?: Maybe<Scalars['JSON']>;
  /** Run incident */
  runIncident?: Maybe<Scalars['String']>;
  /** Start the User Activity Agent to analyze user activity within a date range. Returns an ID to poll for results. */
  runUserActivityAgent?: Maybe<StartActivityResponse>;
  safeDecipher?: Maybe<Scalars['String']>;
  /** Send Ach Details Request */
  sendAchDetailsRequest?: Maybe<PathFinderActionsResponse>;
  sendAgentMessage?: Maybe<AgentJobSubmission>;
  sendModelMessage?: Maybe<MessageResponse>;
  /** Create shadow candidate strategy */
  shadowCandidateStrategyCreate?: Maybe<FeatureStrategy>;
  /** Update shadow candidate strategy */
  shadowCandidateStrategyUpdate?: Maybe<FeatureStrategy>;
  /** Simulate strategy */
  simulateStrategy?: Maybe<SimulationTriggerResponse>;
  slotAddLabels?: Maybe<Slot>;
  slotCreate?: Maybe<Slot>;
  slotRemoveLabels?: Maybe<Slot>;
  slotUpdateConcernAreas?: Maybe<Slot>;
  slotUpdateLabels?: Maybe<Slot>;
  /** Stop Payment */
  stopPayment?: Maybe<PathFinderActionsResponse>;
  /** Clone rule */
  strategyRuleClone?: Maybe<CreateOnerulesPayload>;
  /** Create rule */
  strategyRuleCreate?: Maybe<CreateOnerulesPayload>;
  /** Delete rule */
  strategyRuleDelete?: Maybe<DeleteResponse>;
  /** Update rule */
  strategyRuleUpdate?: Maybe<UpdateOnerulesPayload>;
  /** Stuck Payment Escalation */
  stuckPaymentEscalation?: Maybe<PathFinderActionsResponse>;
  submitAgentFeedback?: Maybe<AgentFeedbackResponse>;
  submitFeedback?: Maybe<SubmitFeedbackResponse>;
  taskAssignConcernArea?: Maybe<Array<Maybe<Task>>>;
  taskAssignLabel?: Maybe<Array<Maybe<Task>>>;
  taskUnassign?: Maybe<Scalars['Boolean']>;
  taskUnassignConcernArea?: Maybe<Scalars['Boolean']>;
  testFlow?: Maybe<Scalars['JSON']>;
  trackPageEvent: TrackPageEventResponse;
  /** Trigger a risk AI agent execution for a given entity. */
  triggerRiskAgent: Array<TriggerAgentResponseItem>;
  updateFileType?: Maybe<Scalars['Boolean']>;
  /** Update flow */
  updateFlow?: Maybe<UpdateOneUiFlowPayload>;
  /** Manage flow permissions */
  updateFlowPermission?: Maybe<FlowPermission>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateGayaForm?: Maybe<UpdateOneGayaFormPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateGayaThemeById?: Maybe<UpdateByIdGayaThemePayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  updateGayaThemeMany?: Maybe<UpdateManyGayaThemePayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateGayaThemeOne?: Maybe<UpdateOneGayaThemePayload>;
  /** Update organization type */
  updateOrgType?: Maybe<UpdateOrgTypeType>;
  /** Update organization fees */
  updateOrganizationFees?: Maybe<OrganizationFee>;
  /** Update organization seats */
  updateOrganizationSeats?: Maybe<UpdateOperationSuccessType>;
  /** Add promo-code to organization subscription */
  updateOrganizationSubscription?: Maybe<UpdateSubscriptionType>;
  /** Update partner fees */
  updatePartnerFees?: Maybe<PartnerFee>;
  updateProject?: Maybe<Project>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateRubric?: Maybe<UpdateByIdRubricPayload>;
  updateTaskStatus?: Maybe<GenericTask>;
  /** Upgrade organization subscription */
  upgradeOrganizationSubscription?: Maybe<UpdateSubscriptionType>;
  /** Request to add T+2 feature */
  upgradeTPlusTwo?: Maybe<UpdateOperationSuccessType>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  upsertView?: Maybe<CreateOneWatsonViewPayload>;
  /** User Deletion Request */
  userDeletionRequest?: Maybe<PathFinderActionsResponse>;
  /** Cancel Virtual Card */
  virtualCardCancel?: Maybe<PathFinderActionsResponse>;
  /** Void Check */
  voidCheck?: Maybe<PathFinderActionsResponse>;
};


export type MutationUpdateFSonCKpaymentArgs = {
  description: Scalars['String'];
  fundingSourceId: Scalars['Int'];
  paymentId: Scalars['Int'];
  zendeskTicketId: Scalars['Int'];
};


export type MutationAccountClosureArgs = {
  description: Scalars['String'];
  organizationId: Scalars['Int'];
  requestTime: Scalars['Date'];
  requesterUserId: Scalars['Int'];
  zendeskTicketId: Scalars['Int'];
};


export type MutationAddCommentArgs = {
  collectionName: CollectionName;
  entityId: Scalars['String'];
  note: Scalars['String'];
  visibleTo?: InputMaybe<VisibilityTeam>;
};


export type MutationAddNewCommentArgs = {
  comment: Scalars['String'];
  escalationId: Scalars['String'];
  isEscalationCompleted?: InputMaybe<Scalars['Boolean']>;
  organizationName?: InputMaybe<Scalars['String']>;
  tagged?: InputMaybe<Array<InputMaybe<TaggedInput>>>;
};


export type MutationAddTagToOrganizationArgs = {
  organizationId: Scalars['Int'];
  propertyName?: InputMaybe<Scalars['String']>;
  tagName: Scalars['String'];
};


export type MutationAddTagToPaymentArgs = {
  paymentIds: Array<Scalars['Int']>;
  propertyName?: InputMaybe<Scalars['String']>;
  tagName: Scalars['String'];
};


export type MutationAddTagToUserArgs = {
  propertyName?: InputMaybe<Scalars['String']>;
  tagName: Scalars['String'];
  userId: Scalars['Int'];
};


export type MutationAddUserToOrganizationArgs = {
  email: Scalars['String'];
  organizationId: Scalars['Int'];
  role: UserOrganizationroleEnum;
};


export type MutationAllowMicroDepositEligibleArgs = {
  organizationId: Scalars['Int'];
};


export type MutationArchiveEscalationArgs = {
  escalationId: Scalars['String'];
};


export type MutationAssignUserArgs = {
  taskIds: Array<Scalars['String']>;
  userIds: Array<InputMaybe<Scalars['String']>>;
};


export type MutationAssignVipPlanArgs = {
  isSubscribed: Scalars['Boolean'];
  organizationId: Scalars['Int'];
};


export type MutationBulkUpdateBankAccountsArgs = {
  newAccountNumber: Scalars['String'];
  newRoutingNumber: Scalars['String'];
  oldAccountNumber: Scalars['String'];
  oldRoutingNumber: Scalars['String'];
  vendorIds: Array<Scalars['Int']>;
};


export type MutationCancelOrganizationSubscriptionArgs = {
  fundingSourceId?: InputMaybe<Scalars['Int']>;
  isAccountingClient?: InputMaybe<Scalars['Boolean']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};


export type MutationCancelVipPlanArgs = {
  organizationId: Scalars['Int'];
};


export type MutationChangeEmailArgs = {
  email: Scalars['String'];
  userId: Scalars['Int'];
};


export type MutationChangePaymentStatusArgs = {
  flow: FailFlowEnum;
  paymentId: Scalars['Int'];
  reason: Scalars['String'];
  transferId?: InputMaybe<Scalars['String']>;
};


export type MutationCompareStrategyArgs = {
  strategyId: Scalars['String'];
};


export type MutationConcernAreaCreateArgs = {
  record: CreateOneConcernAreaSchemaInput;
};


export type MutationConcernAreaRemoveByIdArgs = {
  _id: Scalars['MongoID'];
};


export type MutationConcernAreaUpdateByIdArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdConcernAreaSchemaInput;
};


export type MutationCreateAgentConversationArgs = {
  agentName: Scalars['String'];
  partner: Scalars['String'];
};


export type MutationCreateFlowArgs = {
  record: CreateOneUiFlowInput;
};


export type MutationCreateGayaFormArgs = {
  record: CreateOneGayaFormInput;
};


export type MutationCreateGayaFormResponseArgs = {
  content: Scalars['JSON'];
  createdBy: Scalars['MongoID'];
  formId: Scalars['MongoID'];
  slackChannel?: InputMaybe<Scalars['String']>;
  slackMessage?: InputMaybe<Scalars['String']>;
  zendeskGroup?: InputMaybe<Scalars['Float']>;
};


export type MutationCreateGayaThemeArgs = {
  record: CreateOneGayaThemeInput;
};


export type MutationCreateGraphArgs = {
  entity: Scalars['String'];
  id: Scalars['Int'];
};


export type MutationCreateModelConversationArgs = {
  modelId: Scalars['String'];
  partner: Scalars['String'];
};


export type MutationCreateOrganizationArgs = {
  input?: InputMaybe<CreateOrganizationInput>;
};


export type MutationCreatePartnerArgs = {
  input?: InputMaybe<CreatePartnerInput>;
};


export type MutationCreateProjectArgs = {
  description: Scalars['String'];
  dueDate?: InputMaybe<Scalars['Date']>;
  fieldsToHide: Array<FieldToHide>;
  name: Scalars['String'];
  participants?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  payments: Array<ProjectPayment>;
  startDate?: InputMaybe<Scalars['Date']>;
};


export type MutationCreatePromoCodeArgs = {
  input?: InputMaybe<CreatePromoCodeInput>;
};


export type MutationCreateRubricArgs = {
  record: CreateOneRubricInput;
};


export type MutationCreateTaskHistoryArgs = {
  taskId: Scalars['MongoID'];
  type: TaskHistoryType;
  userId: Scalars['MongoID'];
};


export type MutationCreateUploadRequestArgs = {
  fileName: Scalars['String'];
  organizationId: Scalars['Int'];
  partnerName: Scalars['String'];
};


export type MutationDecipherArgs = {
  appName?: InputMaybe<AppNamesEnum>;
  partnerName?: InputMaybe<Scalars['String']>;
  sourceUrlPath?: InputMaybe<Scalars['String']>;
  useCache?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['String'];
};


export type MutationDeleteCommentArgs = {
  commentId: Scalars['String'];
};


export type MutationDeleteConversationArgs = {
  id: Scalars['String'];
};


export type MutationDeleteDeliveryMethodArgs = {
  deliveryMethodId: Scalars['Int'];
  vendorId: Scalars['Int'];
  zendeskTicketId: Scalars['Int'];
};


export type MutationDeleteFlowArgs = {
  id: Scalars['MongoID'];
};


export type MutationDeleteGayaFormArgs = {
  id: Scalars['MongoID'];
  updatedBy: Scalars['MongoID'];
};


export type MutationDeleteOrganizationFeeArgs = {
  feeCatalogId: Scalars['Int'];
  organizationId: Scalars['String'];
};


export type MutationDeletePartnerFeeArgs = {
  feeCatalogId: Scalars['Int'];
  partnerId: Scalars['String'];
};


export type MutationDeleteProjectArgs = {
  id: Scalars['MongoID'];
};


export type MutationDowngradeOrganizationSubscriptionArgs = {
  fundingSourceId?: InputMaybe<Scalars['Int']>;
  isAccountingClient?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['Int'];
  planCyclePeriod?: InputMaybe<PlanCyclePeriod>;
  subscriptionPlanId: Scalars['String'];
  subscriptionPromoCode?: InputMaybe<Scalars['String']>;
  userId: Scalars['Int'];
};


export type MutationDownloadInvoiceArgs = {
  paymentId: Scalars['Int'];
};


export type MutationDownloadLoiArgs = {
  paymentId: Scalars['Int'];
};


export type MutationDownloadPoaDocumentArgs = {
  paymentId: Scalars['Int'];
};


export type MutationEditUserRoleArgs = {
  organizationId: Scalars['Int'];
  role: UserOrganizationroleEnum;
  userId: Scalars['Int'];
};


export type MutationEscalationDecisionArgs = {
  escalationId: Scalars['String'];
  organizationName?: InputMaybe<Scalars['String']>;
};


export type MutationExportAuditTrailCsvArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientIp?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  organizationId: Scalars['String'];
  sort?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationExportCustomerApprovalCsvArgs = {
  organizationId: Scalars['Int'];
};


export type MutationExportPaymentsListArgs = {
  filter?: InputMaybe<Scalars['SequelizeJSON']>;
  organizationId: Scalars['Int'];
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationGeneralRequestEscalationArgs = {
  description: Scalars['String'];
  paymentIds: Array<Scalars['Int']>;
  zendeskTicketId: Scalars['Int'];
};


export type MutationGenericTaskAssignLabelArgs = {
  inboxType?: InputMaybe<EnumGenericTaskType>;
  labelIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status: EnumGenericTaskStatus;
  tasksAmount?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationGenericTaskUnassignArgs = {
  inboxType?: InputMaybe<EnumGenericTaskType>;
  status: EnumGenericTaskStatus;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationGetAliasDetailsArgs = {
  agentName: Scalars['String'];
  aliasName: Scalars['String'];
};


export type MutationGetFxPayoutInfoArgs = {
  paymentId: Scalars['Int'];
};


export type MutationGlobalOptOutPersistentFastPaymentArgs = {
  vendorId: Scalars['Int'];
};


export type MutationHandleStrategyChangeArgs = {
  id?: InputMaybe<Scalars['String']>;
  logic?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  rules?: InputMaybe<Array<InputMaybe<RuleInput>>>;
  tree?: InputMaybe<Scalars['JSON']>;
};


export type MutationHandoffToCkArgs = {
  paymentId: Scalars['Int'];
};


export type MutationIncidentCloseArgs = {
  incidentId: Scalars['MongoID'];
};


export type MutationIncidentCreateArgs = {
  incident: CreateOneIncidentInput;
  incidentGroups?: InputMaybe<Array<CreateOneIncidentGroupInput>>;
};


export type MutationIncidentGroupSegmentationArgs = {
  incidentId: Scalars['MongoID'];
};


export type MutationIncidentUpdateArgs = {
  incident: UpdateOneIncidentInput;
  incidentGroups?: InputMaybe<Array<CreateOneIncidentGroupInput>>;
  incidentId: Scalars['MongoID'];
};


export type MutationLocalOptOutPersistentFastPaymentArgs = {
  vendorId: Scalars['Int'];
};


export type MutationLogCreateOneArgs = {
  actionType: Scalars['String'];
  taskId: Scalars['String'];
};


export type MutationMigrateLiveStrategiesAndRulesArgs = {
  mode: Scalars['String'];
  strategyNames?: InputMaybe<Array<Scalars['String']>>;
  strategyVersionOverrides?: InputMaybe<Array<StrategyVersionOverrideInput>>;
};


export type MutationModuleRoutesCreateArgs = {
  record: CreateOneModuleRoutesInput;
};


export type MutationModuleRoutesDeleteArgs = {
  _id: Scalars['MongoID'];
};


export type MutationModuleRoutesUpdateArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdModuleRoutesInput;
};


export type MutationMuteUnmuteUserArgs = {
  escalationId: Scalars['String'];
  isMuted?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['String'];
};


export type MutationOptOutOfSunlightArgs = {
  organizationId: Scalars['Int'];
};


export type MutationPollAgentJobResultArgs = {
  jobId: Scalars['String'];
  partner: Scalars['String'];
};


export type MutationProofOfPaymentEscalationArgs = {
  description: Scalars['String'];
  paymentId: Scalars['Int'];
  proofOfPaymentType: ProofOfPaymentType;
  zendeskTicketId: Scalars['Int'];
};


export type MutationPushToLiveArgs = {
  _id: Scalars['String'];
};


export type MutationPushToShadowArgs = {
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  rules?: InputMaybe<Scalars['JSON']>;
};


export type MutationRecalculatePaymentStateArgs = {
  paymentId: Scalars['Int'];
};


export type MutationRecollectOnFeeEscalationArgs = {
  description: Scalars['String'];
  fundingSourceId: Scalars['Int'];
  paymentIds: Array<Scalars['Int']>;
  zendeskTicketId: Scalars['Int'];
};


export type MutationRecordManualPaymentArgs = {
  amount: Scalars['Float'];
  businessEntity: BusinessEntityEnum;
  businessEntityDescription?: InputMaybe<Scalars['String']>;
  createdManualPaymentId: Scalars['Int'];
  manualPaymentType: ManualPaymentTypeEnum;
  payeeName: Scalars['String'];
  paymentId: Scalars['Int'];
  payorName: Scalars['String'];
  reason: Scalars['String'];
  zendeskTicketId: Scalars['Int'];
};


export type MutationRefundArgs = {
  paymentIds: Array<Scalars['Int']>;
};


export type MutationRefundFeeEscalationArgs = {
  description: Scalars['String'];
  feeRefundAmount?: InputMaybe<Scalars['Float']>;
  feeRefundReason: FeeRefundReason;
  feeRefundType: FeeRefundType;
  paymentIds: Array<Scalars['Int']>;
  zendeskTicketId: Scalars['Int'];
};


export type MutationRefundFeePaymentArgs = {
  paymentId: Scalars['Int'];
  reason?: InputMaybe<RefundFeeProcessingPaymentRequestReasonEnum>;
};


export type MutationRefundPaymentEscalationArgs = {
  description: Scalars['String'];
  paymentIds: Array<Scalars['Int']>;
  zendeskTicketId: Scalars['Int'];
};


export type MutationReimbursementEscalationArgs = {
  description: Scalars['String'];
  paymentIds: Array<Scalars['Int']>;
  reimbursementReason: ReimbursementReason;
  zendeskTicketId: Scalars['Int'];
};


export type MutationRemoveGayaThemeByIdArgs = {
  _id: Scalars['MongoID'];
};


export type MutationRemoveTagArgs = {
  entity: Scalars['String'];
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  propertyName: Scalars['String'];
  tagName: Scalars['String'];
};


export type MutationRemoveTagFromOrganizationArgs = {
  organizationId: Scalars['Int'];
  propertyName?: InputMaybe<Scalars['String']>;
  tagName: Scalars['String'];
};


export type MutationRemoveTagFromUserArgs = {
  propertyName?: InputMaybe<Scalars['String']>;
  tagName: Scalars['String'];
  userId: Scalars['Int'];
};


export type MutationRemoveUserFromOrganizationArgs = {
  organizationId: Scalars['Int'];
  userId: Scalars['Int'];
};


export type MutationRequestRefundApprovalArgs = {
  paymentIds: Array<Scalars['Int']>;
};


export type MutationResend2faCodeArgs = {
  userId: Scalars['Int'];
};


export type MutationResetMfaAttemptsArgs = {
  userId: Scalars['Int'];
};


export type MutationRetryCollectArgs = {
  fundingSourceId?: InputMaybe<Scalars['Int']>;
  paymentId: Scalars['Int'];
  transferId?: InputMaybe<Scalars['String']>;
};


export type MutationRetryDeliveryArgs = {
  deliveryMethodId: Scalars['Int'];
  paymentId: Scalars['Int'];
  sendEmailNotification: Scalars['Boolean'];
};


export type MutationRetryDeliveryEscalationArgs = {
  deliveryMethodId: Scalars['Int'];
  description: Scalars['String'];
  paymentId: Scalars['Int'];
  zendeskTicketId: Scalars['Int'];
};


export type MutationRetryInstallmentEscalationArgs = {
  description: Scalars['String'];
  fundingSourceId: Scalars['Int'];
  paymentId: Scalars['Int'];
  zendeskTicketId: Scalars['Int'];
};


export type MutationRunFlowArgs = {
  body: Scalars['JSON'];
  id: Scalars['MongoID'];
};


export type MutationRunFlowByTypeArgs = {
  body: Scalars['JSON'];
  type: Scalars['String'];
};


export type MutationRunIncidentArgs = {
  executedById: Scalars['MongoID'];
  incidentId: Scalars['MongoID'];
  mode: IncidentManagementBatchModeDataType;
};


export type MutationRunUserActivityAgentArgs = {
  endDate: Scalars['String'];
  prompt: Scalars['String'];
  startDate: Scalars['String'];
  summarizedType?: InputMaybe<SummarizedType>;
  userId: Scalars['String'];
};


export type MutationSafeDecipherArgs = {
  appName?: InputMaybe<AppNamesEnum>;
  partnerName?: InputMaybe<Scalars['String']>;
  sourceUrlPath?: InputMaybe<Scalars['String']>;
  useCache?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['String'];
};


export type MutationSendAchDetailsRequestArgs = {
  recipientType: AchDetailsRecipientType;
  vendorId: Scalars['Int'];
};


export type MutationSendAgentMessageArgs = {
  agentName: Scalars['String'];
  aliasName?: InputMaybe<Scalars['String']>;
  aliasVersion?: InputMaybe<Scalars['String']>;
  conversationId: Scalars['String'];
  message: Scalars['String'];
  messages: Array<MessageInput>;
  partner: Scalars['String'];
};


export type MutationSendModelMessageArgs = {
  conversationId: Scalars['String'];
  message: Scalars['String'];
  messages: Array<MessageInput>;
  modelId: Scalars['String'];
  partner: Scalars['String'];
};


export type MutationShadowCandidateStrategyCreateArgs = {
  editedVia?: InputMaybe<Scalars['String']>;
  entityType: Scalars['String'];
  fallthroughDecision: Scalars['String'];
  name: Scalars['String'];
};


export type MutationShadowCandidateStrategyUpdateArgs = {
  editedVia?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  rules?: InputMaybe<Array<Scalars['JSON']>>;
};


export type MutationSimulateStrategyArgs = {
  assessmentPoint: Scalars['String'];
  draftRules?: InputMaybe<Array<Scalars['JSON']>>;
  strategyName: Scalars['String'];
  strategyVersion?: InputMaybe<Scalars['String']>;
  timeframeEnd: Scalars['String'];
  timeframeStart: Scalars['String'];
};


export type MutationSlotAddLabelsArgs = {
  _id: Scalars['String'];
  labelIds?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationSlotCreateArgs = {
  endDateTime: Scalars['Date'];
  role: Scalars['String'];
  shiftId: Scalars['String'];
  slotType?: InputMaybe<Scalars['String']>;
  startDateTime: Scalars['Date'];
  userId: Scalars['String'];
};


export type MutationSlotRemoveLabelsArgs = {
  _id: Scalars['String'];
  labelIds?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationSlotUpdateConcernAreasArgs = {
  _id: Scalars['String'];
  concernAreaSchemaIds?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationSlotUpdateLabelsArgs = {
  _id: Scalars['String'];
  labelIds?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationStopPaymentArgs = {
  paymentIds: Array<Scalars['Int']>;
  reason: Scalars['String'];
  sendEmail?: InputMaybe<Scalars['Boolean']>;
};


export type MutationStrategyRuleCloneArgs = {
  ruleId: Scalars['Int'];
};


export type MutationStrategyRuleCreateArgs = {
  strategyRule: CreateOnerulesInput;
};


export type MutationStrategyRuleDeleteArgs = {
  id: Scalars['String'];
};


export type MutationStrategyRuleUpdateArgs = {
  conditions?: InputMaybe<Array<Scalars['JSON']>>;
  id: Scalars['Int'];
  metadata?: InputMaybe<Scalars['JSON']>;
};


export type MutationStuckPaymentEscalationArgs = {
  description: Scalars['String'];
  paymentIds: Array<Scalars['Int']>;
  zendeskTicketId: Scalars['Int'];
};


export type MutationSubmitAgentFeedbackArgs = {
  input: AgentFeedbackInput;
};


export type MutationSubmitFeedbackArgs = {
  message: Scalars['String'];
  page: Scalars['String'];
  slackChannelId: Scalars['String'];
  type: Scalars['String'];
};


export type MutationTaskAssignConcernAreaArgs = {
  concernAreaIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tasksAmount?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationTaskAssignLabelArgs = {
  labelIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tasksAmount?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationTaskUnassignArgs = {
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationTaskUnassignConcernAreaArgs = {
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationTestFlowArgs = {
  input?: InputMaybe<Scalars['JSON']>;
  uiFlow: Scalars['JSON'];
  variables: Scalars['JSON'];
};


export type MutationTrackPageEventArgs = {
  input: TrackPageEventInput;
};


export type MutationTriggerRiskAgentArgs = {
  agentNames: Array<Scalars['String']>;
  entityId: Scalars['String'];
  entityType: Scalars['String'];
  executionType?: InputMaybe<AgentExecutionType>;
  orchestrationExecutionId?: InputMaybe<Scalars['String']>;
  partnerName?: InputMaybe<Scalars['String']>;
  reason: Scalars['String'];
};


export type MutationUpdateFileTypeArgs = {
  fileId: Scalars['String'];
  newType: Scalars['String'];
  requestId: Scalars['String'];
};


export type MutationUpdateFlowArgs = {
  filter?: InputMaybe<FilterUpdateOneUiFlowInput>;
  record: UpdateOneUiFlowInput;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortUpdateOneUiFlowInput>;
};


export type MutationUpdateFlowPermissionArgs = {
  uiFlowId: Scalars['MongoID'];
  viewRoleIds?: InputMaybe<Array<Scalars['MongoID']>>;
};


export type MutationUpdateGayaFormArgs = {
  filter?: InputMaybe<FilterUpdateOneGayaFormInput>;
  record: UpdateOneGayaFormInput;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortUpdateOneGayaFormInput>;
};


export type MutationUpdateGayaThemeByIdArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdGayaThemeInput;
};


export type MutationUpdateGayaThemeManyArgs = {
  filter?: InputMaybe<FilterUpdateManyGayaThemeInput>;
  limit?: InputMaybe<Scalars['Int']>;
  record: UpdateManyGayaThemeInput;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortUpdateManyGayaThemeInput>;
};


export type MutationUpdateGayaThemeOneArgs = {
  filter?: InputMaybe<FilterUpdateOneGayaThemeInput>;
  record: UpdateOneGayaThemeInput;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortUpdateOneGayaThemeInput>;
};


export type MutationUpdateOrgTypeArgs = {
  companyType?: InputMaybe<OrgTypeChange>;
  organizationId: Scalars['Int'];
  userId: Scalars['Int'];
};


export type MutationUpdateOrganizationFeesArgs = {
  fees?: InputMaybe<OrganizationFeeInput>;
  organizationId: Scalars['String'];
};


export type MutationUpdateOrganizationSeatsArgs = {
  organizationId?: InputMaybe<Scalars['Int']>;
  seats?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateOrganizationSubscriptionArgs = {
  fundingSourceId?: InputMaybe<Scalars['Int']>;
  isAccountingClient?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['Int'];
  planCyclePeriod?: InputMaybe<PlanCyclePeriod>;
  subscriptionPlanId: Scalars['String'];
  subscriptionPromoCode?: InputMaybe<Scalars['String']>;
  userId: Scalars['Int'];
};


export type MutationUpdatePartnerFeesArgs = {
  fees?: InputMaybe<PartnerFeeInput>;
  partnerId: Scalars['String'];
};


export type MutationUpdateProjectArgs = {
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  fieldsToHide?: InputMaybe<Array<InputMaybe<FieldToHide>>>;
  id: Scalars['MongoID'];
  name?: InputMaybe<Scalars['String']>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  startDate?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<ProjectStatus>;
};


export type MutationUpdateRubricArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdRubricInput;
};


export type MutationUpdateTaskStatusArgs = {
  status?: InputMaybe<GenericTaskStatusEnum>;
  taskIds: Array<Scalars['String']>;
};


export type MutationUpgradeOrganizationSubscriptionArgs = {
  fundingSourceId?: InputMaybe<Scalars['Int']>;
  isAccountingClient?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['Int'];
  planCyclePeriod?: InputMaybe<PlanCyclePeriod>;
  subscriptionPlanId: Scalars['String'];
  subscriptionPromoCode?: InputMaybe<Scalars['String']>;
  userId: Scalars['Int'];
};


export type MutationUpgradeTPlusTwoArgs = {
  organizationId: Scalars['Int'];
};


export type MutationUpsertViewArgs = {
  record: CreateOneWatsonViewInput;
};


export type MutationUserDeletionRequestArgs = {
  description: Scalars['String'];
  organizationId: Scalars['Int'];
  requestTime: Scalars['Date'];
  userId: Scalars['Int'];
  zendeskTicketId: Scalars['Int'];
};


export type MutationVirtualCardCancelArgs = {
  paymentId: Scalars['Int'];
  reason: Scalars['String'];
};


export type MutationVoidCheckArgs = {
  checkSerialNumber: Scalars['String'];
  paymentId: Scalars['Int'];
};

export type MuteUnmuteUser = {
  __typename?: 'MuteUnmuteUser';
  escalationId?: Maybe<Scalars['String']>;
  isMuted?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['String']>;
};

export type NewComment = {
  __typename?: 'NewComment';
  comment?: Maybe<Scalars['String']>;
  escalationId: Scalars['String'];
  organizationName?: Maybe<Scalars['String']>;
  tagged?: Maybe<Array<Maybe<Tagged>>>;
};

export type NextSubscriptionType = {
  __typename?: 'NextSubscriptionType';
  planCyclePeriod?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  tier?: Maybe<Scalars['String']>;
};

export enum NoDisputeReason {
  HoldFunds = 'HoldFunds',
  Other = 'Other',
  RealFraud = 'RealFraud',
  RefundPromised = 'RefundPromised',
  Removed = 'Removed'
}

export enum NoReferralSubReason {
  irrelevantPayment = 'irrelevantPayment',
  other = 'other',
  unconfirmedFraud = 'unconfirmedFraud'
}

export type NoUbosDeclaration = {
  __typename?: 'NoUbosDeclaration';
  isDeclaredNoUbos?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedByEmail?: Maybe<Scalars['String']>;
};

export type Node = {
  __typename?: 'Node';
  data?: Maybe<Data>;
  id: Scalars['String'];
  type: Type;
  value: Scalars['String'];
};

export type OdeRiskDecisionCode = {
  __typename?: 'OdeRiskDecisionCode';
  decision: Scalars['String'];
  reason: Scalars['String'];
  riskDecisionCode: Scalars['Int'];
  subcategory: Scalars['String'];
};

export type OperatingSystem = {
  __typename?: 'OperatingSystem';
  isConsistent?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type OrgKeyIndividualDocument = {
  __typename?: 'OrgKeyIndividualDocument';
  expiryDate?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['Int']>;
  idNumber?: Maybe<Scalars['String']>;
  identityDocument?: Maybe<IdentityDocumentTypeEnum>;
  issueDate?: Maybe<Scalars['Date']>;
  issuerCountryCode?: Maybe<Scalars['String']>;
  issuerUSAState?: Maybe<Scalars['String']>;
  organizationKeyIndividualDocumentFiles?: Maybe<Array<OrgKeyIndividualDocumentFile>>;
};

export type OrgKeyIndividualDocumentFile = {
  __typename?: 'OrgKeyIndividualDocumentFile';
  fileId: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  organizationKeyIndividualDocumentId?: Maybe<Scalars['Int']>;
  side?: Maybe<Scalars['String']>;
};

export enum OrgKeyIndividualTypeEnum {
  director = 'director',
  financingApplicant = 'financingApplicant',
  fxAccountHolder = 'fxAccountHolder',
  ubo = 'ubo'
}

export enum OrgTypeChange {
  AccountingFirm = 'AccountingFirm',
  Smb = 'Smb'
}

export type OrgUboData = {
  __typename?: 'OrgUboData';
  data?: Maybe<Array<Maybe<UboData>>>;
  noUbosDeclaration?: Maybe<NoUbosDeclaration>;
};

export type OrganizationAddress = {
  __typename?: 'OrganizationAddress';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  type?: Maybe<OrganizationAddressTypeEnum>;
};

export type OrganizationCes = {
  __typename?: 'OrganizationCes';
  categories?: Maybe<Array<Maybe<OrganizationCesCategory>>>;
  categoriesUpdated?: Maybe<Scalars['Boolean']>;
  highestCesDecisionStatus?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  previousCategories?: Maybe<Array<Maybe<OrganizationCesCategory>>>;
  searchProfile?: Maybe<Scalars['String']>;
};

export type OrganizationCesCategory = {
  __typename?: 'OrganizationCesCategory';
  highestMatchStatus?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type OrganizationDecision = {
  __typename?: 'OrganizationDecision';
  createdAt?: Maybe<Scalars['String']>;
  decision: DecisionsTypes;
  organizationId: Scalars['Int'];
  organizationLabels?: Maybe<Array<Maybe<OrganizationLabel>>>;
  source: Scalars['String'];
  strategy: Scalars['String'];
  user?: Maybe<Scalars['String']>;
};

export type OrganizationDecisionFull = {
  __typename?: 'OrganizationDecisionFull';
  engineExecution?: Maybe<EngineExecution>;
  moneyIn?: Maybe<MoneyIn>;
  moneyOut?: Maybe<MoneyOut>;
  organizationId: Scalars['Int'];
};

export type OrganizationDetailsInput = {
  existingId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type OrganizationDetailsType = {
  __typename?: 'OrganizationDetailsType';
  billingHistory?: Maybe<Array<Maybe<SubscriptionBillingHistoryType>>>;
  billingInformation?: Maybe<BillingInformationType>;
  id?: Maybe<Scalars['Int']>;
  measurementInfo?: Maybe<MeasurementInfo>;
  usedFreeTrial?: Maybe<Scalars['Boolean']>;
};

export type OrganizationFee = {
  __typename?: 'OrganizationFee';
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  fees?: Maybe<Array<Maybe<Fee>>>;
  id: Scalars['String'];
  lastUpdated?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type OrganizationFeeInput = {
  description?: InputMaybe<Scalars['String']>;
  fees?: InputMaybe<Array<InputMaybe<FeeInput>>>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type OrganizationIndustryData = {
  __typename?: 'OrganizationIndustryData';
  industry?: Maybe<NaicsIndustries>;
  industryText?: Maybe<Scalars['String']>;
  subIndustry?: Maybe<NaicsIndustries>;
};

export type OrganizationInfoResponse = {
  __typename?: 'OrganizationInfoResponse';
  addresses?: Maybe<Array<Maybe<OrganizationAddress>>>;
  companyName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  emailAddresses?: Maybe<Array<Scalars['String']>>;
  employerId?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  legalName?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<Scalars['String']>>;
  webAddr?: Maybe<Scalars['String']>;
};

export type OrganizationLabel = {
  __typename?: 'OrganizationLabel';
  category?: Maybe<OrganizationLabelCategory>;
  decision?: Maybe<DecisionsTypes>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<OrganizationLabelName>;
};

export enum OrganizationLabelCategory {
  Compliance = 'Compliance',
  Fraud = 'Fraud',
  Policy = 'Policy'
}

export enum OrganizationLabelName {
  Abuse = 'Abuse',
  AdverseMedia = 'AdverseMedia',
  AllPass = 'AllPass',
  Ato = 'Ato',
  BadReputation = 'BadReputation',
  BlockEdd = 'BlockEdd',
  ChangedLegalInfo = 'ChangedLegalInfo',
  CompletedEdd = 'CompletedEdd',
  ComplianceReject = 'ComplianceReject',
  Consumer = 'Consumer',
  Duplicate = 'Duplicate',
  EddFailed = 'EddFailed',
  FinalisedMoneyLoss = 'FinalisedMoneyLoss',
  InaccurateLegalInfo = 'InaccurateLegalInfo',
  LegalInaccurate = 'LegalInaccurate',
  LegalPass = 'LegalPass',
  LegalReject = 'LegalReject',
  LocationNotSupported = 'LocationNotSupported',
  LossRisk = 'LossRisk',
  ManualReviewRequired = 'ManualReviewRequired',
  ManualReviewRequiredFraud = 'ManualReviewRequiredFraud',
  ManualReviewRequiredPolicy = 'ManualReviewRequiredPolicy',
  MdFraud = 'MdFraud',
  MissingCddDecision = 'MissingCddDecision',
  MissingOrganizationSanctionsResult = 'MissingOrganizationSanctionsResult',
  NotRequiredEdd = 'NotRequiredEdd',
  OtherEdd = 'OtherEdd',
  Pass = 'Pass',
  PendingSanctionsReview = 'PendingSanctionsReview',
  Permissible = 'Permissible',
  ProhibitLob = 'ProhibitLob',
  RequiredEdd = 'RequiredEdd',
  Restricted = 'Restricted',
  SanctionHit = 'SanctionHit',
  SanctionTrueHit = 'SanctionTrueHit',
  SanctionsCheckClear = 'SanctionsCheckClear',
  SanctionsDeterminationPendingUnableToCompleteReview = 'SanctionsDeterminationPendingUnableToCompleteReview',
  SilentVerificationLegalInaccurate = 'SilentVerificationLegalInaccurate',
  StolenData = 'StolenData',
  SuspectedProhibitedIndustry = 'SuspectedProhibitedIndustry',
  SuspectedReturningBad = 'SuspectedReturningBad',
  UboVerification = 'UboVerification',
  Unresponsive = 'Unresponsive',
  UnresponsiveEdd = 'UnresponsiveEdd',
  UnresponsiveUser = 'UnresponsiveUser'
}

export type OrganizationListItem = {
  __typename?: 'OrganizationListItem';
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastUpdated?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type OrganizationPartner = {
  __typename?: 'OrganizationPartner';
  companyName?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
};

export type OrganizationProducts = {
  __typename?: 'OrganizationProducts';
  organizationId?: Maybe<Scalars['Int']>;
  products?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type OrganizationProhibitedIndustriesData = {
  __typename?: 'OrganizationProhibitedIndustriesData';
  companyLegalNameSuspectedWords: Array<Scalars['String']>;
  companyNameSuspectedWords: Array<Scalars['String']>;
  industrySuspectedWords: Array<Scalars['String']>;
  isIndustrySuspected: Scalars['Boolean'];
  isNaicsIndustrySuspected: Scalars['Boolean'];
  isQbNaicsIndustrySuspected: Scalars['Boolean'];
};

export type OrganizationRiskInsights = {
  __typename?: 'OrganizationRiskInsights';
  decision_label?: Maybe<Scalars['String']>;
  error_code?: Maybe<Scalars['String']>;
  escalation_point_of_contact_if_needed?: Maybe<Scalars['String']>;
  final_message?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
};

export type OrganizationRiskInsightsResponse = {
  __typename?: 'OrganizationRiskInsightsResponse';
  data?: Maybe<OrganizationRiskInsights>;
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum OrganizationRuleDecision {
  accept = 'accept',
  block = 'block',
  blockCompliance = 'blockCompliance',
  blockRisk = 'blockRisk',
  reject = 'reject',
  undecided = 'undecided'
}

export enum OrganizationToBusinessOriginTypes {
  ArErpForm = 'ArErpForm',
  ExistingGetPaidVendor = 'ExistingGetPaidVendor',
  PublicForm = 'PublicForm',
  SalesForm = 'SalesForm',
  SalesGetPaidWizard = 'SalesGetPaidWizard',
  UnilateralAndEnrollment = 'UnilateralAndEnrollment'
}

export type OrganizationUltimateBeneficialOwner = {
  __typename?: 'OrganizationUltimateBeneficialOwner';
  address: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  createdAt: Scalars['DateTime'];
  dateOfBirth: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  financingApplicationBusinessDetails?: Maybe<FinancingApplicationBusinessDetails>;
  firstName: Scalars['String'];
  id: Scalars['Int'];
  jobTitle?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  organizationUltimateBeneficialOwnerTypes?: Maybe<Array<Maybe<OrganizationUltimateBeneficialOwnerType>>>;
  ownershipPercentage?: Maybe<Scalars['Int']>;
  partnerName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  taxId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  zipCode: Scalars['String'];
};

export type OrganizationUltimateBeneficialOwnerCount = {
  __typename?: 'OrganizationUltimateBeneficialOwnerCount';
  count?: Maybe<Scalars['Int']>;
};

export type OrganizationWithSubscriptionTier = {
  __typename?: 'OrganizationWithSubscriptionTier';
  OrganizationUltimateBeneficialOwners?: Maybe<Array<Maybe<OrganizationUltimateBeneficialOwner>>>;
  accountingFirms?: Maybe<Array<Maybe<AccountingFirm>>>;
  accountingPlatformOrganization?: Maybe<AccountingPlatformOrganization>;
  accountingSoftware?: Maybe<Scalars['String']>;
  accounts?: Maybe<Array<Maybe<Account>>>;
  achRefunds?: Maybe<Array<Maybe<AchRefund>>>;
  actionLogs?: Maybe<Array<Maybe<ActionLog>>>;
  addedDeliveryMethod: Scalars['Boolean'];
  addedFunding: Scalars['Boolean'];
  addressLat?: Maybe<Scalars['String']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressLng?: Maybe<Scalars['String']>;
  annualRevenue?: Maybe<Scalars['Int']>;
  approvalWorkflows?: Maybe<Array<Maybe<ApprovalWorkflow>>>;
  aptNumber?: Maybe<Scalars['String']>;
  billingItems?: Maybe<Array<Maybe<BillingItem>>>;
  billingSettings?: Maybe<BillingSettings>;
  bills?: Maybe<Array<Maybe<Bill>>>;
  billsCount?: Maybe<Scalars['Int']>;
  businessDirectoryId?: Maybe<Scalars['String']>;
  businessType?: Maybe<Scalars['String']>;
  capitalOsAccount?: Maybe<CapitalOsAccounts>;
  cardholders?: Maybe<Array<Maybe<Cardholder>>>;
  ces?: Maybe<OrganizationCes>;
  chargebacks?: Maybe<Array<Maybe<Scalars['SequelizeJSON']>>>;
  city?: Maybe<Scalars['String']>;
  clientRoleFirmClients?: Maybe<Array<Maybe<FirmClient>>>;
  clients?: Maybe<Array<Maybe<Organization>>>;
  collectCompletionDaysOverride?: Maybe<Scalars['Int']>;
  companyDescription?: Maybe<Scalars['String']>;
  companyEmail?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyType?: Maybe<OrganizationcompanyTypeEnumType>;
  companyWebsite?: Maybe<Scalars['String']>;
  complianceGoodStandingVerification?: Maybe<ComplianceGoodStandingVerification>;
  connectedCards?: Maybe<Array<Maybe<ConnectedCard>>>;
  contactFirstName?: Maybe<Scalars['String']>;
  contactLastName?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  contacts?: Maybe<Array<Maybe<Contact>>>;
  countryCode?: Maybe<OrganizationcountryCodeEnumType>;
  createOrigin?: Maybe<OrganizationcreateOriginEnumType>;
  createdAt: Scalars['DateTime'];
  createdBill: Scalars['Boolean'];
  createdByPartner?: Maybe<Partner>;
  createdByPartnerId?: Maybe<Scalars['Int']>;
  crr?: Maybe<Crr>;
  customerSegment?: Maybe<Scalars['String']>;
  deferredDelivery?: Maybe<Scalars['SequelizeJSON']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  eBills?: Maybe<Array<Maybe<EBill>>>;
  ekata?: Maybe<Scalars['SequelizeJSON']>;
  emailVerified: Scalars['Boolean'];
  emailageOrg?: Maybe<Scalars['SequelizeJSON']>;
  enigmaAddressVerification?: Maybe<AddressVerification>;
  expenseManagementOnboardingStatus?: Maybe<Scalars['Boolean']>;
  expenses?: Maybe<Array<Maybe<Expense>>>;
  features?: Maybe<Scalars['SequelizeJSON']>;
  files?: Maybe<Array<Maybe<File>>>;
  firmRoleFirmClients?: Maybe<Array<Maybe<FirmClient>>>;
  firms?: Maybe<Array<Maybe<Organization>>>;
  firstTimePay: Scalars['Boolean'];
  formattedAddress?: Maybe<Scalars['String']>;
  fundingSources?: Maybe<Array<Maybe<FundingSource>>>;
  googlePlaceId?: Maybe<Scalars['String']>;
  guestPayorOrganizationMetadata?: Maybe<GuestPayorOrganizationMetadata>;
  id: Scalars['Int'];
  inboxEmailAddresses?: Maybe<Array<Maybe<InboxEmailAddress>>>;
  industry?: Maybe<Industry>;
  industryId?: Maybe<Scalars['Int']>;
  industrySource?: Maybe<OrganizationindustrySourceEnumType>;
  intuitCompanyAccountType?: Maybe<Scalars['String']>;
  intuitLastFullUpdate?: Maybe<Scalars['DateTime']>;
  intuitRealmId?: Maybe<Scalars['String']>;
  invitations?: Maybe<Array<Maybe<Invitation>>>;
  isApiPartner?: Maybe<Scalars['Boolean']>;
  isBusinessEmail: Scalars['Boolean'];
  isEmailageEnriched?: Maybe<Scalars['Boolean']>;
  isMelioMe?: Maybe<Scalars['Boolean']>;
  isMelioMeOrg: Scalars['Boolean'];
  isMicroDepositEligible?: Maybe<Scalars['Boolean']>;
  isMicroDepositEligibleConfidence?: Maybe<Scalars['String']>;
  isMicroDepositEligibleOverridden?: Maybe<Scalars['Boolean']>;
  isOrgLinked?: Maybe<Scalars['Boolean']>;
  isPlaidEnriched?: Maybe<Scalars['Boolean']>;
  isWhitePagesEnriched?: Maybe<Scalars['Boolean']>;
  joinOrganizationRequests?: Maybe<Array<Maybe<JoinOrganizationRequest>>>;
  jurisdictionStateOfIncorporation?: Maybe<Array<Maybe<Scalars['String']>>>;
  kyb?: Maybe<OrganizationkybEnumType>;
  kybConfidence?: Maybe<Scalars['Int']>;
  kybInConfidence?: Maybe<Scalars['Int']>;
  kybMoneyIn?: Maybe<OrganizationkybMoneyInEnumType>;
  kybMoneyInSubType?: Maybe<OrganizationkybMoneyInSubTypeEnumType>;
  kybStatus?: Maybe<OrganizationkybStatusEnumType>;
  kybSubType?: Maybe<OrganizationkybSubTypeEnumType>;
  lastPayDate?: Maybe<Scalars['DateTime']>;
  legalAddressLat?: Maybe<Scalars['String']>;
  legalAddressLine1?: Maybe<Scalars['String']>;
  legalAddressLine2?: Maybe<Scalars['String']>;
  legalAddressLng?: Maybe<Scalars['String']>;
  legalAptNumber?: Maybe<Scalars['String']>;
  legalCity?: Maybe<Scalars['String']>;
  legalCompanyName?: Maybe<Scalars['String']>;
  legalCountryCode?: Maybe<OrganizationlegalCountryCodeEnumType>;
  legalDateOfBirth?: Maybe<Scalars['DateTime']>;
  legalFormattedAddress?: Maybe<Scalars['String']>;
  legalGooglePlaceId?: Maybe<Scalars['String']>;
  legalState?: Maybe<Scalars['String']>;
  legalZipCode?: Maybe<Scalars['String']>;
  linkedAccountingSoftware: Scalars['Boolean'];
  linking?: Maybe<Array<Maybe<OrgLinking>>>;
  logo?: Maybe<File>;
  logoId?: Maybe<Scalars['Int']>;
  melioDbCases?: Maybe<Array<Maybe<Scalars['SequelizeJSON']>>>;
  mql?: Maybe<OrganizationmqlEnumType>;
  mqlConfidence?: Maybe<Scalars['String']>;
  mqlManual?: Maybe<Scalars['Boolean']>;
  notificationPreferences?: Maybe<Array<Maybe<NotificationPreference>>>;
  ode?: Maybe<OrganizationDecisionFull>;
  orgFees?: Maybe<Array<Maybe<Scalars['SequelizeJSON']>>>;
  organizationBranding?: Maybe<OrganizationBranding>;
  organizationKybActions?: Maybe<Array<Maybe<OrganizationKybAction>>>;
  organizationNaicsIndustries?: Maybe<OrganizationIndustryData>;
  organizationPreferences?: Maybe<Array<Maybe<OrganizationPreference>>>;
  organizationSyncData?: Maybe<AccountingPlatformOrganization>;
  ownedVendors?: Maybe<Array<Maybe<Vendor>>>;
  owner?: Maybe<User>;
  owningOrganizationProhibitedIndustriesData?: Maybe<OrganizationProhibitedIndustriesData>;
  partner?: Maybe<OrganizationPartner>;
  partnerIntegrationId?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  paymentRequests?: Maybe<Array<Maybe<PaymentRequest>>>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  paymentsCount?: Maybe<Scalars['Int']>;
  pendingApprovalPayments?: Maybe<Array<Maybe<Payment>>>;
  phone?: Maybe<Scalars['String']>;
  plaidItems?: Maybe<Array<Maybe<PlaidItem>>>;
  prohibitedIndustriesData?: Maybe<OrganizationProhibitedIndustriesData>;
  promotions?: Maybe<Array<Maybe<Promotion>>>;
  quickbooksDesktopCompany?: Maybe<QuickbooksDesktopCompany>;
  recurringBills?: Maybe<Array<Maybe<RecurringBill>>>;
  shopifyShop?: Maybe<ShopifyShop>;
  state?: Maybe<Scalars['String']>;
  subIndustry?: Maybe<SubIndustry>;
  subIndustryId?: Maybe<Scalars['Int']>;
  subscriptionDetails?: Maybe<SubscriptionDetails>;
  subscriptionTier?: Maybe<Scalars['String']>;
  subscriptions?: Maybe<Array<Maybe<BillSubscription>>>;
  syncActivity?: Maybe<Array<Maybe<OrganizationSyncActivity>>>;
  syncData?: Maybe<SyncDataType>;
  syncExternalFailedObjects?: Maybe<Array<Maybe<SyncExternalFailedObject>>>;
  syncMetadata?: Maybe<Array<Maybe<OrganizationSyncMetadata>>>;
  tags?: Maybe<Array<Maybe<EntityTag>>>;
  taxId?: Maybe<Scalars['String']>;
  taxIdLast4Digits?: Maybe<Scalars['String']>;
  taxIdType?: Maybe<OrganizationtaxIdTypeEnumType>;
  taxVerification?: Maybe<TaxVerification>;
  transactions?: Maybe<Array<Maybe<Transaction>>>;
  updatedAt: Scalars['DateTime'];
  userOrganizations?: Maybe<Array<Maybe<UserOrganization>>>;
  userQuickbooksCredentials?: Maybe<Array<Maybe<UserQuickbooksCredential>>>;
  users?: Maybe<Array<Maybe<User>>>;
  vendorPaymentLinks?: Maybe<Array<Maybe<VendorPaymentLink>>>;
  vendors?: Maybe<Array<Maybe<Vendor>>>;
  vendorsCount?: Maybe<Scalars['Int']>;
  wiseProfileRestriction?: Maybe<WiseProfileRestriction>;
  yearOfIncorporation?: Maybe<Scalars['Int']>;
  zipCode?: Maybe<Scalars['String']>;
};


export type OrganizationWithSubscriptionTierBillsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type OrganizationWithSubscriptionTierBillsCountArgs = {
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type OrganizationWithSubscriptionTierCardholdersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type OrganizationWithSubscriptionTierConnectedCardsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type OrganizationWithSubscriptionTierExpensesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type OrganizationWithSubscriptionTierFundingSourcesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type OrganizationWithSubscriptionTierPaymentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type OrganizationWithSubscriptionTierPaymentsCountArgs = {
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type OrganizationWithSubscriptionTierVendorsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type OrganizationWithSubscriptionTierVendorsCountArgs = {
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};

export enum OrganizationkybMoneyInEnumType {
  accept = 'accept',
  approveAll = 'approveAll',
  policy = 'policy',
  reject = 'reject',
  undecided = 'undecided'
}

export enum OrganizationkybMoneyInSubTypeEnumType {
  abuse = 'abuse',
  becameAbusive = 'becameAbusive',
  compromised = 'compromised',
  consumer = 'consumer',
  duplicate = 'duplicate',
  finalisedMoneyLoss = 'finalisedMoneyLoss',
  fraud = 'fraud',
  inaccurateLegalInfo = 'inaccurateLegalInfo',
  lossRisk = 'lossRisk',
  other = 'other',
  prohibitedLOB = 'prohibitedLOB',
  reinstated = 'reinstated',
  sensitive = 'sensitive',
  standard = 'standard',
  tentative = 'tentative',
  unresponsiveUser = 'unresponsiveUser'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PaginatedVendors = {
  __typename?: 'PaginatedVendors';
  currentPage?: Maybe<Scalars['Int']>;
  data?: Maybe<Array<Vendor>>;
  pageSize?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  currentPage: Scalars['Int'];
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  itemCount?: Maybe<Scalars['Int']>;
  pageCount?: Maybe<Scalars['Int']>;
  perPage: Scalars['Int'];
};

export type PartialAccount = {
  __typename?: 'PartialAccount';
  name?: Maybe<Scalars['String']>;
};

export type PartialTag = {
  __typename?: 'PartialTag';
  id: Scalars['String'];
  name: Scalars['String'];
  source?: Maybe<Scalars['String']>;
};

export type PartialVendor = {
  __typename?: 'PartialVendor';
  vendorName: Scalars['String'];
};

export type PartnerAccount = {
  __typename?: 'PartnerAccount';
  balance?: Maybe<Scalars['Float']>;
  typeName?: Maybe<PartnerPaymentAccountTypeName>;
};

export type PartnerFee = {
  __typename?: 'PartnerFee';
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  fees?: Maybe<Array<Maybe<Fee>>>;
  id: Scalars['String'];
  lastUpdated?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type PartnerFeeInput = {
  description?: InputMaybe<Scalars['String']>;
  fees?: InputMaybe<Array<InputMaybe<FeeInput>>>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type PartnerListItem = {
  __typename?: 'PartnerListItem';
  catalogId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastUpdated?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export enum PartnerPaymentAccountTypeName {
  ShopifyBalance = 'ShopifyBalance'
}

export enum PathFinderActionEntity {
  ORGANIZATION = 'ORGANIZATION',
  PAYMENT = 'PAYMENT',
  USER = 'USER',
  VENDOR = 'VENDOR'
}

export type PathFinderActionsEligibilityResponse = {
  __typename?: 'PathFinderActionsEligibilityResponse';
  entityActions: Scalars['JSON'];
  globalActions?: Maybe<Array<Maybe<EntityActionConfig>>>;
};

export type PathFinderActionsResponse = {
  __typename?: 'PathFinderActionsResponse';
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type PathFinderActionsResponseWithFile = {
  __typename?: 'PathFinderActionsResponseWithFile';
  /** Optional file data for downloadable content */
  fileData?: Maybe<FileData>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type PathFinderExportFileData = {
  __typename?: 'PathFinderExportFileData';
  content: Scalars['String'];
  contentType: Scalars['String'];
  fileName: Scalars['String'];
};

export type PathFinderExportFileResponse = {
  __typename?: 'PathFinderExportFileResponse';
  data?: Maybe<PathFinderExportFileData>;
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type PathFinderFileData = {
  __typename?: 'PathFinderFileData';
  content: Scalars['String'];
  contentType: Scalars['String'];
  fileName: Scalars['String'];
  paymentId: Scalars['Int'];
};

export type PathFinderFileResponse = {
  __typename?: 'PathFinderFileResponse';
  data?: Maybe<PathFinderFileData>;
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type PathFinderPayoutInfoResponse = {
  __typename?: 'PathFinderPayoutInfoResponse';
  data?: Maybe<PayoutInfoData>;
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type PayeeAccountNetwork = {
  __typename?: 'PayeeAccountNetwork';
  name?: Maybe<Scalars['String']>;
  status?: Maybe<PayeeAccountNetworkStatus>;
};

export enum PayeeAccountNetworkStatus {
  approved = 'approved',
  declined = 'declined',
  pending = 'pending'
}

export enum PayeeAccountType {
  aba = 'aba',
  australian = 'australian',
  brazil_business = 'brazil_business',
  canadian = 'canadian',
  chile = 'chile',
  chinese_local_business = 'chinese_local_business',
  czech = 'czech',
  emirates = 'emirates',
  hongkong = 'hongkong',
  hungarian = 'hungarian',
  iban = 'iban',
  indian = 'indian',
  israeli_local = 'israeli_local',
  japanese = 'japanese',
  kenya_local = 'kenya_local',
  mexican = 'mexican',
  newzealand = 'newzealand',
  nigerian = 'nigerian',
  philippines = 'philippines',
  polish = 'polish',
  singapore = 'singapore',
  sort_code = 'sort_code',
  south_korean_paygate_business = 'south_korean_paygate_business',
  southafrica = 'southafrica',
  swift_code = 'swift_code',
  thailand = 'thailand',
  vietname_earthport = 'vietname_earthport'
}

export type PayingOrganizationType = {
  __typename?: 'PayingOrganizationType';
  fundingSource?: Maybe<Array<Maybe<FundingSource>>>;
  hasFundingSource?: Maybe<Scalars['Boolean']>;
  organizationId?: Maybe<Scalars['Int']>;
};

export type PaymentAccessPayload = {
  __typename?: 'PaymentAccessPayload';
  orgId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

export type PaymentAccessResponse = {
  __typename?: 'PaymentAccessResponse';
  otherMatch?: Maybe<Scalars['Boolean']>;
  payload?: Maybe<PaymentAccessPayload>;
  paymentNotFound?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
};

export enum PaymentApprovalResult {
  Approved = 'Approved',
  Declined = 'Declined',
  Pending = 'Pending'
}

export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  deliveryEta?: Maybe<Scalars['Date']>;
  isDeliveryLate?: Maybe<Scalars['Boolean']>;
  scheduledDate?: Maybe<Scalars['Date']>;
};

export type PaymentDetailsResponse = {
  __typename?: 'PaymentDetailsResponse';
  data?: Maybe<PaymentDetails>;
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type PaymentEligibilityResponse = {
  __typename?: 'PaymentEligibilityResponse';
  error?: Maybe<Scalars['String']>;
  refundEligible?: Maybe<Scalars['Boolean']>;
  retryEligible?: Maybe<Scalars['Boolean']>;
  success: Scalars['Boolean'];
};

export type PaymentFastDecision = {
  __typename?: 'PaymentFastDecision';
  createdAt?: Maybe<Scalars['String']>;
  decision?: Maybe<Scalars['String']>;
  deliveryMethodId?: Maybe<Scalars['Int']>;
  eligibilityType?: Maybe<Scalars['String']>;
  featuresResult?: Maybe<Scalars['SequelizeJSON']>;
  fundingSourceId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  modelVersion?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  paymentAmount?: Maybe<Scalars['Int']>;
  paymentId?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  rulesResult?: Maybe<Scalars['SequelizeJSON']>;
  side?: Maybe<Scalars['String']>;
  trigger?: Maybe<Scalars['String']>;
};

export type PaymentFeeDetail = {
  __typename?: 'PaymentFeeDetail';
  actor: FeeActor;
  amount: Scalars['Float'];
  feePaymentId?: Maybe<Scalars['Int']>;
  labelKey?: Maybe<FeeLabelKey>;
};

export type PaymentIdByExternalIdResponse = {
  __typename?: 'PaymentIdByExternalIdResponse';
  paymentId?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type PaymentProhibitedIndustriesData = {
  __typename?: 'PaymentProhibitedIndustriesData';
  noteSuspectedWords: Array<Scalars['String']>;
  purposeSuspectedWords: Array<Scalars['String']>;
};

export type PaymentRiskInsights = {
  __typename?: 'PaymentRiskInsights';
  help_center_link?: Maybe<Scalars['String']>;
  last_decision?: Maybe<Scalars['String']>;
  last_decision_category?: Maybe<Scalars['String']>;
  macro?: Maybe<Scalars['String']>;
  message_for_cx?: Maybe<Scalars['String']>;
  org_company_name?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['Int']>;
  payment_amount?: Maybe<Scalars['String']>;
  payment_id?: Maybe<Scalars['Int']>;
  payment_status?: Maybe<PaymentriskStatusEnumType>;
  terms_of_service_link?: Maybe<Scalars['String']>;
  vendor_company_name?: Maybe<Scalars['String']>;
};

export type PaymentRiskInsightsResponse = {
  __typename?: 'PaymentRiskInsightsResponse';
  data?: Maybe<PaymentRiskInsights>;
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type PaymentTimeline = {
  __typename?: 'PaymentTimeline';
  isCreated?: Maybe<Scalars['Boolean']>;
  paymentStatus?: Maybe<PaymentstatusEnumType>;
};

export enum PaymentTimelineEntity {
  ACH_LOSS = 'ACH_LOSS',
  ACTION_LOG = 'ACTION_LOG',
  CHARGEBACK = 'CHARGEBACK',
  DM = 'DM',
  FS = 'FS',
  INTERVENTION = 'INTERVENTION',
  PAYMENT = 'PAYMENT',
  RISK = 'RISK'
}

export type PaymentViewData = {
  __typename?: 'PaymentViewData';
  amountUsd?: Maybe<Scalars['Float']>;
  applicationPaymentStatus?: Maybe<Scalars['String']>;
  balance?: Maybe<Scalars['Float']>;
  createdById?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  deliveryPreference?: Maybe<PaymentDeliveryPreferenceEnum>;
  expeditedBy?: Maybe<ExpeditedByEnum>;
  fundingSource?: Maybe<FundingSource>;
  fundingSourceId?: Maybe<Scalars['Int']>;
  invoiceNumbers?: Maybe<Array<Maybe<Scalars['String']>>>;
  markedAsPaid?: Maybe<Scalars['Boolean']>;
  organizationId?: Maybe<Scalars['Int']>;
  paymentCreatedAt?: Maybe<Scalars['Date']>;
  paymentId?: Maybe<Scalars['Int']>;
  paymentType?: Maybe<TypePaymentEnum>;
  payorCompanyName?: Maybe<Scalars['String']>;
  product?: Maybe<ProductEnumTc>;
  rails?: Maybe<RailsTypeEnum>;
  recurringOccurrenceInfo?: Maybe<RecurringOccurrenceInfo>;
  riskStatus?: Maybe<PaymentriskStatusEnumType>;
  scheduleDate?: Maybe<Scalars['Date']>;
  status?: Maybe<PaymentstatusEnumType>;
  vendorName?: Maybe<Scalars['String']>;
};

export enum PaymentriskStatusEnumType {
  approved = 'approved',
  declined = 'declined',
  pending = 'pending'
}

export enum PaymentsDbDeliveryPreference {
  draft_check = 'draft_check',
  expedited_ach = 'expedited_ach',
  express_card = 'express_card',
  express_check = 'express_check',
  express_domestic_wire = 'express_domestic_wire',
  fast_international = 'fast_international',
  fast_vc = 'fast_vc',
  internal_express_check = 'internal_express_check',
  overnight_ach = 'overnight_ach',
  overnight_check = 'overnight_check',
  rtp = 'rtp'
}

export enum PaymentsDbLedgerEntryType {
  credit = 'credit',
  debit = 'debit'
}

export enum PaymentsDbOurAccount {
  currency_cloud = 'currency_cloud',
  evolve = 'evolve',
  jpm = 'jpm',
  none = 'none',
  svb = 'svb',
  wise = 'wise'
}

export enum PaymentsDbProvider {
  chase = 'chase',
  currency_cloud = 'currency_cloud',
  fiserv = 'fiserv',
  flex = 'flex',
  svb = 'svb',
  tabapay = 'tabapay',
  wise = 'wise'
}

export enum PaymentsDbRail {
  capital_one = 'capital_one',
  currency_cloud = 'currency_cloud',
  fiserv_checkfree_next = 'fiserv_checkfree_next',
  fiserv_smb = 'fiserv_smb',
  fiserv_smb_ar = 'fiserv_smb_ar',
  melio = 'melio',
  paypal = 'paypal',
  wise = 'wise'
}

export enum PaymentsDbTargetAccountType {
  deliver_method = 'deliver_method',
  delivery_account = 'delivery_account',
  financing_provider = 'financing_provider',
  funding_account = 'funding_account',
  funding_source = 'funding_source',
  our_account = 'our_account'
}

export type PaymentsDbTransfer = {
  __typename?: 'PaymentsDBTransfer';
  acknowledgedDate?: Maybe<Scalars['Date']>;
  acknowledgedSourceLink?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  amountRule?: Maybe<Scalars['String']>;
  blocked?: Maybe<Scalars['Boolean']>;
  cancelTransferId?: Maybe<Scalars['String']>;
  clearedDate?: Maybe<Scalars['Date']>;
  clearedSourceLink?: Maybe<Scalars['String']>;
  committedDate?: Maybe<Scalars['Date']>;
  createdAt?: Maybe<Scalars['Date']>;
  currency?: Maybe<Scalars['String']>;
  currencyRule?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['Date']>;
  effectiveDate?: Maybe<Scalars['Date']>;
  errorCode?: Maybe<Scalars['String']>;
  errorReason?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  failedDate?: Maybe<Scalars['Date']>;
  failedSourceLink?: Maybe<Scalars['String']>;
  failureData?: Maybe<Scalars['JSON']>;
  fallbackTransferId?: Maybe<Scalars['String']>;
  flow?: Maybe<PaymentsDbTransferFlow>;
  id?: Maybe<Scalars['String']>;
  idempotentId?: Maybe<Scalars['String']>;
  installmentNumber?: Maybe<Scalars['Int']>;
  issueDate?: Maybe<Scalars['Date']>;
  ledgerEntryType?: Maybe<PaymentsDbLedgerEntryType>;
  methodTypePreference?: Maybe<PaymentsDbDeliveryPreference>;
  nextFeeTransferId?: Maybe<Scalars['String']>;
  nextTransferId?: Maybe<Scalars['String']>;
  ourAccount?: Maybe<PaymentsDbOurAccount>;
  ourAccountRule?: Maybe<Scalars['String']>;
  ourAccountType?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  parentIntegrationId?: Maybe<Scalars['String']>;
  payment?: Maybe<PaymentsDbTransferPayment>;
  paymentId?: Maybe<Scalars['String']>;
  paymentMethodType?: Maybe<PaymentsDbTransferPaymentMethodType>;
  paymentMethodTypeRule?: Maybe<Scalars['String']>;
  proofOfPayment?: Maybe<Scalars['String']>;
  provider?: Maybe<PaymentsDbProvider>;
  providerRule?: Maybe<Scalars['String']>;
  rail?: Maybe<PaymentsDbRail>;
  sentDate?: Maybe<Scalars['Date']>;
  sentSourceLink?: Maybe<Scalars['String']>;
  settledDate?: Maybe<Scalars['Date']>;
  settledSourceLink?: Maybe<Scalars['String']>;
  status?: Maybe<PaymentsDbTransferStatus>;
  supportId?: Maybe<Scalars['String']>;
  targetAccountId?: Maybe<Scalars['String']>;
  targetAccountType?: Maybe<PaymentsDbTargetAccountType>;
  transferEventLog?: Maybe<Array<Maybe<PaymentsDbTransferEventLog>>>;
  transferType?: Maybe<PaymentsDbTransferType>;
  type?: Maybe<PaymentsDbTransferType>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type PaymentsDbTransferEventLog = {
  __typename?: 'PaymentsDBTransferEventLog';
  id?: Maybe<Scalars['String']>;
  rawData?: Maybe<Scalars['JSON']>;
  status?: Maybe<PaymentsDbTransferStatus>;
};

export enum PaymentsDbTransferFlow {
  balancing = 'balancing',
  cancel_collect = 'cancel_collect',
  cancel_deliver = 'cancel_deliver',
  collect = 'collect',
  deliver = 'deliver'
}

export type PaymentsDbTransferPayment = {
  __typename?: 'PaymentsDBTransferPayment';
  externalId?: Maybe<Scalars['String']>;
};

export enum PaymentsDbTransferPaymentMethodType {
  ach = 'ach',
  balance = 'balance',
  biller_directory = 'biller_directory',
  card = 'card',
  check = 'check',
  credit_line = 'credit_line',
  crypto_usd = 'crypto_usd',
  domestic_wire = 'domestic_wire',
  international = 'international',
  international_wire = 'international_wire',
  managed = 'managed',
  rpps = 'rpps',
  rtp = 'rtp',
  undetermined = 'undetermined',
  venmo = 'venmo',
  virtual = 'virtual',
  virtual_card = 'virtual_card',
  wire = 'wire'
}

export enum PaymentsDbTransferStatus {
  acknowledged = 'acknowledged',
  cleared = 'cleared',
  committed = 'committed',
  failed = 'failed',
  scheduled = 'scheduled',
  sent = 'sent',
  settled = 'settled'
}

export enum PaymentsDbTransferType {
  fee = 'fee',
  fee_refund = 'fee_refund',
  follower = 'follower',
  follower_fee = 'follower_fee',
  payment = 'payment'
}

export type PaymentsStatisticsObjectTc = {
  __typename?: 'PaymentsStatisticsObjectTC';
  failed?: Maybe<SupplierClusterPaymentsStatisticsFieldsObjectTc>;
  inProgress?: Maybe<SupplierClusterPaymentsStatisticsFieldsObjectTc>;
  scheduled?: Maybe<SupplierClusterPaymentsStatisticsFieldsObjectTc>;
};

export type PaymentsTableResult = {
  __typename?: 'PaymentsTableResult';
  hasNextPage: Scalars['Boolean'];
  items: Array<PaymentViewData>;
};

export enum PaymentstatusEnumType {
  blocked = 'blocked',
  completed = 'completed',
  failed = 'failed',
  inProgress = 'inProgress',
  scheduled = 'scheduled'
}

export type PayoutInfoData = {
  __typename?: 'PayoutInfoData';
  bankingPartnerName?: Maybe<Scalars['String']>;
  bankingPartnerReference?: Maybe<Scalars['String']>;
  deliveryMode?: Maybe<Scalars['String']>;
  mt103?: Maybe<Scalars['String']>;
  processorName?: Maybe<Scalars['String']>;
};

export type PendingPayments = {
  __typename?: 'PendingPayments';
  numberAttached?: Maybe<Scalars['Int']>;
  numberRFI?: Maybe<Scalars['Int']>;
  numberZendeskopenTickets?: Maybe<Scalars['Int']>;
};

export type PendingTasks = {
  __typename?: 'PendingTasks';
  total: Scalars['Int'];
};

export type PlanCycle = {
  __typename?: 'PlanCycle';
  basePrice?: Maybe<Scalars['Float']>;
  unitPrice?: Maybe<Scalars['Float']>;
};

export enum PlanCyclePeriod {
  Annual = 'Annual',
  Monthly = 'Monthly'
}

export type PlanCycles = {
  __typename?: 'PlanCycles';
  annual?: Maybe<PlanCycle>;
  monthly?: Maybe<PlanCycle>;
};

export type PlansType = {
  __typename?: 'PlansType';
  createdAt?: Maybe<Scalars['Date']>;
  cycles?: Maybe<PlanCycles>;
  excessStandardTransactionFee?: Maybe<Scalars['Float']>;
  features?: Maybe<SubscriptionFeatures>;
  id?: Maybe<Scalars['String']>;
  numberOfFreeTransactions?: Maybe<Scalars['Int']>;
  numberOfFreeUsers?: Maybe<Scalars['Int']>;
  partnerName?: Maybe<Scalars['String']>;
  tier?: Maybe<Tier>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type PreviewOrganizationSubscriptionResponseType = {
  __typename?: 'PreviewOrganizationSubscriptionResponseType';
  billing?: Maybe<PreviewSubscriptionBill>;
};

export type PreviewSubscriptionBill = {
  __typename?: 'PreviewSubscriptionBill';
  amount?: Maybe<Scalars['Float']>;
  amountWithoutTax?: Maybe<Scalars['Float']>;
  billingItems?: Maybe<Array<Maybe<PreviewSubscriptionBillingItem>>>;
  createdAt?: Maybe<Scalars['Date']>;
  discounts?: Maybe<Array<Maybe<SubscriptionDiscountType>>>;
  targetDate?: Maybe<Scalars['Date']>;
  taxAmount?: Maybe<Scalars['Float']>;
};

export type PreviewSubscriptionBillingItem = {
  __typename?: 'PreviewSubscriptionBillingItem';
  amount?: Maybe<Scalars['Float']>;
  amountWithoutTax?: Maybe<Scalars['Float']>;
  chargeDescription?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  isFreeTrial?: Maybe<Scalars['Boolean']>;
  measurementInfo?: Maybe<MeasurementInfo>;
  planId?: Maybe<Scalars['String']>;
  serviceEndDate?: Maybe<Scalars['Date']>;
  serviceStartDate?: Maybe<Scalars['Date']>;
  taxAmount?: Maybe<Scalars['Float']>;
};

export type PreviouslyDetectedPayment = {
  __typename?: 'PreviouslyDetectedPayment';
  paymentId: Scalars['Int'];
  tags: Array<Scalars['String']>;
};

export type PrincipalPayment = {
  __typename?: 'PrincipalPayment';
  actor: FeeActor;
  principalPaymentId: Scalars['Int'];
};

export enum ProductEnumTc {
  Payable = 'Payable',
  Receivable = 'Receivable'
}

export type Project = {
  __typename?: 'Project';
  _id: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  createdBy: Scalars['MongoID'];
  deletedAt?: Maybe<Scalars['Date']>;
  description: Scalars['String'];
  dueDate?: Maybe<Scalars['Date']>;
  fieldsToHide: Array<Maybe<EnumProjectFieldsToHide>>;
  name: Scalars['String'];
  numOfCompletedTasks?: Maybe<Scalars['Int']>;
  participants?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  startDate?: Maybe<Scalars['Date']>;
  status: EnumProjectStatus;
  totalTasks?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type ProjectPayment = {
  enrichment: Scalars['SequelizeJSON'];
  id: Scalars['Int'];
};

export enum ProjectStatus {
  Archived = 'Archived',
  Open = 'Open'
}

export type PromoCampaign = {
  __typename?: 'PromoCampaign';
  effectiveFrom?: Maybe<Scalars['String']>;
  effectiveTo?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type PromoCodeAdmin = {
  __typename?: 'PromoCodeAdmin';
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['String']>;
  discountPercentage: Scalars['Float'];
  externalProductRatePlanChargeId: Scalars['String'];
  externalProductRatePlanId: Scalars['String'];
  partnerName: Scalars['String'];
  updatedAt?: Maybe<Scalars['String']>;
};

export type PromoCodeType = {
  __typename?: 'PromoCodeType';
  code?: Maybe<Scalars['String']>;
  discountPercentage?: Maybe<Scalars['Float']>;
};

export type PromoDiscountRatePlan = {
  __typename?: 'PromoDiscountRatePlan';
  defaultBillingPeriod?: Maybe<Scalars['String']>;
  defaultDiscountPercentage?: Maybe<Scalars['Float']>;
  defaultEndDateCondition?: Maybe<Scalars['String']>;
  durationLabel?: Maybe<Scalars['String']>;
  externalProductRatePlanChargeId: Scalars['String'];
  externalProductRatePlanId: Scalars['String'];
  id: Scalars['String'];
  label: Scalars['String'];
};

export enum ProofOfPaymentType {
  Collect = 'Collect',
  Delivery = 'Delivery',
  DeliveryMissingPayment = 'DeliveryMissingPayment',
  Refund = 'Refund'
}

export enum ProtectedMutations {
  featureStrategyBuilderCloneRule = 'featureStrategyBuilderCloneRule',
  featureStrategyBuilderCompare = 'featureStrategyBuilderCompare',
  featureStrategyBuilderCreateRule = 'featureStrategyBuilderCreateRule',
  featureStrategyBuilderCreateShadowCandidateStrategy = 'featureStrategyBuilderCreateShadowCandidateStrategy',
  featureStrategyBuilderDeleteRule = 'featureStrategyBuilderDeleteRule',
  featureStrategyBuilderMigrateStrategiesAndRules = 'featureStrategyBuilderMigrateStrategiesAndRules',
  featureStrategyBuilderPushToLive = 'featureStrategyBuilderPushToLive',
  featureStrategyBuilderPushToShadow = 'featureStrategyBuilderPushToShadow',
  featureStrategyBuilderSimulateStrategy = 'featureStrategyBuilderSimulateStrategy',
  featureStrategyBuilderUpdateRule = 'featureStrategyBuilderUpdateRule',
  featureStrategyBuilderUpdateShadowCandidateStrategy = 'featureStrategyBuilderUpdateShadowCandidateStrategy',
  feesManagementCreateOrganizationWithFeeConfiguration = 'feesManagementCreateOrganizationWithFeeConfiguration',
  feesManagementCreatePartnerWithFeeConfiguration = 'feesManagementCreatePartnerWithFeeConfiguration',
  feesManagementCreatePromoCode = 'feesManagementCreatePromoCode',
  feesManagementDeletePartnerFee = 'feesManagementDeletePartnerFee',
  feesManagementUpdateOrganizationFees = 'feesManagementUpdateOrganizationFees',
  feesManagementUpdatePartnerFees = 'feesManagementUpdatePartnerFees',
  generalReadOnly = 'generalReadOnly',
  incidentManagementCalculateIncidentGroups = 'incidentManagementCalculateIncidentGroups',
  incidentManagementCreateIncident = 'incidentManagementCreateIncident',
  incidentManagementFinishIncident = 'incidentManagementFinishIncident',
  incidentManagementRunIncident = 'incidentManagementRunIncident',
  incidentManagementUpdateIncident = 'incidentManagementUpdateIncident',
  pathFinderAccountClosure = 'pathFinderAccountClosure',
  pathFinderAddComment = 'pathFinderAddComment',
  pathFinderAddTagToOrganization = 'pathFinderAddTagToOrganization',
  pathFinderAddTagToPayment = 'pathFinderAddTagToPayment',
  pathFinderAddTagToUser = 'pathFinderAddTagToUser',
  pathFinderAddUserToOrganization = 'pathFinderAddUserToOrganization',
  pathFinderAllowMicroDepositEligible = 'pathFinderAllowMicroDepositEligible',
  pathFinderBulkUpdateBankAccounts = 'pathFinderBulkUpdateBankAccounts',
  pathFinderCancelVirtualCard = 'pathFinderCancelVirtualCard',
  pathFinderChangeEmail = 'pathFinderChangeEmail',
  pathFinderChangePaymentStatus = 'pathFinderChangePaymentStatus',
  pathFinderDeleteComment = 'pathFinderDeleteComment',
  pathFinderDeleteDeliveryMethod = 'pathFinderDeleteDeliveryMethod',
  pathFinderDownloadInvoice = 'pathFinderDownloadInvoice',
  pathFinderDownloadLoi = 'pathFinderDownloadLoi',
  pathFinderDownloadPoaDocument = 'pathFinderDownloadPoaDocument',
  pathFinderEditUserRole = 'pathFinderEditUserRole',
  pathFinderExportPaymentsList = 'pathFinderExportPaymentsList',
  pathFinderGeneralRequestEscalation = 'pathFinderGeneralRequestEscalation',
  pathFinderGetFxPayoutInfo = 'pathFinderGetFxPayoutInfo',
  pathFinderGlobalOptOutPersistentFastPayment = 'pathFinderGlobalOptOutPersistentFastPayment',
  pathFinderHandoffToCk = 'pathFinderHandoffToCk',
  pathFinderLocalOptOutPersistentFastPayment = 'pathFinderLocalOptOutPersistentFastPayment',
  pathFinderOptOutOfSunlight = 'pathFinderOptOutOfSunlight',
  pathFinderProofOfPaymentEscalation = 'pathFinderProofOfPaymentEscalation',
  pathFinderRecalculatePaymentState = 'pathFinderRecalculatePaymentState',
  pathFinderRecollectOnFeeEscalation = 'pathFinderRecollectOnFeeEscalation',
  pathFinderRecordManualPayment = 'pathFinderRecordManualPayment',
  pathFinderRefund = 'pathFinderRefund',
  pathFinderRefundFeeEscalation = 'pathFinderRefundFeeEscalation',
  pathFinderRefundFeePayment = 'pathFinderRefundFeePayment',
  pathFinderRefundPaymentEscalation = 'pathFinderRefundPaymentEscalation',
  pathFinderReimbursementEscalation = 'pathFinderReimbursementEscalation',
  pathFinderRemoveTagFromOrganization = 'pathFinderRemoveTagFromOrganization',
  pathFinderRemoveTagFromUser = 'pathFinderRemoveTagFromUser',
  pathFinderRemoveUserFromOrganization = 'pathFinderRemoveUserFromOrganization',
  pathFinderRequestRefundApproval = 'pathFinderRequestRefundApproval',
  pathFinderResend2FaCode = 'pathFinderResend2FaCode',
  pathFinderResetMfaAttempts = 'pathFinderResetMfaAttempts',
  pathFinderRetryCollect = 'pathFinderRetryCollect',
  pathFinderRetryDelivery = 'pathFinderRetryDelivery',
  pathFinderRetryDeliveryEscalation = 'pathFinderRetryDeliveryEscalation',
  pathFinderRetryInstallmentEscalation = 'pathFinderRetryInstallmentEscalation',
  pathFinderSendAchDetailsRequest = 'pathFinderSendAchDetailsRequest',
  pathFinderStopPayment = 'pathFinderStopPayment',
  pathFinderStuckPaymentEscalation = 'pathFinderStuckPaymentEscalation',
  pathFinderUpdateFsOnCkPayment = 'pathFinderUpdateFsOnCkPayment',
  pathFinderUserDeletionRequest = 'pathFinderUserDeletionRequest',
  pathFinderVoidCheck = 'pathFinderVoidCheck',
  rubyCreateFlow = 'rubyCreateFlow',
  rubyDeleteFlow = 'rubyDeleteFlow',
  rubyManageFlowPermissions = 'rubyManageFlowPermissions',
  rubySaveStrategy = 'rubySaveStrategy',
  rubyUpdateFlow = 'rubyUpdateFlow',
  subscriptionAddPromoCodeToOrganizationSubscription = 'subscriptionAddPromoCodeToOrganizationSubscription',
  subscriptionAssignVipPlan = 'subscriptionAssignVipPlan',
  subscriptionCancelOrganizationSubscription = 'subscriptionCancelOrganizationSubscription',
  subscriptionCancelVipPlan = 'subscriptionCancelVipPlan',
  subscriptionDowngradeOrganizationSubscription = 'subscriptionDowngradeOrganizationSubscription',
  subscriptionRequestToAddT2Feature = 'subscriptionRequestToAddT2Feature',
  subscriptionUpdateOrganizationType = 'subscriptionUpdateOrganizationType',
  subscriptionUpgradeOrganizationSubscription = 'subscriptionUpgradeOrganizationSubscription'
}

export type Query = {
  __typename?: 'Query';
  OrganizationUltimateBeneficialOwner?: Maybe<Array<Maybe<OrganizationUltimateBeneficialOwner>>>;
  OrganizationUltimateBeneficialOwnerCount?: Maybe<OrganizationUltimateBeneficialOwnerCount>;
  ShadowCandidateStrategies?: Maybe<Array<Maybe<FeatureStrategy>>>;
  account?: Maybe<Array<Maybe<Account>>>;
  accountCompletedPaymentStats: AccountCompletedPaymentStats;
  accountCount?: Maybe<AccountCount>;
  accountCrr?: Maybe<CrrLatest>;
  accountDeliveryMethods?: Maybe<Array<Maybe<DeliveryMethod>>>;
  accountEntityStatistics: AccountEntityStatistics;
  accountFeatures?: Maybe<AccountFeatures>;
  accountFundingSources?: Maybe<Array<Maybe<FundingSource>>>;
  accountGeneralStatistics: AccountGeneralStatistics;
  accountIPs?: Maybe<Array<Maybe<Ip>>>;
  accountInfo?: Maybe<AccountInfo>;
  accountOde?: Maybe<OrganizationDecisionFull>;
  accountOrgLinking?: Maybe<OrgLinkingObj>;
  accountPayors?: Maybe<Array<Maybe<Organization>>>;
  accountStatistics?: Maybe<Statistics>;
  accountUsers?: Maybe<Array<Maybe<UserOrganization>>>;
  accountVendors?: Maybe<PaginatedVendors>;
  accountingPlatform?: Maybe<Array<Maybe<AccountingPlatform>>>;
  accountingPlatformCount?: Maybe<AccountingPlatformCount>;
  accountingPlatformEntity?: Maybe<Array<Maybe<AccountingPlatformEntity>>>;
  accountingPlatformEntityCount?: Maybe<AccountingPlatformEntityCount>;
  accountingPlatformOrganization?: Maybe<Array<Maybe<AccountingPlatformOrganization>>>;
  accountingPlatformOrganizationCount?: Maybe<AccountingPlatformOrganizationCount>;
  accountingPlatformOrganizationsMetadata?: Maybe<Array<Maybe<AccountingPlatformOrganizationsMetadata>>>;
  accountingPlatformOrganizationsMetadataCount?: Maybe<AccountingPlatformOrganizationsMetadataCount>;
  achRefund?: Maybe<Array<Maybe<AchRefund>>>;
  achRefundCount?: Maybe<AchRefundCount>;
  actionById?: Maybe<Action>;
  actionByIds: Array<Action>;
  actionConnection?: Maybe<ActionConnection>;
  actionCount?: Maybe<Scalars['Int']>;
  actionLogById?: Maybe<ActionLog>;
  actionLogByIds: Array<ActionLog>;
  actionLogConnection?: Maybe<ActionLogConnection>;
  actionLogCount?: Maybe<Scalars['Int']>;
  actionLogMany: Array<ActionLog>;
  actionLogOne?: Maybe<ActionLog>;
  actionLogPagination?: Maybe<ActionLogPagination>;
  actionMany: Array<Action>;
  actionOne?: Maybe<Action>;
  actionPagination?: Maybe<ActionPagination>;
  actionsNotSet?: Maybe<Scalars['JSON']>;
  /** Get list of available agents directly from gen-ai-gateway without AWS Bedrock enhancements */
  agentsList?: Maybe<Array<Maybe<Agent>>>;
  agreement?: Maybe<Array<Maybe<Agreement>>>;
  agreementCount?: Maybe<AgreementCount>;
  agreementSignature?: Maybe<Array<Maybe<AgreementSignature>>>;
  agreementSignatureCount?: Maybe<AgreementSignatureCount>;
  allCases?: Maybe<AllCasesEntityRecord>;
  allRelatedCompletedPayments?: Maybe<Scalars['Boolean']>;
  apiKey?: Maybe<Array<Maybe<ApiKey>>>;
  apiKeyCount?: Maybe<ApiKeyCount>;
  apiPartnerBrandings?: Maybe<Array<Maybe<ApiPartnerBrandings>>>;
  apiPartnerBrandingsCount?: Maybe<ApiPartnerBrandingsCount>;
  appleIdToUser?: Maybe<Array<Maybe<AppleIdToUser>>>;
  appleIdToUserCount?: Maybe<AppleIdToUserCount>;
  applicationPayment?: Maybe<Array<Maybe<ApplicationPayment>>>;
  applicationPaymentCount?: Maybe<ApplicationPaymentCount>;
  approvalDecision?: Maybe<Array<Maybe<ApprovalDecision>>>;
  approvalDecisionCount?: Maybe<ApprovalDecisionCount>;
  approvalWorkflow?: Maybe<Array<Maybe<ApprovalWorkflow>>>;
  approvalWorkflowCount?: Maybe<ApprovalWorkflowCount>;
  approvalWorkflowUser?: Maybe<Array<Maybe<ApprovalWorkflowUser>>>;
  approvalWorkflowUserCount?: Maybe<ApprovalWorkflowUserCount>;
  assets?: Maybe<Assets>;
  attachedFiles: Array<AttachedFile>;
  attachedFilesIndication: AttachedFileIndication;
  autoDebitContract?: Maybe<Array<Maybe<AutoDebitContract>>>;
  autoDebitContractCount?: Maybe<AutoDebitContractCount>;
  autoDebitPayorAuthorization?: Maybe<Array<Maybe<AutoDebitPayorAuthorization>>>;
  autoDebitPayorAuthorizationCount?: Maybe<AutoDebitPayorAuthorizationCount>;
  autoDebitRequest?: Maybe<Array<Maybe<AutoDebitRequest>>>;
  autoDebitRequestCount?: Maybe<AutoDebitRequestCount>;
  autoPayPolicy?: Maybe<Array<Maybe<AutoPayPolicy>>>;
  autoPayPolicyCount?: Maybe<AutoPayPolicyCount>;
  badAssetsLinking?: Maybe<BadAssetsLinkingResponse>;
  bankAccount?: Maybe<Array<Maybe<BankAccount>>>;
  bankAccountCount?: Maybe<BankAccountCount>;
  banksBlockedForPayment?: Maybe<Array<Maybe<BanksBlockedForPayment>>>;
  banksBlockedForPaymentCount?: Maybe<BanksBlockedForPaymentCount>;
  bill?: Maybe<Array<Maybe<Bill>>>;
  billCount?: Maybe<BillCount>;
  billLineItem?: Maybe<Array<Maybe<BillLineItem>>>;
  billLineItemCount?: Maybe<BillLineItemCount>;
  billLineItemLabel?: Maybe<Array<Maybe<BillLineItemLabel>>>;
  billLineItemLabelCount?: Maybe<BillLineItemLabelCount>;
  billLineItemsSyncMetadata?: Maybe<Array<Maybe<BillLineItemsSyncMetadata>>>;
  billLineItemsSyncMetadataCount?: Maybe<BillLineItemsSyncMetadataCount>;
  billNotification?: Maybe<Array<Maybe<BillNotification>>>;
  billNotificationCount?: Maybe<BillNotificationCount>;
  billPayment?: Maybe<Array<Maybe<BillPayment>>>;
  billPaymentCount?: Maybe<BillPaymentCount>;
  billSubscription?: Maybe<Array<Maybe<BillSubscription>>>;
  billSubscriptionCount?: Maybe<BillSubscriptionCount>;
  billSubscriptionOccurrence?: Maybe<Array<Maybe<BillSubscriptionOccurrence>>>;
  billSubscriptionOccurrenceCount?: Maybe<BillSubscriptionOccurrenceCount>;
  billSyncActivity?: Maybe<Array<Maybe<BillSyncActivity>>>;
  billSyncActivityCount?: Maybe<BillSyncActivityCount>;
  biller?: Maybe<Array<Maybe<Biller>>>;
  billerCount?: Maybe<BillerCount>;
  billingItem?: Maybe<Array<Maybe<BillingItem>>>;
  billingItemCount?: Maybe<BillingItemCount>;
  billingPermission?: Maybe<Array<Maybe<BillingPermission>>>;
  billingPermissionCount?: Maybe<BillingPermissionCount>;
  billingSettings?: Maybe<Array<Maybe<BillingSettings>>>;
  billingSettingsCount?: Maybe<BillingSettingsCount>;
  blockCreditToVendorConfiguration?: Maybe<Array<Maybe<BlockCreditToVendorConfiguration>>>;
  blockCreditToVendorConfigurationCount?: Maybe<BlockCreditToVendorConfigurationCount>;
  blockRules: Array<BlockRule>;
  bulkComments?: Maybe<Array<Maybe<BulkCommentsResponse>>>;
  busyTaskSourceType?: Maybe<Array<Maybe<BusyTaskSourceType>>>;
  capitalOsAccounts?: Maybe<Array<Maybe<CapitalOsAccounts>>>;
  capitalOsAccountsCount?: Maybe<CapitalOsAccountsCount>;
  cardAccount?: Maybe<Array<Maybe<CardAccount>>>;
  cardAccountCount?: Maybe<CardAccountCount>;
  cardAccountTabapayClient?: Maybe<Array<Maybe<CardAccountTabapayClient>>>;
  cardAccountTabapayClientCount?: Maybe<CardAccountTabapayClientCount>;
  catalogItem?: Maybe<Array<Maybe<CatalogItem>>>;
  catalogItemCount?: Maybe<CatalogItemCount>;
  ccBlockedBins?: Maybe<Array<Maybe<CcBlockedBins>>>;
  ccBlockedBinsCount?: Maybe<CcBlockedBinsCount>;
  charge?: Maybe<Array<Maybe<Charge>>>;
  chargeCount?: Maybe<ChargeCount>;
  chargebacks?: Maybe<ChargebackRecord>;
  checkTrack?: Maybe<Array<Maybe<CheckTrack>>>;
  checkTrackCount?: Maybe<CheckTrackCount>;
  checkout?: Maybe<Array<Maybe<Checkout>>>;
  checkoutCount?: Maybe<CheckoutCount>;
  clusterTpv?: Maybe<ClusterTpv>;
  codeEmailVerification?: Maybe<Array<Maybe<CodeEmailVerification>>>;
  codeEmailVerificationCount?: Maybe<CodeEmailVerificationCount>;
  comments?: Maybe<Array<Maybe<Comment>>>;
  concernAreaById?: Maybe<ConcernAreaSchema>;
  concernAreaByIds: Array<ConcernAreaSchema>;
  concernAreaMany: Array<ConcernAreaSchema>;
  concernAreaOne?: Maybe<ConcernAreaSchema>;
  consentedGuestFundingSource?: Maybe<Array<Maybe<ConsentedGuestFundingSource>>>;
  consentedGuestFundingSourceCount?: Maybe<ConsentedGuestFundingSourceCount>;
  contact?: Maybe<Array<Maybe<Contact>>>;
  contactCount?: Maybe<ContactCount>;
  /** Get a specific conversation by ID */
  conversation?: Maybe<Conversation>;
  /** Get list of all conversations */
  conversations?: Maybe<Array<Maybe<Conversation>>>;
  countVendorsTable?: Maybe<Scalars['Int']>;
  coupon?: Maybe<Array<Maybe<Coupon>>>;
  couponCount?: Maybe<CouponCount>;
  couponTemplate?: Maybe<Array<Maybe<CouponTemplate>>>;
  couponTemplateCount?: Maybe<CouponTemplateCount>;
  couponsMetadata?: Maybe<Array<Maybe<CouponsMetadata>>>;
  couponsMetadataCount?: Maybe<CouponsMetadataCount>;
  crrHistory?: Maybe<Array<Maybe<CrrHistory>>>;
  cryptoUSDAccount?: Maybe<Array<Maybe<CryptoUsdAccount>>>;
  cryptoUSDAccountCount?: Maybe<CryptoUsdAccountCount>;
  customerSyncActivity?: Maybe<Array<Maybe<CustomerSyncActivity>>>;
  customerSyncActivityCount?: Maybe<CustomerSyncActivityCount>;
  customersSyncMetadata?: Maybe<Array<Maybe<CustomersSyncMetadata>>>;
  customersSyncMetadataCount?: Maybe<CustomersSyncMetadataCount>;
  decisionCodes?: Maybe<DecisionCodes>;
  decryptByEntityId?: Maybe<Scalars['String']>;
  deletionRequest?: Maybe<Array<Maybe<DeletionRequest>>>;
  deletionRequestCount?: Maybe<DeletionRequestCount>;
  deletionRequestItem?: Maybe<Array<Maybe<DeletionRequestItem>>>;
  deletionRequestItemCount?: Maybe<DeletionRequestItemCount>;
  deliveryMethod?: Maybe<Array<Maybe<DeliveryMethod>>>;
  deliveryMethodCount?: Maybe<DeliveryMethodCount>;
  deliveryMethodFeeOnlyFundingSource?: Maybe<Array<Maybe<DeliveryMethodFeeOnlyFundingSource>>>;
  deliveryMethodFeeOnlyFundingSourceCount?: Maybe<DeliveryMethodFeeOnlyFundingSourceCount>;
  description?: Maybe<EscalationComment>;
  discount?: Maybe<Array<Maybe<Discount>>>;
  discountCount?: Maybe<DiscountCount>;
  documentRequests?: Maybe<DocumentRequest>;
  domesticWireAccount?: Maybe<Array<Maybe<DomesticWireAccount>>>;
  domesticWireAccountCount?: Maybe<DomesticWireAccountCount>;
  draftDeliveryMethod?: Maybe<Array<Maybe<DraftDeliveryMethod>>>;
  draftDeliveryMethodCount?: Maybe<DraftDeliveryMethodCount>;
  dynamicVariablesFields?: Maybe<Array<Maybe<FilterQueryField>>>;
  eBill?: Maybe<Array<Maybe<EBill>>>;
  eBillCount?: Maybe<EBillCount>;
  eBillLineItem?: Maybe<Array<Maybe<EBillLineItem>>>;
  eBillLineItemCount?: Maybe<EBillLineItemCount>;
  eBillSubscription?: Maybe<Array<Maybe<EBillSubscription>>>;
  eBillSubscriptionCount?: Maybe<EBillSubscriptionCount>;
  emailTemplate?: Maybe<Array<Maybe<EmailTemplate>>>;
  emailTemplateCount?: Maybe<EmailTemplateCount>;
  emailage?: Maybe<Scalars['JSON']>;
  emailageByEmailLatest?: Maybe<Scalars['JSON']>;
  emailageOrg?: Maybe<Scalars['JSON']>;
  entityMapping?: Maybe<Array<Maybe<EntityMapping>>>;
  entityMappingCount?: Maybe<EntityMappingCount>;
  externalPaymentLogicalIdMapping?: Maybe<Array<Maybe<ExternalPaymentLogicalIdMapping>>>;
  externalPaymentLogicalIdMappingCount?: Maybe<ExternalPaymentLogicalIdMappingCount>;
  failedEmails?: Maybe<Array<Maybe<FailedEmails>>>;
  failedEmailsCount?: Maybe<FailedEmailsCount>;
  failedPaymentsRetries?: Maybe<Array<Maybe<FailedPaymentsRetries>>>;
  failedPaymentsRetriesCount?: Maybe<FailedPaymentsRetriesCount>;
  fastAchConfiguration?: Maybe<Array<Maybe<FastAchConfiguration>>>;
  fastAchConfigurationCount?: Maybe<FastAchConfigurationCount>;
  featureStrategies?: Maybe<Array<Maybe<FeatureStrategy>>>;
  featureStrategy?: Maybe<FeatureStrategy>;
  feeCatalog?: Maybe<Array<Maybe<FeeCatalog>>>;
  feeCatalogCount?: Maybe<FeeCatalogCount>;
  /** Get list of available fee types */
  feeTypesList?: Maybe<Array<Scalars['String']>>;
  feedbackSubmission?: Maybe<Array<Maybe<FeedbackSubmission>>>;
  feedbackSubmissionCount?: Maybe<FeedbackSubmissionCount>;
  file?: Maybe<Array<Maybe<File>>>;
  fileBill?: Maybe<Array<Maybe<FileBill>>>;
  fileBillCount?: Maybe<FileBillCount>;
  fileCount?: Maybe<FileCount>;
  fileEBill?: Maybe<Array<Maybe<FileEBill>>>;
  fileEBillCount?: Maybe<FileEBillCount>;
  filePaymentRequest?: Maybe<Array<Maybe<FilePaymentRequest>>>;
  filePaymentRequestCount?: Maybe<FilePaymentRequestCount>;
  fileTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  fileUser?: Maybe<Array<Maybe<FileUser>>>;
  fileUserCount?: Maybe<FileUserCount>;
  filterQueryFields?: Maybe<Array<Maybe<FilterQueryField>>>;
  financingAccount?: Maybe<Array<Maybe<FinancingAccount>>>;
  financingAccountCount?: Maybe<FinancingAccountCount>;
  financingApplicationBusinessDetails?: Maybe<Array<Maybe<FinancingApplicationBusinessDetails>>>;
  financingApplicationBusinessDetailsCount?: Maybe<FinancingApplicationBusinessDetailsCount>;
  firmClient?: Maybe<Array<Maybe<FirmClient>>>;
  firmClientCount?: Maybe<FirmClientCount>;
  fiservCredential?: Maybe<Array<Maybe<FiservCredential>>>;
  fiservCredentialCount?: Maybe<FiservCredentialCount>;
  flexAccount?: Maybe<Array<Maybe<FlexAccount>>>;
  flexAccountCount?: Maybe<FlexAccountCount>;
  flow?: Maybe<UiFlow>;
  flowExecutionById?: Maybe<FlowExecution>;
  flowExecutionByIds: Array<FlowExecution>;
  flowExecutionCount?: Maybe<Scalars['Int']>;
  flowExecutionMany: Array<FlowExecution>;
  flowExecutionOne?: Maybe<FlowExecution>;
  flowPermissionByFlowId?: Maybe<FlowPermission>;
  flowPermissionMany: Array<FlowPermission>;
  flowUiById?: Maybe<UiFlow>;
  flowUiByIds: Array<UiFlow>;
  flowUiCount?: Maybe<Scalars['Int']>;
  flowUiHistory?: Maybe<Array<Maybe<UiFlow>>>;
  flowUiMany: Array<UiFlow>;
  flowUiOne?: Maybe<UiFlow>;
  fundingSource?: Maybe<Array<Maybe<FundingSource>>>;
  fundingSourceCount?: Maybe<FundingSourceCount>;
  gayaForm?: Maybe<GayaForm>;
  gayaFormById?: Maybe<GayaForm>;
  gayaFormByIds: Array<GayaForm>;
  gayaFormCount?: Maybe<Scalars['Int']>;
  gayaFormHistory?: Maybe<Array<Maybe<GayaForm>>>;
  gayaFormHistoryByVersion?: Maybe<GayaForm>;
  gayaFormMany: Array<GayaForm>;
  gayaFormOne?: Maybe<GayaForm>;
  gayaFormResponse?: Maybe<GayaFormResponse>;
  gayaFormResponseById?: Maybe<GayaFormResponse>;
  gayaFormResponseByIds: Array<GayaFormResponse>;
  gayaFormResponseCount?: Maybe<Scalars['Int']>;
  gayaFormResponseMany: Array<GayaFormResponse>;
  gayaFormResponseOne?: Maybe<GayaFormResponse>;
  gayaFormResponsePagination?: Maybe<GayaFormResponsePagination>;
  gayaTheme?: Maybe<GayaTheme>;
  gayaThemeById?: Maybe<GayaTheme>;
  gayaThemeByIds: Array<GayaTheme>;
  gayaThemeMany: Array<GayaTheme>;
  gayaThemeOne?: Maybe<GayaTheme>;
  gayaZendeskFormFields?: Maybe<Scalars['JSON']>;
  gayaZendeskForms?: Maybe<Scalars['JSON']>;
  genericTaskCount?: Maybe<Scalars['Int']>;
  genericTaskMany: Array<GenericTask>;
  genericTaskOne?: Maybe<GenericTask>;
  genericTaskPagination?: Maybe<GenericTaskPagination>;
  genericTaskTotalCount?: Maybe<TaskTotalCount>;
  getAccountingFirmsTiers?: Maybe<Array<Maybe<AccountingFirmTier>>>;
  /** Get response from the risk AI agent. */
  getAgentResponse?: Maybe<Array<Maybe<AgentResultResponse>>>;
  getAllProjects: Array<Project>;
  getAllTags?: Maybe<AllTags>;
  getAppliedLimitations: LimitationsResponse;
  getAtoCaseByPaymentId?: Maybe<AtoCase>;
  getAtoCasesByOrgId?: Maybe<Array<AtoCase>>;
  getAvailablePropertiesByEntity?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Get list of available risk agent names. */
  getAvailableRiskAgents: Array<Scalars['String']>;
  getAvailableTagsByEntity?: Maybe<Array<Maybe<Tag>>>;
  getBatchGroupsBaseData?: Maybe<Array<Maybe<IncidentBatchGroupsBaseDataType>>>;
  getBatchMonitorData?: Maybe<Array<Maybe<IncidentExecutionGroupsType>>>;
  getBillAttachments: Array<BillAttachment>;
  getBillsAutocomplete?: Maybe<Array<Maybe<Bill>>>;
  getBusinessById?: Maybe<BusinessType>;
  getCardholderById?: Maybe<Cardholder>;
  getCardholders?: Maybe<CardholdersResponse>;
  getCommunication?: Maybe<CommunicationDisplayType>;
  getCommunications?: Maybe<Array<Maybe<CommunicationRowType>>>;
  getCompletedPaymentsCountForIp?: Maybe<Scalars['Int']>;
  getConnectedCards?: Maybe<ConnectedCardsResponse>;
  getCurrentFraudReferralCases: Array<FraudReferralCase>;
  getDeliveryMethodsByPaymentId?: Maybe<DeliveryMethodsResponse>;
  getDeviceConsistencyData?: Maybe<DeviceConsistencyResponse>;
  /** Fetches all device features for multiple action IDs from Chalk device data. Returns a map of actionId to raw Chalk features. */
  getDeviceFeaturesByActionIds: Scalars['JSON'];
  getExpenseById?: Maybe<Expense>;
  getExpenseManagementOnboardingStatus?: Maybe<ExpenseManagementOnboardingStatus>;
  getExpenses?: Maybe<ExpensesResponse>;
  getFinancingPaymentData?: Maybe<FinancingPaymentDataResponse>;
  getFraudReferralCasesCountByOrgId: Scalars['Int'];
  getFundingSourcesByPaymentId?: Maybe<FundingSourcesResponse>;
  getGraph?: Maybe<Graph>;
  getIncidentExecutionsList?: Maybe<FlowExecutionPagination>;
  getLatestScore?: Maybe<Crr>;
  getLimitationInfo?: Maybe<Array<Maybe<LimitationInfo>>>;
  getLimitationLogs?: Maybe<LimitationActionLogResponse>;
  getMelioDBUserById: User;
  getMelioDBUsers?: Maybe<UserAndCount>;
  getOrganizationAllDecisionsAndLabels: Array<Maybe<OrganizationDecision>>;
  getOrganizationAllDecisionsCount: Scalars['Int'];
  getOrganizationCompanyNamesByVendorFilter?: Maybe<Array<Maybe<Scalars['String']>>>;
  getOrganizationLatestDecisionAndLabels?: Maybe<OrganizationDecisionFull>;
  getOrganizationPaymentFiles: Array<AttachedPaymentFile>;
  getOrganizationPaymentFilesCount?: Maybe<Scalars['Int']>;
  getOrganizationProductTags?: Maybe<Array<Maybe<OrganizationProducts>>>;
  getOrganizationRiskInsights?: Maybe<OrganizationRiskInsightsResponse>;
  getOrganizationTickets: Array<Maybe<ZendeskOrgTicket>>;
  getOrganizationsAutocomplete?: Maybe<Array<Maybe<OrganizationWithSubscriptionTier>>>;
  getPathFinderAvailableActions?: Maybe<PathFinderActionsEligibilityResponse>;
  getPaymentAccess?: Maybe<PaymentAccessResponse>;
  getPaymentBillAttachments?: Maybe<Array<Maybe<BillPayment>>>;
  getPaymentByOrganizationIdField?: Maybe<PaymentLocator>;
  getPaymentDataByUserId: TotalPaymentsByUserType;
  getPaymentDetails?: Maybe<PaymentDetailsResponse>;
  getPaymentEligibility?: Maybe<PaymentEligibilityResponse>;
  getPaymentIdByExternalId?: Maybe<PaymentIdByExternalIdResponse>;
  getPaymentInvoiceAttachments?: Maybe<Array<Maybe<File>>>;
  getPaymentMelioGeneratedInvoices?: Maybe<Array<Maybe<File>>>;
  getPaymentPayeeDocs?: Maybe<Array<Maybe<File>>>;
  getPaymentRiskInsights?: Maybe<PaymentRiskInsightsResponse>;
  getPaymentTimeline?: Maybe<TimelineResponse>;
  getPaymentsAutocomplete?: Maybe<Array<Maybe<Payment>>>;
  getPaymentsByUserEmail?: Maybe<PaymentLocator>;
  getPaymentsTable?: Maybe<PaymentsTableResult>;
  getPreviousFraudReferralCases: Array<FraudReferralCase>;
  getProjectById?: Maybe<Project>;
  getProjectCount?: Maybe<Scalars['Int']>;
  getProtectedMutations?: Maybe<ProtectedMutations>;
  getReceivablePaymentDocs?: Maybe<Array<Maybe<File>>>;
  getRiskDecisionCodes: Array<Maybe<OdeRiskDecisionCode>>;
  getRubrics: Array<Rubric>;
  getStrategyOdeLabels?: Maybe<Array<Maybe<StrategyOdeLabel>>>;
  getSubscriptionByOrgId?: Maybe<SubscriptionType>;
  getSubscriptionManyByOrgId?: Maybe<Array<Maybe<SubscriptionType>>>;
  getSubscriptionPlans?: Maybe<Array<Maybe<PlansType>>>;
  getTaggingByBulkEntities?: Maybe<Array<Maybe<BulkEntitiesTags>>>;
  getTaggingByEntities?: Maybe<Array<Maybe<EntityTags>>>;
  getTimeline?: Maybe<Array<Maybe<SubscriptionTimeline>>>;
  getTotalPaymentsByOrganizationId?: Maybe<TotalPayments>;
  getUploadRequest: UploadRequest;
  getUploadRequestStatus?: Maybe<ExpenseManagementUploadRequestStatus>;
  getUsers?: Maybe<Array<Maybe<User>>>;
  getVendorBankAccountPrefill?: Maybe<VendorBankAccountPrefill>;
  getVendorStatsById: VendorStatsType;
  getVendorsAutocomplete?: Maybe<Array<Maybe<Vendor>>>;
  getVendorsTable?: Maybe<Array<Maybe<Vendor>>>;
  getView?: Maybe<WatsonViewWithColumns>;
  globals?: Maybe<Array<Maybe<Globals>>>;
  globalsCount?: Maybe<GlobalsCount>;
  groupEntityMany: Array<GroupEntity>;
  guestPayorOrganizationMetadata?: Maybe<Array<Maybe<GuestPayorOrganizationMetadata>>>;
  guestPayorOrganizationMetadataCount?: Maybe<GuestPayorOrganizationMetadataCount>;
  hints?: Maybe<HintsQuery>;
  identityProvider?: Maybe<Array<Maybe<IdentityProvider>>>;
  identityProviderAccountCredential?: Maybe<Array<Maybe<IdentityProviderAccountCredential>>>;
  identityProviderAccountCredentialCount?: Maybe<IdentityProviderAccountCredentialCount>;
  identityProviderAccountLog?: Maybe<Array<Maybe<IdentityProviderAccountLog>>>;
  identityProviderAccountLogCount?: Maybe<IdentityProviderAccountLogCount>;
  identityProviderCount?: Maybe<IdentityProviderCount>;
  identityProvidersAccounts?: Maybe<Array<Maybe<IdentityProvidersAccounts>>>;
  identityProvidersAccountsCount?: Maybe<IdentityProvidersAccountsCount>;
  idmData?: Maybe<IdmData>;
  inboxEmail?: Maybe<Array<Maybe<InboxEmail>>>;
  inboxEmailAddress?: Maybe<Array<Maybe<InboxEmailAddress>>>;
  inboxEmailAddressCount?: Maybe<InboxEmailAddressCount>;
  inboxEmailCount?: Maybe<InboxEmailCount>;
  incident?: Maybe<Incident>;
  incidentById?: Maybe<Incident>;
  incidentByIds: Array<Incident>;
  incidentCount?: Maybe<Scalars['Int']>;
  incidentExecutionLog?: Maybe<IncidentExecutionLog>;
  incidentExecutionLogById?: Maybe<IncidentExecutionLog>;
  incidentExecutionLogByIds: Array<IncidentExecutionLog>;
  incidentExecutionLogMany: Array<IncidentExecutionLog>;
  incidentExecutionLogOne?: Maybe<IncidentExecutionLog>;
  incidentGroup?: Maybe<IncidentGroup>;
  incidentGroupById?: Maybe<IncidentGroup>;
  incidentGroupByIds: Array<IncidentGroup>;
  incidentGroupMany: Array<IncidentGroup>;
  incidentGroupOne?: Maybe<IncidentGroup>;
  incidentLogicFields?: Maybe<Array<Maybe<FilterQueryField>>>;
  incidentMany: Array<Incident>;
  incidentOne?: Maybe<Incident>;
  industry?: Maybe<Array<Maybe<Industry>>>;
  industryCount?: Maybe<IndustryCount>;
  internationalAccount?: Maybe<Array<Maybe<InternationalAccount>>>;
  internationalAccountCount?: Maybe<InternationalAccountCount>;
  invitation?: Maybe<Array<Maybe<Invitation>>>;
  invitationCount?: Maybe<InvitationCount>;
  invoice?: Maybe<Array<Maybe<Invoice>>>;
  invoiceAttachment?: Maybe<Array<Maybe<InvoiceAttachment>>>;
  invoiceAttachmentCount?: Maybe<InvoiceAttachmentCount>;
  invoiceCount?: Maybe<InvoiceCount>;
  invoiceCustomer?: Maybe<Array<Maybe<InvoiceCustomer>>>;
  invoiceCustomerCount?: Maybe<InvoiceCustomerCount>;
  invoiceDiscount?: Maybe<Array<Maybe<InvoiceDiscount>>>;
  invoiceDiscountCount?: Maybe<InvoiceDiscountCount>;
  invoiceLineItem?: Maybe<Array<Maybe<InvoiceLineItem>>>;
  invoiceLineItemCount?: Maybe<InvoiceLineItemCount>;
  invoiceLineSyncMetadata?: Maybe<Array<Maybe<InvoiceLineSyncMetadata>>>;
  invoiceLineSyncMetadataCount?: Maybe<InvoiceLineSyncMetadataCount>;
  invoicePaymentMetadata?: Maybe<Array<Maybe<InvoicePaymentMetadata>>>;
  invoicePaymentMetadataCount?: Maybe<InvoicePaymentMetadataCount>;
  invoicePreferences?: Maybe<Array<Maybe<InvoicePreferences>>>;
  invoicePreferencesCount?: Maybe<InvoicePreferencesCount>;
  invoiceServiceCharge?: Maybe<Array<Maybe<InvoiceServiceCharge>>>;
  invoiceServiceChargeCount?: Maybe<InvoiceServiceChargeCount>;
  invoiceSyncActivity?: Maybe<Array<Maybe<InvoiceSyncActivity>>>;
  invoiceSyncActivityCount?: Maybe<InvoiceSyncActivityCount>;
  invoiceSyncMetadata?: Maybe<Array<Maybe<InvoiceSyncMetadata>>>;
  invoiceSyncMetadataCount?: Maybe<InvoiceSyncMetadataCount>;
  invoiceTaxRate?: Maybe<Array<Maybe<InvoiceTaxRate>>>;
  invoiceTaxRateCount?: Maybe<InvoiceTaxRateCount>;
  joinOrganizationRequest?: Maybe<Array<Maybe<JoinOrganizationRequest>>>;
  joinOrganizationRequestCount?: Maybe<JoinOrganizationRequestCount>;
  labelById?: Maybe<Label>;
  labelByIds: Array<Label>;
  labelConnection?: Maybe<LabelConnection>;
  labelCount?: Maybe<Scalars['Int']>;
  labelMany: Array<Label>;
  labelOne?: Maybe<Label>;
  labelPagination?: Maybe<LabelPagination>;
  lastEscalatedUser?: Maybe<LastEscalatedUser>;
  legalInfoData: LegalInfoData;
  locks?: Maybe<Array<Maybe<Locks>>>;
  locksCount?: Maybe<LocksCount>;
  logsMany: Array<Log>;
  loss?: Maybe<Array<Maybe<Loss>>>;
  lossCount?: Maybe<LossCount>;
  managedAccount?: Maybe<Array<Maybe<ManagedAccount>>>;
  managedAccountCount?: Maybe<ManagedAccountCount>;
  melioDbCases?: Maybe<MelioDbCaseRecord>;
  mentionFields?: Maybe<Array<Maybe<FilterQueryField>>>;
  mentionableUsers?: Maybe<Array<MentionUser>>;
  merchantConfiguration?: Maybe<Array<Maybe<MerchantConfiguration>>>;
  merchantConfigurationCount?: Maybe<MerchantConfigurationCount>;
  microDeposit?: Maybe<Array<Maybe<MicroDeposit>>>;
  microDepositBlackList?: Maybe<Array<Maybe<MicroDepositBlackList>>>;
  microDepositBlackListCount?: Maybe<MicroDepositBlackListCount>;
  microDepositCount?: Maybe<MicroDepositCount>;
  microDepositsDebit?: Maybe<Array<Maybe<MicroDepositsDebit>>>;
  microDepositsDebitCount?: Maybe<MicroDepositsDebitCount>;
  /** Get list of available models from gen-ai-gateway */
  modelsList?: Maybe<Array<Maybe<Model>>>;
  moduleById?: Maybe<Module>;
  moduleMany: Array<Module>;
  moduleRoutesById?: Maybe<ModuleRoutes>;
  moduleRoutesMany: Array<ModuleRoutes>;
  moduleRoutesManyByIds: Array<ModuleRoutes>;
  moduleRoutesOne?: Maybe<ModuleRoutes>;
  naicsIndustries?: Maybe<Array<Maybe<NaicsIndustries>>>;
  naicsIndustriesCount?: Maybe<NaicsIndustriesCount>;
  nightlyPaymentPayload?: Maybe<Array<Maybe<NightlyPaymentPayload>>>;
  nightlyPaymentPayloadCount?: Maybe<NightlyPaymentPayloadCount>;
  normalizedEmail?: Maybe<Array<Maybe<NormalizedEmail>>>;
  normalizedEmailCount?: Maybe<NormalizedEmailCount>;
  notificationGroup?: Maybe<Array<Maybe<NotificationGroup>>>;
  notificationGroupCount?: Maybe<NotificationGroupCount>;
  notificationGroupEmailTemplate?: Maybe<Array<Maybe<NotificationGroupEmailTemplate>>>;
  notificationGroupEmailTemplateCount?: Maybe<NotificationGroupEmailTemplateCount>;
  notificationPreference?: Maybe<Array<Maybe<NotificationPreference>>>;
  notificationPreferenceCount?: Maybe<NotificationPreferenceCount>;
  offShiftUsers?: Maybe<Array<Maybe<SherlockUser>>>;
  onboardingIndustry?: Maybe<Array<Maybe<OnboardingIndustry>>>;
  onboardingIndustryCount?: Maybe<OnboardingIndustryCount>;
  onboardingSubIndustry?: Maybe<Array<Maybe<OnboardingSubIndustry>>>;
  onboardingSubIndustryCount?: Maybe<OnboardingSubIndustryCount>;
  optedOutOfSaleUser?: Maybe<Array<Maybe<OptedOutOfSaleUser>>>;
  optedOutOfSaleUserCount?: Maybe<OptedOutOfSaleUserCount>;
  orgHasChargebacks?: Maybe<Scalars['Boolean']>;
  orgLinking?: Maybe<OrgLinkingObj>;
  orgOwesUsMoney?: Maybe<Scalars['Boolean']>;
  organization?: Maybe<Array<Maybe<Organization>>>;
  organizationBillingFee?: Maybe<Array<Maybe<OrganizationBillingFee>>>;
  organizationBillingFeeCount?: Maybe<OrganizationBillingFeeCount>;
  organizationBranding?: Maybe<Array<Maybe<OrganizationBranding>>>;
  organizationBrandingCount?: Maybe<OrganizationBrandingCount>;
  organizationContact?: Maybe<Array<Maybe<OrganizationContact>>>;
  organizationContactCount?: Maybe<OrganizationContactCount>;
  organizationCount?: Maybe<OrganizationCount>;
  organizationDetails?: Maybe<OrganizationFee>;
  organizationHasVendor?: Maybe<Array<Maybe<OrganizationHasVendor>>>;
  organizationHasVendorCount?: Maybe<OrganizationHasVendorCount>;
  organizationKybAction?: Maybe<Array<Maybe<OrganizationKybAction>>>;
  organizationKybActionCount?: Maybe<OrganizationKybActionCount>;
  organizationNaicsIndustry?: Maybe<Array<Maybe<OrganizationNaicsIndustry>>>;
  organizationNaicsIndustryCount?: Maybe<OrganizationNaicsIndustryCount>;
  organizationNotes?: Maybe<Scalars['JSON']>;
  organizationPlan?: Maybe<PlansType>;
  organizationPreference?: Maybe<Array<Maybe<OrganizationPreference>>>;
  organizationPreferenceCount?: Maybe<OrganizationPreferenceCount>;
  organizationQuestionnaire?: Maybe<Array<Maybe<OrganizationQuestionnaire>>>;
  organizationQuestionnaireCount?: Maybe<OrganizationQuestionnaireCount>;
  organizationSyncActivity?: Maybe<Array<Maybe<OrganizationSyncActivity>>>;
  organizationSyncActivityCount?: Maybe<OrganizationSyncActivityCount>;
  organizationSyncMetadata?: Maybe<Array<Maybe<OrganizationSyncMetadata>>>;
  organizationSyncMetadataCount?: Maybe<OrganizationSyncMetadataCount>;
  organizationUltimateBeneficialOwnerType?: Maybe<Array<Maybe<OrganizationUltimateBeneficialOwnerType>>>;
  organizationUltimateBeneficialOwnerTypeCount?: Maybe<OrganizationUltimateBeneficialOwnerTypeCount>;
  organizationVendorTraits?: Maybe<Array<Maybe<OrganizationVendorTraits>>>;
  organizationVendorTraitsCount?: Maybe<OrganizationVendorTraitsCount>;
  organizationsList?: Maybe<Array<Maybe<OrganizationListItem>>>;
  organizationsToBusinesses?: Maybe<Array<Maybe<OrganizationsToBusinesses>>>;
  organizationsToBusinessesCount?: Maybe<OrganizationsToBusinessesCount>;
  paperCheck?: Maybe<Array<Maybe<PaperCheck>>>;
  paperCheckCount?: Maybe<PaperCheckCount>;
  partner?: Maybe<Array<Maybe<Partner>>>;
  partnerAuthProviderConfig?: Maybe<Array<Maybe<PartnerAuthProviderConfig>>>;
  partnerAuthProviderConfigCount?: Maybe<PartnerAuthProviderConfigCount>;
  partnerBankAccountIcon?: Maybe<Array<Maybe<PartnerBankAccountIcon>>>;
  partnerBankAccountIconCount?: Maybe<PartnerBankAccountIconCount>;
  partnerCount?: Maybe<PartnerCount>;
  partnerDetails?: Maybe<PartnerFee>;
  partnerFeeCatalog?: Maybe<Array<Maybe<PartnerFeeCatalog>>>;
  partnerFeeCatalogCount?: Maybe<PartnerFeeCatalogCount>;
  partnerFees?: Maybe<PartnerFee>;
  partnerKey?: Maybe<Array<Maybe<PartnerKey>>>;
  partnerKeyCount?: Maybe<PartnerKeyCount>;
  partnerPaymentAccount?: Maybe<Array<Maybe<PartnerPaymentAccount>>>;
  partnerPaymentAccountCount?: Maybe<PartnerPaymentAccountCount>;
  partnerPaymentAccountType?: Maybe<Array<Maybe<PartnerPaymentAccountType>>>;
  partnerPaymentAccountTypeCount?: Maybe<PartnerPaymentAccountTypeCount>;
  partnersList?: Maybe<Array<Maybe<PartnerListItem>>>;
  payment?: Maybe<Array<Maybe<Payment>>>;
  paymentApprovalAction?: Maybe<Array<Maybe<PaymentApprovalAction>>>;
  paymentApprovalActionCount?: Maybe<PaymentApprovalActionCount>;
  paymentApprovalDecision?: Maybe<Array<Maybe<PaymentApprovalDecision>>>;
  paymentApprovalDecisionCount?: Maybe<PaymentApprovalDecisionCount>;
  paymentCount?: Maybe<PaymentCount>;
  paymentIntent?: Maybe<Array<Maybe<PaymentIntent>>>;
  paymentIntentCount?: Maybe<PaymentIntentCount>;
  paymentNotes?: Maybe<Scalars['JSON']>;
  paymentReceiptFile?: Maybe<Array<Maybe<PaymentReceiptFile>>>;
  paymentReceiptFileCount?: Maybe<PaymentReceiptFileCount>;
  paymentRequest?: Maybe<Array<Maybe<PaymentRequest>>>;
  paymentRequestCount?: Maybe<PaymentRequestCount>;
  paymentRequestExternalReference?: Maybe<Array<Maybe<PaymentRequestExternalReference>>>;
  paymentRequestExternalReferenceCount?: Maybe<PaymentRequestExternalReferenceCount>;
  paymentRequestOrganizationAssignment?: Maybe<Array<Maybe<PaymentRequestOrganizationAssignment>>>;
  paymentRequestOrganizationAssignmentCount?: Maybe<PaymentRequestOrganizationAssignmentCount>;
  paymentRetries?: Maybe<Array<Maybe<PaymentRetries>>>;
  paymentRetriesCount?: Maybe<PaymentRetriesCount>;
  paymentSyncActivity?: Maybe<Array<Maybe<PaymentSyncActivity>>>;
  paymentSyncActivityCount?: Maybe<PaymentSyncActivityCount>;
  paymentSyncMetadata?: Maybe<Array<Maybe<PaymentSyncMetadata>>>;
  paymentSyncMetadataCount?: Maybe<PaymentSyncMetadataCount>;
  paymentsDBGetTransfersByPaymentId?: Maybe<Array<Maybe<PaymentsDbTransfer>>>;
  payorDetails?: Maybe<Array<Maybe<PayorDetails>>>;
  payorDetailsCount?: Maybe<PayorDetailsCount>;
  paypalBalanceAccount?: Maybe<Array<Maybe<PaypalBalanceAccount>>>;
  paypalBalanceAccountCount?: Maybe<PaypalBalanceAccountCount>;
  personalCompletedTasks: PersonalCompletedTasks;
  personalConcernAreasCompletedTasks: PersonalConcernAreasCompletedTasks;
  personalConcernAreasDashboard: PersonalConcernAreasDashboard;
  personalOrganizationTasks: PersonalOrganizationTasks;
  personalPaymentTasks: PersonalPaymentTasks;
  plaidAccount?: Maybe<Array<Maybe<PlaidAccount>>>;
  plaidAccountCount?: Maybe<PlaidAccountCount>;
  plaidInstitutionInformation?: Maybe<Array<Maybe<PlaidInstitutionInformation>>>;
  plaidInstitutionInformationCount?: Maybe<PlaidInstitutionInformationCount>;
  plaidItem?: Maybe<Array<Maybe<PlaidItem>>>;
  plaidItemCount?: Maybe<PlaidItemCount>;
  plaidItemIdentity?: Maybe<Array<Maybe<PlaidItemIdentity>>>;
  plaidItemIdentityCount?: Maybe<PlaidItemIdentityCount>;
  policyPermittedEntity?: Maybe<Array<Maybe<PolicyPermittedEntity>>>;
  policyPermittedEntityCount?: Maybe<PolicyPermittedEntityCount>;
  previewSubscription?: Maybe<PreviewOrganizationSubscriptionResponseType>;
  promoCampaigns?: Maybe<Array<Maybe<PromoCampaign>>>;
  promoCode?: Maybe<PromoCodeAdmin>;
  promoCodes?: Maybe<Array<Maybe<PromoCodeAdmin>>>;
  promoDiscountRatePlans?: Maybe<Array<Maybe<PromoDiscountRatePlan>>>;
  promotion?: Maybe<Array<Maybe<Promotion>>>;
  promotionCount?: Maybe<PromotionCount>;
  promotionsTemplate?: Maybe<Array<Maybe<PromotionsTemplate>>>;
  promotionsTemplateCount?: Maybe<PromotionsTemplateCount>;
  pushToDebitConfiguration?: Maybe<Array<Maybe<PushToDebitConfiguration>>>;
  pushToDebitConfigurationCount?: Maybe<PushToDebitConfigurationCount>;
  /** Query audit trail events for an organization */
  queryAuditTrailEvents?: Maybe<AuditTrailQueryResponse>;
  /** Returns the total count of audit trail events for an organization. */
  queryAuditTrailTotalCount?: Maybe<Scalars['Int']>;
  /** Query customer approval events for an organization from Redash */
  queryCustomerApprovalEvents?: Maybe<CustomerApprovalQueryResponse>;
  /** Returns the total count of customer approval events for an organization */
  queryCustomerApprovalTotalCount?: Maybe<Scalars['Int']>;
  quickbooksDesktopCompany?: Maybe<Array<Maybe<QuickbooksDesktopCompany>>>;
  quickbooksDesktopCompanyCount?: Maybe<QuickbooksDesktopCompanyCount>;
  railsByPaymentId?: Maybe<Rails>;
  receivableOrganizationMetadata?: Maybe<Array<Maybe<ReceivableOrganizationMetadata>>>;
  receivableOrganizationMetadataCount?: Maybe<ReceivableOrganizationMetadataCount>;
  receivablePaymentAttachment?: Maybe<Array<Maybe<ReceivablePaymentAttachment>>>;
  receivablePaymentAttachmentCount?: Maybe<ReceivablePaymentAttachmentCount>;
  receivablePaymentDetails?: Maybe<Array<Maybe<ReceivablePaymentDetails>>>;
  receivablePaymentDetailsCount?: Maybe<ReceivablePaymentDetailsCount>;
  recoSummary?: Maybe<RecoSummaryType>;
  reconBankRecordUpdateValidation?: Maybe<ReconBankRecordUpdateValidationType>;
  recordById?: Maybe<CardRecord>;
  recordByIds: Array<CardRecord>;
  recordConnection?: Maybe<CardRecordConnection>;
  recordCount?: Maybe<Scalars['Int']>;
  recordMany: Array<CardRecord>;
  recordOne?: Maybe<CardRecord>;
  recordPagination?: Maybe<CardRecordPagination>;
  recurringBill?: Maybe<Array<Maybe<RecurringBill>>>;
  recurringBillCount?: Maybe<RecurringBillCount>;
  reminder?: Maybe<Array<Maybe<Reminder>>>;
  reminderCount?: Maybe<ReminderCount>;
  renderCommunicationTemplate?: Maybe<CommunicationRenderedTemplateType>;
  riskDecisionCode?: Maybe<Array<Maybe<RiskDecisionCode>>>;
  riskDecisionCodeCount?: Maybe<RiskDecisionCodeCount>;
  riskEngineDecision?: Maybe<Array<Maybe<RiskEngineDecision>>>;
  riskEngineDecisionCount?: Maybe<RiskEngineDecisionCount>;
  riskEngineDecisionMetadata?: Maybe<Array<Maybe<RiskEngineDecisionMetadata>>>;
  riskEngineDecisionMetadataCount?: Maybe<RiskEngineDecisionMetadataCount>;
  robinhoodDecisionReportById?: Maybe<DecisionReport>;
  robinhoodDecisionReportByIds: Array<DecisionReport>;
  robinhoodDecisionReportConnection?: Maybe<DecisionReportConnection>;
  robinhoodDecisionReportCount?: Maybe<Scalars['Int']>;
  robinhoodDecisionReportMany: Array<DecisionReport>;
  robinhoodDecisionReportOne?: Maybe<DecisionReport>;
  robinhoodDecisionReportPagination?: Maybe<DecisionReportPagination>;
  robinhoodRuleById?: Maybe<Rule>;
  robinhoodRuleByIds: Array<Rule>;
  robinhoodRuleConnection?: Maybe<RuleConnection>;
  robinhoodRuleCount?: Maybe<Scalars['Int']>;
  robinhoodRuleMany: Array<Rule>;
  robinhoodRuleOne?: Maybe<Rule>;
  robinhoodRulePagination?: Maybe<RulePagination>;
  robinhoodStrategyById?: Maybe<Strategy>;
  robinhoodStrategyByIds: Array<Strategy>;
  robinhoodStrategyConnection?: Maybe<StrategyConnection>;
  robinhoodStrategyCount?: Maybe<Scalars['Int']>;
  robinhoodStrategyMany: Array<Strategy>;
  robinhoodStrategyOne?: Maybe<Strategy>;
  robinhoodStrategyPagination?: Maybe<StrategyPagination>;
  roleById?: Maybe<Role>;
  roleByIds: Array<Role>;
  roleConnection?: Maybe<RoleConnection>;
  roleCount?: Maybe<Scalars['Int']>;
  roleMany: Array<Role>;
  roleOne?: Maybe<Role>;
  rolePagination?: Maybe<RolePagination>;
  rppsAccount?: Maybe<Array<Maybe<RppsAccount>>>;
  rppsAccountCount?: Maybe<RppsAccountCount>;
  rubyLogicFields?: Maybe<Array<Maybe<FilterQueryField>>>;
  ruleStrategies?: Maybe<Array<Maybe<RuleStrategyName>>>;
  sanctionScreeningDecision?: Maybe<Array<Maybe<SanctionScreeningDecision>>>;
  sanctionScreeningDecisionCount?: Maybe<SanctionScreeningDecisionCount>;
  sanctionScreeningItem?: Maybe<Array<Maybe<SanctionScreeningItem>>>;
  sanctionScreeningItemCount?: Maybe<SanctionScreeningItemCount>;
  sbbFiservUserMapping?: Maybe<Array<Maybe<SbbFiservUserMapping>>>;
  sbbFiservUserMappingCount?: Maybe<SbbFiservUserMappingCount>;
  sbcCardDetails?: Maybe<Array<Maybe<SbcCardDetails>>>;
  sbcCardDetailsCount?: Maybe<SbcCardDetailsCount>;
  scannedInvoice?: Maybe<Array<Maybe<ScannedInvoice>>>;
  scannedInvoiceCount?: Maybe<ScannedInvoiceCount>;
  scannedInvoiceLineItem?: Maybe<Array<Maybe<ScannedInvoiceLineItem>>>;
  scannedInvoiceLineItemCount?: Maybe<ScannedInvoiceLineItemCount>;
  searchCount: Array<Maybe<ZendeskStatistics>>;
  searchRules?: Maybe<Array<Maybe<Rule>>>;
  selfServeRefund?: Maybe<Array<Maybe<SelfServeRefund>>>;
  selfServeRefundCount?: Maybe<SelfServeRefundCount>;
  serviceChargeCatalog?: Maybe<Array<Maybe<ServiceChargeCatalog>>>;
  serviceChargeCatalogCount?: Maybe<ServiceChargeCatalogCount>;
  shadowCandidateStrategy?: Maybe<FeatureStrategy>;
  sherlockUserCount?: Maybe<Scalars['Int']>;
  shift?: Maybe<Shift>;
  shiftConcernAreasById?: Maybe<Array<Maybe<ShiftConcernArea>>>;
  shiftConcernAreasSummaryByTeam?: Maybe<ShiftConcernAreasSummary>;
  shiftVirtualCardToACHPaymentCredentials?: Maybe<Array<Maybe<ShiftVirtualCardToAchPaymentCredentials>>>;
  shiftVirtualCardToACHPaymentCredentialsCount?: Maybe<ShiftVirtualCardToAchPaymentCredentialsCount>;
  shopifyShop?: Maybe<Array<Maybe<ShopifyShop>>>;
  shopifyShopCount?: Maybe<ShopifyShopCount>;
  shopifyStockyApiKey?: Maybe<Array<Maybe<ShopifyStockyApiKey>>>;
  shopifyStockyApiKeyCount?: Maybe<ShopifyStockyApiKeyCount>;
  similarBusinesses?: Maybe<Array<Maybe<SimilarBusinessType>>>;
  slotById?: Maybe<Slot>;
  slotByIds: Array<Slot>;
  slotConnection?: Maybe<SlotConnection>;
  slotCount?: Maybe<Scalars['Int']>;
  slotMany: Array<Slot>;
  slotOne?: Maybe<Slot>;
  slotPagination?: Maybe<SlotPagination>;
  squadById?: Maybe<Squad>;
  squadByIds: Array<Squad>;
  squadConnection?: Maybe<SquadConnection>;
  squadCount?: Maybe<Scalars['Int']>;
  squadMany: Array<Squad>;
  squadOne?: Maybe<Squad>;
  squadPagination?: Maybe<SquadPagination>;
  /** Fetch a single rule by ID */
  strategyRuleById?: Maybe<Rules>;
  /** Fetch a single rule by name */
  strategyRuleByName?: Maybe<Rules>;
  /** Fetch rules, optionally filtered by entityType */
  strategyRules?: Maybe<Array<Maybe<BasicRule>>>;
  /** Get versions of a strategy by name with pagination */
  strategyVersions?: Maybe<StrategyVersionsResponse>;
  subIndustry?: Maybe<Array<Maybe<SubIndustry>>>;
  subIndustryCount?: Maybe<SubIndustryCount>;
  suggestedBiller?: Maybe<Array<Maybe<SuggestedBiller>>>;
  suggestedBillerCount?: Maybe<SuggestedBillerCount>;
  supplier?: Maybe<Supplier>;
  supplierClusterAddressesDetails?: Maybe<SupplierClusterAddressesDetailsObjectTc>;
  supplierClusterBusinessNamesDetails?: Maybe<SupplierClusterBusinessNamesDetailsObjectTc>;
  supplierClusterContactNamesDetails?: Maybe<SupplierClusterContactNamesDetailsObjectTc>;
  supplierClusterDeliveryMethodsDetails?: Maybe<SupplierClusterDeliveryMethodsDetailsObjectTc>;
  supplierClusterEmailsDetails?: Maybe<SupplierClusterEmailsDetailsObjectTc>;
  supplierClusterLocalVendors: SupplierClusterLocalVendorsObjectTc;
  supplierClusterPhonesDetails?: Maybe<SupplierClusterPhonesDetailsObjectTc>;
  supplierClusterSimilarBusinesses: SupplierClusterSimilarBusinessesObjectTc;
  supplierClusterStatistics?: Maybe<SupplierClusterStatisticsObjectTc>;
  syncActivity?: Maybe<Array<Maybe<SyncActivity>>>;
  syncActivityCount?: Maybe<SyncActivityCount>;
  syncExternalFailedObject?: Maybe<Array<Maybe<SyncExternalFailedObject>>>;
  syncExternalFailedObjectCount?: Maybe<SyncExternalFailedObjectCount>;
  taggingByEntityId?: Maybe<Array<Maybe<EntityTag>>>;
  taskById?: Maybe<Task>;
  taskByIds: Array<Task>;
  taskConnection?: Maybe<TaskConnection>;
  taskCount?: Maybe<Scalars['Int']>;
  taskMany?: Maybe<Array<Maybe<Task>>>;
  taskOne?: Maybe<Task>;
  taskPagination?: Maybe<TaskPagination>;
  taskTotalCount?: Maybe<TaskTotalCount>;
  taxRate?: Maybe<Array<Maybe<TaxRate>>>;
  taxRateCount?: Maybe<TaxRateCount>;
  taxVerificationData?: Maybe<TaxVerificationData>;
  taxpayerIdentificationRequest?: Maybe<Array<Maybe<TaxpayerIdentificationRequest>>>;
  taxpayerIdentificationRequestCount?: Maybe<TaxpayerIdentificationRequestCount>;
  taxpayerInfo?: Maybe<Array<Maybe<TaxpayerInfo>>>;
  taxpayerInfoCount?: Maybe<TaxpayerInfoCount>;
  teamById?: Maybe<Team>;
  teamByIds: Array<Team>;
  teamConnection?: Maybe<TeamConnection>;
  teamCount?: Maybe<Scalars['Int']>;
  teamIntegrationById?: Maybe<TeamIntegration>;
  teamIntegrationByIds: Array<TeamIntegration>;
  teamIntegrationConnection?: Maybe<TeamIntegrationConnection>;
  teamIntegrationCount?: Maybe<Scalars['Int']>;
  teamIntegrationMany: Array<TeamIntegration>;
  teamIntegrationOne?: Maybe<TeamIntegration>;
  teamIntegrationPagination?: Maybe<TeamIntegrationPagination>;
  teamMany: Array<Team>;
  teamOne?: Maybe<Team>;
  teamPagination?: Maybe<TeamPagination>;
  threadInfo: ThreadInfo;
  todo?: Maybe<Array<Maybe<Todo>>>;
  todoAction?: Maybe<Array<Maybe<TodoAction>>>;
  todoActionCount?: Maybe<TodoActionCount>;
  todoCount?: Maybe<TodoCount>;
  transaction?: Maybe<Array<Maybe<Transaction>>>;
  transactionCount?: Maybe<TransactionCount>;
  transactionsData?: Maybe<Array<Maybe<TransactionsData>>>;
  transfers?: Maybe<Array<Maybe<TransferTimeline>>>;
  transfersCount?: Maybe<TransferTimelineCount>;
  uboData?: Maybe<OrgUboData>;
  uhvInfo?: Maybe<UhvInfo>;
  unilateralRequest?: Maybe<Array<Maybe<UnilateralRequest>>>;
  unilateralRequestCount?: Maybe<UnilateralRequestCount>;
  user?: Maybe<Array<Maybe<User>>>;
  /** Get the status of a User Activity Agent run by ID */
  userActivityStatus?: Maybe<ActivityStatusResponse>;
  userAutoComplete?: Maybe<Array<Maybe<SherlockUser>>>;
  userById?: Maybe<SherlockUser>;
  userByIds: Array<SherlockUser>;
  userConnection?: Maybe<SherlockUserConnection>;
  userCount?: Maybe<UserCount>;
  userEmailLog?: Maybe<Array<Maybe<UserEmailLog>>>;
  userEmailLogCount?: Maybe<UserEmailLogCount>;
  userEntitlementsType?: Maybe<Array<Maybe<UserEntitlementsType>>>;
  userEntitlementsTypeCount?: Maybe<UserEntitlementsTypeCount>;
  userGroup?: Maybe<Array<Maybe<UserGroup>>>;
  userGroupCount?: Maybe<UserGroupCount>;
  userIntuitCredential?: Maybe<Array<Maybe<UserIntuitCredential>>>;
  userIntuitCredentialCount?: Maybe<UserIntuitCredentialCount>;
  userLoginToken?: Maybe<Array<Maybe<UserLoginToken>>>;
  userLoginTokenCount?: Maybe<UserLoginTokenCount>;
  userMany: Array<SherlockUser>;
  userOAuthCredential?: Maybe<Array<Maybe<UserOAuthCredential>>>;
  userOAuthCredentialCount?: Maybe<UserOAuthCredentialCount>;
  userOne?: Maybe<SherlockUser>;
  userOrganization?: Maybe<Array<Maybe<UserOrganization>>>;
  userOrganizationCount?: Maybe<UserOrganizationCount>;
  userPagination?: Maybe<SherlockUserPagination>;
  userPreference?: Maybe<Array<Maybe<UserPreference>>>;
  userPreferenceCount?: Maybe<UserPreferenceCount>;
  userQuickbooksCredential?: Maybe<Array<Maybe<UserQuickbooksCredential>>>;
  userQuickbooksCredentialCount?: Maybe<UserQuickbooksCredentialCount>;
  userToNormalizedEmail?: Maybe<Array<Maybe<UserToNormalizedEmail>>>;
  userToNormalizedEmailCount?: Maybe<UserToNormalizedEmailCount>;
  validatePromoCode?: Maybe<ValidatePromoCodeInputType>;
  vendor?: Maybe<Array<Maybe<Vendor>>>;
  vendorCount?: Maybe<VendorCount>;
  vendorCredits?: Maybe<Array<Maybe<VendorCredits>>>;
  vendorCreditsCount?: Maybe<VendorCreditsCount>;
  vendorCreditsPayments?: Maybe<Array<Maybe<VendorCreditsPayments>>>;
  vendorCreditsPaymentsCount?: Maybe<VendorCreditsPaymentsCount>;
  vendorExternalReferences?: Maybe<Array<Maybe<VendorExternalReferences>>>;
  vendorExternalReferencesCount?: Maybe<VendorExternalReferencesCount>;
  vendorLink?: Maybe<Array<Maybe<VendorLink>>>;
  vendorLinkCandidate?: Maybe<Array<Maybe<VendorLinkCandidate>>>;
  vendorLinkCandidateCount?: Maybe<VendorLinkCandidateCount>;
  vendorLinkCount?: Maybe<VendorLinkCount>;
  vendorOnboardingSessions?: Maybe<Array<Maybe<VendorOnboardingSessions>>>;
  vendorOnboardingSessionsCount?: Maybe<VendorOnboardingSessionsCount>;
  vendorPaymentLink?: Maybe<Array<Maybe<VendorPaymentLink>>>;
  vendorPaymentLinkCount?: Maybe<VendorPaymentLinkCount>;
  vendorPortalConnection?: Maybe<Array<Maybe<VendorPortalConnection>>>;
  vendorPortalConnectionCount?: Maybe<VendorPortalConnectionCount>;
  vendorPreference?: Maybe<Array<Maybe<VendorPreference>>>;
  vendorPreferenceCount?: Maybe<VendorPreferenceCount>;
  vendorSyncActivity?: Maybe<Array<Maybe<VendorSyncActivity>>>;
  vendorSyncActivityCount?: Maybe<VendorSyncActivityCount>;
  vendorUserGroup?: Maybe<Array<Maybe<VendorUserGroup>>>;
  vendorUserGroupCount?: Maybe<VendorUserGroupCount>;
  virtualAccount?: Maybe<Array<Maybe<VirtualAccount>>>;
  virtualAccountCount?: Maybe<VirtualAccountCount>;
  virtualCard?: Maybe<Array<Maybe<VirtualCard>>>;
  virtualCardAccount?: Maybe<Array<Maybe<VirtualCardAccount>>>;
  virtualCardAccountCount?: Maybe<VirtualCardAccountCount>;
  virtualCardCandidates?: Maybe<Array<Maybe<VirtualCardCandidates>>>;
  virtualCardCandidatesCount?: Maybe<VirtualCardCandidatesCount>;
  virtualCardCount?: Maybe<VirtualCardCount>;
  voidCheck?: Maybe<Array<Maybe<VoidCheck>>>;
  voidCheckCount?: Maybe<VoidCheckCount>;
  whitepages?: Maybe<Scalars['JSON']>;
  workflowCriteria?: Maybe<Array<Maybe<WorkflowCriteria>>>;
  workflowCriteriaCount?: Maybe<WorkflowCriteriaCount>;
  workflowEntityUserNotification?: Maybe<Array<Maybe<WorkflowEntityUserNotification>>>;
  workflowEntityUserNotificationCount?: Maybe<WorkflowEntityUserNotificationCount>;
  workflowProgress?: Maybe<Array<Maybe<WorkflowProgress>>>;
  workflowProgressCount?: Maybe<WorkflowProgressCount>;
  workflowStep?: Maybe<Array<Maybe<WorkflowStep>>>;
  workflowStepCount?: Maybe<WorkflowStepCount>;
  workflowStepProgress?: Maybe<Array<Maybe<WorkflowStepProgress>>>;
  workflowStepProgressCount?: Maybe<WorkflowStepProgressCount>;
  workflowStepUserApprover?: Maybe<Array<Maybe<WorkflowStepUserApprover>>>;
  workflowStepUserApproverCount?: Maybe<WorkflowStepUserApproverCount>;
  xeroOnBoarding?: Maybe<XeroOnboardingResponse>;
  zendeskFields?: Maybe<Scalars['JSON']>;
  zendeskGroups?: Maybe<ZendeskGroups>;
};


export type QueryOrganizationUltimateBeneficialOwnerArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOrganizationUltimateBeneficialOwnerCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryAccountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryAccountCompletedPaymentStatsArgs = {
  organizationId: Scalars['Int'];
};


export type QueryAccountCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryAccountCrrArgs = {
  organizationId: Scalars['Int'];
};


export type QueryAccountDeliveryMethodsArgs = {
  organizationId: Scalars['Int'];
};


export type QueryAccountEntityStatisticsArgs = {
  entity: AccountEntityEnum;
  entityIdentifier: Scalars['String'];
  organizationId: Scalars['Int'];
};


export type QueryAccountFeaturesArgs = {
  organizationId: Scalars['Int'];
};


export type QueryAccountFundingSourcesArgs = {
  fundingType?: InputMaybe<FundingTypeEnum>;
  organizationId: Scalars['Int'];
};


export type QueryAccountGeneralStatisticsArgs = {
  organizationId: Scalars['Int'];
};


export type QueryAccountIPsArgs = {
  organizationId: Scalars['Int'];
};


export type QueryAccountInfoArgs = {
  organizationId: Scalars['Int'];
};


export type QueryAccountOdeArgs = {
  organizationId: Scalars['Int'];
};


export type QueryAccountOrgLinkingArgs = {
  organizationId: Scalars['Int'];
};


export type QueryAccountPayorsArgs = {
  organizationId: Scalars['Int'];
};


export type QueryAccountStatisticsArgs = {
  organizationId: Scalars['Int'];
};


export type QueryAccountUsersArgs = {
  organizationId: Scalars['Int'];
};


export type QueryAccountVendorsArgs = {
  filter?: InputMaybe<VendorFilter>;
  organizationId: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<VendorSort>;
};


export type QueryAccountingPlatformArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryAccountingPlatformCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryAccountingPlatformEntityArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryAccountingPlatformEntityCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryAccountingPlatformOrganizationArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryAccountingPlatformOrganizationCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryAccountingPlatformOrganizationsMetadataArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryAccountingPlatformOrganizationsMetadataCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryAchRefundArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryAchRefundCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryActionByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryActionByIdsArgs = {
  _ids: Array<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsActionInput>;
};


export type QueryActionConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FilterFindManyActionInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortConnectionActionEnum>;
};


export type QueryActionCountArgs = {
  filter?: InputMaybe<FilterCountActionInput>;
};


export type QueryActionLogByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryActionLogByIdsArgs = {
  _ids: Array<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsActionLogInput>;
};


export type QueryActionLogConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FilterFindManyActionLogInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortConnectionActionLogEnum>;
};


export type QueryActionLogCountArgs = {
  filter?: InputMaybe<FilterFindManyActionLogInput>;
};


export type QueryActionLogManyArgs = {
  filter?: InputMaybe<FilterFindManyActionLogInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyActionLogInput>;
};


export type QueryActionLogOneArgs = {
  filter?: InputMaybe<FilterFindOneActionLogInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneActionLogInput>;
};


export type QueryActionLogPaginationArgs = {
  filter?: InputMaybe<FilterFindManyActionLogInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyActionLogInput>;
};


export type QueryActionManyArgs = {
  filter?: InputMaybe<FilterFindManyActionInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyActionInput>;
};


export type QueryActionOneArgs = {
  filter?: InputMaybe<FilterFindOneActionInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneActionInput>;
};


export type QueryActionPaginationArgs = {
  filter?: InputMaybe<FilterFindManyActionInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyActionInput>;
};


export type QueryAgreementArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryAgreementCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryAgreementSignatureArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryAgreementSignatureCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryAllCasesArgs = {
  amount?: InputMaybe<Scalars['Int']>;
  caseId?: InputMaybe<Scalars['String']>;
  highLevelClaim?: InputMaybe<HighLevelClaim>;
  includeVersions?: InputMaybe<Scalars['Boolean']>;
  latest?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['String']>;
  paymentIds?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Status>;
  subStatus?: InputMaybe<AllCasesSubStatus>;
};


export type QueryAllRelatedCompletedPaymentsArgs = {
  escalationId: Scalars['String'];
};


export type QueryApiKeyArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryApiKeyCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryApiPartnerBrandingsArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryApiPartnerBrandingsCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryAppleIdToUserArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryAppleIdToUserCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryApplicationPaymentArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryApplicationPaymentCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryApprovalDecisionArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryApprovalDecisionCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryApprovalWorkflowArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryApprovalWorkflowCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryApprovalWorkflowUserArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryApprovalWorkflowUserCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryAttachedFilesArgs = {
  organizationId: Scalars['String'];
};


export type QueryAttachedFilesIndicationArgs = {
  paymentId: Scalars['Int'];
};


export type QueryAutoDebitContractArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryAutoDebitContractCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryAutoDebitPayorAuthorizationArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryAutoDebitPayorAuthorizationCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryAutoDebitRequestArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryAutoDebitRequestCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryAutoPayPolicyArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryAutoPayPolicyCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBadAssetsLinkingArgs = {
  paymentId: Scalars['Int'];
};


export type QueryBankAccountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBankAccountCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBanksBlockedForPaymentArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBanksBlockedForPaymentCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBillArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBillCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBillLineItemArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBillLineItemCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBillLineItemLabelArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBillLineItemLabelCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBillLineItemsSyncMetadataArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBillLineItemsSyncMetadataCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBillNotificationArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBillNotificationCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBillPaymentArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBillPaymentCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBillSubscriptionArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBillSubscriptionCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBillSubscriptionOccurrenceArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBillSubscriptionOccurrenceCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBillSyncActivityArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBillSyncActivityCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBillerArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBillerCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBillingItemArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBillingItemCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBillingPermissionArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBillingPermissionCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBillingSettingsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBillingSettingsCountArgs = {
  organizationId?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBlockCreditToVendorConfigurationArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBlockCreditToVendorConfigurationCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryBulkCommentsArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
};


export type QueryCapitalOsAccountsArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryCapitalOsAccountsCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryCardAccountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryCardAccountCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryCardAccountTabapayClientArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryCardAccountTabapayClientCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryCatalogItemArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryCatalogItemCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryCcBlockedBinsArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryCcBlockedBinsCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryChargeArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryChargeCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryChargebacksArgs = {
  amount?: InputMaybe<Scalars['Int']>;
  caseId?: InputMaybe<Scalars['String']>;
  highLevelClaim?: InputMaybe<HighLevelClaim>;
  id?: InputMaybe<Scalars['String']>;
  includeVersions?: InputMaybe<Scalars['Boolean']>;
  latest?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['String']>;
  paymentIds?: InputMaybe<Scalars['String']>;
  scenario?: InputMaybe<ChargebackScenario>;
  sort?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Status>;
  subStatus?: InputMaybe<ChargebackSubStatus>;
};


export type QueryCheckTrackArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryCheckTrackCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryCheckoutArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryCheckoutCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryClusterTpvArgs = {
  clusterId?: InputMaybe<Scalars['String']>;
};


export type QueryCodeEmailVerificationArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryCodeEmailVerificationCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryCommentsArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
};


export type QueryConcernAreaByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryConcernAreaByIdsArgs = {
  _ids: Array<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsConcernAreaSchemaInput>;
};


export type QueryConcernAreaManyArgs = {
  filter?: InputMaybe<FilterFindManyConcernAreaSchemaInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyConcernAreaSchemaInput>;
};


export type QueryConcernAreaOneArgs = {
  filter?: InputMaybe<FilterFindOneConcernAreaSchemaInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneConcernAreaSchemaInput>;
};


export type QueryConsentedGuestFundingSourceArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryConsentedGuestFundingSourceCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryContactArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryContactCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryConversationArgs = {
  id: Scalars['String'];
};


export type QueryConversationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryCountVendorsTableArgs = {
  filter?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryCouponArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryCouponCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryCouponTemplateArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryCouponTemplateCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryCouponsMetadataArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryCouponsMetadataCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryCrrHistoryArgs = {
  organizationId: Scalars['Int'];
};


export type QueryCryptoUsdAccountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryCryptoUsdAccountCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryCustomerSyncActivityArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryCustomerSyncActivityCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryCustomersSyncMetadataArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryCustomersSyncMetadataCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryDecryptByEntityIdArgs = {
  decryptedValue: Scalars['String'];
  entityId: Scalars['Int'];
  field: Scalars['String'];
  groupEntityId: Scalars['String'];
  mode: Scalars['String'];
  model: Scalars['String'];
  partnerName?: InputMaybe<Scalars['String']>;
};


export type QueryDeletionRequestArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryDeletionRequestCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryDeletionRequestItemArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryDeletionRequestItemCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryDeliveryMethodArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryDeliveryMethodCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryDeliveryMethodFeeOnlyFundingSourceArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryDeliveryMethodFeeOnlyFundingSourceCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryDescriptionArgs = {
  escalationId: Scalars['String'];
};


export type QueryDiscountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryDiscountCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryDocumentRequestsArgs = {
  entityId: Scalars['String'];
  timeSearch?: InputMaybe<Scalars['String']>;
};


export type QueryDomesticWireAccountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryDomesticWireAccountCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryDraftDeliveryMethodArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryDraftDeliveryMethodCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryEBillArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryEBillCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryEBillLineItemArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryEBillLineItemCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryEBillSubscriptionArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryEBillSubscriptionCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryEmailTemplateArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryEmailTemplateCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryEmailageArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
};


export type QueryEmailageByEmailLatestArgs = {
  email?: InputMaybe<Scalars['String']>;
};


export type QueryEmailageOrgArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
};


export type QueryEntityMappingArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryEntityMappingCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryExternalPaymentLogicalIdMappingArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryExternalPaymentLogicalIdMappingCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFailedEmailsArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFailedEmailsCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFailedPaymentsRetriesArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFailedPaymentsRetriesCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFastAchConfigurationArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFastAchConfigurationCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFeatureStrategyArgs = {
  strategyId?: InputMaybe<Scalars['String']>;
};


export type QueryFeeCatalogArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFeeCatalogCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFeedbackSubmissionArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFeedbackSubmissionCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFileArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFileBillArgs = {
  billId?: InputMaybe<Scalars['Int']>;
  fileId?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFileBillCountArgs = {
  billId?: InputMaybe<Scalars['Int']>;
  fileId?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFileCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFileEBillArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFileEBillCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFilePaymentRequestArgs = {
  fileId?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  paymentRequestId?: InputMaybe<Scalars['Int']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFilePaymentRequestCountArgs = {
  fileId?: InputMaybe<Scalars['Int']>;
  paymentRequestId?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFileUserArgs = {
  fileId?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  userId?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFileUserCountArgs = {
  fileId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFilterQueryFieldsArgs = {
  collection?: InputMaybe<Scalars['String']>;
  inboxType?: InputMaybe<EnumGenericTaskType>;
};


export type QueryFinancingAccountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFinancingAccountCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFinancingApplicationBusinessDetailsArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFinancingApplicationBusinessDetailsCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFirmClientArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFirmClientCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFiservCredentialArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFiservCredentialCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFlexAccountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFlexAccountCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFlowArgs = {
  filter?: InputMaybe<FilterFindOneUiFlowInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneUiFlowInput>;
};


export type QueryFlowExecutionByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryFlowExecutionByIdsArgs = {
  _ids: Array<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsFlowExecutionInput>;
};


export type QueryFlowExecutionCountArgs = {
  filter?: InputMaybe<FilterCountFlowExecutionInput>;
};


export type QueryFlowExecutionManyArgs = {
  filter?: InputMaybe<FilterFindManyFlowExecutionInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyFlowExecutionInput>;
};


export type QueryFlowExecutionOneArgs = {
  filter?: InputMaybe<FilterFindOneFlowExecutionInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneFlowExecutionInput>;
};


export type QueryFlowPermissionByFlowIdArgs = {
  uiFlowId: Scalars['MongoID'];
};


export type QueryFlowPermissionManyArgs = {
  filter?: InputMaybe<FilterFindManyFlowPermissionInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyFlowPermissionInput>;
};


export type QueryFlowUiByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryFlowUiByIdsArgs = {
  _ids: Array<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsUiFlowInput>;
};


export type QueryFlowUiCountArgs = {
  filter?: InputMaybe<FilterCountUiFlowInput>;
};


export type QueryFlowUiHistoryArgs = {
  uiFlowId: Scalars['MongoID'];
};


export type QueryFlowUiManyArgs = {
  filter?: InputMaybe<FilterFindManyUiFlowInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyUiFlowInput>;
};


export type QueryFlowUiOneArgs = {
  filter?: InputMaybe<FilterFindOneUiFlowInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneUiFlowInput>;
};


export type QueryFundingSourceArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryFundingSourceCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryGayaFormArgs = {
  filter?: InputMaybe<FilterFindOneGayaFormInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneGayaFormInput>;
};


export type QueryGayaFormByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryGayaFormByIdsArgs = {
  _ids: Array<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsGayaFormInput>;
};


export type QueryGayaFormCountArgs = {
  filter?: InputMaybe<FilterCountGayaFormInput>;
};


export type QueryGayaFormHistoryArgs = {
  gayaFormId: Scalars['MongoID'];
};


export type QueryGayaFormHistoryByVersionArgs = {
  gayaFormId: Scalars['MongoID'];
  gayaFormVersion?: InputMaybe<Scalars['Float']>;
};


export type QueryGayaFormManyArgs = {
  filter?: InputMaybe<FilterFindManyGayaFormInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyGayaFormInput>;
};


export type QueryGayaFormOneArgs = {
  filter?: InputMaybe<FilterFindOneGayaFormInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneGayaFormInput>;
};


export type QueryGayaFormResponseArgs = {
  filter?: InputMaybe<FilterFindOneGayaFormResponseInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneGayaFormResponseInput>;
};


export type QueryGayaFormResponseByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryGayaFormResponseByIdsArgs = {
  _ids: Array<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsGayaFormResponseInput>;
};


export type QueryGayaFormResponseCountArgs = {
  filter?: InputMaybe<FilterCountGayaFormResponseInput>;
};


export type QueryGayaFormResponseManyArgs = {
  filter?: InputMaybe<FilterFindManyGayaFormResponseInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyGayaFormResponseInput>;
};


export type QueryGayaFormResponseOneArgs = {
  filter?: InputMaybe<FilterFindOneGayaFormResponseInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneGayaFormResponseInput>;
};


export type QueryGayaFormResponsePaginationArgs = {
  filter?: InputMaybe<FilterFindManyGayaFormResponseInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyGayaFormResponseInput>;
};


export type QueryGayaThemeArgs = {
  filter?: InputMaybe<FilterFindOneGayaThemeInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneGayaThemeInput>;
};


export type QueryGayaThemeByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryGayaThemeByIdsArgs = {
  _ids: Array<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsGayaThemeInput>;
};


export type QueryGayaThemeManyArgs = {
  filter?: InputMaybe<FilterFindManyGayaThemeInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyGayaThemeInput>;
};


export type QueryGayaThemeOneArgs = {
  filter?: InputMaybe<FilterFindOneGayaThemeInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneGayaThemeInput>;
};


export type QueryGayaZendeskFormFieldsArgs = {
  zendeskFormId?: InputMaybe<Scalars['Float']>;
};


export type QueryGenericTaskCountArgs = {
  filter?: InputMaybe<FilterFindManyGenericTaskInput>;
};


export type QueryGenericTaskManyArgs = {
  filter?: InputMaybe<FilterFindManyGenericTaskInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortFindManyGenericTaskInput>>;
};


export type QueryGenericTaskOneArgs = {
  filter?: InputMaybe<FilterFindOneGenericTaskInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortFindOneGenericTaskInput>>;
};


export type QueryGenericTaskPaginationArgs = {
  filter?: InputMaybe<FilterFindManyGenericTaskInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyGenericTaskInput>;
};


export type QueryGenericTaskTotalCountArgs = {
  entityType: Scalars['String'];
  filter?: InputMaybe<Scalars['JSON']>;
  taskType?: InputMaybe<EntityType>;
};


export type QueryGetAccountingFirmsTiersArgs = {
  firmIds: Array<Scalars['Int']>;
};


export type QueryGetAgentResponseArgs = {
  agentNames: Array<InputMaybe<Scalars['String']>>;
  entityId: Scalars['String'];
  entityType: Scalars['String'];
};


export type QueryGetAllProjectsArgs = {
  filter?: InputMaybe<FilterFindManyProjectInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortFindManyProjectInput>>;
};


export type QueryGetAllTagsArgs = {
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  page: Scalars['Int'];
  size: Scalars['Int'];
};


export type QueryGetAppliedLimitationsArgs = {
  entity: AppliedLimitationEntity;
  entityId: Scalars['Int'];
};


export type QueryGetAtoCaseByPaymentIdArgs = {
  paymentId: Scalars['Int'];
};


export type QueryGetAtoCasesByOrgIdArgs = {
  organizationId: Scalars['Int'];
};


export type QueryGetAvailablePropertiesByEntityArgs = {
  entity: Scalars['String'];
};


export type QueryGetAvailableTagsByEntityArgs = {
  entity: Entity;
};


export type QueryGetBatchGroupsBaseDataArgs = {
  groupsIds: Array<InputMaybe<Scalars['String']>>;
};


export type QueryGetBatchMonitorDataArgs = {
  batchId?: InputMaybe<Scalars['String']>;
};


export type QueryGetBillAttachmentsArgs = {
  externalBillIds: Array<Scalars['String']>;
  organizationId: Scalars['Int'];
  partnerName?: InputMaybe<Scalars['String']>;
  paymentId: Scalars['Int'];
};


export type QueryGetBillsAutocompleteArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  paymentIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  query?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type QueryGetBusinessByIdArgs = {
  businessId?: InputMaybe<Scalars['String']>;
};


export type QueryGetCardholderByIdArgs = {
  id: Scalars['String'];
  organizationId: Scalars['Int'];
};


export type QueryGetCardholdersArgs = {
  includeArchived?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CardholderStatus>;
};


export type QueryGetCommunicationArgs = {
  communicationType?: InputMaybe<Scalars['String']>;
};


export type QueryGetCommunicationsArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCompletedPaymentsCountForIpArgs = {
  ip: Scalars['String'];
};


export type QueryGetConnectedCardsArgs = {
  cardholder?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryGetCurrentFraudReferralCasesArgs = {
  organizationId: Scalars['Int'];
};


export type QueryGetDeliveryMethodsByPaymentIdArgs = {
  paymentId: Scalars['Int'];
};


export type QueryGetDeviceConsistencyDataArgs = {
  paymentId?: InputMaybe<Scalars['String']>;
};


export type QueryGetDeviceFeaturesByActionIdsArgs = {
  actionIds: Array<Scalars['String']>;
};


export type QueryGetExpenseByIdArgs = {
  id: Scalars['String'];
  organizationId: Scalars['Int'];
};


export type QueryGetExpenseManagementOnboardingStatusArgs = {
  organizationId: Scalars['Int'];
};


export type QueryGetExpensesArgs = {
  card?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cardholder?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fromDate?: InputMaybe<Scalars['Date']>;
  fromTransactionDate?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
  stage?: InputMaybe<ExpenseStage>;
  toDate?: InputMaybe<Scalars['Date']>;
  toTransactionDate?: InputMaybe<Scalars['Date']>;
};


export type QueryGetFinancingPaymentDataArgs = {
  paymentId: Scalars['Int'];
};


export type QueryGetFraudReferralCasesCountByOrgIdArgs = {
  organizationId: Scalars['Int'];
};


export type QueryGetFundingSourcesByPaymentIdArgs = {
  paymentId: Scalars['Int'];
};


export type QueryGetGraphArgs = {
  entity: Scalars['String'];
  id: Scalars['Int'];
};


export type QueryGetIncidentExecutionsListArgs = {
  filter?: InputMaybe<FilterFindManyFlowExecutionInput>;
  flowExecutionFilter?: InputMaybe<FilterFindManyFlowExecutionInput>;
  groupId?: InputMaybe<Scalars['String']>;
  incidentId?: InputMaybe<Scalars['String']>;
  logsFilter?: InputMaybe<FilterFindManyIncidentExecutionLogInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyFlowExecutionInput>;
};


export type QueryGetLatestScoreArgs = {
  organizationId: Scalars['Int'];
};


export type QueryGetLimitationInfoArgs = {
  organizationId: Scalars['Int'];
  userId: Scalars['Int'];
};


export type QueryGetLimitationLogsArgs = {
  organizationId: Scalars['Int'];
};


export type QueryGetMelioDbUserByIdArgs = {
  filter?: InputMaybe<Scalars['SequelizeJSON']>;
  id: Scalars['Int'];
  isDeletedOrgs?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryGetMelioDbUsersArgs = {
  filter?: InputMaybe<Scalars['SequelizeJSON']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryGetOrganizationAllDecisionsAndLabelsArgs = {
  organizationId: Scalars['Int'];
};


export type QueryGetOrganizationAllDecisionsCountArgs = {
  organizationId: Scalars['Int'];
};


export type QueryGetOrganizationCompanyNamesByVendorFilterArgs = {
  filter?: InputMaybe<Scalars['SequelizeJSON']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryGetOrganizationLatestDecisionAndLabelsArgs = {
  organizationId: Scalars['Int'];
};


export type QueryGetOrganizationPaymentFilesArgs = {
  filters?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['Int'];
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
};


export type QueryGetOrganizationPaymentFilesCountArgs = {
  filters?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['Int'];
};


export type QueryGetOrganizationProductTagsArgs = {
  organizationIds: Array<InputMaybe<Scalars['Int']>>;
};


export type QueryGetOrganizationRiskInsightsArgs = {
  organizationId: Scalars['Int'];
};


export type QueryGetOrganizationTicketsArgs = {
  fromDate?: InputMaybe<Scalars['Date']>;
  organizationId: Scalars['Int'];
  toDate?: InputMaybe<Scalars['Date']>;
};


export type QueryGetOrganizationsAutocompleteArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  paymentIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  query?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type QueryGetPathFinderAvailableActionsArgs = {
  entityIds: Array<Scalars['Int']>;
  entityType: PathFinderActionEntity;
  orgId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};


export type QueryGetPaymentAccessArgs = {
  paymentId: Scalars['Int'];
  userId?: InputMaybe<Scalars['Int']>;
};


export type QueryGetPaymentBillAttachmentsArgs = {
  paymentId: Scalars['Int'];
};


export type QueryGetPaymentByOrganizationIdFieldArgs = {
  filter?: InputMaybe<Scalars['SequelizeJSON']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['String'];
};


export type QueryGetPaymentDataByUserIdArgs = {
  userId: Scalars['Int'];
};


export type QueryGetPaymentDetailsArgs = {
  paymentId: Scalars['Int'];
};


export type QueryGetPaymentEligibilityArgs = {
  paymentId: Scalars['Int'];
};


export type QueryGetPaymentIdByExternalIdArgs = {
  externalId: Scalars['String'];
};


export type QueryGetPaymentInvoiceAttachmentsArgs = {
  paymentId: Scalars['Int'];
};


export type QueryGetPaymentMelioGeneratedInvoicesArgs = {
  paymentId: Scalars['Int'];
};


export type QueryGetPaymentPayeeDocsArgs = {
  paymentId: Scalars['Int'];
};


export type QueryGetPaymentRiskInsightsArgs = {
  paymentId: Scalars['Int'];
};


export type QueryGetPaymentTimelineArgs = {
  paymentId: Scalars['Int'];
};


export type QueryGetPaymentsAutocompleteArgs = {
  billIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  deliverStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  query?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type QueryGetPaymentsByUserEmailArgs = {
  email: Scalars['String'];
  filter?: InputMaybe<Scalars['SequelizeJSON']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
};


export type QueryGetPaymentsTableArgs = {
  filter?: InputMaybe<Scalars['SequelizeJSON']>;
  limit?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryGetPreviousFraudReferralCasesArgs = {
  organizationId: Scalars['Int'];
};


export type QueryGetProjectByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryGetProjectCountArgs = {
  filter?: InputMaybe<FilterCountProjectInput>;
};


export type QueryGetReceivablePaymentDocsArgs = {
  paymentId: Scalars['Int'];
};


export type QueryGetRubricsArgs = {
  filter?: InputMaybe<FilterFindManyRubricInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyRubricInput>;
};


export type QueryGetSubscriptionByOrgIdArgs = {
  organizationId: Scalars['Int'];
};


export type QueryGetSubscriptionManyByOrgIdArgs = {
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type QueryGetSubscriptionPlansArgs = {
  organizationId: Scalars['Int'];
};


export type QueryGetTaggingByBulkEntitiesArgs = {
  filter?: InputMaybe<Array<InputMaybe<EntityFilterInput>>>;
};


export type QueryGetTaggingByEntitiesArgs = {
  filter?: InputMaybe<Array<InputMaybe<EntityFilterInput>>>;
};


export type QueryGetTimelineArgs = {
  organizationId: Scalars['Int'];
};


export type QueryGetTotalPaymentsByOrganizationIdArgs = {
  organizationId: Scalars['Int'];
};


export type QueryGetUploadRequestArgs = {
  partnerName: Scalars['String'];
  uploadRequestId: Scalars['String'];
};


export type QueryGetUploadRequestStatusArgs = {
  id?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['Int'];
};


export type QueryGetUsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryGetVendorBankAccountPrefillArgs = {
  vendorIds: Array<Scalars['Int']>;
};


export type QueryGetVendorStatsByIdArgs = {
  vendorId: Scalars['Int'];
};


export type QueryGetVendorsAutocompleteArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  paymentIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  query?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type QueryGetVendorsTableArgs = {
  filter?: InputMaybe<Scalars['SequelizeJSON']>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type QueryGetViewArgs = {
  filter?: InputMaybe<FilterFindOneWatsonViewInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneWatsonViewInput>;
};


export type QueryGlobalsArgs = {
  key?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryGlobalsCountArgs = {
  key?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryGroupEntityManyArgs = {
  filter?: InputMaybe<FilterFindManyGroupEntityInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortFindManyGroupEntityInput>>;
};


export type QueryGuestPayorOrganizationMetadataArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryGuestPayorOrganizationMetadataCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryHintsArgs = {
  organizationId?: InputMaybe<Scalars['Int']>;
};


export type QueryIdentityProviderArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryIdentityProviderAccountCredentialArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryIdentityProviderAccountCredentialCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryIdentityProviderAccountLogArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryIdentityProviderAccountLogCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryIdentityProviderCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryIdentityProvidersAccountsArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryIdentityProvidersAccountsCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryIdmDataArgs = {
  organizationId: Scalars['Int'];
};


export type QueryInboxEmailArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInboxEmailAddressArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInboxEmailAddressCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInboxEmailCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryIncidentArgs = {
  filter?: InputMaybe<FilterFindOneIncidentInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneIncidentInput>;
};


export type QueryIncidentByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryIncidentByIdsArgs = {
  _ids: Array<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsIncidentInput>;
};


export type QueryIncidentCountArgs = {
  filter?: InputMaybe<FilterCountIncidentInput>;
};


export type QueryIncidentExecutionLogArgs = {
  filter?: InputMaybe<FilterFindOneIncidentExecutionLogInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneIncidentExecutionLogInput>;
};


export type QueryIncidentExecutionLogByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryIncidentExecutionLogByIdsArgs = {
  _ids: Array<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsIncidentExecutionLogInput>;
};


export type QueryIncidentExecutionLogManyArgs = {
  filter?: InputMaybe<FilterFindManyIncidentExecutionLogInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyIncidentExecutionLogInput>;
};


export type QueryIncidentExecutionLogOneArgs = {
  filter?: InputMaybe<FilterFindOneIncidentExecutionLogInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneIncidentExecutionLogInput>;
};


export type QueryIncidentGroupArgs = {
  filter?: InputMaybe<FilterFindOneIncidentGroupInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneIncidentGroupInput>;
};


export type QueryIncidentGroupByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryIncidentGroupByIdsArgs = {
  _ids: Array<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsIncidentGroupInput>;
};


export type QueryIncidentGroupManyArgs = {
  filter?: InputMaybe<FilterFindManyIncidentGroupInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyIncidentGroupInput>;
};


export type QueryIncidentGroupOneArgs = {
  filter?: InputMaybe<FilterFindOneIncidentGroupInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneIncidentGroupInput>;
};


export type QueryIncidentLogicFieldsArgs = {
  collection?: InputMaybe<Scalars['String']>;
};


export type QueryIncidentManyArgs = {
  filter?: InputMaybe<FilterFindManyIncidentInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortFindManyIncidentInput>>;
};


export type QueryIncidentOneArgs = {
  filter?: InputMaybe<FilterFindOneIncidentInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneIncidentInput>;
};


export type QueryIndustryArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryIndustryCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInternationalAccountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInternationalAccountCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInvitationArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInvitationCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInvoiceArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInvoiceAttachmentArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInvoiceAttachmentCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInvoiceCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInvoiceCustomerArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInvoiceCustomerCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInvoiceDiscountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInvoiceDiscountCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInvoiceLineItemArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInvoiceLineItemCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInvoiceLineSyncMetadataArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInvoiceLineSyncMetadataCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInvoicePaymentMetadataArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInvoicePaymentMetadataCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInvoicePreferencesArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInvoicePreferencesCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInvoiceServiceChargeArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInvoiceServiceChargeCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInvoiceSyncActivityArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInvoiceSyncActivityCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInvoiceSyncMetadataArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInvoiceSyncMetadataCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInvoiceTaxRateArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryInvoiceTaxRateCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryJoinOrganizationRequestArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryJoinOrganizationRequestCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryLabelByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryLabelByIdsArgs = {
  _ids: Array<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsLabelInput>;
};


export type QueryLabelConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FilterFindManyLabelInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortConnectionLabelEnum>;
};


export type QueryLabelCountArgs = {
  filter?: InputMaybe<FilterFindManyLabelInput>;
};


export type QueryLabelManyArgs = {
  filter?: InputMaybe<FilterFindManyLabelInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortFindManyLabelInput>>;
};


export type QueryLabelOneArgs = {
  filter?: InputMaybe<FilterFindOneLabelInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneLabelInput>;
};


export type QueryLabelPaginationArgs = {
  filter?: InputMaybe<FilterFindManyLabelInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyLabelInput>;
};


export type QueryLastEscalatedUserArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
};


export type QueryLegalInfoDataArgs = {
  organizationId: Scalars['Int'];
};


export type QueryLocksArgs = {
  id?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryLocksCountArgs = {
  id?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryLogsManyArgs = {
  filter?: InputMaybe<FilterFindManyLogInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyLogInput>;
};


export type QueryLossArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryLossCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryManagedAccountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryManagedAccountCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryMelioDbCasesArgs = {
  amount?: InputMaybe<Scalars['Int']>;
  highLevelClaim?: InputMaybe<HighLevelClaim>;
  id?: InputMaybe<Scalars['String']>;
  includeVersions?: InputMaybe<Scalars['Boolean']>;
  latest?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['String']>;
  paymentIds?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Status>;
  subStatus?: InputMaybe<MelioDbCaseSubStatus>;
};


export type QueryMerchantConfigurationArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryMerchantConfigurationCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryMicroDepositArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryMicroDepositBlackListArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryMicroDepositBlackListCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryMicroDepositCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryMicroDepositsDebitArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryMicroDepositsDebitCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryModuleByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryModuleManyArgs = {
  filter?: InputMaybe<FilterFindManyModuleInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyModuleInput>;
};


export type QueryModuleRoutesByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryModuleRoutesManyArgs = {
  filter?: InputMaybe<FilterFindManyModuleRoutesInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyModuleRoutesInput>;
};


export type QueryModuleRoutesManyByIdsArgs = {
  _ids: Array<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsModuleRoutesInput>;
};


export type QueryModuleRoutesOneArgs = {
  filter?: InputMaybe<FilterFindOneModuleRoutesInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneModuleRoutesInput>;
};


export type QueryNaicsIndustriesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  naicsCode?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryNaicsIndustriesCountArgs = {
  naicsCode?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryNightlyPaymentPayloadArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryNightlyPaymentPayloadCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryNormalizedEmailArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryNormalizedEmailCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryNotificationGroupArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryNotificationGroupCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryNotificationGroupEmailTemplateArgs = {
  emailTemplateId?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  notificationGroupId?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryNotificationGroupEmailTemplateCountArgs = {
  emailTemplateId?: InputMaybe<Scalars['Int']>;
  notificationGroupId?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryNotificationPreferenceArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryNotificationPreferenceCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOffShiftUsersArgs = {
  teamName?: InputMaybe<Scalars['String']>;
};


export type QueryOnboardingIndustryArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOnboardingIndustryCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOnboardingSubIndustryArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOnboardingSubIndustryCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOptedOutOfSaleUserArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOptedOutOfSaleUserCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOrgHasChargebacksArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
};


export type QueryOrgLinkingArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
};


export type QueryOrgOwesUsMoneyArgs = {
  organizationId: Scalars['Int'];
};


export type QueryOrganizationArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOrganizationBillingFeeArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOrganizationBillingFeeCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOrganizationBrandingArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOrganizationBrandingCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOrganizationContactArgs = {
  contactId?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOrganizationContactCountArgs = {
  contactId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOrganizationCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOrganizationDetailsArgs = {
  organizationId: Scalars['String'];
};


export type QueryOrganizationHasVendorArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOrganizationHasVendorCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOrganizationKybActionArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOrganizationKybActionCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOrganizationNaicsIndustryArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOrganizationNaicsIndustryCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOrganizationNotesArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
};


export type QueryOrganizationPlanArgs = {
  organizationId: Scalars['Int'];
  planId?: InputMaybe<Scalars['String']>;
};


export type QueryOrganizationPreferenceArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOrganizationPreferenceCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOrganizationQuestionnaireArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOrganizationQuestionnaireCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOrganizationSyncActivityArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOrganizationSyncActivityCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOrganizationSyncMetadataArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOrganizationSyncMetadataCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOrganizationUltimateBeneficialOwnerTypeArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOrganizationUltimateBeneficialOwnerTypeCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOrganizationVendorTraitsArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOrganizationVendorTraitsCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOrganizationsToBusinessesArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryOrganizationsToBusinessesCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPaperCheckArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPaperCheckCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPartnerArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPartnerAuthProviderConfigArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPartnerAuthProviderConfigCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPartnerBankAccountIconArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPartnerBankAccountIconCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPartnerCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPartnerDetailsArgs = {
  partnerId: Scalars['String'];
};


export type QueryPartnerFeeCatalogArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPartnerFeeCatalogCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPartnerFeesArgs = {
  partnerId: Scalars['String'];
};


export type QueryPartnerKeyArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPartnerKeyCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPartnerPaymentAccountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPartnerPaymentAccountCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPartnerPaymentAccountTypeArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPartnerPaymentAccountTypeCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPaymentArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPaymentApprovalActionArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPaymentApprovalActionCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPaymentApprovalDecisionArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPaymentApprovalDecisionCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPaymentCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPaymentIntentArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPaymentIntentCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPaymentNotesArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
};


export type QueryPaymentReceiptFileArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPaymentReceiptFileCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPaymentRequestArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPaymentRequestCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPaymentRequestExternalReferenceArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPaymentRequestExternalReferenceCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPaymentRequestOrganizationAssignmentArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPaymentRequestOrganizationAssignmentCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPaymentRetriesArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPaymentRetriesCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPaymentSyncActivityArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPaymentSyncActivityCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPaymentSyncMetadataArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPaymentSyncMetadataCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPaymentsDbGetTransfersByPaymentIdArgs = {
  paymentId: Scalars['Int'];
};


export type QueryPayorDetailsArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPayorDetailsCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPaypalBalanceAccountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPaypalBalanceAccountCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPersonalCompletedTasksArgs = {
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
  taskType?: InputMaybe<EntityType>;
};


export type QueryPersonalConcernAreasCompletedTasksArgs = {
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};


export type QueryPersonalConcernAreasDashboardArgs = {
  date: Scalars['Date'];
};


export type QueryPersonalOrganizationTasksArgs = {
  date: Scalars['Date'];
};


export type QueryPersonalPaymentTasksArgs = {
  date: Scalars['Date'];
};


export type QueryPlaidAccountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPlaidAccountCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPlaidInstitutionInformationArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPlaidInstitutionInformationCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPlaidItemArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPlaidItemCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPlaidItemIdentityArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPlaidItemIdentityCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPolicyPermittedEntityArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPolicyPermittedEntityCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPreviewSubscriptionArgs = {
  organizationId: Scalars['Int'];
  planCyclePeriod?: InputMaybe<PlanCyclePeriod>;
  quantity?: InputMaybe<Scalars['Int']>;
  subscriptionPlanId: Scalars['String'];
  subscriptionPromoCode?: InputMaybe<Scalars['String']>;
};


export type QueryPromoCodeArgs = {
  code: Scalars['String'];
};


export type QueryPromotionArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPromotionCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPromotionsTemplateArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPromotionsTemplateCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPushToDebitConfigurationArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryPushToDebitConfigurationCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryQueryAuditTrailEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientIp?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  includeTotalCount?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['String'];
  sort?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryQueryAuditTrailTotalCountArgs = {
  organizationId: Scalars['String'];
};


export type QueryQueryCustomerApprovalEventsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['Int'];
};


export type QueryQueryCustomerApprovalTotalCountArgs = {
  organizationId: Scalars['Int'];
};


export type QueryQuickbooksDesktopCompanyArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryQuickbooksDesktopCompanyCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryRailsByPaymentIdArgs = {
  paymentId: Scalars['Int'];
};


export type QueryReceivableOrganizationMetadataArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryReceivableOrganizationMetadataCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryReceivablePaymentAttachmentArgs = {
  fileId?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  receivablePaymentId?: InputMaybe<Scalars['Int']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryReceivablePaymentAttachmentCountArgs = {
  fileId?: InputMaybe<Scalars['Int']>;
  receivablePaymentId?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryReceivablePaymentDetailsArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryReceivablePaymentDetailsCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryRecoSummaryArgs = {
  accountType?: InputMaybe<AccountType>;
  from: Scalars['String'];
  to: Scalars['String'];
};


export type QueryReconBankRecordUpdateValidationArgs = {
  recordId: Scalars['String'];
  transferIdsBatch?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryRecordByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryRecordByIdsArgs = {
  _ids: Array<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsCardRecordInput>;
};


export type QueryRecordConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FilterFindManyCardRecordInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortConnectionCardRecordEnum>;
};


export type QueryRecordCountArgs = {
  filter?: InputMaybe<FilterCountCardRecordInput>;
};


export type QueryRecordManyArgs = {
  filter?: InputMaybe<FilterFindManyCardRecordInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyCardRecordInput>;
};


export type QueryRecordOneArgs = {
  filter?: InputMaybe<FilterFindOneCardRecordInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneCardRecordInput>;
};


export type QueryRecordPaginationArgs = {
  filter?: InputMaybe<FilterFindManyCardRecordInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyCardRecordInput>;
};


export type QueryRecurringBillArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryRecurringBillCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryReminderArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryReminderCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryRenderCommunicationTemplateArgs = {
  communicationType?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  editorMode?: InputMaybe<Scalars['Boolean']>;
  partner: Scalars['String'];
  recipientType?: InputMaybe<CommunicationRecipientTypes>;
};


export type QueryRiskDecisionCodeArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryRiskDecisionCodeCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryRiskEngineDecisionArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryRiskEngineDecisionCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryRiskEngineDecisionMetadataArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryRiskEngineDecisionMetadataCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryRobinhoodDecisionReportByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryRobinhoodDecisionReportByIdsArgs = {
  _ids: Array<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsDecisionReportInput>;
};


export type QueryRobinhoodDecisionReportConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FilterFindManyDecisionReportInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortConnectionDecisionReportEnum>;
};


export type QueryRobinhoodDecisionReportCountArgs = {
  filter?: InputMaybe<FilterCountDecisionReportInput>;
};


export type QueryRobinhoodDecisionReportManyArgs = {
  filter?: InputMaybe<FilterFindManyDecisionReportInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyDecisionReportInput>;
};


export type QueryRobinhoodDecisionReportOneArgs = {
  filter?: InputMaybe<FilterFindOneDecisionReportInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneDecisionReportInput>;
};


export type QueryRobinhoodDecisionReportPaginationArgs = {
  filter?: InputMaybe<FilterFindManyDecisionReportInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyDecisionReportInput>;
};


export type QueryRobinhoodRuleByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryRobinhoodRuleByIdsArgs = {
  _ids: Array<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsRuleInput>;
};


export type QueryRobinhoodRuleConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FilterFindManyRuleInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortConnectionRuleEnum>;
};


export type QueryRobinhoodRuleCountArgs = {
  filter?: InputMaybe<FilterCountRuleInput>;
};


export type QueryRobinhoodRuleManyArgs = {
  filter?: InputMaybe<FilterFindManyRuleInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyRuleInput>;
};


export type QueryRobinhoodRuleOneArgs = {
  filter?: InputMaybe<FilterFindOneRuleInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneRuleInput>;
};


export type QueryRobinhoodRulePaginationArgs = {
  filter?: InputMaybe<FilterFindManyRuleInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyRuleInput>;
};


export type QueryRobinhoodStrategyByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryRobinhoodStrategyByIdsArgs = {
  _ids: Array<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsStrategyInput>;
};


export type QueryRobinhoodStrategyConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FilterFindManyStrategyInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortConnectionStrategyEnum>;
};


export type QueryRobinhoodStrategyCountArgs = {
  filter?: InputMaybe<FilterCountStrategyInput>;
};


export type QueryRobinhoodStrategyManyArgs = {
  filter?: InputMaybe<FilterFindManyStrategyInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyStrategyInput>;
};


export type QueryRobinhoodStrategyOneArgs = {
  filter?: InputMaybe<FilterFindOneStrategyInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneStrategyInput>;
};


export type QueryRobinhoodStrategyPaginationArgs = {
  filter?: InputMaybe<FilterFindManyStrategyInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyStrategyInput>;
};


export type QueryRoleByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryRoleByIdsArgs = {
  _ids: Array<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsRoleInput>;
};


export type QueryRoleConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FilterFindManyRoleInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortConnectionRoleEnum>;
};


export type QueryRoleCountArgs = {
  filter?: InputMaybe<FilterCountRoleInput>;
};


export type QueryRoleManyArgs = {
  filter?: InputMaybe<FilterFindManyRoleInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyRoleInput>;
};


export type QueryRoleOneArgs = {
  filter?: InputMaybe<FilterFindOneRoleInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneRoleInput>;
};


export type QueryRolePaginationArgs = {
  filter?: InputMaybe<FilterFindManyRoleInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyRoleInput>;
};


export type QueryRppsAccountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryRppsAccountCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryRubyLogicFieldsArgs = {
  collection?: InputMaybe<Scalars['String']>;
};


export type QueryRuleStrategiesArgs = {
  ruleId?: InputMaybe<Scalars['Int']>;
};


export type QuerySanctionScreeningDecisionArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QuerySanctionScreeningDecisionCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QuerySanctionScreeningItemArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QuerySanctionScreeningItemCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QuerySbbFiservUserMappingArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QuerySbbFiservUserMappingCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QuerySbcCardDetailsArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QuerySbcCardDetailsCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryScannedInvoiceArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryScannedInvoiceCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryScannedInvoiceLineItemArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryScannedInvoiceLineItemCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QuerySearchCountArgs = {
  entityId?: InputMaybe<Scalars['Int']>;
  resource?: InputMaybe<Resource>;
};


export type QuerySearchRulesArgs = {
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type QuerySelfServeRefundArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QuerySelfServeRefundCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryServiceChargeCatalogArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryServiceChargeCatalogCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryShadowCandidateStrategyArgs = {
  strategyId: Scalars['String'];
};


export type QuerySherlockUserCountArgs = {
  filter?: InputMaybe<FilterFindManysherlockUserInput>;
};


export type QueryShiftArgs = {
  teamName?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<LabelType>;
};


export type QueryShiftConcernAreasByIdArgs = {
  shiftId?: InputMaybe<Scalars['MongoID']>;
  teamName?: InputMaybe<Scalars['String']>;
};


export type QueryShiftConcernAreasSummaryByTeamArgs = {
  teamName?: InputMaybe<Scalars['String']>;
};


export type QueryShiftVirtualCardToAchPaymentCredentialsArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryShiftVirtualCardToAchPaymentCredentialsCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryShopifyShopArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryShopifyShopCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryShopifyStockyApiKeyArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryShopifyStockyApiKeyCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QuerySimilarBusinessesArgs = {
  taskIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type QuerySlotByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QuerySlotByIdsArgs = {
  _ids: Array<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsSlotInput>;
};


export type QuerySlotConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FilterFindManySlotInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortConnectionSlotEnum>;
};


export type QuerySlotCountArgs = {
  filter?: InputMaybe<FilterFindManySlotInput>;
};


export type QuerySlotManyArgs = {
  filter?: InputMaybe<FilterFindManySlotInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortFindManySlotInput>>;
};


export type QuerySlotOneArgs = {
  filter?: InputMaybe<FilterFindOneSlotInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneSlotInput>;
};


export type QuerySlotPaginationArgs = {
  filter?: InputMaybe<FilterFindManySlotInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManySlotInput>;
};


export type QuerySquadByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QuerySquadByIdsArgs = {
  _ids: Array<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsSquadInput>;
};


export type QuerySquadConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FilterFindManySquadInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortConnectionSquadEnum>;
};


export type QuerySquadCountArgs = {
  filter?: InputMaybe<FilterCountSquadInput>;
};


export type QuerySquadManyArgs = {
  filter?: InputMaybe<FilterFindManySquadInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManySquadInput>;
};


export type QuerySquadOneArgs = {
  filter?: InputMaybe<FilterFindOneSquadInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneSquadInput>;
};


export type QuerySquadPaginationArgs = {
  filter?: InputMaybe<FilterFindManySquadInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManySquadInput>;
};


export type QueryStrategyRuleByIdArgs = {
  ruleId?: InputMaybe<Scalars['Int']>;
};


export type QueryStrategyRuleByNameArgs = {
  name?: InputMaybe<Scalars['String']>;
};


export type QueryStrategyRulesArgs = {
  entityType?: InputMaybe<Scalars['String']>;
};


export type QueryStrategyVersionsArgs = {
  fields?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  strategyName: Scalars['String'];
};


export type QuerySubIndustryArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QuerySubIndustryCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QuerySuggestedBillerArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QuerySuggestedBillerCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QuerySupplierArgs = {
  entityId?: InputMaybe<Scalars['String']>;
  entityType?: InputMaybe<SupplierTypeEnum>;
};


export type QuerySupplierClusterAddressesDetailsArgs = {
  clusterId?: InputMaybe<Scalars['String']>;
};


export type QuerySupplierClusterBusinessNamesDetailsArgs = {
  clusterId?: InputMaybe<Scalars['String']>;
};


export type QuerySupplierClusterContactNamesDetailsArgs = {
  clusterId?: InputMaybe<Scalars['String']>;
};


export type QuerySupplierClusterDeliveryMethodsDetailsArgs = {
  clusterId?: InputMaybe<Scalars['String']>;
};


export type QuerySupplierClusterEmailsDetailsArgs = {
  clusterId?: InputMaybe<Scalars['String']>;
};


export type QuerySupplierClusterLocalVendorsArgs = {
  clusterId?: InputMaybe<Scalars['String']>;
};


export type QuerySupplierClusterPhonesDetailsArgs = {
  clusterId?: InputMaybe<Scalars['String']>;
};


export type QuerySupplierClusterSimilarBusinessesArgs = {
  clusterId?: InputMaybe<Scalars['String']>;
};


export type QuerySupplierClusterStatisticsArgs = {
  clusterId?: InputMaybe<Scalars['String']>;
};


export type QuerySyncActivityArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QuerySyncActivityCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QuerySyncExternalFailedObjectArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QuerySyncExternalFailedObjectCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryTaggingByEntityIdArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
};


export type QueryTaskByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryTaskByIdsArgs = {
  _ids: Array<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsTaskInput>;
};


export type QueryTaskConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FilterFindManyTaskInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortConnectionTaskEnum>;
};


export type QueryTaskCountArgs = {
  filter?: InputMaybe<FilterFindManyTaskInput>;
};


export type QueryTaskManyArgs = {
  filter?: InputMaybe<FilterFindManyTaskInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortFindManyTaskInput>>;
};


export type QueryTaskOneArgs = {
  filter?: InputMaybe<FilterFindOneTaskInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneTaskInput>;
};


export type QueryTaskPaginationArgs = {
  filter?: InputMaybe<FilterFindManyTaskInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyTaskInput>;
};


export type QueryTaskTotalCountArgs = {
  entityType: Scalars['String'];
  filter?: InputMaybe<FilterFindManyTaskInput>;
};


export type QueryTaxRateArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryTaxRateCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryTaxVerificationDataArgs = {
  organizationId: Scalars['Int'];
};


export type QueryTaxpayerIdentificationRequestArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryTaxpayerIdentificationRequestCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryTaxpayerInfoArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryTaxpayerInfoCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryTeamByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryTeamByIdsArgs = {
  _ids: Array<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsTeamInput>;
};


export type QueryTeamConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FilterFindManyTeamInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortConnectionTeamEnum>;
};


export type QueryTeamCountArgs = {
  filter?: InputMaybe<FilterCountTeamInput>;
};


export type QueryTeamIntegrationByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryTeamIntegrationByIdsArgs = {
  _ids: Array<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsTeamIntegrationInput>;
};


export type QueryTeamIntegrationConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FilterFindManyTeamIntegrationInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortConnectionTeamIntegrationEnum>;
};


export type QueryTeamIntegrationCountArgs = {
  filter?: InputMaybe<FilterCountTeamIntegrationInput>;
};


export type QueryTeamIntegrationManyArgs = {
  filter?: InputMaybe<FilterFindManyTeamIntegrationInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortFindManyTeamIntegrationInput>>;
};


export type QueryTeamIntegrationOneArgs = {
  filter?: InputMaybe<FilterFindOneTeamIntegrationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneTeamIntegrationInput>;
};


export type QueryTeamIntegrationPaginationArgs = {
  filter?: InputMaybe<FilterFindManyTeamIntegrationInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyTeamIntegrationInput>;
};


export type QueryTeamManyArgs = {
  filter?: InputMaybe<FilterFindManyTeamInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyTeamInput>;
};


export type QueryTeamOneArgs = {
  filter?: InputMaybe<FilterFindOneTeamInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneTeamInput>;
};


export type QueryTeamPaginationArgs = {
  filter?: InputMaybe<FilterFindManyTeamInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyTeamInput>;
};


export type QueryThreadInfoArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
};


export type QueryTodoArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryTodoActionArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryTodoActionCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryTodoCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryTransactionArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryTransactionCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryTransactionsDataArgs = {
  organizationId: Scalars['Int'];
};


export type QueryTransfersArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
};


export type QueryTransfersCountArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
};


export type QueryUboDataArgs = {
  organizationId: Scalars['Int'];
};


export type QueryUhvInfoArgs = {
  organizationId: Scalars['Int'];
};


export type QueryUnilateralRequestArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryUnilateralRequestCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryUserActivityStatusArgs = {
  id: Scalars['String'];
};


export type QueryUserAutoCompleteArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryUserByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryUserByIdsArgs = {
  _ids: Array<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdssherlockUserInput>;
};


export type QueryUserConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FilterFindManysherlockUserInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortConnectionsherlockUserEnum>;
};


export type QueryUserCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryUserEmailLogArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryUserEmailLogCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryUserEntitlementsTypeArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryUserEntitlementsTypeCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryUserGroupArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryUserGroupCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryUserIntuitCredentialArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryUserIntuitCredentialCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryUserLoginTokenArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryUserLoginTokenCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryUserManyArgs = {
  filter?: InputMaybe<FilterFindManysherlockUserInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManysherlockUserInput>;
};


export type QueryUserOAuthCredentialArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryUserOAuthCredentialCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryUserOneArgs = {
  filter?: InputMaybe<FilterFindOnesherlockUserInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOnesherlockUserInput>;
};


export type QueryUserOrganizationArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryUserOrganizationCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryUserPaginationArgs = {
  filter?: InputMaybe<FilterFindManysherlockUserInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManysherlockUserInput>;
};


export type QueryUserPreferenceArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryUserPreferenceCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryUserQuickbooksCredentialArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryUserQuickbooksCredentialCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryUserToNormalizedEmailArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryUserToNormalizedEmailCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryValidatePromoCodeArgs = {
  code: Scalars['String'];
  organizationId: Scalars['Int'];
};


export type QueryVendorArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVendorCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVendorCreditsArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVendorCreditsCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVendorCreditsPaymentsArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVendorCreditsPaymentsCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVendorExternalReferencesArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVendorExternalReferencesCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVendorLinkArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVendorLinkCandidateArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVendorLinkCandidateCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVendorLinkCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVendorOnboardingSessionsArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVendorOnboardingSessionsCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVendorPaymentLinkArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVendorPaymentLinkCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVendorPortalConnectionArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVendorPortalConnectionCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVendorPreferenceArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVendorPreferenceCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVendorSyncActivityArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVendorSyncActivityCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVendorUserGroupArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  userGroupId?: InputMaybe<Scalars['Int']>;
  vendorId?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVendorUserGroupCountArgs = {
  userGroupId?: InputMaybe<Scalars['Int']>;
  vendorId?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVirtualAccountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVirtualAccountCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVirtualCardArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVirtualCardAccountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVirtualCardAccountCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVirtualCardCandidatesArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVirtualCardCandidatesCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVirtualCardCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVoidCheckArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryVoidCheckCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryWhitepagesArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
};


export type QueryWorkflowCriteriaArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryWorkflowCriteriaCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryWorkflowEntityUserNotificationArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryWorkflowEntityUserNotificationCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryWorkflowProgressArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryWorkflowProgressCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryWorkflowStepArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryWorkflowStepCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryWorkflowStepProgressArgs = {
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryWorkflowStepProgressCountArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type QueryWorkflowStepUserApproverArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  upToDate?: InputMaybe<Scalars['Date']>;
  userId?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
  workflowStepId?: InputMaybe<Scalars['Int']>;
};


export type QueryWorkflowStepUserApproverCountArgs = {
  userId?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
  workflowStepId?: InputMaybe<Scalars['Int']>;
};


export type QueryXeroOnBoardingArgs = {
  externalOrganizationId: Scalars['String'];
  organization?: InputMaybe<OrganizationDetailsInput>;
  user?: InputMaybe<UserDetailsInput>;
};


export type QueryZendeskFieldsArgs = {
  entity?: InputMaybe<DescribeEntity>;
  operation?: InputMaybe<DescribeOperation>;
  ticketFormId?: InputMaybe<Scalars['Float']>;
};


export type QueryZendeskGroupsArgs = {
  groupId?: InputMaybe<Scalars['Float']>;
};

export type Rails = {
  __typename?: 'Rails';
  rails?: Maybe<Array<Maybe<RailsTypeEnum>>>;
};

export type RecoSummaryByBankType = {
  __typename?: 'RecoSummaryByBankType';
  ach?: Maybe<BankRecordTypeSummaryGraphQlType>;
  card?: Maybe<BankRecordTypeSummaryGraphQlType>;
  check?: Maybe<BankRecordTypeSummaryGraphQlType>;
};

export type RecoSummaryByFinancialInstitutions = {
  __typename?: 'RecoSummaryByFinancialInstitutions';
  evolve?: Maybe<FinancialInstitutionSummaryGraphQlType>;
  jpm?: Maybe<FinancialInstitutionSummaryGraphQlType>;
  svb?: Maybe<FinancialInstitutionSummaryGraphQlType>;
};

export type RecoSummaryType = {
  __typename?: 'RecoSummaryType';
  credit?: Maybe<DirectionSummaryGraphQlType>;
  debit?: Maybe<DirectionSummaryGraphQlType>;
  summaryByBankType?: Maybe<RecoSummaryByBankType>;
  summaryByFinancialInstitution?: Maybe<RecoSummaryByFinancialInstitutions>;
  totalReconciledRecords?: Maybe<Scalars['Float']>;
  totalReconciledSumOfMoney?: Maybe<Scalars['Float']>;
  totalRecords?: Maybe<Scalars['Float']>;
  totalSumOfMoney?: Maybe<Scalars['Float']>;
  totalUnreconciledRecords?: Maybe<Scalars['Float']>;
  totalUnreconciledSumOfMoney?: Maybe<Scalars['Float']>;
};

export type ReconBankRecordUpdateValidationType = {
  __typename?: 'ReconBankRecordUpdateValidationType';
  failureData?: Maybe<UpdateBankRecordValidationResponseFailureDataType>;
  valid: Scalars['Boolean'];
};

export type RecurringOccurrenceInfo = {
  __typename?: 'RecurringOccurrenceInfo';
  amount?: Maybe<Scalars['Float']>;
  endDate?: Maybe<Scalars['Date']>;
  endPolicy?: Maybe<SubscriptionEndPolicy>;
  intervalType?: Maybe<SubscriptionIntervalType>;
  numOfOccurrences?: Maybe<Scalars['Int']>;
  occurrenceNumber?: Maybe<Scalars['Int']>;
  status?: Maybe<SubscriptionStatus>;
};

export type ReferenceType = {
  __typename?: 'ReferenceType';
  note?: Maybe<Scalars['String']>;
  source?: Maybe<SourceEnum>;
};

export enum RefundFeeProcessingPaymentRequestReasonEnum {
  DelayedPayment = 'DelayedPayment',
  FailedStopped = 'FailedStopped',
  FraudulentActivity = 'FraudulentActivity',
  Subscription = 'Subscription'
}

export enum ReimbursementReason {
  FraudulentActivity = 'FraudulentActivity',
  PaymentOther = 'PaymentOther'
}

export type RemoveByIdConcernAreaSchemaPayload = {
  __typename?: 'RemoveByIdConcernAreaSchemaPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<ConcernAreaSchema>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type RemoveByIdGayaThemePayload = {
  __typename?: 'RemoveByIdGayaThemePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<GayaTheme>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type RemoveByIdModuleRoutesPayload = {
  __typename?: 'RemoveByIdModuleRoutesPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<ModuleRoutes>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type RemoveTag = {
  __typename?: 'RemoveTag';
  entity?: Maybe<Scalars['String']>;
  ids?: Maybe<Array<Maybe<Scalars['String']>>>;
  propertyName?: Maybe<Scalars['String']>;
  tagName?: Maybe<Scalars['String']>;
  tagsRemove?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ResolutionSize = {
  __typename?: 'ResolutionSize';
  isConsistent?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export enum RestrictedScope {
  AddNewUser = 'AddNewUser',
  AddVendor = 'AddVendor',
  AllowSubscription = 'AllowSubscription',
  CreateInternationalPayment = 'CreateInternationalPayment',
  CreateNewOrg = 'CreateNewOrg',
  CreatePayment = 'CreatePayment',
  DeleteInternationalPayment = 'DeleteInternationalPayment',
  DeletePayment = 'DeletePayment',
  EditInternationalPayment = 'EditInternationalPayment',
  EditPayment = 'EditPayment',
  EditSubscriptionFundingSource = 'EditSubscriptionFundingSource',
  Login = 'Login',
  MaintainRecurringPayment = 'MaintainRecurringPayment',
  SendCommsFromOrg = 'SendCommsFromOrg'
}

export type RiskStatusPaymentsStatisticsObjectTc = {
  __typename?: 'RiskStatusPaymentsStatisticsObjectTC';
  approved?: Maybe<SupplierClusterPaymentsStatisticsFieldsObjectTc>;
  declined?: Maybe<SupplierClusterPaymentsStatisticsFieldsObjectTc>;
  pending?: Maybe<SupplierClusterPaymentsStatisticsFieldsObjectTc>;
};

export type RiskTimeline = {
  __typename?: 'RiskTimeline';
  riskStatus?: Maybe<PaymentApprovalResult>;
};

export type Role = {
  __typename?: 'Role';
  _id: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  forbiddenGroupEntities: Array<GroupEntity>;
  forbiddenGroupEntityIds?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  name: Scalars['String'];
  team?: Maybe<Team>;
  teamId: Scalars['MongoID'];
  updatedAt?: Maybe<Scalars['Date']>;
};


export type RoleForbiddenGroupEntitiesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsGroupEntityInput>;
};

/** A connection to a list of items. */
export type RoleConnection = {
  __typename?: 'RoleConnection';
  /** Total object count. */
  count: Scalars['Int'];
  /** Information to aid in pagination. */
  edges: Array<RoleEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RoleEdge = {
  __typename?: 'RoleEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Role;
};

/** List of items with pagination. */
export type RolePagination = {
  __typename?: 'RolePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Role>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type Rubric = {
  __typename?: 'Rubric';
  _id: Scalars['MongoID'];
  createdBy?: Maybe<Scalars['MongoID']>;
  entity?: Maybe<Scalars['String']>;
  fields?: Maybe<Array<Maybe<RubricFields>>>;
  name?: Maybe<Scalars['String']>;
  tableCollection?: Maybe<Scalars['String']>;
  type?: Maybe<EnumRubricType>;
  updatedBy?: Maybe<Scalars['MongoID']>;
  view?: Maybe<WatsonView>;
};


export type RubricViewArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneWatsonViewInput>;
};

export type RubricFields = {
  __typename?: 'RubricFields';
  displayName?: Maybe<Scalars['String']>;
  displayText?: Maybe<Scalars['String']>;
  displayType?: Maybe<EnumRubricFieldsDisplayType>;
  key?: Maybe<Scalars['String']>;
  linkFormat?: Maybe<Scalars['String']>;
};

export type RubricFieldsInput = {
  displayName?: InputMaybe<Scalars['String']>;
  displayText?: InputMaybe<Scalars['String']>;
  displayType?: InputMaybe<EnumRubricFieldsDisplayType>;
  key?: InputMaybe<Scalars['String']>;
  linkFormat?: InputMaybe<Scalars['String']>;
};

export type Rule = {
  __typename?: 'Rule';
  _id: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  logic?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
  tree?: Maybe<Scalars['JSON']>;
  updatedAt?: Maybe<Scalars['Date']>;
  version?: Maybe<Scalars['Float']>;
};

/** A connection to a list of items. */
export type RuleConnection = {
  __typename?: 'RuleConnection';
  /** Total object count. */
  count: Scalars['Int'];
  /** Information to aid in pagination. */
  edges: Array<RuleEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export enum RuleDecision {
  accept = 'accept',
  approved = 'approved',
  block = 'block',
  blockCompliance = 'blockCompliance',
  blockRisk = 'blockRisk',
  declined = 'declined',
  eligible = 'eligible',
  ineligible = 'ineligible',
  pending = 'pending',
  reject = 'reject',
  undecided = 'undecided'
}

/** An edge in a connection. */
export type RuleEdge = {
  __typename?: 'RuleEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Rule;
};

export type RuleInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  logic?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  tree?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  version?: InputMaybe<Scalars['Float']>;
};

/** List of items with pagination. */
export type RulePagination = {
  __typename?: 'RulePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Rule>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type RuleProperties = {
  __typename?: 'RuleProperties';
  _id?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['JSON']>;
  decision?: Maybe<RuleDecision>;
  entityType?: Maybe<Scalars['String']>;
  labelIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  limitations?: Maybe<Scalars['JSON']>;
  mos?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  riskDecisionCodeId?: Maybe<Scalars['Int']>;
  ruleId?: Maybe<Scalars['Int']>;
  subcategory?: Maybe<Scalars['String']>;
};

export type RuleStrategyName = {
  __typename?: 'RuleStrategyName';
  strategyName?: Maybe<Scalars['String']>;
};

export type RuntimeError = ErrorInterface & {
  __typename?: 'RuntimeError';
  /** Runtime error message */
  message?: Maybe<Scalars['String']>;
};

export type ScreenSize = {
  __typename?: 'ScreenSize';
  isConsistent?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type SherlockDecisionTaggingEntityCachedData = {
  __typename?: 'SherlockDecisionTaggingEntityCachedData';
  bill: SherlockDecisionTaggingEntityCachedDataBill;
  deliveryMethod: SherlockDecisionTaggingEntityCachedDataDeliveryMethod;
  enrichmentData?: Maybe<Scalars['JSON']>;
  features?: Maybe<SherlockDecisionTaggingEntityCachedDataFeatures>;
  firstBlockingRiskEngineDecisionDate?: Maybe<Scalars['Date']>;
  fundingSource: SherlockDecisionTaggingEntityCachedDataFundingSource;
  organization: SherlockDecisionTaggingEntityCachedDataOrganization;
  payment: SherlockDecisionTaggingEntityCachedDataPayment;
  recurringBill: SherlockDecisionTaggingEntityCachedDataRecurringBill;
  riskEngineDecision?: Maybe<SherlockDecisionTaggingEntityCachedDataRiskEngineDecision>;
  tagNames?: Maybe<SherlockDecisionTaggingEntityCachedDataTagNames>;
  vendor: SherlockDecisionTaggingEntityCachedDataVendor;
};

export type SherlockDecisionTaggingEntityCachedDataBill = {
  __typename?: 'SherlockDecisionTaggingEntityCachedDataBill';
  currency?: Maybe<Scalars['String']>;
  recurringBillIndex?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
};

export type SherlockDecisionTaggingEntityCachedDataDeliveryMethod = {
  __typename?: 'SherlockDecisionTaggingEntityCachedDataDeliveryMethod';
  createdAt?: Maybe<Scalars['Date']>;
  deliveryType: EnumSherlockDecisionTaggingEntityCachedDataDeliveryMethodDeliveryType;
  id?: Maybe<Scalars['Float']>;
  verifiedStatus?: Maybe<EnumSherlockDecisionTaggingEntityCachedDataDeliveryMethodVerifiedStatus>;
};

export type SherlockDecisionTaggingEntityCachedDataFeatures = {
  __typename?: 'SherlockDecisionTaggingEntityCachedDataFeatures';
  clientIpAgeForOrganization?: Maybe<Scalars['Float']>;
  clientIpAgeForUser?: Maybe<Scalars['Float']>;
  doesOrgOweMoney?: Maybe<Scalars['Boolean']>;
  hasFileRequests?: Maybe<Scalars['Boolean']>;
  invoiceOrNoteHasSanctionedWord?: Maybe<Scalars['Boolean']>;
  invoiceOrNoteHasSanctionedWordError?: Maybe<Scalars['Boolean']>;
  isApFinancingPayment?: Maybe<Scalars['Boolean']>;
  isCardWithSimilarDataApproved?: Maybe<Scalars['Boolean']>;
  isEmailVerified?: Maybe<Scalars['Boolean']>;
  isFRR?: Maybe<Scalars['Boolean']>;
  isGoodsReceived?: Maybe<Scalars['Boolean']>;
  isHighAmountForFS?: Maybe<Scalars['Boolean']>;
  isPaymentExpedited?: Maybe<Scalars['Boolean']>;
  numManuallyApprovedPayments?: Maybe<Scalars['Float']>;
  numOrganizationVendorCompletedPayments?: Maybe<Scalars['Float']>;
  payeeIdmScreeningNumHits?: Maybe<Scalars['Float']>;
  payorCreateOrigin?: Maybe<Scalars['String']>;
  payorIdmScreeningNumHits?: Maybe<Scalars['Float']>;
  vendorHasHandle?: Maybe<Scalars['Boolean']>;
};

export type SherlockDecisionTaggingEntityCachedDataFundingSource = {
  __typename?: 'SherlockDecisionTaggingEntityCachedDataFundingSource';
  bankAccountId?: Maybe<Scalars['Float']>;
  cardAccount?: Maybe<SherlockDecisionTaggingEntityCachedDataFundingSourceCardAccount>;
  intuitAccountId?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  origin?: Maybe<EnumSherlockDecisionTaggingEntityCachedDataFundingSourceOrigin>;
  plaidAccountId?: Maybe<Scalars['Float']>;
};

export type SherlockDecisionTaggingEntityCachedDataFundingSourceCardAccount = {
  __typename?: 'SherlockDecisionTaggingEntityCachedDataFundingSourceCardAccount';
  cardType?: Maybe<Scalars['String']>;
  network?: Maybe<Scalars['String']>;
};

export type SherlockDecisionTaggingEntityCachedDataOrganization = {
  __typename?: 'SherlockDecisionTaggingEntityCachedDataOrganization';
  companyName?: Maybe<Scalars['String']>;
  decision?: Maybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationDecision>;
  id?: Maybe<Scalars['Float']>;
  kybMoneyIn?: Maybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationKybMoneyIn>;
  kybMoneyInSubType?: Maybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationKybMoneyInSubType>;
  kybStatus?: Maybe<Scalars['String']>;
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  taxIdType?: Maybe<EnumSherlockDecisionTaggingEntityCachedDataOrganizationTaxIdType>;
};

export type SherlockDecisionTaggingEntityCachedDataPayment = {
  __typename?: 'SherlockDecisionTaggingEntityCachedDataPayment';
  amount?: Maybe<Scalars['Float']>;
  createOrigin?: Maybe<EnumSherlockDecisionTaggingEntityCachedDataPaymentCreateOrigin>;
  createdAt?: Maybe<Scalars['Date']>;
  createdByEmail?: Maybe<Scalars['String']>;
  createdByPartner?: Maybe<SherlockDecisionTaggingEntityCachedDataPaymentCreatedByPartner>;
  currency?: Maybe<Scalars['String']>;
  direction?: Maybe<EnumSherlockDecisionTaggingEntityCachedDataPaymentDirection>;
  foreignAmount?: Maybe<Scalars['Float']>;
  foreignCurrency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Float']>;
  isPartial?: Maybe<Scalars['Boolean']>;
  paymentApprovalActionReason?: Maybe<Scalars['String']>;
  riskStatus?: Maybe<EnumSherlockDecisionTaggingEntityCachedDataPaymentRiskStatus>;
  scheduledDate?: Maybe<Scalars['Date']>;
};

export type SherlockDecisionTaggingEntityCachedDataPaymentCreatedByPartner = {
  __typename?: 'SherlockDecisionTaggingEntityCachedDataPaymentCreatedByPartner';
  _id?: Maybe<Scalars['MongoID']>;
  companyName?: Maybe<Scalars['String']>;
};

export type SherlockDecisionTaggingEntityCachedDataRecurringBill = {
  __typename?: 'SherlockDecisionTaggingEntityCachedDataRecurringBill';
  occurrences?: Maybe<Scalars['Float']>;
};

export type SherlockDecisionTaggingEntityCachedDataRiskEngineDecision = {
  __typename?: 'SherlockDecisionTaggingEntityCachedDataRiskEngineDecision';
  reason?: Maybe<Scalars['String']>;
};

export type SherlockDecisionTaggingEntityCachedDataTagNames = {
  __typename?: 'SherlockDecisionTaggingEntityCachedDataTagNames';
  organizationDecision?: Maybe<Scalars['String']>;
  organizationLabels?: Maybe<Array<Maybe<Scalars['String']>>>;
  paymentRiskStatus?: Maybe<Scalars['String']>;
};

export type SherlockDecisionTaggingEntityCachedDataVendor = {
  __typename?: 'SherlockDecisionTaggingEntityCachedDataVendor';
  companyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Float']>;
};

export type SherlockEscalationEntityCachedData = {
  __typename?: 'SherlockEscalationEntityCachedData';
  concernAreaDetails?: Maybe<ConcernAreaSchema>;
  concernAreaId?: Maybe<Scalars['MongoID']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['MongoID']>;
  createdByUser?: Maybe<SherlockUser>;
  escalatedTo?: Maybe<EscalatedTo>;
  organization: SherlockEscalationEntityCachedDataOrganization;
  partner?: Maybe<SherlockEscalationEntityCachedDataPartner>;
  reason: Scalars['String'];
  relatedActiveTasks: Array<Task>;
  relatedOrganizationTask?: Maybe<SherlockOrganizationTask>;
  relatedTaskIds?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  relatedTaskInboxType?: Maybe<EnumSherlockEscalationEntityCachedDataRelatedTaskInboxType>;
  relatedTasks: Array<Task>;
};


export type SherlockEscalationEntityCachedDataRelatedActiveTasksArgs = {
  filter?: InputMaybe<FilterFindManyTaskInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyTaskInput>;
};


export type SherlockEscalationEntityCachedDataRelatedOrganizationTaskArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortFindOneSherlockOrganizationTaskInput>>;
};


export type SherlockEscalationEntityCachedDataRelatedTasksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyTaskInput>;
};

export type SherlockEscalationEntityCachedDataOrganization = {
  __typename?: 'SherlockEscalationEntityCachedDataOrganization';
  companyName?: Maybe<Scalars['String']>;
  decision?: Maybe<EnumSherlockEscalationEntityCachedDataOrganizationDecision>;
  id?: Maybe<Scalars['Float']>;
};

export type SherlockEscalationEntityCachedDataPartner = {
  __typename?: 'SherlockEscalationEntityCachedDataPartner';
  companyName: Scalars['String'];
  partnerName: Scalars['String'];
};

export type SherlockOrganizationEntityCachedData = {
  __typename?: 'SherlockOrganizationEntityCachedData';
  _id: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  crrRank?: Maybe<EnumSherlockOrganizationEntityCachedDataCrrRank>;
  detectionDate?: Maybe<Scalars['Date']>;
  lastDecisionDetails?: Maybe<SherlockOrganizationEntityCachedDataLastDecisionDetails>;
  lastEscalatedDetails?: Maybe<SherlockOrganizationEntityCachedDataLastEscalatedDetails>;
  name: Scalars['String'];
  odeMoneyInDecision?: Maybe<EnumSherlockOrganizationEntityCachedDataOdeMoneyInDecision>;
  odeMoneyOutDecision?: Maybe<EnumSherlockOrganizationEntityCachedDataOdeMoneyOutDecision>;
  organizationId: Scalars['Float'];
  origin?: Maybe<EnumSherlockOrganizationEntityCachedDataOrigin>;
  partner?: Maybe<SherlockOrganizationEntityCachedDataPartner>;
  relatedTasksNum?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  taxIdType?: Maybe<EnumSherlockOrganizationEntityCachedDataTaxIdType>;
  tpv?: Maybe<Scalars['Float']>;
  zendeskTickets?: Maybe<Array<Maybe<SherlockOrganizationEntityCachedDataZendeskTickets>>>;
};

export type SherlockOrganizationEntityCachedDataLastDecisionDetails = {
  __typename?: 'SherlockOrganizationEntityCachedDataLastDecisionDetails';
  date?: Maybe<Scalars['Date']>;
  reason?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['MongoID']>;
};

export type SherlockOrganizationEntityCachedDataLastEscalatedDetails = {
  __typename?: 'SherlockOrganizationEntityCachedDataLastEscalatedDetails';
  createdAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  teamIntegrationId?: Maybe<Scalars['MongoID']>;
  userId?: Maybe<Scalars['MongoID']>;
};

export type SherlockOrganizationEntityCachedDataPartner = {
  __typename?: 'SherlockOrganizationEntityCachedDataPartner';
  companyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Float']>;
  partnerName?: Maybe<Scalars['String']>;
};

export type SherlockOrganizationEntityCachedDataZendeskTickets = {
  __typename?: 'SherlockOrganizationEntityCachedDataZendeskTickets';
  id?: Maybe<Scalars['Float']>;
  latestComment?: Maybe<SherlockOrganizationEntityCachedDataZendeskTicketsLatestComment>;
};

export type SherlockOrganizationEntityCachedDataZendeskTicketsLatestComment = {
  __typename?: 'SherlockOrganizationEntityCachedDataZendeskTicketsLatestComment';
  commenter?: Maybe<SherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentCommenter>;
  createdAt?: Maybe<Scalars['Date']>;
  priority?: Maybe<EnumSherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentPriority>;
  status?: Maybe<EnumSherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentStatus>;
};

export type SherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentCommenter = {
  __typename?: 'SherlockOrganizationEntityCachedDataZendeskTicketsLatestCommentCommenter';
  isAnalyst?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type SherlockOrganizationTask = {
  __typename?: 'SherlockOrganizationTask';
  _id: Scalars['MongoID'];
  assignedTo?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  entityCachedData: SherlockOrganizationTaskEntityCachedData;
  entityId?: Maybe<Scalars['String']>;
  labelDetails?: Maybe<Label>;
  labelIds?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  parentTaskId?: Maybe<Scalars['MongoID']>;
  partnerName?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['MongoID']>;
  status: EnumSherlockOrganizationTaskStatus;
  type?: Maybe<EnumSherlockOrganizationTaskType>;
  updatedAt?: Maybe<Scalars['Date']>;
  userDetails?: Maybe<SherlockUser>;
};

export type SherlockOrganizationTaskEntityCachedData = {
  __typename?: 'SherlockOrganizationTaskEntityCachedData';
  _id?: Maybe<Scalars['MongoID']>;
  createdAt?: Maybe<Scalars['Date']>;
  crrRank?: Maybe<EnumSherlockOrganizationTaskEntityCachedDataCrrRank>;
  detectionDate?: Maybe<Scalars['Date']>;
  lastDecisionDetails?: Maybe<SherlockOrganizationTaskEntityCachedDataLastDecisionDetails>;
  lastEscalatedDetails?: Maybe<SherlockOrganizationTaskEntityCachedDataLastEscalatedDetails>;
  name: Scalars['String'];
  odeMoneyInDecision?: Maybe<EnumSherlockOrganizationTaskEntityCachedDataOdeMoneyInDecision>;
  odeMoneyOutDecision?: Maybe<EnumSherlockOrganizationTaskEntityCachedDataOdeMoneyOutDecision>;
  organizationId: Scalars['Float'];
  origin?: Maybe<EnumSherlockOrganizationTaskEntityCachedDataOrigin>;
  partner?: Maybe<SherlockOrganizationTaskEntityCachedDataPartner>;
  state?: Maybe<Scalars['String']>;
  taxIdType?: Maybe<EnumSherlockOrganizationTaskEntityCachedDataTaxIdType>;
  tpv?: Maybe<Scalars['Float']>;
  zendeskTickets?: Maybe<Array<Maybe<SherlockOrganizationTaskEntityCachedDataZendeskTickets>>>;
};

export type SherlockOrganizationTaskEntityCachedDataLastDecisionDetails = {
  __typename?: 'SherlockOrganizationTaskEntityCachedDataLastDecisionDetails';
  date?: Maybe<Scalars['Date']>;
  reason?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['MongoID']>;
};

export type SherlockOrganizationTaskEntityCachedDataLastEscalatedDetails = {
  __typename?: 'SherlockOrganizationTaskEntityCachedDataLastEscalatedDetails';
  createdAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  teamIntegrationId?: Maybe<Scalars['MongoID']>;
  userId?: Maybe<Scalars['MongoID']>;
};

export type SherlockOrganizationTaskEntityCachedDataPartner = {
  __typename?: 'SherlockOrganizationTaskEntityCachedDataPartner';
  companyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Float']>;
  partnerName?: Maybe<Scalars['String']>;
};

export type SherlockOrganizationTaskEntityCachedDataZendeskTickets = {
  __typename?: 'SherlockOrganizationTaskEntityCachedDataZendeskTickets';
  id?: Maybe<Scalars['Float']>;
  latestComment?: Maybe<SherlockOrganizationTaskEntityCachedDataZendeskTicketsLatestComment>;
};

export type SherlockOrganizationTaskEntityCachedDataZendeskTicketsLatestComment = {
  __typename?: 'SherlockOrganizationTaskEntityCachedDataZendeskTicketsLatestComment';
  commenter?: Maybe<SherlockOrganizationTaskEntityCachedDataZendeskTicketsLatestCommentCommenter>;
  createdAt?: Maybe<Scalars['Date']>;
  priority?: Maybe<EnumSherlockOrganizationTaskEntityCachedDataZendeskTicketsLatestCommentPriority>;
  status?: Maybe<EnumSherlockOrganizationTaskEntityCachedDataZendeskTicketsLatestCommentStatus>;
};

export type SherlockOrganizationTaskEntityCachedDataZendeskTicketsLatestCommentCommenter = {
  __typename?: 'SherlockOrganizationTaskEntityCachedDataZendeskTicketsLatestCommentCommenter';
  isAnalyst?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type Shift = {
  __typename?: 'Shift';
  date?: Maybe<Scalars['String']>;
  id: Scalars['MongoID'];
  labels?: Maybe<Array<ShiftLabel>>;
  slots?: Maybe<Array<Slot>>;
};

export type ShiftConcernArea = {
  __typename?: 'ShiftConcernArea';
  assigning?: Maybe<Array<Maybe<Slot>>>;
  atRisk?: Maybe<Scalars['Int']>;
  concernArea?: Maybe<ConcernAreaSchema>;
  delayedPayments?: Maybe<Scalars['Int']>;
  qpRating?: Maybe<Scalars['String']>;
  totalPayments?: Maybe<Scalars['Int']>;
};

export type ShiftConcernAreasSummary = {
  __typename?: 'ShiftConcernAreasSummary';
  atRiskOrganizationsCount?: Maybe<Scalars['Int']>;
  atRiskPayments?: Maybe<Scalars['Int']>;
  delayedOrganizationsCount?: Maybe<Scalars['Int']>;
  delayedPayments?: Maybe<Scalars['Int']>;
  escalatedOrganizationsCount?: Maybe<Scalars['Int']>;
  escalatedPayments?: Maybe<Scalars['Int']>;
  openConcernAreas?: Maybe<Scalars['Int']>;
  openConcernAreasOrganizationsCount?: Maybe<Scalars['Int']>;
  openConcernAreasPaymentsCount?: Maybe<Scalars['Int']>;
  pendingPayments?: Maybe<PendingPayments>;
};

export type ShiftLabel = {
  __typename?: 'ShiftLabel';
  assigning?: Maybe<Array<Maybe<Slot>>>;
  atRisk?: Maybe<Scalars['Int']>;
  delayedPayments?: Maybe<Scalars['Int']>;
  label?: Maybe<Label>;
  organizationIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  qpRating?: Maybe<Scalars['String']>;
  relatedEntityTaskCount?: Maybe<Scalars['Int']>;
  tasksCount?: Maybe<Scalars['Int']>;
  totalPayments?: Maybe<Scalars['Int']>;
};

export type SimilarBusinessAdditionalDataType = {
  __typename?: 'SimilarBusinessAdditionalDataType';
  organizationId?: Maybe<Scalars['Int']>;
};

export type SimilarBusinessAddressType = {
  __typename?: 'SimilarBusinessAddressType';
  addressLine1?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<BusinessPropertyTag>>>;
  zipCode?: Maybe<Scalars['String']>;
};

export type SimilarBusinessBankAccountType = {
  __typename?: 'SimilarBusinessBankAccountType';
  accountNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  routingNumber?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<BusinessPropertyTag>>>;
};

export type SimilarBusinessBusinessNameType = {
  __typename?: 'SimilarBusinessBusinessNameType';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<BusinessPropertyTag>>>;
  type?: Maybe<BusinessNameTypes>;
};

export type SimilarBusinessContactType = {
  __typename?: 'SimilarBusinessContactType';
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<BusinessPropertyTag>>>;
};

export type SimilarBusinessDataType = {
  __typename?: 'SimilarBusinessDataType';
  addresses?: Maybe<Array<Maybe<SimilarBusinessAddressType>>>;
  bankAccounts?: Maybe<Array<Maybe<SimilarBusinessBankAccountType>>>;
  businessNames?: Maybe<Array<Maybe<SimilarBusinessBusinessNameType>>>;
  businessRelationshipTypes?: Maybe<Array<Maybe<SimilarBusinessRelationshipType>>>;
  contacts?: Maybe<Array<Maybe<SimilarBusinessContactType>>>;
  emails?: Maybe<Array<Maybe<SimilarBusinessEmailType>>>;
  virtualCard?: Maybe<SimilarBusinessVirtualCardType>;
};

export type SimilarBusinessEmailType = {
  __typename?: 'SimilarBusinessEmailType';
  address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<BusinessPropertyTag>>>;
};

export enum SimilarBusinessRelationshipType {
  Branch = 'Branch',
  Conglomerate = 'Conglomerate',
  Franchisee = 'Franchisee',
  Franchisor = 'Franchisor',
  PayableCohort = 'PayableCohort',
  Subsidiary = 'Subsidiary'
}

export type SimilarBusinessType = {
  __typename?: 'SimilarBusinessType';
  additionalData?: Maybe<SimilarBusinessAdditionalDataType>;
  businessData?: Maybe<SimilarBusinessDataType>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type SimilarBusinessVirtualCardType = {
  __typename?: 'SimilarBusinessVirtualCardType';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mcc?: Maybe<Scalars['String']>;
  status?: Maybe<VirtualCardStatus>;
};

export type SimulationTriggerResponse = {
  __typename?: 'SimulationTriggerResponse';
  simulationId?: Maybe<Scalars['String']>;
};

export type Slot = {
  __typename?: 'Slot';
  _id: Scalars['MongoID'];
  assignedBy?: Maybe<Scalars['MongoID']>;
  assignedDate?: Maybe<Scalars['Date']>;
  concernAreaSchemaIds?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  concernAreaSchemas?: Maybe<Array<Maybe<ConcernAreaSchema>>>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  endDateTime: Scalars['Date'];
  externalSystemId?: Maybe<Scalars['Float']>;
  labelIds?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  labels?: Maybe<Array<Maybe<Label>>>;
  role: Scalars['String'];
  shiftId: Scalars['MongoID'];
  slotType?: Maybe<Scalars['String']>;
  startDateTime: Scalars['Date'];
  taskCounters: TaskCounters;
  updatedAt?: Maybe<Scalars['Date']>;
  user?: Maybe<SherlockUser>;
  userId: Scalars['MongoID'];
};

/** A connection to a list of items. */
export type SlotConnection = {
  __typename?: 'SlotConnection';
  /** Total object count. */
  count: Scalars['Int'];
  /** Information to aid in pagination. */
  edges: Array<SlotEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SlotEdge = {
  __typename?: 'SlotEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Slot;
};

/** List of items with pagination. */
export type SlotPagination = {
  __typename?: 'SlotPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Slot>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export enum SortConnectionActionEnum {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortConnectionActionLogEnum {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortConnectionCardRecordEnum {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortConnectionDecisionReportEnum {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortConnectionLabelEnum {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortConnectionRoleEnum {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortConnectionRuleEnum {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortConnectionSlotEnum {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortConnectionSquadEnum {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortConnectionStrategyEnum {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortConnectionTaskEnum {
  ENTITYID_ASC = 'ENTITYID_ASC',
  ENTITYID_DESC = 'ENTITYID_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortConnectionTeamEnum {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortConnectionTeamIntegrationEnum {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortConnectionsherlockUserEnum {
  EMAIL_ASC = 'EMAIL_ASC',
  EMAIL_DESC = 'EMAIL_DESC',
  XEROEMAIL_ASC = 'XEROEMAIL_ASC',
  XEROEMAIL_DESC = 'XEROEMAIL_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindByIdsActionInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindByIdsActionLogInput {
  CREATEDAT_ASC = 'CREATEDAT_ASC',
  CREATEDAT_DESC = 'CREATEDAT_DESC',
  ENTITY_ASC = 'ENTITY_ASC',
  ENTITY_DESC = 'ENTITY_DESC',
  ENTITY__ENTITYID_ASC = 'ENTITY__ENTITYID_ASC',
  ENTITY__ENTITYID_DESC = 'ENTITY__ENTITYID_DESC',
  ENTITY__ENTITYID__CREATEDAT_ASC = 'ENTITY__ENTITYID__CREATEDAT_ASC',
  ENTITY__ENTITYID__CREATEDAT_DESC = 'ENTITY__ENTITYID__CREATEDAT_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindByIdsCardRecordInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindByIdsConcernAreaSchemaInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindByIdsDecisionReportInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindByIdsFlowExecutionInput {
  CREATEDAT_ASC = 'CREATEDAT_ASC',
  CREATEDAT_DESC = 'CREATEDAT_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindByIdsGayaFormInput {
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindByIdsGayaFormResponseInput {
  CREATEDAT_ASC = 'CREATEDAT_ASC',
  CREATEDAT_DESC = 'CREATEDAT_DESC',
  CREATEDBY_ASC = 'CREATEDBY_ASC',
  CREATEDBY_DESC = 'CREATEDBY_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindByIdsGayaThemeInput {
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindByIdsGroupEntityInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindByIdsIncidentExecutionLogInput {
  BATCHID_ASC = 'BATCHID_ASC',
  BATCHID_DESC = 'BATCHID_DESC',
  INCIDENTGROUP_ASC = 'INCIDENTGROUP_ASC',
  INCIDENTGROUP_DESC = 'INCIDENTGROUP_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindByIdsIncidentGroupInput {
  INCIDENTID_ASC = 'INCIDENTID_ASC',
  INCIDENTID_DESC = 'INCIDENTID_DESC',
  INCIDENTID__NAME_ASC = 'INCIDENTID__NAME_ASC',
  INCIDENTID__NAME_DESC = 'INCIDENTID__NAME_DESC',
  INCIDENTID__NAME__DELETEDAT_ASC = 'INCIDENTID__NAME__DELETEDAT_ASC',
  INCIDENTID__NAME__DELETEDAT_DESC = 'INCIDENTID__NAME__DELETEDAT_DESC',
  INCIDENTID__ORDER_ASC = 'INCIDENTID__ORDER_ASC',
  INCIDENTID__ORDER_DESC = 'INCIDENTID__ORDER_DESC',
  INCIDENTID__ORDER__DELETEDAT_ASC = 'INCIDENTID__ORDER__DELETEDAT_ASC',
  INCIDENTID__ORDER__DELETEDAT_DESC = 'INCIDENTID__ORDER__DELETEDAT_DESC',
  ISTEMPLATE_ASC = 'ISTEMPLATE_ASC',
  ISTEMPLATE_DESC = 'ISTEMPLATE_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindByIdsIncidentInput {
  CREATEDAT_ASC = 'CREATEDAT_ASC',
  CREATEDAT_DESC = 'CREATEDAT_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindByIdsLabelInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindByIdsModuleRoutesInput {
  PATH_ASC = 'PATH_ASC',
  PATH_DESC = 'PATH_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindByIdsRoleInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindByIdsRuleInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindByIdsSlotInput {
  SHIFTID_ASC = 'SHIFTID_ASC',
  SHIFTID_DESC = 'SHIFTID_DESC',
  SHIFTID__DELETEDAT_ASC = 'SHIFTID__DELETEDAT_ASC',
  SHIFTID__DELETEDAT_DESC = 'SHIFTID__DELETEDAT_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindByIdsSquadInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindByIdsStrategyInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindByIdsTaskInput {
  CONCERNAREAS__CONCERNAREASCHEMAID_ASC = 'CONCERNAREAS__CONCERNAREASCHEMAID_ASC',
  CONCERNAREAS__CONCERNAREASCHEMAID_DESC = 'CONCERNAREAS__CONCERNAREASCHEMAID_DESC',
  CONCERNAREAS__CONCERNAREASCHEMAID__CONCERNAREAS__STATUS_ASC = 'CONCERNAREAS__CONCERNAREASCHEMAID__CONCERNAREAS__STATUS_ASC',
  CONCERNAREAS__CONCERNAREASCHEMAID__CONCERNAREAS__STATUS_DESC = 'CONCERNAREAS__CONCERNAREASCHEMAID__CONCERNAREAS__STATUS_DESC',
  CONCERNAREAS__CONCERNAREASCHEMAID__CONCERNAREAS__STATUS__DELETEDAT_ASC = 'CONCERNAREAS__CONCERNAREASCHEMAID__CONCERNAREAS__STATUS__DELETEDAT_ASC',
  CONCERNAREAS__CONCERNAREASCHEMAID__CONCERNAREAS__STATUS__DELETEDAT_DESC = 'CONCERNAREAS__CONCERNAREASCHEMAID__CONCERNAREAS__STATUS__DELETEDAT_DESC',
  CONCERNAREAS__CONCERNAREASCHEMAID__DELETEDAT_ASC = 'CONCERNAREAS__CONCERNAREASCHEMAID__DELETEDAT_ASC',
  CONCERNAREAS__CONCERNAREASCHEMAID__DELETEDAT_DESC = 'CONCERNAREAS__CONCERNAREASCHEMAID__DELETEDAT_DESC',
  CONCERNAREAS__DECISION_ASC = 'CONCERNAREAS__DECISION_ASC',
  CONCERNAREAS__DECISION_DESC = 'CONCERNAREAS__DECISION_DESC',
  CONCERNAREAS__DECISION__CONCERNAREAS__STATUS_ASC = 'CONCERNAREAS__DECISION__CONCERNAREAS__STATUS_ASC',
  CONCERNAREAS__DECISION__CONCERNAREAS__STATUS_DESC = 'CONCERNAREAS__DECISION__CONCERNAREAS__STATUS_DESC',
  CONCERNAREAS__DECISION__CONCERNAREAS__STATUS__DELETEDAT_ASC = 'CONCERNAREAS__DECISION__CONCERNAREAS__STATUS__DELETEDAT_ASC',
  CONCERNAREAS__DECISION__CONCERNAREAS__STATUS__DELETEDAT_DESC = 'CONCERNAREAS__DECISION__CONCERNAREAS__STATUS__DELETEDAT_DESC',
  CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONDATE_ASC = 'CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONDATE_ASC',
  CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONDATE_DESC = 'CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONDATE_DESC',
  CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONDATE__DELETEDAT_ASC = 'CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONDATE__DELETEDAT_ASC',
  CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONDATE__DELETEDAT_DESC = 'CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONDATE__DELETEDAT_DESC',
  CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONMAKERID_ASC = 'CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONMAKERID_ASC',
  CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONMAKERID_DESC = 'CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONMAKERID_DESC',
  CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONMAKERID__DELETEDAT_ASC = 'CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONMAKERID__DELETEDAT_ASC',
  CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONMAKERID__DELETEDAT_DESC = 'CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONMAKERID__DELETEDAT_DESC',
  CONCERNAREAS__STATUS_ASC = 'CONCERNAREAS__STATUS_ASC',
  CONCERNAREAS__STATUS_DESC = 'CONCERNAREAS__STATUS_DESC',
  CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO_ASC = 'CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO_ASC',
  CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO_DESC = 'CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO_DESC',
  CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__DELETEDAT_ASC = 'CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__DELETEDAT_ASC',
  CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__DELETEDAT_DESC = 'CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__DELETEDAT_DESC',
  DELETEDAT_ASC = 'DELETEDAT_ASC',
  DELETEDAT_DESC = 'DELETEDAT_DESC',
  ENTITYCACHEDDATA__BILL__ID_ASC = 'ENTITYCACHEDDATA__BILL__ID_ASC',
  ENTITYCACHEDDATA__BILL__ID_DESC = 'ENTITYCACHEDDATA__BILL__ID_DESC',
  ENTITYCACHEDDATA__BILL__ID__STATUS_ASC = 'ENTITYCACHEDDATA__BILL__ID__STATUS_ASC',
  ENTITYCACHEDDATA__BILL__ID__STATUS_DESC = 'ENTITYCACHEDDATA__BILL__ID__STATUS_DESC',
  ENTITYCACHEDDATA__BILL__ID__STATUS__DELETEDAT_ASC = 'ENTITYCACHEDDATA__BILL__ID__STATUS__DELETEDAT_ASC',
  ENTITYCACHEDDATA__BILL__ID__STATUS__DELETEDAT_DESC = 'ENTITYCACHEDDATA__BILL__ID__STATUS__DELETEDAT_DESC',
  ENTITYCACHEDDATA__DELIVERYMETHOD__CREATEDAT_ASC = 'ENTITYCACHEDDATA__DELIVERYMETHOD__CREATEDAT_ASC',
  ENTITYCACHEDDATA__DELIVERYMETHOD__CREATEDAT_DESC = 'ENTITYCACHEDDATA__DELIVERYMETHOD__CREATEDAT_DESC',
  ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORORGANIZATION_ASC = 'ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORORGANIZATION_ASC',
  ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORORGANIZATION_DESC = 'ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORORGANIZATION_DESC',
  ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORUSER_ASC = 'ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORUSER_ASC',
  ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORUSER_DESC = 'ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORUSER_DESC',
  ENTITYCACHEDDATA__FEATURES__HASFILEREQUESTS_ASC = 'ENTITYCACHEDDATA__FEATURES__HASFILEREQUESTS_ASC',
  ENTITYCACHEDDATA__FEATURES__HASFILEREQUESTS_DESC = 'ENTITYCACHEDDATA__FEATURES__HASFILEREQUESTS_DESC',
  ENTITYCACHEDDATA__FUNDINGSOURCE__ID_ASC = 'ENTITYCACHEDDATA__FUNDINGSOURCE__ID_ASC',
  ENTITYCACHEDDATA__FUNDINGSOURCE__ID_DESC = 'ENTITYCACHEDDATA__FUNDINGSOURCE__ID_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__COMPANYNAME_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__COMPANYNAME_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__COMPANYNAME_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__COMPANYNAME_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__DECISION_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__DECISION_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__DECISION_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__DECISION_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__ID_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__ID_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__ID_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__ID_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__ID__STATUS_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__ID__STATUS_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__ID__STATUS_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__ID__STATUS_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__ID__STATUS__DELETEDAT_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__ID__STATUS__DELETEDAT_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__ID__STATUS__DELETEDAT_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__ID__STATUS__DELETEDAT_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYINSUBTYPE_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYINSUBTYPE_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYINSUBTYPE_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYINSUBTYPE_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYIN_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYIN_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYIN_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYIN_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__KYBSTATUS_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__KYBSTATUS_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__KYBSTATUS_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__KYBSTATUS_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__PARTNER__PARTNERNAME_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__PARTNER__PARTNERNAME_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__PARTNER__PARTNERNAME_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__PARTNER__PARTNERNAME_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__TAXIDTYPE_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__TAXIDTYPE_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__TAXIDTYPE_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__TAXIDTYPE_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__ZENDESKTICKETS__ID_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__ZENDESKTICKETS__ID_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__ZENDESKTICKETS__ID_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__ZENDESKTICKETS__ID_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__ZENDESKTICKETS__ID__DELETEDAT_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__ZENDESKTICKETS__ID__DELETEDAT_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__ZENDESKTICKETS__ID__DELETEDAT_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__ZENDESKTICKETS__ID__DELETEDAT_DESC',
  ENTITYCACHEDDATA__PAYMENT__AMOUNT_ASC = 'ENTITYCACHEDDATA__PAYMENT__AMOUNT_ASC',
  ENTITYCACHEDDATA__PAYMENT__AMOUNT_DESC = 'ENTITYCACHEDDATA__PAYMENT__AMOUNT_DESC',
  ENTITYCACHEDDATA__PAYMENT__CREATEDAT_ASC = 'ENTITYCACHEDDATA__PAYMENT__CREATEDAT_ASC',
  ENTITYCACHEDDATA__PAYMENT__CREATEDAT_DESC = 'ENTITYCACHEDDATA__PAYMENT__CREATEDAT_DESC',
  ENTITYCACHEDDATA__PAYMENT__CREATEDBYEMAIL_ASC = 'ENTITYCACHEDDATA__PAYMENT__CREATEDBYEMAIL_ASC',
  ENTITYCACHEDDATA__PAYMENT__CREATEDBYEMAIL_DESC = 'ENTITYCACHEDDATA__PAYMENT__CREATEDBYEMAIL_DESC',
  ENTITYCACHEDDATA__PAYMENT__CREATEDBYPARTNER__COMPANYNAME_ASC = 'ENTITYCACHEDDATA__PAYMENT__CREATEDBYPARTNER__COMPANYNAME_ASC',
  ENTITYCACHEDDATA__PAYMENT__CREATEDBYPARTNER__COMPANYNAME_DESC = 'ENTITYCACHEDDATA__PAYMENT__CREATEDBYPARTNER__COMPANYNAME_DESC',
  ENTITYCACHEDDATA__PAYMENT__DIRECTION_ASC = 'ENTITYCACHEDDATA__PAYMENT__DIRECTION_ASC',
  ENTITYCACHEDDATA__PAYMENT__DIRECTION_DESC = 'ENTITYCACHEDDATA__PAYMENT__DIRECTION_DESC',
  ENTITYCACHEDDATA__PAYMENT__DIRECTION__DELETEDAT_ASC = 'ENTITYCACHEDDATA__PAYMENT__DIRECTION__DELETEDAT_ASC',
  ENTITYCACHEDDATA__PAYMENT__DIRECTION__DELETEDAT_DESC = 'ENTITYCACHEDDATA__PAYMENT__DIRECTION__DELETEDAT_DESC',
  ENTITYCACHEDDATA__PAYMENT__ID_ASC = 'ENTITYCACHEDDATA__PAYMENT__ID_ASC',
  ENTITYCACHEDDATA__PAYMENT__ID_DESC = 'ENTITYCACHEDDATA__PAYMENT__ID_DESC',
  ENTITYCACHEDDATA__PAYMENT__SCHEDULEDDATE_ASC = 'ENTITYCACHEDDATA__PAYMENT__SCHEDULEDDATE_ASC',
  ENTITYCACHEDDATA__PAYMENT__SCHEDULEDDATE_DESC = 'ENTITYCACHEDDATA__PAYMENT__SCHEDULEDDATE_DESC',
  ENTITYCACHEDDATA__VENDOR__COMPANYNAME_ASC = 'ENTITYCACHEDDATA__VENDOR__COMPANYNAME_ASC',
  ENTITYCACHEDDATA__VENDOR__COMPANYNAME_DESC = 'ENTITYCACHEDDATA__VENDOR__COMPANYNAME_DESC',
  ENTITYID_ASC = 'ENTITYID_ASC',
  ENTITYID_DESC = 'ENTITYID_DESC',
  ENTITYID__DELETEDAT_ASC = 'ENTITYID__DELETEDAT_ASC',
  ENTITYID__DELETEDAT_DESC = 'ENTITYID__DELETEDAT_DESC',
  ENTITYID__STATUS_ASC = 'ENTITYID__STATUS_ASC',
  ENTITYID__STATUS_DESC = 'ENTITYID__STATUS_DESC',
  ENTITYID__STATUS__DELETEDAT_ASC = 'ENTITYID__STATUS__DELETEDAT_ASC',
  ENTITYID__STATUS__DELETEDAT_DESC = 'ENTITYID__STATUS__DELETEDAT_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  LASTDECISIONDETAILS__LASTDECISIONDATE_ASC = 'LASTDECISIONDETAILS__LASTDECISIONDATE_ASC',
  LASTDECISIONDETAILS__LASTDECISIONDATE_DESC = 'LASTDECISIONDETAILS__LASTDECISIONDATE_DESC',
  LASTDECISIONDETAILS__LASTDECISIONMAKERID_ASC = 'LASTDECISIONDETAILS__LASTDECISIONMAKERID_ASC',
  LASTDECISIONDETAILS__LASTDECISIONMAKERID_DESC = 'LASTDECISIONDETAILS__LASTDECISIONMAKERID_DESC',
  LASTESCALATEDDETAILS__TEAMINTEGRATIONID_ASC = 'LASTESCALATEDDETAILS__TEAMINTEGRATIONID_ASC',
  LASTESCALATEDDETAILS__TEAMINTEGRATIONID_DESC = 'LASTESCALATEDDETAILS__TEAMINTEGRATIONID_DESC',
  PRIORITIZATION_ASC = 'PRIORITIZATION_ASC',
  PRIORITIZATION_DESC = 'PRIORITIZATION_DESC',
  RECURRINGBILLID_ASC = 'RECURRINGBILLID_ASC',
  RECURRINGBILLID_DESC = 'RECURRINGBILLID_DESC',
  RECURRINGBILLID__STATUS_ASC = 'RECURRINGBILLID__STATUS_ASC',
  RECURRINGBILLID__STATUS_DESC = 'RECURRINGBILLID__STATUS_DESC',
  RECURRINGBILLID__STATUS__PARENTTASKID_ASC = 'RECURRINGBILLID__STATUS__PARENTTASKID_ASC',
  RECURRINGBILLID__STATUS__PARENTTASKID_DESC = 'RECURRINGBILLID__STATUS__PARENTTASKID_DESC',
  STATUS_ASC = 'STATUS_ASC',
  STATUS_DESC = 'STATUS_DESC',
  STATUS__CONCERNAREAS__STATUS_ASC = 'STATUS__CONCERNAREAS__STATUS_ASC',
  STATUS__CONCERNAREAS__STATUS_DESC = 'STATUS__CONCERNAREAS__STATUS_DESC',
  STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO_ASC = 'STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO_ASC',
  STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO_DESC = 'STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO_DESC',
  STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__PARENTTASKID_ASC = 'STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__PARENTTASKID_ASC',
  STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__PARENTTASKID_DESC = 'STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__PARENTTASKID_DESC',
  STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__PARENTTASKID__DELETEDAT_ASC = 'STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__PARENTTASKID__DELETEDAT_ASC',
  STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__PARENTTASKID__DELETEDAT_DESC = 'STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__PARENTTASKID__DELETEDAT_DESC',
  STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON_ASC = 'STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON_ASC',
  STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON_DESC = 'STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON_DESC',
  STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID_ASC = 'STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID_ASC',
  STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID_DESC = 'STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID_DESC',
  STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID__DELETEDAT_ASC = 'STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID__DELETEDAT_ASC',
  STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID__DELETEDAT_DESC = 'STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID__DELETEDAT_DESC',
  STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID__DELETEDAT__ENTITYCACHEDDATA__PAYMENT__ID_ASC = 'STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID__DELETEDAT__ENTITYCACHEDDATA__PAYMENT__ID_ASC',
  STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID__DELETEDAT__ENTITYCACHEDDATA__PAYMENT__ID_DESC = 'STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID__DELETEDAT__ENTITYCACHEDDATA__PAYMENT__ID_DESC',
  STATUS__PARENTTASKID_ASC = 'STATUS__PARENTTASKID_ASC',
  STATUS__PARENTTASKID_DESC = 'STATUS__PARENTTASKID_DESC',
  STATUS__PARENTTASKID__DELETEDAT_ASC = 'STATUS__PARENTTASKID__DELETEDAT_ASC',
  STATUS__PARENTTASKID__DELETEDAT_DESC = 'STATUS__PARENTTASKID__DELETEDAT_DESC',
  STATUS__PARENTTASKID__DELETEDAT__LABEL_ASC = 'STATUS__PARENTTASKID__DELETEDAT__LABEL_ASC',
  STATUS__PARENTTASKID__DELETEDAT__LABEL_DESC = 'STATUS__PARENTTASKID__DELETEDAT__LABEL_DESC',
  STATUS__PARENTTASKID__LABEL_ASC = 'STATUS__PARENTTASKID__LABEL_ASC',
  STATUS__PARENTTASKID__LABEL_DESC = 'STATUS__PARENTTASKID__LABEL_DESC',
  UPDATEDAT_ASC = 'UPDATEDAT_ASC',
  UPDATEDAT_DESC = 'UPDATEDAT_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindByIdsTeamInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindByIdsTeamIntegrationInput {
  REASON_ASC = 'REASON_ASC',
  REASON_DESC = 'REASON_DESC',
  REASON__TYPE_ASC = 'REASON__TYPE_ASC',
  REASON__TYPE_DESC = 'REASON__TYPE_DESC',
  ROLEIDS_ASC = 'ROLEIDS_ASC',
  ROLEIDS_DESC = 'ROLEIDS_DESC',
  ROLEIDS__TYPE_ASC = 'ROLEIDS__TYPE_ASC',
  ROLEIDS__TYPE_DESC = 'ROLEIDS__TYPE_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindByIdsUiFlowInput {
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindByIdssherlockUserInput {
  EMAIL_ASC = 'EMAIL_ASC',
  EMAIL_DESC = 'EMAIL_DESC',
  XEROEMAIL_ASC = 'XEROEMAIL_ASC',
  XEROEMAIL_DESC = 'XEROEMAIL_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyActionInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyActionLogInput {
  CREATEDAT_ASC = 'CREATEDAT_ASC',
  CREATEDAT_DESC = 'CREATEDAT_DESC',
  ENTITY_ASC = 'ENTITY_ASC',
  ENTITY_DESC = 'ENTITY_DESC',
  ENTITY__ENTITYID_ASC = 'ENTITY__ENTITYID_ASC',
  ENTITY__ENTITYID_DESC = 'ENTITY__ENTITYID_DESC',
  ENTITY__ENTITYID__CREATEDAT_ASC = 'ENTITY__ENTITYID__CREATEDAT_ASC',
  ENTITY__ENTITYID__CREATEDAT_DESC = 'ENTITY__ENTITYID__CREATEDAT_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyCardRecordInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyConcernAreaSchemaInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyDecisionReportInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyFlowExecutionInput {
  CREATEDAT_ASC = 'CREATEDAT_ASC',
  CREATEDAT_DESC = 'CREATEDAT_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyFlowPermissionInput {
  UIFLOWID_ASC = 'UIFLOWID_ASC',
  UIFLOWID_DESC = 'UIFLOWID_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyGayaFormInput {
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyGayaFormResponseInput {
  CREATEDAT_ASC = 'CREATEDAT_ASC',
  CREATEDAT_DESC = 'CREATEDAT_DESC',
  CREATEDBY_ASC = 'CREATEDBY_ASC',
  CREATEDBY_DESC = 'CREATEDBY_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyGayaThemeInput {
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyGenericTaskInput {
  BUSY_ACCOUNTNUMBER_ASC = 'BUSY_ACCOUNTNUMBER_ASC',
  BUSY_ACCOUNTNUMBER_DESC = 'BUSY_ACCOUNTNUMBER_DESC',
  BUSY_COMPANYNAME_ASC = 'BUSY_COMPANYNAME_ASC',
  BUSY_COMPANYNAME_DESC = 'BUSY_COMPANYNAME_DESC',
  BUSY_CREATEDAT_ASC = 'BUSY_CREATEDAT_ASC',
  BUSY_CREATEDAT_DESC = 'BUSY_CREATEDAT_DESC',
  BUSY_ESCALATIONREASON_ASC = 'BUSY_ESCALATIONREASON_ASC',
  BUSY_ESCALATIONREASON_DESC = 'BUSY_ESCALATIONREASON_DESC',
  BUSY_PHONE_ASC = 'BUSY_PHONE_ASC',
  BUSY_PHONE_DESC = 'BUSY_PHONE_DESC',
  BUSY_REJECTIONREASON_ASC = 'BUSY_REJECTIONREASON_ASC',
  BUSY_REJECTIONREASON_DESC = 'BUSY_REJECTIONREASON_DESC',
  BUSY_ROUTINGNUMBER_ASC = 'BUSY_ROUTINGNUMBER_ASC',
  BUSY_ROUTINGNUMBER_DESC = 'BUSY_ROUTINGNUMBER_DESC',
  BUSY_SOURCETYPE_ASC = 'BUSY_SOURCETYPE_ASC',
  BUSY_SOURCETYPE_DESC = 'BUSY_SOURCETYPE_DESC',
  BUSY_UNMATCH_TASK_BUSINESSNAME_ASC = 'BUSY_UNMATCH_TASK_BUSINESSNAME_ASC',
  BUSY_UNMATCH_TASK_BUSINESSNAME_DESC = 'BUSY_UNMATCH_TASK_BUSINESSNAME_DESC',
  BUSY_UNMATCH_TASK_CREATEDAT_ASC = 'BUSY_UNMATCH_TASK_CREATEDAT_ASC',
  BUSY_UNMATCH_TASK_CREATEDAT_DESC = 'BUSY_UNMATCH_TASK_CREATEDAT_DESC',
  BUSY_UNMATCH_TASK_ISPAIDVENDOR_ASC = 'BUSY_UNMATCH_TASK_ISPAIDVENDOR_ASC',
  BUSY_UNMATCH_TASK_ISPAIDVENDOR_DESC = 'BUSY_UNMATCH_TASK_ISPAIDVENDOR_DESC',
  BUSY_UNMATCH_TASK_NEXT30DAYSTPV_ASC = 'BUSY_UNMATCH_TASK_NEXT30DAYSTPV_ASC',
  BUSY_UNMATCH_TASK_NEXT30DAYSTPV_DESC = 'BUSY_UNMATCH_TASK_NEXT30DAYSTPV_DESC',
  BUSY_UNMATCH_TASK_SOURCETYPE_ASC = 'BUSY_UNMATCH_TASK_SOURCETYPE_ASC',
  BUSY_UNMATCH_TASK_SOURCETYPE_DESC = 'BUSY_UNMATCH_TASK_SOURCETYPE_DESC',
  BUSY_UNMATCH_TASK_VENDORNAME_ASC = 'BUSY_UNMATCH_TASK_VENDORNAME_ASC',
  BUSY_UNMATCH_TASK_VENDORNAME_DESC = 'BUSY_UNMATCH_TASK_VENDORNAME_DESC',
  BUSY_UPDATEDAT_ASC = 'BUSY_UPDATEDAT_ASC',
  BUSY_UPDATEDAT_DESC = 'BUSY_UPDATEDAT_DESC',
  BUSY_VIRTUALCARDEMAIL_ASC = 'BUSY_VIRTUALCARDEMAIL_ASC',
  BUSY_VIRTUALCARDEMAIL_DESC = 'BUSY_VIRTUALCARDEMAIL_DESC',
  LUCI_AMOUNT_ASC = 'LUCI_AMOUNT_ASC',
  LUCI_AMOUNT_DESC = 'LUCI_AMOUNT_DESC',
  LUCI_CASEID_ASC = 'LUCI_CASEID_ASC',
  LUCI_CASEID_DESC = 'LUCI_CASEID_DESC',
  LUCI_CREATEDAT_ASC = 'LUCI_CREATEDAT_ASC',
  LUCI_CREATEDAT_DESC = 'LUCI_CREATEDAT_DESC',
  LUCI_DUEDATE_ASC = 'LUCI_DUEDATE_ASC',
  LUCI_DUEDATE_DESC = 'LUCI_DUEDATE_DESC',
  LUCI_HIGHLEVELCLAIM_ASC = 'LUCI_HIGHLEVELCLAIM_ASC',
  LUCI_HIGHLEVELCLAIM_DESC = 'LUCI_HIGHLEVELCLAIM_DESC',
  LUCI_ORGANIZATIONID_ASC = 'LUCI_ORGANIZATIONID_ASC',
  LUCI_ORGANIZATIONID_DESC = 'LUCI_ORGANIZATIONID_DESC',
  LUCI_PAYMENTID_ASC = 'LUCI_PAYMENTID_ASC',
  LUCI_PAYMENTID_DESC = 'LUCI_PAYMENTID_DESC',
  LUCI_PAYMENT__ID_ASC = 'LUCI_PAYMENT__ID_ASC',
  LUCI_PAYMENT__ID_DESC = 'LUCI_PAYMENT__ID_DESC',
  LUCI_PAYMENT__ORGANIZATION__COMPANYNAME_ASC = 'LUCI_PAYMENT__ORGANIZATION__COMPANYNAME_ASC',
  LUCI_PAYMENT__ORGANIZATION__COMPANYNAME_DESC = 'LUCI_PAYMENT__ORGANIZATION__COMPANYNAME_DESC',
  LUCI_SCENARIO_ASC = 'LUCI_SCENARIO_ASC',
  LUCI_SCENARIO_DESC = 'LUCI_SCENARIO_DESC',
  LUCI_STATUS_ASC = 'LUCI_STATUS_ASC',
  LUCI_STATUS_DESC = 'LUCI_STATUS_DESC',
  LUCI_SUBSTATUS_ASC = 'LUCI_SUBSTATUS_ASC',
  LUCI_SUBSTATUS_DESC = 'LUCI_SUBSTATUS_DESC',
  SHERLOCK_DECISION_TAGGING_DELIVERYMETHOD__CREATEDAT_ASC = 'SHERLOCK_DECISION_TAGGING_DELIVERYMETHOD__CREATEDAT_ASC',
  SHERLOCK_DECISION_TAGGING_DELIVERYMETHOD__CREATEDAT_DESC = 'SHERLOCK_DECISION_TAGGING_DELIVERYMETHOD__CREATEDAT_DESC',
  SHERLOCK_DECISION_TAGGING_FEATURES__CLIENTIPAGEFORORGANIZATION_ASC = 'SHERLOCK_DECISION_TAGGING_FEATURES__CLIENTIPAGEFORORGANIZATION_ASC',
  SHERLOCK_DECISION_TAGGING_FEATURES__CLIENTIPAGEFORORGANIZATION_DESC = 'SHERLOCK_DECISION_TAGGING_FEATURES__CLIENTIPAGEFORORGANIZATION_DESC',
  SHERLOCK_DECISION_TAGGING_FEATURES__CLIENTIPAGEFORUSER_ASC = 'SHERLOCK_DECISION_TAGGING_FEATURES__CLIENTIPAGEFORUSER_ASC',
  SHERLOCK_DECISION_TAGGING_FEATURES__CLIENTIPAGEFORUSER_DESC = 'SHERLOCK_DECISION_TAGGING_FEATURES__CLIENTIPAGEFORUSER_DESC',
  SHERLOCK_DECISION_TAGGING_ORGANIZATION__COMPANYNAME_ASC = 'SHERLOCK_DECISION_TAGGING_ORGANIZATION__COMPANYNAME_ASC',
  SHERLOCK_DECISION_TAGGING_ORGANIZATION__COMPANYNAME_DESC = 'SHERLOCK_DECISION_TAGGING_ORGANIZATION__COMPANYNAME_DESC',
  SHERLOCK_DECISION_TAGGING_ORGANIZATION__DECISION_ASC = 'SHERLOCK_DECISION_TAGGING_ORGANIZATION__DECISION_ASC',
  SHERLOCK_DECISION_TAGGING_ORGANIZATION__DECISION_DESC = 'SHERLOCK_DECISION_TAGGING_ORGANIZATION__DECISION_DESC',
  SHERLOCK_DECISION_TAGGING_ORGANIZATION__KYBMONEYINSUBTYPE_ASC = 'SHERLOCK_DECISION_TAGGING_ORGANIZATION__KYBMONEYINSUBTYPE_ASC',
  SHERLOCK_DECISION_TAGGING_ORGANIZATION__KYBMONEYINSUBTYPE_DESC = 'SHERLOCK_DECISION_TAGGING_ORGANIZATION__KYBMONEYINSUBTYPE_DESC',
  SHERLOCK_DECISION_TAGGING_ORGANIZATION__KYBMONEYIN_ASC = 'SHERLOCK_DECISION_TAGGING_ORGANIZATION__KYBMONEYIN_ASC',
  SHERLOCK_DECISION_TAGGING_ORGANIZATION__KYBMONEYIN_DESC = 'SHERLOCK_DECISION_TAGGING_ORGANIZATION__KYBMONEYIN_DESC',
  SHERLOCK_DECISION_TAGGING_ORGANIZATION__KYBSTATUS_ASC = 'SHERLOCK_DECISION_TAGGING_ORGANIZATION__KYBSTATUS_ASC',
  SHERLOCK_DECISION_TAGGING_ORGANIZATION__KYBSTATUS_DESC = 'SHERLOCK_DECISION_TAGGING_ORGANIZATION__KYBSTATUS_DESC',
  SHERLOCK_DECISION_TAGGING_ORGANIZATION__TAXIDTYPE_ASC = 'SHERLOCK_DECISION_TAGGING_ORGANIZATION__TAXIDTYPE_ASC',
  SHERLOCK_DECISION_TAGGING_ORGANIZATION__TAXIDTYPE_DESC = 'SHERLOCK_DECISION_TAGGING_ORGANIZATION__TAXIDTYPE_DESC',
  SHERLOCK_DECISION_TAGGING_PAYMENT__AMOUNT_ASC = 'SHERLOCK_DECISION_TAGGING_PAYMENT__AMOUNT_ASC',
  SHERLOCK_DECISION_TAGGING_PAYMENT__AMOUNT_DESC = 'SHERLOCK_DECISION_TAGGING_PAYMENT__AMOUNT_DESC',
  SHERLOCK_DECISION_TAGGING_PAYMENT__CREATEDBYEMAIL_ASC = 'SHERLOCK_DECISION_TAGGING_PAYMENT__CREATEDBYEMAIL_ASC',
  SHERLOCK_DECISION_TAGGING_PAYMENT__CREATEDBYEMAIL_DESC = 'SHERLOCK_DECISION_TAGGING_PAYMENT__CREATEDBYEMAIL_DESC',
  SHERLOCK_DECISION_TAGGING_PAYMENT__CREATEDBYPARTNER__COMPANYNAME_ASC = 'SHERLOCK_DECISION_TAGGING_PAYMENT__CREATEDBYPARTNER__COMPANYNAME_ASC',
  SHERLOCK_DECISION_TAGGING_PAYMENT__CREATEDBYPARTNER__COMPANYNAME_DESC = 'SHERLOCK_DECISION_TAGGING_PAYMENT__CREATEDBYPARTNER__COMPANYNAME_DESC',
  SHERLOCK_DECISION_TAGGING_PAYMENT__DIRECTION_ASC = 'SHERLOCK_DECISION_TAGGING_PAYMENT__DIRECTION_ASC',
  SHERLOCK_DECISION_TAGGING_PAYMENT__DIRECTION_DESC = 'SHERLOCK_DECISION_TAGGING_PAYMENT__DIRECTION_DESC',
  SHERLOCK_DECISION_TAGGING_PAYMENT__SCHEDULEDDATE_ASC = 'SHERLOCK_DECISION_TAGGING_PAYMENT__SCHEDULEDDATE_ASC',
  SHERLOCK_DECISION_TAGGING_PAYMENT__SCHEDULEDDATE_DESC = 'SHERLOCK_DECISION_TAGGING_PAYMENT__SCHEDULEDDATE_DESC',
  SHERLOCK_DECISION_TAGGING_TAGNAMES__ORGANIZATIONDECISION_ASC = 'SHERLOCK_DECISION_TAGGING_TAGNAMES__ORGANIZATIONDECISION_ASC',
  SHERLOCK_DECISION_TAGGING_TAGNAMES__ORGANIZATIONDECISION_DESC = 'SHERLOCK_DECISION_TAGGING_TAGNAMES__ORGANIZATIONDECISION_DESC',
  SHERLOCK_DECISION_TAGGING_VENDOR__COMPANYNAME_ASC = 'SHERLOCK_DECISION_TAGGING_VENDOR__COMPANYNAME_ASC',
  SHERLOCK_DECISION_TAGGING_VENDOR__COMPANYNAME_DESC = 'SHERLOCK_DECISION_TAGGING_VENDOR__COMPANYNAME_DESC',
  SHERLOCK_ESCALATION_ORGANIZATION__COMPANYNAME_ASC = 'SHERLOCK_ESCALATION_ORGANIZATION__COMPANYNAME_ASC',
  SHERLOCK_ESCALATION_ORGANIZATION__COMPANYNAME_DESC = 'SHERLOCK_ESCALATION_ORGANIZATION__COMPANYNAME_DESC',
  SHERLOCK_ESCALATION_ORGANIZATION__DECISION_ASC = 'SHERLOCK_ESCALATION_ORGANIZATION__DECISION_ASC',
  SHERLOCK_ESCALATION_ORGANIZATION__DECISION_DESC = 'SHERLOCK_ESCALATION_ORGANIZATION__DECISION_DESC',
  SHERLOCK_ESCALATION_REASON_ASC = 'SHERLOCK_ESCALATION_REASON_ASC',
  SHERLOCK_ESCALATION_REASON_DESC = 'SHERLOCK_ESCALATION_REASON_DESC',
  SHERLOCK_ORGANIZATION_CRRRANK_ASC = 'SHERLOCK_ORGANIZATION_CRRRANK_ASC',
  SHERLOCK_ORGANIZATION_CRRRANK_DESC = 'SHERLOCK_ORGANIZATION_CRRRANK_DESC',
  SHERLOCK_ORGANIZATION_NAME_ASC = 'SHERLOCK_ORGANIZATION_NAME_ASC',
  SHERLOCK_ORGANIZATION_NAME_DESC = 'SHERLOCK_ORGANIZATION_NAME_DESC',
  SHERLOCK_ORGANIZATION_ODEMONEYINDECISION_ASC = 'SHERLOCK_ORGANIZATION_ODEMONEYINDECISION_ASC',
  SHERLOCK_ORGANIZATION_ODEMONEYINDECISION_DESC = 'SHERLOCK_ORGANIZATION_ODEMONEYINDECISION_DESC',
  SHERLOCK_ORGANIZATION_ODEMONEYOUTDECISION_ASC = 'SHERLOCK_ORGANIZATION_ODEMONEYOUTDECISION_ASC',
  SHERLOCK_ORGANIZATION_ODEMONEYOUTDECISION_DESC = 'SHERLOCK_ORGANIZATION_ODEMONEYOUTDECISION_DESC',
  SHERLOCK_ORGANIZATION_ORGANIZATIONID_ASC = 'SHERLOCK_ORGANIZATION_ORGANIZATIONID_ASC',
  SHERLOCK_ORGANIZATION_ORGANIZATIONID_DESC = 'SHERLOCK_ORGANIZATION_ORGANIZATIONID_DESC',
  SHERLOCK_ORGANIZATION_ORIGIN_ASC = 'SHERLOCK_ORGANIZATION_ORIGIN_ASC',
  SHERLOCK_ORGANIZATION_ORIGIN_DESC = 'SHERLOCK_ORGANIZATION_ORIGIN_DESC',
  SHERLOCK_ORGANIZATION_PARTNER__COMPANYNAME_ASC = 'SHERLOCK_ORGANIZATION_PARTNER__COMPANYNAME_ASC',
  SHERLOCK_ORGANIZATION_PARTNER__COMPANYNAME_DESC = 'SHERLOCK_ORGANIZATION_PARTNER__COMPANYNAME_DESC',
  SHERLOCK_ORGANIZATION_TAXIDTYPE_ASC = 'SHERLOCK_ORGANIZATION_TAXIDTYPE_ASC',
  SHERLOCK_ORGANIZATION_TAXIDTYPE_DESC = 'SHERLOCK_ORGANIZATION_TAXIDTYPE_DESC',
  SHERLOCK_ORGANIZATION_TPV_ASC = 'SHERLOCK_ORGANIZATION_TPV_ASC',
  SHERLOCK_ORGANIZATION_TPV_DESC = 'SHERLOCK_ORGANIZATION_TPV_DESC',
  SHERLOCK_ORGANIZATION_ZENDESKTICKETS__LATESTCOMMENT__STATUS_ASC = 'SHERLOCK_ORGANIZATION_ZENDESKTICKETS__LATESTCOMMENT__STATUS_ASC',
  SHERLOCK_ORGANIZATION_ZENDESKTICKETS__LATESTCOMMENT__STATUS_DESC = 'SHERLOCK_ORGANIZATION_ZENDESKTICKETS__LATESTCOMMENT__STATUS_DESC',
  SHERLOCK_ORGANIZATION__ID_ASC = 'SHERLOCK_ORGANIZATION__ID_ASC',
  SHERLOCK_ORGANIZATION__ID_DESC = 'SHERLOCK_ORGANIZATION__ID_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyGroupEntityInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyIncidentExecutionLogInput {
  BATCHID_ASC = 'BATCHID_ASC',
  BATCHID_DESC = 'BATCHID_DESC',
  INCIDENTGROUP_ASC = 'INCIDENTGROUP_ASC',
  INCIDENTGROUP_DESC = 'INCIDENTGROUP_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyIncidentGroupInput {
  INCIDENTID_ASC = 'INCIDENTID_ASC',
  INCIDENTID_DESC = 'INCIDENTID_DESC',
  INCIDENTID__NAME_ASC = 'INCIDENTID__NAME_ASC',
  INCIDENTID__NAME_DESC = 'INCIDENTID__NAME_DESC',
  INCIDENTID__NAME__DELETEDAT_ASC = 'INCIDENTID__NAME__DELETEDAT_ASC',
  INCIDENTID__NAME__DELETEDAT_DESC = 'INCIDENTID__NAME__DELETEDAT_DESC',
  INCIDENTID__ORDER_ASC = 'INCIDENTID__ORDER_ASC',
  INCIDENTID__ORDER_DESC = 'INCIDENTID__ORDER_DESC',
  INCIDENTID__ORDER__DELETEDAT_ASC = 'INCIDENTID__ORDER__DELETEDAT_ASC',
  INCIDENTID__ORDER__DELETEDAT_DESC = 'INCIDENTID__ORDER__DELETEDAT_DESC',
  ISTEMPLATE_ASC = 'ISTEMPLATE_ASC',
  ISTEMPLATE_DESC = 'ISTEMPLATE_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyIncidentInput {
  CREATEDAT_ASC = 'CREATEDAT_ASC',
  CREATEDAT_DESC = 'CREATEDAT_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyLabelInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyLogInput {
  ACTIONTYPE_ASC = 'ACTIONTYPE_ASC',
  ACTIONTYPE_DESC = 'ACTIONTYPE_DESC',
  ACTIONTYPE__TASKID_ASC = 'ACTIONTYPE__TASKID_ASC',
  ACTIONTYPE__TASKID_DESC = 'ACTIONTYPE__TASKID_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyModuleInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyModuleRoutesInput {
  PATH_ASC = 'PATH_ASC',
  PATH_DESC = 'PATH_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyProjectInput {
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyRoleInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyRubricInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyRuleInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManySlotInput {
  SHIFTID_ASC = 'SHIFTID_ASC',
  SHIFTID_DESC = 'SHIFTID_DESC',
  SHIFTID__DELETEDAT_ASC = 'SHIFTID__DELETEDAT_ASC',
  SHIFTID__DELETEDAT_DESC = 'SHIFTID__DELETEDAT_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManySquadInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyStrategyInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyTaskInput {
  CONCERNAREAS__CONCERNAREASCHEMAID_ASC = 'CONCERNAREAS__CONCERNAREASCHEMAID_ASC',
  CONCERNAREAS__CONCERNAREASCHEMAID_DESC = 'CONCERNAREAS__CONCERNAREASCHEMAID_DESC',
  CONCERNAREAS__CONCERNAREASCHEMAID__CONCERNAREAS__STATUS_ASC = 'CONCERNAREAS__CONCERNAREASCHEMAID__CONCERNAREAS__STATUS_ASC',
  CONCERNAREAS__CONCERNAREASCHEMAID__CONCERNAREAS__STATUS_DESC = 'CONCERNAREAS__CONCERNAREASCHEMAID__CONCERNAREAS__STATUS_DESC',
  CONCERNAREAS__CONCERNAREASCHEMAID__CONCERNAREAS__STATUS__DELETEDAT_ASC = 'CONCERNAREAS__CONCERNAREASCHEMAID__CONCERNAREAS__STATUS__DELETEDAT_ASC',
  CONCERNAREAS__CONCERNAREASCHEMAID__CONCERNAREAS__STATUS__DELETEDAT_DESC = 'CONCERNAREAS__CONCERNAREASCHEMAID__CONCERNAREAS__STATUS__DELETEDAT_DESC',
  CONCERNAREAS__CONCERNAREASCHEMAID__DELETEDAT_ASC = 'CONCERNAREAS__CONCERNAREASCHEMAID__DELETEDAT_ASC',
  CONCERNAREAS__CONCERNAREASCHEMAID__DELETEDAT_DESC = 'CONCERNAREAS__CONCERNAREASCHEMAID__DELETEDAT_DESC',
  CONCERNAREAS__DECISION_ASC = 'CONCERNAREAS__DECISION_ASC',
  CONCERNAREAS__DECISION_DESC = 'CONCERNAREAS__DECISION_DESC',
  CONCERNAREAS__DECISION__CONCERNAREAS__STATUS_ASC = 'CONCERNAREAS__DECISION__CONCERNAREAS__STATUS_ASC',
  CONCERNAREAS__DECISION__CONCERNAREAS__STATUS_DESC = 'CONCERNAREAS__DECISION__CONCERNAREAS__STATUS_DESC',
  CONCERNAREAS__DECISION__CONCERNAREAS__STATUS__DELETEDAT_ASC = 'CONCERNAREAS__DECISION__CONCERNAREAS__STATUS__DELETEDAT_ASC',
  CONCERNAREAS__DECISION__CONCERNAREAS__STATUS__DELETEDAT_DESC = 'CONCERNAREAS__DECISION__CONCERNAREAS__STATUS__DELETEDAT_DESC',
  CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONDATE_ASC = 'CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONDATE_ASC',
  CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONDATE_DESC = 'CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONDATE_DESC',
  CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONDATE__DELETEDAT_ASC = 'CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONDATE__DELETEDAT_ASC',
  CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONDATE__DELETEDAT_DESC = 'CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONDATE__DELETEDAT_DESC',
  CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONMAKERID_ASC = 'CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONMAKERID_ASC',
  CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONMAKERID_DESC = 'CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONMAKERID_DESC',
  CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONMAKERID__DELETEDAT_ASC = 'CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONMAKERID__DELETEDAT_ASC',
  CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONMAKERID__DELETEDAT_DESC = 'CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONMAKERID__DELETEDAT_DESC',
  CONCERNAREAS__STATUS_ASC = 'CONCERNAREAS__STATUS_ASC',
  CONCERNAREAS__STATUS_DESC = 'CONCERNAREAS__STATUS_DESC',
  CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO_ASC = 'CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO_ASC',
  CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO_DESC = 'CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO_DESC',
  CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__DELETEDAT_ASC = 'CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__DELETEDAT_ASC',
  CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__DELETEDAT_DESC = 'CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__DELETEDAT_DESC',
  DELETEDAT_ASC = 'DELETEDAT_ASC',
  DELETEDAT_DESC = 'DELETEDAT_DESC',
  ENTITYCACHEDDATA__BILL__ID_ASC = 'ENTITYCACHEDDATA__BILL__ID_ASC',
  ENTITYCACHEDDATA__BILL__ID_DESC = 'ENTITYCACHEDDATA__BILL__ID_DESC',
  ENTITYCACHEDDATA__BILL__ID__STATUS_ASC = 'ENTITYCACHEDDATA__BILL__ID__STATUS_ASC',
  ENTITYCACHEDDATA__BILL__ID__STATUS_DESC = 'ENTITYCACHEDDATA__BILL__ID__STATUS_DESC',
  ENTITYCACHEDDATA__BILL__ID__STATUS__DELETEDAT_ASC = 'ENTITYCACHEDDATA__BILL__ID__STATUS__DELETEDAT_ASC',
  ENTITYCACHEDDATA__BILL__ID__STATUS__DELETEDAT_DESC = 'ENTITYCACHEDDATA__BILL__ID__STATUS__DELETEDAT_DESC',
  ENTITYCACHEDDATA__DELIVERYMETHOD__CREATEDAT_ASC = 'ENTITYCACHEDDATA__DELIVERYMETHOD__CREATEDAT_ASC',
  ENTITYCACHEDDATA__DELIVERYMETHOD__CREATEDAT_DESC = 'ENTITYCACHEDDATA__DELIVERYMETHOD__CREATEDAT_DESC',
  ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORORGANIZATION_ASC = 'ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORORGANIZATION_ASC',
  ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORORGANIZATION_DESC = 'ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORORGANIZATION_DESC',
  ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORUSER_ASC = 'ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORUSER_ASC',
  ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORUSER_DESC = 'ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORUSER_DESC',
  ENTITYCACHEDDATA__FEATURES__HASFILEREQUESTS_ASC = 'ENTITYCACHEDDATA__FEATURES__HASFILEREQUESTS_ASC',
  ENTITYCACHEDDATA__FEATURES__HASFILEREQUESTS_DESC = 'ENTITYCACHEDDATA__FEATURES__HASFILEREQUESTS_DESC',
  ENTITYCACHEDDATA__FUNDINGSOURCE__ID_ASC = 'ENTITYCACHEDDATA__FUNDINGSOURCE__ID_ASC',
  ENTITYCACHEDDATA__FUNDINGSOURCE__ID_DESC = 'ENTITYCACHEDDATA__FUNDINGSOURCE__ID_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__COMPANYNAME_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__COMPANYNAME_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__COMPANYNAME_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__COMPANYNAME_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__DECISION_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__DECISION_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__DECISION_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__DECISION_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__ID_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__ID_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__ID_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__ID_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__ID__STATUS_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__ID__STATUS_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__ID__STATUS_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__ID__STATUS_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__ID__STATUS__DELETEDAT_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__ID__STATUS__DELETEDAT_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__ID__STATUS__DELETEDAT_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__ID__STATUS__DELETEDAT_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYINSUBTYPE_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYINSUBTYPE_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYINSUBTYPE_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYINSUBTYPE_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYIN_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYIN_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYIN_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYIN_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__KYBSTATUS_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__KYBSTATUS_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__KYBSTATUS_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__KYBSTATUS_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__PARTNER__PARTNERNAME_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__PARTNER__PARTNERNAME_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__PARTNER__PARTNERNAME_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__PARTNER__PARTNERNAME_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__TAXIDTYPE_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__TAXIDTYPE_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__TAXIDTYPE_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__TAXIDTYPE_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__ZENDESKTICKETS__ID_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__ZENDESKTICKETS__ID_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__ZENDESKTICKETS__ID_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__ZENDESKTICKETS__ID_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__ZENDESKTICKETS__ID__DELETEDAT_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__ZENDESKTICKETS__ID__DELETEDAT_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__ZENDESKTICKETS__ID__DELETEDAT_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__ZENDESKTICKETS__ID__DELETEDAT_DESC',
  ENTITYCACHEDDATA__PAYMENT__AMOUNT_ASC = 'ENTITYCACHEDDATA__PAYMENT__AMOUNT_ASC',
  ENTITYCACHEDDATA__PAYMENT__AMOUNT_DESC = 'ENTITYCACHEDDATA__PAYMENT__AMOUNT_DESC',
  ENTITYCACHEDDATA__PAYMENT__CREATEDAT_ASC = 'ENTITYCACHEDDATA__PAYMENT__CREATEDAT_ASC',
  ENTITYCACHEDDATA__PAYMENT__CREATEDAT_DESC = 'ENTITYCACHEDDATA__PAYMENT__CREATEDAT_DESC',
  ENTITYCACHEDDATA__PAYMENT__CREATEDBYEMAIL_ASC = 'ENTITYCACHEDDATA__PAYMENT__CREATEDBYEMAIL_ASC',
  ENTITYCACHEDDATA__PAYMENT__CREATEDBYEMAIL_DESC = 'ENTITYCACHEDDATA__PAYMENT__CREATEDBYEMAIL_DESC',
  ENTITYCACHEDDATA__PAYMENT__CREATEDBYPARTNER__COMPANYNAME_ASC = 'ENTITYCACHEDDATA__PAYMENT__CREATEDBYPARTNER__COMPANYNAME_ASC',
  ENTITYCACHEDDATA__PAYMENT__CREATEDBYPARTNER__COMPANYNAME_DESC = 'ENTITYCACHEDDATA__PAYMENT__CREATEDBYPARTNER__COMPANYNAME_DESC',
  ENTITYCACHEDDATA__PAYMENT__DIRECTION_ASC = 'ENTITYCACHEDDATA__PAYMENT__DIRECTION_ASC',
  ENTITYCACHEDDATA__PAYMENT__DIRECTION_DESC = 'ENTITYCACHEDDATA__PAYMENT__DIRECTION_DESC',
  ENTITYCACHEDDATA__PAYMENT__DIRECTION__DELETEDAT_ASC = 'ENTITYCACHEDDATA__PAYMENT__DIRECTION__DELETEDAT_ASC',
  ENTITYCACHEDDATA__PAYMENT__DIRECTION__DELETEDAT_DESC = 'ENTITYCACHEDDATA__PAYMENT__DIRECTION__DELETEDAT_DESC',
  ENTITYCACHEDDATA__PAYMENT__ID_ASC = 'ENTITYCACHEDDATA__PAYMENT__ID_ASC',
  ENTITYCACHEDDATA__PAYMENT__ID_DESC = 'ENTITYCACHEDDATA__PAYMENT__ID_DESC',
  ENTITYCACHEDDATA__PAYMENT__SCHEDULEDDATE_ASC = 'ENTITYCACHEDDATA__PAYMENT__SCHEDULEDDATE_ASC',
  ENTITYCACHEDDATA__PAYMENT__SCHEDULEDDATE_DESC = 'ENTITYCACHEDDATA__PAYMENT__SCHEDULEDDATE_DESC',
  ENTITYCACHEDDATA__VENDOR__COMPANYNAME_ASC = 'ENTITYCACHEDDATA__VENDOR__COMPANYNAME_ASC',
  ENTITYCACHEDDATA__VENDOR__COMPANYNAME_DESC = 'ENTITYCACHEDDATA__VENDOR__COMPANYNAME_DESC',
  ENTITYID_ASC = 'ENTITYID_ASC',
  ENTITYID_DESC = 'ENTITYID_DESC',
  ENTITYID__DELETEDAT_ASC = 'ENTITYID__DELETEDAT_ASC',
  ENTITYID__DELETEDAT_DESC = 'ENTITYID__DELETEDAT_DESC',
  ENTITYID__STATUS_ASC = 'ENTITYID__STATUS_ASC',
  ENTITYID__STATUS_DESC = 'ENTITYID__STATUS_DESC',
  ENTITYID__STATUS__DELETEDAT_ASC = 'ENTITYID__STATUS__DELETEDAT_ASC',
  ENTITYID__STATUS__DELETEDAT_DESC = 'ENTITYID__STATUS__DELETEDAT_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  LASTDECISIONDETAILS__LASTDECISIONDATE_ASC = 'LASTDECISIONDETAILS__LASTDECISIONDATE_ASC',
  LASTDECISIONDETAILS__LASTDECISIONDATE_DESC = 'LASTDECISIONDETAILS__LASTDECISIONDATE_DESC',
  LASTDECISIONDETAILS__LASTDECISIONMAKERID_ASC = 'LASTDECISIONDETAILS__LASTDECISIONMAKERID_ASC',
  LASTDECISIONDETAILS__LASTDECISIONMAKERID_DESC = 'LASTDECISIONDETAILS__LASTDECISIONMAKERID_DESC',
  LASTESCALATEDDETAILS__TEAMINTEGRATIONID_ASC = 'LASTESCALATEDDETAILS__TEAMINTEGRATIONID_ASC',
  LASTESCALATEDDETAILS__TEAMINTEGRATIONID_DESC = 'LASTESCALATEDDETAILS__TEAMINTEGRATIONID_DESC',
  PRIORITIZATION_ASC = 'PRIORITIZATION_ASC',
  PRIORITIZATION_DESC = 'PRIORITIZATION_DESC',
  RECURRINGBILLID_ASC = 'RECURRINGBILLID_ASC',
  RECURRINGBILLID_DESC = 'RECURRINGBILLID_DESC',
  RECURRINGBILLID__STATUS_ASC = 'RECURRINGBILLID__STATUS_ASC',
  RECURRINGBILLID__STATUS_DESC = 'RECURRINGBILLID__STATUS_DESC',
  RECURRINGBILLID__STATUS__PARENTTASKID_ASC = 'RECURRINGBILLID__STATUS__PARENTTASKID_ASC',
  RECURRINGBILLID__STATUS__PARENTTASKID_DESC = 'RECURRINGBILLID__STATUS__PARENTTASKID_DESC',
  STATUS_ASC = 'STATUS_ASC',
  STATUS_DESC = 'STATUS_DESC',
  STATUS__CONCERNAREAS__STATUS_ASC = 'STATUS__CONCERNAREAS__STATUS_ASC',
  STATUS__CONCERNAREAS__STATUS_DESC = 'STATUS__CONCERNAREAS__STATUS_DESC',
  STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO_ASC = 'STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO_ASC',
  STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO_DESC = 'STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO_DESC',
  STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__PARENTTASKID_ASC = 'STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__PARENTTASKID_ASC',
  STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__PARENTTASKID_DESC = 'STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__PARENTTASKID_DESC',
  STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__PARENTTASKID__DELETEDAT_ASC = 'STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__PARENTTASKID__DELETEDAT_ASC',
  STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__PARENTTASKID__DELETEDAT_DESC = 'STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__PARENTTASKID__DELETEDAT_DESC',
  STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON_ASC = 'STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON_ASC',
  STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON_DESC = 'STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON_DESC',
  STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID_ASC = 'STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID_ASC',
  STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID_DESC = 'STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID_DESC',
  STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID__DELETEDAT_ASC = 'STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID__DELETEDAT_ASC',
  STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID__DELETEDAT_DESC = 'STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID__DELETEDAT_DESC',
  STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID__DELETEDAT__ENTITYCACHEDDATA__PAYMENT__ID_ASC = 'STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID__DELETEDAT__ENTITYCACHEDDATA__PAYMENT__ID_ASC',
  STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID__DELETEDAT__ENTITYCACHEDDATA__PAYMENT__ID_DESC = 'STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID__DELETEDAT__ENTITYCACHEDDATA__PAYMENT__ID_DESC',
  STATUS__PARENTTASKID_ASC = 'STATUS__PARENTTASKID_ASC',
  STATUS__PARENTTASKID_DESC = 'STATUS__PARENTTASKID_DESC',
  STATUS__PARENTTASKID__DELETEDAT_ASC = 'STATUS__PARENTTASKID__DELETEDAT_ASC',
  STATUS__PARENTTASKID__DELETEDAT_DESC = 'STATUS__PARENTTASKID__DELETEDAT_DESC',
  STATUS__PARENTTASKID__DELETEDAT__LABEL_ASC = 'STATUS__PARENTTASKID__DELETEDAT__LABEL_ASC',
  STATUS__PARENTTASKID__DELETEDAT__LABEL_DESC = 'STATUS__PARENTTASKID__DELETEDAT__LABEL_DESC',
  STATUS__PARENTTASKID__LABEL_ASC = 'STATUS__PARENTTASKID__LABEL_ASC',
  STATUS__PARENTTASKID__LABEL_DESC = 'STATUS__PARENTTASKID__LABEL_DESC',
  UPDATEDAT_ASC = 'UPDATEDAT_ASC',
  UPDATEDAT_DESC = 'UPDATEDAT_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyTeamInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyTeamIntegrationInput {
  REASON_ASC = 'REASON_ASC',
  REASON_DESC = 'REASON_DESC',
  REASON__TYPE_ASC = 'REASON__TYPE_ASC',
  REASON__TYPE_DESC = 'REASON__TYPE_DESC',
  ROLEIDS_ASC = 'ROLEIDS_ASC',
  ROLEIDS_DESC = 'ROLEIDS_DESC',
  ROLEIDS__TYPE_ASC = 'ROLEIDS__TYPE_ASC',
  ROLEIDS__TYPE_DESC = 'ROLEIDS__TYPE_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManyUiFlowInput {
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindManysherlockUserInput {
  EMAIL_ASC = 'EMAIL_ASC',
  EMAIL_DESC = 'EMAIL_DESC',
  XEROEMAIL_ASC = 'XEROEMAIL_ASC',
  XEROEMAIL_DESC = 'XEROEMAIL_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOneActionInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOneActionLogInput {
  CREATEDAT_ASC = 'CREATEDAT_ASC',
  CREATEDAT_DESC = 'CREATEDAT_DESC',
  ENTITY_ASC = 'ENTITY_ASC',
  ENTITY_DESC = 'ENTITY_DESC',
  ENTITY__ENTITYID_ASC = 'ENTITY__ENTITYID_ASC',
  ENTITY__ENTITYID_DESC = 'ENTITY__ENTITYID_DESC',
  ENTITY__ENTITYID__CREATEDAT_ASC = 'ENTITY__ENTITYID__CREATEDAT_ASC',
  ENTITY__ENTITYID__CREATEDAT_DESC = 'ENTITY__ENTITYID__CREATEDAT_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOneCardRecordInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOneConcernAreaSchemaInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOneDecisionReportInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOneFlowExecutionInput {
  CREATEDAT_ASC = 'CREATEDAT_ASC',
  CREATEDAT_DESC = 'CREATEDAT_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOneFlowPermissionInput {
  UIFLOWID_ASC = 'UIFLOWID_ASC',
  UIFLOWID_DESC = 'UIFLOWID_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOneGayaFormInput {
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOneGayaFormResponseInput {
  CREATEDAT_ASC = 'CREATEDAT_ASC',
  CREATEDAT_DESC = 'CREATEDAT_DESC',
  CREATEDBY_ASC = 'CREATEDBY_ASC',
  CREATEDBY_DESC = 'CREATEDBY_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOneGayaThemeInput {
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOneGenericTaskInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOneIncidentExecutionLogInput {
  BATCHID_ASC = 'BATCHID_ASC',
  BATCHID_DESC = 'BATCHID_DESC',
  INCIDENTGROUP_ASC = 'INCIDENTGROUP_ASC',
  INCIDENTGROUP_DESC = 'INCIDENTGROUP_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOneIncidentGroupInput {
  INCIDENTID_ASC = 'INCIDENTID_ASC',
  INCIDENTID_DESC = 'INCIDENTID_DESC',
  INCIDENTID__NAME_ASC = 'INCIDENTID__NAME_ASC',
  INCIDENTID__NAME_DESC = 'INCIDENTID__NAME_DESC',
  INCIDENTID__NAME__DELETEDAT_ASC = 'INCIDENTID__NAME__DELETEDAT_ASC',
  INCIDENTID__NAME__DELETEDAT_DESC = 'INCIDENTID__NAME__DELETEDAT_DESC',
  INCIDENTID__ORDER_ASC = 'INCIDENTID__ORDER_ASC',
  INCIDENTID__ORDER_DESC = 'INCIDENTID__ORDER_DESC',
  INCIDENTID__ORDER__DELETEDAT_ASC = 'INCIDENTID__ORDER__DELETEDAT_ASC',
  INCIDENTID__ORDER__DELETEDAT_DESC = 'INCIDENTID__ORDER__DELETEDAT_DESC',
  ISTEMPLATE_ASC = 'ISTEMPLATE_ASC',
  ISTEMPLATE_DESC = 'ISTEMPLATE_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOneIncidentInput {
  CREATEDAT_ASC = 'CREATEDAT_ASC',
  CREATEDAT_DESC = 'CREATEDAT_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOneLabelInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOneModuleRoutesInput {
  PATH_ASC = 'PATH_ASC',
  PATH_DESC = 'PATH_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOneRoleInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOneRuleInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOneSherlockOrganizationTaskInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOneSlotInput {
  SHIFTID_ASC = 'SHIFTID_ASC',
  SHIFTID_DESC = 'SHIFTID_DESC',
  SHIFTID__DELETEDAT_ASC = 'SHIFTID__DELETEDAT_ASC',
  SHIFTID__DELETEDAT_DESC = 'SHIFTID__DELETEDAT_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOneSquadInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOneStrategyInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOneTaskInput {
  CONCERNAREAS__CONCERNAREASCHEMAID_ASC = 'CONCERNAREAS__CONCERNAREASCHEMAID_ASC',
  CONCERNAREAS__CONCERNAREASCHEMAID_DESC = 'CONCERNAREAS__CONCERNAREASCHEMAID_DESC',
  CONCERNAREAS__CONCERNAREASCHEMAID__CONCERNAREAS__STATUS_ASC = 'CONCERNAREAS__CONCERNAREASCHEMAID__CONCERNAREAS__STATUS_ASC',
  CONCERNAREAS__CONCERNAREASCHEMAID__CONCERNAREAS__STATUS_DESC = 'CONCERNAREAS__CONCERNAREASCHEMAID__CONCERNAREAS__STATUS_DESC',
  CONCERNAREAS__CONCERNAREASCHEMAID__CONCERNAREAS__STATUS__DELETEDAT_ASC = 'CONCERNAREAS__CONCERNAREASCHEMAID__CONCERNAREAS__STATUS__DELETEDAT_ASC',
  CONCERNAREAS__CONCERNAREASCHEMAID__CONCERNAREAS__STATUS__DELETEDAT_DESC = 'CONCERNAREAS__CONCERNAREASCHEMAID__CONCERNAREAS__STATUS__DELETEDAT_DESC',
  CONCERNAREAS__CONCERNAREASCHEMAID__DELETEDAT_ASC = 'CONCERNAREAS__CONCERNAREASCHEMAID__DELETEDAT_ASC',
  CONCERNAREAS__CONCERNAREASCHEMAID__DELETEDAT_DESC = 'CONCERNAREAS__CONCERNAREASCHEMAID__DELETEDAT_DESC',
  CONCERNAREAS__DECISION_ASC = 'CONCERNAREAS__DECISION_ASC',
  CONCERNAREAS__DECISION_DESC = 'CONCERNAREAS__DECISION_DESC',
  CONCERNAREAS__DECISION__CONCERNAREAS__STATUS_ASC = 'CONCERNAREAS__DECISION__CONCERNAREAS__STATUS_ASC',
  CONCERNAREAS__DECISION__CONCERNAREAS__STATUS_DESC = 'CONCERNAREAS__DECISION__CONCERNAREAS__STATUS_DESC',
  CONCERNAREAS__DECISION__CONCERNAREAS__STATUS__DELETEDAT_ASC = 'CONCERNAREAS__DECISION__CONCERNAREAS__STATUS__DELETEDAT_ASC',
  CONCERNAREAS__DECISION__CONCERNAREAS__STATUS__DELETEDAT_DESC = 'CONCERNAREAS__DECISION__CONCERNAREAS__STATUS__DELETEDAT_DESC',
  CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONDATE_ASC = 'CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONDATE_ASC',
  CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONDATE_DESC = 'CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONDATE_DESC',
  CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONDATE__DELETEDAT_ASC = 'CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONDATE__DELETEDAT_ASC',
  CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONDATE__DELETEDAT_DESC = 'CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONDATE__DELETEDAT_DESC',
  CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONMAKERID_ASC = 'CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONMAKERID_ASC',
  CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONMAKERID_DESC = 'CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONMAKERID_DESC',
  CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONMAKERID__DELETEDAT_ASC = 'CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONMAKERID__DELETEDAT_ASC',
  CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONMAKERID__DELETEDAT_DESC = 'CONCERNAREAS__LASTDECISIONDETAILS__LASTDECISIONMAKERID__DELETEDAT_DESC',
  CONCERNAREAS__STATUS_ASC = 'CONCERNAREAS__STATUS_ASC',
  CONCERNAREAS__STATUS_DESC = 'CONCERNAREAS__STATUS_DESC',
  CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO_ASC = 'CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO_ASC',
  CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO_DESC = 'CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO_DESC',
  CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__DELETEDAT_ASC = 'CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__DELETEDAT_ASC',
  CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__DELETEDAT_DESC = 'CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__DELETEDAT_DESC',
  DELETEDAT_ASC = 'DELETEDAT_ASC',
  DELETEDAT_DESC = 'DELETEDAT_DESC',
  ENTITYCACHEDDATA__BILL__ID_ASC = 'ENTITYCACHEDDATA__BILL__ID_ASC',
  ENTITYCACHEDDATA__BILL__ID_DESC = 'ENTITYCACHEDDATA__BILL__ID_DESC',
  ENTITYCACHEDDATA__BILL__ID__STATUS_ASC = 'ENTITYCACHEDDATA__BILL__ID__STATUS_ASC',
  ENTITYCACHEDDATA__BILL__ID__STATUS_DESC = 'ENTITYCACHEDDATA__BILL__ID__STATUS_DESC',
  ENTITYCACHEDDATA__BILL__ID__STATUS__DELETEDAT_ASC = 'ENTITYCACHEDDATA__BILL__ID__STATUS__DELETEDAT_ASC',
  ENTITYCACHEDDATA__BILL__ID__STATUS__DELETEDAT_DESC = 'ENTITYCACHEDDATA__BILL__ID__STATUS__DELETEDAT_DESC',
  ENTITYCACHEDDATA__DELIVERYMETHOD__CREATEDAT_ASC = 'ENTITYCACHEDDATA__DELIVERYMETHOD__CREATEDAT_ASC',
  ENTITYCACHEDDATA__DELIVERYMETHOD__CREATEDAT_DESC = 'ENTITYCACHEDDATA__DELIVERYMETHOD__CREATEDAT_DESC',
  ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORORGANIZATION_ASC = 'ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORORGANIZATION_ASC',
  ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORORGANIZATION_DESC = 'ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORORGANIZATION_DESC',
  ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORUSER_ASC = 'ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORUSER_ASC',
  ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORUSER_DESC = 'ENTITYCACHEDDATA__FEATURES__CLIENTIPAGEFORUSER_DESC',
  ENTITYCACHEDDATA__FEATURES__HASFILEREQUESTS_ASC = 'ENTITYCACHEDDATA__FEATURES__HASFILEREQUESTS_ASC',
  ENTITYCACHEDDATA__FEATURES__HASFILEREQUESTS_DESC = 'ENTITYCACHEDDATA__FEATURES__HASFILEREQUESTS_DESC',
  ENTITYCACHEDDATA__FUNDINGSOURCE__ID_ASC = 'ENTITYCACHEDDATA__FUNDINGSOURCE__ID_ASC',
  ENTITYCACHEDDATA__FUNDINGSOURCE__ID_DESC = 'ENTITYCACHEDDATA__FUNDINGSOURCE__ID_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__COMPANYNAME_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__COMPANYNAME_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__COMPANYNAME_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__COMPANYNAME_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__DECISION_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__DECISION_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__DECISION_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__DECISION_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__ID_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__ID_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__ID_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__ID_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__ID__STATUS_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__ID__STATUS_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__ID__STATUS_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__ID__STATUS_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__ID__STATUS__DELETEDAT_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__ID__STATUS__DELETEDAT_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__ID__STATUS__DELETEDAT_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__ID__STATUS__DELETEDAT_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYINSUBTYPE_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYINSUBTYPE_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYINSUBTYPE_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYINSUBTYPE_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYIN_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYIN_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYIN_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__KYBMONEYIN_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__KYBSTATUS_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__KYBSTATUS_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__KYBSTATUS_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__KYBSTATUS_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__PARTNER__PARTNERNAME_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__PARTNER__PARTNERNAME_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__PARTNER__PARTNERNAME_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__PARTNER__PARTNERNAME_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__TAXIDTYPE_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__TAXIDTYPE_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__TAXIDTYPE_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__TAXIDTYPE_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__ZENDESKTICKETS__ID_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__ZENDESKTICKETS__ID_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__ZENDESKTICKETS__ID_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__ZENDESKTICKETS__ID_DESC',
  ENTITYCACHEDDATA__ORGANIZATION__ZENDESKTICKETS__ID__DELETEDAT_ASC = 'ENTITYCACHEDDATA__ORGANIZATION__ZENDESKTICKETS__ID__DELETEDAT_ASC',
  ENTITYCACHEDDATA__ORGANIZATION__ZENDESKTICKETS__ID__DELETEDAT_DESC = 'ENTITYCACHEDDATA__ORGANIZATION__ZENDESKTICKETS__ID__DELETEDAT_DESC',
  ENTITYCACHEDDATA__PAYMENT__AMOUNT_ASC = 'ENTITYCACHEDDATA__PAYMENT__AMOUNT_ASC',
  ENTITYCACHEDDATA__PAYMENT__AMOUNT_DESC = 'ENTITYCACHEDDATA__PAYMENT__AMOUNT_DESC',
  ENTITYCACHEDDATA__PAYMENT__CREATEDAT_ASC = 'ENTITYCACHEDDATA__PAYMENT__CREATEDAT_ASC',
  ENTITYCACHEDDATA__PAYMENT__CREATEDAT_DESC = 'ENTITYCACHEDDATA__PAYMENT__CREATEDAT_DESC',
  ENTITYCACHEDDATA__PAYMENT__CREATEDBYEMAIL_ASC = 'ENTITYCACHEDDATA__PAYMENT__CREATEDBYEMAIL_ASC',
  ENTITYCACHEDDATA__PAYMENT__CREATEDBYEMAIL_DESC = 'ENTITYCACHEDDATA__PAYMENT__CREATEDBYEMAIL_DESC',
  ENTITYCACHEDDATA__PAYMENT__CREATEDBYPARTNER__COMPANYNAME_ASC = 'ENTITYCACHEDDATA__PAYMENT__CREATEDBYPARTNER__COMPANYNAME_ASC',
  ENTITYCACHEDDATA__PAYMENT__CREATEDBYPARTNER__COMPANYNAME_DESC = 'ENTITYCACHEDDATA__PAYMENT__CREATEDBYPARTNER__COMPANYNAME_DESC',
  ENTITYCACHEDDATA__PAYMENT__DIRECTION_ASC = 'ENTITYCACHEDDATA__PAYMENT__DIRECTION_ASC',
  ENTITYCACHEDDATA__PAYMENT__DIRECTION_DESC = 'ENTITYCACHEDDATA__PAYMENT__DIRECTION_DESC',
  ENTITYCACHEDDATA__PAYMENT__DIRECTION__DELETEDAT_ASC = 'ENTITYCACHEDDATA__PAYMENT__DIRECTION__DELETEDAT_ASC',
  ENTITYCACHEDDATA__PAYMENT__DIRECTION__DELETEDAT_DESC = 'ENTITYCACHEDDATA__PAYMENT__DIRECTION__DELETEDAT_DESC',
  ENTITYCACHEDDATA__PAYMENT__ID_ASC = 'ENTITYCACHEDDATA__PAYMENT__ID_ASC',
  ENTITYCACHEDDATA__PAYMENT__ID_DESC = 'ENTITYCACHEDDATA__PAYMENT__ID_DESC',
  ENTITYCACHEDDATA__PAYMENT__SCHEDULEDDATE_ASC = 'ENTITYCACHEDDATA__PAYMENT__SCHEDULEDDATE_ASC',
  ENTITYCACHEDDATA__PAYMENT__SCHEDULEDDATE_DESC = 'ENTITYCACHEDDATA__PAYMENT__SCHEDULEDDATE_DESC',
  ENTITYCACHEDDATA__VENDOR__COMPANYNAME_ASC = 'ENTITYCACHEDDATA__VENDOR__COMPANYNAME_ASC',
  ENTITYCACHEDDATA__VENDOR__COMPANYNAME_DESC = 'ENTITYCACHEDDATA__VENDOR__COMPANYNAME_DESC',
  ENTITYID_ASC = 'ENTITYID_ASC',
  ENTITYID_DESC = 'ENTITYID_DESC',
  ENTITYID__DELETEDAT_ASC = 'ENTITYID__DELETEDAT_ASC',
  ENTITYID__DELETEDAT_DESC = 'ENTITYID__DELETEDAT_DESC',
  ENTITYID__STATUS_ASC = 'ENTITYID__STATUS_ASC',
  ENTITYID__STATUS_DESC = 'ENTITYID__STATUS_DESC',
  ENTITYID__STATUS__DELETEDAT_ASC = 'ENTITYID__STATUS__DELETEDAT_ASC',
  ENTITYID__STATUS__DELETEDAT_DESC = 'ENTITYID__STATUS__DELETEDAT_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  LASTDECISIONDETAILS__LASTDECISIONDATE_ASC = 'LASTDECISIONDETAILS__LASTDECISIONDATE_ASC',
  LASTDECISIONDETAILS__LASTDECISIONDATE_DESC = 'LASTDECISIONDETAILS__LASTDECISIONDATE_DESC',
  LASTDECISIONDETAILS__LASTDECISIONMAKERID_ASC = 'LASTDECISIONDETAILS__LASTDECISIONMAKERID_ASC',
  LASTDECISIONDETAILS__LASTDECISIONMAKERID_DESC = 'LASTDECISIONDETAILS__LASTDECISIONMAKERID_DESC',
  LASTESCALATEDDETAILS__TEAMINTEGRATIONID_ASC = 'LASTESCALATEDDETAILS__TEAMINTEGRATIONID_ASC',
  LASTESCALATEDDETAILS__TEAMINTEGRATIONID_DESC = 'LASTESCALATEDDETAILS__TEAMINTEGRATIONID_DESC',
  PRIORITIZATION_ASC = 'PRIORITIZATION_ASC',
  PRIORITIZATION_DESC = 'PRIORITIZATION_DESC',
  RECURRINGBILLID_ASC = 'RECURRINGBILLID_ASC',
  RECURRINGBILLID_DESC = 'RECURRINGBILLID_DESC',
  RECURRINGBILLID__STATUS_ASC = 'RECURRINGBILLID__STATUS_ASC',
  RECURRINGBILLID__STATUS_DESC = 'RECURRINGBILLID__STATUS_DESC',
  RECURRINGBILLID__STATUS__PARENTTASKID_ASC = 'RECURRINGBILLID__STATUS__PARENTTASKID_ASC',
  RECURRINGBILLID__STATUS__PARENTTASKID_DESC = 'RECURRINGBILLID__STATUS__PARENTTASKID_DESC',
  STATUS_ASC = 'STATUS_ASC',
  STATUS_DESC = 'STATUS_DESC',
  STATUS__CONCERNAREAS__STATUS_ASC = 'STATUS__CONCERNAREAS__STATUS_ASC',
  STATUS__CONCERNAREAS__STATUS_DESC = 'STATUS__CONCERNAREAS__STATUS_DESC',
  STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO_ASC = 'STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO_ASC',
  STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO_DESC = 'STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO_DESC',
  STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__PARENTTASKID_ASC = 'STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__PARENTTASKID_ASC',
  STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__PARENTTASKID_DESC = 'STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__PARENTTASKID_DESC',
  STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__PARENTTASKID__DELETEDAT_ASC = 'STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__PARENTTASKID__DELETEDAT_ASC',
  STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__PARENTTASKID__DELETEDAT_DESC = 'STATUS__CONCERNAREAS__STATUS__CONCERNAREAS__ASSIGNEDTO__PARENTTASKID__DELETEDAT_DESC',
  STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON_ASC = 'STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON_ASC',
  STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON_DESC = 'STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON_DESC',
  STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID_ASC = 'STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID_ASC',
  STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID_DESC = 'STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID_DESC',
  STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID__DELETEDAT_ASC = 'STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID__DELETEDAT_ASC',
  STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID__DELETEDAT_DESC = 'STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID__DELETEDAT_DESC',
  STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID__DELETEDAT__ENTITYCACHEDDATA__PAYMENT__ID_ASC = 'STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID__DELETEDAT__ENTITYCACHEDDATA__PAYMENT__ID_ASC',
  STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID__DELETEDAT__ENTITYCACHEDDATA__PAYMENT__ID_DESC = 'STATUS__ENTITYCACHEDDATA__RISKENGINEDECISION__REASON__PARENTTASKID__DELETEDAT__ENTITYCACHEDDATA__PAYMENT__ID_DESC',
  STATUS__PARENTTASKID_ASC = 'STATUS__PARENTTASKID_ASC',
  STATUS__PARENTTASKID_DESC = 'STATUS__PARENTTASKID_DESC',
  STATUS__PARENTTASKID__DELETEDAT_ASC = 'STATUS__PARENTTASKID__DELETEDAT_ASC',
  STATUS__PARENTTASKID__DELETEDAT_DESC = 'STATUS__PARENTTASKID__DELETEDAT_DESC',
  STATUS__PARENTTASKID__DELETEDAT__LABEL_ASC = 'STATUS__PARENTTASKID__DELETEDAT__LABEL_ASC',
  STATUS__PARENTTASKID__DELETEDAT__LABEL_DESC = 'STATUS__PARENTTASKID__DELETEDAT__LABEL_DESC',
  STATUS__PARENTTASKID__LABEL_ASC = 'STATUS__PARENTTASKID__LABEL_ASC',
  STATUS__PARENTTASKID__LABEL_DESC = 'STATUS__PARENTTASKID__LABEL_DESC',
  UPDATEDAT_ASC = 'UPDATEDAT_ASC',
  UPDATEDAT_DESC = 'UPDATEDAT_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOneTeamInput {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOneTeamIntegrationInput {
  REASON_ASC = 'REASON_ASC',
  REASON_DESC = 'REASON_DESC',
  REASON__TYPE_ASC = 'REASON__TYPE_ASC',
  REASON__TYPE_DESC = 'REASON__TYPE_DESC',
  ROLEIDS_ASC = 'ROLEIDS_ASC',
  ROLEIDS_DESC = 'ROLEIDS_DESC',
  ROLEIDS__TYPE_ASC = 'ROLEIDS__TYPE_ASC',
  ROLEIDS__TYPE_DESC = 'ROLEIDS__TYPE_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOneUiFlowInput {
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOneWatsonViewInput {
  ENTITY_ASC = 'ENTITY_ASC',
  ENTITY_DESC = 'ENTITY_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortFindOnesherlockUserInput {
  EMAIL_ASC = 'EMAIL_ASC',
  EMAIL_DESC = 'EMAIL_DESC',
  XEROEMAIL_ASC = 'XEROEMAIL_ASC',
  XEROEMAIL_DESC = 'XEROEMAIL_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortUpdateManyGayaThemeInput {
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortUpdateOneGayaFormInput {
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortUpdateOneGayaThemeInput {
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SortUpdateOneUiFlowInput {
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC',
  _ID_ASC = '_ID_ASC',
  _ID_DESC = '_ID_DESC'
}

export enum SourceEnum {
  charityNavigator = 'charityNavigator',
  gbg = 'gbg',
  openWebSearch = 'openWebSearch',
  sos = 'sos',
  userDocumentation = 'userDocumentation'
}

export enum SourceOfIntervention {
  Automation = 'Automation',
  Pops = 'Pops',
  Robinhood = 'Robinhood',
  SelfServe = 'SelfServe',
  Unknown = 'Unknown'
}

export type SpiiData = {
  __typename?: 'SpiiData';
  isSpii?: Maybe<Scalars['Boolean']>;
  partnerName?: Maybe<Scalars['String']>;
};

export type Squad = {
  __typename?: 'Squad';
  _id: Scalars['MongoID'];
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  name: Scalars['String'];
  team?: Maybe<Team>;
  teamId: Scalars['MongoID'];
  updatedAt?: Maybe<Scalars['Date']>;
};

/** A connection to a list of items. */
export type SquadConnection = {
  __typename?: 'SquadConnection';
  /** Total object count. */
  count: Scalars['Int'];
  /** Information to aid in pagination. */
  edges: Array<SquadEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SquadEdge = {
  __typename?: 'SquadEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Squad;
};

/** List of items with pagination. */
export type SquadPagination = {
  __typename?: 'SquadPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Squad>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type StartActivityResponse = {
  __typename?: 'StartActivityResponse';
  id: Scalars['String'];
};

export enum Status {
  Lost = 'Lost',
  PartnerLoss = 'PartnerLoss',
  PotentialLoss = 'PotentialLoss',
  Recovered = 'Recovered',
  ResolvedPotentialLoss = 'ResolvedPotentialLoss'
}

export type Strategy = {
  __typename?: 'Strategy';
  _id: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  enabled?: Maybe<Scalars['Boolean']>;
  logic?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
  rules?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  selectedRules: Array<Rule>;
  tree?: Maybe<Scalars['JSON']>;
  updatedAt?: Maybe<Scalars['Date']>;
  version?: Maybe<Scalars['Float']>;
};


export type StrategySelectedRulesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsRuleInput>;
};

/** A connection to a list of items. */
export type StrategyConnection = {
  __typename?: 'StrategyConnection';
  /** Total object count. */
  count: Scalars['Int'];
  /** Information to aid in pagination. */
  edges: Array<StrategyEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type StrategyEdge = {
  __typename?: 'StrategyEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Strategy;
};

export type StrategyFeatureTc = {
  __typename?: 'StrategyFeatureTC';
  fact?: Maybe<Scalars['String']>;
  featureName?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type StrategyOdeLabel = {
  __typename?: 'StrategyOdeLabel';
  _id: Scalars['Int'];
  name: Scalars['String'];
};

/** List of items with pagination. */
export type StrategyPagination = {
  __typename?: 'StrategyPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Strategy>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type StrategyVersionOverrideInput = {
  strategyName: Scalars['String'];
  versionId: Scalars['String'];
};

export type StrategyVersionsPagination = {
  __typename?: 'StrategyVersionsPagination';
  hasMore?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type StrategyVersionsResponse = {
  __typename?: 'StrategyVersionsResponse';
  pagination?: Maybe<StrategyVersionsPagination>;
  versions?: Maybe<Array<Maybe<FeatureStrategy>>>;
};

export type SubmitFeedbackResponse = {
  __typename?: 'SubmitFeedbackResponse';
  success: Scalars['Boolean'];
  viewFeedback?: Maybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  genericTaskMany: Array<GenericTask>;
  incidentManagementCalculationProgressSubscription?: Maybe<IncidentManagementCalculateProgressDataType>;
  incidentManagementCalculationSubscription?: Maybe<IncidentManagementCalculateDataType>;
  incidentManagementSingleIncidentSubscription?: Maybe<IncidentManagementSingleDataType>;
  personalConcernAreasDashboardSubscription?: Maybe<PersonalConcernAreasDashboard>;
  personalOrganizationTasksSubscription?: Maybe<PersonalOrganizationTasks>;
  personalPaymentTasksSubscription?: Maybe<PersonalPaymentTasks>;
  sanctionDecisionMade?: Maybe<SanctionDecision>;
  shiftConcernAreasById?: Maybe<Array<Maybe<ShiftConcernArea>>>;
  shiftLabelsById?: Maybe<Array<Maybe<ShiftLabel>>>;
  shiftSlotsById?: Maybe<Array<Maybe<Slot>>>;
  slotAssigned?: Maybe<Array<Maybe<Slot>>>;
  slotAssignedByConcernArea?: Maybe<Array<Maybe<Slot>>>;
  slotAssignedByLabel?: Maybe<Array<Maybe<Slot>>>;
  slotOne?: Maybe<Slot>;
  taskMany?: Maybe<Array<Maybe<Task>>>;
};


export type SubscriptionGenericTaskManyArgs = {
  filter?: InputMaybe<FilterFindManyGenericTaskInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortFindManyGenericTaskInput>>;
  taskIds?: InputMaybe<Array<Scalars['String']>>;
};


export type SubscriptionIncidentManagementCalculationProgressSubscriptionArgs = {
  incidentId: Scalars['String'];
};


export type SubscriptionIncidentManagementCalculationSubscriptionArgs = {
  incidentId: Scalars['String'];
};


export type SubscriptionIncidentManagementSingleIncidentSubscriptionArgs = {
  incidentId: Scalars['String'];
};


export type SubscriptionPersonalConcernAreasDashboardSubscriptionArgs = {
  concernAreaIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  date: Scalars['Date'];
  userId?: InputMaybe<Scalars['String']>;
};


export type SubscriptionPersonalOrganizationTasksSubscriptionArgs = {
  date: Scalars['Date'];
  labelIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
};


export type SubscriptionPersonalPaymentTasksSubscriptionArgs = {
  date: Scalars['Date'];
  labelIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
};


export type SubscriptionSanctionDecisionMadeArgs = {
  organizationId?: InputMaybe<Scalars['Int']>;
  vendorId?: InputMaybe<Scalars['Int']>;
};


export type SubscriptionShiftConcernAreasByIdArgs = {
  shiftId: Scalars['MongoID'];
  teamName?: InputMaybe<Scalars['String']>;
};


export type SubscriptionShiftLabelsByIdArgs = {
  shiftId: Scalars['MongoID'];
  type?: InputMaybe<LabelType>;
};


export type SubscriptionShiftSlotsByIdArgs = {
  shiftId: Scalars['MongoID'];
};


export type SubscriptionSlotAssignedArgs = {
  filter?: InputMaybe<FilterFindManySlotInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManySlotInput>;
};


export type SubscriptionSlotAssignedByConcernAreaArgs = {
  concernAreaId: Scalars['String'];
  filter?: InputMaybe<FilterFindManySlotInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManySlotInput>;
};


export type SubscriptionSlotAssignedByLabelArgs = {
  filter?: InputMaybe<FilterFindManySlotInput>;
  labelId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManySlotInput>;
};


export type SubscriptionSlotOneArgs = {
  filter?: InputMaybe<FilterFindOneSlotInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneSlotInput>;
};


export type SubscriptionTaskManyArgs = {
  filter?: InputMaybe<FilterFindManyTaskInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortFindManyTaskInput>>;
  taskIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionBillingHistoryType = {
  __typename?: 'SubscriptionBillingHistoryType';
  amount?: Maybe<Scalars['Float']>;
  amountWithoutTax?: Maybe<Scalars['Float']>;
  billingItems?: Maybe<Array<Maybe<SubscriptionBillingItemType>>>;
  createdAt?: Maybe<Scalars['Date']>;
  discounts?: Maybe<Array<Maybe<SubscriptionDiscountType>>>;
  id?: Maybe<Scalars['String']>;
  melioBillId?: Maybe<Scalars['Int']>;
  paidDate?: Maybe<Scalars['Date']>;
  status?: Maybe<Scalars['String']>;
  taxAmount?: Maybe<Scalars['Float']>;
};

export type SubscriptionBillingItemType = {
  __typename?: 'SubscriptionBillingItemType';
  amountWithoutTax?: Maybe<Scalars['Float']>;
  childOrgId?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['Date']>;
  subscriptionId?: Maybe<Scalars['String']>;
  taxAmount?: Maybe<Scalars['Float']>;
};

export type SubscriptionDetails = {
  __typename?: 'SubscriptionDetails';
  plan?: Maybe<PlansType>;
  trialType?: Maybe<TrialTypeEnum>;
};

export type SubscriptionDiscountType = {
  __typename?: 'SubscriptionDiscountType';
  amount?: Maybe<Scalars['Float']>;
  billingItemId?: Maybe<Scalars['String']>;
  childOrgId?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['Date']>;
};

export type SubscriptionEnabled = {
  __typename?: 'SubscriptionEnabled';
  enabled?: Maybe<Scalars['Boolean']>;
};

export enum SubscriptionEndPolicy {
  endDate = 'endDate',
  noEndDate = 'noEndDate',
  numOfOccurrences = 'numOfOccurrences'
}

export type SubscriptionFeatures = {
  __typename?: 'SubscriptionFeatures';
  accountingPlatformQbdt?: Maybe<SubscriptionEnabled>;
  achTPlusTwo?: Maybe<SubscriptionEnabled>;
  advancedApprovalWorkflows?: Maybe<SubscriptionEnabled>;
  approvalWorkflows?: Maybe<SubscriptionEnabled>;
  ar?: Maybe<SubscriptionEnabled>;
  batchPayments?: Maybe<SubscriptionEnabled>;
  classesAndLocations?: Maybe<SubscriptionEnabled>;
  freeAchPayments?: Maybe<SubscriptionQuantityFeature>;
  lineItems?: Maybe<SubscriptionEnabled>;
  requestCallbackSupport?: Maybe<SubscriptionEnabled>;
  syncedPayments?: Maybe<SubscriptionQuantityFeature>;
  tax1099?: Maybe<SubscriptionEnabled>;
  w9?: Maybe<SubscriptionEnabled>;
};

export enum SubscriptionIntervalType {
  every2Months = 'every2Months',
  every2Weeks = 'every2Weeks',
  every3Months = 'every3Months',
  every4Months = 'every4Months',
  every4Weeks = 'every4Weeks',
  every6Months = 'every6Months',
  monthly = 'monthly',
  twiceAMonth = 'twiceAMonth',
  weekly = 'weekly',
  yearly = 'yearly'
}

export type SubscriptionQuantityFeature = {
  __typename?: 'SubscriptionQuantityFeature';
  limit?: Maybe<Scalars['Int']>;
};

export enum SubscriptionStatus {
  canceled = 'canceled',
  created = 'created',
  done = 'done',
  inProgress = 'inProgress',
  stopped = 'stopped'
}

export type SubscriptionTimeline = {
  __typename?: 'SubscriptionTimeline';
  action?: Maybe<TimelineAction>;
  fields?: Maybe<SubscriptionTimelineFields>;
  timestamp?: Maybe<Scalars['Date']>;
};

export type SubscriptionTimelineFields = {
  __typename?: 'SubscriptionTimelineFields';
  entityType?: Maybe<AllCasesEntityResponseEntityEnum>;
  isTrial?: Maybe<Scalars['Boolean']>;
  promoCode?: Maybe<Scalars['String']>;
  promoExpiration?: Maybe<Scalars['Date']>;
  seats?: Maybe<Scalars['Int']>;
  tier?: Maybe<Scalars['String']>;
};

export type SubscriptionType = {
  __typename?: 'SubscriptionType';
  endDate?: Maybe<Scalars['Date']>;
  endReason?: Maybe<Scalars['String']>;
  freeAchUsage?: Maybe<FreeAchUsage>;
  fundingSource?: Maybe<Array<Maybe<FundingSource>>>;
  fundingSourceId?: Maybe<Scalars['Int']>;
  isFreeTrial?: Maybe<Scalars['Boolean']>;
  measurementInfo?: Maybe<MeasurementInfo>;
  melioDbOrganization?: Maybe<Array<Maybe<Organization>>>;
  nextBillingAmount?: Maybe<Scalars['Float']>;
  nextBillingDate?: Maybe<Scalars['Date']>;
  nextSubscription?: Maybe<NextSubscriptionType>;
  organizationDetails?: Maybe<OrganizationDetailsType>;
  organizationId?: Maybe<Scalars['Int']>;
  payingOrganization?: Maybe<PayingOrganizationType>;
  plan?: Maybe<PlansType>;
  planCyclePeriod?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
};

export enum SummarizedType {
  agentic = 'agentic',
  deterministic = 'deterministic'
}

export type Supplier = {
  __typename?: 'Supplier';
  addresses?: Maybe<Array<Maybe<AddressObjectTc>>>;
  businessNames?: Maybe<Array<Maybe<BusinessNameObjectTc>>>;
  businessType?: Maybe<SupplierViewBusinessType>;
  contactNames?: Maybe<Array<Maybe<ContactNameObjectTc>>>;
  contactPhones?: Maybe<Array<Maybe<ContactPhoneObjectTc>>>;
  createdAt?: Maybe<Scalars['Date']>;
  deliveryMethods?: Maybe<Array<DeliveryMethodObjectTc>>;
  emails?: Maybe<Array<Maybe<EmailObjectTc>>>;
  groupId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  origin?: Maybe<OrganizationToBusinessOriginTypes>;
  sourceId?: Maybe<Scalars['String']>;
  sourceType?: Maybe<VerificationTaskSourceType>;
  status?: Maybe<VerificationTaskStatus>;
  totalClusterEntitiesStatistics?: Maybe<TotalClusterEntitiesStatisticsObjectTc>;
};

export type SupplierClusterAddressObjectTc = {
  __typename?: 'SupplierClusterAddressObjectTC';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  aptNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type SupplierClusterAddressesDetailsObjectTc = {
  __typename?: 'SupplierClusterAddressesDetailsObjectTC';
  clusterAddresses?: Maybe<Array<Maybe<SupplierClusterAddressesObjectTc>>>;
};

export type SupplierClusterAddressesObjectTc = {
  __typename?: 'SupplierClusterAddressesObjectTC';
  address?: Maybe<SupplierClusterAddressObjectTc>;
  clusterAppearances?: Maybe<Scalars['Int']>;
};

export type SupplierClusterBankAccountObjectTc = {
  __typename?: 'SupplierClusterBankAccountObjectTC';
  accountNumber?: Maybe<Scalars['String']>;
  routingNumber?: Maybe<Scalars['String']>;
};

export type SupplierClusterBusinessNamesDetailsObjectTc = {
  __typename?: 'SupplierClusterBusinessNamesDetailsObjectTC';
  clusterBusinessNames?: Maybe<Array<Maybe<SupplierClusterBusinessNamesObjectTc>>>;
};

export type SupplierClusterBusinessNamesObjectTc = {
  __typename?: 'SupplierClusterBusinessNamesObjectTC';
  clusterAppearances?: Maybe<Scalars['Int']>;
  companyNameLowered?: Maybe<Scalars['String']>;
};

export type SupplierClusterContactNamesDetailsObjectTc = {
  __typename?: 'SupplierClusterContactNamesDetailsObjectTC';
  clusterContactNames?: Maybe<Array<Maybe<SupplierClusterContactNamesObjectTc>>>;
};

export type SupplierClusterContactNamesObjectTc = {
  __typename?: 'SupplierClusterContactNamesObjectTC';
  clusterAppearances?: Maybe<Scalars['Int']>;
  contactNameLowered?: Maybe<Scalars['String']>;
};

export type SupplierClusterDeliveryMethodsDetailsObjectTc = {
  __typename?: 'SupplierClusterDeliveryMethodsDetailsObjectTC';
  clusterDeliveryMethods?: Maybe<Array<Maybe<SupplierClusterDeliveryMethodsObjectTc>>>;
};

export type SupplierClusterDeliveryMethodsObjectTc = {
  __typename?: 'SupplierClusterDeliveryMethodsObjectTC';
  clusterAppearances?: Maybe<Scalars['Int']>;
  completedPayments?: Maybe<Scalars['Int']>;
  deliveryMethodType?: Maybe<DeliveryMethodType>;
  normalizedBankAccount?: Maybe<SupplierClusterBankAccountObjectTc>;
  normalizedEmail?: Maybe<Scalars['String']>;
};

export type SupplierClusterEmailsDetailsObjectTc = {
  __typename?: 'SupplierClusterEmailsDetailsObjectTC';
  clusterEmails?: Maybe<Array<Maybe<SupplierClusterEmailsObjectTc>>>;
};

export type SupplierClusterEmailsObjectTc = {
  __typename?: 'SupplierClusterEmailsObjectTC';
  clusterAppearances?: Maybe<Scalars['Int']>;
  emailLowered?: Maybe<Scalars['String']>;
};

export type SupplierClusterLocalVendorAddressObjectTc = {
  __typename?: 'SupplierClusterLocalVendorAddressObjectTC';
  addressLine1?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type SupplierClusterLocalVendorObjectTc = {
  __typename?: 'SupplierClusterLocalVendorObjectTC';
  accountNumber?: Maybe<Scalars['String']>;
  address?: Maybe<SupplierClusterLocalVendorAddressObjectTc>;
  companyName?: Maybe<Scalars['String']>;
  completedPayments?: Maybe<Scalars['Int']>;
  contactName?: Maybe<Scalars['String']>;
  deliveryMethodCreatedAt?: Maybe<Scalars['Date']>;
  deliveryMethodType?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  routingNumber?: Maybe<Scalars['String']>;
};

export type SupplierClusterLocalVendorsObjectTc = {
  __typename?: 'SupplierClusterLocalVendorsObjectTC';
  localVendors: Array<SupplierClusterLocalVendorObjectTc>;
};

export type SupplierClusterPaymentsStatisticsFieldsObjectTc = {
  __typename?: 'SupplierClusterPaymentsStatisticsFieldsObjectTC';
  amount?: Maybe<Scalars['Int']>;
  tpv?: Maybe<Scalars['Int']>;
};

export type SupplierClusterPhonesDetailsObjectTc = {
  __typename?: 'SupplierClusterPhonesDetailsObjectTC';
  clusterPhones?: Maybe<Array<Maybe<SupplierClusterPhonesObjectTc>>>;
};

export type SupplierClusterPhonesObjectTc = {
  __typename?: 'SupplierClusterPhonesObjectTC';
  clusterAppearances?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
};

export type SupplierClusterSimilarBusinessObjectTc = {
  __typename?: 'SupplierClusterSimilarBusinessObjectTC';
  businessName?: Maybe<Scalars['String']>;
  businessType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type SupplierClusterSimilarBusinessesObjectTc = {
  __typename?: 'SupplierClusterSimilarBusinessesObjectTC';
  similarBusinesses: Array<SupplierClusterSimilarBusinessObjectTc>;
};

export type SupplierClusterStatisticsObjectTc = {
  __typename?: 'SupplierClusterStatisticsObjectTC';
  payments?: Maybe<PaymentsStatisticsObjectTc>;
  riskStatusPayments?: Maybe<RiskStatusPaymentsStatisticsObjectTc>;
};

export enum SupplierTypeEnum {
  enrolled = 'enrolled',
  guest = 'guest',
  verified = 'verified'
}

export enum SupplierViewBusinessType {
  Branch = 'Branch',
  Conglomerate = 'Conglomerate',
  Franchisee = 'Franchisee',
  Franchisor = 'Franchisor',
  NotSure = 'NotSure',
  PartOfLargerOrganization = 'PartOfLargerOrganization',
  PayableCohort = 'PayableCohort',
  StandaloneBusiness = 'StandaloneBusiness',
  Subsidiary = 'Subsidiary'
}

export type SyncDataType = {
  __typename?: 'SyncDataType';
  organizationInfo?: Maybe<OrganizationInfoResponse>;
};

export type Tag = {
  __typename?: 'Tag';
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  entity?: Maybe<Entity>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
};

export type Tagged = {
  __typename?: 'Tagged';
  id: Scalars['String'];
};

export type TaggedInput = {
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type Tags = {
  __typename?: 'Tags';
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  entity?: Maybe<Entity>;
  entityId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  propertyName?: Maybe<Scalars['String']>;
  tag?: Maybe<Tag>;
};

export type Task = {
  __typename?: 'Task';
  _id: Scalars['MongoID'];
  assignedTo?: Maybe<Scalars['MongoID']>;
  children: Array<Task>;
  concernAreas?: Maybe<Array<Maybe<TaskConcernArea>>>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  /** the payment id of the task */
  entity?: Maybe<Payment>;
  entityCachedData: TaskEntityCachedData;
  entityId: Scalars['String'];
  label?: Maybe<Scalars['MongoID']>;
  labelDetails?: Maybe<Label>;
  lastDecisionDetails?: Maybe<TaskConcernAreasLastDecisionDetails>;
  lastEscalatedDetails?: Maybe<TaskLastEscalatedDetails>;
  parentTaskId?: Maybe<Scalars['MongoID']>;
  partnerName?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['JSON']>;
  previousEscalationId?: Maybe<Scalars['String']>;
  prioritization?: Maybe<Scalars['Float']>;
  recurringBillId?: Maybe<Scalars['Float']>;
  status?: Maybe<EnumTaskStatus>;
  taskVersion?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedInSherlock?: Maybe<Scalars['Boolean']>;
  userDetails?: Maybe<SherlockUser>;
};


export type TaskChildrenArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type TaskConcernArea = {
  __typename?: 'TaskConcernArea';
  assignedTo?: Maybe<Scalars['ID']>;
  assignedUser?: Maybe<AssignedUser>;
  blockedRules?: Maybe<Array<Maybe<Scalars['String']>>>;
  concernAreaDetails?: Maybe<ConcernAreaSchema>;
  concernAreaSchemaId?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['Date']>;
  decision?: Maybe<ConcernAreaDecision>;
  lastDecisionDetails?: Maybe<LastDecisionDetails>;
  prevDecision?: Maybe<ConcernAreaDecision>;
  status?: Maybe<ConcernAreaStatus>;
};

export type TaskConcernAreasLastDecisionDetails = {
  __typename?: 'TaskConcernAreasLastDecisionDetails';
  approveAutomatedActions?: Maybe<Scalars['Boolean']>;
  freeTextReason?: Maybe<Scalars['String']>;
  includeRecurring?: Maybe<Scalars['Boolean']>;
  lastDecisionDate: Scalars['Date'];
  lastDecisionMaker?: Maybe<SherlockUser>;
  lastDecisionMakerId?: Maybe<Scalars['MongoID']>;
  reason?: Maybe<Scalars['String']>;
  type?: Maybe<EnumTaskConcernAreasLastDecisionDetailsType>;
};

/** A connection to a list of items. */
export type TaskConnection = {
  __typename?: 'TaskConnection';
  /** Total object count. */
  count: Scalars['Int'];
  /** Information to aid in pagination. */
  edges: Array<TaskEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TaskCounters = {
  __typename?: 'TaskCounters';
  completed: CompletedTasks;
  pending: PendingTasks;
  unreviewed: UnreviewedTasks;
};

/** An edge in a connection. */
export type TaskEdge = {
  __typename?: 'TaskEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Task;
};

export type TaskEntityCachedData = {
  __typename?: 'TaskEntityCachedData';
  bill?: Maybe<TaskEntityCachedDataBill>;
  deliveryMethod?: Maybe<TaskEntityCachedDataDeliveryMethod>;
  features?: Maybe<TaskEntityCachedDataFeatures>;
  fundingSource?: Maybe<TaskEntityCachedDataFundingSource>;
  organization?: Maybe<TaskEntityCachedDataOrganization>;
  payment?: Maybe<TaskEntityCachedDataPayment>;
  paymentApprovalAction?: Maybe<TaskEntityCachedDataPaymentApprovalAction>;
  recurringBill?: Maybe<TaskEntityCachedDataRecurringBill>;
  riskEngineDecision?: Maybe<TaskEntityCachedDataRiskEngineDecision>;
  vendor?: Maybe<TaskEntityCachedDataVendor>;
};

export type TaskEntityCachedDataBill = {
  __typename?: 'TaskEntityCachedDataBill';
  currency: Scalars['String'];
  id: Scalars['Float'];
  isTest?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
  recurringBillIndex?: Maybe<Scalars['Float']>;
  totalAmount: Scalars['Float'];
};

export type TaskEntityCachedDataDeliveryMethod = {
  __typename?: 'TaskEntityCachedDataDeliveryMethod';
  bankAccountId?: Maybe<Scalars['Float']>;
  cardAccount?: Maybe<TaskEntityCachedDataDeliveryMethodCardAccount>;
  createdAt?: Maybe<Scalars['Date']>;
  deliveryType?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  intuitAccountId?: Maybe<Scalars['String']>;
  isVerified: Scalars['Boolean'];
  paperCheckId?: Maybe<Scalars['Float']>;
  plaidAccountId?: Maybe<Scalars['Float']>;
  rppsAccountId?: Maybe<Scalars['Float']>;
  verifiedStatus?: Maybe<Scalars['String']>;
};

export type TaskEntityCachedDataDeliveryMethodCardAccount = {
  __typename?: 'TaskEntityCachedDataDeliveryMethodCardAccount';
  cardType?: Maybe<Scalars['String']>;
  network?: Maybe<Scalars['String']>;
};

export type TaskEntityCachedDataFeatures = {
  __typename?: 'TaskEntityCachedDataFeatures';
  clientIpAgeForOrganization?: Maybe<Scalars['Float']>;
  clientIpAgeForUser?: Maybe<Scalars['Float']>;
  deliveryMethodType?: Maybe<Scalars['String']>;
  doesOrgOweMoney?: Maybe<Scalars['Boolean']>;
  fundingSourceType?: Maybe<Scalars['String']>;
  hasFileRequests?: Maybe<Scalars['Boolean']>;
  invoiceOrNoteHasSanctionedWord?: Maybe<Scalars['Boolean']>;
  invoiceOrNoteHasSanctionedWordError?: Maybe<Scalars['Boolean']>;
  isApFinancingPayment?: Maybe<Scalars['Boolean']>;
  isCardWithSimilarDataApproved?: Maybe<Scalars['Boolean']>;
  isEmailVerified?: Maybe<Scalars['Boolean']>;
  isFRR?: Maybe<Scalars['Boolean']>;
  isGoodsReceived?: Maybe<Scalars['Boolean']>;
  isHighAmountForFS?: Maybe<Scalars['Boolean']>;
  isMicroDeposit?: Maybe<Scalars['Boolean']>;
  isOriginalDmEqualToCurrentDM?: Maybe<Scalars['Boolean']>;
  isPaymentExpedited?: Maybe<Scalars['Boolean']>;
  isPaymentOriginSafe?: Maybe<Scalars['Boolean']>;
  isSuspectedOfProhibitedIndustries?: Maybe<Scalars['Boolean']>;
  numOrganizationVendorCompletedPayments?: Maybe<Scalars['Float']>;
  payeeIdmScreeningNumHits?: Maybe<Scalars['Float']>;
  payorCreateOrigin?: Maybe<Scalars['String']>;
  payorIdmScreeningNumHits?: Maybe<Scalars['Float']>;
  vendorHasHandle?: Maybe<Scalars['Boolean']>;
};

export type TaskEntityCachedDataFundingSource = {
  __typename?: 'TaskEntityCachedDataFundingSource';
  bankAccountId?: Maybe<Scalars['Float']>;
  cardAccount?: Maybe<TaskEntityCachedDataFundingSourceCardAccount>;
  flexAccountId?: Maybe<Scalars['Float']>;
  id: Scalars['Float'];
  intuitAccountId?: Maybe<Scalars['String']>;
  isVerified: Scalars['Boolean'];
  origin: Scalars['String'];
  plaidAccountId?: Maybe<Scalars['Float']>;
};

export type TaskEntityCachedDataFundingSourceCardAccount = {
  __typename?: 'TaskEntityCachedDataFundingSourceCardAccount';
  cardType?: Maybe<Scalars['String']>;
  network?: Maybe<Scalars['String']>;
};

export type TaskEntityCachedDataOrganization = {
  __typename?: 'TaskEntityCachedDataOrganization';
  companyName?: Maybe<Scalars['String']>;
  decision?: Maybe<EnumTaskEntityCachedDataOrganizationDecision>;
  id: Scalars['Float'];
  isApiPartner?: Maybe<Scalars['Boolean']>;
  isSuspectedOfProhibitedIndustries?: Maybe<Scalars['Boolean']>;
  kybMoneyIn?: Maybe<EnumTaskEntityCachedDataOrganizationKybMoneyIn>;
  kybMoneyInSubType?: Maybe<EnumTaskEntityCachedDataOrganizationKybMoneyInSubType>;
  kybStatus?: Maybe<Scalars['String']>;
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  partner?: Maybe<TaskEntityCachedDataOrganizationPartner>;
  taxIdType?: Maybe<EnumTaskEntityCachedDataOrganizationTaxIdType>;
  zendeskTickets?: Maybe<Array<Maybe<TaskEntityCachedDataOrganizationZendeskTickets>>>;
};

export type TaskEntityCachedDataOrganizationPartner = {
  __typename?: 'TaskEntityCachedDataOrganizationPartner';
  companyName?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
};

export type TaskEntityCachedDataOrganizationZendeskTickets = {
  __typename?: 'TaskEntityCachedDataOrganizationZendeskTickets';
  id?: Maybe<Scalars['Float']>;
  latestComment?: Maybe<TaskEntityCachedDataOrganizationZendeskTicketsLatestComment>;
};

export type TaskEntityCachedDataOrganizationZendeskTicketsLatestComment = {
  __typename?: 'TaskEntityCachedDataOrganizationZendeskTicketsLatestComment';
  commenter?: Maybe<TaskEntityCachedDataOrganizationZendeskTicketsLatestCommentCommenter>;
  createdAt?: Maybe<Scalars['Date']>;
  priority?: Maybe<EnumTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentPriority>;
  status?: Maybe<EnumTaskEntityCachedDataOrganizationZendeskTicketsLatestCommentStatus>;
};

export type TaskEntityCachedDataOrganizationZendeskTicketsLatestCommentCommenter = {
  __typename?: 'TaskEntityCachedDataOrganizationZendeskTicketsLatestCommentCommenter';
  isAnalyst?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type TaskEntityCachedDataPayment = {
  __typename?: 'TaskEntityCachedDataPayment';
  amount: Scalars['Float'];
  createOrigin: EnumTaskEntityCachedDataPaymentCreateOrigin;
  createdAt?: Maybe<Scalars['Date']>;
  createdByEmail?: Maybe<Scalars['String']>;
  createdByPartner?: Maybe<TaskEntityCachedDataPaymentCreatedByPartner>;
  currency: Scalars['String'];
  deliveryPreference?: Maybe<EnumTaskEntityCachedDataPaymentDeliveryPreference>;
  direction?: Maybe<EnumTaskEntityCachedDataPaymentDirection>;
  foreignAmount?: Maybe<Scalars['Float']>;
  foreignCurrency?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  isPartial?: Maybe<Scalars['Boolean']>;
  isSuspectedOfProhibitedIndustries?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
  pendingReason?: Maybe<Scalars['String']>;
  productUseCase?: Maybe<Scalars['String']>;
  riskStatus?: Maybe<EnumTaskEntityCachedDataPaymentRiskStatus>;
  scheduledDate: Scalars['Date'];
};

export type TaskEntityCachedDataPaymentApprovalAction = {
  __typename?: 'TaskEntityCachedDataPaymentApprovalAction';
  reason?: Maybe<Scalars['String']>;
};

export type TaskEntityCachedDataPaymentCreatedByPartner = {
  __typename?: 'TaskEntityCachedDataPaymentCreatedByPartner';
  companyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Float']>;
};

export type TaskEntityCachedDataRecurringBill = {
  __typename?: 'TaskEntityCachedDataRecurringBill';
  id?: Maybe<Scalars['Float']>;
  occurrences?: Maybe<Scalars['Float']>;
};

export type TaskEntityCachedDataRiskEngineDecision = {
  __typename?: 'TaskEntityCachedDataRiskEngineDecision';
  features?: Maybe<Scalars['JSON']>;
  reason?: Maybe<Scalars['String']>;
};

export type TaskEntityCachedDataVendor = {
  __typename?: 'TaskEntityCachedDataVendor';
  companyName: Scalars['String'];
  id: Scalars['Float'];
  isSuspectedOfProhibitedIndustries?: Maybe<Scalars['Boolean']>;
};

export enum TaskHistoryType {
  Assigned = 'Assigned',
  ConcernAreaAssigned = 'ConcernAreaAssigned',
  ConcernAreaClaimed = 'ConcernAreaClaimed',
  ConcernAreaDecisionMade = 'ConcernAreaDecisionMade',
  ConcernAreaOverturned = 'ConcernAreaOverturned',
  ConcernAreaRerun = 'ConcernAreaRerun',
  ConcernAreaUnassigned = 'ConcernAreaUnassigned',
  EscalatedExternally = 'EscalatedExternally',
  SingleViewInFocus = 'SingleViewInFocus',
  SingleViewUnfocused = 'SingleViewUnfocused',
  TaskCompleted = 'TaskCompleted',
  TaskCreated = 'TaskCreated',
  TaskPrioritized = 'TaskPrioritized',
  TaskUpdated = 'TaskUpdated',
  Unassigned = 'Unassigned',
  UserAFK = 'UserAFK'
}

export type TaskLastEscalatedDetails = {
  __typename?: 'TaskLastEscalatedDetails';
  createdAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  lastUser?: Maybe<SherlockUser>;
  teamIntegration?: Maybe<TeamIntegration>;
  teamIntegrationId: Scalars['MongoID'];
  userId: Scalars['MongoID'];
};

/** List of items with pagination. */
export type TaskPagination = {
  __typename?: 'TaskPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Task>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TaxVerification = {
  __typename?: 'TaxVerification';
  match?: Maybe<Scalars['Boolean']>;
  provider?: Maybe<TaxVerificationProviderEnum>;
  transactionId?: Maybe<Scalars['String']>;
  transactionRecordId?: Maybe<Scalars['String']>;
};

export type TaxVerificationData = {
  __typename?: 'TaxVerificationData';
  entries?: Maybe<Array<IdmData>>;
};

export enum TaxVerificationProviderEnum {
  IdmConsumerIdology = 'IdmConsumerIdology',
  IdmConsumerUbo = 'IdmConsumerUbo',
  IdmMerchantEnigma = 'IdmMerchantEnigma',
  IdmMerchantTincheck = 'IdmMerchantTincheck',
  TruliooAdvancedKyb = 'TruliooAdvancedKyb',
  TruliooKyb = 'TruliooKyb',
  TruliooKyc = 'TruliooKyc'
}

export type Team = {
  __typename?: 'Team';
  _id: Scalars['MongoID'];
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  name: Scalars['String'];
  roles: Array<Role>;
  updatedAt?: Maybe<Scalars['Date']>;
};


export type TeamRolesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyRoleInput>;
};

/** A connection to a list of items. */
export type TeamConnection = {
  __typename?: 'TeamConnection';
  /** Total object count. */
  count: Scalars['Int'];
  /** Information to aid in pagination. */
  edges: Array<TeamEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TeamEdge = {
  __typename?: 'TeamEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Team;
};

export type TeamIntegration = {
  __typename?: 'TeamIntegration';
  _id: Scalars['MongoID'];
  deletedAt?: Maybe<Scalars['Date']>;
  entityType?: Maybe<Scalars['String']>;
  reason: Scalars['String'];
  roleIds: Array<Maybe<Scalars['MongoID']>>;
  settings: TeamIntegrationSettings;
  type: EnumTeamIntegrationType;
};

/** A connection to a list of items. */
export type TeamIntegrationConnection = {
  __typename?: 'TeamIntegrationConnection';
  /** Total object count. */
  count: Scalars['Int'];
  /** Information to aid in pagination. */
  edges: Array<TeamIntegrationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TeamIntegrationEdge = {
  __typename?: 'TeamIntegrationEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: TeamIntegration;
};

/** List of items with pagination. */
export type TeamIntegrationPagination = {
  __typename?: 'TeamIntegrationPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<TeamIntegration>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TeamIntegrationSettings = {
  __typename?: 'TeamIntegrationSettings';
  showAmount?: Maybe<Scalars['Boolean']>;
  slackChannelId?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
};

/** List of items with pagination. */
export type TeamPagination = {
  __typename?: 'TeamPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Team>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ThreadInfo = {
  __typename?: 'ThreadInfo';
  analysts?: Maybe<Array<Analyst>>;
  comments?: Maybe<Array<EscalationComment>>;
  description: EscalationDescription;
};

export enum Tier {
  FiservApArBasic = 'FiservApArBasic',
  FiservApArPro = 'FiservApArPro',
  FiservApBasic = 'FiservApBasic',
  FiservApPro = 'FiservApPro',
  FiservBase = 'FiservBase',
  FiservPro = 'FiservPro',
  GustoBasic = 'GustoBasic',
  GustoLegacy = 'GustoLegacy',
  GustoPremium = 'GustoPremium',
  MelioAccountingClientBoost = 'MelioAccountingClientBoost',
  MelioAccountingClientCore = 'MelioAccountingClientCore',
  MelioAccountingClientUnlimitedAch = 'MelioAccountingClientUnlimitedAch',
  MelioAccountingClientUnlimitedFreeTrial = 'MelioAccountingClientUnlimitedFreeTrial',
  MelioAccountingFirm = 'MelioAccountingFirm',
  MelioBasic = 'MelioBasic',
  MelioPlus = 'MelioPlus',
  MelioPro = 'MelioPro',
  MelioUnlimitedAch = 'MelioUnlimitedAch',
  MelioUnlimitedFreeTrial = 'MelioUnlimitedFreeTrial',
  MelioVip = 'MelioVip'
}

export enum TimelineAction {
  BillingStarted = 'BillingStarted',
  Canceled = 'Canceled',
  Downgraded = 'Downgraded',
  Enrolled = 'Enrolled',
  LossCreated = 'LossCreated',
  LossRecovered = 'LossRecovered',
  PromoApplied = 'PromoApplied',
  PromoExpired = 'PromoExpired',
  SeatsAdd = 'SeatsAdd',
  SeatsRemove = 'SeatsRemove',
  Upgraded = 'Upgraded'
}

export type TimelineResponse = {
  __typename?: 'TimelineResponse';
  data?: Maybe<Array<Maybe<TimelineRow>>>;
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type TimelineRow = {
  __typename?: 'TimelineRow';
  action?: Maybe<TimelineUnionAction>;
  entityType?: Maybe<PaymentTimelineEntity>;
  timestamp?: Maybe<Scalars['String']>;
};

export type TimelineUnionAction = AchLossTimeline | ActionLogTimeline | ChargebackTimeline | DmTimeline | FsTimeline | InterventionTimeline | PaymentTimeline | RiskTimeline;

export type TotalClusterEntitiesStatisticsObjectTc = {
  __typename?: 'TotalClusterEntitiesStatisticsObjectTC';
  addresses?: Maybe<TotalClusterEntityStatisticsObjectTc>;
  businessNames?: Maybe<TotalClusterEntityStatisticsObjectTc>;
  contactNames?: Maybe<TotalClusterEntityStatisticsObjectTc>;
  deliveryMethods?: Maybe<TotalClusterEntityStatisticsObjectTc>;
  emails?: Maybe<TotalClusterEntityStatisticsObjectTc>;
  phones?: Maybe<TotalClusterEntityStatisticsObjectTc>;
};

export type TotalClusterEntityStatisticsObjectTc = {
  __typename?: 'TotalClusterEntityStatisticsObjectTC';
  clusterAppearances?: Maybe<Scalars['Int']>;
  distinctValuesAmount?: Maybe<Scalars['Int']>;
};

export type TotalPayments = {
  __typename?: 'TotalPayments';
  TPV?: Maybe<Scalars['Float']>;
  numOfPayments?: Maybe<Scalars['Int']>;
};

export type TotalPaymentsByUserType = {
  __typename?: 'TotalPaymentsByUserType';
  amount?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Int']>;
  firstCompletedPaymentDate?: Maybe<Scalars['Date']>;
  lastCompletedPaymentDate?: Maybe<Scalars['Date']>;
};

export type TrackPageEventInput = {
  eventType: EventType;
  extraData?: InputMaybe<EventExtraDataInput>;
  pageTitle: Scalars['String'];
  rawUrl: Scalars['String'];
  url: UrlStructureInput;
};

export type TrackPageEventResponse = {
  __typename?: 'TrackPageEventResponse';
  createdAt?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['ID']>;
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum TransferFlow {
  Balancing = 'Balancing',
  CancelCollect = 'CancelCollect',
  CancelDeliver = 'CancelDeliver',
  Collect = 'Collect',
  Deliver = 'Deliver'
}

export enum TransferStatus {
  Acknowledged = 'Acknowledged',
  Cleared = 'Cleared',
  Committed = 'Committed',
  Completed = 'Completed',
  Failed = 'Failed',
  Scheduled = 'Scheduled',
  Sent = 'Sent',
  Settled = 'Settled'
}

export type TransferTimeline = {
  __typename?: 'TransferTimeline';
  accountType?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  clearanceDate?: Maybe<Scalars['Date']>;
  currency?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSON']>;
  errorCode?: Maybe<Scalars['String']>;
  errorReason?: Maybe<Scalars['String']>;
  failureData?: Maybe<FailureData>;
  failureDate?: Maybe<Scalars['Date']>;
  flow?: Maybe<TransferFlow>;
  installmentNumber?: Maybe<Scalars['Int']>;
  issueDate?: Maybe<Scalars['Date']>;
  ledgerEntryType?: Maybe<Scalars['String']>;
  ourAccount?: Maybe<Scalars['String']>;
  paymentMethodType?: Maybe<Scalars['String']>;
  proofOfPayment?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  rail?: Maybe<Scalars['String']>;
  sentDate?: Maybe<Scalars['Date']>;
  settlementDate?: Maybe<Scalars['Date']>;
  status?: Maybe<TransferStatus>;
  targetAccountId?: Maybe<Scalars['String']>;
  targetAccountType?: Maybe<Scalars['String']>;
  transferId?: Maybe<Scalars['String']>;
};

export type TransferTimelineCount = {
  __typename?: 'TransferTimelineCount';
  count?: Maybe<Scalars['Int']>;
};

export enum TrialTypeEnum {
  Grace = 'Grace',
  Trial = 'Trial'
}

/** A triggered agent execution with its tracking flow ID. */
export type TriggerAgentResponseItem = {
  __typename?: 'TriggerAgentResponseItem';
  /** Name of the agent that was triggered. */
  agentName: Scalars['String'];
  /** Flow ID for tracking the agent execution. */
  flowId: Scalars['String'];
};

export enum Type {
  BANK_ACCOUNT = 'BANK_ACCOUNT',
  EMAIL = 'EMAIL',
  ORGANIZATION = 'ORGANIZATION',
  USER = 'USER'
}

export enum TypePaymentEnum {
  feePayment = 'feePayment',
  feeSubscription = 'feeSubscription',
  payment = 'payment',
  paymentAndFee = 'paymentAndFee',
  recurring = 'recurring'
}

export type UiFlow = {
  __typename?: 'UIFlow';
  _id: Scalars['MongoID'];
  blocks: Array<Maybe<UiFlowBlocks>>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  disabled?: Maybe<Scalars['Boolean']>;
  disabledMessage?: Maybe<Scalars['String']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  permission?: Maybe<FlowPermission>;
  readingDeletedEntities?: Maybe<UiFlowReadingDeletedEntities>;
  rejectHandler?: Maybe<UiFlowRejectHandler>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** parameters required to run the flow */
  testParameters?: Maybe<Scalars['JSON']>;
  triggers?: Maybe<UiFlowTriggers>;
  type: Scalars['String'];
  updateComment?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  version?: Maybe<Scalars['Float']>;
};


export type UiFlowPermissionArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneFlowPermissionInput>;
};

export type UiFlowBlocks = {
  __typename?: 'UIFlowBlocks';
  actionId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  dynamicVariables?: Maybe<Array<Maybe<UiFlowBlocksDynamicVariables>>>;
  extras?: Maybe<Scalars['JSON']>;
  flowId?: Maybe<Scalars['MongoID']>;
  flowResult?: Maybe<Scalars['String']>;
  flowStatus?: Maybe<EnumUiFlowBlocksFlowStatus>;
  id: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  locked?: Maybe<Scalars['Boolean']>;
  parameters?: Maybe<Array<Maybe<UiFlowBlocksParameters>>>;
  ports?: Maybe<Array<Maybe<UiFlowBlocksPorts>>>;
  readOnly?: Maybe<Scalars['Boolean']>;
  selected?: Maybe<Scalars['Boolean']>;
  strategyId?: Maybe<Scalars['String']>;
  type?: Maybe<EnumUiFlowBlocksType>;
  wait?: Maybe<UiFlowBlocksWait>;
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type UiFlowBlocksDynamicVariables = {
  __typename?: 'UIFlowBlocksDynamicVariables';
  name: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type UiFlowBlocksDynamicVariablesInput = {
  name: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type UiFlowBlocksInput = {
  actionId?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  dynamicVariables?: InputMaybe<Array<InputMaybe<UiFlowBlocksDynamicVariablesInput>>>;
  extras?: InputMaybe<Scalars['JSON']>;
  flowId?: InputMaybe<Scalars['MongoID']>;
  flowResult?: InputMaybe<Scalars['String']>;
  flowStatus?: InputMaybe<EnumUiFlowBlocksFlowStatus>;
  id: Scalars['String'];
  label?: InputMaybe<Scalars['String']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  parameters?: InputMaybe<Array<InputMaybe<UiFlowBlocksParametersInput>>>;
  ports?: InputMaybe<Array<InputMaybe<UiFlowBlocksPortsInput>>>;
  readOnly?: InputMaybe<Scalars['Boolean']>;
  selected?: InputMaybe<Scalars['Boolean']>;
  strategyId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<EnumUiFlowBlocksType>;
  wait?: InputMaybe<UiFlowBlocksWaitInput>;
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type UiFlowBlocksParameters = {
  __typename?: 'UIFlowBlocksParameters';
  name: Scalars['String'];
  value: Scalars['JSON'];
};

export type UiFlowBlocksParametersInput = {
  name: Scalars['String'];
  value: Scalars['JSON'];
};

export type UiFlowBlocksPorts = {
  __typename?: 'UIFlowBlocksPorts';
  alignment?: Maybe<EnumUiFlowBlocksPortsAlignment>;
  extras?: Maybe<Scalars['JSON']>;
  id: Scalars['String'];
  in?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  link?: Maybe<UiFlowBlocksPortsLink>;
  links?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  locked?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  parentNode?: Maybe<Scalars['String']>;
  selected?: Maybe<Scalars['Boolean']>;
  target?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type UiFlowBlocksPortsInput = {
  alignment?: InputMaybe<EnumUiFlowBlocksPortsAlignment>;
  extras?: InputMaybe<Scalars['JSON']>;
  id: Scalars['String'];
  in?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<UiFlowBlocksPortsLinkInput>;
  links?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  locked?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentNode?: InputMaybe<Scalars['String']>;
  selected?: InputMaybe<Scalars['Boolean']>;
  target?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type UiFlowBlocksPortsLink = {
  __typename?: 'UIFlowBlocksPortsLink';
  color?: Maybe<Scalars['String']>;
  curvyness?: Maybe<Scalars['Float']>;
  extras?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['String']>;
  labels?: Maybe<Array<Maybe<UiFlowBlocksPortsLinkLabels>>>;
  locked?: Maybe<Scalars['Boolean']>;
  points?: Maybe<Array<Maybe<UiFlowBlocksPortsLinkPoints>>>;
  selected?: Maybe<Scalars['Boolean']>;
  selectedColor?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  sourcePort?: Maybe<Scalars['String']>;
  target?: Maybe<Scalars['String']>;
  targetPort?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export type UiFlowBlocksPortsLinkInput = {
  color?: InputMaybe<Scalars['String']>;
  curvyness?: InputMaybe<Scalars['Float']>;
  extras?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Array<InputMaybe<UiFlowBlocksPortsLinkLabelsInput>>>;
  locked?: InputMaybe<Scalars['Boolean']>;
  points?: InputMaybe<Array<InputMaybe<UiFlowBlocksPortsLinkPointsInput>>>;
  selected?: InputMaybe<Scalars['Boolean']>;
  selectedColor?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  sourcePort?: InputMaybe<Scalars['String']>;
  target?: InputMaybe<Scalars['String']>;
  targetPort?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type UiFlowBlocksPortsLinkLabels = {
  __typename?: 'UIFlowBlocksPortsLinkLabels';
  extras?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['String']>;
  locked?: Maybe<Scalars['Boolean']>;
  offsetX?: Maybe<Scalars['Float']>;
  offsetY?: Maybe<Scalars['Float']>;
  selected?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};

export type UiFlowBlocksPortsLinkLabelsInput = {
  extras?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  offsetX?: InputMaybe<Scalars['Float']>;
  offsetY?: InputMaybe<Scalars['Float']>;
  selected?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UiFlowBlocksPortsLinkPoints = {
  __typename?: 'UIFlowBlocksPortsLinkPoints';
  extras?: Maybe<Scalars['JSON']>;
  id: Scalars['String'];
  locked?: Maybe<Scalars['Boolean']>;
  selected?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type UiFlowBlocksPortsLinkPointsInput = {
  extras?: InputMaybe<Scalars['JSON']>;
  id: Scalars['String'];
  locked?: InputMaybe<Scalars['Boolean']>;
  selected?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type UiFlowBlocksWait = {
  __typename?: 'UIFlowBlocksWait';
  amount: Scalars['Float'];
  interval: EnumUiFlowBlocksWaitInterval;
  startFrom?: Maybe<Scalars['String']>;
};

export type UiFlowBlocksWaitInput = {
  amount: Scalars['Float'];
  interval: EnumUiFlowBlocksWaitInterval;
  startFrom?: InputMaybe<Scalars['String']>;
};

export type UiFlowReadingDeletedEntities = {
  __typename?: 'UIFlowReadingDeletedEntities';
  defaultPolicy: Scalars['Boolean'];
  deliveryMethod?: Maybe<Scalars['Boolean']>;
  fundingSource?: Maybe<Scalars['Boolean']>;
  payment?: Maybe<Scalars['Boolean']>;
};

export type UiFlowReadingDeletedEntitiesInput = {
  defaultPolicy: Scalars['Boolean'];
  deliveryMethod?: InputMaybe<Scalars['Boolean']>;
  fundingSource?: InputMaybe<Scalars['Boolean']>;
  payment?: InputMaybe<Scalars['Boolean']>;
};

export type UiFlowRejectHandler = {
  __typename?: 'UIFlowRejectHandler';
  actionId: Scalars['String'];
  parameters?: Maybe<Array<Maybe<UiFlowRejectHandlerParameters>>>;
};

export type UiFlowRejectHandlerInput = {
  actionId: Scalars['String'];
  parameters?: InputMaybe<Array<InputMaybe<UiFlowRejectHandlerParametersInput>>>;
};

export type UiFlowRejectHandlerParameters = {
  __typename?: 'UIFlowRejectHandlerParameters';
  name: Scalars['String'];
  value: Scalars['JSON'];
};

export type UiFlowRejectHandlerParametersInput = {
  name: Scalars['String'];
  value: Scalars['JSON'];
};

export type UiFlowTriggers = {
  __typename?: 'UIFlowTriggers';
  events?: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

export type UiFlowTriggersInput = {
  events?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type UboData = {
  __typename?: 'UboData';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['Date']>;
  dobMatch?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  idType?: Maybe<Scalars['String']>;
  internationalIdType?: Maybe<Scalars['String']>;
  isUSResident?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  lastUpdatedAt?: Maybe<Scalars['Date']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  nationality?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  organizationKeyIndividualDocuments?: Maybe<Array<OrgKeyIndividualDocument>>;
  ownership?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<Scalars['String']>;
  providedBy?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<OrgKeyIndividualTypeEnum>>;
  state?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<EntityTag>>>;
  taxId?: Maybe<Scalars['String']>;
  taxIdMatch?: Maybe<Scalars['Boolean']>;
  taxIdType?: Maybe<Scalars['String']>;
  verificationProvider?: Maybe<TaxVerificationProviderEnum>;
  verificationTransactionId?: Maybe<Scalars['String']>;
  verificationTransactionRecordId?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export enum UfSource {
  Fee = 'Fee',
  Payment = 'Payment',
  SubscriptionFee = 'SubscriptionFee'
}

export type UhvInfo = {
  __typename?: 'UhvInfo';
  accountOwner?: Maybe<Scalars['String']>;
  isCurrentlyUhv?: Maybe<Scalars['Boolean']>;
};

export type UnreviewedTasks = {
  __typename?: 'UnreviewedTasks';
  total: Scalars['Int'];
};

export enum UpdateBankRecordValidationResponseFailureDataFailureCode {
  ReconBatchTransferAmountMismatch = 'ReconBatchTransferAmountMismatch',
  ReconGeneralFailure = 'ReconGeneralFailure'
}

export type UpdateBankRecordValidationResponseFailureDataType = {
  __typename?: 'UpdateBankRecordValidationResponseFailureDataType';
  failureCode?: Maybe<UpdateBankRecordValidationResponseFailureDataFailureCode>;
  failureReason: Scalars['String'];
  metadata?: Maybe<MetaData>;
  originService: Scalars['String'];
  referenceId?: Maybe<Scalars['String']>;
};

export type UpdateByIdConcernAreaSchemaInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  isMandatory?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  rules?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  squadId?: InputMaybe<Scalars['MongoID']>;
  status?: InputMaybe<EnumConcernAreaSchemaStatus>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type UpdateByIdConcernAreaSchemaPayload = {
  __typename?: 'UpdateByIdConcernAreaSchemaPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ConcernAreaSchema>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdGayaThemeInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  theme?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type UpdateByIdGayaThemePayload = {
  __typename?: 'UpdateByIdGayaThemePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<GayaTheme>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdModuleRoutesInput = {
  module?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type UpdateByIdModuleRoutesPayload = {
  __typename?: 'UpdateByIdModuleRoutesPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ModuleRoutes>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdRubricFieldsInput = {
  displayName?: InputMaybe<Scalars['String']>;
  displayText?: InputMaybe<Scalars['String']>;
  displayType?: InputMaybe<EnumRubricFieldsDisplayType>;
  key?: InputMaybe<Scalars['String']>;
  linkFormat?: InputMaybe<Scalars['String']>;
};

export type UpdateByIdRubricInput = {
  createdBy?: InputMaybe<Scalars['MongoID']>;
  entity?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<Array<InputMaybe<UpdateByIdRubricFieldsInput>>>;
  name?: InputMaybe<Scalars['String']>;
  tableCollection?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<EnumRubricType>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type UpdateByIdRubricPayload = {
  __typename?: 'UpdateByIdRubricPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Rubric>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateManyGayaThemeInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  theme?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type UpdateManyGayaThemePayload = {
  __typename?: 'UpdateManyGayaThemePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']>;
};

export type UpdateOneGayaFormInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  formType?: InputMaybe<EnumGayaFormFormType>;
  name?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  schema?: InputMaybe<Scalars['JSON']>;
  theme?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
  version?: InputMaybe<Scalars['Float']>;
};

export type UpdateOneGayaFormPayload = {
  __typename?: 'UpdateOneGayaFormPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<GayaForm>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateOneGayaThemeInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  theme?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['MongoID']>;
};

export type UpdateOneGayaThemePayload = {
  __typename?: 'UpdateOneGayaThemePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<GayaTheme>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateOneIncidentBatchIdsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  batchId?: InputMaybe<Scalars['MongoID']>;
  executedBy?: InputMaybe<Scalars['MongoID']>;
  failedEntities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  groupsIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  isRunning?: InputMaybe<Scalars['Boolean']>;
  mode?: InputMaybe<EnumIncidentBatchIdsMode>;
  runAt?: InputMaybe<Scalars['Date']>;
};

export type UpdateOneIncidentInput = {
  batchIds?: InputMaybe<Array<InputMaybe<UpdateOneIncidentBatchIdsInput>>>;
  calculationSize?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['MongoID']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  entity?: InputMaybe<EnumIncidentEntity>;
  entityIds?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  fireHydrantUrl?: InputMaybe<Scalars['String']>;
  isCalculating?: InputMaybe<Scalars['Boolean']>;
  isCalculationFailed?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<EnumIncidentStatus>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type UpdateOneIncidentPayload = {
  __typename?: 'UpdateOneIncidentPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Incident>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateOneUiFlowBlocksDynamicVariablesInput = {
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type UpdateOneUiFlowBlocksInput = {
  actionId?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  dynamicVariables?: InputMaybe<Array<InputMaybe<UpdateOneUiFlowBlocksDynamicVariablesInput>>>;
  extras?: InputMaybe<Scalars['JSON']>;
  flowId?: InputMaybe<Scalars['MongoID']>;
  flowResult?: InputMaybe<Scalars['String']>;
  flowStatus?: InputMaybe<EnumUiFlowBlocksFlowStatus>;
  id?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  parameters?: InputMaybe<Array<InputMaybe<UpdateOneUiFlowBlocksParametersInput>>>;
  ports?: InputMaybe<Array<InputMaybe<UpdateOneUiFlowBlocksPortsInput>>>;
  readOnly?: InputMaybe<Scalars['Boolean']>;
  selected?: InputMaybe<Scalars['Boolean']>;
  strategyId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<EnumUiFlowBlocksType>;
  wait?: InputMaybe<UpdateOneUiFlowBlocksWaitInput>;
  x?: InputMaybe<Scalars['Float']>;
  y?: InputMaybe<Scalars['Float']>;
};

export type UpdateOneUiFlowBlocksParametersInput = {
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type UpdateOneUiFlowBlocksPortsInput = {
  alignment?: InputMaybe<EnumUiFlowBlocksPortsAlignment>;
  extras?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<UpdateOneUiFlowBlocksPortsLinkInput>;
  links?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  locked?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentNode?: InputMaybe<Scalars['String']>;
  selected?: InputMaybe<Scalars['Boolean']>;
  target?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  x?: InputMaybe<Scalars['Float']>;
  y?: InputMaybe<Scalars['Float']>;
};

export type UpdateOneUiFlowBlocksPortsLinkInput = {
  color?: InputMaybe<Scalars['String']>;
  curvyness?: InputMaybe<Scalars['Float']>;
  extras?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Array<InputMaybe<UpdateOneUiFlowBlocksPortsLinkLabelsInput>>>;
  locked?: InputMaybe<Scalars['Boolean']>;
  points?: InputMaybe<Array<InputMaybe<UpdateOneUiFlowBlocksPortsLinkPointsInput>>>;
  selected?: InputMaybe<Scalars['Boolean']>;
  selectedColor?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  sourcePort?: InputMaybe<Scalars['String']>;
  target?: InputMaybe<Scalars['String']>;
  targetPort?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type UpdateOneUiFlowBlocksPortsLinkLabelsInput = {
  extras?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  offsetX?: InputMaybe<Scalars['Float']>;
  offsetY?: InputMaybe<Scalars['Float']>;
  selected?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateOneUiFlowBlocksPortsLinkPointsInput = {
  extras?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  selected?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  x?: InputMaybe<Scalars['Float']>;
  y?: InputMaybe<Scalars['Float']>;
};

export type UpdateOneUiFlowBlocksWaitInput = {
  amount?: InputMaybe<Scalars['Float']>;
  interval?: InputMaybe<EnumUiFlowBlocksWaitInterval>;
  startFrom?: InputMaybe<Scalars['String']>;
};

export type UpdateOneUiFlowInput = {
  blocks?: InputMaybe<Array<InputMaybe<UpdateOneUiFlowBlocksInput>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  disabledMessage?: InputMaybe<Scalars['String']>;
  lastUpdatedBy?: InputMaybe<Scalars['String']>;
  readingDeletedEntities?: InputMaybe<UpdateOneUiFlowReadingDeletedEntitiesInput>;
  rejectHandler?: InputMaybe<UpdateOneUiFlowRejectHandlerInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  triggers?: InputMaybe<UpdateOneUiFlowTriggersInput>;
  type?: InputMaybe<Scalars['String']>;
  updateComment?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  version?: InputMaybe<Scalars['Float']>;
};

export type UpdateOneUiFlowPayload = {
  __typename?: 'UpdateOneUIFlowPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<UiFlow>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateOneUiFlowReadingDeletedEntitiesInput = {
  defaultPolicy?: InputMaybe<Scalars['Boolean']>;
  deliveryMethod?: InputMaybe<Scalars['Boolean']>;
  fundingSource?: InputMaybe<Scalars['Boolean']>;
  payment?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateOneUiFlowRejectHandlerInput = {
  actionId?: InputMaybe<Scalars['String']>;
  parameters?: InputMaybe<Array<InputMaybe<UpdateOneUiFlowRejectHandlerParametersInput>>>;
};

export type UpdateOneUiFlowRejectHandlerParametersInput = {
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type UpdateOneUiFlowTriggersInput = {
  events?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type UpdateOnerulesPayload = {
  __typename?: 'UpdateOnerulesPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Rules>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateSubscriptionType = {
  __typename?: 'UpdateSubscriptionType';
  endDate?: Maybe<Scalars['Date']>;
  endReason?: Maybe<Scalars['String']>;
  fundingSourceId?: Maybe<Scalars['Int']>;
  isFreeTrial?: Maybe<Scalars['Boolean']>;
  measurementInfo?: Maybe<MeasurementInfo>;
  nextSubscription?: Maybe<NextSubscriptionType>;
  planCyclePeriod?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
};

export type UpdatedByUser = {
  __typename?: 'UpdatedByUser';
  name?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UploadRequest = {
  __typename?: 'UploadRequest';
  fileId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  uploadStatus: UploadStatus;
};

export type UploadRequestStatus = {
  __typename?: 'UploadRequestStatus';
  id: Scalars['String'];
  uploadUrl: Scalars['String'];
};

export enum UploadStatus {
  Completed = 'Completed',
  Failed = 'Failed'
}

export type UrlStructureInput = {
  appName?: InputMaybe<Scalars['String']>;
  baseUrl: Scalars['String'];
  module?: InputMaybe<Scalars['String']>;
  pathParams?: InputMaybe<Scalars['JSON']>;
  queryParams?: InputMaybe<Scalars['JSON']>;
};

export type UserAndCount = {
  __typename?: 'UserAndCount';
  count?: Maybe<Scalars['Int']>;
  users?: Maybe<Array<Maybe<User>>>;
};

export type UserDetailsInput = {
  emailAddress?: InputMaybe<Scalars['String']>;
  existingId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type UserProhibitedIndustriesData = {
  __typename?: 'UserProhibitedIndustriesData';
  email: EmailProhibitedIndustriesData;
};

export type ValidatePromoCodeInputType = {
  __typename?: 'ValidatePromoCodeInputType';
  promotionCode?: Maybe<PromoCodeType>;
  valid?: Maybe<Scalars['Boolean']>;
  validationFailure?: Maybe<ValidationFailureType>;
};

export type ValidationError = ErrorInterface & {
  __typename?: 'ValidationError';
  /** List of validator errors */
  errors?: Maybe<Array<ValidatorError>>;
  /** Combined error message from all validators */
  message?: Maybe<Scalars['String']>;
};

export type ValidationFailureType = {
  __typename?: 'ValidationFailureType';
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
};

export type ValidatorError = {
  __typename?: 'ValidatorError';
  /** Input record idx in array which occurs the validation error. This `idx` is useful for createMany operation. For singular operations it always be 0. For *Many operations `idx` represents record index in array received from user. */
  idx: Scalars['Int'];
  /** Validation error message */
  message?: Maybe<Scalars['String']>;
  /** Source of the validation error from the model path */
  path?: Maybe<Scalars['String']>;
  /** Field value which occurs the validation error */
  value?: Maybe<Scalars['JSON']>;
};

export type VendorBankAccountPrefill = {
  __typename?: 'VendorBankAccountPrefill';
  accountNumber: Scalars['String'];
  routingNumber: Scalars['String'];
};

export type VendorFilter = {
  field?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type VendorProhibitedIndustriesData = {
  __typename?: 'VendorProhibitedIndustriesData';
  companyNameSuspectedWords: Array<Scalars['String']>;
  contactEmail: EmailProhibitedIndustriesData;
};

export type VendorSort = {
  field?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['String']>;
};

export type VendorStatsType = {
  __typename?: 'VendorStatsType';
  billsCount?: Maybe<Scalars['Int']>;
  completedBillsCount?: Maybe<Scalars['Int']>;
  openRequestsCount?: Maybe<Scalars['Int']>;
  totalReceivedPaymentVolume?: Maybe<Scalars['Float']>;
};

export type VendorTypeDetailsType = {
  __typename?: 'VendorTypeDetailsType';
  handle?: Maybe<Scalars['String']>;
  hasAchDeliveryMethod?: Maybe<Scalars['Boolean']>;
  hasChildVendors?: Maybe<Scalars['Boolean']>;
  hasParentVendor?: Maybe<Scalars['Boolean']>;
  hasVirtualCardDeliveryMethod?: Maybe<Scalars['Boolean']>;
  isOptedInToSTP?: Maybe<Scalars['Boolean']>;
  managedBy?: Maybe<Scalars['String']>;
  matchStatus?: Maybe<Scalars['String']>;
  matchedBusinessName?: Maybe<Scalars['String']>;
  ownedById?: Maybe<Scalars['Int']>;
  persistentFastPreference?: Maybe<Scalars['String']>;
  vendorType?: Maybe<VendorTypeEnum>;
  virtualCardAccountCreateOrigin?: Maybe<Scalars['String']>;
  virtualCardAccountStpProvider?: Maybe<Scalars['String']>;
};

export enum VendorTypeEnum {
  CHILD_GET_PAID_VENDOR = 'CHILD_GET_PAID_VENDOR',
  FAILED_TO_CALCULATE_VENDOR_TYPE = 'FAILED_TO_CALCULATE_VENDOR_TYPE',
  GLOBAL_OPT_IN_SUVC_VENDOR = 'GLOBAL_OPT_IN_SUVC_VENDOR',
  LOCAL_GUEST_VENDOR = 'LOCAL_GUEST_VENDOR',
  LOCAL_OPT_IN_SUVC_VENDOR = 'LOCAL_OPT_IN_SUVC_VENDOR',
  NETWORK_VENDOR_MSN = 'NETWORK_VENDOR_MSN',
  PARENT_GET_PAID_VENDOR = 'PARENT_GET_PAID_VENDOR',
  PERSISTENT_FAST_VENDOR_LOCAL_OPT_IN = 'PERSISTENT_FAST_VENDOR_LOCAL_OPT_IN',
  SUNLIGHT_API_VENDOR = 'SUNLIGHT_API_VENDOR'
}

export enum VerificationTaskSourceType {
  IntuitVcBusinessSubmissionForm = 'IntuitVcBusinessSubmissionForm',
  JpmVcBusinessFileUpload = 'JpmVcBusinessFileUpload',
  Msn = 'Msn',
  MsnGetPaidOrganizationFileUpload = 'MsnGetPaidOrganizationFileUpload',
  StrategicSegmentsFile = 'StrategicSegmentsFile',
  UnlinkBusinessMatch = 'UnlinkBusinessMatch',
  VcBusinessSubmissionForm = 'VcBusinessSubmissionForm'
}

export enum VerificationTaskStatus {
  Cancelled = 'Cancelled',
  Pending = 'Pending',
  Rejected = 'Rejected',
  Verified = 'Verified'
}

export enum VirtualCardStatus {
  Active = 'Active',
  Deactivated = 'Deactivated'
}

export type VirtualCardType = {
  __typename?: 'VirtualCardType';
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mcc?: Maybe<Scalars['String']>;
  status?: Maybe<VirtualCardStatus>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export enum VisibilityTeam {
  Compliance = 'Compliance',
  Default = 'Default',
  Risk = 'Risk'
}

export type WatsonView = {
  __typename?: 'WatsonView';
  _id: Scalars['MongoID'];
  createdBy?: Maybe<Scalars['MongoID']>;
  entity?: Maybe<Scalars['String']>;
  fields?: Maybe<Array<Maybe<WatsonViewFields>>>;
};

export type WatsonViewColumn = {
  __typename?: 'WatsonViewColumn';
  displayName?: Maybe<Scalars['String']>;
  displayText?: Maybe<Scalars['String']>;
  displayType?: Maybe<ColumnDisplayType>;
  filterType?: Maybe<Scalars['Int']>;
  filtersEnum?: Maybe<Array<Maybe<FilterEnum>>>;
  key?: Maybe<Scalars['String']>;
  linkFormat?: Maybe<Scalars['String']>;
};

export type WatsonViewFields = {
  __typename?: 'WatsonViewFields';
  displayName?: Maybe<Scalars['String']>;
  displayText?: Maybe<Scalars['String']>;
  displayType?: Maybe<EnumWatsonViewFieldsDisplayType>;
  key?: Maybe<Scalars['String']>;
  linkFormat?: Maybe<Scalars['String']>;
};

export type WatsonViewFieldsInput = {
  displayName?: InputMaybe<Scalars['String']>;
  displayText?: InputMaybe<Scalars['String']>;
  displayType?: InputMaybe<EnumWatsonViewFieldsDisplayType>;
  key?: InputMaybe<Scalars['String']>;
  linkFormat?: InputMaybe<Scalars['String']>;
};

export type WatsonViewWithColumns = {
  __typename?: 'WatsonViewWithColumns';
  _id?: Maybe<Scalars['String']>;
  columns?: Maybe<Array<Maybe<WatsonViewColumn>>>;
};

export type WiseProfileRestriction = {
  __typename?: 'WiseProfileRestriction';
  restricted?: Maybe<Scalars['Boolean']>;
  restrictedAt?: Maybe<Scalars['DateTime']>;
};

export type XeroOnboardingResponse = {
  __typename?: 'XeroOnboardingResponse';
  code?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ZendeskGroup = {
  __typename?: 'ZendeskGroup';
  created_at?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  share_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type ZendeskGroups = {
  __typename?: 'ZendeskGroups';
  groups?: Maybe<Array<Maybe<ZendeskGroup>>>;
};

export type ZendeskOrgTicket = {
  __typename?: 'ZendeskOrgTicket';
  createdAt?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ZendeskStatistics = {
  __typename?: 'ZendeskStatistics';
  group_name: GroupNamesEnum;
  resolved_count: Scalars['Int'];
  resolved_query?: Maybe<Scalars['String']>;
  unresolved_count: Scalars['Int'];
  unresolved_query?: Maybe<Scalars['String']>;
};

export type Account = {
  __typename?: 'account';
  accountId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  lastActiveAt?: Maybe<Scalars['DateTime']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerId?: Maybe<Scalars['Int']>;
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

export type AccountCompletedPaymentStats = {
  __typename?: 'accountCompletedPaymentStats';
  completed_pmts_for_org?: Maybe<DataWithRails>;
  id: Scalars['String'];
};

export type AccountCount = {
  __typename?: 'accountCount';
  count?: Maybe<Scalars['Int']>;
};

export type AccountEntityStatistics = {
  __typename?: 'accountEntityStatistics';
  escalatedTasksCount: Scalars['Int'];
  id: Scalars['String'];
  num_auto_declined_pmts_for_org: Scalars['Int'];
  num_completed_pmts: Scalars['Int'];
  num_failed_pmts: Scalars['Int'];
  num_failed_to_collect_pmts: Scalars['Int'];
  num_failed_to_deliver_pmts: Scalars['Int'];
  num_in_progress_pmts: Scalars['Int'];
  num_manually_declined_pmts_for_org: Scalars['Int'];
  num_pending_pmts_for_org: Scalars['Int'];
  num_scheduled_pmts: Scalars['Int'];
  pendingTasksCount: Scalars['Int'];
  sum_auto_declined_pmts_for_org: Scalars['Float'];
  sum_completed_pmts: Scalars['Float'];
  sum_failed_pmts: Scalars['Float'];
  sum_in_progress_pmts: Scalars['Float'];
  sum_manually_declined_pmts_for_org: Scalars['Float'];
  sum_pending_pmts_for_org: Scalars['Float'];
  sum_scheduled_pmts: Scalars['Float'];
  unreviewedTasksCount: Scalars['Int'];
};

export type AccountFeatures = {
  __typename?: 'accountFeatures';
  payeeZiNaicsCode4?: Maybe<Scalars['String']>;
  payeeZiNaicsCode6?: Maybe<Scalars['String']>;
  payeeZiNaicsConfidenceScore?: Maybe<Scalars['String']>;
  payorIdmTinMatch?: Maybe<Scalars['String']>;
  payorIdmTinRun?: Maybe<Scalars['String']>;
  payorZiNaicsCode4?: Maybe<Scalars['String']>;
  payorZiNaicsCode6?: Maybe<Scalars['String']>;
  payorZiNaicsConfidenceScore?: Maybe<Scalars['String']>;
};

export type AccountGeneralStatistics = {
  __typename?: 'accountGeneralStatistics';
  app_status_completed: AppStatusCount;
  app_status_failed: AppStatusCount;
  app_status_in_progress: AppStatusCount;
  app_status_scheduled: AppStatusCount;
  escalatedTasksCount: Scalars['Int'];
  failed_pmts_for_org?: Maybe<DataWithRails>;
  id: Scalars['String'];
  in_progress_pmts_for_org: DataWithRails;
  num_approved_pmts_for_org: Scalars['Int'];
  num_completed_pmts_for_org: Scalars['Int'];
  num_completed_refunds_for_org: Scalars['Int'];
  num_declined_pmts_for_org: Scalars['Int'];
  num_failed_pmts_for_org: Scalars['Int'];
  num_failed_to_collect_pmts_for_org: Scalars['Int'];
  num_failed_to_deliver_pmts_for_org: Scalars['Int'];
  num_in_progress_refunds_for_org: Scalars['Int'];
  num_pending_pmts_for_org: Scalars['Int'];
  pendingTasksCount: Scalars['Int'];
  scheduled_pmts_for_org: DataWithRails;
  sum_approved_pmts_for_org: Scalars['Float'];
  sum_completed_pmts_for_org: Scalars['Float'];
  sum_completed_refunds_for_org: Scalars['Float'];
  sum_declined_pmts_for_org: Scalars['Float'];
  sum_failed_pmts_for_org: Scalars['Float'];
  sum_in_progress_refunds_for_org: Scalars['Float'];
  sum_pending_pmts_for_org: Scalars['Float'];
  unreviewedTasksCount: Scalars['Int'];
  zendesk_statistics?: Maybe<Array<Maybe<ZendeskStatistics>>>;
};

export type AccountInfo = {
  __typename?: 'accountInfo';
  crr?: Maybe<CrrLatest>;
  features?: Maybe<AccountFeatures>;
  ode?: Maybe<OrganizationDecisionFull>;
  organization?: Maybe<Organization>;
  statistics?: Maybe<Statistics>;
};

export type AccountingPlatform = {
  __typename?: 'accountingPlatform';
  accountPayablesEnabled: Scalars['Boolean'];
  accountReceivablesEnabled: Scalars['Boolean'];
  accountingPlatformOrganizations?: Maybe<Array<Maybe<AccountingPlatformOrganization>>>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  integrationType: AccountingPlatformintegrationTypeEnumType;
  invoiceGenerationEnabled: Scalars['Boolean'];
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  paymentAccountReconciliationEnabled: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  vendorCreditsUsageEnabled: Scalars['Boolean'];
};

export type AccountingPlatformCount = {
  __typename?: 'accountingPlatformCount';
  count?: Maybe<Scalars['Int']>;
};

export type AccountingPlatformEntity = {
  __typename?: 'accountingPlatformEntity';
  accountingPlatform?: Maybe<AccountingPlatform>;
  accountingPlatformId: Scalars['Int'];
  accountingPlatformOrganization?: Maybe<AccountingPlatformOrganization>;
  accountingPlatformOrganizationId?: Maybe<Scalars['Int']>;
  createOrigin: AccountingPlatformEntitycreateOriginEnumType;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  entityId: Scalars['Int'];
  entityType: Scalars['String'];
  externalId: Scalars['String'];
  externalLastUpdated?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  lastSync?: Maybe<Scalars['DateTime']>;
  localLastUpdated?: Maybe<Scalars['DateTime']>;
  metadata?: Maybe<Scalars['SequelizeJSON']>;
  partnerName?: Maybe<Scalars['String']>;
  remoteVersion?: Maybe<Scalars['String']>;
  uniqueEntityRefIndex?: Maybe<Scalars['Boolean']>;
  uniqueExternalRefIndex?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['DateTime'];
};

export type AccountingPlatformEntityCount = {
  __typename?: 'accountingPlatformEntityCount';
  count?: Maybe<Scalars['Int']>;
};

export enum AccountingPlatformEntitycreateOriginEnumType {
  external = 'external',
  local = 'local'
}

export type AccountingPlatformOrganization = {
  __typename?: 'accountingPlatformOrganization';
  accountingPlatform?: Maybe<AccountingPlatform>;
  accountingPlatformId: Scalars['Int'];
  accountingPlatformName?: Maybe<Scalars['String']>;
  authLink?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdById?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  lastSync?: Maybe<Scalars['DateTime']>;
  melioFeesAccountId?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['SequelizeJSON']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  remoteName?: Maybe<Scalars['String']>;
  shouldGenerateInvoiceFile?: Maybe<Scalars['Boolean']>;
  syncStatus: AccountingPlatformOrganizationsyncStatusEnumType;
  uniqueDeletedAtIndex?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['DateTime'];
};

export type AccountingPlatformOrganizationCount = {
  __typename?: 'accountingPlatformOrganizationCount';
  count?: Maybe<Scalars['Int']>;
};

export type AccountingPlatformOrganizationsMetadata = {
  __typename?: 'accountingPlatformOrganizationsMetadata';
  accountingPlatformOrganizationId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  dataType: Scalars['String'];
  externalLastFetch?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  localLastFetch?: Maybe<Scalars['DateTime']>;
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type AccountingPlatformOrganizationsMetadataCount = {
  __typename?: 'accountingPlatformOrganizationsMetadataCount';
  count?: Maybe<Scalars['Int']>;
};

export enum AccountingPlatformOrganizationsyncStatusEnumType {
  failure = 'failure',
  pending = 'pending',
  started = 'started',
  synced = 'synced'
}

export enum AccountingPlatformintegrationTypeEnumType {
  codat = 'codat',
  embedded = 'embedded',
  native = 'native',
  qbdt = 'qbdt'
}

export type AchRefund = {
  __typename?: 'achRefund';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  id: Scalars['Int'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  originalPayment?: Maybe<Payment>;
  originalPaymentId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  paymentId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  voidCheck?: Maybe<VoidCheck>;
  voidCheckId?: Maybe<Scalars['Int']>;
};

export type AchRefundCount = {
  __typename?: 'achRefundCount';
  count?: Maybe<Scalars['Int']>;
};

export type Agreement = {
  __typename?: 'agreement';
  agreementSignature?: Maybe<Array<Maybe<AgreementSignature>>>;
  createdAt: Scalars['DateTime'];
  createdByPartner?: Maybe<Partner>;
  createdByPartnerId: Scalars['Int'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  enforceReading: Scalars['Boolean'];
  file?: Maybe<File>;
  fileId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  isRevoked: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type AgreementCount = {
  __typename?: 'agreementCount';
  count?: Maybe<Scalars['Int']>;
};

export type AgreementSignature = {
  __typename?: 'agreementSignature';
  agreement?: Maybe<Agreement>;
  agreementId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  createdByPartner?: Maybe<Partner>;
  createdByPartnerId: Scalars['Int'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  signerIp?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

export type AgreementSignatureCount = {
  __typename?: 'agreementSignatureCount';
  count?: Maybe<Scalars['Int']>;
};

export type ApiKey = {
  __typename?: 'apiKey';
  apiKey: Scalars['String'];
  branding?: Maybe<ApiPartnerBrandings>;
  brandingId?: Maybe<Scalars['Int']>;
  catalogId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  enableMelioEmails?: Maybe<Scalars['Boolean']>;
  erpPricingKey?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName: Scalars['String'];
  prefix?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  webhookAccountStatus?: Maybe<Scalars['String']>;
  webhookPaymentRequestStatus?: Maybe<Scalars['String']>;
  webhookSecret?: Maybe<Scalars['String']>;
};

export type ApiKeyCount = {
  __typename?: 'apiKeyCount';
  count?: Maybe<Scalars['Int']>;
};

export type ApiPartnerBrandings = {
  __typename?: 'apiPartnerBrandings';
  createdAt: Scalars['DateTime'];
  faviconUrl: Scalars['String'];
  id: Scalars['Int'];
  logoUrl: Scalars['String'];
  name: Scalars['String'];
  primaryColor: Scalars['String'];
  secondaryColor: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ApiPartnerBrandingsCount = {
  __typename?: 'apiPartnerBrandingsCount';
  count?: Maybe<Scalars['Int']>;
};

export enum AppNamesEnum {
  ActivityAgent = 'ActivityAgent',
  AgentBuilder = 'AgentBuilder',
  Busy = 'Busy',
  CommPlatform = 'CommPlatform',
  CryptoService = 'CryptoService',
  DimeShowcase = 'DimeShowcase',
  FeatureStrategyBuilder = 'FeatureStrategyBuilder',
  FeeManagement = 'FeeManagement',
  Gaya = 'Gaya',
  IncidentManagement = 'IncidentManagement',
  Melgov = 'Melgov',
  MelioLlmPlayground = 'MelioLlmPlayground',
  PathFinder = 'PathFinder',
  Reco = 'Reco',
  Ruby = 'Ruby',
  Settings = 'Settings',
  Sherlock = 'Sherlock',
  Sima = 'Sima',
  Subscription = 'Subscription',
  TaggingManagement = 'TaggingManagement',
  Watson = 'Watson'
}

export type AppStatusCount = {
  __typename?: 'appStatusCount';
  num: Scalars['Int'];
  sum: Scalars['Float'];
};

export type AppleIdToUser = {
  __typename?: 'appleIdToUser';
  appleId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

export type AppleIdToUserCount = {
  __typename?: 'appleIdToUserCount';
  count?: Maybe<Scalars['Int']>;
};

export type ApplicationPayment = {
  __typename?: 'applicationPayment';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  isDraftCheck?: Maybe<Scalars['Boolean']>;
  markedAsDeposited?: Maybe<Scalars['Boolean']>;
  partnerName?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  paymentId: Scalars['Int'];
  status: ApplicationPaymentstatusEnumType;
  uniqueDeletedAtIndex?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['DateTime'];
};

export type ApplicationPaymentCount = {
  __typename?: 'applicationPaymentCount';
  count?: Maybe<Scalars['Int']>;
};

export enum ApplicationPaymentstatusEnumType {
  blocked = 'blocked',
  canceled = 'canceled',
  completed = 'completed',
  failed = 'failed',
  in_progress = 'in_progress',
  scheduled = 'scheduled'
}

export type ApprovalDecision = {
  __typename?: 'approvalDecision';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  entityId: Scalars['Int'];
  entityType: ApprovalDecisionentityTypeEnumType;
  id: Scalars['Int'];
  partnerName: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
  status: ApprovalDecisionstatusEnumType;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

export type ApprovalDecisionCount = {
  __typename?: 'approvalDecisionCount';
  count?: Maybe<Scalars['Int']>;
};

export enum ApprovalDecisionentityTypeEnumType {
  bill = 'bill',
  payment = 'payment'
}

export enum ApprovalDecisionstatusEnumType {
  approved = 'approved',
  declined = 'declined'
}

export type ApprovalWorkflow = {
  __typename?: 'approvalWorkflow';
  approvalDecisionsCount: Scalars['Int'];
  approversGroup: ApprovalWorkflowapproversGroupEnumType;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  createdById: Scalars['Int'];
  creatorsGroup: ApprovalWorkflowcreatorsGroupEnumType;
  deletedAt?: Maybe<Scalars['DateTime']>;
  entityType: ApprovalWorkflowentityTypeEnumType;
  firstWorkflowStepId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName: Scalars['String'];
  paymentCreators?: Maybe<Array<Maybe<User>>>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  threshold: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['Int']>;
  workflowCriterias?: Maybe<Array<Maybe<WorkflowCriteria>>>;
  workflowProgresses?: Maybe<Array<Maybe<WorkflowProgress>>>;
  workflowStep?: Maybe<WorkflowStep>;
  workflowSteps?: Maybe<Array<Maybe<WorkflowStep>>>;
};

export type ApprovalWorkflowCount = {
  __typename?: 'approvalWorkflowCount';
  count?: Maybe<Scalars['Int']>;
};

export type ApprovalWorkflowUser = {
  __typename?: 'approvalWorkflowUser';
  approvalWorkflowId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

export type ApprovalWorkflowUserCount = {
  __typename?: 'approvalWorkflowUserCount';
  count?: Maybe<Scalars['Int']>;
};

export enum ApprovalWorkflowapproversGroupEnumType {
  all = 'all',
  some = 'some'
}

export enum ApprovalWorkflowcreatorsGroupEnumType {
  all = 'all',
  none = 'none',
  some = 'some'
}

export enum ApprovalWorkflowentityTypeEnumType {
  bill = 'bill',
  payment = 'payment'
}

export type AutoDebitContract = {
  __typename?: 'autoDebitContract';
  autoDebitPayorAuthorization?: Maybe<AutoDebitPayorAuthorization>;
  autoDebitPayorAuthorizationId?: Maybe<Scalars['Int']>;
  autoDebitRequest?: Maybe<AutoDebitRequest>;
  autoDebitRequestId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  isAchAllowed: Scalars['Boolean'];
  isCardAllowed: Scalars['Boolean'];
  isCardFeesAbsorbedByPayor: Scalars['Boolean'];
  maxTotalAmount?: Maybe<Scalars['String']>;
  partnerName: Scalars['String'];
  status: AutoDebitContractstatusEnumType;
  updatedAt: Scalars['DateTime'];
};

export type AutoDebitContractCount = {
  __typename?: 'autoDebitContractCount';
  count?: Maybe<Scalars['Int']>;
};

export enum AutoDebitContractstatusEnumType {
  active = 'active',
  expired = 'expired',
  pending = 'pending',
  revoked = 'revoked',
  suspended = 'suspended'
}

export type AutoDebitPayorAuthorization = {
  __typename?: 'autoDebitPayorAuthorization';
  clientIp: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  fundingSource?: Maybe<FundingSource>;
  fundingSourceId: Scalars['Int'];
  id: Scalars['Int'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

export type AutoDebitPayorAuthorizationCount = {
  __typename?: 'autoDebitPayorAuthorizationCount';
  count?: Maybe<Scalars['Int']>;
};

export type AutoDebitRequest = {
  __typename?: 'autoDebitRequest';
  contact?: Maybe<Contact>;
  contactId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type AutoDebitRequestCount = {
  __typename?: 'autoDebitRequestCount';
  count?: Maybe<Scalars['Int']>;
};

export type AutoPayPolicy = {
  __typename?: 'autoPayPolicy';
  amountType: Scalars['String'];
  clientIp: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  createdById: Scalars['Int'];
  daysBeforeDue?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  deliveryMethodId: Scalars['Int'];
  fixedAmount?: Maybe<Scalars['String']>;
  fundingSource?: Maybe<FundingSource>;
  fundingSourceId: Scalars['Int'];
  id: Scalars['Int'];
  maxAmount?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName: Scalars['String'];
  pauseReason?: Maybe<Scalars['String']>;
  payTiming: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userAgent: Scalars['String'];
  vendor?: Maybe<Vendor>;
  vendorId: Scalars['Int'];
};

export type AutoPayPolicyCount = {
  __typename?: 'autoPayPolicyCount';
  count?: Maybe<Scalars['Int']>;
};

export type BankAccount = {
  __typename?: 'bankAccount';
  accountCategory?: Maybe<BankAccountaccountCategoryEnumType>;
  accountNumber: Scalars['String'];
  accountNumberHash?: Maybe<Scalars['String']>;
  accountNumberLast4Digits?: Maybe<Scalars['String']>;
  accountType: BankAccountaccountTypeEnumType;
  createdAt: Scalars['DateTime'];
  createdAtOrigin?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  fundingSource?: Maybe<FundingSource>;
  id: Scalars['Int'];
  microDeposits?: Maybe<Array<Maybe<MicroDeposit>>>;
  microDepositsDebit?: Maybe<MicroDepositsDebit>;
  missingRoutingNumber: Scalars['Boolean'];
  partnerName?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  riskEngineDecisionMetadata?: Maybe<RiskEngineDecisionMetadata>;
  routingNumber: Scalars['String'];
  status?: Maybe<BankAccountstatusEnumType>;
  updatedAt: Scalars['DateTime'];
};

export type BankAccountCount = {
  __typename?: 'bankAccountCount';
  count?: Maybe<Scalars['Int']>;
};

export enum BankAccountaccountCategoryEnumType {
  business = 'business',
  personal = 'personal'
}

export enum BankAccountaccountTypeEnumType {
  checking = 'checking',
  savings = 'savings'
}

export enum BankAccountstatusEnumType {
  closed = 'closed',
  frozen = 'frozen',
  open = 'open'
}

export enum BankType {
  ach = 'ach',
  card = 'card',
  check = 'check'
}

export type BanksBlockedForPayment = {
  __typename?: 'banksBlockedForPayment';
  accountNumber: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  routingNumber: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type BanksBlockedForPaymentCount = {
  __typename?: 'banksBlockedForPaymentCount';
  count?: Maybe<Scalars['Int']>;
};

export type Bill = {
  __typename?: 'bill';
  accountingPlatformEntity?: Maybe<AccountingPlatformEntity>;
  accountingSoftwareData?: Maybe<AccountingSoftwareData>;
  approvalDecisionStatus: BillapprovalDecisionStatusEnumType;
  approvalDecisions?: Maybe<Array<Maybe<ApprovalDecision>>>;
  balance: Scalars['String'];
  billLineItems?: Maybe<Array<Maybe<BillLineItem>>>;
  billNotifications?: Maybe<Array<Maybe<BillNotification>>>;
  billPayments?: Maybe<Array<Maybe<BillPayment>>>;
  billSubscriptionOccurrence?: Maybe<BillSubscriptionOccurrence>;
  billerAccountBalance?: Maybe<Scalars['String']>;
  billingItems?: Maybe<Array<Maybe<BillingItem>>>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  classificationId?: Maybe<Scalars['String']>;
  contractor?: Maybe<Scalars['Boolean']>;
  createMethod?: Maybe<BillcreateMethodEnumType>;
  createdAt: Scalars['DateTime'];
  createdAtOrigin?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById: Scalars['Int'];
  createdByPartner?: Maybe<Partner>;
  createdByPartnerId?: Maybe<Scalars['Int']>;
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  eBill?: Maybe<EBill>;
  eBillAmountDue?: Maybe<Scalars['String']>;
  externalBalance?: Maybe<Scalars['String']>;
  externalLabelId?: Maybe<Scalars['String']>;
  externalTotalAmount?: Maybe<Scalars['String']>;
  externalTxnSource?: Maybe<Scalars['String']>;
  externallyPaid: Scalars['String'];
  files?: Maybe<Array<Maybe<File>>>;
  goodsReceived?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  includedInvoiceNumberSanctionedWords: Array<Scalars['String']>;
  includedNoteSanctionedWords: Array<Scalars['String']>;
  internalBill: Scalars['Boolean'];
  intuitAccountId?: Maybe<Scalars['String']>;
  invoiceDate: Scalars['DateTime'];
  invoiceNumber?: Maybe<Scalars['String']>;
  isTest?: Maybe<Scalars['Boolean']>;
  lastSync: Scalars['DateTime'];
  minimumAmount?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  origin: BilloriginEnumType;
  originId: Scalars['String'];
  originMetaUrl?: Maybe<Scalars['String']>;
  originVersion: Scalars['Int'];
  partner?: Maybe<Scalars['String']>;
  partnerIntegrationId?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  paymentRequest?: Maybe<PaymentRequest>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  payorCompanyName?: Maybe<Scalars['String']>;
  prohibitedIndustriesData?: Maybe<BillProhibitedIndustriesData>;
  promotions?: Maybe<Array<Maybe<Promotion>>>;
  purpose?: Maybe<BillpurposeEnumType>;
  qboSyncVersion?: Maybe<Scalars['Int']>;
  recurringBill?: Maybe<RecurringBill>;
  recurringBillId?: Maybe<Scalars['Int']>;
  recurringBillIndex?: Maybe<Scalars['Int']>;
  status: BillstatusEnumType;
  syncActivity?: Maybe<BillSyncActivity>;
  terms?: Maybe<Scalars['Int']>;
  totalAmount: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  updatedById: Scalars['Int'];
  usdToForeignRate?: Maybe<Scalars['String']>;
  vendor?: Maybe<Vendor>;
  vendorCompanyName?: Maybe<Scalars['String']>;
  vendorId: Scalars['Int'];
  vendorOriginId?: Maybe<Scalars['String']>;
  workflowProgresses?: Maybe<Array<Maybe<WorkflowProgress>>>;
};

export type BillCount = {
  __typename?: 'billCount';
  count?: Maybe<Scalars['Int']>;
};

export type BillLineItem = {
  __typename?: 'billLineItem';
  amount: Scalars['String'];
  bill?: Maybe<Bill>;
  billId: Scalars['Int'];
  billLineItemLabels?: Maybe<Array<Maybe<BillLineItemLabel>>>;
  billLineItemSyncMetadata?: Maybe<BillLineItemsSyncMetadata>;
  billable?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  externalCategoryId?: Maybe<Scalars['String']>;
  externalItemId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  order: Scalars['Int'];
  partnerIntegrationId?: Maybe<Scalars['String']>;
  partnerName: Scalars['String'];
  quantity?: Maybe<Scalars['String']>;
  type: BillLineItemtypeEnumType;
  unitPrice?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type BillLineItemCount = {
  __typename?: 'billLineItemCount';
  count?: Maybe<Scalars['Int']>;
};

export type BillLineItemLabel = {
  __typename?: 'billLineItemLabel';
  billLineItem?: Maybe<BillLineItem>;
  billLineItemId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  externalLabelId: Scalars['String'];
  externalListId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  order: Scalars['Int'];
  partnerName: Scalars['String'];
  type: Scalars['String'];
  uniqueDeletedAtIndex?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['DateTime'];
};

export type BillLineItemLabelCount = {
  __typename?: 'billLineItemLabelCount';
  count?: Maybe<Scalars['Int']>;
};

export type BillLineItemsSyncMetadata = {
  __typename?: 'billLineItemsSyncMetadata';
  billLineItem?: Maybe<BillLineItem>;
  billLineItemId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type BillLineItemsSyncMetadataCount = {
  __typename?: 'billLineItemsSyncMetadataCount';
  count?: Maybe<Scalars['Int']>;
};

export enum BillLineItemtypeEnumType {
  category = 'category',
  item = 'item'
}

export type BillNotification = {
  __typename?: 'billNotification';
  bill?: Maybe<Bill>;
  billId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  notificationType: BillNotificationnotificationTypeEnumType;
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  vendorAcknowledgedAt?: Maybe<Scalars['DateTime']>;
};

export type BillNotificationCount = {
  __typename?: 'billNotificationCount';
  count?: Maybe<Scalars['Int']>;
};

export enum BillNotificationnotificationTypeEnumType {
  getProPaymentAlert = 'getProPaymentAlert'
}

export type BillPayment = {
  __typename?: 'billPayment';
  amount: Scalars['String'];
  bill?: Maybe<Bill>;
  billId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  paymentId: Scalars['Int'];
  uniqueBillPaymentId?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['DateTime'];
};

export type BillPaymentCount = {
  __typename?: 'billPaymentCount';
  count?: Maybe<Scalars['Int']>;
};

export type BillSubscription = {
  __typename?: 'billSubscription';
  amount: Scalars['String'];
  approvalDecisionDate?: Maybe<Scalars['DateTime']>;
  approvalDecisionStatus: BillSubscriptionapprovalDecisionStatusEnumType;
  approvalWorkflowId?: Maybe<Scalars['Int']>;
  clientIp?: Maybe<Scalars['String']>;
  createOrigin?: Maybe<BillSubscriptioncreateOriginEnumType>;
  createdAt: Scalars['DateTime'];
  createdByPartner?: Maybe<Partner>;
  createdByPartnerId: Scalars['Int'];
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  deliveryMethodId: Scalars['Int'];
  endDate?: Maybe<Scalars['DateTime']>;
  endPolicy: BillSubscriptionendPolicyEnumType;
  file?: Maybe<File>;
  fileId?: Maybe<Scalars['Int']>;
  fundingSource?: Maybe<FundingSource>;
  fundingSourceId: Scalars['Int'];
  id: Scalars['Int'];
  intervalType: BillSubscriptionintervalTypeEnumType;
  invoiceNumber?: Maybe<Scalars['String']>;
  lastAmount?: Maybe<Scalars['String']>;
  managedBy?: Maybe<BillSubscriptionmanagedByEnumType>;
  memoToVendor?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  numOfOccurrences?: Maybe<Scalars['Int']>;
  occurrences?: Maybe<Array<Maybe<BillSubscriptionOccurrence>>>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerIntegrationId?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  purpose?: Maybe<Scalars['String']>;
  requireDepositApproval: Scalars['Boolean'];
  requireWithdrawApproval: Scalars['Boolean'];
  startDate: Scalars['DateTime'];
  status: BillSubscriptionstatusEnumType;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userAgent?: Maybe<Scalars['String']>;
  userId: Scalars['Int'];
  vendor?: Maybe<Vendor>;
  vendorId: Scalars['Int'];
  windowInDays?: Maybe<Scalars['Int']>;
};

export type BillSubscriptionCount = {
  __typename?: 'billSubscriptionCount';
  count?: Maybe<Scalars['Int']>;
};

export type BillSubscriptionOccurrence = {
  __typename?: 'billSubscriptionOccurrence';
  bill?: Maybe<Bill>;
  billId?: Maybe<Scalars['Int']>;
  billSubscription?: Maybe<BillSubscription>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deliveryDate?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  id: Scalars['Int'];
  occurrenceNumber: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['Int']>;
  scheduledDate: Scalars['DateTime'];
  subscriptionId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type BillSubscriptionOccurrenceCount = {
  __typename?: 'billSubscriptionOccurrenceCount';
  count?: Maybe<Scalars['Int']>;
};

export enum BillSubscriptionapprovalDecisionStatusEnumType {
  approved = 'approved',
  declined = 'declined',
  pending = 'pending',
  skip = 'skip'
}

export enum BillSubscriptioncreateOriginEnumType {
  accountsPayablePlatform = 'accountsPayablePlatform',
  builtPartnership = 'builtPartnership',
  merchantCheckout = 'merchantCheckout',
  nativeAndroid = 'nativeAndroid',
  nativeIos = 'nativeIos',
  nativeSdkAndroid = 'nativeSdkAndroid',
  nativeSdkIos = 'nativeSdkIos',
  pay = 'pay',
  qbdtIntegration = 'qbdtIntegration',
  qbdtMac = 'qbdtMac',
  qbdtWindows = 'qbdtWindows',
  qbmAndroid = 'qbmAndroid',
  qbmIntegration = 'qbmIntegration',
  qbmIos = 'qbmIos',
  qboIntegration = 'qboIntegration',
  qbrAndroid = 'qbrAndroid',
  qbrIntegration = 'qbrIntegration',
  qbrIos = 'qbrIos',
  request = 'request'
}

export enum BillSubscriptionendPolicyEnumType {
  endDate = 'endDate',
  noEndDate = 'noEndDate',
  numOfOccurrences = 'numOfOccurrences'
}

export enum BillSubscriptionintervalTypeEnumType {
  every_2_months = 'every_2_months',
  every_2_weeks = 'every_2_weeks',
  every_3_months = 'every_3_months',
  every_4_months = 'every_4_months',
  every_4_weeks = 'every_4_weeks',
  every_6_months = 'every_6_months',
  monthly = 'monthly',
  twice_a_month = 'twice_a_month',
  weekly = 'weekly',
  yearly = 'yearly'
}

export enum BillSubscriptionmanagedByEnumType {
  fiserv = 'fiserv'
}

export enum BillSubscriptionstatusEnumType {
  canceled = 'canceled',
  created = 'created',
  done = 'done',
  inProgress = 'inProgress',
  stopped = 'stopped'
}

export type BillSyncActivity = {
  __typename?: 'billSyncActivity';
  bill?: Maybe<Bill>;
  billId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  direction: BillSyncActivitydirectionEnumType;
  errorMessage?: Maybe<Scalars['String']>;
  externalIntegrationType?: Maybe<BillSyncActivityexternalIntegrationTypeEnumType>;
  id: Scalars['Int'];
  lastSyncedAt: Scalars['DateTime'];
  partnerName?: Maybe<Scalars['String']>;
  status: BillSyncActivitystatusEnumType;
  updatedAt: Scalars['DateTime'];
};

export type BillSyncActivityCount = {
  __typename?: 'billSyncActivityCount';
  count?: Maybe<Scalars['Int']>;
};

export enum BillSyncActivitydirectionEnumType {
  melio = 'melio',
  qbo = 'qbo'
}

export enum BillSyncActivityexternalIntegrationTypeEnumType {
  qbd = 'qbd',
  qboPaid = 'qboPaid',
  xerox = 'xerox'
}

export enum BillSyncActivitystatusEnumType {
  error = 'error',
  noChange = 'noChange',
  success = 'success'
}

export enum BillapprovalDecisionStatusEnumType {
  approved = 'approved',
  declined = 'declined',
  pending = 'pending',
  skip = 'skip'
}

export enum BillcreateMethodEnumType {
  just_pay = 'just_pay'
}

export type Biller = {
  __typename?: 'biller';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  billerId: Scalars['String'];
  category?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  masks?: Maybe<Scalars['SequelizeJSON']>;
  note?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  zipCode?: Maybe<Scalars['String']>;
};

export type BillerCount = {
  __typename?: 'billerCount';
  count?: Maybe<Scalars['Int']>;
};

export type BillingItem = {
  __typename?: 'billingItem';
  amount: Scalars['String'];
  bill?: Maybe<Bill>;
  billId?: Maybe<Scalars['Int']>;
  calculationId?: Maybe<Scalars['String']>;
  chargeType: BillingItemchargeTypeEnumType;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  feeInternalPaymentId?: Maybe<Scalars['Int']>;
  feeProcessingType: BillingItemfeeProcessingTypeEnumType;
  id: Scalars['Int'];
  isRefunded: Scalars['Boolean'];
  isVendorOrganization?: Maybe<Scalars['Boolean']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  partnerName: Scalars['String'];
  payment?: Maybe<Payment>;
  paymentId: Scalars['Int'];
  status: BillingItemstatusEnumType;
  type: BillingItemtypeEnumType;
  updatedAt: Scalars['DateTime'];
};

export type BillingItemCount = {
  __typename?: 'billingItemCount';
  count?: Maybe<Scalars['Int']>;
};

export enum BillingItemchargeTypeEnumType {
  newFeePayment = 'newFeePayment',
  samePayment = 'samePayment'
}

export enum BillingItemfeeProcessingTypeEnumType {
  gross = 'gross',
  net = 'net'
}

export enum BillingItemstatusEnumType {
  canceled = 'canceled',
  charged = 'charged',
  failed = 'failed',
  pending = 'pending'
}

export enum BillingItemtypeEnumType {
  ach = 'ach',
  achToAch = 'achToAch',
  achToAchVendor = 'achToAchVendor',
  achToCheck = 'achToCheck',
  achToFastInternationalGusd = 'achToFastInternationalGusd',
  arCredit = 'arCredit',
  arDebit = 'arDebit',
  arErpProcessingFee = 'arErpProcessingFee',
  arProcessingFee = 'arProcessingFee',
  billerDirectory = 'billerDirectory',
  cardToAch = 'cardToAch',
  cardToFastInternationalGusd = 'cardToFastInternationalGusd',
  check = 'check',
  credit = 'credit',
  cryptoUsd = 'cryptoUsd',
  debit = 'debit',
  dmAch = 'dmAch',
  dmCheck = 'dmCheck',
  domesticWire = 'domesticWire',
  expeditedAch = 'expeditedAch',
  expeditedAchVendor = 'expeditedAchVendor',
  expressCheck = 'expressCheck',
  expressDomesticWire = 'expressDomesticWire',
  fastInternationalFx = 'fastInternationalFx',
  international = 'international',
  internationalFx = 'internationalFx',
  internationalWire = 'internationalWire',
  overnightCheck = 'overnightCheck',
  paypalBalanceToAch = 'paypalBalanceToAch',
  pushToDebit = 'pushToDebit',
  refund = 'refund',
  rtp = 'rtp',
  rtpOrganization = 'rtpOrganization'
}

export type BillingPermission = {
  __typename?: 'billingPermission';
  checkout?: Maybe<Checkout>;
  checkoutId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  fundingSource?: Maybe<FundingSource>;
  fundingSourceId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  isRechargeable: Scalars['Boolean'];
  netTerms: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  status: BillingPermissionstatusEnumType;
  updatedAt: Scalars['DateTime'];
};

export type BillingPermissionCount = {
  __typename?: 'billingPermissionCount';
  count?: Maybe<Scalars['Int']>;
};

export enum BillingPermissionstatusEnumType {
  active = 'active',
  created = 'created',
  inactive = 'inactive'
}

export type BillingSettings = {
  __typename?: 'billingSettings';
  catalogReference?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  fundingSource?: Maybe<FundingSource>;
  fundingSourceId?: Maybe<Scalars['Int']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type BillingSettingsCount = {
  __typename?: 'billingSettingsCount';
  count?: Maybe<Scalars['Int']>;
};

export enum BilloriginEnumType {
  amazonBusiness = 'amazonBusiness',
  dropbox = 'dropbox',
  fiserv = 'fiserv',
  googleAdwords = 'googleAdwords',
  googleDrive = 'googleDrive',
  intuit = 'intuit',
  local = 'local',
  meta = 'meta',
  oneDrive = 'oneDrive',
  quickbooksDesktop = 'quickbooksDesktop',
  shopifyStocky = 'shopifyStocky'
}

export enum BillpurposeEnumType {
  payment = 'payment',
  paymentFee = 'paymentFee',
  subscriptionFee = 'subscriptionFee'
}

export enum BillstatusEnumType {
  cancelled = 'cancelled',
  draft = 'draft',
  paid = 'paid',
  partially_paid = 'partially_paid',
  scheduled = 'scheduled',
  unpaid = 'unpaid'
}

export type BlockCreditToVendorConfiguration = {
  __typename?: 'blockCreditToVendorConfiguration';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  vendor?: Maybe<Vendor>;
  vendorId: Scalars['Int'];
};

export type BlockCreditToVendorConfigurationCount = {
  __typename?: 'blockCreditToVendorConfigurationCount';
  count?: Maybe<Scalars['Int']>;
};

export type CapitalOsAccounts = {
  __typename?: 'capitalOsAccounts';
  accountId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName: Scalars['String'];
  status: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CapitalOsAccountsCount = {
  __typename?: 'capitalOsAccountsCount';
  count?: Maybe<Scalars['Int']>;
};

export type CardAccount = {
  __typename?: 'cardAccount';
  accountId?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  card4digits: Scalars['String'];
  cardAccountTabapayClient?: Maybe<CardAccountTabapayClient>;
  cardBin?: Maybe<Scalars['String']>;
  cardCountry?: Maybe<Scalars['String']>;
  cardCurrency?: Maybe<Scalars['String']>;
  cardType: CardAccountcardTypeEnumType;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  expiration: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  fundingSource?: Maybe<FundingSource>;
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  network?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  rawAVSQuery?: Maybe<Scalars['String']>;
  referenceId?: Maybe<Scalars['String']>;
  riskEngineDecisionMetadata?: Maybe<RiskEngineDecisionMetadata>;
  state?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  zipCode?: Maybe<Scalars['String']>;
};

export type CardAccountCount = {
  __typename?: 'cardAccountCount';
  count?: Maybe<Scalars['Int']>;
};

export type CardAccountTabapayClient = {
  __typename?: 'cardAccountTabapayClient';
  cardAccount?: Maybe<CardAccount>;
  cardAccountId: Scalars['Int'];
  clientIdType: CardAccountTabapayClientclientIdTypeEnumType;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CardAccountTabapayClientCount = {
  __typename?: 'cardAccountTabapayClientCount';
  count?: Maybe<Scalars['Int']>;
};

export enum CardAccountTabapayClientclientIdTypeEnumType {
  new = 'new',
  old = 'old'
}

export enum CardAccountcardTypeEnumType {
  credit = 'credit',
  debit = 'debit'
}

export type CatalogItem = {
  __typename?: 'catalogItem';
  createdAt: Scalars['DateTime'];
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  price: Scalars['Int'];
  taxable: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type CatalogItemCount = {
  __typename?: 'catalogItemCount';
  count?: Maybe<Scalars['Int']>;
};

export type CcBlockedBins = {
  __typename?: 'ccBlockedBins';
  bin: Scalars['Int'];
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type CcBlockedBinsCount = {
  __typename?: 'ccBlockedBinsCount';
  count?: Maybe<Scalars['Int']>;
};

export type Charge = {
  __typename?: 'charge';
  amount: Scalars['Int'];
  billingPermission?: Maybe<BillingPermission>;
  billingPermissionId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  externalId: Scalars['String'];
  id: Scalars['Int'];
  invoiceFile?: Maybe<File>;
  invoiceFileId?: Maybe<Scalars['Int']>;
  invoiceNumber: Scalars['String'];
  orderId: Scalars['String'];
  partnerName?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type ChargeCount = {
  __typename?: 'chargeCount';
  count?: Maybe<Scalars['Int']>;
};

export type CheckTrack = {
  __typename?: 'checkTrack';
  amount?: Maybe<Scalars['String']>;
  carrier: CheckTrackcarrierEnumType;
  checkSerialNumber: Scalars['String'];
  clearanceDate?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  issueDate?: Maybe<Scalars['DateTime']>;
  partnerName?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  paymentId: Scalars['Int'];
  scannedAmount?: Maybe<Scalars['String']>;
  scannedSerialNumber?: Maybe<Scalars['String']>;
  sentDate?: Maybe<Scalars['DateTime']>;
  trackingNumber?: Maybe<Scalars['String']>;
  trackingUrl: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  voidStatus?: Maybe<CheckTrackvoidStatusEnumType>;
};

export type CheckTrackCount = {
  __typename?: 'checkTrackCount';
  count?: Maybe<Scalars['Int']>;
};

export enum CheckTrackcarrierEnumType {
  fedex = 'fedex',
  ups = 'ups'
}

export enum CheckTrackvoidStatusEnumType {
  positivePayRejected = 'positivePayRejected',
  voided = 'voided'
}

export type Checkout = {
  __typename?: 'checkout';
  approvalDocumentFile?: Maybe<File>;
  approvalDocumentFileId?: Maybe<Scalars['Int']>;
  billingAddress1: Scalars['String'];
  billingAddress2?: Maybe<Scalars['String']>;
  billingCity: Scalars['String'];
  billingContactEmail?: Maybe<Scalars['String']>;
  billingContactFirstName?: Maybe<Scalars['String']>;
  billingContactLastName?: Maybe<Scalars['String']>;
  billingPermission: Scalars['Boolean'];
  billingState: Scalars['String'];
  billingZipCode: Scalars['String'];
  buyerClientIp?: Maybe<Scalars['String']>;
  buyerEmail?: Maybe<Scalars['String']>;
  buyerFirstName?: Maybe<Scalars['String']>;
  buyerLastName?: Maybe<Scalars['String']>;
  buyerOrganization?: Maybe<Organization>;
  buyerOrganizationId?: Maybe<Scalars['Int']>;
  buyerPhone?: Maybe<Scalars['String']>;
  buyerUser?: Maybe<User>;
  buyerUserAgent?: Maybe<Scalars['String']>;
  buyerUserId?: Maybe<Scalars['Int']>;
  charge?: Maybe<Charge>;
  chargeId?: Maybe<Scalars['Int']>;
  companyName?: Maybe<Scalars['String']>;
  coupons?: Maybe<Scalars['SequelizeJSON']>;
  createdAt: Scalars['DateTime'];
  createdByPartner?: Maybe<Partner>;
  createdByPartnerId?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  financingToken?: Maybe<Scalars['String']>;
  fundingSource?: Maybe<FundingSource>;
  fundingSourceId?: Maybe<Scalars['Int']>;
  giftCertificates?: Maybe<Scalars['SequelizeJSON']>;
  grandTotal: Scalars['Int'];
  id: Scalars['Int'];
  lineItems: Scalars['SequelizeJSON'];
  merchantConfiguration?: Maybe<MerchantConfiguration>;
  merchantConfigurationId: Scalars['Int'];
  netTerms: Scalars['Int'];
  outstandingBalance: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  payerClientIp?: Maybe<Scalars['String']>;
  payerNote?: Maybe<Scalars['String']>;
  payerOrganization?: Maybe<Organization>;
  payerOrganizationId?: Maybe<Scalars['Int']>;
  payerUser?: Maybe<User>;
  payerUserAgent?: Maybe<Scalars['String']>;
  payerUserId?: Maybe<Scalars['Int']>;
  paymentForRisk?: Maybe<Payment>;
  paymentForRiskId?: Maybe<Scalars['Int']>;
  paymentRequest?: Maybe<PaymentRequest>;
  paymentRequestId?: Maybe<Scalars['Int']>;
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  returnUrl?: Maybe<Scalars['String']>;
  shippingAddress1: Scalars['String'];
  shippingAddress2?: Maybe<Scalars['String']>;
  shippingCity: Scalars['String'];
  shippingCostTotal?: Maybe<Scalars['Int']>;
  shippingState: Scalars['String'];
  shippingZipCode: Scalars['String'];
  status: CheckoutstatusEnumType;
  storeCredit?: Maybe<Scalars['Int']>;
  subtotal: Scalars['Int'];
  taxTotal: Scalars['Int'];
  taxes?: Maybe<Scalars['SequelizeJSON']>;
  updatedAt: Scalars['DateTime'];
};

export type CheckoutCount = {
  __typename?: 'checkoutCount';
  count?: Maybe<Scalars['Int']>;
};

export enum CheckoutstatusEnumType {
  captured = 'captured',
  completed = 'completed',
  contactBlocked = 'contactBlocked',
  created = 'created',
  expired = 'expired',
  filledContact = 'filledContact',
  filledFunding = 'filledFunding',
  unpaid = 'unpaid'
}

export type CodeEmailVerification = {
  __typename?: 'codeEmailVerification';
  allowedAttempts: Scalars['Int'];
  attemptsMade: Scalars['Int'];
  code: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  expirationDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  isUsed?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<Scalars['SequelizeJSON']>;
  partnerName?: Maybe<Scalars['String']>;
  purpose: CodeEmailVerificationpurposeEnumType;
  status?: Maybe<CodeEmailVerificationstatusEnumType>;
  updatedAt: Scalars['DateTime'];
};

export type CodeEmailVerificationCount = {
  __typename?: 'codeEmailVerificationCount';
  count?: Maybe<Scalars['Int']>;
};

export enum CodeEmailVerificationpurposeEnumType {
  authVerification = 'authVerification',
  emailVerification = 'emailVerification'
}

export enum CodeEmailVerificationstatusEnumType {
  invalid = 'invalid',
  maxAttempts = 'maxAttempts',
  pending = 'pending',
  verified = 'verified'
}

export type ConsentedGuestFundingSource = {
  __typename?: 'consentedGuestFundingSource';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  fundingSource?: Maybe<FundingSource>;
  fundingSourceId: Scalars['Int'];
  id: Scalars['Int'];
  isConsented: Scalars['Boolean'];
  partnerName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ConsentedGuestFundingSourceCount = {
  __typename?: 'consentedGuestFundingSourceCount';
  count?: Maybe<Scalars['Int']>;
};

export type Contact = {
  __typename?: 'contact';
  companyName: Scalars['String'];
  contactOrganization?: Maybe<Organization>;
  contactOrganizationId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  lastName?: Maybe<Scalars['String']>;
  organizations?: Maybe<Array<Maybe<Organization>>>;
  origin?: Maybe<ContactoriginEnumType>;
  originId?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  paymentRequests?: Maybe<Array<Maybe<PaymentRequest>>>;
  phone?: Maybe<Scalars['String']>;
  syncActivity?: Maybe<CustomerSyncActivity>;
  syncMetadata?: Maybe<Array<Maybe<CustomersSyncMetadata>>>;
  type: ContacttypeEnumType;
  updatedAt: Scalars['DateTime'];
};

export type ContactCount = {
  __typename?: 'contactCount';
  count?: Maybe<Scalars['Int']>;
};

export enum ContactoriginEnumType {
  codatIntegration = 'codatIntegration',
  intuit = 'intuit',
  local = 'local',
  melioMeExternalApi = 'melioMeExternalApi',
  quickbooksDesktop = 'quickbooksDesktop'
}

export enum ContacttypeEnumType {
  business = 'business',
  consumer = 'consumer',
  customer = 'customer',
  lead = 'lead',
  vendor = 'vendor'
}

export type Coupon = {
  __typename?: 'coupon';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  metadataHistory?: Maybe<Array<Maybe<CouponsMetadata>>>;
  partnerName?: Maybe<Scalars['String']>;
  paymentRequest?: Maybe<PaymentRequest>;
  paymentRequestId?: Maybe<Scalars['Int']>;
  reimbursementBill?: Maybe<Bill>;
  reimbursementBillId?: Maybe<Scalars['Int']>;
  status: CouponstatusEnumType;
  target?: Maybe<Scalars['String']>;
  targetType: Scalars['String'];
  template?: Maybe<CouponTemplate>;
  templateId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type CouponCount = {
  __typename?: 'couponCount';
  count?: Maybe<Scalars['Int']>;
};

export type CouponTemplate = {
  __typename?: 'couponTemplate';
  applicableIn: CouponTemplateapplicableInEnumType;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  initialMetadata?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  targetType: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CouponTemplateCount = {
  __typename?: 'couponTemplateCount';
  count?: Maybe<Scalars['Int']>;
};

export enum CouponTemplateapplicableInEnumType {
  guestRegistrationFlow = 'guestRegistrationFlow'
}

export type CouponsMetadata = {
  __typename?: 'couponsMetadata';
  coupon?: Maybe<Coupon>;
  couponId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  metadata?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CouponsMetadataCount = {
  __typename?: 'couponsMetadataCount';
  count?: Maybe<Scalars['Int']>;
};

export enum CouponstatusEnumType {
  activated = 'activated',
  created = 'created',
  expired = 'expired',
  fulfilled = 'fulfilled'
}

export type CrrLatest = {
  __typename?: 'crrLatest';
  crrRank?: Maybe<CrrRankEnum>;
  source?: Maybe<CrrSourceEnum>;
};

export type CryptoUsdAccount = {
  __typename?: 'cryptoUSDAccount';
  addressLast4Chars?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  id: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CryptoUsdAccountCount = {
  __typename?: 'cryptoUSDAccountCount';
  count?: Maybe<Scalars['Int']>;
};

export type CustomerSyncActivity = {
  __typename?: 'customerSyncActivity';
  contact?: Maybe<Contact>;
  createdAt: Scalars['DateTime'];
  customerId: Scalars['Int'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  direction: CustomerSyncActivitydirectionEnumType;
  errorMessage?: Maybe<Scalars['String']>;
  externalIntegrationType?: Maybe<CustomerSyncActivityexternalIntegrationTypeEnumType>;
  id: Scalars['Int'];
  lastSyncedAt: Scalars['DateTime'];
  partnerName?: Maybe<Scalars['String']>;
  status: CustomerSyncActivitystatusEnumType;
  updatedAt: Scalars['DateTime'];
};

export type CustomerSyncActivityCount = {
  __typename?: 'customerSyncActivityCount';
  count?: Maybe<Scalars['Int']>;
};

export enum CustomerSyncActivitydirectionEnumType {
  melio = 'melio',
  qbo = 'qbo'
}

export enum CustomerSyncActivityexternalIntegrationTypeEnumType {
  qbd = 'qbd',
  qboGetPaid = 'qboGetPaid',
  xerox = 'xerox'
}

export enum CustomerSyncActivitystatusEnumType {
  error = 'error',
  noChange = 'noChange',
  success = 'success'
}

export type CustomersSyncMetadata = {
  __typename?: 'customersSyncMetadata';
  createRequestId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  customerId?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  externalIntegrationType?: Maybe<CustomersSyncMetadataexternalIntegrationTypeEnumType>;
  externalLastUpdate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  localLastUpdate?: Maybe<Scalars['DateTime']>;
  partnerName?: Maybe<Scalars['String']>;
  syncMetadata?: Maybe<Contact>;
  txnSource?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CustomersSyncMetadataCount = {
  __typename?: 'customersSyncMetadataCount';
  count?: Maybe<Scalars['Int']>;
};

export enum CustomersSyncMetadataexternalIntegrationTypeEnumType {
  qbd = 'qbd',
  qboGetPaid = 'qboGetPaid',
  xerox = 'xerox'
}

export type DataWithRails = {
  __typename?: 'dataWithRails';
  num: Scalars['Int'];
  offRailsCount: Scalars['Int'];
  onRailsCount: Scalars['Int'];
  onRailsSum: Scalars['Float'];
  sum: Scalars['Float'];
};

export type DecisionCodes = {
  __typename?: 'decisionCodes';
  decisionCodes?: Maybe<Array<Maybe<DecisionCodeTc>>>;
};

export type DeletionRequest = {
  __typename?: 'deletionRequest';
  createdAt: Scalars['DateTime'];
  cxAgentEmail: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletionRequestItems?: Maybe<Array<Maybe<DeletionRequestItem>>>;
  id: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
  partnerName: Scalars['String'];
  requestTime: Scalars['DateTime'];
  requesterUserId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type DeletionRequestCount = {
  __typename?: 'deletionRequestCount';
  count?: Maybe<Scalars['Int']>;
};

export type DeletionRequestItem = {
  __typename?: 'deletionRequestItem';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletionRequest?: Maybe<DeletionRequest>;
  entityId: Scalars['Int'];
  entityType: DeletionRequestItementityTypeEnumType;
  id: Scalars['Int'];
  partnerName: Scalars['String'];
  requestId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type DeletionRequestItemCount = {
  __typename?: 'deletionRequestItemCount';
  count?: Maybe<Scalars['Int']>;
};

export enum DeletionRequestItementityTypeEnumType {
  ORGANIZATION = 'ORGANIZATION',
  USER = 'USER'
}

export type DeliveryMethod = {
  __typename?: 'deliveryMethod';
  achLast4Digits?: Maybe<Scalars['String']>;
  bankAccount?: Maybe<BankAccount>;
  bankAccountId?: Maybe<Scalars['Int']>;
  billSubscriptions?: Maybe<Array<Maybe<BillSubscription>>>;
  cardAccount?: Maybe<CardAccount>;
  cardAccountId?: Maybe<Scalars['Int']>;
  cardLast4Digits?: Maybe<Scalars['String']>;
  checkFormattedAddress?: Maybe<Scalars['String']>;
  checkPrintName?: Maybe<Scalars['String']>;
  checkSerialNumber?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  createdByEmail?: Maybe<Scalars['String']>;
  createdById: Scalars['Int'];
  createdByPartner?: Maybe<Partner>;
  createdByPartnerId?: Maybe<Scalars['Int']>;
  cryptoUSDAccount?: Maybe<CryptoUsdAccount>;
  cryptoUSDAccountId?: Maybe<Scalars['Int']>;
  deferredDelivery?: Maybe<Scalars['SequelizeJSON']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deliveryMethodAccount?: Maybe<AccountsServiceAccountInfo>;
  deliveryType: DeliveryMethoddeliveryTypeEnumType;
  dmLinkingDetails: DmLinkingDetails;
  domesticWireAccount?: Maybe<DomesticWireAccount>;
  domesticWireAccountId?: Maybe<Scalars['Int']>;
  features?: Maybe<DeliveryMethodFeatures>;
  id: Scalars['Int'];
  internationalAccount?: Maybe<InternationalAccount>;
  internationalAccountId?: Maybe<Scalars['Int']>;
  intuitAccountId?: Maybe<Scalars['String']>;
  isFilledByVendor: Scalars['Boolean'];
  isVerified: Scalars['Boolean'];
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  logo?: Maybe<Scalars['String']>;
  managedAccount?: Maybe<ManagedAccount>;
  managedAccountId?: Maybe<Scalars['Int']>;
  managedBy?: Maybe<DeliveryMethodmanagedByEnumType>;
  managingDeliveryMethod?: Maybe<DeliveryMethod>;
  managingDeliveryMethodId?: Maybe<Scalars['Int']>;
  paperCheck?: Maybe<PaperCheck>;
  paperCheckId?: Maybe<Scalars['Int']>;
  partnerIntegrationId?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  paymentsAccountId?: Maybe<Scalars['String']>;
  paypalBalanceAccount?: Maybe<PaypalBalanceAccount>;
  paypalBalanceAccountId?: Maybe<Scalars['Int']>;
  plaidAccount?: Maybe<PlaidAccount>;
  plaidAccountId?: Maybe<Scalars['Int']>;
  requireConfirmationForPayment: Scalars['Boolean'];
  riskEngineDecisionMetadata?: Maybe<RiskEngineDecisionMetadata>;
  routingNumber?: Maybe<Scalars['String']>;
  rppsAccount?: Maybe<RppsAccount>;
  rppsAccountId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  vendor?: Maybe<Vendor>;
  vendorId: Scalars['Int'];
  verifiedAt?: Maybe<Scalars['DateTime']>;
  verifiedStatus: DeliveryMethodverifiedStatusEnumType;
  virtualAccount?: Maybe<VirtualAccount>;
  virtualAccountId?: Maybe<Scalars['Int']>;
  virtualCardAccount?: Maybe<VirtualCardAccount>;
  virtualCardAccountId?: Maybe<Scalars['Int']>;
};


export type DeliveryMethodLastUsedAtArgs = {
  organizationId?: InputMaybe<Scalars['Int']>;
};

export type DeliveryMethodCount = {
  __typename?: 'deliveryMethodCount';
  count?: Maybe<Scalars['Int']>;
};

export type DeliveryMethodFeatures = {
  __typename?: 'deliveryMethodFeatures';
  isDmFilledByVendor?: Maybe<Scalars['Boolean']>;
};

export type DeliveryMethodFeeOnlyFundingSource = {
  __typename?: 'deliveryMethodFeeOnlyFundingSource';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  deliveryMethodId: Scalars['Int'];
  fundingSource?: Maybe<FundingSource>;
  fundingSourceId: Scalars['Int'];
  id: Scalars['Int'];
  partnerName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type DeliveryMethodFeeOnlyFundingSourceCount = {
  __typename?: 'deliveryMethodFeeOnlyFundingSourceCount';
  count?: Maybe<Scalars['Int']>;
};

export enum DeliveryMethoddeliveryTypeEnumType {
  ach = 'ach',
  card = 'card',
  check = 'check',
  cryptoUsd = 'cryptoUsd',
  domesticWire = 'domesticWire',
  international = 'international',
  internationalWire = 'internationalWire',
  managed = 'managed',
  paypalBalance = 'paypalBalance',
  rpps = 'rpps',
  virtual = 'virtual',
  virtualCard = 'virtualCard'
}

export enum DeliveryMethodmanagedByEnumType {
  biller = 'biller',
  fiserv = 'fiserv',
  msn = 'msn',
  shared = 'shared',
  virtualCard = 'virtualCard'
}

export enum DeliveryMethodverifiedStatusEnumType {
  microDepositVerified = 'microDepositVerified',
  notVerified = 'notVerified',
  plaidVerified = 'plaidVerified',
  softVerified = 'softVerified'
}

export type Discount = {
  __typename?: 'discount';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  type: DiscounttypeEnumType;
  updatedAt: Scalars['DateTime'];
  value: Scalars['Float'];
};

export type DiscountCount = {
  __typename?: 'discountCount';
  count?: Maybe<Scalars['Int']>;
};

export enum DiscounttypeEnumType {
  amount = 'amount',
  percentage = 'percentage'
}

export type DomesticWireAccount = {
  __typename?: 'domesticWireAccount';
  aba?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  financialInstitutionName?: Maybe<Scalars['String']>;
  financialInstitutionZipCode?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  last4Digits?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  payeeName?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  zipCode?: Maybe<Scalars['String']>;
};

export type DomesticWireAccountCount = {
  __typename?: 'domesticWireAccountCount';
  count?: Maybe<Scalars['Int']>;
};

export type DraftDeliveryMethod = {
  __typename?: 'draftDeliveryMethod';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  details: Scalars['String'];
  dmType: Scalars['String'];
  id: Scalars['Int'];
  partnerName: Scalars['String'];
  source: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  vendor?: Maybe<Vendor>;
  vendorId: Scalars['Int'];
};

export type DraftDeliveryMethodCount = {
  __typename?: 'draftDeliveryMethodCount';
  count?: Maybe<Scalars['Int']>;
};

export type EBill = {
  __typename?: 'eBill';
  acceptedAt?: Maybe<Scalars['DateTime']>;
  amount?: Maybe<Scalars['String']>;
  bill?: Maybe<Bill>;
  billId?: Maybe<Scalars['Int']>;
  createOrigin?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  downloadUrl?: Maybe<Scalars['String']>;
  eBillLineItems?: Maybe<Array<Maybe<EBillLineItem>>>;
  file?: Maybe<File>;
  fileId: Scalars['Int'];
  id: Scalars['Int'];
  invoiceNumber?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  parsedData?: Maybe<Scalars['SequelizeJSON']>;
  partnerName?: Maybe<Scalars['String']>;
  processedAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  vendor?: Maybe<Vendor>;
  vendorId: Scalars['Int'];
};

export type EBillCount = {
  __typename?: 'eBillCount';
  count?: Maybe<Scalars['Int']>;
};

export type EBillLineItem = {
  __typename?: 'eBillLineItem';
  amount?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  eBill?: Maybe<EBill>;
  eBillId: Scalars['Int'];
  externalItemId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['String']>;
  type?: Maybe<EBillLineItemtypeEnumType>;
  unitPrice?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type EBillLineItemCount = {
  __typename?: 'eBillLineItemCount';
  count?: Maybe<Scalars['Int']>;
};

export enum EBillLineItemtypeEnumType {
  category = 'category',
  item = 'item'
}

export type EBillSubscription = {
  __typename?: 'eBillSubscription';
  allowPaperSuppression?: Maybe<Scalars['Boolean']>;
  autoPayStatus?: Maybe<EBillSubscriptionautoPayStatusEnumType>;
  createOrigin?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  eBillStatus: EBillSubscriptioneBillStatusEnumType;
  eBillTrialEndDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  optedInAt?: Maybe<Scalars['DateTime']>;
  optedOutAt?: Maybe<Scalars['DateTime']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  vendor?: Maybe<Vendor>;
  vendorId: Scalars['Int'];
};

export type EBillSubscriptionCount = {
  __typename?: 'eBillSubscriptionCount';
  count?: Maybe<Scalars['Int']>;
};

export enum EBillSubscriptionautoPayStatusEnumType {
  active = 'active',
  capable = 'capable',
  not_capable = 'not_capable'
}

export enum EBillSubscriptioneBillStatusEnumType {
  active = 'active',
  capable = 'capable',
  not_capable = 'not_capable',
  pending = 'pending',
  rejected = 'rejected'
}

export type EmailTemplate = {
  __typename?: 'emailTemplate';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  notificationGroups?: Maybe<Array<Maybe<NotificationGroup>>>;
  templateId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type EmailTemplateCount = {
  __typename?: 'emailTemplateCount';
  count?: Maybe<Scalars['Int']>;
};

export type EntityCachedData = BusyEntityCachedData | BusyUnmatchTaskEntityCachedData | LuciEntityCachedData | SherlockDecisionTaggingEntityCachedData | SherlockEscalationEntityCachedData | SherlockOrganizationEntityCachedData;

export type EntityMapping = {
  __typename?: 'entityMapping';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  entityId: Scalars['Int'];
  entityType: EntityMappingentityTypeEnumType;
  externalId: Scalars['String'];
  id: Scalars['Int'];
  metadata?: Maybe<Scalars['SequelizeJSON']>;
  organizationId?: Maybe<Scalars['Int']>;
  partnerName: Scalars['String'];
  providerName: EntityMappingproviderNameEnumType;
  updatedAt: Scalars['DateTime'];
};

export type EntityMappingCount = {
  __typename?: 'entityMappingCount';
  count?: Maybe<Scalars['Int']>;
};

export enum EntityMappingentityTypeEnumType {
  automaticPayment = 'automaticPayment',
  bankAccountDeliveryMethod = 'bankAccountDeliveryMethod',
  bill = 'bill',
  billFile = 'billFile',
  billPayment = 'billPayment',
  billSubscription = 'billSubscription',
  checkDeliveryMethod = 'checkDeliveryMethod',
  customer = 'customer',
  fundingSource = 'fundingSource',
  group = 'group',
  managedCheckDeliveryMethod = 'managedCheckDeliveryMethod',
  managedDeliveryMethod = 'managedDeliveryMethod',
  organization = 'organization',
  partner = 'partner',
  payment = 'payment',
  paymentRequest = 'paymentRequest',
  todo = 'todo',
  user = 'user',
  vendor = 'vendor'
}

export enum EntityMappingproviderNameEnumType {
  capital_one_sbb = 'capital_one_sbb',
  fiserv_checkfree = 'fiserv_checkfree',
  fiserv_smb = 'fiserv_smb',
  shopify_stocky = 'shopify_stocky',
  standard = 'standard'
}

export enum EscalationUserTypeEnum {
  Group = 'Group',
  Single = 'Single'
}

export enum ExpeditedByEnum {
  payee = 'payee',
  payor = 'payor'
}

export type ExtendedOrgLinking = {
  __typename?: 'extendedOrgLinking';
  companyName?: Maybe<Scalars['String']>;
  isApiPartner?: Maybe<Scalars['Boolean']>;
  nonStrictMatchedData?: Maybe<Scalars['String']>;
  ode?: Maybe<OrganizationDecisionFull>;
  organizationId?: Maybe<Scalars['String']>;
  partner?: Maybe<OrganizationPartner>;
  strictMatchedData?: Maybe<Scalars['String']>;
};

export type ExternalPaymentLogicalIdMapping = {
  __typename?: 'externalPaymentLogicalIdMapping';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  externalLogicalId: Scalars['String'];
  id: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  paymentId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type ExternalPaymentLogicalIdMappingCount = {
  __typename?: 'externalPaymentLogicalIdMappingCount';
  count?: Maybe<Scalars['Int']>;
};

export type FailedEmails = {
  __typename?: 'failedEmails';
  codeType?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  entityId: Scalars['Int'];
  entityType: FailedEmailsentityTypeEnumType;
  fromEmail: Scalars['String'];
  id: Scalars['Int'];
  metadata?: Maybe<Scalars['SequelizeJSON']>;
  tag?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  toEmail: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type FailedEmailsCount = {
  __typename?: 'failedEmailsCount';
  count?: Maybe<Scalars['Int']>;
};

export enum FailedEmailsentityTypeEnumType {
  paymentRequest = 'paymentRequest'
}

export type FailedPaymentsRetries = {
  __typename?: 'failedPaymentsRetries';
  createOrigin: FailedPaymentsRetriescreateOriginEnumType;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  isRetriedByVendor?: Maybe<Scalars['Boolean']>;
  originDeliveryMethodId?: Maybe<Scalars['Int']>;
  originFundingSourceId?: Maybe<Scalars['Int']>;
  originPaymentId?: Maybe<Scalars['Int']>;
  originScheduledDate: Scalars['DateTime'];
  partnerName?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  paymentId: Scalars['Int'];
  reason: FailedPaymentsRetriesreasonEnumType;
  selectedDeliveryMethodId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type FailedPaymentsRetriesCount = {
  __typename?: 'failedPaymentsRetriesCount';
  count?: Maybe<Scalars['Int']>;
};

export enum FailedPaymentsRetriescreateOriginEnumType {
  accountsPayablePlatform = 'accountsPayablePlatform',
  arInvoice = 'arInvoice',
  arLink = 'arLink',
  builtPartnership = 'builtPartnership',
  merchantCheckout = 'merchantCheckout',
  nativeAndroid = 'nativeAndroid',
  nativeIos = 'nativeIos',
  nativeSdkAndroid = 'nativeSdkAndroid',
  nativeSdkIos = 'nativeSdkIos',
  pay = 'pay',
  qbdtIntegration = 'qbdtIntegration',
  qbdtMac = 'qbdtMac',
  qbdtWindows = 'qbdtWindows',
  qbmAndroid = 'qbmAndroid',
  qbmIntegration = 'qbmIntegration',
  qbmIos = 'qbmIos',
  qboIntegration = 'qboIntegration',
  qbrAndroid = 'qbrAndroid',
  qbrIntegration = 'qbrIntegration',
  qbrIos = 'qbrIos',
  request = 'request'
}

export enum FailedPaymentsRetriesreasonEnumType {
  failed_to_collect_no_delivery_yet = 'failed_to_collect_no_delivery_yet',
  failed_to_collect_success_to_deliver = 'failed_to_collect_success_to_deliver',
  failed_to_deliver = 'failed_to_deliver',
  undeposited_check = 'undeposited_check',
  unilateral = 'unilateral'
}

export type FastAchConfiguration = {
  __typename?: 'fastAchConfiguration';
  createdAt: Scalars['DateTime'];
  eligibilityType: FastAchConfigurationeligibilityTypeEnumType;
  fee: Scalars['String'];
  fundingSource?: Maybe<FundingSource>;
  fundingSourceId: Scalars['Int'];
  id: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  showPercent: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type FastAchConfigurationCount = {
  __typename?: 'fastAchConfigurationCount';
  count?: Maybe<Scalars['Int']>;
};

export enum FastAchConfigurationeligibilityTypeEnumType {
  Jun21 = 'Jun21',
  Plaid = 'Plaid',
  _202104 = '_202104'
}

export type FeeCatalog = {
  __typename?: 'feeCatalog';
  activeFrom?: Maybe<Scalars['DateTime']>;
  cap?: Maybe<Scalars['String']>;
  catalogId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  feeType: FeeCatalogfeeTypeEnumType;
  id: Scalars['Int'];
  min?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  prevFeeCatalog?: Maybe<FeeCatalog>;
  prevFeeCatalogId?: Maybe<Scalars['Int']>;
  promotedFee?: Maybe<FeeCatalog>;
  promotedFeeId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  value: Scalars['String'];
  valueType: FeeCatalogvalueTypeEnumType;
};

export type FeeCatalogCount = {
  __typename?: 'feeCatalogCount';
  count?: Maybe<Scalars['Int']>;
};

export enum FeeCatalogfeeTypeEnumType {
  ach = 'ach',
  achToAch = 'achToAch',
  achToAchVendor = 'achToAchVendor',
  achToCheck = 'achToCheck',
  achToFastInternationalGusd = 'achToFastInternationalGusd',
  arCredit = 'arCredit',
  arDebit = 'arDebit',
  arErpProcessingFee = 'arErpProcessingFee',
  arProcessingFee = 'arProcessingFee',
  cardToAch = 'cardToAch',
  cardToFastInternationalGusd = 'cardToFastInternationalGusd',
  check = 'check',
  credit = 'credit',
  cryptoUsd = 'cryptoUsd',
  debit = 'debit',
  dmAch = 'dmAch',
  dmCheck = 'dmCheck',
  domesticWire = 'domesticWire',
  excessStandard = 'excessStandard',
  expeditedAch = 'expeditedAch',
  expeditedAchVendor = 'expeditedAchVendor',
  expressCheck = 'expressCheck',
  expressDomesticWire = 'expressDomesticWire',
  fastInternationalFx = 'fastInternationalFx',
  international = 'international',
  internationalFx = 'internationalFx',
  internationalWire = 'internationalWire',
  overnightCheck = 'overnightCheck',
  paypalBalanceToAch = 'paypalBalanceToAch',
  pushToDebit = 'pushToDebit',
  refund = 'refund',
  rtp = 'rtp',
  rtpOrganization = 'rtpOrganization',
  unilateral = 'unilateral',
  unilateralInternationalFx = 'unilateralInternationalFx',
  unilateralInternationalGusd = 'unilateralInternationalGusd'
}

export enum FeeCatalogvalueTypeEnumType {
  fixed = 'fixed',
  percent = 'percent'
}

export type FeedbackSubmission = {
  __typename?: 'feedbackSubmission';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  metaData: Scalars['SequelizeJSON'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

export type FeedbackSubmissionCount = {
  __typename?: 'feedbackSubmissionCount';
  count?: Maybe<Scalars['Int']>;
};

export type File = {
  __typename?: 'file';
  agreements?: Maybe<Array<Maybe<Agreement>>>;
  attachedToInvoices?: Maybe<Array<Maybe<Invoice>>>;
  billSubscriptions?: Maybe<Array<Maybe<BillSubscription>>>;
  bills?: Maybe<Array<Maybe<Bill>>>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  fileName?: Maybe<Scalars['String']>;
  hash?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  invoice?: Maybe<Invoice>;
  mimeType?: Maybe<Scalars['String']>;
  ocrJson?: Maybe<OcrJson>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  paymentRequests?: Maybe<Array<Maybe<PaymentRequest>>>;
  previewRef?: Maybe<Scalars['String']>;
  receivablePaymentDetails?: Maybe<Array<Maybe<ReceivablePaymentDetails>>>;
  size?: Maybe<Scalars['Int']>;
  storageRef?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  users?: Maybe<Array<Maybe<User>>>;
};

export type FileBill = {
  __typename?: 'fileBill';
  billId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  fileId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type FileBillCount = {
  __typename?: 'fileBillCount';
  count?: Maybe<Scalars['Int']>;
};

export type FileCount = {
  __typename?: 'fileCount';
  count?: Maybe<Scalars['Int']>;
};

export type FileEBill = {
  __typename?: 'fileEBill';
  createdAt: Scalars['DateTime'];
  eBillId: Scalars['Int'];
  fileId: Scalars['Int'];
  id: Scalars['Int'];
  partnerName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type FileEBillCount = {
  __typename?: 'fileEBillCount';
  count?: Maybe<Scalars['Int']>;
};

export type FilePaymentRequest = {
  __typename?: 'filePaymentRequest';
  createdAt: Scalars['DateTime'];
  fileId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  paymentRequestId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type FilePaymentRequestCount = {
  __typename?: 'filePaymentRequestCount';
  count?: Maybe<Scalars['Int']>;
};

export type FileUser = {
  __typename?: 'fileUser';
  createdAt: Scalars['DateTime'];
  fileId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['Int'];
};

export type FileUserCount = {
  __typename?: 'fileUserCount';
  count?: Maybe<Scalars['Int']>;
};

export enum FinancialInstitution {
  evolve = 'evolve',
  jpm = 'jpm',
  svb = 'svb'
}

export type FinancingAccount = {
  __typename?: 'financingAccount';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  eligibilityToken: Scalars['String'];
  financingToken: Scalars['String'];
  id: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  paymentId: Scalars['Int'];
  provider: FinancingAccountproviderEnumType;
  updatedAt: Scalars['DateTime'];
};

export type FinancingAccountCount = {
  __typename?: 'financingAccountCount';
  count?: Maybe<Scalars['Int']>;
};

export enum FinancingAccountproviderEnumType {
  creditKey = 'creditKey'
}

export type FinancingApplicationBusinessDetails = {
  __typename?: 'financingApplicationBusinessDetails';
  annualRevenue: Scalars['Int'];
  businessType: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  submittedByUbo?: Maybe<OrganizationUltimateBeneficialOwner>;
  submittedByUboId?: Maybe<Scalars['Int']>;
  taxId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type FinancingApplicationBusinessDetailsCount = {
  __typename?: 'financingApplicationBusinessDetailsCount';
  count?: Maybe<Scalars['Int']>;
};

export type FirmClient = {
  __typename?: 'firmClient';
  client?: Maybe<Organization>;
  clientOrganizationId: Scalars['Int'];
  clientUserOrganizations?: Maybe<Array<Maybe<UserOrganization>>>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  firm?: Maybe<Organization>;
  firmOrganizationId: Scalars['Int'];
  firmUserOrganizations?: Maybe<Array<Maybe<UserOrganization>>>;
  id: Scalars['Int'];
  isHidden: Scalars['Boolean'];
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type FirmClientCount = {
  __typename?: 'firmClientCount';
  count?: Maybe<Scalars['Int']>;
};

export type FiservCredential = {
  __typename?: 'fiservCredential';
  accessToken: Scalars['String'];
  accessTokenExpiration?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  partnerName: Scalars['String'];
  refreshToken?: Maybe<Scalars['String']>;
  refreshTokenExpiration?: Maybe<Scalars['DateTime']>;
  scopes?: Maybe<Scalars['String']>;
  sponsorId: Scalars['String'];
  subscriberId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type FiservCredentialCount = {
  __typename?: 'fiservCredentialCount';
  count?: Maybe<Scalars['Int']>;
};

export type FlexAccount = {
  __typename?: 'flexAccount';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  externalProviderId: Scalars['String'];
  fundingSource?: Maybe<FundingSource>;
  id: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type FlexAccountCount = {
  __typename?: 'flexAccountCount';
  count?: Maybe<Scalars['Int']>;
};

export type FundingSource = {
  __typename?: 'fundingSource';
  accountNumberLast4Digits?: Maybe<Scalars['String']>;
  accountingPlatformEntity?: Maybe<AccountingPlatformEntity>;
  availableBalance?: Maybe<Scalars['String']>;
  availableBalanceUpdatedAt?: Maybe<Scalars['DateTime']>;
  bankAccount?: Maybe<BankAccount>;
  bankAccountId?: Maybe<Scalars['Int']>;
  bankAccountRoutingNumber?: Maybe<Scalars['String']>;
  billSubscriptions?: Maybe<Array<Maybe<BillSubscription>>>;
  billingSettings?: Maybe<Array<Maybe<BillingSettings>>>;
  cardAccount?: Maybe<CardAccount>;
  cardAccountId?: Maybe<Scalars['Int']>;
  cardLast4Digits?: Maybe<Scalars['String']>;
  consentedGuestFundingSource?: Maybe<ConsentedGuestFundingSource>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['Int']>;
  createdByPartner?: Maybe<Partner>;
  createdByPartnerId?: Maybe<Scalars['Int']>;
  deferredDelivery?: Maybe<Scalars['SequelizeJSON']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  displayName: Scalars['String'];
  fastAchConfigurations?: Maybe<Array<Maybe<FastAchConfiguration>>>;
  features?: Maybe<FundingSourceFeatures>;
  feeOnly: Scalars['Boolean'];
  flexAccount?: Maybe<FlexAccount>;
  flexAccountId?: Maybe<Scalars['Int']>;
  fundingSourceAccount?: Maybe<AccountsServiceAccountInfo>;
  fundingType: FundingSourcefundingTypeEnumType;
  id: Scalars['Int'];
  intuitAccountId?: Maybe<Scalars['String']>;
  isTest?: Maybe<Scalars['Boolean']>;
  isVerified: Scalars['Boolean'];
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  logo?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  origin: FundingSourceoriginEnumType;
  partnerAccount?: Maybe<PartnerAccount>;
  partnerIntegrationId?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  partnerPaymentAccount?: Maybe<PartnerPaymentAccount>;
  partnerPaymentAccountId?: Maybe<Scalars['Int']>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  paymentsAccountId?: Maybe<Scalars['String']>;
  paypalBalanceAccount?: Maybe<PaypalBalanceAccount>;
  paypalBalanceAccountId?: Maybe<Scalars['Int']>;
  plaidAccount?: Maybe<PlaidAccount>;
  plaidAccountId?: Maybe<Scalars['Int']>;
  syncActivityMigrationStatus?: Maybe<RailsDateTypeEnum>;
  tags?: Maybe<Array<Maybe<EntityTag>>>;
  updatedAt: Scalars['DateTime'];
  verifiedAt?: Maybe<Scalars['DateTime']>;
  verifiedDate?: Maybe<Scalars['DateTime']>;
};


export type FundingSourceVerifiedDateArgs = {
  organizationId?: InputMaybe<Scalars['Int']>;
};

export type FundingSourceCount = {
  __typename?: 'fundingSourceCount';
  count?: Maybe<Scalars['Int']>;
};

export type FundingSourceFeatures = {
  __typename?: 'fundingSourceFeatures';
  is_fs_manually_approved?: Maybe<Scalars['Boolean']>;
};

export enum FundingSourcefundingTypeEnumType {
  ach = 'ach',
  card = 'card',
  flex = 'flex',
  paypalBalance = 'paypalBalance'
}

export enum FundingSourceoriginEnumType {
  carat = 'carat',
  card = 'card',
  manual = 'manual',
  micro = 'micro',
  partner = 'partner',
  plaid = 'plaid',
  qbcash = 'qbcash',
  tabaPay = 'tabaPay'
}

export type Globals = {
  __typename?: 'globals';
  counterType?: Maybe<GlobalscounterTypeEnumType>;
  createdAt: Scalars['DateTime'];
  key: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  value: Scalars['String'];
};

export type GlobalsCount = {
  __typename?: 'globalsCount';
  count?: Maybe<Scalars['Int']>;
};

export enum GlobalscounterTypeEnumType {
  daily = 'daily'
}

export type GrossProfit = {
  __typename?: 'grossProfit';
  last30Days?: Maybe<Scalars['Float']>;
  lossesRatio?: Maybe<Scalars['Float']>;
  sumTotal?: Maybe<Scalars['Float']>;
};

export type GuestPayorOrganizationMetadata = {
  __typename?: 'guestPayorOrganizationMetadata';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName: Scalars['String'];
  payorType?: Maybe<GuestPayorOrganizationMetadatapayorTypeEnumType>;
  updatedAt: Scalars['DateTime'];
};

export type GuestPayorOrganizationMetadataCount = {
  __typename?: 'guestPayorOrganizationMetadataCount';
  count?: Maybe<Scalars['Int']>;
};

export enum GuestPayorOrganizationMetadatapayorTypeEnumType {
  business = 'business',
  consumer = 'consumer'
}

export type IdentityProvider = {
  __typename?: 'identityProvider';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  partner?: Maybe<Partner>;
  partnerId?: Maybe<Scalars['Int']>;
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type IdentityProviderAccountCredential = {
  __typename?: 'identityProviderAccountCredential';
  accessToken: Scalars['String'];
  accessTokenExpiration?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  identityProviderAccountId: Scalars['Int'];
  identityProviderAccounts?: Maybe<IdentityProvidersAccounts>;
  partnerName?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  refreshTokenExpiration?: Maybe<Scalars['DateTime']>;
  scopes: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type IdentityProviderAccountCredentialCount = {
  __typename?: 'identityProviderAccountCredentialCount';
  count?: Maybe<Scalars['Int']>;
};

export type IdentityProviderAccountLog = {
  __typename?: 'identityProviderAccountLog';
  category: Scalars['String'];
  createdAt: Scalars['DateTime'];
  currentData?: Maybe<Scalars['SequelizeJSON']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  formattedData: Scalars['SequelizeJSON'];
  id: Scalars['Int'];
  organizationId?: Maybe<Scalars['Int']>;
  partnerName?: Maybe<Scalars['String']>;
  rawData: Scalars['SequelizeJSON'];
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['Int']>;
};

export type IdentityProviderAccountLogCount = {
  __typename?: 'identityProviderAccountLogCount';
  count?: Maybe<Scalars['Int']>;
};

export type IdentityProviderCount = {
  __typename?: 'identityProviderCount';
  count?: Maybe<Scalars['Int']>;
};

export type IdentityProvidersAccounts = {
  __typename?: 'identityProvidersAccounts';
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  externalOrganizationId?: Maybe<Scalars['String']>;
  externalUserId: Scalars['String'];
  id: Scalars['Int'];
  identityProviderId?: Maybe<Scalars['Int']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

export type IdentityProvidersAccountsCount = {
  __typename?: 'identityProvidersAccountsCount';
  count?: Maybe<Scalars['Int']>;
};

export type InboxEmail = {
  __typename?: 'inboxEmail';
  carbonCopy?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  origin: InboxEmailoriginEnumType;
  partnerName?: Maybe<Scalars['String']>;
  processingResults?: Maybe<Scalars['SequelizeJSON']>;
  recipient: Scalars['String'];
  s3FileName: Scalars['String'];
  scannedInvoices?: Maybe<Array<Maybe<ScannedInvoice>>>;
  sender: Scalars['String'];
  sentAt?: Maybe<Scalars['DateTime']>;
  subject?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type InboxEmailAddress = {
  __typename?: 'inboxEmailAddress';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  id: Scalars['Int'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type InboxEmailAddressCount = {
  __typename?: 'inboxEmailAddressCount';
  count?: Maybe<Scalars['Int']>;
};

export type InboxEmailCount = {
  __typename?: 'inboxEmailCount';
  count?: Maybe<Scalars['Int']>;
};

export enum InboxEmailoriginEnumType {
  bills_inbox = 'bills_inbox',
  gmail_sync = 'gmail_sync',
  outlook_sync = 'outlook_sync'
}

export type IncidentBatchGroupsBaseDataType = {
  __typename?: 'incidentBatchGroupsBaseDataType';
  flowName?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
};

export type IncidentExecutionGroupsType = {
  __typename?: 'incidentExecutionGroupsType';
  failed: Scalars['Int'];
  groupId: Scalars['String'];
  rejected: Scalars['Int'];
  succeeded: Scalars['Int'];
  total: Scalars['Int'];
  waiting: Scalars['Int'];
};

export enum IncidentManagementBatchModeDataType {
  live = 'live',
  retry = 'retry',
  shadow = 'shadow'
}

export type IncidentManagementCalculateDataType = {
  __typename?: 'incidentManagementCalculateDataType';
  isCalculating?: Maybe<Scalars['Boolean']>;
  isSuccessful?: Maybe<Scalars['Boolean']>;
  origin?: Maybe<Scalars['String']>;
};

export type IncidentManagementCalculateProgressDataType = {
  __typename?: 'incidentManagementCalculateProgressDataType';
  percentage?: Maybe<Scalars['String']>;
};

export type IncidentManagementSingleDataType = {
  __typename?: 'incidentManagementSingleDataType';
  isSuccessful?: Maybe<Scalars['Boolean']>;
};

export type Industry = {
  __typename?: 'industry';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  organizations?: Maybe<Array<Maybe<Organization>>>;
  subIndustries?: Maybe<Array<Maybe<SubIndustry>>>;
  updatedAt: Scalars['DateTime'];
};

export type IndustryCount = {
  __typename?: 'industryCount';
  count?: Maybe<Scalars['Int']>;
};

export type InternationalAccount = {
  __typename?: 'internationalAccount';
  createdAt: Scalars['DateTime'];
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  id: Scalars['Int'];
  last4Digits?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  payeeAddress?: Maybe<Scalars['String']>;
  payeeBankAccountHolderName: Scalars['String'];
  payeeBankAccountNumber?: Maybe<Scalars['String']>;
  payeeBankBicSwift?: Maybe<Scalars['String']>;
  payeeBankCountry: Scalars['String'];
  payeeBankIban?: Maybe<Scalars['String']>;
  payeeBankName?: Maybe<Scalars['String']>;
  payeeBankRoutingCode1?: Maybe<Scalars['String']>;
  payeeBankRoutingCode2?: Maybe<Scalars['String']>;
  payeeBankRoutingCodeType1?: Maybe<InternationalAccountpayeeBankRoutingCodeType1EnumType>;
  payeeBankRoutingCodeType2?: Maybe<InternationalAccountpayeeBankRoutingCodeType2EnumType>;
  payeeCity?: Maybe<Scalars['String']>;
  payeeCompanyName?: Maybe<Scalars['String']>;
  payeeCountry?: Maybe<Scalars['String']>;
  payeeExternalId: Scalars['String'];
  payeeName: Scalars['String'];
  payeePostcode?: Maybe<Scalars['String']>;
  payeeState?: Maybe<Scalars['String']>;
  payorAccountId?: Maybe<Scalars['String']>;
  payorExternalId: Scalars['String'];
  provider: InternationalAccountproviderEnumType;
  riskEngineDecisionMetadata?: Maybe<RiskEngineDecisionMetadata>;
  updatedAt: Scalars['DateTime'];
};

export type InternationalAccountCount = {
  __typename?: 'internationalAccountCount';
  count?: Maybe<Scalars['Int']>;
};

export enum InternationalAccountpayeeBankRoutingCodeType1EnumType {
  aba = 'aba',
  bankCode = 'bankCode',
  branchCode = 'branchCode',
  bsbCode = 'bsbCode',
  clabe = 'clabe',
  cnaps = 'cnaps',
  ifsc = 'ifsc',
  institutionNo = 'institutionNo',
  sortCode = 'sortCode'
}

export enum InternationalAccountpayeeBankRoutingCodeType2EnumType {
  aba = 'aba',
  bankCode = 'bankCode',
  branchCode = 'branchCode',
  bsbCode = 'bsbCode',
  clabe = 'clabe',
  cnaps = 'cnaps',
  institutionNo = 'institutionNo',
  sortCode = 'sortCode'
}

export enum InternationalAccountproviderEnumType {
  currencyCloud = 'currencyCloud',
  paypal = 'paypal',
  wise = 'wise'
}

export type Invitation = {
  __typename?: 'invitation';
  accessLevel: InvitationaccessLevelEnumType;
  approvalAmountThreshold?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  expired?: Maybe<Scalars['DateTime']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  invitedByUser?: Maybe<User>;
  invitedByUserId: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  requireApproval?: Maybe<Scalars['Boolean']>;
  role: InvitationroleEnumType;
  roleUniqueName?: Maybe<InvitationroleUniqueNameEnumType>;
  status: InvitationstatusEnumType;
  updatedAt: Scalars['DateTime'];
};

export type InvitationCount = {
  __typename?: 'invitationCount';
  count?: Maybe<Scalars['Int']>;
};

export enum InvitationaccessLevelEnumType {
  full = 'full',
  none = 'none'
}

export enum InvitationroleEnumType {
  accountant = 'accountant',
  admin = 'admin',
  approver = 'approver',
  clerk = 'clerk',
  contributor = 'contributor',
  owner = 'owner',
  viewer = 'viewer'
}

export enum InvitationroleUniqueNameEnumType {
  capitalOneAm = 'capitalOneAm',
  capitalOnePrimary = 'capitalOnePrimary',
  cloverAdmin = 'cloverAdmin',
  cloverOwner = 'cloverOwner',
  deploymentsDemoOwner = 'deploymentsDemoOwner',
  fiservLevel1 = 'fiservLevel1',
  fiservLevel2 = 'fiservLevel2',
  fiservLevel3 = 'fiservLevel3',
  melioAccountant = 'melioAccountant',
  melioAdmin = 'melioAdmin',
  melioApprover = 'melioApprover',
  melioClerk = 'melioClerk',
  melioContributor = 'melioContributor',
  melioOwner = 'melioOwner',
  melioViewer = 'melioViewer',
  shopifyNonOwner = 'shopifyNonOwner',
  shopifyOwner = 'shopifyOwner'
}

export enum InvitationstatusEnumType {
  approved = 'approved',
  canceled = 'canceled',
  pending = 'pending'
}

export type Invoice = {
  __typename?: 'invoice';
  blockedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  currency: Scalars['String'];
  customer?: Maybe<Contact>;
  customerId: Scalars['Int'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  discount?: Maybe<Discount>;
  discountId?: Maybe<Scalars['Int']>;
  dueDate: Scalars['DateTime'];
  file?: Maybe<File>;
  fileId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  invoiceAttachments?: Maybe<Array<Maybe<InvoiceAttachment>>>;
  invoiceDiscount?: Maybe<InvoiceDiscount>;
  invoiceLineItems?: Maybe<Array<Maybe<InvoiceLineItem>>>;
  invoiceNumber: Scalars['String'];
  invoicePaymentMetadata?: Maybe<InvoicePaymentMetadata>;
  invoiceServiceCharges?: Maybe<Array<Maybe<InvoiceServiceCharge>>>;
  invoiceTaxRate?: Maybe<InvoiceTaxRate>;
  invoiceType?: Maybe<InvoiceinvoiceTypeEnumType>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  openBalance: Scalars['Int'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerIntegrationId?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  paymentRequests?: Maybe<Array<Maybe<PaymentRequest>>>;
  source: InvoicesourceEnumType;
  status: InvoicestatusEnumType;
  taxRate?: Maybe<TaxRate>;
  taxRateId?: Maybe<Scalars['Int']>;
  totalAmount: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type InvoiceAttachment = {
  __typename?: 'invoiceAttachment';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  file?: Maybe<File>;
  fileId: Scalars['Int'];
  id: Scalars['Int'];
  invoice?: Maybe<Invoice>;
  invoiceId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type InvoiceAttachmentCount = {
  __typename?: 'invoiceAttachmentCount';
  count?: Maybe<Scalars['Int']>;
};

export type InvoiceCount = {
  __typename?: 'invoiceCount';
  count?: Maybe<Scalars['Int']>;
};

export type InvoiceCustomer = {
  __typename?: 'invoiceCustomer';
  companyName: Scalars['String'];
  contact?: Maybe<Contact>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  invoice?: Maybe<Invoice>;
  invoiceId: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  parentContactId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type InvoiceCustomerCount = {
  __typename?: 'invoiceCustomerCount';
  count?: Maybe<Scalars['Int']>;
};

export type InvoiceDiscount = {
  __typename?: 'invoiceDiscount';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  discount?: Maybe<Discount>;
  id: Scalars['Int'];
  invoice?: Maybe<Invoice>;
  invoiceId: Scalars['Int'];
  name: Scalars['String'];
  parentDiscountId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  type: InvoiceDiscounttypeEnumType;
  updatedAt: Scalars['DateTime'];
  value: Scalars['Float'];
};

export type InvoiceDiscountCount = {
  __typename?: 'invoiceDiscountCount';
  count?: Maybe<Scalars['Int']>;
};

export enum InvoiceDiscounttypeEnumType {
  amount = 'amount',
  percentage = 'percentage'
}

export type InvoiceLineItem = {
  __typename?: 'invoiceLineItem';
  catalogItem?: Maybe<CatalogItem>;
  catalogItemId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  invoice?: Maybe<Invoice>;
  invoiceId: Scalars['Int'];
  name: Scalars['String'];
  partnerName?: Maybe<Scalars['String']>;
  price: Scalars['String'];
  quantity: Scalars['String'];
  tax?: Maybe<Scalars['String']>;
  taxable: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type InvoiceLineItemCount = {
  __typename?: 'invoiceLineItemCount';
  count?: Maybe<Scalars['Int']>;
};

export type InvoiceLineSyncMetadata = {
  __typename?: 'invoiceLineSyncMetadata';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  externalInvoiceId?: Maybe<Scalars['String']>;
  externalInvoiceLineId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  invoice?: Maybe<Invoice>;
  invoiceLineItem?: Maybe<InvoiceLineItem>;
  localInvoiceId: Scalars['Int'];
  localInvoiceLineId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type InvoiceLineSyncMetadataCount = {
  __typename?: 'invoiceLineSyncMetadataCount';
  count?: Maybe<Scalars['Int']>;
};

export type InvoicePaymentMetadata = {
  __typename?: 'invoicePaymentMetadata';
  autoDebitContract?: Maybe<AutoDebitContract>;
  autoDebitContractId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  customPayInstructions?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  invoice?: Maybe<Invoice>;
  invoiceId?: Maybe<Scalars['Int']>;
  isAchAllowed: Scalars['Boolean'];
  isAutoRemindersEnabled: Scalars['Boolean'];
  isCardAllowed: Scalars['Boolean'];
  isCardFeesAbsorbedByPayor?: Maybe<Scalars['Boolean']>;
  isTest: Scalars['Boolean'];
  partnerName?: Maybe<Scalars['String']>;
  paymentRequest?: Maybe<PaymentRequest>;
  paymentRequestId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type InvoicePaymentMetadataCount = {
  __typename?: 'invoicePaymentMetadataCount';
  count?: Maybe<Scalars['Int']>;
};

export type InvoicePreferences = {
  __typename?: 'invoicePreferences';
  allowACHPayment: Scalars['Boolean'];
  allowCardPayment: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  customPayInstructions?: Maybe<Scalars['String']>;
  defaultReceivingMethod?: Maybe<InvoicePreferencesdefaultReceivingMethodEnumType>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  invoiceNumber: Scalars['String'];
  noteOnInvoice?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName: Scalars['String'];
  prefix?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type InvoicePreferencesCount = {
  __typename?: 'invoicePreferencesCount';
  count?: Maybe<Scalars['Int']>;
};

export enum InvoicePreferencesdefaultReceivingMethodEnumType {
  ach = 'ach',
  card = 'card'
}

export type InvoiceServiceCharge = {
  __typename?: 'invoiceServiceCharge';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  invoice?: Maybe<Invoice>;
  invoiceId: Scalars['Int'];
  name: Scalars['String'];
  partnerName?: Maybe<Scalars['String']>;
  serviceChargeCatalog?: Maybe<ServiceChargeCatalog>;
  serviceChargeCatalogId: Scalars['Int'];
  type: InvoiceServiceChargetypeEnumType;
  updatedAt: Scalars['DateTime'];
  value: Scalars['String'];
};

export type InvoiceServiceChargeCount = {
  __typename?: 'invoiceServiceChargeCount';
  count?: Maybe<Scalars['Int']>;
};

export enum InvoiceServiceChargetypeEnumType {
  amount = 'amount',
  percentage = 'percentage'
}

export type InvoiceSyncActivity = {
  __typename?: 'invoiceSyncActivity';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  direction: InvoiceSyncActivitydirectionEnumType;
  errorMessage?: Maybe<Scalars['String']>;
  externalIntegrationType?: Maybe<InvoiceSyncActivityexternalIntegrationTypeEnumType>;
  id: Scalars['Int'];
  invoiceId: Scalars['Int'];
  lastSyncedAt: Scalars['DateTime'];
  partnerName?: Maybe<Scalars['String']>;
  paymentRequest?: Maybe<PaymentRequest>;
  status: InvoiceSyncActivitystatusEnumType;
  updatedAt: Scalars['DateTime'];
};

export type InvoiceSyncActivityCount = {
  __typename?: 'invoiceSyncActivityCount';
  count?: Maybe<Scalars['Int']>;
};

export enum InvoiceSyncActivitydirectionEnumType {
  melio = 'melio',
  qbo = 'qbo'
}

export enum InvoiceSyncActivityexternalIntegrationTypeEnumType {
  qbd = 'qbd',
  qboGetPaid = 'qboGetPaid',
  xerox = 'xerox'
}

export enum InvoiceSyncActivitystatusEnumType {
  error = 'error',
  noChange = 'noChange',
  success = 'success'
}

export type InvoiceSyncMetadata = {
  __typename?: 'invoiceSyncMetadata';
  createRequestId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  externalId?: Maybe<Scalars['String']>;
  externalIntegrationType?: Maybe<InvoiceSyncMetadataexternalIntegrationTypeEnumType>;
  externalLastUpdate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  invoiceId?: Maybe<Scalars['Int']>;
  localLastUpdate?: Maybe<Scalars['DateTime']>;
  partnerName?: Maybe<Scalars['String']>;
  syncMetadata?: Maybe<PaymentRequest>;
  txnSource?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type InvoiceSyncMetadataCount = {
  __typename?: 'invoiceSyncMetadataCount';
  count?: Maybe<Scalars['Int']>;
};

export enum InvoiceSyncMetadataexternalIntegrationTypeEnumType {
  qbd = 'qbd',
  qboGetPaid = 'qboGetPaid',
  xerox = 'xerox'
}

export type InvoiceTaxRate = {
  __typename?: 'invoiceTaxRate';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  invoice?: Maybe<Invoice>;
  invoiceId: Scalars['Int'];
  name: Scalars['String'];
  parentTaxRate?: Maybe<TaxRate>;
  parentTaxRateId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  rate: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
};

export type InvoiceTaxRateCount = {
  __typename?: 'invoiceTaxRateCount';
  count?: Maybe<Scalars['Int']>;
};

export enum InvoiceinvoiceTypeEnumType {
  base = 'base',
  light = 'light',
  regular = 'regular'
}

export enum InvoicesourceEnumType {
  file = 'file',
  manual = 'manual',
  qbdt = 'qbdt',
  qbo = 'qbo',
  xero = 'xero'
}

export enum InvoicestatusEnumType {
  canceled = 'canceled',
  created = 'created',
  draft = 'draft',
  fulfilled = 'fulfilled',
  issued = 'issued',
  pending = 'pending'
}

export type IpFeatures = {
  __typename?: 'ipFeatures';
  first_pmt_date_of_organization_and_ip?: Maybe<Scalars['DateTime']>;
  is_ip_manually_approved?: Maybe<Scalars['Boolean']>;
  is_ip_used_for_registration?: Maybe<Scalars['Boolean']>;
  maxmindClientIpCity?: Maybe<Scalars['String']>;
  maxmindClientIpCountry?: Maybe<Scalars['String']>;
  maxmindClientIpDistanceToBilling?: Maybe<Scalars['String']>;
  maxmindClientIpProxy?: Maybe<Scalars['Boolean']>;
  maxmindClientIpRegion?: Maybe<Scalars['String']>;
  maxmindClientIpScore?: Maybe<Scalars['Float']>;
  num_pmt_for_ip?: Maybe<Scalars['Int']>;
  payorEaClientIpCity?: Maybe<Scalars['String']>;
  payorEaClientIpEmailRiskScore?: Maybe<Scalars['Float']>;
  payorEaClientIpRegion?: Maybe<Scalars['String']>;
  payorEaClientIpRiskLevel?: Maybe<Scalars['String']>;
  payorEaClientIpScoreReason?: Maybe<Scalars['String']>;
  payorEaEmailRiskScore?: Maybe<Scalars['Float']>;
  payorEaIpCity?: Maybe<Scalars['String']>;
  payorEaIpRegion?: Maybe<Scalars['String']>;
  payorEaIpRiskLevel?: Maybe<Scalars['String']>;
  payorEaScoreReason?: Maybe<Scalars['String']>;
  payorIdmMMBadProxy?: Maybe<Scalars['Boolean']>;
  payorIdmMMCity?: Maybe<Scalars['String']>;
  payorIdmMMClientIpBadProxy?: Maybe<Scalars['Boolean']>;
  payorIdmMMClientIpCity?: Maybe<Scalars['String']>;
  payorIdmMMClientIpProxy?: Maybe<Scalars['Boolean']>;
  payorIdmMMClientIpRegion?: Maybe<Scalars['String']>;
  payorIdmMMClientIpScore?: Maybe<Scalars['Float']>;
  payorIdmMMProxy?: Maybe<Scalars['Boolean']>;
  payorIdmMMRegion?: Maybe<Scalars['String']>;
  payorIdmMMScore?: Maybe<Scalars['Float']>;
  payorWpClientIpIdentityScore?: Maybe<Scalars['Float']>;
  payorWpClientIpNetworkScore?: Maybe<Scalars['Float']>;
  payorWpIdentityScore?: Maybe<Scalars['Float']>;
  payorWpNetworkScore?: Maybe<Scalars['Float']>;
};

export type JoinOrganizationRequest = {
  __typename?: 'joinOrganizationRequest';
  addressLat?: Maybe<Scalars['String']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressLng?: Maybe<Scalars['String']>;
  aptNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<JoinOrganizationRequestcountryCodeEnumType>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  expired?: Maybe<Scalars['DateTime']>;
  firstName?: Maybe<Scalars['String']>;
  formattedAddress?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  requestingOrganization?: Maybe<Organization>;
  requestingOrganizationId?: Maybe<Scalars['Int']>;
  role: JoinOrganizationRequestroleEnumType;
  state?: Maybe<Scalars['String']>;
  status: JoinOrganizationRequeststatusEnumType;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['Int'];
  zipCode?: Maybe<Scalars['String']>;
};

export type JoinOrganizationRequestCount = {
  __typename?: 'joinOrganizationRequestCount';
  count?: Maybe<Scalars['Int']>;
};

export enum JoinOrganizationRequestcountryCodeEnumType {
  GU = 'GU',
  MP = 'MP',
  PR = 'PR',
  US = 'US',
  VI = 'VI'
}

export enum JoinOrganizationRequestroleEnumType {
  accountant = 'accountant',
  admin = 'admin',
  contributor = 'contributor',
  owner = 'owner'
}

export enum JoinOrganizationRequeststatusEnumType {
  approved = 'approved',
  canceled = 'canceled',
  pending = 'pending'
}

export enum LabelType {
  organization = 'organization',
  payment = 'payment'
}

export type LatestRiskDecision = {
  __typename?: 'latestRiskDecision';
  features?: Maybe<Scalars['SequelizeJSON']>;
  reason?: Maybe<Scalars['String']>;
  rules?: Maybe<Scalars['SequelizeJSON']>;
};

export type Locks = {
  __typename?: 'locks';
  id: Scalars['String'];
  timestamp: Scalars['DateTime'];
};

export type LocksCount = {
  __typename?: 'locksCount';
  count?: Maybe<Scalars['Int']>;
};

export type Loss = {
  __typename?: 'loss';
  amount: Scalars['String'];
  caseId?: Maybe<Scalars['String']>;
  chargeReferenceNumber?: Maybe<Scalars['String']>;
  chargebackAccount?: Maybe<LosschargebackAccountEnumType>;
  chargebackBankDate?: Maybe<Scalars['DateTime']>;
  claim?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  disputed?: Maybe<Scalars['Boolean']>;
  externalStatus?: Maybe<Scalars['String']>;
  handlingByAcro?: Maybe<Scalars['Boolean']>;
  highLevelClaim?: Maybe<LosshighLevelClaimEnumType>;
  id: Scalars['Int'];
  lastUpdatedBy?: Maybe<Scalars['String']>;
  nonDisputeReason?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  originalCbId?: Maybe<Scalars['String']>;
  originalLossCreatedAt?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  recoveryAccount?: Maybe<LossrecoveryAccountEnumType>;
  recoveryBankDate?: Maybe<Scalars['DateTime']>;
  recoveryDate?: Maybe<Scalars['DateTime']>;
  recoveryMethod?: Maybe<Scalars['String']>;
  scenario?: Maybe<Scalars['String']>;
  source: LosssourceEnumType;
  status: LossstatusEnumType;
  subStatus?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type LossCount = {
  __typename?: 'lossCount';
  count?: Maybe<Scalars['Int']>;
};

export enum LosschargebackAccountEnumType {
  Evolve2586DDA = 'Evolve2586DDA',
  Evolve2587FBO = 'Evolve2587FBO',
  SVB3639FBO = 'SVB3639FBO',
  SVB3643FBO = 'SVB3643FBO',
  SVB8361DDA = 'SVB8361DDA'
}

export type Losses = {
  __typename?: 'losses';
  apActive?: Maybe<StatisticsLoss>;
  apFinal?: Maybe<StatisticsLoss>;
  apSum?: Maybe<Scalars['Float']>;
  arActive?: Maybe<StatisticsLoss>;
  arFinal?: Maybe<StatisticsLoss>;
  arSum?: Maybe<Scalars['Float']>;
  sumTotal?: Maybe<Scalars['Float']>;
};

export enum LosshighLevelClaimEnumType {
  fraud = 'fraud',
  processing = 'processing',
  service = 'service'
}

export enum LossrecoveryAccountEnumType {
  Evolve2586DDA = 'Evolve2586DDA',
  Evolve2587FBO = 'Evolve2587FBO',
  SVB3639FBO = 'SVB3639FBO',
  SVB3643FBO = 'SVB3643FBO',
  SVB8361DDA = 'SVB8361DDA'
}

export enum LosssourceEnumType {
  amex = 'amex',
  manual = 'manual',
  system = 'system',
  tabapay = 'tabapay'
}

export enum LossstatusEnumType {
  lost = 'lost',
  potentialLoss = 'potentialLoss',
  recovered = 'recovered'
}

export type ManagedAccount = {
  __typename?: 'managedAccount';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  deliveryType?: Maybe<ManagedAccountdeliveryTypeEnumType>;
  id: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  preferred: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type ManagedAccountCount = {
  __typename?: 'managedAccountCount';
  count?: Maybe<Scalars['Int']>;
};

export enum ManagedAccountdeliveryTypeEnumType {
  ach = 'ach',
  check = 'check'
}

export type MerchantConfiguration = {
  __typename?: 'merchantConfiguration';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  externalId: Scalars['String'];
  id: Scalars['Int'];
  logo?: Maybe<File>;
  logoId?: Maybe<Scalars['Int']>;
  mccCode?: Maybe<Scalars['String']>;
  netTerms: Scalars['Int'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  tosUrl?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  websiteUrl?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type MerchantConfigurationCount = {
  __typename?: 'merchantConfigurationCount';
  count?: Maybe<Scalars['Int']>;
};

export type MetaData = {
  __typename?: 'metaData';
  transfersBatchAmountDifference?: Maybe<Scalars['Float']>;
};

export type MicroDeposit = {
  __typename?: 'microDeposit';
  accountNumber: Scalars['String'];
  amount: Scalars['String'];
  attemptsMade: Scalars['Int'];
  bankAccount?: Maybe<BankAccount>;
  bankAccountId?: Maybe<Scalars['Int']>;
  collectDate?: Maybe<Scalars['DateTime']>;
  collectFailedDate?: Maybe<Scalars['DateTime']>;
  collectStatus: MicroDepositcollectStatusEnumType;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deliverDate?: Maybe<Scalars['DateTime']>;
  deliverFailedDate?: Maybe<Scalars['DateTime']>;
  deliverStatus: MicroDepositdeliverStatusEnumType;
  id: Scalars['Int'];
  microDepositsDebit?: Maybe<MicroDepositsDebit>;
  microDepositsDebitId?: Maybe<Scalars['Int']>;
  note: Scalars['String'];
  organizationId?: Maybe<Scalars['Int']>;
  partnerName?: Maybe<Scalars['String']>;
  riskStatus?: Maybe<MicroDepositriskStatusEnumType>;
  riskStatusReason?: Maybe<Scalars['String']>;
  routingNumber: Scalars['String'];
  status: MicroDepositstatusEnumType;
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['Int']>;
  vendorId?: Maybe<Scalars['Int']>;
};

export type MicroDepositBlackList = {
  __typename?: 'microDepositBlackList';
  accountNumber: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  routingNumber: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type MicroDepositBlackListCount = {
  __typename?: 'microDepositBlackListCount';
  count?: Maybe<Scalars['Int']>;
};

export type MicroDepositCount = {
  __typename?: 'microDepositCount';
  count?: Maybe<Scalars['Int']>;
};

export enum MicroDepositcollectStatusEnumType {
  completed = 'completed',
  failed = 'failed',
  pending = 'pending'
}

export enum MicroDepositdeliverStatusEnumType {
  completed = 'completed',
  failed = 'failed',
  pending = 'pending'
}

export enum MicroDepositriskStatusEnumType {
  approved = 'approved',
  declined = 'declined'
}

export type MicroDepositsDebit = {
  __typename?: 'microDepositsDebit';
  accountNumber: Scalars['String'];
  amount: Scalars['String'];
  bankAccount?: Maybe<BankAccount>;
  bankAccountId: Scalars['Int'];
  collectStatus: MicroDepositsDebitcollectStatusEnumType;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deliverStatus: MicroDepositsDebitdeliverStatusEnumType;
  id: Scalars['Int'];
  microDeposits?: Maybe<Array<Maybe<MicroDeposit>>>;
  partnerName?: Maybe<Scalars['String']>;
  routingNumber: Scalars['String'];
  status: MicroDepositsDebitstatusEnumType;
  updatedAt: Scalars['DateTime'];
};

export type MicroDepositsDebitCount = {
  __typename?: 'microDepositsDebitCount';
  count?: Maybe<Scalars['Int']>;
};

export enum MicroDepositsDebitcollectStatusEnumType {
  completed = 'completed',
  failed = 'failed',
  pending = 'pending'
}

export enum MicroDepositsDebitdeliverStatusEnumType {
  completed = 'completed',
  failed = 'failed',
  pending = 'pending'
}

export enum MicroDepositsDebitstatusEnumType {
  failed = 'failed',
  pending = 'pending',
  sent = 'sent'
}

export enum MicroDepositstatusEnumType {
  expired = 'expired',
  pending = 'pending',
  sent = 'sent',
  verified = 'verified'
}

export type MoneyIn = {
  __typename?: 'moneyIn';
  decision?: Maybe<DecisionsTypes>;
  labels?: Maybe<Array<Maybe<OrganizationLabel>>>;
  source?: Maybe<Scalars['String']>;
};

export type MoneyOut = {
  __typename?: 'moneyOut';
  decision?: Maybe<DecisionsTypes>;
  labels?: Maybe<Array<Maybe<OrganizationLabel>>>;
  source?: Maybe<Scalars['String']>;
};

export type NaicsIndustries = {
  __typename?: 'naicsIndustries';
  createdAt: Scalars['DateTime'];
  naicsCode: Scalars['Int'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type NaicsIndustriesCount = {
  __typename?: 'naicsIndustriesCount';
  count?: Maybe<Scalars['Int']>;
};

export type NightlyPaymentPayload = {
  __typename?: 'nightlyPaymentPayload';
  checkNumber?: Maybe<Scalars['String']>;
  confirmationId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deliveryEta: Scalars['DateTime'];
  deliveryLast4Digits?: Maybe<Scalars['String']>;
  deliveryType: Scalars['String'];
  fundingLast4Digits: Scalars['String'];
  fundingType: Scalars['String'];
  id: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  paymentAmount: Scalars['String'];
  scheduledDate?: Maybe<Scalars['DateTime']>;
  subscriberId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userFirstName: Scalars['String'];
  userId: Scalars['Int'];
  vendorAddressCity?: Maybe<Scalars['String']>;
  vendorAddressLine1?: Maybe<Scalars['String']>;
  vendorAddressLine2?: Maybe<Scalars['String']>;
  vendorAddressState?: Maybe<Scalars['String']>;
  vendorAddressZipCode?: Maybe<Scalars['String']>;
  vendorName: Scalars['String'];
};

export type NightlyPaymentPayloadCount = {
  __typename?: 'nightlyPaymentPayloadCount';
  count?: Maybe<Scalars['Int']>;
};

export type NormalizedEmail = {
  __typename?: 'normalizedEmail';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userToNormalizedEmails?: Maybe<Array<Maybe<UserToNormalizedEmail>>>;
  users?: Maybe<Array<Maybe<User>>>;
  value: Scalars['String'];
};

export type NormalizedEmailCount = {
  __typename?: 'normalizedEmailCount';
  count?: Maybe<Scalars['Int']>;
};

export type NotificationGroup = {
  __typename?: 'notificationGroup';
  createdAt: Scalars['DateTime'];
  emailTemplates?: Maybe<Array<Maybe<EmailTemplate>>>;
  id: Scalars['Int'];
  name: Scalars['String'];
  notificationPreferences?: Maybe<Array<Maybe<NotificationPreference>>>;
  type: NotificationGrouptypeEnumType;
  updatedAt: Scalars['DateTime'];
};

export type NotificationGroupCount = {
  __typename?: 'notificationGroupCount';
  count?: Maybe<Scalars['Int']>;
};

export type NotificationGroupEmailTemplate = {
  __typename?: 'notificationGroupEmailTemplate';
  createdAt: Scalars['DateTime'];
  emailTemplate?: Maybe<EmailTemplate>;
  emailTemplateId: Scalars['Int'];
  notificationGroup?: Maybe<NotificationGroup>;
  notificationGroupId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type NotificationGroupEmailTemplateCount = {
  __typename?: 'notificationGroupEmailTemplateCount';
  count?: Maybe<Scalars['Int']>;
};

export enum NotificationGrouptypeEnumType {
  email = 'email',
  pushNotification = 'pushNotification',
  sms = 'sms'
}

export type NotificationPreference = {
  __typename?: 'notificationPreference';
  createdAt: Scalars['DateTime'];
  customMessage?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  id: Scalars['Int'];
  notificationGroup?: Maybe<NotificationGroup>;
  notificationGroupId: Scalars['Int'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

export type NotificationPreferenceCount = {
  __typename?: 'notificationPreferenceCount';
  count?: Maybe<Scalars['Int']>;
};

export type OcrJson = {
  __typename?: 'ocrJson';
  includedProhibitedIndustrySuspectedWords?: Maybe<Array<Scalars['String']>>;
  includedSanctionedWords: Array<Scalars['String']>;
  isError?: Maybe<Scalars['Boolean']>;
  text: Scalars['String'];
};

export type OnboardingIndustry = {
  __typename?: 'onboardingIndustry';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  onboardingSubIndustries?: Maybe<Array<Maybe<OnboardingSubIndustry>>>;
  order: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type OnboardingIndustryCount = {
  __typename?: 'onboardingIndustryCount';
  count?: Maybe<Scalars['Int']>;
};

export type OnboardingSubIndustry = {
  __typename?: 'onboardingSubIndustry';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  onboardingIndustry?: Maybe<OnboardingIndustry>;
  onboardingIndustryId: Scalars['Int'];
  order: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type OnboardingSubIndustryCount = {
  __typename?: 'onboardingSubIndustryCount';
  count?: Maybe<Scalars['Int']>;
};

export type OptedOutOfSaleUser = {
  __typename?: 'optedOutOfSaleUser';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  phoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userAgent: Scalars['String'];
  userEmail: Scalars['String'];
  userIp: Scalars['String'];
  userPrivacyRegulationType: OptedOutOfSaleUseruserPrivacyRegulationTypeEnumType;
};

export type OptedOutOfSaleUserCount = {
  __typename?: 'optedOutOfSaleUserCount';
  count?: Maybe<Scalars['Int']>;
};

export enum OptedOutOfSaleUseruserPrivacyRegulationTypeEnumType {
  ccpa = 'ccpa'
}

export type OrgLinking = {
  __typename?: 'orgLinking';
  companyName?: Maybe<Scalars['String']>;
  nonStrictMatchedData?: Maybe<Scalars['String']>;
  ode?: Maybe<OrganizationDecisionFull>;
  organizationId?: Maybe<Scalars['String']>;
  strictMatchedData?: Maybe<Scalars['String']>;
};

export type OrgLinkingObj = {
  __typename?: 'orgLinkingObj';
  data?: Maybe<Array<ExtendedOrgLinking>>;
  numLinkedOrgs?: Maybe<Scalars['Int']>;
};

export type Organization = {
  __typename?: 'organization';
  OrganizationUltimateBeneficialOwners?: Maybe<Array<Maybe<OrganizationUltimateBeneficialOwner>>>;
  accountingFirms?: Maybe<Array<Maybe<AccountingFirm>>>;
  accountingPlatformOrganization?: Maybe<AccountingPlatformOrganization>;
  accountingSoftware?: Maybe<Scalars['String']>;
  accounts?: Maybe<Array<Maybe<Account>>>;
  achRefunds?: Maybe<Array<Maybe<AchRefund>>>;
  actionLogs?: Maybe<Array<Maybe<ActionLog>>>;
  addedDeliveryMethod: Scalars['Boolean'];
  addedFunding: Scalars['Boolean'];
  addressLat?: Maybe<Scalars['String']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressLng?: Maybe<Scalars['String']>;
  annualRevenue?: Maybe<Scalars['Int']>;
  approvalWorkflows?: Maybe<Array<Maybe<ApprovalWorkflow>>>;
  aptNumber?: Maybe<Scalars['String']>;
  billingItems?: Maybe<Array<Maybe<BillingItem>>>;
  billingSettings?: Maybe<BillingSettings>;
  bills?: Maybe<Array<Maybe<Bill>>>;
  billsCount?: Maybe<Scalars['Int']>;
  businessDirectoryId?: Maybe<Scalars['String']>;
  businessType?: Maybe<Scalars['String']>;
  capitalOsAccount?: Maybe<CapitalOsAccounts>;
  cardholders?: Maybe<Array<Maybe<Cardholder>>>;
  ces?: Maybe<OrganizationCes>;
  chargebacks?: Maybe<Array<Maybe<Scalars['SequelizeJSON']>>>;
  city?: Maybe<Scalars['String']>;
  clientRoleFirmClients?: Maybe<Array<Maybe<FirmClient>>>;
  clients?: Maybe<Array<Maybe<Organization>>>;
  collectCompletionDaysOverride?: Maybe<Scalars['Int']>;
  companyDescription?: Maybe<Scalars['String']>;
  companyEmail?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyType?: Maybe<OrganizationcompanyTypeEnumType>;
  companyWebsite?: Maybe<Scalars['String']>;
  complianceGoodStandingVerification?: Maybe<ComplianceGoodStandingVerification>;
  connectedCards?: Maybe<Array<Maybe<ConnectedCard>>>;
  contactFirstName?: Maybe<Scalars['String']>;
  contactLastName?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  contacts?: Maybe<Array<Maybe<Contact>>>;
  countryCode?: Maybe<OrganizationcountryCodeEnumType>;
  createOrigin?: Maybe<OrganizationcreateOriginEnumType>;
  createdAt: Scalars['DateTime'];
  createdBill: Scalars['Boolean'];
  createdByPartner?: Maybe<Partner>;
  createdByPartnerId?: Maybe<Scalars['Int']>;
  crr?: Maybe<Crr>;
  customerSegment?: Maybe<Scalars['String']>;
  deferredDelivery?: Maybe<Scalars['SequelizeJSON']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  eBills?: Maybe<Array<Maybe<EBill>>>;
  ekata?: Maybe<Scalars['SequelizeJSON']>;
  emailVerified: Scalars['Boolean'];
  emailageOrg?: Maybe<Scalars['SequelizeJSON']>;
  enigmaAddressVerification?: Maybe<AddressVerification>;
  expenseManagementOnboardingStatus?: Maybe<Scalars['Boolean']>;
  expenses?: Maybe<Array<Maybe<Expense>>>;
  features?: Maybe<Scalars['SequelizeJSON']>;
  files?: Maybe<Array<Maybe<File>>>;
  firmRoleFirmClients?: Maybe<Array<Maybe<FirmClient>>>;
  firms?: Maybe<Array<Maybe<Organization>>>;
  firstTimePay: Scalars['Boolean'];
  formattedAddress?: Maybe<Scalars['String']>;
  fundingSources?: Maybe<Array<Maybe<FundingSource>>>;
  googlePlaceId?: Maybe<Scalars['String']>;
  guestPayorOrganizationMetadata?: Maybe<GuestPayorOrganizationMetadata>;
  id: Scalars['Int'];
  inboxEmailAddresses?: Maybe<Array<Maybe<InboxEmailAddress>>>;
  industry?: Maybe<Industry>;
  industryId?: Maybe<Scalars['Int']>;
  industrySource?: Maybe<OrganizationindustrySourceEnumType>;
  intuitCompanyAccountType?: Maybe<Scalars['String']>;
  intuitLastFullUpdate?: Maybe<Scalars['DateTime']>;
  intuitRealmId?: Maybe<Scalars['String']>;
  invitations?: Maybe<Array<Maybe<Invitation>>>;
  isApiPartner?: Maybe<Scalars['Boolean']>;
  isBusinessEmail: Scalars['Boolean'];
  isEmailageEnriched?: Maybe<Scalars['Boolean']>;
  isMelioMe?: Maybe<Scalars['Boolean']>;
  isMelioMeOrg: Scalars['Boolean'];
  isMicroDepositEligible?: Maybe<Scalars['Boolean']>;
  isMicroDepositEligibleConfidence?: Maybe<Scalars['String']>;
  isMicroDepositEligibleOverridden?: Maybe<Scalars['Boolean']>;
  isOrgLinked?: Maybe<Scalars['Boolean']>;
  isPlaidEnriched?: Maybe<Scalars['Boolean']>;
  isWhitePagesEnriched?: Maybe<Scalars['Boolean']>;
  joinOrganizationRequests?: Maybe<Array<Maybe<JoinOrganizationRequest>>>;
  jurisdictionStateOfIncorporation?: Maybe<Array<Maybe<Scalars['String']>>>;
  kyb?: Maybe<OrganizationkybEnumType>;
  kybConfidence?: Maybe<Scalars['Int']>;
  kybInConfidence?: Maybe<Scalars['Int']>;
  kybMoneyIn?: Maybe<OrganizationkybMoneyInEnumType>;
  kybMoneyInSubType?: Maybe<OrganizationkybMoneyInSubTypeEnumType>;
  kybStatus?: Maybe<OrganizationkybStatusEnumType>;
  kybSubType?: Maybe<OrganizationkybSubTypeEnumType>;
  lastPayDate?: Maybe<Scalars['DateTime']>;
  legalAddressLat?: Maybe<Scalars['String']>;
  legalAddressLine1?: Maybe<Scalars['String']>;
  legalAddressLine2?: Maybe<Scalars['String']>;
  legalAddressLng?: Maybe<Scalars['String']>;
  legalAptNumber?: Maybe<Scalars['String']>;
  legalCity?: Maybe<Scalars['String']>;
  legalCompanyName?: Maybe<Scalars['String']>;
  legalCountryCode?: Maybe<OrganizationlegalCountryCodeEnumType>;
  legalDateOfBirth?: Maybe<Scalars['DateTime']>;
  legalFormattedAddress?: Maybe<Scalars['String']>;
  legalGooglePlaceId?: Maybe<Scalars['String']>;
  legalState?: Maybe<Scalars['String']>;
  legalZipCode?: Maybe<Scalars['String']>;
  linkedAccountingSoftware: Scalars['Boolean'];
  linking?: Maybe<Array<Maybe<OrgLinking>>>;
  logo?: Maybe<File>;
  logoId?: Maybe<Scalars['Int']>;
  melioDbCases?: Maybe<Array<Maybe<Scalars['SequelizeJSON']>>>;
  mql?: Maybe<OrganizationmqlEnumType>;
  mqlConfidence?: Maybe<Scalars['String']>;
  mqlManual?: Maybe<Scalars['Boolean']>;
  notificationPreferences?: Maybe<Array<Maybe<NotificationPreference>>>;
  ode?: Maybe<OrganizationDecisionFull>;
  orgFees?: Maybe<Array<Maybe<Scalars['SequelizeJSON']>>>;
  organizationBranding?: Maybe<OrganizationBranding>;
  organizationKybActions?: Maybe<Array<Maybe<OrganizationKybAction>>>;
  organizationNaicsIndustries?: Maybe<OrganizationIndustryData>;
  organizationPreferences?: Maybe<Array<Maybe<OrganizationPreference>>>;
  organizationSyncData?: Maybe<AccountingPlatformOrganization>;
  ownedVendors?: Maybe<Array<Maybe<Vendor>>>;
  owner?: Maybe<User>;
  owningOrganizationProhibitedIndustriesData?: Maybe<OrganizationProhibitedIndustriesData>;
  partner?: Maybe<OrganizationPartner>;
  partnerIntegrationId?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  paymentRequests?: Maybe<Array<Maybe<PaymentRequest>>>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  paymentsCount?: Maybe<Scalars['Int']>;
  pendingApprovalPayments?: Maybe<Array<Maybe<Payment>>>;
  phone?: Maybe<Scalars['String']>;
  plaidItems?: Maybe<Array<Maybe<PlaidItem>>>;
  prohibitedIndustriesData?: Maybe<OrganizationProhibitedIndustriesData>;
  promotions?: Maybe<Array<Maybe<Promotion>>>;
  quickbooksDesktopCompany?: Maybe<QuickbooksDesktopCompany>;
  recurringBills?: Maybe<Array<Maybe<RecurringBill>>>;
  shopifyShop?: Maybe<ShopifyShop>;
  state?: Maybe<Scalars['String']>;
  subIndustry?: Maybe<SubIndustry>;
  subIndustryId?: Maybe<Scalars['Int']>;
  subscriptionDetails?: Maybe<SubscriptionDetails>;
  subscriptions?: Maybe<Array<Maybe<BillSubscription>>>;
  syncActivity?: Maybe<Array<Maybe<OrganizationSyncActivity>>>;
  syncData?: Maybe<SyncDataType>;
  syncExternalFailedObjects?: Maybe<Array<Maybe<SyncExternalFailedObject>>>;
  syncMetadata?: Maybe<Array<Maybe<OrganizationSyncMetadata>>>;
  tags?: Maybe<Array<Maybe<EntityTag>>>;
  taxId?: Maybe<Scalars['String']>;
  taxIdLast4Digits?: Maybe<Scalars['String']>;
  taxIdType?: Maybe<OrganizationtaxIdTypeEnumType>;
  taxVerification?: Maybe<TaxVerification>;
  transactions?: Maybe<Array<Maybe<Transaction>>>;
  updatedAt: Scalars['DateTime'];
  userOrganizations?: Maybe<Array<Maybe<UserOrganization>>>;
  userQuickbooksCredentials?: Maybe<Array<Maybe<UserQuickbooksCredential>>>;
  users?: Maybe<Array<Maybe<User>>>;
  vendorPaymentLinks?: Maybe<Array<Maybe<VendorPaymentLink>>>;
  vendors?: Maybe<Array<Maybe<Vendor>>>;
  vendorsCount?: Maybe<Scalars['Int']>;
  wiseProfileRestriction?: Maybe<WiseProfileRestriction>;
  yearOfIncorporation?: Maybe<Scalars['Int']>;
  zipCode?: Maybe<Scalars['String']>;
};


export type OrganizationBillsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type OrganizationBillsCountArgs = {
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type OrganizationCardholdersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type OrganizationConnectedCardsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type OrganizationExpensesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type OrganizationFundingSourcesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type OrganizationPaymentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type OrganizationPaymentsCountArgs = {
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type OrganizationVendorsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type OrganizationVendorsCountArgs = {
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};

export enum OrganizationAddressTypeEnum {
  Billing = 'Billing',
  CustomerCommunication = 'CustomerCommunication',
  Delivery = 'Delivery'
}

export type OrganizationBillingFee = {
  __typename?: 'organizationBillingFee';
  billingFeeType?: Maybe<OrganizationBillingFeebillingFeeTypeEnumType>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  createdById: Scalars['Int'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  fundingSource?: Maybe<FundingSource>;
  fundingSourceId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  managedByOrganization?: Maybe<Organization>;
  managedByOrganizationId?: Maybe<Scalars['Int']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  updatedById: Scalars['Int'];
};

export type OrganizationBillingFeeCount = {
  __typename?: 'organizationBillingFeeCount';
  count?: Maybe<Scalars['Int']>;
};

export enum OrganizationBillingFeebillingFeeTypeEnumType {
  ach_to_check = 'ach_to_check'
}

export type OrganizationBranding = {
  __typename?: 'organizationBranding';
  brandColor?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type OrganizationBrandingCount = {
  __typename?: 'organizationBrandingCount';
  count?: Maybe<Scalars['Int']>;
};

export type OrganizationContact = {
  __typename?: 'organizationContact';
  contactId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  organizationId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type OrganizationContactCount = {
  __typename?: 'organizationContactCount';
  count?: Maybe<Scalars['Int']>;
};

export type OrganizationCount = {
  __typename?: 'organizationCount';
  count?: Maybe<Scalars['Int']>;
};

export type OrganizationHasVendor = {
  __typename?: 'organizationHasVendor';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  mccCode?: Maybe<Scalars['String']>;
  organizationId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  shared: Scalars['Boolean'];
  trusted: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  vendorId: Scalars['Int'];
};

export type OrganizationHasVendorCount = {
  __typename?: 'organizationHasVendorCount';
  count?: Maybe<Scalars['Int']>;
};

export type OrganizationKybAction = {
  __typename?: 'organizationKybAction';
  createdAt: Scalars['DateTime'];
  externalId: Scalars['String'];
  id: Scalars['Int'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  result: Scalars['String'];
  source: OrganizationKybActionsourceEnumType;
  updatedAt: Scalars['DateTime'];
};

export type OrganizationKybActionCount = {
  __typename?: 'organizationKybActionCount';
  count?: Maybe<Scalars['Int']>;
};

export enum OrganizationKybActionsourceEnumType {
  idm = 'idm',
  manual = 'manual',
  system = 'system'
}

export type OrganizationNaicsIndustry = {
  __typename?: 'organizationNaicsIndustry';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  industryText: Scalars['String'];
  naicsCode?: Maybe<Scalars['Int']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  parentNaicsCode?: Maybe<Scalars['Int']>;
  partnerName: Scalars['String'];
  source?: Maybe<OrganizationNaicsIndustrysourceEnumType>;
  updatedAt: Scalars['DateTime'];
};

export type OrganizationNaicsIndustryCount = {
  __typename?: 'organizationNaicsIndustryCount';
  count?: Maybe<Scalars['Int']>;
};

export enum OrganizationNaicsIndustrysourceEnumType {
  manualOverride = 'manualOverride',
  userProvided = 'userProvided'
}

export type OrganizationPreference = {
  __typename?: 'organizationPreference';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  key: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  value: Scalars['String'];
};

export type OrganizationPreferenceCount = {
  __typename?: 'organizationPreferenceCount';
  count?: Maybe<Scalars['Int']>;
};

export type OrganizationQuestionnaire = {
  __typename?: 'organizationQuestionnaire';
  createdAt: Scalars['DateTime'];
  createdById: Scalars['Int'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  firmServices?: Maybe<Scalars['SequelizeJSON']>;
  id: Scalars['Int'];
  managingApArClients?: Maybe<Scalars['String']>;
  melioUsages?: Maybe<Scalars['SequelizeJSON']>;
  numberOfEmployees?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  otherPayableTools?: Maybe<Scalars['SequelizeJSON']>;
  partnerName: Scalars['String'];
  roleDescription?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  usedAccountingSoftware?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type OrganizationQuestionnaireCount = {
  __typename?: 'organizationQuestionnaireCount';
  count?: Maybe<Scalars['Int']>;
};

export type OrganizationSyncActivity = {
  __typename?: 'organizationSyncActivity';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  externalIntegrationType?: Maybe<OrganizationSyncActivityexternalIntegrationTypeEnumType>;
  id: Scalars['Int'];
  lastSyncedAt: Scalars['DateTime'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  status: OrganizationSyncActivitystatusEnumType;
  updatedAt: Scalars['DateTime'];
};

export type OrganizationSyncActivityCount = {
  __typename?: 'organizationSyncActivityCount';
  count?: Maybe<Scalars['Int']>;
};

export enum OrganizationSyncActivityexternalIntegrationTypeEnumType {
  qbd = 'qbd',
  qbo = 'qbo',
  qboGetPaid = 'qboGetPaid',
  qboPaid = 'qboPaid',
  xerox = 'xerox'
}

export enum OrganizationSyncActivitystatusEnumType {
  done = 'done',
  error = 'error'
}

export type OrganizationSyncMetadata = {
  __typename?: 'organizationSyncMetadata';
  createRequestId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  externalId?: Maybe<Scalars['String']>;
  externalIntegrationType?: Maybe<OrganizationSyncMetadataexternalIntegrationTypeEnumType>;
  externalLastUpdate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  lastFullSync?: Maybe<Scalars['DateTime']>;
  localLastUpdate?: Maybe<Scalars['DateTime']>;
  organizationId?: Maybe<Scalars['Int']>;
  partnerName?: Maybe<Scalars['String']>;
  syncMetadata?: Maybe<Organization>;
  updatedAt: Scalars['DateTime'];
};

export type OrganizationSyncMetadataCount = {
  __typename?: 'organizationSyncMetadataCount';
  count?: Maybe<Scalars['Int']>;
};

export enum OrganizationSyncMetadataexternalIntegrationTypeEnumType {
  qbd = 'qbd',
  qboGetPaid = 'qboGetPaid',
  qboPaid = 'qboPaid',
  xerox = 'xerox'
}

export type OrganizationUltimateBeneficialOwnerType = {
  __typename?: 'organizationUltimateBeneficialOwnerType';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  organizationUltimateBeneficialOwner?: Maybe<OrganizationUltimateBeneficialOwner>;
  organizationUltimateBeneficialOwnerId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  type: OrganizationUltimateBeneficialOwnerTypetypeEnumType;
  uniqueUboIdType?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['DateTime'];
};

export type OrganizationUltimateBeneficialOwnerTypeCount = {
  __typename?: 'organizationUltimateBeneficialOwnerTypeCount';
  count?: Maybe<Scalars['Int']>;
};

export enum OrganizationUltimateBeneficialOwnerTypetypeEnumType {
  director = 'director',
  financingApplicant = 'financingApplicant',
  fxAccountHolder = 'fxAccountHolder',
  ubo = 'ubo'
}

export type OrganizationVendorTraits = {
  __typename?: 'organizationVendorTraits';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  eligibleCardNetworks?: Maybe<Scalars['SequelizeJSON']>;
  id: Scalars['Int'];
  mccCode?: Maybe<Scalars['String']>;
  organizationId: Scalars['Int'];
  partnerName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  vendorId: Scalars['Int'];
};

export type OrganizationVendorTraitsCount = {
  __typename?: 'organizationVendorTraitsCount';
  count?: Maybe<Scalars['Int']>;
};

export enum OrganizationcompanyTypeEnumType {
  accountingFirm = 'accountingFirm',
  smb = 'smb'
}

export enum OrganizationcountryCodeEnumType {
  GU = 'GU',
  MP = 'MP',
  PR = 'PR',
  US = 'US',
  VI = 'VI'
}

export enum OrganizationcreateOriginEnumType {
  accountsPayablePlatform = 'accountsPayablePlatform',
  addCompany = 'addCompany',
  builtPartnership = 'builtPartnership',
  erpVendorOnboarding = 'erpVendorOnboarding',
  guest = 'guest',
  merchantCheckout = 'merchantCheckout',
  msnPortal = 'msnPortal',
  nativeAndroid = 'nativeAndroid',
  nativeIos = 'nativeIos',
  nativeSdkAndroid = 'nativeSdkAndroid',
  nativeSdkIos = 'nativeSdkIos',
  pushToDebit = 'pushToDebit',
  qbdtIntegration = 'qbdtIntegration',
  qbdtMac = 'qbdtMac',
  qbdtWindows = 'qbdtWindows',
  qbmAndroid = 'qbmAndroid',
  qbmIntegration = 'qbmIntegration',
  qbmIos = 'qbmIos',
  qboIntegration = 'qboIntegration',
  qbrAndroid = 'qbrAndroid',
  qbrIntegration = 'qbrIntegration',
  qbrIos = 'qbrIos',
  syngencyIntegration = 'syngencyIntegration',
  unilateralRequest = 'unilateralRequest',
  userSignup = 'userSignup'
}

export enum OrganizationindustrySourceEnumType {
  manual = 'manual',
  prediction = 'prediction'
}

export enum OrganizationkybEnumType {
  accept = 'accept',
  approveAll = 'approveAll',
  legal = 'legal',
  policy = 'policy',
  reject = 'reject',
  undecided = 'undecided'
}

export enum OrganizationkybStatusEnumType {
  accepted = 'accepted',
  denied = 'denied',
  undecided = 'undecided'
}

export enum OrganizationkybSubTypeEnumType {
  abuse = 'abuse',
  becameAbusive = 'becameAbusive',
  compromised = 'compromised',
  consumer = 'consumer',
  duplicate = 'duplicate',
  finalisedMoneyLoss = 'finalisedMoneyLoss',
  fraud = 'fraud',
  inaccurateLegalInfo = 'inaccurateLegalInfo',
  lossRisk = 'lossRisk',
  other = 'other',
  prohibitedLOB = 'prohibitedLOB',
  reinstated = 'reinstated',
  sanctionTrueHit = 'sanctionTrueHit',
  sensitive = 'sensitive',
  standard = 'standard',
  tentative = 'tentative',
  unresponsiveUser = 'unresponsiveUser'
}

export enum OrganizationlegalCountryCodeEnumType {
  GU = 'GU',
  MP = 'MP',
  PR = 'PR',
  US = 'US',
  VI = 'VI'
}

export enum OrganizationmqlEnumType {
  qualified = 'qualified',
  undecided = 'undecided',
  unqualified = 'unqualified'
}

export type OrganizationsToBusinesses = {
  __typename?: 'organizationsToBusinesses';
  businessId?: Maybe<Scalars['String']>;
  candidateId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  linkStatus: OrganizationsToBusinesseslinkStatusEnumType;
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  origin: OrganizationsToBusinessesoriginEnumType;
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  virtualCardCandidate?: Maybe<VirtualCardCandidates>;
};

export type OrganizationsToBusinessesCount = {
  __typename?: 'organizationsToBusinessesCount';
  count?: Maybe<Scalars['Int']>;
};

export enum OrganizationsToBusinesseslinkStatusEnumType {
  opt_out = 'opt_out',
  pending_to_create = 'pending_to_create',
  rejected = 'rejected',
  verified = 'verified'
}

export enum OrganizationsToBusinessesoriginEnumType {
  ar_erp_form = 'ar_erp_form',
  existing_get_paid_vendor = 'existing_get_paid_vendor',
  public_form = 'public_form',
  sales_form = 'sales_form',
  sales_get_paid_wizard = 'sales_get_paid_wizard',
  unilateral_and_enrollment = 'unilateral_and_enrollment',
  wex = 'wex'
}

export enum OrganizationtaxIdTypeEnumType {
  EIN = 'EIN',
  ITIN = 'ITIN',
  SSN = 'SSN'
}

export type PaperCheck = {
  __typename?: 'paperCheck';
  addressLat?: Maybe<Scalars['String']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressLng?: Maybe<Scalars['String']>;
  aptNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<PaperCheckcountryCodeEnumType>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  formattedAddress?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isAddressSuggestionIgnored?: Maybe<Scalars['Boolean']>;
  partnerName?: Maybe<Scalars['String']>;
  printName: Scalars['String'];
  riskEngineDecisionMetadata?: Maybe<RiskEngineDecisionMetadata>;
  state?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  zipCode?: Maybe<Scalars['String']>;
};

export type PaperCheckCount = {
  __typename?: 'paperCheckCount';
  count?: Maybe<Scalars['Int']>;
};

export enum PaperCheckcountryCodeEnumType {
  GU = 'GU',
  MP = 'MP',
  PR = 'PR',
  US = 'US',
  VI = 'VI'
}

export enum ParticipantStatusEnum {
  Active = 'Active',
  Inactive = 'Inactive',
  Initiator = 'Initiator'
}

export type Partner = {
  __typename?: 'partner';
  accounts?: Maybe<Array<Maybe<Account>>>;
  agreementSignatures?: Maybe<Array<Maybe<AgreementSignature>>>;
  agreements?: Maybe<Array<Maybe<Agreement>>>;
  billSubscriptions?: Maybe<Array<Maybe<BillSubscription>>>;
  bills?: Maybe<Array<Maybe<Bill>>>;
  companyName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deliveryMethods?: Maybe<Array<Maybe<DeliveryMethod>>>;
  email?: Maybe<Scalars['String']>;
  fundingSources?: Maybe<Array<Maybe<FundingSource>>>;
  id: Scalars['Int'];
  lastActiveAt?: Maybe<Scalars['DateTime']>;
  organizations?: Maybe<Array<Maybe<Organization>>>;
  partnerKeys?: Maybe<Array<Maybe<PartnerKey>>>;
  partnerName: Scalars['String'];
  partnerOriginValue: Scalars['String'];
  paymentIntents?: Maybe<Array<Maybe<PaymentIntent>>>;
  paymentRequests?: Maybe<Array<Maybe<PaymentRequest>>>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['Int']>;
  users?: Maybe<Array<Maybe<User>>>;
  vendors?: Maybe<Array<Maybe<Vendor>>>;
};

export type PartnerAuthProviderConfig = {
  __typename?: 'partnerAuthProviderConfig';
  config?: Maybe<Scalars['SequelizeJSON']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int'];
  partnerName: Scalars['String'];
  provider: PartnerAuthProviderConfigproviderEnumType;
  updatedAt: Scalars['DateTime'];
};

export type PartnerAuthProviderConfigCount = {
  __typename?: 'partnerAuthProviderConfigCount';
  count?: Maybe<Scalars['Int']>;
};

export enum PartnerAuthProviderConfigproviderEnumType {
  capitalOne = 'capitalOne',
  clover = 'clover',
  fiserv = 'fiserv',
  shopify = 'shopify',
  standard = 'standard'
}

export type PartnerBankAccountIcon = {
  __typename?: 'partnerBankAccountIcon';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  logoUrl: Scalars['String'];
  partnerName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type PartnerBankAccountIconCount = {
  __typename?: 'partnerBankAccountIconCount';
  count?: Maybe<Scalars['Int']>;
};

export type PartnerCount = {
  __typename?: 'partnerCount';
  count?: Maybe<Scalars['Int']>;
};

export type PartnerFeeCatalog = {
  __typename?: 'partnerFeeCatalog';
  createdAt: Scalars['DateTime'];
  currentCatalogVersionId: Scalars['Int'];
  id: Scalars['Int'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type PartnerFeeCatalogCount = {
  __typename?: 'partnerFeeCatalogCount';
  count?: Maybe<Scalars['Int']>;
};

export type PartnerKey = {
  __typename?: 'partnerKey';
  createdAt: Scalars['DateTime'];
  expiredAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  keyId?: Maybe<Scalars['String']>;
  lastActiveAt?: Maybe<Scalars['DateTime']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  secret: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type PartnerKeyCount = {
  __typename?: 'partnerKeyCount';
  count?: Maybe<Scalars['Int']>;
};

export type PartnerPaymentAccount = {
  __typename?: 'partnerPaymentAccount';
  accountHolderAddressCity?: Maybe<Scalars['String']>;
  accountHolderAddressLine1?: Maybe<Scalars['String']>;
  accountHolderAddressLine2?: Maybe<Scalars['String']>;
  accountHolderAddressState?: Maybe<Scalars['String']>;
  accountHolderAddressZip?: Maybe<Scalars['String']>;
  accountHolderName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  partnerName: Scalars['String'];
  partnerPaymentAccountType?: Maybe<PartnerPaymentAccountType>;
  partnerPaymentAccountTypeId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type PartnerPaymentAccountCount = {
  __typename?: 'partnerPaymentAccountCount';
  count?: Maybe<Scalars['Int']>;
};

export type PartnerPaymentAccountType = {
  __typename?: 'partnerPaymentAccountType';
  base64Logo: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  partnerName: Scalars['String'];
  partnerPaymentAccounts?: Maybe<Array<Maybe<PartnerPaymentAccount>>>;
  updatedAt: Scalars['DateTime'];
};

export type PartnerPaymentAccountTypeCount = {
  __typename?: 'partnerPaymentAccountTypeCount';
  count?: Maybe<Scalars['Int']>;
};

export type Payment = {
  __typename?: 'payment';
  accountInitiatedBy?: Maybe<PaymentaccountInitiatedByEnumType>;
  accountingPlatformEntity?: Maybe<AccountingPlatformEntity>;
  achRefunds?: Maybe<Array<Maybe<AchRefund>>>;
  actionLogs?: Maybe<Array<Maybe<ActionLog>>>;
  amount: Scalars['String'];
  apAccountingPlatformEntity?: Maybe<AccountingPlatformEntity>;
  applicationPayment?: Maybe<ApplicationPayment>;
  approvalDecisionBy?: Maybe<User>;
  approvalDecisionByEmail?: Maybe<Scalars['String']>;
  approvalDecisionById?: Maybe<Scalars['Int']>;
  approvalDecisionDate?: Maybe<Scalars['DateTime']>;
  approvalDecisionReason?: Maybe<Scalars['String']>;
  approvalDecisionStatus: PaymentapprovalDecisionStatusEnumType;
  approvalWorkflow?: Maybe<ApprovalWorkflow>;
  approvalWorkflowId?: Maybe<Scalars['Int']>;
  autoPayPolicy?: Maybe<AutoPayPolicy>;
  autoPayPolicyId?: Maybe<Scalars['Int']>;
  balance?: Maybe<Scalars['String']>;
  bill?: Maybe<Bill>;
  billId?: Maybe<Scalars['Int']>;
  billPayments?: Maybe<Array<Maybe<BillPayment>>>;
  billSubscriptionOccurrence?: Maybe<BillSubscriptionOccurrence>;
  billingItems?: Maybe<Array<Maybe<BillingItem>>>;
  bills?: Maybe<Array<Maybe<Bill>>>;
  catalogReference?: Maybe<Scalars['Int']>;
  checkTracks?: Maybe<Array<Maybe<CheckTrack>>>;
  clientIp?: Maybe<Scalars['String']>;
  collectFailureData?: Maybe<Scalars['SequelizeJSON']>;
  collectPreference?: Maybe<PaymentcollectPreferenceEnumType>;
  collectStatus?: Maybe<PaymentcollectStatusEnumType>;
  complyAdvantagePaymentUrl?: Maybe<Scalars['String']>;
  confirmationNumber?: Maybe<Scalars['String']>;
  createMethod: PaymentcreateMethodEnumType;
  createOrigin: PaymentcreateOriginEnumType;
  createdAt: Scalars['DateTime'];
  createdAtOrigin?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById: Scalars['Int'];
  createdByPartner?: Maybe<Partner>;
  createdByPartnerId?: Maybe<Scalars['Int']>;
  currency: Scalars['String'];
  deferredDelivery?: Maybe<Scalars['SequelizeJSON']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deliverFailureData?: Maybe<Scalars['SequelizeJSON']>;
  deliverStatus?: Maybe<PaymentdeliverStatusEnumType>;
  deliveryDate?: Maybe<Scalars['DateTime']>;
  deliveryEta?: Maybe<Scalars['DateTime']>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  deliveryMethodId?: Maybe<Scalars['Int']>;
  deliveryPreference?: Maybe<PaymentdeliveryPreferenceEnumType>;
  eligibleForPushToDebit: Scalars['Boolean'];
  etaFeatures?: Maybe<Scalars['SequelizeJSON']>;
  expeditedBy?: Maybe<PaymentexpeditedByEnumType>;
  fastPaymentDecisions?: Maybe<Array<Maybe<PaymentFastDecision>>>;
  financingAccount?: Maybe<FinancingAccount>;
  foreignAmount?: Maybe<Scalars['String']>;
  foreignCurrency?: Maybe<Scalars['String']>;
  fundingSource?: Maybe<FundingSource>;
  fundingSourceId?: Maybe<Scalars['Int']>;
  getPaidAccountingPlatformEntity?: Maybe<AccountingPlatformEntity>;
  hasManuallyApproved?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  includedNoteSanctionedWords: Array<Scalars['String']>;
  includedPurposeSanctionedWords: Array<Scalars['String']>;
  intuitAccountId?: Maybe<Scalars['String']>;
  isApiPartner?: Maybe<Scalars['Boolean']>;
  isExpedited: Scalars['Boolean'];
  isFinanced: Scalars['Boolean'];
  isGoodsReceived?: Maybe<Scalars['Boolean']>;
  isOffRail?: Maybe<Scalars['Boolean']>;
  isPartial?: Maybe<Scalars['SequelizeJSON']>;
  isTest?: Maybe<Scalars['Boolean']>;
  issuedDate?: Maybe<Scalars['DateTime']>;
  lastSync?: Maybe<Scalars['DateTime']>;
  latestPaymentApprovalAction?: Maybe<PaymentApprovalAction>;
  latestRiskDecision?: Maybe<LatestRiskDecision>;
  losses?: Maybe<Array<Maybe<Loss>>>;
  manual?: Maybe<Scalars['Boolean']>;
  manualType?: Maybe<PaymentmanualTypeEnumType>;
  maxDeliveryEta?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  origin: PaymentoriginEnumType;
  originId: Scalars['String'];
  originMetaUrl?: Maybe<Scalars['String']>;
  originVersion: Scalars['Int'];
  originalDeliveryMethod?: Maybe<DeliveryMethod>;
  originalDeliveryMethodId?: Maybe<Scalars['Int']>;
  originalPayment?: Maybe<Array<Maybe<AchRefund>>>;
  paidDate?: Maybe<Scalars['DateTime']>;
  partnerCompanyName?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  payeeApprovalDecisionBy?: Maybe<User>;
  payeeApprovalDecisionById?: Maybe<Scalars['Int']>;
  payeeApprovalDecisionDate?: Maybe<Scalars['DateTime']>;
  payeeApprovalDecisionReason?: Maybe<Scalars['String']>;
  payeeApprovalDecisionStatus: PaymentpayeeApprovalDecisionStatusEnumType;
  paymentApprovalActions?: Maybe<Array<Maybe<PaymentApprovalAction>>>;
  paymentApprovalDecisions?: Maybe<Array<Maybe<PaymentApprovalDecision>>>;
  paymentFees?: Maybe<Array<PaymentFeeDetail>>;
  paymentSyncActivity?: Maybe<PaymentSyncActivity>;
  paymentType?: Maybe<TypePaymentEnum>;
  payorFeeFundingSource?: Maybe<FundingSource>;
  payorFeeFundingSourceId?: Maybe<Scalars['Int']>;
  payorType?: Maybe<PaymentpayorTypeEnumType>;
  principalPayment?: Maybe<PrincipalPayment>;
  processingPaymentId?: Maybe<Scalars['String']>;
  processingPaymentVersion?: Maybe<Scalars['String']>;
  productUseCase?: Maybe<PaymentproductUseCaseEnumType>;
  prohibitedIndustriesData?: Maybe<PaymentProhibitedIndustriesData>;
  providerDeliveryEta?: Maybe<Scalars['DateTime']>;
  purpose?: Maybe<Scalars['String']>;
  purposeDetails?: Maybe<Scalars['SequelizeJSON']>;
  railsType?: Maybe<RailsTypeEnum>;
  refundProcessDate?: Maybe<Scalars['DateTime']>;
  riskEngineDecisions?: Maybe<Array<Maybe<RiskEngineDecision>>>;
  riskStatus?: Maybe<PaymentriskStatusEnumType>;
  robinhoodExecutions?: Maybe<Array<Maybe<FlowExecution>>>;
  scheduledDate: Scalars['DateTime'];
  status?: Maybe<PaymentstatusEnumType>;
  syncMetadata?: Maybe<Array<Maybe<PaymentSyncMetadata>>>;
  terminated: Scalars['Boolean'];
  transactions?: Maybe<Array<Maybe<Transaction>>>;
  transfers?: Maybe<Array<Maybe<TransferTimeline>>>;
  unilateralRequests?: Maybe<Array<Maybe<UnilateralRequest>>>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  updatedById: Scalars['Int'];
  usdToForeignRate?: Maybe<Scalars['String']>;
  userNote?: Maybe<Scalars['String']>;
  vendor?: Maybe<Vendor>;
  vendorCreditsPayments?: Maybe<Array<Maybe<VendorCreditsPayments>>>;
  vendorId: Scalars['Int'];
  vendorMcc?: Maybe<Scalars['String']>;
  virtualCards?: Maybe<Array<Maybe<VirtualCard>>>;
  voidChecks?: Maybe<Array<Maybe<VoidCheck>>>;
  workflowProgresses?: Maybe<Array<Maybe<WorkflowProgress>>>;
};

export type PaymentApprovalAction = {
  __typename?: 'paymentApprovalAction';
  createdAt: Scalars['DateTime'];
  decisionType?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  paymentId: Scalars['Int'];
  reasons?: Maybe<Scalars['String']>;
  result: PaymentApprovalActionresultEnumType;
  riskDecisionCode?: Maybe<RiskDecisionCode>;
  riskDecisionCodeId?: Maybe<Scalars['Int']>;
  riskEngineDecision?: Maybe<RiskEngineDecision>;
  riskEngineDecisionId?: Maybe<Scalars['Int']>;
  source: PaymentApprovalActionsourceEnumType;
  updatedAt: Scalars['DateTime'];
};

export type PaymentApprovalActionCount = {
  __typename?: 'paymentApprovalActionCount';
  count?: Maybe<Scalars['Int']>;
};

export enum PaymentApprovalActionresultEnumType {
  approved = 'approved',
  declined = 'declined',
  pending = 'pending'
}

export enum PaymentApprovalActionsourceEnumType {
  manual = 'manual',
  system = 'system'
}

export type PaymentApprovalDecision = {
  __typename?: 'paymentApprovalDecision';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  paymentId: Scalars['Int'];
  reason?: Maybe<Scalars['String']>;
  status: PaymentApprovalDecisionstatusEnumType;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

export type PaymentApprovalDecisionCount = {
  __typename?: 'paymentApprovalDecisionCount';
  count?: Maybe<Scalars['Int']>;
};

export enum PaymentApprovalDecisionstatusEnumType {
  approved = 'approved',
  declined = 'declined',
  pending = 'pending',
  skip = 'skip'
}

export type PaymentCount = {
  __typename?: 'paymentCount';
  count?: Maybe<Scalars['Int']>;
};

export enum PaymentCreateMethodEnum {
  AUTO_DEBIT = 'AUTO_DEBIT',
  AUTO_PAYMENT = 'AUTO_PAYMENT',
  BATCH = 'BATCH',
  JUST_PAY = 'JUST_PAY',
  JUST_PAY_BATCH = 'JUST_PAY_BATCH',
  JUST_PAY_SYNC = 'JUST_PAY_SYNC',
  PAYMENT_FEE = 'PAYMENT_FEE',
  RECURRING = 'RECURRING',
  SINGLE = 'SINGLE',
  SINGLE_SYNC = 'SINGLE_SYNC',
  SUBSCRIPTION_FEE = 'SUBSCRIPTION_FEE',
  SYNC_RECURRING = 'SYNC_RECURRING'
}

export enum PaymentCreateOriginEnum {
  ACCOUNTS_PAYABLE_PLATFORM = 'ACCOUNTS_PAYABLE_PLATFORM',
  AR_INVOICE = 'AR_INVOICE',
  AR_LINK = 'AR_LINK',
  BUILT_PARTNERSHIP = 'BUILT_PARTNERSHIP',
  MERCHANT_CHECKOUT = 'MERCHANT_CHECKOUT',
  NATIVE_ANDROID = 'NATIVE_ANDROID',
  NATIVE_IOS = 'NATIVE_IOS',
  NATIVE_SDK_ANDROID = 'NATIVE_SDK_ANDROID',
  NATIVE_SDK_IOS = 'NATIVE_SDK_IOS',
  PAY = 'PAY',
  QBDT_INTEGRATION = 'QBDT_INTEGRATION',
  QBDT_MAC = 'QBDT_MAC',
  QBDT_WINDOWS = 'QBDT_WINDOWS',
  QBM_ANDROID = 'QBM_ANDROID',
  QBM_INTEGRATION = 'QBM_INTEGRATION',
  QBM_IOS = 'QBM_IOS',
  QBO_INTEGRATION = 'QBO_INTEGRATION',
  QBR_ANDROID = 'QBR_ANDROID',
  QBR_INTEGRATION = 'QBR_INTEGRATION',
  QBR_IOS = 'QBR_IOS',
  REQUEST = 'REQUEST'
}

export enum PaymentDeliveryPreferenceEnum {
  expeditedAch = 'expeditedAch',
  expressCard = 'expressCard',
  expressCheck = 'expressCheck',
  expressDomesticWire = 'expressDomesticWire',
  fastInternational = 'fastInternational',
  fastVc = 'fastVc',
  internalExpressCheck = 'internalExpressCheck',
  overnightAch = 'overnightAch',
  overnightCheck = 'overnightCheck',
  rtp = 'rtp'
}

export type PaymentIntent = {
  __typename?: 'paymentIntent';
  bill?: Maybe<Bill>;
  billId?: Maybe<Scalars['Int']>;
  billPayments?: Maybe<Scalars['SequelizeJSON']>;
  catalogReference?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  createdById?: Maybe<Scalars['Int']>;
  createdByPartner?: Maybe<Partner>;
  createdByPartnerId?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deliveryDate?: Maybe<Scalars['DateTime']>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  deliveryMethodId?: Maybe<Scalars['Int']>;
  deliveryPreference?: Maybe<PaymentIntentdeliveryPreferenceEnumType>;
  financingEligibilityToken?: Maybe<Scalars['String']>;
  financingNumberOfInstallments?: Maybe<Scalars['Int']>;
  financingProviderName?: Maybe<PaymentIntentfinancingProviderNameEnumType>;
  fundingSource?: Maybe<FundingSource>;
  fundingSourceId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  paymentAmount?: Maybe<Scalars['String']>;
  paymentId?: Maybe<Scalars['Int']>;
  paymentRequest?: Maybe<PaymentRequest>;
  paymentRequestId?: Maybe<Scalars['Int']>;
  purpose?: Maybe<Scalars['String']>;
  recoverablePayment?: Maybe<Payment>;
  recoverablePaymentId?: Maybe<Scalars['Int']>;
  requireDepositApproval: Scalars['Boolean'];
  requireWithdrawApproval: Scalars['Boolean'];
  scheduleDate?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userNote?: Maybe<Scalars['String']>;
};

export type PaymentIntentCount = {
  __typename?: 'paymentIntentCount';
  count?: Maybe<Scalars['Int']>;
};

export enum PaymentIntentdeliveryPreferenceEnumType {
  ach = 'ach',
  card = 'card',
  check = 'check',
  domesticWire = 'domesticWire',
  expeditedAch = 'expeditedAch',
  expressCard = 'expressCard',
  expressCheck = 'expressCheck',
  expressDomesticWire = 'expressDomesticWire',
  fastInternational = 'fastInternational',
  fastVc = 'fastVc',
  international = 'international',
  internationalWire = 'internationalWire',
  overnightAch = 'overnightAch',
  overnightCheck = 'overnightCheck',
  rpps = 'rpps',
  rtp = 'rtp',
  virtual = 'virtual',
  virtualCard = 'virtualCard'
}

export enum PaymentIntentfinancingProviderNameEnumType {
  CreditKey = 'CreditKey'
}

export type PaymentLocator = {
  __typename?: 'paymentLocator';
  payments?: Maybe<Array<Maybe<Payment>>>;
  paymentsCount: Scalars['Int'];
};

export type PaymentReceiptFile = {
  __typename?: 'paymentReceiptFile';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  partnerName: Scalars['String'];
  payment?: Maybe<Payment>;
  paymentId: Scalars['Int'];
  receiptId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type PaymentReceiptFileCount = {
  __typename?: 'paymentReceiptFileCount';
  count?: Maybe<Scalars['Int']>;
};

export type PaymentRequest = {
  __typename?: 'paymentRequest';
  accountingPlatformEntity?: Maybe<AccountingPlatformEntity>;
  approvalStatus: PaymentRequestapprovalStatusEnumType;
  bill?: Maybe<Bill>;
  billId?: Maybe<Scalars['Int']>;
  cancelledByCustomerAt?: Maybe<Scalars['DateTime']>;
  contact?: Maybe<Contact>;
  contactId?: Maybe<Scalars['Int']>;
  contactPhone?: Maybe<Scalars['String']>;
  counter: Scalars['Int'];
  createOrigin: PaymentRequestcreateOriginEnumType;
  createdAt: Scalars['DateTime'];
  createdByPartner?: Maybe<Partner>;
  createdByPartnerId?: Maybe<Scalars['Int']>;
  createdByUser?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['Int']>;
  currency: Scalars['String'];
  customerEmail?: Maybe<Scalars['String']>;
  customerName: Scalars['String'];
  customerNote?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  feesPaidBy: PaymentRequestfeesPaidByEnumType;
  files?: Maybe<Array<Maybe<File>>>;
  id: Scalars['Int'];
  invoice?: Maybe<Invoice>;
  invoiceId?: Maybe<Scalars['Int']>;
  invoiceNumber: Scalars['String'];
  invoicePaymentOriginId?: Maybe<Scalars['String']>;
  lastSeen?: Maybe<Scalars['DateTime']>;
  link: Scalars['String'];
  markedAsPaidAt?: Maybe<Scalars['DateTime']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  originId?: Maybe<Scalars['String']>;
  ownerOrganizationId?: Maybe<Scalars['Int']>;
  partnerName?: Maybe<Scalars['String']>;
  paymentId?: Maybe<Scalars['Int']>;
  paymentRequestExternalReference?: Maybe<PaymentRequestExternalReference>;
  publicRef?: Maybe<Scalars['String']>;
  receivablePayment?: Maybe<ReceivablePaymentDetails>;
  receivablePaymentId?: Maybe<Scalars['Int']>;
  sentAt?: Maybe<Scalars['DateTime']>;
  sentFrom?: Maybe<PaymentRequestsentFromEnumType>;
  shouldAttachInvoice?: Maybe<Scalars['Boolean']>;
  status: PaymentRequeststatusEnumType;
  syncActivity?: Maybe<InvoiceSyncActivity>;
  syncMetadata?: Maybe<Array<Maybe<InvoiceSyncMetadata>>>;
  syncType?: Maybe<PaymentRequestsyncTypeEnumType>;
  totalAmount: Scalars['String'];
  totalAmountInCents?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  vendor?: Maybe<Vendor>;
  vendorId: Scalars['Int'];
};

export type PaymentRequestCount = {
  __typename?: 'paymentRequestCount';
  count?: Maybe<Scalars['Int']>;
};

export type PaymentRequestExternalReference = {
  __typename?: 'paymentRequestExternalReference';
  apiKey?: Maybe<ApiKey>;
  apiKeyId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  customerExternalId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  paymentRequest?: Maybe<PaymentRequest>;
  paymentRequestId?: Maybe<Scalars['Int']>;
  referenceId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type PaymentRequestExternalReferenceCount = {
  __typename?: 'paymentRequestExternalReferenceCount';
  count?: Maybe<Scalars['Int']>;
};

export type PaymentRequestOrganizationAssignment = {
  __typename?: 'paymentRequestOrganizationAssignment';
  contact?: Maybe<Contact>;
  contactId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  vendor?: Maybe<Vendor>;
  vendorId?: Maybe<Scalars['Int']>;
};

export type PaymentRequestOrganizationAssignmentCount = {
  __typename?: 'paymentRequestOrganizationAssignmentCount';
  count?: Maybe<Scalars['Int']>;
};

export enum PaymentRequestapprovalStatusEnumType {
  approved = 'approved',
  denied = 'denied',
  pending = 'pending',
  skipped = 'skipped'
}

export enum PaymentRequestcreateOriginEnumType {
  accountReceivable = 'accountReceivable',
  checkoutButton = 'checkoutButton',
  codatIntegration = 'codatIntegration',
  file = 'file',
  melioMe = 'melioMe',
  melioMeExternalApi = 'melioMeExternalApi',
  melioMeGenericLink = 'melioMeGenericLink',
  merchantCheckout = 'merchantCheckout',
  paymentRequest = 'paymentRequest',
  quickbooksOnline = 'quickbooksOnline'
}

export enum PaymentRequestfeesPaidByEnumType {
  payor = 'payor',
  vendor = 'vendor'
}

export enum PaymentRequestsentFromEnumType {
  melioMe = 'melioMe',
  melioOnBehalfPartnerApi = 'melioOnBehalfPartnerApi',
  melioPro = 'melioPro',
  merchantCheckout = 'merchantCheckout',
  partner = 'partner'
}

export enum PaymentRequeststatusEnumType {
  cancelledByCustomer = 'cancelledByCustomer',
  created = 'created',
  fulfilled = 'fulfilled',
  nonPayable = 'nonPayable',
  pending = 'pending'
}

export enum PaymentRequestsyncTypeEnumType {
  AR = 'AR',
  getPaid = 'getPaid'
}

export type PaymentRetries = {
  __typename?: 'paymentRetries';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  originScheduledDate: Scalars['DateTime'];
  originalPayment?: Maybe<DeliveryMethod>;
  originalPaymentId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  paymentId: Scalars['Int'];
  reason: PaymentRetriesreasonEnumType;
  scheduledDate: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type PaymentRetriesCount = {
  __typename?: 'paymentRetriesCount';
  count?: Maybe<Scalars['Int']>;
};

export enum PaymentRetriesreasonEnumType {
  failed_to_collect_no_delivery_yet = 'failed_to_collect_no_delivery_yet',
  failed_to_collect_success_to_deliver = 'failed_to_collect_success_to_deliver',
  failed_to_deliver = 'failed_to_deliver',
  unilateral = 'unilateral'
}

export type PaymentSyncActivity = {
  __typename?: 'paymentSyncActivity';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  direction: PaymentSyncActivitydirectionEnumType;
  errorMessage?: Maybe<Scalars['String']>;
  externalIntegrationType?: Maybe<PaymentSyncActivityexternalIntegrationTypeEnumType>;
  id: Scalars['Int'];
  lastSyncedAt: Scalars['DateTime'];
  partnerName?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  paymentId: Scalars['Int'];
  status: PaymentSyncActivitystatusEnumType;
  updatedAt: Scalars['DateTime'];
};

export type PaymentSyncActivityCount = {
  __typename?: 'paymentSyncActivityCount';
  count?: Maybe<Scalars['Int']>;
};

export enum PaymentSyncActivitydirectionEnumType {
  melio = 'melio',
  qbo = 'qbo'
}

export enum PaymentSyncActivityexternalIntegrationTypeEnumType {
  qbd = 'qbd',
  qbo = 'qbo',
  qboGetPaid = 'qboGetPaid',
  qboPaid = 'qboPaid',
  xerox = 'xerox'
}

export enum PaymentSyncActivitystatusEnumType {
  error = 'error',
  noChange = 'noChange',
  success = 'success'
}

export type PaymentSyncMetadata = {
  __typename?: 'paymentSyncMetadata';
  createRequestId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  externalId?: Maybe<Scalars['String']>;
  externalIntegrationType?: Maybe<PaymentSyncMetadataexternalIntegrationTypeEnumType>;
  externalLastUpdate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  localLastUpdate?: Maybe<Scalars['DateTime']>;
  partnerName?: Maybe<Scalars['String']>;
  paymentId?: Maybe<Scalars['Int']>;
  syncMetadata?: Maybe<Payment>;
  updatedAt: Scalars['DateTime'];
};

export type PaymentSyncMetadataCount = {
  __typename?: 'paymentSyncMetadataCount';
  count?: Maybe<Scalars['Int']>;
};

export enum PaymentSyncMetadataexternalIntegrationTypeEnumType {
  qbd = 'qbd',
  qboGetPaid = 'qboGetPaid',
  xerox = 'xerox'
}

export enum PaymentaccountInitiatedByEnumType {
  AP = 'AP',
  AR = 'AR'
}

export enum PaymentapprovalDecisionStatusEnumType {
  approved = 'approved',
  declined = 'declined',
  pending = 'pending',
  skip = 'skip'
}

export enum PaymentcollectPreferenceEnumType {
  overnightAch = 'overnightAch',
  preScheduledNextDay = 'preScheduledNextDay'
}

export enum PaymentcollectStatusEnumType {
  acknowledged = 'acknowledged',
  blocked = 'blocked',
  cancelAcknowledged = 'cancelAcknowledged',
  cancelCleared = 'cancelCleared',
  cancelFailed = 'cancelFailed',
  cancelInProgress = 'cancelInProgress',
  cancelScheduled = 'cancelScheduled',
  cancelSent = 'cancelSent',
  cancelSettled = 'cancelSettled',
  cleared = 'cleared',
  committed = 'committed',
  failed = 'failed',
  inProgress = 'inProgress',
  invalid = 'invalid',
  retry = 'retry',
  scheduled = 'scheduled',
  sent = 'sent',
  settled = 'settled'
}

export enum PaymentcreateMethodEnumType {
  auto_debit = 'auto_debit',
  auto_payment = 'auto_payment',
  batch = 'batch',
  just_pay = 'just_pay',
  just_pay_batch = 'just_pay_batch',
  just_pay_sync = 'just_pay_sync',
  payment_fee = 'payment_fee',
  recurring = 'recurring',
  single = 'single',
  single_sync = 'single_sync',
  subscription_fee = 'subscription_fee',
  sync_recurring = 'sync_recurring'
}

export enum PaymentcreateOriginEnumType {
  accountsPayablePlatform = 'accountsPayablePlatform',
  arInvoice = 'arInvoice',
  arLink = 'arLink',
  builtPartnership = 'builtPartnership',
  merchantCheckout = 'merchantCheckout',
  nativeAndroid = 'nativeAndroid',
  nativeIos = 'nativeIos',
  nativeSdkAndroid = 'nativeSdkAndroid',
  nativeSdkIos = 'nativeSdkIos',
  pay = 'pay',
  qbdtIntegration = 'qbdtIntegration',
  qbdtMac = 'qbdtMac',
  qbdtWindows = 'qbdtWindows',
  qbmAndroid = 'qbmAndroid',
  qbmIntegration = 'qbmIntegration',
  qbmIos = 'qbmIos',
  qboIntegration = 'qboIntegration',
  qbrAndroid = 'qbrAndroid',
  qbrIntegration = 'qbrIntegration',
  qbrIos = 'qbrIos',
  request = 'request'
}

export enum PaymentdeliverStatusEnumType {
  acknowledged = 'acknowledged',
  blocked = 'blocked',
  cancelAcknowledged = 'cancelAcknowledged',
  cancelCleared = 'cancelCleared',
  cancelFailed = 'cancelFailed',
  cancelInProgress = 'cancelInProgress',
  cancelScheduled = 'cancelScheduled',
  cancelSent = 'cancelSent',
  cancelSettled = 'cancelSettled',
  cleared = 'cleared',
  committed = 'committed',
  failed = 'failed',
  inProgress = 'inProgress',
  invalid = 'invalid',
  retry = 'retry',
  scheduled = 'scheduled',
  sent = 'sent',
  settled = 'settled'
}

export enum PaymentdeliveryPreferenceEnumType {
  expeditedAch = 'expeditedAch',
  expressCard = 'expressCard',
  expressCheck = 'expressCheck',
  expressDomesticWire = 'expressDomesticWire',
  fastInternational = 'fastInternational',
  fastVc = 'fastVc',
  internalExpressCheck = 'internalExpressCheck',
  overnightAch = 'overnightAch',
  overnightCheck = 'overnightCheck',
  rtp = 'rtp'
}

export enum PaymentexpeditedByEnumType {
  payee = 'payee',
  payor = 'payor'
}

export enum PaymentmanualTypeEnumType {
  billPayBalance = 'billPayBalance',
  credits = 'credits',
  externalProcessing = 'externalProcessing',
  historicalPayment = 'historicalPayment',
  markedAsPaid = 'markedAsPaid'
}

export enum PaymentoriginEnumType {
  fiserv = 'fiserv',
  intuit = 'intuit',
  local = 'local',
  quickbooksDesktop = 'quickbooksDesktop'
}

export enum PaymentpayeeApprovalDecisionStatusEnumType {
  approved = 'approved',
  declined = 'declined',
  pending = 'pending',
  skip = 'skip'
}

export enum PaymentpayorTypeEnumType {
  Business = 'Business',
  Consumer = 'Consumer'
}

export enum PaymentproductUseCaseEnumType {
  ap = 'ap',
  ar = 'ar',
  payroll = 'payroll'
}

export type PayorDetails = {
  __typename?: 'payorDetails';
  companyName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type PayorDetailsCount = {
  __typename?: 'payorDetailsCount';
  count?: Maybe<Scalars['Int']>;
};

export type PaypalBalanceAccount = {
  __typename?: 'paypalBalanceAccount';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  id: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type PaypalBalanceAccountCount = {
  __typename?: 'paypalBalanceAccountCount';
  count?: Maybe<Scalars['Int']>;
};

export type PersonalCompletedTasks = {
  __typename?: 'personalCompletedTasks';
  approvedPaymentsNum?: Maybe<Scalars['Int']>;
  declinedPaymentsNum?: Maybe<Scalars['Int']>;
  pendingEscalatedPaymentsNum?: Maybe<Scalars['Int']>;
  pendingUcPaymentsNum?: Maybe<Scalars['Int']>;
  totalCompletedTasks: Scalars['Int'];
};

export type PersonalConcernArea = {
  __typename?: 'personalConcernArea';
  assignedTasks?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  name: Scalars['String'];
  squadId?: Maybe<Scalars['String']>;
};

export type PersonalConcernAreasCompletedTasks = {
  __typename?: 'personalConcernAreasCompletedTasks';
  approvedConcernAreasNum?: Maybe<Scalars['Int']>;
  declinedConcernAreasNum?: Maybe<Scalars['Int']>;
  escalatedConcernAreasNum?: Maybe<Scalars['Int']>;
  pendingConcernAreasNum?: Maybe<Scalars['Int']>;
  totalCompletedConcernAreas: Scalars['Int'];
};

export type PersonalConcernAreasDashboard = {
  __typename?: 'personalConcernAreasDashboard';
  concernAreas?: Maybe<Array<PersonalConcernArea>>;
  personalConcernAreasNum?: Maybe<Scalars['Int']>;
  personalEscalatedNum: Scalars['Int'];
  personalPaymentNum: Scalars['Int'];
  teamConcernAreasNum?: Maybe<Scalars['Int']>;
  teamMembers?: Maybe<Array<Maybe<Scalars['String']>>>;
  teamPaymentsNum: Scalars['Int'];
  totalLivePayments: Scalars['Int'];
};

export type PersonalLabel = {
  __typename?: 'personalLabel';
  assignedTasks: Scalars['Int'];
  color: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type PersonalOrganizationTasks = {
  __typename?: 'personalOrganizationTasks';
  labels: Array<PersonalLabel>;
  personalTasksNum: Scalars['Int'];
  personalUncompletedPaymentsNum: Scalars['Int'];
  teamMembers?: Maybe<Array<Maybe<Scalars['String']>>>;
  teamTasksNum: Scalars['Int'];
  teamUncompletedPaymentsNum: Scalars['Int'];
};

export type PersonalPaymentTasks = {
  __typename?: 'personalPaymentTasks';
  labels: Array<PersonalLabel>;
  personalEscalatedNum: Scalars['Int'];
  personalOrgsNum: Scalars['Int'];
  personalPaymentNum: Scalars['Int'];
  teamMembers?: Maybe<Array<Maybe<Scalars['String']>>>;
  teamOrgsNum: Scalars['Int'];
  teamPaymentsNum: Scalars['Int'];
  totalLivePayments: Scalars['Int'];
};

export type PlaidAccount = {
  __typename?: 'plaidAccount';
  accountId: Scalars['String'];
  balance?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  fundingSource?: Maybe<FundingSource>;
  id: Scalars['Int'];
  microDepositPostingTime?: Maybe<Scalars['DateTime']>;
  partnerName?: Maybe<Scalars['String']>;
  plaidItem?: Maybe<PlaidItem>;
  plaidItemId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  verificationMethod?: Maybe<Scalars['String']>;
  verificationStatus?: Maybe<Scalars['String']>;
};

export type PlaidAccountCount = {
  __typename?: 'plaidAccountCount';
  count?: Maybe<Scalars['Int']>;
};

export type PlaidInstitutionInformation = {
  __typename?: 'plaidInstitutionInformation';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  institutionId: Scalars['String'];
  logo: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type PlaidInstitutionInformationCount = {
  __typename?: 'plaidInstitutionInformationCount';
  count?: Maybe<Scalars['Int']>;
};

export type PlaidItem = {
  __typename?: 'plaidItem';
  accessToken: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  firstSyncErrorAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  institutionId: Scalars['String'];
  institutionName: Scalars['String'];
  itemId: Scalars['String'];
  lastSyncErrorAt?: Maybe<Scalars['DateTime']>;
  lastSyncErrorCode?: Maybe<Scalars['String']>;
  lastSyncErrorMessage?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  originId?: Maybe<Scalars['String']>;
  originMetaUrl?: Maybe<Scalars['String']>;
  originVersion: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  plaidAccounts?: Maybe<Array<Maybe<PlaidAccount>>>;
  plaidItemIdentity?: Maybe<PlaidItemIdentity>;
  removedInPlaid: Scalars['Boolean'];
  transactionSyncCursor?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type PlaidItemCount = {
  __typename?: 'plaidItemCount';
  count?: Maybe<Scalars['Int']>;
};

export type PlaidItemIdentity = {
  __typename?: 'plaidItemIdentity';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  identityData: Scalars['String'];
  partnerName?: Maybe<Scalars['String']>;
  plaidItem?: Maybe<PlaidItem>;
  plaidItemId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type PlaidItemIdentityCount = {
  __typename?: 'plaidItemIdentityCount';
  count?: Maybe<Scalars['Int']>;
};

export type PolicyPermittedEntity = {
  __typename?: 'policyPermittedEntity';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  fundingSource?: Maybe<FundingSource>;
  fundingSourceId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

export type PolicyPermittedEntityCount = {
  __typename?: 'policyPermittedEntityCount';
  count?: Maybe<Scalars['Int']>;
};

export type Promotion = {
  __typename?: 'promotion';
  bill?: Maybe<Bill>;
  billId?: Maybe<Scalars['Int']>;
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  expiration?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  metadata?: Maybe<Scalars['SequelizeJSON']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  partnerName?: Maybe<Scalars['String']>;
  promotions?: Maybe<Array<Maybe<Promotion>>>;
  promotionsTemplate?: Maybe<PromotionsTemplate>;
  promotionsTemplateId?: Maybe<Scalars['Int']>;
  rootPromotion?: Maybe<Scalars['Int']>;
  status: PromotionstatusEnumType;
  updatedAt: Scalars['DateTime'];
};

export type PromotionCount = {
  __typename?: 'promotionCount';
  count?: Maybe<Scalars['Int']>;
};

export type PromotionsTemplate = {
  __typename?: 'promotionsTemplate';
  applicableIn: PromotionsTemplateapplicableInEnumType;
  campaigns?: Maybe<Scalars['SequelizeJSON']>;
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  expiration?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  metadata?: Maybe<Scalars['SequelizeJSON']>;
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type PromotionsTemplateCount = {
  __typename?: 'promotionsTemplateCount';
  count?: Maybe<Scalars['Int']>;
};

export enum PromotionsTemplateapplicableInEnumType {
  SIGNUP = 'SIGNUP',
  SIGNUP_ME = 'SIGNUP_ME'
}

export enum PromotionstatusEnumType {
  expired = 'expired',
  fully_used = 'fully_used',
  partially_used = 'partially_used',
  unused = 'unused'
}

export type PushToDebitConfiguration = {
  __typename?: 'pushToDebitConfiguration';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  vendor?: Maybe<Vendor>;
  vendorId: Scalars['Int'];
};

export type PushToDebitConfigurationCount = {
  __typename?: 'pushToDebitConfigurationCount';
  count?: Maybe<Scalars['Int']>;
};

export type QuickbooksDesktopCompany = {
  __typename?: 'quickbooksDesktopCompany';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  externalOrganizationId: Scalars['String'];
  id: Scalars['Int'];
  lastAuthenticatedAt?: Maybe<Scalars['DateTime']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  passwordHash: Scalars['String'];
  qbdtCompanyName?: Maybe<Scalars['String']>;
  qwcFileId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type QuickbooksDesktopCompanyCount = {
  __typename?: 'quickbooksDesktopCompanyCount';
  count?: Maybe<Scalars['Int']>;
};

export enum RailsDateTypeEnum {
  During = 'During',
  Post = 'Post',
  Pre = 'Pre'
}

export enum RailsTypeEnum {
  CapitalOne = 'CapitalOne',
  CurrencyCloud = 'CurrencyCloud',
  FiservCheckfreeNext = 'FiservCheckfreeNext',
  FiservSmb = 'FiservSmb',
  FiservSmbAr = 'FiservSmbAr',
  Melio = 'Melio',
  Paypal = 'Paypal',
  Wise = 'Wise'
}

export type ReceivableOrganizationMetadata = {
  __typename?: 'receivableOrganizationMetadata';
  achInvoiceLimit?: Maybe<Scalars['Int']>;
  cardInvoiceLimit?: Maybe<Scalars['Int']>;
  companyIdentifier?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  enrollmentStatus: ReceivableOrganizationMetadataenrollmentStatusEnumType;
  fastDeliveryPreferenceType?: Maybe<ReceivableOrganizationMetadatafastDeliveryPreferenceTypeEnumType>;
  id: Scalars['Int'];
  invoiceLimit: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ReceivableOrganizationMetadataCount = {
  __typename?: 'receivableOrganizationMetadataCount';
  count?: Maybe<Scalars['Int']>;
};

export enum ReceivableOrganizationMetadataenrollmentStatusEnumType {
  active = 'active',
  awaitDocument = 'awaitDocument',
  awaitMoreInfo = 'awaitMoreInfo',
  failed = 'failed',
  inactive = 'inactive',
  notSubmitted = 'notSubmitted',
  pending = 'pending'
}

export enum ReceivableOrganizationMetadatafastDeliveryPreferenceTypeEnumType {
  fastAch = 'fastAch',
  rtp = 'rtp'
}

export type ReceivablePaymentAttachment = {
  __typename?: 'receivablePaymentAttachment';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  file?: Maybe<File>;
  fileId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  receivablePayment?: Maybe<ReceivablePaymentDetails>;
  receivablePaymentId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type ReceivablePaymentAttachmentCount = {
  __typename?: 'receivablePaymentAttachmentCount';
  count?: Maybe<Scalars['Int']>;
};

export type ReceivablePaymentDetails = {
  __typename?: 'receivablePaymentDetails';
  amount?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  creationDate?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deprecatePaymentRequest?: Maybe<PaymentRequest>;
  externalId?: Maybe<Scalars['String']>;
  files?: Maybe<Array<Maybe<File>>>;
  id: Scalars['Int'];
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  isExpedited: Scalars['Boolean'];
  maxDeliveryETA?: Maybe<Scalars['DateTime']>;
  method: ReceivablePaymentDetailsmethodEnumType;
  note?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  partnerName?: Maybe<Scalars['String']>;
  paymentRequestId?: Maybe<Scalars['Int']>;
  payorDetails?: Maybe<PayorDetails>;
  payorDetailsId?: Maybe<Scalars['Int']>;
  referenceNumber?: Maybe<Scalars['String']>;
  scheduleDate?: Maybe<Scalars['DateTime']>;
  source: ReceivablePaymentDetailssourceEnumType;
  status?: Maybe<ReceivablePaymentDetailsstatusEnumType>;
  uniqueRefIndex?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['DateTime'];
};

export type ReceivablePaymentDetailsCount = {
  __typename?: 'receivablePaymentDetailsCount';
  count?: Maybe<Scalars['Int']>;
};

export enum ReceivablePaymentDetailsmethodEnumType {
  ach = 'ach',
  card = 'card',
  cash = 'cash',
  check = 'check',
  other = 'other'
}

export enum ReceivablePaymentDetailssourceEnumType {
  manual = 'manual',
  system = 'system'
}

export enum ReceivablePaymentDetailsstatusEnumType {
  completed = 'completed',
  failed = 'failed',
  inProgress = 'inProgress',
  scheduled = 'scheduled'
}

export type RecurringBill = {
  __typename?: 'recurringBill';
  amount: Scalars['String'];
  bills?: Maybe<Array<Maybe<Bill>>>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  frequency: RecurringBillfrequencyEnumType;
  id: Scalars['Int'];
  invoiceNumber?: Maybe<Scalars['String']>;
  notifyOnDecline: Scalars['Boolean'];
  occurrences: Scalars['Int'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  vendor?: Maybe<Vendor>;
  vendorId: Scalars['Int'];
};

export type RecurringBillCount = {
  __typename?: 'recurringBillCount';
  count?: Maybe<Scalars['Int']>;
};

export enum RecurringBillfrequencyEnumType {
  monthly = 'monthly',
  weekly = 'weekly'
}

export type Reminder = {
  __typename?: 'reminder';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  createdById: Scalars['Int'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  remindAt: Scalars['DateTime'];
  status: ReminderstatusEnumType;
  type: RemindertypeEnumType;
  updatedAt: Scalars['DateTime'];
};

export type ReminderCount = {
  __typename?: 'reminderCount';
  count?: Maybe<Scalars['Int']>;
};

export enum ReminderstatusEnumType {
  created = 'created',
  sent = 'sent'
}

export enum RemindertypeEnumType {
  firstBillReminder = 'firstBillReminder'
}

export enum Resource {
  organization = 'organization',
  payment = 'payment',
  vendor = 'vendor'
}

export type RiskDecisionCode = {
  __typename?: 'riskDecisionCode';
  canUseManually: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  decision: RiskDecisionCodedecisionEnumType;
  id: Scalars['Int'];
  paymentApprovalActions?: Maybe<Array<Maybe<PaymentApprovalAction>>>;
  reason: Scalars['String'];
  subcategory: RiskDecisionCodesubcategoryEnumType;
  updatedAt: Scalars['DateTime'];
};

export type RiskDecisionCodeCount = {
  __typename?: 'riskDecisionCodeCount';
  count?: Maybe<Scalars['Int']>;
};

export enum RiskDecisionCodedecisionEnumType {
  approved = 'approved',
  declined = 'declined',
  pending = 'pending'
}

export enum RiskDecisionCodesubcategoryEnumType {
  abuse = 'abuse',
  compliance = 'compliance',
  fraud = 'fraud',
  notApplicable = 'notApplicable',
  policy = 'policy',
  technical = 'technical'
}

export type RiskEngineDecision = {
  __typename?: 'riskEngineDecision';
  createdAt: Scalars['DateTime'];
  decision: RiskEngineDecisiondecisionEnumType;
  deletedAt?: Maybe<Scalars['DateTime']>;
  executionUUID: Scalars['String'];
  gitRevision?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  mode?: Maybe<RiskEngineDecisionmodeEnumType>;
  modelResult: Scalars['SequelizeJSON'];
  modelVersion: Scalars['String'];
  partnerName?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  paymentApprovalAction?: Maybe<PaymentApprovalAction>;
  paymentId: Scalars['Int'];
  riskEngineDecisionMetadata?: Maybe<RiskEngineDecisionMetadata>;
  trigger: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type RiskEngineDecisionCount = {
  __typename?: 'riskEngineDecisionCount';
  count?: Maybe<Scalars['Int']>;
};

export type RiskEngineDecisionMetadata = {
  __typename?: 'riskEngineDecisionMetadata';
  accountNumber?: Maybe<Scalars['String']>;
  bankAccount?: Maybe<BankAccount>;
  bankAccountId?: Maybe<Scalars['Int']>;
  card4digits?: Maybe<Scalars['String']>;
  cardAccount?: Maybe<CardAccount>;
  cardAccountId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  deliveryMethodId: Scalars['Int'];
  deliveryType: RiskEngineDecisionMetadatadeliveryTypeEnumType;
  id: Scalars['Int'];
  internationalAccount?: Maybe<InternationalAccount>;
  internationalAccountId?: Maybe<Scalars['Int']>;
  paperCheck?: Maybe<PaperCheck>;
  paperCheckId?: Maybe<Scalars['Int']>;
  partnerName?: Maybe<Scalars['String']>;
  payeeBankIban?: Maybe<Scalars['String']>;
  riskEngineDecision?: Maybe<RiskEngineDecision>;
  riskEngineDecisionId: Scalars['Int'];
  routingNumber?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  zipCode?: Maybe<Scalars['String']>;
};

export type RiskEngineDecisionMetadataCount = {
  __typename?: 'riskEngineDecisionMetadataCount';
  count?: Maybe<Scalars['Int']>;
};

export enum RiskEngineDecisionMetadatadeliveryTypeEnumType {
  ach = 'ach',
  card = 'card',
  check = 'check',
  cryptoUsd = 'cryptoUsd',
  domesticWire = 'domesticWire',
  international = 'international',
  internationalWire = 'internationalWire',
  managed = 'managed',
  paypalBalance = 'paypalBalance',
  rpps = 'rpps',
  virtual = 'virtual',
  virtualCard = 'virtualCard'
}

export enum RiskEngineDecisiondecisionEnumType {
  approved = 'approved',
  declined = 'declined',
  pending = 'pending'
}

export enum RiskEngineDecisionmodeEnumType {
  live = 'live',
  shadow = 'shadow'
}

export type RppsAccount = {
  __typename?: 'rppsAccount';
  accountNumber: Scalars['String'];
  biller?: Maybe<Biller>;
  billerId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  id: Scalars['Int'];
  mask: Scalars['String'];
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type RppsAccountCount = {
  __typename?: 'rppsAccountCount';
  count?: Maybe<Scalars['Int']>;
};

export type Rules = {
  __typename?: 'rules';
  _id: Scalars['MongoID'];
  conditions?: Maybe<Scalars['JSON']>;
  createdAt?: Maybe<Scalars['Date']>;
  decision?: Maybe<Scalars['JSON']>;
  deletedAt?: Maybe<Scalars['Date']>;
  editedVia?: Maybe<Scalars['String']>;
  entityType?: Maybe<Scalars['String']>;
  labelIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  lastEditedBy?: Maybe<Scalars['String']>;
  limitations?: Maybe<Scalars['JSON']>;
  mos?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  name?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  riskDecisionCodeId?: Maybe<Scalars['Int']>;
  ruleId?: Maybe<Scalars['Float']>;
  ruleVersion?: Maybe<Scalars['String']>;
  subcategory?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  version?: Maybe<Scalars['Float']>;
};

export type SanctionDecision = {
  __typename?: 'sanctionDecision';
  id?: Maybe<Scalars['Int']>;
};

export type SanctionScreeningDecision = {
  __typename?: 'sanctionScreeningDecision';
  addressDecision: SanctionScreeningDecisionaddressDecisionEnumType;
  createdAt: Scalars['DateTime'];
  decision: SanctionScreeningDecisiondecisionEnumType;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id: Scalars['Int'];
  isCompliant: Scalars['Boolean'];
  nameDecision: SanctionScreeningDecisionnameDecisionEnumType;
  partnerName?: Maybe<Scalars['String']>;
  sanctionScreeningItem?: Maybe<SanctionScreeningItem>;
  sanctionScreeningItemId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type SanctionScreeningDecisionCount = {
  __typename?: 'sanctionScreeningDecisionCount';
  count?: Maybe<Scalars['Int']>;
};

export enum SanctionScreeningDecisionaddressDecisionEnumType {
  AddressMatch = 'AddressMatch',
  AddressMismatch = 'AddressMismatch',
  AddressMissing = 'AddressMissing',
  GeoMatch = 'GeoMatch',
  GeoMismatch = 'GeoMismatch'
}

export enum SanctionScreeningDecisiondecisionEnumType {
  FalsePositive = 'FalsePositive',
  TrueHit = 'TrueHit'
}

export enum SanctionScreeningDecisionnameDecisionEnumType {
  FullMatch = 'FullMatch',
  FullMismatch = 'FullMismatch',
  FuzzyMatch = 'FuzzyMatch',
  FuzzyMismatch = 'FuzzyMismatch'
}

export type SanctionScreeningItem = {
  __typename?: 'sanctionScreeningItem';
  attribute?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  expirationReason?: Maybe<SanctionScreeningItemexpirationReasonEnumType>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  listName: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  partnerName?: Maybe<Scalars['String']>;
  sanctionScreeningDecisions?: Maybe<Array<Maybe<SanctionScreeningDecision>>>;
  score: Scalars['Int'];
  ubo?: Maybe<OrganizationUltimateBeneficialOwner>;
  uboId?: Maybe<Scalars['Int']>;
  uidInList: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  values?: Maybe<Scalars['SequelizeJSON']>;
  vendor?: Maybe<Vendor>;
  vendorId?: Maybe<Scalars['Int']>;
};

export type SanctionScreeningItemCount = {
  __typename?: 'sanctionScreeningItemCount';
  count?: Maybe<Scalars['Int']>;
};

export enum SanctionScreeningItemexpirationReasonEnumType {
  RemovedFromList = 'RemovedFromList',
  ScoreWasUpdated = 'ScoreWasUpdated'
}

export type SbbFiservUserMapping = {
  __typename?: 'sbbFiservUserMapping';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  hasMigrated: Scalars['Boolean'];
  id: Scalars['Int'];
  numberOfOrganizations?: Maybe<Scalars['Int']>;
  partnerName?: Maybe<Scalars['String']>;
  sbbId: Scalars['String'];
  subscriberId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type SbbFiservUserMappingCount = {
  __typename?: 'sbbFiservUserMappingCount';
  count?: Maybe<Scalars['Int']>;
};

export type SbcCardDetails = {
  __typename?: 'sbcCardDetails';
  availableSpendBalance: Scalars['String'];
  cardAccount?: Maybe<CardAccount>;
  cardAccountId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  isChargeCard: Scalars['Boolean'];
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type SbcCardDetailsCount = {
  __typename?: 'sbcCardDetailsCount';
  count?: Maybe<Scalars['Int']>;
};

export type ScannedInvoice = {
  __typename?: 'scannedInvoice';
  amount?: Maybe<Scalars['String']>;
  bill?: Maybe<Bill>;
  billId?: Maybe<Scalars['Int']>;
  createOrigin?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  file?: Maybe<File>;
  fileId: Scalars['Int'];
  id: Scalars['Int'];
  inboxEmail?: Maybe<InboxEmail>;
  inboxEmailId?: Maybe<Scalars['Int']>;
  invoiceDate?: Maybe<Scalars['DateTime']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  ocrServiceName: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  parsedData: Scalars['SequelizeJSON'];
  partnerIntegrationId?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  scannedInvoiceLineItems?: Maybe<Array<Maybe<ScannedInvoiceLineItem>>>;
  updatedAt: Scalars['DateTime'];
  vendor?: Maybe<Vendor>;
  vendorId?: Maybe<Scalars['Int']>;
  vendorName?: Maybe<Scalars['String']>;
};

export type ScannedInvoiceCount = {
  __typename?: 'scannedInvoiceCount';
  count?: Maybe<Scalars['Int']>;
};

export type ScannedInvoiceLineItem = {
  __typename?: 'scannedInvoiceLineItem';
  amount?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  externalCategoryId?: Maybe<Scalars['String']>;
  externalItemId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  partnerIntegrationId?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['String']>;
  scannedInvoice?: Maybe<ScannedInvoice>;
  scannedInvoiceId: Scalars['Int'];
  type?: Maybe<ScannedInvoiceLineItemtypeEnumType>;
  unitPrice?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type ScannedInvoiceLineItemCount = {
  __typename?: 'scannedInvoiceLineItemCount';
  count?: Maybe<Scalars['Int']>;
};

export enum ScannedInvoiceLineItemtypeEnumType {
  category = 'category',
  item = 'item'
}

export type SelfServeRefund = {
  __typename?: 'selfServeRefund';
  createdAt: Scalars['DateTime'];
  createdById: Scalars['Int'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  paymentId: Scalars['Int'];
  reason: SelfServeRefundreasonEnumType;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
};

export type SelfServeRefundCount = {
  __typename?: 'selfServeRefundCount';
  count?: Maybe<Scalars['Int']>;
};

export enum SelfServeRefundreasonEnumType {
  goodsServicesIssues = 'goodsServicesIssues',
  incorrectPaymentAmount = 'incorrectPaymentAmount',
  incorrectVendorDetails = 'incorrectVendorDetails',
  other = 'other',
  paidViaAnotherProvider = 'paidViaAnotherProvider',
  paymentIssues = 'paymentIssues',
  switchingPaymentMethod = 'switchingPaymentMethod'
}

export type ServiceChargeCatalog = {
  __typename?: 'serviceChargeCatalog';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  type: ServiceChargeCatalogtypeEnumType;
  updatedAt: Scalars['DateTime'];
  value: Scalars['String'];
};

export type ServiceChargeCatalogCount = {
  __typename?: 'serviceChargeCatalogCount';
  count?: Maybe<Scalars['Int']>;
};

export enum ServiceChargeCatalogtypeEnumType {
  amount = 'amount',
  percentage = 'percentage'
}

export type SherlockUser = {
  __typename?: 'sherlockUser';
  _id: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  email: Scalars['String'];
  favoriteModules?: Maybe<Array<Maybe<Scalars['String']>>>;
  lastLoginAt?: Maybe<Scalars['Date']>;
  name: Scalars['String'];
  picture?: Maybe<Scalars['String']>;
  role?: Maybe<Role>;
  roles?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  rolesList?: Maybe<Array<Maybe<Role>>>;
  squads?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  squadsList?: Maybe<Array<Maybe<Squad>>>;
  status: EnumsherlockUserStatus;
  updatedAt?: Maybe<Scalars['Date']>;
  xeroEmail?: Maybe<Scalars['String']>;
};

/** A connection to a list of items. */
export type SherlockUserConnection = {
  __typename?: 'sherlockUserConnection';
  /** Total object count. */
  count: Scalars['Int'];
  /** Information to aid in pagination. */
  edges: Array<SherlockUserEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SherlockUserEdge = {
  __typename?: 'sherlockUserEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: SherlockUser;
};

/** List of items with pagination. */
export type SherlockUserPagination = {
  __typename?: 'sherlockUserPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<SherlockUser>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ShiftVirtualCardToAchPaymentCredentials = {
  __typename?: 'shiftVirtualCardToACHPaymentCredentials';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  isVCDetailsWasShown: Scalars['Boolean'];
  partnerName?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  paymentId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type ShiftVirtualCardToAchPaymentCredentialsCount = {
  __typename?: 'shiftVirtualCardToACHPaymentCredentialsCount';
  count?: Maybe<Scalars['Int']>;
};

export type ShopifyShop = {
  __typename?: 'shopifyShop';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  domain: Scalars['String'];
  id: Scalars['Int'];
  installationStatus: ShopifyShopinstallationStatusEnumType;
  installedAt: Scalars['DateTime'];
  myshopifyDomain: Scalars['String'];
  offlineAccessToken: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  partnerName: Scalars['String'];
  shopifyData: Scalars['String'];
  shopifyId: Scalars['String'];
  status: ShopifyShopstatusEnumType;
  stockyApiKey?: Maybe<ShopifyStockyApiKey>;
  uninstalledAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};

export type ShopifyShopCount = {
  __typename?: 'shopifyShopCount';
  count?: Maybe<Scalars['Int']>;
};

export enum ShopifyShopinstallationStatusEnumType {
  installed = 'installed',
  uninstalled = 'uninstalled'
}

export enum ShopifyShopstatusEnumType {
  active = 'active',
  blocked = 'blocked'
}

export type ShopifyStockyApiKey = {
  __typename?: 'shopifyStockyApiKey';
  apiKey: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  myshopifyDomain: Scalars['String'];
  partnerName: Scalars['String'];
  shopifyShop?: Maybe<ShopifyShop>;
  shopifyShopId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type ShopifyStockyApiKeyCount = {
  __typename?: 'shopifyStockyApiKeyCount';
  count?: Maybe<Scalars['Int']>;
};

export type Statistics = {
  __typename?: 'statistics';
  firstCompletedPaymentDate?: Maybe<Scalars['DateTime']>;
  grossProfit?: Maybe<GrossProfit>;
  lastCompletedPaymentDate?: Maybe<Scalars['DateTime']>;
  losses?: Maybe<Losses>;
  tpvCompleted?: Maybe<TpvCompleted>;
};

export type StatisticsLoss = {
  __typename?: 'statisticsLoss';
  count: Scalars['Float'];
  sum: Scalars['Float'];
};

export type SubIndustry = {
  __typename?: 'subIndustry';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  industry?: Maybe<Industry>;
  industryId: Scalars['Int'];
  name: Scalars['String'];
  organizations?: Maybe<Array<Maybe<Organization>>>;
  updatedAt: Scalars['DateTime'];
};

export type SubIndustryCount = {
  __typename?: 'subIndustryCount';
  count?: Maybe<Scalars['Int']>;
};

export type SuggestedBiller = {
  __typename?: 'suggestedBiller';
  companyName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  icon: Scalars['String'];
  id: Scalars['Int'];
  industryId?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  state?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type SuggestedBillerCount = {
  __typename?: 'suggestedBillerCount';
  count?: Maybe<Scalars['Int']>;
};

export type SyncActivity = {
  __typename?: 'syncActivity';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  lastSyncedAt: Scalars['DateTime'];
  organizationId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  providerName: SyncActivityproviderNameEnumType;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['Int'];
};

export type SyncActivityCount = {
  __typename?: 'syncActivityCount';
  count?: Maybe<Scalars['Int']>;
};

export enum SyncActivityproviderNameEnumType {
  capital_one_sbb = 'capital_one_sbb',
  fiserv_checkfree = 'fiserv_checkfree',
  fiserv_smb = 'fiserv_smb',
  shopify_stocky = 'shopify_stocky',
  standard = 'standard'
}

export type SyncExternalFailedObject = {
  __typename?: 'syncExternalFailedObject';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  entityType: Scalars['String'];
  errorMessage: Scalars['String'];
  externalId: Scalars['String'];
  externalIntegrationType: Scalars['String'];
  externalOrganizationId: Scalars['String'];
  id: Scalars['Int'];
  organizationId?: Maybe<Scalars['Int']>;
  partnerName?: Maybe<Scalars['String']>;
  syncActivity?: Maybe<Organization>;
  updatedAt: Scalars['DateTime'];
};

export type SyncExternalFailedObjectCount = {
  __typename?: 'syncExternalFailedObjectCount';
  count?: Maybe<Scalars['Int']>;
};

export type TaskTotalCount = {
  __typename?: 'taskTotalCount';
  assigned?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type TaxRate = {
  __typename?: 'taxRate';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  isDefault?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  rate: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
};

export type TaxRateCount = {
  __typename?: 'taxRateCount';
  count?: Maybe<Scalars['Int']>;
};

export type TaxpayerIdentificationRequest = {
  __typename?: 'taxpayerIdentificationRequest';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  createdById: Scalars['Int'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailsSentCount: Scalars['Int'];
  id: Scalars['Int'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  status: TaxpayerIdentificationRequeststatusEnumType;
  updatedAt: Scalars['DateTime'];
  vendor?: Maybe<Vendor>;
  vendorId: Scalars['Int'];
};

export type TaxpayerIdentificationRequestCount = {
  __typename?: 'taxpayerIdentificationRequestCount';
  count?: Maybe<Scalars['Int']>;
};

export enum TaxpayerIdentificationRequeststatusEnumType {
  canceled = 'canceled',
  completed = 'completed',
  pending = 'pending'
}

export type TaxpayerInfo = {
  __typename?: 'taxpayerInfo';
  accountNumber?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['SequelizeJSON']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  businessType?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  createdById: Scalars['Int'];
  createdByType: TaxpayerInfocreatedByTypeEnumType;
  deletedAt?: Maybe<Scalars['DateTime']>;
  file?: Maybe<File>;
  fileId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  partnerName: Scalars['String'];
  processMetadata?: Maybe<Scalars['SequelizeJSON']>;
  signature: Scalars['Boolean'];
  signatureDate?: Maybe<Scalars['DateTime']>;
  taxId?: Maybe<Scalars['String']>;
  taxIdType?: Maybe<TaxpayerInfotaxIdTypeEnumType>;
  taxIdVerified: Scalars['Boolean'];
  taxpayerIdentificationRequest?: Maybe<TaxpayerIdentificationRequest>;
  taxpayerIdentificationRequestId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  vendor?: Maybe<Vendor>;
  vendorId: Scalars['Int'];
};

export type TaxpayerInfoCount = {
  __typename?: 'taxpayerInfoCount';
  count?: Maybe<Scalars['Int']>;
};

export enum TaxpayerInfocreatedByTypeEnumType {
  payor = 'payor',
  vendor = 'vendor'
}

export enum TaxpayerInfotaxIdTypeEnumType {
  ein = 'ein',
  ssn = 'ssn'
}

export type Todo = {
  __typename?: 'todo';
  bill?: Maybe<Bill>;
  billId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  dismissActions?: Maybe<Array<Maybe<TodoAction>>>;
  id: Scalars['Int'];
  invoice?: Maybe<Invoice>;
  invoiceId?: Maybe<Scalars['Int']>;
  metadata?: Maybe<Scalars['SequelizeJSON']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  partnerName: Scalars['String'];
  payment?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['Int']>;
  paymentRequest?: Maybe<PaymentRequest>;
  paymentRequestId?: Maybe<Scalars['Int']>;
  receivablePaymentDetail?: Maybe<ReceivablePaymentDetails>;
  receivablePaymentDetailId?: Maybe<Scalars['Int']>;
  scannedInvoice?: Maybe<ScannedInvoice>;
  scannedInvoiceId?: Maybe<Scalars['Int']>;
  todoActions?: Maybe<Array<Maybe<TodoAction>>>;
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']>;
  viewActions?: Maybe<Array<Maybe<TodoAction>>>;
};

export type TodoAction = {
  __typename?: 'todoAction';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  organizationId?: Maybe<Scalars['Int']>;
  partnerName: Scalars['String'];
  todo?: Maybe<Todo>;
  todoId: Scalars['Int'];
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['Int']>;
};

export type TodoActionCount = {
  __typename?: 'todoActionCount';
  count?: Maybe<Scalars['Int']>;
};

export type TodoCount = {
  __typename?: 'todoCount';
  count?: Maybe<Scalars['Int']>;
};

export type TpvCompleted = {
  __typename?: 'tpvCompleted';
  apSum?: Maybe<Scalars['Float']>;
  arSum?: Maybe<Scalars['Float']>;
  sumTotal?: Maybe<Scalars['Float']>;
  totalCompletedPaymentsCount?: Maybe<Scalars['Int']>;
};

export type Transaction = {
  __typename?: 'transaction';
  amount: Scalars['String'];
  checkSerialNumber?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  currency: Scalars['String'];
  destination: TransactiondestinationEnumType;
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  idempotentId?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  partnerName?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  paymentId: Scalars['Int'];
  rawData?: Maybe<Scalars['SequelizeJSON']>;
  source?: Maybe<TransactionsourceEnumType>;
  sourceLink?: Maybe<Scalars['String']>;
  status?: Maybe<TransactionstatusEnumType>;
  transactionDirection: TransactiontransactionDirectionEnumType;
  transactionType: TransactiontransactionTypeEnumType;
  transferId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  vendor?: Maybe<Vendor>;
  vendorId?: Maybe<Scalars['Int']>;
};

export type TransactionCount = {
  __typename?: 'transactionCount';
  count?: Maybe<Scalars['Int']>;
};

export enum TransactiondestinationEnumType {
  fboCreditKey = 'fboCreditKey',
  fboCurrencyCloud = 'fboCurrencyCloud',
  fboEvolve = 'fboEvolve',
  fboJpm = 'fboJpm',
  fboSvb = 'fboSvb',
  msbCreditKey = 'msbCreditKey',
  msbEvolve = 'msbEvolve',
  msbJpm = 'msbJpm',
  msbSvb = 'msbSvb',
  organization = 'organization',
  vendor = 'vendor'
}

export type TransactionsData = {
  __typename?: 'transactionsData';
  amountFX?: Maybe<Scalars['Float']>;
  amountFXCurrency?: Maybe<Scalars['String']>;
  amountUsd?: Maybe<Scalars['Float']>;
  bill?: Maybe<Bill>;
  billNote?: Maybe<Scalars['String']>;
  card4Digits?: Maybe<Scalars['String']>;
  cardAddress?: Maybe<Scalars['String']>;
  cardBin?: Maybe<Scalars['String']>;
  cardFirstName?: Maybe<Scalars['String']>;
  cardLastName?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  cardZip?: Maybe<Scalars['String']>;
  checkAddressLine1?: Maybe<Scalars['String']>;
  checkAddressLine2?: Maybe<Scalars['String']>;
  checkAddressLng?: Maybe<Scalars['String']>;
  checkAptNumber?: Maybe<Scalars['String']>;
  checkCity?: Maybe<Scalars['String']>;
  checkPrintname?: Maybe<Scalars['String']>;
  checkState?: Maybe<Scalars['String']>;
  checkZipcode?: Maybe<Scalars['String']>;
  createOrigin?: Maybe<PaymentCreateOriginEnum>;
  createdByEmail?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['Date']>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  deliveryPreference?: Maybe<PaymentDeliveryPreferenceEnum>;
  direction?: Maybe<Scalars['String']>;
  dmAccount?: Maybe<Scalars['String']>;
  dmId?: Maybe<Scalars['Int']>;
  dmRouting?: Maybe<Scalars['String']>;
  dmType?: Maybe<Scalars['String']>;
  fsAccount?: Maybe<Scalars['String']>;
  fsId?: Maybe<Scalars['Int']>;
  fsRouting?: Maybe<Scalars['String']>;
  fsType?: Maybe<Scalars['String']>;
  fundingSource?: Maybe<FundingSource>;
  isApiPartner?: Maybe<Scalars['Boolean']>;
  manual?: Maybe<Scalars['Boolean']>;
  network?: Maybe<Scalars['String']>;
  partnerCompanyName?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  paymentCreatedAt?: Maybe<Scalars['Date']>;
  paymentId?: Maybe<Scalars['Int']>;
  paymentIpCity?: Maybe<Scalars['String']>;
  paymentIpState?: Maybe<Scalars['String']>;
  paymentNote?: Maybe<Scalars['String']>;
  payorCompanyName?: Maybe<Scalars['String']>;
  payorId?: Maybe<Scalars['Int']>;
  rails?: Maybe<RailsTypeEnum>;
  riskDecisionFeatures?: Maybe<Scalars['SequelizeJSON']>;
  riskDecisionReason?: Maybe<Scalars['String']>;
  riskStatus?: Maybe<PaymentriskStatusEnumType>;
  scheduleDate?: Maybe<Scalars['Date']>;
  status?: Maybe<Scalars['String']>;
  transactionType?: Maybe<PaymentCreateMethodEnum>;
  vendorBankAccountNumber?: Maybe<Scalars['String']>;
  vendorBankCountry?: Maybe<Scalars['String']>;
  vendorBankIban?: Maybe<Scalars['String']>;
  vendorBankbicSwift?: Maybe<Scalars['String']>;
  vendorCity?: Maybe<Scalars['String']>;
  vendorContact?: Maybe<Scalars['String']>;
  vendorCountry?: Maybe<Scalars['String']>;
  vendorEmail?: Maybe<Scalars['String']>;
  vendorHasHandle?: Maybe<Scalars['Boolean']>;
  vendorId?: Maybe<Scalars['String']>;
  vendorName?: Maybe<Scalars['String']>;
  vendorPhone?: Maybe<Scalars['String']>;
  virtualCardCard4Digit?: Maybe<Scalars['String']>;
  virtualCardCvv?: Maybe<Scalars['String']>;
};

export enum TransactionsourceEnumType {
  chase = 'chase',
  currencyCloud = 'currencyCloud',
  evolve = 'evolve',
  fiserv = 'fiserv',
  jpm = 'jpm',
  manual = 'manual',
  svb = 'svb',
  system = 'system',
  tabaPay = 'tabaPay'
}

export enum TransactionstatusEnumType {
  ACKNOWLEDGED = 'ACKNOWLEDGED',
  AUTHORIZATION = 'AUTHORIZATION',
  BLOCKED = 'BLOCKED',
  CANCEL = 'CANCEL',
  CANCELACKNOWLEDGED = 'CANCELACKNOWLEDGED',
  CANCELCLEARED = 'CANCELCLEARED',
  CANCELED = 'CANCELED',
  CANCELFAILED = 'CANCELFAILED',
  CANCELINPROGRESS = 'CANCELINPROGRESS',
  CANCELSCHEDULED = 'CANCELSCHEDULED',
  CANCELSENT = 'CANCELSENT',
  CANCELSETTLED = 'CANCELSETTLED',
  CHARGE_READY = 'CHARGE_READY',
  CLEARED = 'CLEARED',
  COMMITTED = 'COMMITTED',
  COMPLETED = 'COMPLETED',
  ERROR = 'ERROR',
  FAILED = 'FAILED',
  INPROGRESS = 'INPROGRESS',
  INVALID = 'INVALID',
  NOTIFICATION_OF_CHANGE = 'NOTIFICATION_OF_CHANGE',
  RETRY = 'RETRY',
  SCHEDULED = 'SCHEDULED',
  SENT = 'SENT',
  SETTLED = 'SETTLED',
  SYSTEM = 'SYSTEM',
  UNBLOCKED = 'UNBLOCKED',
  UNKNOWN = 'UNKNOWN'
}

export enum TransactiontransactionDirectionEnumType {
  credit = 'credit',
  debit = 'debit'
}

export enum TransactiontransactionTypeEnumType {
  ach = 'ach',
  audit = 'audit',
  card = 'card',
  check = 'check',
  domesticWire = 'domesticWire',
  international = 'international',
  routing = 'routing',
  rpps = 'rpps',
  unilateral = 'unilateral',
  virtualCard = 'virtualCard'
}

export type UnilateralRequest = {
  __typename?: 'unilateralRequest';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailsSentCount: Scalars['Int'];
  flow: UnilateralRequestflowEnumType;
  id: Scalars['Int'];
  originalDeliveryMethodId?: Maybe<Scalars['Int']>;
  partnerName?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['Int']>;
  selectedDeliveryMethodId?: Maybe<Scalars['Int']>;
  status: UnilateralRequeststatusEnumType;
  updatedAt: Scalars['DateTime'];
  vendor?: Maybe<Vendor>;
  vendorId: Scalars['Int'];
};

export type UnilateralRequestCount = {
  __typename?: 'unilateralRequestCount';
  count?: Maybe<Scalars['Int']>;
};

export enum UnilateralRequestflowEnumType {
  expiredVirtualCard = 'expiredVirtualCard',
  failedToCollect = 'failedToCollect',
  failedToDeliver = 'failedToDeliver',
  paymentScheduled = 'paymentScheduled',
  vendorTab = 'vendorTab'
}

export enum UnilateralRequeststatusEnumType {
  completed = 'completed',
  created = 'created',
  sent = 'sent'
}

export type UpdateOperationSuccessType = {
  __typename?: 'updateOperationSuccessType';
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateOrgTypeType = {
  __typename?: 'updateOrgTypeType';
  manual: Scalars['Boolean'];
  success?: Maybe<Scalars['Boolean']>;
};

export type User = {
  __typename?: 'user';
  accessLevel?: Maybe<Scalars['String']>;
  actionLogs?: Maybe<Array<Maybe<ActionLog>>>;
  agreementSignatures?: Maybe<Array<Maybe<AgreementSignature>>>;
  approvalAmountThreshold?: Maybe<Scalars['Float']>;
  approvalWorkflows?: Maybe<Array<Maybe<ApprovalWorkflow>>>;
  bills?: Maybe<Array<Maybe<Bill>>>;
  canApprovePayments?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  createdByPartner?: Maybe<Partner>;
  createdByPartnerId?: Maybe<Scalars['Int']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deliveryMethods?: Maybe<Array<Maybe<DeliveryMethod>>>;
  ekata?: Maybe<Scalars['SequelizeJSON']>;
  email: Scalars['String'];
  emailVerificationToken?: Maybe<Scalars['String']>;
  emailVerified: Scalars['Boolean'];
  emailage?: Maybe<Scalars['SequelizeJSON']>;
  externalUserId?: Maybe<Scalars['String']>;
  features?: Maybe<UserFeatures>;
  files?: Maybe<Array<Maybe<File>>>;
  firstName?: Maybe<Scalars['String']>;
  fundingSources?: Maybe<Array<Maybe<FundingSource>>>;
  hasActiveLimitations?: Maybe<Scalars['Boolean']>;
  hasPendingApprovalPayments?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  intuitAccessToken?: Maybe<Scalars['String']>;
  intuitId?: Maybe<Scalars['String']>;
  intuitRealmId?: Maybe<Scalars['String']>;
  intuitRefreshToken?: Maybe<Scalars['String']>;
  intuitValidGrant: Scalars['Boolean'];
  isGuest: Scalars['Boolean'];
  joinOrganizationRequests?: Maybe<Array<Maybe<JoinOrganizationRequest>>>;
  lastName?: Maybe<Scalars['String']>;
  loginToken?: Maybe<Array<Maybe<UserLoginToken>>>;
  marketingTam?: Maybe<Scalars['String']>;
  marketingUtms?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  normalizedEmails?: Maybe<Array<Maybe<NormalizedEmail>>>;
  notificationPreferences?: Maybe<Array<Maybe<NotificationPreference>>>;
  organizations?: Maybe<Array<Maybe<Organization>>>;
  partner?: Maybe<Partner>;
  partnerIntegrationId?: Maybe<Scalars['String']>;
  partnerName: Scalars['String'];
  password?: Maybe<Scalars['String']>;
  paymentApprovalDecisions?: Maybe<Array<Maybe<PaymentApprovalDecision>>>;
  paymentCreators?: Maybe<Array<Maybe<Payment>>>;
  paymentCreatorsCount?: Maybe<Scalars['Int']>;
  paymentIntents?: Maybe<Array<Maybe<PaymentIntent>>>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  permission?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  prohibitedIndustriesData?: Maybe<UserProhibitedIndustriesData>;
  promo?: Maybe<Scalars['String']>;
  registrationFlow: UserregistrationFlowEnumType;
  registrationIp?: Maybe<Scalars['String']>;
  registrationOrigin: Scalars['String'];
  requireApproval?: Maybe<Scalars['Boolean']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  subscriptions?: Maybe<Array<Maybe<BillSubscription>>>;
  syncActivityMigrationStatus?: Maybe<RailsDateTypeEnum>;
  tags?: Maybe<Array<Maybe<EntityTag>>>;
  uniqueId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userEmailLogs?: Maybe<Array<Maybe<UserEmailLog>>>;
  userIntuitCredentials?: Maybe<Array<Maybe<UserIntuitCredential>>>;
  userOAuthCredentials?: Maybe<Array<Maybe<UserOAuthCredential>>>;
  userOrganizationLinking?: Maybe<Array<Maybe<UserOrganization>>>;
  userOrganizations?: Maybe<Array<Maybe<UserOrganization>>>;
  userPreferences?: Maybe<Array<Maybe<UserPreference>>>;
  userQuickbooksCredentials?: Maybe<Array<Maybe<UserQuickbooksCredential>>>;
  userToNormalizedEmails?: Maybe<Array<Maybe<UserToNormalizedEmail>>>;
};


export type UserPaymentCreatorsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type UserPaymentCreatorsCountArgs = {
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type UserUserOrganizationLinkingArgs = {
  orgIdToSkip?: InputMaybe<Scalars['Int']>;
};

export type UserCount = {
  __typename?: 'userCount';
  count?: Maybe<Scalars['Int']>;
};

export type UserEmailLog = {
  __typename?: 'userEmailLog';
  createdAt: Scalars['DateTime'];
  emailType: Scalars['String'];
  id: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  relatedId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

export type UserEmailLogCount = {
  __typename?: 'userEmailLogCount';
  count?: Maybe<Scalars['Int']>;
};

export type UserEntitlementsType = {
  __typename?: 'userEntitlementsType';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  entitlementType: UserEntitlementsTypeentitlementTypeEnumType;
  entityType: UserEntitlementsTypeentityTypeEnumType;
  id: Scalars['Int'];
  organizationId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['Int'];
};

export type UserEntitlementsTypeCount = {
  __typename?: 'userEntitlementsTypeCount';
  count?: Maybe<Scalars['Int']>;
};

export enum UserEntitlementsTypeentitlementTypeEnumType {
  all = 'all',
  selective = 'selective'
}

export enum UserEntitlementsTypeentityTypeEnumType {
  fundingSource = 'fundingSource'
}

export type UserFeatures = {
  __typename?: 'userFeatures';
  maxmindClientIpCity?: Maybe<Scalars['String']>;
  maxmindClientIpCountry?: Maybe<Scalars['String']>;
  maxmindClientIpDistanceToBilling?: Maybe<Scalars['String']>;
  maxmindClientIpProxy?: Maybe<Scalars['Boolean']>;
  maxmindClientIpRegion?: Maybe<Scalars['String']>;
  maxmindClientIpScore?: Maybe<Scalars['Float']>;
  num_of_orgs_for_normalized_email?: Maybe<Scalars['Int']>;
  payorIdmMMBadProxy?: Maybe<Scalars['Boolean']>;
  payorIdmMMCity?: Maybe<Scalars['String']>;
  payorIdmMMClientIpBadProxy?: Maybe<Scalars['Boolean']>;
  payorIdmMMClientIpCity?: Maybe<Scalars['String']>;
  payorIdmMMClientIpProxy?: Maybe<Scalars['Boolean']>;
  payorIdmMMClientIpRegion?: Maybe<Scalars['String']>;
  payorIdmMMClientIpScore?: Maybe<Scalars['Float']>;
  payorIdmMMProxy?: Maybe<Scalars['Boolean']>;
  payorIdmMMRegion?: Maybe<Scalars['String']>;
  payorIdmMMScore?: Maybe<Scalars['Float']>;
};

export type UserGroup = {
  __typename?: 'userGroup';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['Int'];
  vendorUserGroups?: Maybe<Array<Maybe<VendorUserGroup>>>;
  vendors?: Maybe<Array<Maybe<Vendor>>>;
};

export type UserGroupCount = {
  __typename?: 'userGroupCount';
  count?: Maybe<Scalars['Int']>;
};

export type UserIntuitCredential = {
  __typename?: 'userIntuitCredential';
  accessToken?: Maybe<Scalars['String']>;
  appType: UserIntuitCredentialappTypeEnumType;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  intuitId: Scalars['String'];
  partnerName?: Maybe<Scalars['String']>;
  refreshToken: Scalars['String'];
  scope?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

export type UserIntuitCredentialCount = {
  __typename?: 'userIntuitCredentialCount';
  count?: Maybe<Scalars['Int']>;
};

export enum UserIntuitCredentialappTypeEnumType {
  billpay = 'billpay',
  default = 'default',
  qbdt = 'qbdt'
}

export type UserIpAge = {
  __typename?: 'userIpAge';
  email: Scalars['String'];
  firstUsedAt: Scalars['DateTime'];
};

export type UserLoginToken = {
  __typename?: 'userLoginToken';
  createdAt: Scalars['DateTime'];
  data?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  tokenId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

export type UserLoginTokenCount = {
  __typename?: 'userLoginTokenCount';
  count?: Maybe<Scalars['Int']>;
};

export type UserOAuthCredential = {
  __typename?: 'userOAuthCredential';
  accessToken: Scalars['String'];
  accessTokenExpiration: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  profileResponse: Scalars['SequelizeJSON'];
  provider: UserOAuthCredentialproviderEnumType;
  refreshToken?: Maybe<Scalars['String']>;
  refreshTokenExpiration?: Maybe<Scalars['DateTime']>;
  scope: Scalars['String'];
  subId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

export type UserOAuthCredentialCount = {
  __typename?: 'userOAuthCredentialCount';
  count?: Maybe<Scalars['Int']>;
};

export enum UserOAuthCredentialproviderEnumType {
  google = 'google',
  xero = 'xero'
}

export type UserOrganization = {
  __typename?: 'userOrganization';
  accessLevel: UserOrganizationaccessLevelEnumType;
  addedBy?: Maybe<User>;
  approvalAmountThreshold?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  isHidden?: Maybe<Scalars['Boolean']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName: Scalars['String'];
  permission?: Maybe<UserOrganizationpermissionEnumType>;
  requireApproval?: Maybe<Scalars['Boolean']>;
  role: UserOrganizationroleEnumType;
  roleUniqueName?: Maybe<UserOrganizationroleUniqueNameEnumType>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

export type UserOrganizationCount = {
  __typename?: 'userOrganizationCount';
  count?: Maybe<Scalars['Int']>;
};

export enum UserOrganizationaccessLevelEnumType {
  blocked = 'blocked',
  full = 'full',
  none = 'none'
}

export enum UserOrganizationpermissionEnumType {
  blocked = 'blocked',
  full = 'full',
  readonly = 'readonly'
}

export enum UserOrganizationroleEnum {
  accountant = 'accountant',
  admin = 'admin',
  approver = 'approver',
  contributor = 'contributor',
  owner = 'owner',
  viewer = 'viewer'
}

export enum UserOrganizationroleEnumType {
  accountant = 'accountant',
  admin = 'admin',
  approver = 'approver',
  clerk = 'clerk',
  contributor = 'contributor',
  owner = 'owner',
  viewer = 'viewer'
}

export enum UserOrganizationroleUniqueNameEnumType {
  capitalOneAm = 'capitalOneAm',
  capitalOnePrimary = 'capitalOnePrimary',
  cloverAdmin = 'cloverAdmin',
  cloverOwner = 'cloverOwner',
  deploymentsDemoOwner = 'deploymentsDemoOwner',
  fiservLevel1 = 'fiservLevel1',
  fiservLevel2 = 'fiservLevel2',
  fiservLevel3 = 'fiservLevel3',
  melioAccountant = 'melioAccountant',
  melioAdmin = 'melioAdmin',
  melioApprover = 'melioApprover',
  melioClerk = 'melioClerk',
  melioContributor = 'melioContributor',
  melioOwner = 'melioOwner',
  melioViewer = 'melioViewer',
  shopifyNonOwner = 'shopifyNonOwner',
  shopifyOwner = 'shopifyOwner'
}

export type UserPreference = {
  __typename?: 'userPreference';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  key: Scalars['String'];
  partnerName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['Int'];
  value?: Maybe<Scalars['String']>;
};

export type UserPreferenceCount = {
  __typename?: 'userPreferenceCount';
  count?: Maybe<Scalars['Int']>;
};

export type UserQuickbooksCredential = {
  __typename?: 'userQuickbooksCredential';
  accessToken: Scalars['String'];
  appType: UserQuickbooksCredentialappTypeEnumType;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  intuitId: Scalars['String'];
  isValid: Scalars['Boolean'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  refreshToken: Scalars['String'];
  scope?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

export type UserQuickbooksCredentialCount = {
  __typename?: 'userQuickbooksCredentialCount';
  count?: Maybe<Scalars['Int']>;
};

export enum UserQuickbooksCredentialappTypeEnumType {
  billpay = 'billpay',
  default = 'default',
  fiserv = 'fiserv',
  paypal = 'paypal'
}

export type UserToNormalizedEmail = {
  __typename?: 'userToNormalizedEmail';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  normalizedEmail?: Maybe<NormalizedEmail>;
  normalizedEmailId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

export type UserToNormalizedEmailCount = {
  __typename?: 'userToNormalizedEmailCount';
  count?: Maybe<Scalars['Int']>;
};

export enum UserregistrationFlowEnumType {
  accountsPayablePlatform = 'accountsPayablePlatform',
  apple = 'apple',
  builtPartnership = 'builtPartnership',
  checkoutButton = 'checkoutButton',
  erpVendorOnboarding = 'erpVendorOnboarding',
  google = 'google',
  guest = 'guest',
  guestPayor = 'guestPayor',
  guestPayorEmail = 'guestPayorEmail',
  guestPayorPaymentTracking = 'guestPayorPaymentTracking',
  merchantCheckout = 'merchantCheckout',
  msnPortalPublicForm = 'msnPortalPublicForm',
  msnPortalSalesForm = 'msnPortalSalesForm',
  paymentDeliveredVendorEmail = 'paymentDeliveredVendorEmail',
  paymentScheduledVendorEmail = 'paymentScheduledVendorEmail',
  paymentUnilateralVendorEmail = 'paymentUnilateralVendorEmail',
  pushToDebit = 'pushToDebit',
  pushToFastAch = 'pushToFastAch',
  pushToRtp = 'pushToRtp',
  pushToSuvc = 'pushToSuvc',
  qbdtIntegration = 'qbdtIntegration',
  qbdtMac = 'qbdtMac',
  qbdtWindows = 'qbdtWindows',
  qbmAndroid = 'qbmAndroid',
  qbmIntegration = 'qbmIntegration',
  qbmIos = 'qbmIos',
  qboIntegration = 'qboIntegration',
  qbrAndroid = 'qbrAndroid',
  qbrIntegration = 'qbrIntegration',
  qbrIos = 'qbrIos',
  quickbooks = 'quickbooks',
  regular = 'regular',
  spendManagement = 'spendManagement',
  syngencyIntegration = 'syngencyIntegration',
  unilateralWithEnrollment = 'unilateralWithEnrollment',
  userInvited = 'userInvited',
  vendor = 'vendor',
  vendorPaymentTracking = 'vendorPaymentTracking',
  vendorShiftCheckToAch = 'vendorShiftCheckToAch',
  vendorUnilateralGenericRequest = 'vendorUnilateralGenericRequest',
  vendorUnilateralPayment = 'vendorUnilateralPayment',
  vendorW9 = 'vendorW9',
  xero = 'xero'
}

export type Vendor = {
  __typename?: 'vendor';
  accountIdentifier?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  accountingPlatformEntity?: Maybe<AccountingPlatformEntity>;
  actionLogs?: Maybe<Array<Maybe<ActionLog>>>;
  address?: Maybe<Scalars['SequelizeJSON']>;
  autoPayPolicy?: Maybe<AutoPayPolicy>;
  autoPayStatus?: Maybe<VendorautoPayStatusEnumType>;
  billSubscriptions?: Maybe<Array<Maybe<BillSubscription>>>;
  billSubscriptionsCount?: Maybe<Scalars['Int']>;
  bills?: Maybe<Array<Maybe<Bill>>>;
  billsCount?: Maybe<Scalars['Int']>;
  businessDirectory?: Maybe<BusinessType>;
  childVendors?: Maybe<Array<Maybe<Vendor>>>;
  companyName: Scalars['String'];
  contactEmail?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  contractor?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  createdById: Scalars['Int'];
  createdByPartner?: Maybe<Partner>;
  createdByPartnerId?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
  customers?: Maybe<Array<Maybe<ArCustomer>>>;
  deferredDelivery?: Maybe<Scalars['SequelizeJSON']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deliveryMethods?: Maybe<Array<Maybe<DeliveryMethod>>>;
  deliveryMethodsCount?: Maybe<Scalars['Int']>;
  eBillStatus?: Maybe<VendoreBillStatusEnumType>;
  eBillSubscription?: Maybe<EBillSubscription>;
  eBills?: Maybe<Array<Maybe<EBill>>>;
  externalLogoUrl?: Maybe<Scalars['String']>;
  externalTxnSource?: Maybe<Scalars['String']>;
  features?: Maybe<VendorsFeatures>;
  handle?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  initialManagedByType: VendorinitialManagedByTypeEnumType;
  isEditable?: Maybe<Scalars['String']>;
  isMelioMe?: Maybe<Scalars['Boolean']>;
  isOwned?: Maybe<Scalars['String']>;
  lastPaymentAt?: Maybe<Scalars['DateTime']>;
  lastSync: Scalars['DateTime'];
  managedBy?: Maybe<VendormanagedByEnumType>;
  managingVendor?: Maybe<Vendor>;
  master?: Maybe<Scalars['Boolean']>;
  masterId?: Maybe<Scalars['Int']>;
  nickname?: Maybe<Scalars['String']>;
  organizations?: Maybe<Array<Maybe<Organization>>>;
  organizationsCount?: Maybe<Scalars['Int']>;
  origin: VendororiginEnumType;
  originId: Scalars['String'];
  originMetaUrl?: Maybe<Scalars['String']>;
  originVersion: Scalars['Int'];
  ownedBy?: Maybe<Organization>;
  ownedById?: Maybe<Scalars['Int']>;
  partnerIntegrationId?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  payeeAccountNetworks?: Maybe<Array<Maybe<PayeeAccountNetwork>>>;
  paymentRequests?: Maybe<Array<Maybe<PaymentRequest>>>;
  paymentRequestsCount?: Maybe<Scalars['Int']>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  paymentsCount?: Maybe<Scalars['Int']>;
  printOnCheck?: Maybe<Scalars['String']>;
  prohibitedIndustriesData?: Maybe<VendorProhibitedIndustriesData>;
  public?: Maybe<Scalars['Boolean']>;
  recurringBills?: Maybe<Array<Maybe<RecurringBill>>>;
  recurringBillsCount?: Maybe<Scalars['Int']>;
  status: VendorstatusEnumType;
  syncActivity?: Maybe<VendorSyncActivity>;
  syncActivityMigrationStatus?: Maybe<RailsDateTypeEnum>;
  tags?: Maybe<Array<Maybe<EntityTag>>>;
  taxpayerIdentificationRequests?: Maybe<Array<Maybe<TaxpayerIdentificationRequest>>>;
  taxpayerInfo?: Maybe<TaxpayerInfo>;
  taxpayerInfos?: Maybe<Array<Maybe<TaxpayerInfo>>>;
  traits?: Maybe<Array<Maybe<OrganizationVendorTraits>>>;
  transactions?: Maybe<Array<Maybe<Transaction>>>;
  uniqueName?: Maybe<Scalars['String']>;
  unverifiedAddress?: Maybe<Scalars['SequelizeJSON']>;
  unverifiedAddressSuggestion?: Maybe<Scalars['SequelizeJSON']>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  updatedById: Scalars['Int'];
  userGroups?: Maybe<Array<Maybe<UserGroup>>>;
  uuid?: Maybe<Scalars['String']>;
  vendorCredits?: Maybe<Array<Maybe<VendorCredits>>>;
  vendorPortalConnections?: Maybe<Array<Maybe<VendorPortalConnection>>>;
  vendorPreferences?: Maybe<Array<Maybe<VendorPreference>>>;
  vendorType?: Maybe<VendorTypeEnum>;
  vendorTypeDetails?: Maybe<VendorTypeDetailsType>;
};


export type VendorBillSubscriptionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type VendorBillSubscriptionsCountArgs = {
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type VendorBillsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type VendorBillsCountArgs = {
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type VendorCustomersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type VendorDeliveryMethodsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type VendorDeliveryMethodsCountArgs = {
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type VendorLastPaymentAtArgs = {
  organizationId?: InputMaybe<Scalars['Int']>;
};


export type VendorOrganizationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type VendorOrganizationsCountArgs = {
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type VendorPaymentRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type VendorPaymentRequestsCountArgs = {
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type VendorPaymentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type VendorPaymentsCountArgs = {
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type VendorRecurringBillsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};


export type VendorRecurringBillsCountArgs = {
  where?: InputMaybe<Scalars['SequelizeJSON']>;
};

export type VendorCount = {
  __typename?: 'vendorCount';
  count?: Maybe<Scalars['Int']>;
};

export type VendorCredits = {
  __typename?: 'vendorCredits';
  amount: Scalars['String'];
  balance?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  issuedAt?: Maybe<Scalars['DateTime']>;
  originCreatedAt?: Maybe<Scalars['DateTime']>;
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  vendor?: Maybe<Vendor>;
  vendorCreditsPayments?: Maybe<Array<Maybe<VendorCreditsPayments>>>;
  vendorId: Scalars['Int'];
};

export type VendorCreditsCount = {
  __typename?: 'vendorCreditsCount';
  count?: Maybe<Scalars['Int']>;
};

export type VendorCreditsPayments = {
  __typename?: 'vendorCreditsPayments';
  amount: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  paymentId: Scalars['Int'];
  uniqueVendorCreditsPaymentId?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['DateTime'];
  vendorCredits?: Maybe<VendorCredits>;
  vendorCreditsId: Scalars['Int'];
};

export type VendorCreditsPaymentsCount = {
  __typename?: 'vendorCreditsPaymentsCount';
  count?: Maybe<Scalars['Int']>;
};

export type VendorExternalReferences = {
  __typename?: 'vendorExternalReferences';
  apiKey?: Maybe<ApiKey>;
  apiKeyId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  externalAccountId: Scalars['String'];
  id: Scalars['Int'];
  internalVendor?: Maybe<Vendor>;
  internalVendorId: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type VendorExternalReferencesCount = {
  __typename?: 'vendorExternalReferencesCount';
  count?: Maybe<Scalars['Int']>;
};

export type VendorLink = {
  __typename?: 'vendorLink';
  child?: Maybe<Vendor>;
  childId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  parent?: Maybe<Vendor>;
  parentId: Scalars['Int'];
  partnerName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type VendorLinkCandidate = {
  __typename?: 'vendorLinkCandidate';
  child?: Maybe<Vendor>;
  childId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  parent?: Maybe<Vendor>;
  parentId: Scalars['Int'];
  partnerName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type VendorLinkCandidateCount = {
  __typename?: 'vendorLinkCandidateCount';
  count?: Maybe<Scalars['Int']>;
};

export type VendorLinkCount = {
  __typename?: 'vendorLinkCount';
  count?: Maybe<Scalars['Int']>;
};

export type VendorOnboardingSessions = {
  __typename?: 'vendorOnboardingSessions';
  apiKey?: Maybe<ApiKey>;
  apiKeyId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  externalAccountId: Scalars['String'];
  id: Scalars['Int'];
  onboardingData: Scalars['SequelizeJSON'];
  partnerName?: Maybe<Scalars['String']>;
  redirectUrl?: Maybe<Scalars['String']>;
  sessionId: Scalars['String'];
  status: VendorOnboardingSessionsstatusEnumType;
  updatedAt: Scalars['DateTime'];
};

export type VendorOnboardingSessionsCount = {
  __typename?: 'vendorOnboardingSessionsCount';
  count?: Maybe<Scalars['Int']>;
};

export enum VendorOnboardingSessionsstatusEnumType {
  completed = 'completed',
  created = 'created'
}

export type VendorPaymentLink = {
  __typename?: 'vendorPaymentLink';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  link: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type VendorPaymentLinkCount = {
  __typename?: 'vendorPaymentLinkCount';
  count?: Maybe<Scalars['Int']>;
};

export type VendorPortalConnection = {
  __typename?: 'vendorPortalConnection';
  connectionStatus: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  externalVendorId: Scalars['String'];
  id: Scalars['Int'];
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  metadata?: Maybe<Scalars['SequelizeJSON']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  partnerName: Scalars['String'];
  provider: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  vendor?: Maybe<Vendor>;
  vendorId: Scalars['Int'];
};

export type VendorPortalConnectionCount = {
  __typename?: 'vendorPortalConnectionCount';
  count?: Maybe<Scalars['Int']>;
};

export type VendorPreference = {
  __typename?: 'vendorPreference';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  key: Scalars['String'];
  partnerName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  value: Scalars['String'];
  vendor?: Maybe<Vendor>;
  vendorId: Scalars['Int'];
};

export type VendorPreferenceCount = {
  __typename?: 'vendorPreferenceCount';
  count?: Maybe<Scalars['Int']>;
};

export type VendorSyncActivity = {
  __typename?: 'vendorSyncActivity';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  direction: VendorSyncActivitydirectionEnumType;
  errorMessage?: Maybe<Scalars['String']>;
  externalIntegrationType?: Maybe<VendorSyncActivityexternalIntegrationTypeEnumType>;
  id: Scalars['Int'];
  lastSyncedAt: Scalars['DateTime'];
  partnerName?: Maybe<Scalars['String']>;
  status: VendorSyncActivitystatusEnumType;
  updatedAt: Scalars['DateTime'];
  vendor?: Maybe<Vendor>;
  vendorId: Scalars['Int'];
};

export type VendorSyncActivityCount = {
  __typename?: 'vendorSyncActivityCount';
  count?: Maybe<Scalars['Int']>;
};

export enum VendorSyncActivitydirectionEnumType {
  melio = 'melio',
  qbo = 'qbo'
}

export enum VendorSyncActivityexternalIntegrationTypeEnumType {
  qbd = 'qbd',
  qbo = 'qbo',
  qboPaid = 'qboPaid',
  xerox = 'xerox'
}

export enum VendorSyncActivitystatusEnumType {
  error = 'error',
  noChange = 'noChange',
  success = 'success'
}

export type VendorUserGroup = {
  __typename?: 'vendorUserGroup';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  partnerName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userGroup?: Maybe<UserGroup>;
  userGroupId: Scalars['Int'];
  vendor?: Maybe<Vendor>;
  vendorId: Scalars['Int'];
};

export type VendorUserGroupCount = {
  __typename?: 'vendorUserGroupCount';
  count?: Maybe<Scalars['Int']>;
};

export enum VendorautoPayStatusEnumType {
  active = 'active',
  capable = 'capable',
  not_capable = 'not_capable'
}

export enum VendoreBillStatusEnumType {
  active = 'active',
  capable = 'capable',
  not_capable = 'not_capable',
  pending = 'pending',
  rejected = 'rejected'
}

export enum VendorinitialManagedByTypeEnumType {
  managed = 'managed',
  unmanaged = 'unmanaged'
}

export enum VendormanagedByEnumType {
  biller = 'biller',
  fiserv = 'fiserv',
  msn = 'msn',
  shared = 'shared',
  virtualCard = 'virtualCard'
}

export enum VendororiginEnumType {
  amazonBusiness = 'amazonBusiness',
  dropbox = 'dropbox',
  fiserv = 'fiserv',
  googleAdwords = 'googleAdwords',
  googleDrive = 'googleDrive',
  intuit = 'intuit',
  local = 'local',
  meta = 'meta',
  oneDrive = 'oneDrive',
  quickbooksDesktop = 'quickbooksDesktop',
  shopifyStocky = 'shopifyStocky',
  xeroInternationalMerchant = 'xeroInternationalMerchant'
}

export type VendorsFeatures = {
  __typename?: 'vendorsFeatures';
  is_vendor_manually_approved?: Maybe<Scalars['Boolean']>;
};

export enum VendorstatusEnumType {
  approved = 'approved',
  duplicate = 'duplicate',
  pending = 'pending'
}

export type VirtualAccount = {
  __typename?: 'virtualAccount';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  email: Scalars['String'];
  expired?: Maybe<Scalars['DateTime']>;
  geography: Scalars['String'];
  id: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type VirtualAccountCount = {
  __typename?: 'virtualAccountCount';
  count?: Maybe<Scalars['Int']>;
};

export type VirtualCard = {
  __typename?: 'virtualCard';
  amount: Scalars['String'];
  authorizationDate?: Maybe<Scalars['DateTime']>;
  authorizationNumber?: Maybe<Scalars['String']>;
  canceledDate?: Maybe<Scalars['DateTime']>;
  cardNumber: Scalars['String'];
  clearedDate?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  cvv: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  endDate: Scalars['DateTime'];
  expirationDate: Scalars['DateTime'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  idempotentId: Scalars['String'];
  partnerName?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  paymentId: Scalars['Int'];
  postedDate?: Maybe<Scalars['DateTime']>;
  status: VirtualCardstatusEnumType;
  updatedAt: Scalars['DateTime'];
};

export type VirtualCardAccount = {
  __typename?: 'virtualCardAccount';
  accountEmail?: Maybe<Scalars['String']>;
  createOrigin?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  id: Scalars['Int'];
  partnerName?: Maybe<Scalars['String']>;
  stpProvider?: Maybe<VirtualCardAccountstpProviderEnumType>;
  updatedAt: Scalars['DateTime'];
};

export type VirtualCardAccountCount = {
  __typename?: 'virtualCardAccountCount';
  count?: Maybe<Scalars['Int']>;
};

export enum VirtualCardAccountstpProviderEnumType {
  billtrust = 'billtrust',
  boost = 'boost',
  melioSunlight = 'melioSunlight'
}

export type VirtualCardCandidates = {
  __typename?: 'virtualCardCandidates';
  candidateFor?: Maybe<VirtualCardCandidatescandidateForEnumType>;
  candidateSource?: Maybe<VirtualCardCandidatescandidateSourceEnumType>;
  capLimitAmount?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  emailAddress?: Maybe<Scalars['String']>;
  emailsSentCount: Scalars['Int'];
  id: Scalars['Int'];
  interchangeRateType: VirtualCardCandidatesinterchangeRateTypeEnumType;
  isVendorFilledForm: Scalars['Boolean'];
  matchConfidence: VirtualCardCandidatesmatchConfidenceEnumType;
  matchGroup: VirtualCardCandidatesmatchGroupEnumType;
  melioVendorId?: Maybe<Scalars['Int']>;
  partnerName?: Maybe<Scalars['String']>;
  payorCount: Scalars['Int'];
  phoneNumber?: Maybe<Scalars['String']>;
  scoreGrade?: Maybe<Scalars['String']>;
  tpv: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  vendor?: Maybe<Vendor>;
  vendorCompanyName: Scalars['String'];
};

export type VirtualCardCandidatesCount = {
  __typename?: 'virtualCardCandidatesCount';
  count?: Maybe<Scalars['Int']>;
};

export enum VirtualCardCandidatescandidateForEnumType {
  msnVendor = 'msnVendor',
  virtualCard = 'virtualCard'
}

export enum VirtualCardCandidatescandidateSourceEnumType {
  jpm = 'jpm',
  other = 'other'
}

export enum VirtualCardCandidatesinterchangeRateTypeEnumType {
  rate_2_30 = 'rate_2_30',
  rate_2_85 = 'rate_2_85'
}

export enum VirtualCardCandidatesmatchConfidenceEnumType {
  high = 'high',
  low = 'low',
  medium = 'medium'
}

export enum VirtualCardCandidatesmatchGroupEnumType {
  other_match = 'other_match',
  stp = 'stp',
  sua = 'sua'
}

export type VirtualCardCount = {
  __typename?: 'virtualCardCount';
  count?: Maybe<Scalars['Int']>;
};

export enum VirtualCardstatusEnumType {
  active = 'active',
  authorized = 'authorized',
  canceled = 'canceled',
  cleared = 'cleared',
  expired = 'expired',
  posted = 'posted'
}

export type VoidCheck = {
  __typename?: 'voidCheck';
  achRefunds?: Maybe<Array<Maybe<AchRefund>>>;
  action: VoidCheckactionEnumType;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  id: Scalars['Int'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  partnerName?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  paymentId: Scalars['Int'];
  reason: Scalars['String'];
  source: VoidChecksourceEnumType;
  status: VoidCheckstatusEnumType;
  updatedAt: Scalars['DateTime'];
  vendor?: Maybe<Vendor>;
  vendorId?: Maybe<Scalars['Int']>;
};

export type VoidCheckCount = {
  __typename?: 'voidCheckCount';
  count?: Maybe<Scalars['Int']>;
};

export enum VoidCheckactionEnumType {
  ach = 'ach',
  refund = 'refund',
  reissued = 'reissued',
  reroute = 'reroute',
  waiting = 'waiting'
}

export enum VoidChecksourceEnumType {
  checkAlt = 'checkAlt',
  cxFile = 'cxFile',
  manual = 'manual'
}

export enum VoidCheckstatusEnumType {
  refunded = 'refunded',
  todo = 'todo',
  voided = 'voided',
  voidedAch = 'voidedAch',
  voidedRefunded = 'voidedRefunded',
  voidedReissued = 'voidedReissued'
}

export type WorkflowCriteria = {
  __typename?: 'workflowCriteria';
  approvalWorkflow?: Maybe<ApprovalWorkflow>;
  config?: Maybe<Scalars['SequelizeJSON']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  organizationId?: Maybe<Scalars['Int']>;
  partnerName: Scalars['String'];
  type: WorkflowCriteriatypeEnumType;
  updatedAt: Scalars['DateTime'];
  workflowId: Scalars['Int'];
};

export type WorkflowCriteriaCount = {
  __typename?: 'workflowCriteriaCount';
  count?: Maybe<Scalars['Int']>;
};

export enum WorkflowCriteriatypeEnumType {
  amount = 'amount',
  created_by_roles = 'created_by_roles',
  created_by_users = 'created_by_users',
  externally_decided = 'externally_decided',
  line_item_category = 'line_item_category',
  line_item_class = 'line_item_class',
  line_item_item = 'line_item_item',
  line_item_tracking_category = 'line_item_tracking_category',
  location = 'location',
  vendor = 'vendor'
}

export type WorkflowEntityUserNotification = {
  __typename?: 'workflowEntityUserNotification';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  entityId: Scalars['Int'];
  entityType: WorkflowEntityUserNotificationentityTypeEnumType;
  id: Scalars['Int'];
  partnerName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['Int'];
};

export type WorkflowEntityUserNotificationCount = {
  __typename?: 'workflowEntityUserNotificationCount';
  count?: Maybe<Scalars['Int']>;
};

export enum WorkflowEntityUserNotificationentityTypeEnumType {
  bill = 'bill',
  bill_subscription = 'bill_subscription',
  payment = 'payment'
}

export type WorkflowProgress = {
  __typename?: 'workflowProgress';
  cancelReason?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  entityId: Scalars['Int'];
  entityType: WorkflowProgressentityTypeEnumType;
  id: Scalars['Int'];
  partnerName: Scalars['String'];
  status: WorkflowProgressstatusEnumType;
  updatedAt: Scalars['DateTime'];
  workflow?: Maybe<ApprovalWorkflow>;
  workflowId: Scalars['Int'];
  workflowStepProgresses?: Maybe<Array<Maybe<WorkflowStepProgress>>>;
};

export type WorkflowProgressCount = {
  __typename?: 'workflowProgressCount';
  count?: Maybe<Scalars['Int']>;
};

export enum WorkflowProgressentityTypeEnumType {
  bill = 'bill',
  bill_subscription = 'bill_subscription',
  payment = 'payment'
}

export enum WorkflowProgressstatusEnumType {
  active = 'active',
  cancelled = 'cancelled',
  failed = 'failed',
  success = 'success'
}

export type WorkflowStep = {
  __typename?: 'workflowStep';
  approvalWorkflow?: Maybe<ApprovalWorkflow>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  nextWorkflowStepId?: Maybe<Scalars['Int']>;
  partnerName: Scalars['String'];
  type: WorkflowSteptypeEnumType;
  updatedAt: Scalars['DateTime'];
  userApprovers?: Maybe<Array<Maybe<User>>>;
  workflowId: Scalars['Int'];
  workflowStep?: Maybe<WorkflowStep>;
  workflowStepProgresses?: Maybe<Array<Maybe<WorkflowStepProgress>>>;
  workflowStepUserApprover?: Maybe<Array<Maybe<WorkflowStepUserApprover>>>;
};

export type WorkflowStepCount = {
  __typename?: 'workflowStepCount';
  count?: Maybe<Scalars['Int']>;
};

export type WorkflowStepProgress = {
  __typename?: 'workflowStepProgress';
  cancelReason?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  partnerName: Scalars['String'];
  status: WorkflowStepProgressstatusEnumType;
  updatedAt: Scalars['DateTime'];
  userApprovers?: Maybe<Array<Maybe<WorkflowStepUserApprover>>>;
  workflowProgress?: Maybe<WorkflowProgress>;
  workflowProgressId: Scalars['Int'];
  workflowStep?: Maybe<WorkflowStep>;
  workflowStepId: Scalars['Int'];
};

export type WorkflowStepProgressCount = {
  __typename?: 'workflowStepProgressCount';
  count?: Maybe<Scalars['Int']>;
};

export enum WorkflowStepProgressstatusEnumType {
  active = 'active',
  blocked = 'blocked',
  cancelled = 'cancelled',
  failed = 'failed',
  success = 'success'
}

export type WorkflowStepUserApprover = {
  __typename?: 'workflowStepUserApprover';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  organizationId?: Maybe<Scalars['Int']>;
  partnerName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['Int'];
  workflowStep?: Maybe<WorkflowStep>;
  workflowStepId: Scalars['Int'];
};

export type WorkflowStepUserApproverCount = {
  __typename?: 'workflowStepUserApproverCount';
  count?: Maybe<Scalars['Int']>;
};

export enum WorkflowSteptypeEnumType {
  roles = 'roles',
  users = 'users'
}
